// Auto-generated: all Italian comuni (ISTAT) with province/region + coordinates.
export const COMUNI_ALL = [
  "Abano Terme",
  "Abbadia Cerreto",
  "Abbadia Lariana",
  "Abbadia San Salvatore",
  "Abbasanta",
  "Abbateggio",
  "Abbiategrasso",
  "Abetone Cutigliano",
  "Abriola",
  "Acate",
  "Accadia",
  "Acceglio",
  "Accettura",
  "Acciano",
  "Accumoli",
  "Acerenza",
  "Acerno",
  "Acerra",
  "Aci Bonaccorsi",
  "Aci Castello",
  "Aci Catena",
  "Aci Sant'Antonio",
  "Acireale",
  "Acquafondata",
  "Acquaformosa",
  "Acquafredda",
  "Acqualagna",
  "Acquanegra Cremonese",
  "Acquanegra sul Chiese",
  "Acquapendente",
  "Acquappesa",
  "Acquaro",
  "Acquasanta Terme",
  "Acquasparta",
  "Acquaviva Collecroce",
  "Acquaviva d'Isernia",
  "Acquaviva delle Fonti",
  "Acquaviva Picena",
  "Acquaviva Platani",
  "Acquedolci",
  "Acqui Terme",
  "Acri",
  "Acuto",
  "Adelfia",
  "Adrano",
  "Adrara San Martino",
  "Adrara San Rocco",
  "Adria",
  "Adro",
  "Affi",
  "Affile",
  "Afragola",
  "Africo",
  "Agazzano",
  "Agerola",
  "Aggius",
  "Agira",
  "Agliana",
  "Agliano Terme",
  "Aglientu",
  "Agliè",
  "Agna",
  "Agnadello",
  "Agnana Calabra",
  "Agnone",
  "Agnosine",
  "Agordo",
  "Agosta",
  "Agra",
  "Agrate Brianza",
  "Agrate Conturbia",
  "Agrigento",
  "Agropoli",
  "Agugliano",
  "Agugliaro",
  "Aicurzio",
  "Aidomaggiore",
  "Aidone",
  "Aielli",
  "Aiello Calabro",
  "Aiello del Friuli",
  "Aiello del Sabato",
  "Aieta",
  "Ailano",
  "Ailoche",
  "Airasca",
  "Airola",
  "Airole",
  "Airuno",
  "Aisone",
  "Ala",
  "Ala di Stura",
  "Alagna",
  "Alagna Valsesia",
  "Alanno",
  "Alano di Piave",
  "Alassio",
  "Alatri",
  "Alba",
  "Alba Adriatica",
  "Albagiara",
  "Albairate",
  "Albanella",
  "Albano di Lucania",
  "Albano Laziale",
  "Albano Sant'Alessandro",
  "Albano Vercellese",
  "Albaredo Arnaboldi",
  "Albaredo d'Adige",
  "Albaredo per San Marco",
  "Albareto",
  "Albaretto della Torre",
  "Albavilla",
  "Albenga",
  "Albera Ligure",
  "Alberobello",
  "Alberona",
  "Albese con Cassano",
  "Albettone",
  "Albi",
  "Albiano",
  "Albiano d'Ivrea",
  "Albiate",
  "Albidona",
  "Albignasego",
  "Albinea",
  "Albino",
  "Albiolo",
  "Albisola Superiore",
  "Albissola Marina",
  "Albizzate",
  "Albonese",
  "Albosaggia",
  "Albugnano",
  "Albuzzano",
  "Alcamo",
  "Alcara li Fusi",
  "Aldeno",
  "Aldino",
  "Ales",
  "Alessandria",
  "Alessandria del Carretto",
  "Alessandria della Rocca",
  "Alessano",
  "Alezio",
  "Alfano",
  "Alfedena",
  "Alfianello",
  "Alfiano Natta",
  "Alfonsine",
  "Alghero",
  "Algua",
  "Alia",
  "Aliano",
  "Alice Bel Colle",
  "Alice Castello",
  "Alife",
  "Alimena",
  "Aliminusa",
  "Allai",
  "Alleghe",
  "Allein",
  "Allerona",
  "Alliste",
  "Allumiere",
  "Alluvioni Piovera",
  "Almenno San Bartolomeo",
  "Almenno San Salvatore",
  "Almese",
  "Almè",
  "Alonte",
  "Alpago",
  "Alpette",
  "Alpignano",
  "Alseno",
  "Alserio",
  "Alta Val Tidone",
  "Alta Valle Intelvi",
  "Altamura",
  "Altare",
  "Altavalle",
  "Altavilla Irpina",
  "Altavilla Milicia",
  "Altavilla Monferrato",
  "Altavilla Silentina",
  "Altavilla Vicentina",
  "Altidona",
  "Altilia",
  "Altino",
  "Altissimo",
  "Altivole",
  "Alto",
  "Alto Reno Terme",
  "Alto Sermenza",
  "Altofonte",
  "Altomonte",
  "Altopascio",
  "Altopiano della Vigolana",
  "Alviano",
  "Alvignano",
  "Alvito",
  "Alzano Lombardo",
  "Alzano Scrivia",
  "Alzate Brianza",
  "Alà dei Sardi",
  "Alì",
  "Alì Terme",
  "Amalfi",
  "Amandola",
  "Amantea",
  "Amaro",
  "Amaroni",
  "Amaseno",
  "Amato",
  "Amatrice",
  "Ambivere",
  "Amblar-Don",
  "Ameglia",
  "Amelia",
  "Amendolara",
  "Ameno",
  "Amorosi",
  "Ampezzo",
  "Anacapri",
  "Anagni",
  "Ancarano",
  "Ancona",
  "Andali",
  "Andalo",
  "Andalo Valtellino",
  "Andezeno",
  "Andora",
  "Andorno Micca",
  "Andrano",
  "Andrate",
  "Andreis",
  "Andretta",
  "Andria",
  "Andriano",
  "Anela",
  "Anfo",
  "Angera",
  "Anghiari",
  "Angiari",
  "Angolo Terme",
  "Angri",
  "Angrogna",
  "Anguillara Sabazia",
  "Anguillara Veneta",
  "Annicco",
  "Annone di Brianza",
  "Annone Veneto",
  "Anoia",
  "Antegnate",
  "Anterivo",
  "Antey-Saint-André",
  "Anticoli Corrado",
  "Antignano",
  "Antillo",
  "Antonimina",
  "Antrodoco",
  "Antrona Schieranco",
  "Anversa degli Abruzzi",
  "Anzano del Parco",
  "Anzano di Puglia",
  "Anzi",
  "Anzio",
  "Anzola d'Ossola",
  "Anzola dell'Emilia",
  "Aosta",
  "Apecchio",
  "Apice",
  "Apiro",
  "Apollosa",
  "Appiano Gentile",
  "Appiano sulla strada del vino",
  "Appignano",
  "Appignano del Tronto",
  "Aprica",
  "Apricale",
  "Apricena",
  "Aprigliano",
  "Aprilia",
  "Aquara",
  "Aquila d'Arroscia",
  "Aquileia",
  "Aquilonia",
  "Aquino",
  "Aradeo",
  "Aragona",
  "Aramengo",
  "Arba",
  "Arborea",
  "Arborio",
  "Arbus",
  "Arcade",
  "Arce",
  "Arcene",
  "Arcevia",
  "Archi",
  "Arcidosso",
  "Arcinazzo Romano",
  "Arcisate",
  "Arco",
  "Arcola",
  "Arcole",
  "Arconate",
  "Arcore",
  "Arcugnano",
  "Ardara",
  "Ardauli",
  "Ardea",
  "Ardenno",
  "Ardesio",
  "Ardore",
  "Arena",
  "Arena Po",
  "Arenzano",
  "Arese",
  "Arezzo",
  "Argegno",
  "Argelato",
  "Argenta",
  "Argentera",
  "Arguello",
  "Argusto",
  "Ari",
  "Ariano Irpino",
  "Ariano nel Polesine",
  "Ariccia",
  "Arielli",
  "Arienzo",
  "Arignano",
  "Aritzo",
  "Arizzano",
  "Arlena di Castro",
  "Arluno",
  "Armeno",
  "Armento",
  "Armo",
  "Armungia",
  "Arnad",
  "Arnara",
  "Arnasco",
  "Arnesano",
  "Arola",
  "Arona",
  "Arosio",
  "Arpaia",
  "Arpaise",
  "Arpino",
  "Arquata del Tronto",
  "Arquata Scrivia",
  "Arquà Petrarca",
  "Arquà Polesine",
  "Arre",
  "Arrone",
  "Arsago Seprio",
  "Arsiero",
  "Arsita",
  "Arsiè",
  "Arsoli",
  "Arta Terme",
  "Artegna",
  "Artena",
  "Artogne",
  "Arvier",
  "Arzachena",
  "Arzago d'Adda",
  "Arzana",
  "Arzano",
  "Arzergrande",
  "Arzignano",
  "Ascea",
  "Asciano",
  "Ascoli Piceno",
  "Ascoli Satriano",
  "Ascrea",
  "Asiago",
  "Asigliano Veneto",
  "Asigliano Vercellese",
  "Asola",
  "Asolo",
  "Assago",
  "Assemini",
  "Assisi",
  "Asso",
  "Assolo",
  "Assoro",
  "Asti",
  "Asuni",
  "Ateleta",
  "Atella",
  "Atena Lucana",
  "Atessa",
  "Atina",
  "Atrani",
  "Atri",
  "Atripalda",
  "Attigliano",
  "Attimis",
  "Atzara",
  "Augusta",
  "Auletta",
  "Aulla",
  "Aurano",
  "Aurigo",
  "Auronzo di Cadore",
  "Ausonia",
  "Austis",
  "Avegno",
  "Avelengo",
  "Avella",
  "Avellino",
  "Averara",
  "Aversa",
  "Avetrana",
  "Avezzano",
  "Aviano",
  "Aviatico",
  "Avigliana",
  "Avigliano",
  "Avigliano Umbro",
  "Avio",
  "Avise",
  "Avola",
  "Avolasca",
  "Ayas",
  "Aymavilles",
  "Azeglio",
  "Azzanello",
  "Azzano d'Asti",
  "Azzano Decimo",
  "Azzano Mella",
  "Azzano San Paolo",
  "Azzate",
  "Azzio",
  "Azzone",
  "Baceno",
  "Bacoli",
  "Badalucco",
  "Badesi",
  "Badia",
  "Badia Calavena",
  "Badia Pavese",
  "Badia Polesine",
  "Badia Tedalda",
  "Badolato",
  "Bagaladi",
  "Bagheria",
  "Bagnacavallo",
  "Bagnara Calabra",
  "Bagnara di Romagna",
  "Bagnaria",
  "Bagnaria Arsa",
  "Bagnasco",
  "Bagnatica",
  "Bagni di Lucca",
  "Bagno a Ripoli",
  "Bagno di Romagna",
  "Bagnoli del Trigno",
  "Bagnoli di Sopra",
  "Bagnoli Irpino",
  "Bagnolo Cremasco",
  "Bagnolo del Salento",
  "Bagnolo di Po",
  "Bagnolo in Piano",
  "Bagnolo Mella",
  "Bagnolo Piemonte",
  "Bagnolo San Vito",
  "Bagnone",
  "Bagnoregio",
  "Bagolino",
  "Baia e Latina",
  "Baiano",
  "Bairo",
  "Baiso",
  "Bajardo",
  "Balangero",
  "Baldichieri d'Asti",
  "Baldissero Canavese",
  "Baldissero d'Alba",
  "Baldissero Torinese",
  "Balestrate",
  "Balestrino",
  "Ballabio",
  "Ballao",
  "Balme",
  "Balmuccia",
  "Balocco",
  "Balsorano",
  "Balvano",
  "Balzola",
  "Banari",
  "Banchette",
  "Bannio Anzino",
  "Banzi",
  "Baone",
  "Baradili",
  "Baragiano",
  "Baranello",
  "Barano d'Ischia",
  "Baranzate",
  "Barasso",
  "Baratili San Pietro",
  "Barbania",
  "Barbara",
  "Barbarano Mossano",
  "Barbarano Romano",
  "Barbaresco",
  "Barbariga",
  "Barbata",
  "Barberino di Mugello",
  "Barberino Tavarnelle",
  "Barbianello",
  "Barbiano",
  "Barbona",
  "Barcellona Pozzo di Gotto",
  "Barcis",
  "Bard",
  "Bardello",
  "Bardi",
  "Bardineto",
  "Bardolino",
  "Bardonecchia",
  "Bareggio",
  "Barengo",
  "Baressa",
  "Barete",
  "Barga",
  "Bargagli",
  "Barge",
  "Barghe",
  "Bari",
  "Bari Sardo",
  "Bariano",
  "Baricella",
  "Barile",
  "Barisciano",
  "Barlassina",
  "Barletta",
  "Barni",
  "Barolo",
  "Barone Canavese",
  "Baronissi",
  "Barrafranca",
  "Barrali",
  "Barrea",
  "Barumini",
  "Barzago",
  "Barzana",
  "Barzanò",
  "Barzio",
  "Basaluzzo",
  "Bascapè",
  "Baschi",
  "Basciano",
  "Baselga di Pinè",
  "Baselice",
  "Basiano",
  "Basicò",
  "Basiglio",
  "Basiliano",
  "Bassano Bresciano",
  "Bassano del Grappa",
  "Bassano in Teverina",
  "Bassano Romano",
  "Bassiano",
  "Bassignana",
  "Bastia Mondovì",
  "Bastia Umbra",
  "Bastida Pancarana",
  "Bastiglia",
  "Battaglia Terme",
  "Battifollo",
  "Battipaglia",
  "Battuda",
  "Baucina",
  "Bauladu",
  "Baunei",
  "Baveno",
  "Bedero Valcuvia",
  "Bedizzole",
  "Bedollo",
  "Bedonia",
  "Bedulita",
  "Bee",
  "Beinasco",
  "Beinette",
  "Belcastro",
  "Belfiore",
  "Belforte all'Isauro",
  "Belforte del Chienti",
  "Belforte Monferrato",
  "Belgioioso",
  "Belgirate",
  "Bella",
  "Bellagio",
  "Bellano",
  "Bellante",
  "Bellaria-Igea Marina",
  "Bellegra",
  "Bellino",
  "Bellinzago Lombardo",
  "Bellinzago Novarese",
  "Bellizzi",
  "Bellona",
  "Bellosguardo",
  "Belluno",
  "Bellusco",
  "Belmonte Calabro",
  "Belmonte Castello",
  "Belmonte del Sannio",
  "Belmonte in Sabina",
  "Belmonte Mezzagno",
  "Belmonte Piceno",
  "Belpasso",
  "Belsito",
  "Belvedere di Spinello",
  "Belvedere Langhe",
  "Belvedere Marittimo",
  "Belvedere Ostrense",
  "Belveglio",
  "Belvì",
  "Bema",
  "Bene Lario",
  "Bene Vagienna",
  "Benestare",
  "Benetutti",
  "Benevello",
  "Benevento",
  "Benna",
  "Bentivoglio",
  "Berbenno",
  "Berbenno di Valtellina",
  "Berceto",
  "Berchidda",
  "Beregazzo con Figliaro",
  "Bereguardo",
  "Bergamasco",
  "Bergamo",
  "Bergantino",
  "Bergeggi",
  "Bergolo",
  "Berlingo",
  "Bernalda",
  "Bernareggio",
  "Bernate Ticino",
  "Bernezzo",
  "Bertinoro",
  "Bertiolo",
  "Bertonico",
  "Berzano di San Pietro",
  "Berzano di Tortona",
  "Berzo Demo",
  "Berzo Inferiore",
  "Berzo San Fermo",
  "Besana in Brianza",
  "Besano",
  "Besate",
  "Besenello",
  "Besenzone",
  "Besnate",
  "Besozzo",
  "Bessude",
  "Bettola",
  "Bettona",
  "Beura-Cardezza",
  "Bevagna",
  "Beverino",
  "Bevilacqua",
  "Biancavilla",
  "Bianchi",
  "Bianco",
  "Biandrate",
  "Biandronno",
  "Bianzano",
  "Bianzone",
  "Bianzè",
  "Biassono",
  "Bibbiano",
  "Bibbiena",
  "Bibbona",
  "Bibiana",
  "Biccari",
  "Bicinicco",
  "Bidonì",
  "Biella",
  "Bienno",
  "Bieno",
  "Bientina",
  "Binago",
  "Binasco",
  "Binetto",
  "Bioglio",
  "Bionaz",
  "Bione",
  "Birori",
  "Bisaccia",
  "Bisacquino",
  "Bisceglie",
  "Bisegna",
  "Bisenti",
  "Bisignano",
  "Bistagno",
  "Bisuschio",
  "Bitetto",
  "Bitonto",
  "Bitritto",
  "Bitti",
  "Bivona",
  "Bivongi",
  "Bizzarone",
  "Bleggio Superiore",
  "Blello",
  "Blera",
  "Blessagno",
  "Blevio",
  "Blufi",
  "Boara Pisani",
  "Bobbio",
  "Bobbio Pellice",
  "Boca",
  "Bocchigliero",
  "Boccioleto",
  "Bocenago",
  "Bodio Lomnago",
  "Boffalora d'Adda",
  "Boffalora sopra Ticino",
  "Bogliasco",
  "Bognanco",
  "Bogogno",
  "Boissano",
  "Bojano",
  "Bolano",
  "Bolgare",
  "Bollate",
  "Bollengo",
  "Bologna",
  "Bolognano",
  "Bolognetta",
  "Bolognola",
  "Bolotana",
  "Bolsena",
  "Boltiere",
  "Bolzano",
  "Bolzano Novarese",
  "Bolzano Vicentino",
  "Bomarzo",
  "Bomba",
  "Bompensiere",
  "Bompietro",
  "Bomporto",
  "Bonarcado",
  "Bonassola",
  "Bonate Sopra",
  "Bonate Sotto",
  "Bonavigo",
  "Bondeno",
  "Bondone",
  "Bonea",
  "Bonefro",
  "Bonemerse",
  "Bonifati",
  "Bonito",
  "Bonnanaro",
  "Bono",
  "Bonorva",
  "Bonvicino",
  "Borbona",
  "Borca di Cadore",
  "Bordano",
  "Bordighera",
  "Bordolano",
  "Bore",
  "Boretto",
  "Borgarello",
  "Borgaro Torinese",
  "Borgetto",
  "Borghetto d'Arroscia",
  "Borghetto di Borbera",
  "Borghetto di Vara",
  "Borghetto Lodigiano",
  "Borghetto Santo Spirito",
  "Borghi",
  "Borgia",
  "Borgiallo",
  "Borgio Verezzi",
  "Borgo a Mozzano",
  "Borgo Chiese",
  "Borgo d'Ale",
  "Borgo d'Anaunia",
  "Borgo di Terzo",
  "Borgo Lares",
  "Borgo Mantovano",
  "Borgo Pace",
  "Borgo Priolo",
  "Borgo San Dalmazzo",
  "Borgo San Giacomo",
  "Borgo San Giovanni",
  "Borgo San Lorenzo",
  "Borgo San Martino",
  "Borgo San Siro",
  "Borgo Ticino",
  "Borgo Tossignano",
  "Borgo Val di Taro",
  "Borgo Valbelluna",
  "Borgo Valsugana",
  "Borgo Velino",
  "Borgo Veneto",
  "Borgo Vercelli",
  "Borgo Virgilio",
  "Borgocarbonara",
  "Borgofranco d'Ivrea",
  "Borgolavezzaro",
  "Borgomale",
  "Borgomanero",
  "Borgomaro",
  "Borgomasino",
  "Borgomezzavalle",
  "Borgone Susa",
  "Borgonovo Val Tidone",
  "Borgoratto Alessandrino",
  "Borgoratto Mormorolo",
  "Borgoricco",
  "Borgorose",
  "Borgosatollo",
  "Borgosesia",
  "Bormida",
  "Bormio",
  "Bornasco",
  "Borno",
  "Boroneddu",
  "Borore",
  "Borrello",
  "Borriana",
  "Borso del Grappa",
  "Bortigali",
  "Bortigiadas",
  "Borutta",
  "Borzonasca",
  "Bosa",
  "Bosaro",
  "Boschi Sant'Anna",
  "Bosco Chiesanuova",
  "Bosco Marengo",
  "Bosconero",
  "Boscoreale",
  "Boscotrecase",
  "Bosia",
  "Bosio",
  "Bosisio Parini",
  "Bosnasco",
  "Bossico",
  "Bossolasco",
  "Botricello",
  "Botrugno",
  "Bottanuco",
  "Botticino",
  "Bottidda",
  "Bova",
  "Bova Marina",
  "Bovalino",
  "Bovegno",
  "Boves",
  "Bovezzo",
  "Boville Ernica",
  "Bovino",
  "Bovisio-Masciago",
  "Bovolenta",
  "Bovolone",
  "Bozzole",
  "Bozzolo",
  "Bra",
  "Bracca",
  "Bracciano",
  "Bracigliano",
  "Braies",
  "Brallo di Pregola",
  "Brancaleone",
  "Brandico",
  "Brandizzo",
  "Branzi",
  "Braone",
  "Brebbia",
  "Breda di Piave",
  "Bregano",
  "Breganze",
  "Bregnano",
  "Brembate",
  "Brembate di Sopra",
  "Brembio",
  "Breme",
  "Brendola",
  "Brenna",
  "Brennero",
  "Breno",
  "Brenta",
  "Brentino Belluno",
  "Brentonico",
  "Brenzone sul Garda",
  "Brescello",
  "Brescia",
  "Bresimo",
  "Bressana Bottarone",
  "Bressanone",
  "Bressanvido",
  "Bresso",
  "Brezzo di Bedero",
  "Briaglia",
  "Briatico",
  "Bricherasio",
  "Brienno",
  "Brienza",
  "Briga Alta",
  "Briga Novarese",
  "Brignano Gera d'Adda",
  "Brignano-Frascata",
  "Brindisi",
  "Brindisi Montagna",
  "Brinzio",
  "Briona",
  "Brione",
  "Briosco",
  "Brisighella",
  "Brissago-Valtravaglia",
  "Brissogne",
  "Brittoli",
  "Brivio",
  "Broccostella",
  "Brogliano",
  "Brognaturo",
  "Brolo",
  "Brondello",
  "Broni",
  "Bronte",
  "Bronzolo",
  "Brossasco",
  "Brosso",
  "Brovello-Carpugnino",
  "Brozolo",
  "Brugherio",
  "Brugine",
  "Brugnato",
  "Brugnera",
  "Bruino",
  "Brumano",
  "Brunate",
  "Brunello",
  "Brunico",
  "Bruno",
  "Brusaporto",
  "Brusasco",
  "Brusciano",
  "Brusimpiano",
  "Brusnengo",
  "Brusson",
  "Bruzolo",
  "Bruzzano Zeffirio",
  "Bubbiano",
  "Bubbio",
  "Buccheri",
  "Bucchianico",
  "Bucciano",
  "Buccinasco",
  "Buccino",
  "Bucine",
  "Buddusò",
  "Budoia",
  "Budoni",
  "Budrio",
  "Buggerru",
  "Buggiano",
  "Buglio in Monte",
  "Bugnara",
  "Buguggiate",
  "Buja",
  "Bulciago",
  "Bulgarograsso",
  "Bultei",
  "Bulzi",
  "Buonabitacolo",
  "Buonalbergo",
  "Buonconvento",
  "Buonvicino",
  "Burago di Molgora",
  "Burcei",
  "Burgio",
  "Burgos",
  "Buriasco",
  "Burolo",
  "Buronzo",
  "Busachi",
  "Busalla",
  "Busano",
  "Busca",
  "Buscate",
  "Buscemi",
  "Buseto Palizzolo",
  "Busnago",
  "Bussero",
  "Busseto",
  "Bussi sul Tirino",
  "Busso",
  "Bussolengo",
  "Bussoleno",
  "Busto Arsizio",
  "Busto Garolfo",
  "Butera",
  "Buti",
  "Buttapietra",
  "Buttigliera Alta",
  "Buttigliera d'Asti",
  "Buttrio",
  "Cabella Ligure",
  "Cabiate",
  "Cabras",
  "Caccamo",
  "Caccuri",
  "Cadegliano-Viconago",
  "Cadelbosco di Sopra",
  "Cadeo",
  "Caderzone Terme",
  "Cadoneghe",
  "Cadorago",
  "Cadrezzate con Osmate",
  "Caerano di San Marco",
  "Cafasse",
  "Caggiano",
  "Cagli",
  "Cagliari",
  "Caglio",
  "Cagnano Amiterno",
  "Cagnano Varano",
  "Caianello",
  "Caiazzo",
  "Caines",
  "Caino",
  "Caiolo",
  "Cairano",
  "Cairate",
  "Cairo Montenotte",
  "Caivano",
  "Calabritto",
  "Calalzo di Cadore",
  "Calamandrana",
  "Calamonaci",
  "Calangianus",
  "Calanna",
  "Calasca-Castiglione",
  "Calascibetta",
  "Calascio",
  "Calasetta",
  "Calatabiano",
  "Calatafimi-Segesta",
  "Calcata",
  "Calceranica al Lago",
  "Calci",
  "Calciano",
  "Calcinaia",
  "Calcinate",
  "Calcinato",
  "Calcio",
  "Calco",
  "Caldaro sulla strada del vino",
  "Caldarola",
  "Calderara di Reno",
  "Caldes",
  "Caldiero",
  "Caldogno",
  "Caldonazzo",
  "Calendasco",
  "Calenzano",
  "Calestano",
  "Calice al Cornoviglio",
  "Calice Ligure",
  "Calimera",
  "Calitri",
  "Calizzano",
  "Callabiana",
  "Calliano (AT)",
  "Calliano (TN)",
  "Calolziocorte",
  "Calopezzati",
  "Calosso",
  "Caloveto",
  "Caltabellotta",
  "Caltagirone",
  "Caltanissetta",
  "Caltavuturo",
  "Caltignaga",
  "Calto",
  "Caltrano",
  "Calusco d'Adda",
  "Caluso",
  "Calvagese della Riviera",
  "Calvanico",
  "Calvatone",
  "Calvello",
  "Calvene",
  "Calvenzano",
  "Calvera",
  "Calvi",
  "Calvi dell'Umbria",
  "Calvi Risorta",
  "Calvignano",
  "Calvignasco",
  "Calvisano",
  "Calvizzano",
  "Camagna Monferrato",
  "Camaiore",
  "Camandona",
  "Camastra",
  "Cambiago",
  "Cambiano",
  "Cambiasca",
  "Camburzano",
  "Camerana",
  "Camerano",
  "Camerano Casasco",
  "Camerata Cornello",
  "Camerata Nuova",
  "Camerata Picena",
  "Cameri",
  "Camerino",
  "Camerota",
  "Camigliano",
  "Camini",
  "Camino",
  "Camino al Tagliamento",
  "Camisano",
  "Camisano Vicentino",
  "Cammarata",
  "Camogli",
  "Campagna",
  "Campagna Lupia",
  "Campagnano di Roma",
  "Campagnatico",
  "Campagnola Cremasca",
  "Campagnola Emilia",
  "Campana",
  "Camparada",
  "Campegine",
  "Campello sul Clitunno",
  "Campertogno",
  "Campi Bisenzio",
  "Campi Salentina",
  "Campiglia Cervo",
  "Campiglia dei Berici",
  "Campiglia Marittima",
  "Campiglione Fenile",
  "Campione d'Italia",
  "Campitello di Fassa",
  "Campli",
  "Campo Calabro",
  "Campo di Giove",
  "Campo di Trens",
  "Campo Ligure",
  "Campo nell'Elba",
  "Campo San Martino",
  "Campo Tures",
  "Campobasso",
  "Campobello di Licata",
  "Campobello di Mazara",
  "Campochiaro",
  "Campodarsego",
  "Campodenno",
  "Campodimele",
  "Campodipietra",
  "Campodolcino",
  "Campodoro",
  "Campofelice di Fitalia",
  "Campofelice di Roccella",
  "Campofilone",
  "Campofiorito",
  "Campoformido",
  "Campofranco",
  "Campogalliano",
  "Campolattaro",
  "Campoli Appennino",
  "Campoli del Monte Taburno",
  "Campolieto",
  "Campolongo Maggiore",
  "Campolongo Tapogliano",
  "Campomaggiore",
  "Campomarino",
  "Campomorone",
  "Camponogara",
  "Campora",
  "Camporeale",
  "Camporgiano",
  "Camporosso",
  "Camporotondo di Fiastrone",
  "Camporotondo Etneo",
  "Camposampiero",
  "Camposano",
  "Camposanto",
  "Campospinoso",
  "Campotosto",
  "Camugnano",
  "Canal San Bovo",
  "Canale",
  "Canale d'Agordo",
  "Canale Monterano",
  "Canaro",
  "Canazei",
  "Cancellara",
  "Cancello ed Arnone",
  "Canda",
  "Candela",
  "Candelo",
  "Candia Canavese",
  "Candia Lomellina",
  "Candiana",
  "Candida",
  "Candidoni",
  "Candiolo",
  "Canegrate",
  "Canelli",
  "Canepina",
  "Caneva",
  "Canicattini Bagni",
  "Canicattì",
  "Canino",
  "Canischio",
  "Canistro",
  "Canna",
  "Cannalonga",
  "Cannara",
  "Cannero Riviera",
  "Canneto Pavese",
  "Canneto sull'Oglio",
  "Cannobio",
  "Cannole",
  "Canolo",
  "Canonica d'Adda",
  "Canosa di Puglia",
  "Canosa Sannita",
  "Canosio",
  "Canossa",
  "Cansano",
  "Cantagallo",
  "Cantalice",
  "Cantalupa",
  "Cantalupo in Sabina",
  "Cantalupo Ligure",
  "Cantalupo nel Sannio",
  "Cantarana",
  "Cantello",
  "Canterano",
  "Cantiano",
  "Cantoira",
  "Cantù",
  "Canzano",
  "Canzo",
  "Caorle",
  "Caorso",
  "Capaccio Paestum",
  "Capaci",
  "Capalbio",
  "Capannoli",
  "Capannori",
  "Capena",
  "Capergnanica",
  "Capestrano",
  "Capiago Intimiano",
  "Capistrano",
  "Capistrello",
  "Capitignano",
  "Capizzi",
  "Capizzone",
  "Capo d'Orlando",
  "Capo di Ponte",
  "Capodimonte",
  "Capodrise",
  "Capoliveri",
  "Capolona",
  "Caponago",
  "Caporciano",
  "Caposele",
  "Capoterra",
  "Capovalle",
  "Cappadocia",
  "Cappella Cantone",
  "Cappella de' Picenardi",
  "Cappella Maggiore",
  "Cappelle sul Tavo",
  "Capracotta",
  "Capraia e Limite",
  "Capraia Isola",
  "Capralba",
  "Capranica",
  "Capranica Prenestina",
  "Caprarica di Lecce",
  "Caprarola",
  "Caprauna",
  "Caprese Michelangelo",
  "Caprezzo",
  "Capri",
  "Capri Leone",
  "Capriana",
  "Capriano del Colle",
  "Capriata d'Orba",
  "Capriate San Gervasio",
  "Capriati a Volturno",
  "Caprie",
  "Capriglia Irpina",
  "Capriglio",
  "Caprile",
  "Caprino Bergamasco",
  "Caprino Veronese",
  "Capriolo",
  "Capriva del Friuli",
  "Capua",
  "Capurso",
  "Caraffa del Bianco",
  "Caraffa di Catanzaro",
  "Caraglio",
  "Caramagna Piemonte",
  "Caramanico Terme",
  "Carapelle",
  "Carapelle Calvisio",
  "Carasco",
  "Carassai",
  "Carate Brianza",
  "Carate Urio",
  "Caravaggio",
  "Caravate",
  "Caravino",
  "Caravonica",
  "Carbognano",
  "Carbonara al Ticino",
  "Carbonara di Nola",
  "Carbonara Scrivia",
  "Carbonate",
  "Carbone",
  "Carbonera",
  "Carbonia",
  "Carcare",
  "Carceri",
  "Carcoforo",
  "Cardano al Campo",
  "Cardedu",
  "Cardeto",
  "Cardinale",
  "Cardito",
  "Cardè",
  "Careggine",
  "Carema",
  "Carenno",
  "Carentino",
  "Careri",
  "Caresana",
  "Caresanablot",
  "Carezzano",
  "Carfizzi",
  "Cargeghe",
  "Cariati",
  "Carife",
  "Carignano",
  "Carimate",
  "Carinaro",
  "Carini",
  "Carinola",
  "Carisio",
  "Carisolo",
  "Carlantino",
  "Carlazzo",
  "Carlentini",
  "Carlino",
  "Carloforte",
  "Carlopoli",
  "Carmagnola",
  "Carmiano",
  "Carmignano",
  "Carmignano di Brenta",
  "Carnago",
  "Carnate",
  "Carobbio degli Angeli",
  "Carolei",
  "Carona",
  "Caronia",
  "Caronno Pertusella",
  "Caronno Varesino",
  "Carosino",
  "Carovigno",
  "Carovilli",
  "Carpaneto Piacentino",
  "Carpanzano",
  "Carpegna",
  "Carpenedolo",
  "Carpeneto",
  "Carpi",
  "Carpiano",
  "Carpignano Salentino",
  "Carpignano Sesia",
  "Carpineti",
  "Carpineto della Nora",
  "Carpineto Romano",
  "Carpineto Sinello",
  "Carpino",
  "Carpinone",
  "Carrara",
  "Carrega Ligure",
  "Carro",
  "Carrodano",
  "Carrosio",
  "Carrè",
  "Carrù",
  "Carsoli",
  "Cartigliano",
  "Cartignano",
  "Cartoceto",
  "Cartosio",
  "Cartura",
  "Carugate",
  "Carugo",
  "Carunchio",
  "Carvico",
  "Carzano",
  "Casabona",
  "Casacalenda",
  "Casacanditella",
  "Casagiove",
  "Casal Cermelli",
  "Casal di Principe",
  "Casal Velino",
  "Casalanguida",
  "Casalattico",
  "Casalbeltrame",
  "Casalbordino",
  "Casalbore",
  "Casalborgone",
  "Casalbuono",
  "Casalbuttano ed Uniti",
  "Casalciprano",
  "Casalduni",
  "Casale Corte Cerro",
  "Casale Cremasco-Vidolasco",
  "Casale di Scodosia",
  "Casale Litta",
  "Casale Marittimo",
  "Casale Monferrato",
  "Casale sul Sile",
  "Casalecchio di Reno",
  "Casaleggio Boiro",
  "Casaleggio Novara",
  "Casaleone",
  "Casaletto Ceredano",
  "Casaletto di Sopra",
  "Casaletto Lodigiano",
  "Casaletto Spartano",
  "Casaletto Vaprio",
  "Casalfiumanese",
  "Casalgrande",
  "Casalgrasso",
  "Casali del Manco",
  "Casalincontrada",
  "Casalino",
  "Casalmaggiore",
  "Casalmaiocco",
  "Casalmorano",
  "Casalmoro",
  "Casalnoceto",
  "Casalnuovo di Napoli",
  "Casalnuovo Monterotaro",
  "Casaloldo",
  "Casalpusterlengo",
  "Casalromano",
  "Casalserugo",
  "Casaluce",
  "Casalvecchio di Puglia",
  "Casalvecchio Siculo",
  "Casalvieri",
  "Casalvolone",
  "Casalzuigno",
  "Casamarciano",
  "Casamassima",
  "Casamicciola Terme",
  "Casandrino",
  "Casanova Elvo",
  "Casanova Lerrone",
  "Casanova Lonati",
  "Casape",
  "Casapesenna",
  "Casapinta",
  "Casaprota",
  "Casapulla",
  "Casarano",
  "Casargo",
  "Casarile",
  "Casarsa della Delizia",
  "Casarza Ligure",
  "Casasco",
  "Casatenovo",
  "Casatisma",
  "Casavatore",
  "Casazza",
  "Cascia",
  "Casciago",
  "Casciana Terme Lari",
  "Cascina",
  "Cascinette d'Ivrea",
  "Casei Gerola",
  "Caselette",
  "Casella",
  "Caselle in Pittari",
  "Caselle Landi",
  "Caselle Lurani",
  "Caselle Torinese",
  "Caserta",
  "Casier",
  "Casignana",
  "Casina",
  "Casirate d'Adda",
  "Caslino d'Erba",
  "Casnate con Bernate",
  "Casnigo",
  "Casola di Napoli",
  "Casola in Lunigiana",
  "Casola Valsenio",
  "Casole d'Elsa",
  "Casoli",
  "Casorate Primo",
  "Casorate Sempione",
  "Casorezzo",
  "Casoria",
  "Casorzo",
  "Casperia",
  "Caspoggio",
  "Cassacco",
  "Cassago Brianza",
  "Cassano all'Ionio",
  "Cassano d'Adda",
  "Cassano delle Murge",
  "Cassano Irpino",
  "Cassano Magnago",
  "Cassano Spinola",
  "Cassano Valcuvia",
  "Cassaro",
  "Cassiglio",
  "Cassina de' Pecchi",
  "Cassina Rizzardi",
  "Cassina Valsassina",
  "Cassinasco",
  "Cassine",
  "Cassinelle",
  "Cassinetta di Lugagnano",
  "Cassino",
  "Cassola",
  "Cassolnovo",
  "Castagnaro",
  "Castagneto Carducci",
  "Castagneto Po",
  "Castagnito",
  "Castagnole delle Lanze",
  "Castagnole Monferrato",
  "Castagnole Piemonte",
  "Castana",
  "Castano Primo",
  "Casteggio",
  "Castegnato",
  "Castegnero",
  "Castel Baronia",
  "Castel Boglione",
  "Castel Bolognese",
  "Castel Campagnano",
  "Castel Castagna",
  "Castel Condino",
  "Castel d'Aiano",
  "Castel d'Ario",
  "Castel d'Azzano",
  "Castel del Giudice",
  "Castel del Monte",
  "Castel del Piano",
  "Castel del Rio",
  "Castel di Casio",
  "Castel di Ieri",
  "Castel di Iudica",
  "Castel di Lama",
  "Castel di Lucio",
  "Castel di Sangro",
  "Castel di Sasso",
  "Castel di Tora",
  "Castel Focognano",
  "Castel Frentano",
  "Castel Gabbiano",
  "Castel Gandolfo",
  "Castel Giorgio",
  "Castel Goffredo",
  "Castel Guelfo di Bologna",
  "Castel Ivano",
  "Castel Madama",
  "Castel Maggiore",
  "Castel Mella",
  "Castel Morrone",
  "Castel Ritaldi",
  "Castel Rocchero",
  "Castel Rozzone",
  "Castel San Giorgio",
  "Castel San Giovanni",
  "Castel San Lorenzo",
  "Castel San Niccolò",
  "Castel San Pietro Romano",
  "Castel San Pietro Terme",
  "Castel San Vincenzo",
  "Castel Sant'Angelo",
  "Castel Sant'Elia",
  "Castel Viscardo",
  "Castel Vittorio",
  "Castel Volturno",
  "Castelbaldo",
  "Castelbelforte",
  "Castelbellino",
  "Castelbello-Ciardes",
  "Castelbianco",
  "Castelbottaccio",
  "Castelbuono",
  "Castelcivita",
  "Castelcovati",
  "Castelcucco",
  "Casteldaccia",
  "Casteldelci",
  "Casteldelfino",
  "Casteldidone",
  "Castelfidardo",
  "Castelfiorentino",
  "Castelforte",
  "Castelfranci",
  "Castelfranco di Sotto",
  "Castelfranco Emilia",
  "Castelfranco in Miscano",
  "Castelfranco Piandiscò",
  "Castelfranco Veneto",
  "Castelgerundo",
  "Castelgomberto",
  "Castelgrande",
  "Castelguglielmo",
  "Castelguidone",
  "Castell'Alfero",
  "Castell'Arquato",
  "Castell'Azzara",
  "Castell'Umberto",
  "Castellabate",
  "Castellafiume",
  "Castellalto",
  "Castellammare del Golfo",
  "Castellammare di Stabia",
  "Castellamonte",
  "Castellana Grotte",
  "Castellana Sicula",
  "Castellaneta",
  "Castellania Coppi",
  "Castellanza",
  "Castellar Guidobono",
  "Castellarano",
  "Castellaro",
  "Castellazzo Bormida",
  "Castellazzo Novarese",
  "Castelleone",
  "Castelleone di Suasa",
  "Castellero",
  "Castelletto Cervo",
  "Castelletto d'Erro",
  "Castelletto d'Orba",
  "Castelletto di Branduzzo",
  "Castelletto Merli",
  "Castelletto Molina",
  "Castelletto Monferrato",
  "Castelletto sopra Ticino",
  "Castelletto Stura",
  "Castelletto Uzzone",
  "Castelli",
  "Castelli Calepio",
  "Castellina in Chianti",
  "Castellina Marittima",
  "Castellinaldo d'Alba",
  "Castellino del Biferno",
  "Castellino Tanaro",
  "Castelliri",
  "Castello Cabiaglio",
  "Castello d'Agogna",
  "Castello d'Argile",
  "Castello del Matese",
  "Castello dell'Acqua",
  "Castello di Annone",
  "Castello di Brianza",
  "Castello di Cisterna",
  "Castello di Godego",
  "Castello Tesino",
  "Castello-Molina di Fiemme",
  "Castellucchio",
  "Castelluccio dei Sauri",
  "Castelluccio Inferiore",
  "Castelluccio Superiore",
  "Castelluccio Valmaggiore",
  "Castelmagno",
  "Castelmarte",
  "Castelmassa",
  "Castelmauro",
  "Castelmezzano",
  "Castelmola",
  "Castelnovetto",
  "Castelnovo Bariano",
  "Castelnovo del Friuli",
  "Castelnovo di Sotto",
  "Castelnovo ne' Monti",
  "Castelnuovo",
  "Castelnuovo Belbo",
  "Castelnuovo Berardenga",
  "Castelnuovo Bocca d'Adda",
  "Castelnuovo Bormida",
  "Castelnuovo Bozzente",
  "Castelnuovo Calcea",
  "Castelnuovo Cilento",
  "Castelnuovo del Garda",
  "Castelnuovo della Daunia",
  "Castelnuovo di Ceva",
  "Castelnuovo di Conza",
  "Castelnuovo di Farfa",
  "Castelnuovo di Garfagnana",
  "Castelnuovo di Porto",
  "Castelnuovo di Val di Cecina",
  "Castelnuovo Don Bosco",
  "Castelnuovo Magra",
  "Castelnuovo Nigra",
  "Castelnuovo Parano",
  "Castelnuovo Rangone",
  "Castelnuovo Scrivia",
  "Castelpagano",
  "Castelpetroso",
  "Castelpizzuto",
  "Castelplanio",
  "Castelpoto",
  "Castelraimondo",
  "Castelrotto",
  "Castelsantangelo sul Nera",
  "Castelsaraceno",
  "Castelsardo",
  "Castelseprio",
  "Castelsilano",
  "Castelspina",
  "Casteltermini",
  "Castelveccana",
  "Castelvecchio Calvisio",
  "Castelvecchio di Rocca Barbena",
  "Castelvecchio Subequo",
  "Castelvenere",
  "Castelverde",
  "Castelverrino",
  "Castelvetere in Val Fortore",
  "Castelvetere sul Calore",
  "Castelvetrano",
  "Castelvetro di Modena",
  "Castelvetro Piacentino",
  "Castelvisconti",
  "Castenaso",
  "Castenedolo",
  "Castiadas",
  "Castiglion Fibocchi",
  "Castiglion Fiorentino",
  "Castiglione a Casauria",
  "Castiglione Chiavarese",
  "Castiglione Cosentino",
  "Castiglione d'Adda",
  "Castiglione d'Orcia",
  "Castiglione dei Pepoli",
  "Castiglione del Genovesi",
  "Castiglione del Lago",
  "Castiglione della Pescaia",
  "Castiglione delle Stiviere",
  "Castiglione di Garfagnana",
  "Castiglione di Sicilia",
  "Castiglione Falletto",
  "Castiglione in Teverina",
  "Castiglione Messer Marino",
  "Castiglione Messer Raimondo",
  "Castiglione Olona",
  "Castiglione Tinella",
  "Castiglione Torinese",
  "Castignano",
  "Castilenti",
  "Castino",
  "Castione Andevenno",
  "Castione della Presolana",
  "Castions di Strada",
  "Castiraga Vidardo",
  "Casto",
  "Castorano",
  "Castrezzato",
  "Castri di Lecce",
  "Castrignano de' Greci",
  "Castrignano del Capo",
  "Castro (BG)",
  "Castro (LE)",
  "Castro dei Volsci",
  "Castrocaro Terme e Terra del Sole",
  "Castrocielo",
  "Castrofilippo",
  "Castrolibero",
  "Castronno",
  "Castronovo di Sicilia",
  "Castronuovo di Sant'Andrea",
  "Castropignano",
  "Castroreale",
  "Castroregio",
  "Castrovillari",
  "Catania",
  "Catanzaro",
  "Catenanuova",
  "Catignano",
  "Cattolica",
  "Cattolica Eraclea",
  "Caulonia",
  "Cautano",
  "Cava de' Tirreni",
  "Cava Manara",
  "Cavaglietto",
  "Cavaglio d'Agogna",
  "Cavaglià",
  "Cavagnolo",
  "Cavaion Veronese",
  "Cavalese",
  "Cavallerleone",
  "Cavallermaggiore",
  "Cavallino",
  "Cavallino-Treporti",
  "Cavallirio",
  "Cavareno",
  "Cavargna",
  "Cavaria con Premezzo",
  "Cavarzere",
  "Cavaso del Tomba",
  "Cavasso Nuovo",
  "Cavatore",
  "Cavazzo Carnico",
  "Cave",
  "Cavedago",
  "Cavedine",
  "Cavenago d'Adda",
  "Cavenago di Brianza",
  "Cavernago",
  "Cavezzo",
  "Cavizzana",
  "Cavour",
  "Cavriago",
  "Cavriana",
  "Cavriglia",
  "Cazzago Brabbia",
  "Cazzago San Martino",
  "Cazzano di Tramigna",
  "Cazzano Sant'Andrea",
  "Ceccano",
  "Cecima",
  "Cecina",
  "Cedegolo",
  "Cedrasco",
  "Cefalà Diana",
  "Cefalù",
  "Ceggia",
  "Ceglie Messapica",
  "Celano",
  "Celenza sul Trigno",
  "Celenza Valfortore",
  "Celico",
  "Cella Dati",
  "Cella Monte",
  "Cellamare",
  "Cellara",
  "Cellarengo",
  "Cellatica",
  "Celle di Bulgheria",
  "Celle di Macra",
  "Celle di San Vito",
  "Celle Enomondo",
  "Celle Ligure",
  "Celleno",
  "Cellere",
  "Cellino Attanasio",
  "Cellino San Marco",
  "Cellio con Breia",
  "Cellole",
  "Cembra Lisignago",
  "Cenadi",
  "Cenate Sopra",
  "Cenate Sotto",
  "Cencenighe Agordino",
  "Cene",
  "Ceneselli",
  "Cengio",
  "Centallo",
  "Cento",
  "Centola",
  "Centrache",
  "Centro Valle Intelvi",
  "Centuripe",
  "Cepagatti",
  "Ceppaloni",
  "Ceppo Morelli",
  "Ceprano",
  "Cerami",
  "Ceranesi",
  "Cerano",
  "Cerano d'Intelvi",
  "Ceranova",
  "Ceraso",
  "Cercemaggiore",
  "Cercenasco",
  "Cercepiccola",
  "Cerchiara di Calabria",
  "Cerchio",
  "Cercino",
  "Cercivento",
  "Cercola",
  "Cerda",
  "Cerea",
  "Ceregnano",
  "Cerenzia",
  "Ceres",
  "Ceresara",
  "Cereseto",
  "Ceresole Alba",
  "Ceresole Reale",
  "Cerete",
  "Ceretto Lomellina",
  "Cergnago",
  "Ceriale",
  "Ceriana",
  "Ceriano Laghetto",
  "Cerignale",
  "Cerignola",
  "Cerisano",
  "Cermenate",
  "Cermes",
  "Cermignano",
  "Cernobbio",
  "Cernusco Lombardone",
  "Cernusco sul Naviglio",
  "Cerreto d'Asti",
  "Cerreto d'Esi",
  "Cerreto di Spoleto",
  "Cerreto Grue",
  "Cerreto Guidi",
  "Cerreto Laziale",
  "Cerreto Sannita",
  "Cerretto Langhe",
  "Cerrina Monferrato",
  "Cerrione",
  "Cerro al Lambro",
  "Cerro al Volturno",
  "Cerro Maggiore",
  "Cerro Tanaro",
  "Cerro Veronese",
  "Cersosimo",
  "Certaldo",
  "Certosa di Pavia",
  "Cerva",
  "Cervara di Roma",
  "Cervarese Santa Croce",
  "Cervaro",
  "Cervasca",
  "Cervatto",
  "Cerveno",
  "Cervere",
  "Cervesina",
  "Cerveteri",
  "Cervia",
  "Cervicati",
  "Cervignano d'Adda",
  "Cervignano del Friuli",
  "Cervinara",
  "Cervino",
  "Cervo",
  "Cerzeto",
  "Cesa",
  "Cesana Brianza",
  "Cesana Torinese",
  "Cesano Boscone",
  "Cesano Maderno",
  "Cesara",
  "Cesarò",
  "Cesate",
  "Cesena",
  "Cesenatico",
  "Cesinali",
  "Cesio",
  "Cesiomaggiore",
  "Cessalto",
  "Cessaniti",
  "Cessapalombo",
  "Cessole",
  "Cetara",
  "Ceto",
  "Cetona",
  "Cetraro",
  "Ceva",
  "Cevo",
  "Challand-Saint-Anselme",
  "Challand-Saint-Victor",
  "Chambave",
  "Chamois",
  "Champdepraz",
  "Champorcher",
  "Charvensod",
  "Cherasco",
  "Cheremule",
  "Chialamberto",
  "Chiampo",
  "Chianche",
  "Chianciano Terme",
  "Chianni",
  "Chianocco",
  "Chiaramonte Gulfi",
  "Chiaramonti",
  "Chiarano",
  "Chiaravalle",
  "Chiaravalle Centrale",
  "Chiari",
  "Chiaromonte",
  "Chiauci",
  "Chiavari",
  "Chiavenna",
  "Chiaverano",
  "Chienes",
  "Chieri",
  "Chies d'Alpago",
  "Chiesa in Valmalenco",
  "Chiesanuova",
  "Chiesina Uzzanese",
  "Chieti",
  "Chieuti",
  "Chieve",
  "Chignolo d'Isola",
  "Chignolo Po",
  "Chioggia",
  "Chiomonte",
  "Chions",
  "Chiopris-Viscone",
  "Chitignano",
  "Chiuduno",
  "Chiuppano",
  "Chiuro",
  "Chiusa",
  "Chiusa di Pesio",
  "Chiusa di San Michele",
  "Chiusa Sclafani",
  "Chiusaforte",
  "Chiusanico",
  "Chiusano d'Asti",
  "Chiusano di San Domenico",
  "Chiusavecchia",
  "Chiusdino",
  "Chiusi",
  "Chiusi della Verna",
  "Chivasso",
  "Châtillon",
  "Ciampino",
  "Cianciana",
  "Cibiana di Cadore",
  "Cicagna",
  "Cicala",
  "Cicciano",
  "Cicerale",
  "Ciciliano",
  "Cicognolo",
  "Ciconio",
  "Cigliano",
  "Cigliè",
  "Cigognola",
  "Cigole",
  "Cilavegna",
  "Cimadolmo",
  "Cimbergo",
  "Ciminna",
  "Ciminà",
  "Cimitile",
  "Cimolais",
  "Cimone",
  "Cinaglio",
  "Cineto Romano",
  "Cingia de' Botti",
  "Cingoli",
  "Cinigiano",
  "Cinisello Balsamo",
  "Cinisi",
  "Cino",
  "Cinquefrondi",
  "Cintano",
  "Cinte Tesino",
  "Cinto Caomaggiore",
  "Cinto Euganeo",
  "Cinzano",
  "Ciorlano",
  "Cipressa",
  "Circello",
  "Cirigliano",
  "Cirimido",
  "Ciriè",
  "Cirò",
  "Cirò Marina",
  "Cis",
  "Cisano Bergamasco",
  "Cisano sul Neva",
  "Ciserano",
  "Cislago",
  "Cisliano",
  "Cison di Valmarino",
  "Cissone",
  "Cisterna d'Asti",
  "Cisterna di Latina",
  "Cisternino",
  "Citerna",
  "Cittadella",
  "Cittaducale",
  "Cittanova",
  "Cittareale",
  "Cittiglio",
  "Città della Pieve",
  "Città di Castello",
  "Città Sant'Angelo",
  "Civate",
  "Civezza",
  "Civezzano",
  "Civiasco",
  "Cividale del Friuli",
  "Cividate al Piano",
  "Cividate Camuno",
  "Civita",
  "Civita Castellana",
  "Civita d'Antino",
  "Civitacampomarano",
  "Civitaluparella",
  "Civitanova del Sannio",
  "Civitanova Marche",
  "Civitaquana",
  "Civitavecchia",
  "Civitella Alfedena",
  "Civitella Casanova",
  "Civitella d'Agliano",
  "Civitella del Tronto",
  "Civitella di Romagna",
  "Civitella in Val di Chiana",
  "Civitella Messer Raimondo",
  "Civitella Paganico",
  "Civitella Roveto",
  "Civitella San Paolo",
  "Civo",
  "Claino con Osteno",
  "Claut",
  "Clauzetto",
  "Clavesana",
  "Claviere",
  "Cles",
  "Cleto",
  "Clivio",
  "Clusone",
  "Coassolo Torinese",
  "Coazze",
  "Coazzolo",
  "Coccaglio",
  "Cocconato",
  "Cocquio-Trevisago",
  "Cocullo",
  "Codevigo",
  "Codevilla",
  "Codigoro",
  "Codogno",
  "Codognè",
  "Codroipo",
  "Codrongianos",
  "Coggiola",
  "Cogliate",
  "Cogne",
  "Cogoleto",
  "Cogollo del Cengio",
  "Cogorno",
  "Colazza",
  "Colceresa",
  "Colere",
  "Colfelice",
  "Coli",
  "Colico",
  "Collalto Sabino",
  "Collarmele",
  "Collazzone",
  "Colle Brianza",
  "Colle d'Anchise",
  "Colle di Tora",
  "Colle di Val d'Elsa",
  "Colle San Magno",
  "Colle Sannita",
  "Colle Santa Lucia",
  "Colle Umberto",
  "Collebeato",
  "Collecchio",
  "Collecorvino",
  "Colledara",
  "Colledimacine",
  "Colledimezzo",
  "Colleferro",
  "Collegiove",
  "Collegno",
  "Collelongo",
  "Collepardo",
  "Collepasso",
  "Collepietro",
  "Colleretto Castelnuovo",
  "Colleretto Giacosa",
  "Collesalvetti",
  "Collesano",
  "Colletorto",
  "Collevecchio",
  "Colli a Volturno",
  "Colli al Metauro",
  "Colli del Tronto",
  "Colli sul Velino",
  "Colli Verdi",
  "Colliano",
  "Collinas",
  "Collio",
  "Collobiano",
  "Colloredo di Monte Albano",
  "Colmurano",
  "Colobraro",
  "Cologna Veneta",
  "Cologne",
  "Cologno al Serio",
  "Cologno Monzese",
  "Colognola ai Colli",
  "Colonna",
  "Colonnella",
  "Colonno",
  "Colorina",
  "Colorno",
  "Colosimi",
  "Colturano",
  "Colverde",
  "Colzate",
  "Comabbio",
  "Comacchio",
  "Comano",
  "Comano Terme",
  "Comazzo",
  "Comeglians",
  "Comelico Superiore",
  "Comerio",
  "Comezzano-Cizzago",
  "Comignago",
  "Comiso",
  "Comitini",
  "Comiziano",
  "Commessaggio",
  "Commezzadura",
  "Como",
  "Compiano",
  "Comun Nuovo",
  "Comunanza",
  "Cona",
  "Conca Casale",
  "Conca dei Marini",
  "Conca della Campania",
  "Concamarise",
  "Concerviano",
  "Concesio",
  "Concordia Sagittaria",
  "Concordia sulla Secchia",
  "Concorezzo",
  "Condofuri",
  "Condove",
  "Condrò",
  "Conegliano",
  "Confienza",
  "Configni",
  "Conflenti",
  "Coniolo",
  "Conselice",
  "Conselve",
  "Contessa Entellina",
  "Contigliano",
  "Contrada",
  "Controguerra",
  "Controne",
  "Contursi Terme",
  "Contà",
  "Conversano",
  "Conza della Campania",
  "Conzano",
  "Copertino",
  "Copiano",
  "Copparo",
  "Corana",
  "Corato",
  "Corbara",
  "Corbetta",
  "Corbola",
  "Corchiano",
  "Corciano",
  "Cordenons",
  "Cordignano",
  "Cordovado",
  "Coreglia Antelminelli",
  "Coreglia Ligure",
  "Coreno Ausonio",
  "Corfinio",
  "Cori",
  "Coriano",
  "Corigliano d'Otranto",
  "Corigliano-Rossano",
  "Corinaldo",
  "Corio",
  "Corleone",
  "Corleto Monforte",
  "Corleto Perticara",
  "Cormano",
  "Cormons",
  "Corna Imagna",
  "Cornalba",
  "Cornale e Bastida",
  "Cornaredo",
  "Cornate d'Adda",
  "Cornedo all'Isarco",
  "Cornedo Vicentino",
  "Cornegliano Laudense",
  "Corneliano d'Alba",
  "Corniglio",
  "Corno di Rosazzo",
  "Corno Giovine",
  "Cornovecchio",
  "Cornuda",
  "Correggio",
  "Correzzana",
  "Correzzola",
  "Corrido",
  "Corridonia",
  "Corropoli",
  "Corsano",
  "Corsico",
  "Corsione",
  "Cortaccia sulla strada del vino",
  "Cortale",
  "Cortandone",
  "Cortanze",
  "Cortazzone",
  "Corte Brugnatella",
  "Corte de' Cortesi con Cignone",
  "Corte de' Frati",
  "Corte Franca",
  "Corte Palasio",
  "Cortemaggiore",
  "Cortemilia",
  "Corteno Golgi",
  "Cortenova",
  "Cortenuova",
  "Corteolona e Genzone",
  "Cortiglione",
  "Cortina d'Ampezzo",
  "Cortina sulla strada del vino",
  "Cortino",
  "Cortona",
  "Corvara",
  "Corvara in Badia",
  "Corvino San Quirico",
  "Corzano",
  "Coseano",
  "Cosenza",
  "Cosio d'Arroscia",
  "Cosio Valtellino",
  "Cosoleto",
  "Cossano Belbo",
  "Cossano Canavese",
  "Cossato",
  "Cosseria",
  "Cossignano",
  "Cossogno",
  "Cossoine",
  "Cossombrato",
  "Costa de' Nobili",
  "Costa di Mezzate",
  "Costa di Rovigo",
  "Costa Masnaga",
  "Costa Serina",
  "Costa Valle Imagna",
  "Costa Vescovato",
  "Costa Volpino",
  "Costabissara",
  "Costacciaro",
  "Costanzana",
  "Costarainera",
  "Costermano sul Garda",
  "Costigliole d'Asti",
  "Costigliole Saluzzo",
  "Cotignola",
  "Cotronei",
  "Cottanello",
  "Courmayeur",
  "Covo",
  "Cozzo",
  "Craco",
  "Crandola Valsassina",
  "Cravagliana",
  "Cravanzana",
  "Craveggia",
  "Creazzo",
  "Crecchio",
  "Credaro",
  "Credera Rubbiano",
  "Crema",
  "Cremella",
  "Cremenaga",
  "Cremeno",
  "Cremia",
  "Cremolino",
  "Cremona",
  "Cremosano",
  "Crescentino",
  "Crespadoro",
  "Crespiatica",
  "Crespina Lorenzana",
  "Crespino",
  "Cressa",
  "Crevacuore",
  "Crevalcore",
  "Crevoladossola",
  "Crispano",
  "Crispiano",
  "Crissolo",
  "Crocefieschi",
  "Crocetta del Montello",
  "Crodo",
  "Crognaleto",
  "Cropalati",
  "Cropani",
  "Crosia",
  "Crosio della Valle",
  "Crotone",
  "Crotta d'Adda",
  "Crova",
  "Croviana",
  "Crucoli",
  "Cuasso al Monte",
  "Cuccaro Vetere",
  "Cucciago",
  "Cuceglio",
  "Cuggiono",
  "Cugliate-Fabiasco",
  "Cuglieri",
  "Cugnoli",
  "Cumiana",
  "Cumignano sul Naviglio",
  "Cunardo",
  "Cuneo",
  "Cunico",
  "Cuorgnè",
  "Cupello",
  "Cupra Marittima",
  "Cupramontana",
  "Cura Carpignano",
  "Curcuris",
  "Cureggio",
  "Curiglia con Monteviasco",
  "Curinga",
  "Curino",
  "Curno",
  "Curon Venosta",
  "Cursi",
  "Curtarolo",
  "Curtatone",
  "Curti",
  "Cusago",
  "Cusano Milanino",
  "Cusano Mutri",
  "Cusino",
  "Cusio",
  "Custonaci",
  "Cutro",
  "Cutrofiano",
  "Cuveglio",
  "Cuvio",
  "Dairago",
  "Dalmine",
  "Dambel",
  "Danta di Cadore",
  "Darfo Boario Terme",
  "Dasà",
  "Davagna",
  "Daverio",
  "Davoli",
  "Dazio",
  "Decimomannu",
  "Decimoputzu",
  "Decollatura",
  "Dego",
  "Deiva Marina",
  "Delebio",
  "Delia",
  "Delianuova",
  "Deliceto",
  "Dello",
  "Demonte",
  "Denice",
  "Denno",
  "Dernice",
  "Derovere",
  "Deruta",
  "Dervio",
  "Desana",
  "Desenzano del Garda",
  "Desio",
  "Desulo",
  "Diamante",
  "Diano Arentino",
  "Diano Castello",
  "Diano d'Alba",
  "Diano Marina",
  "Diano San Pietro",
  "Dicomano",
  "Dignano",
  "Dimaro Folgarida",
  "Dinami",
  "Dipignano",
  "Diso",
  "Divignano",
  "Dizzasco",
  "Dobbiaco",
  "Doberdò del Lago",
  "Dogliani",
  "Dogliola",
  "Dogna",
  "Dolceacqua",
  "Dolcedo",
  "Dolcè",
  "Dolegna del Collio",
  "Dolianova",
  "Dolo",
  "Dolzago",
  "Domanico",
  "Domaso",
  "Domegge di Cadore",
  "Domicella",
  "Domodossola",
  "Domus de Maria",
  "Domusnovas",
  "Donato",
  "Dongo",
  "Donnas",
  "Donori",
  "Dorgali",
  "Dorio",
  "Dormelletto",
  "Dorno",
  "Dorzano",
  "Dosolo",
  "Dossena",
  "Dosso del Liro",
  "Doues",
  "Dovadola",
  "Dovera",
  "Dozza",
  "Dragoni",
  "Drapia",
  "Drena",
  "Drenchia",
  "Dresano",
  "Dro",
  "Dronero",
  "Druento",
  "Druogno",
  "Dualchi",
  "Dubino",
  "Due Carrare",
  "Dueville",
  "Dugenta",
  "Duino Aurisina",
  "Dumenza",
  "Duno",
  "Durazzano",
  "Duronia",
  "Dusino San Michele",
  "Eboli",
  "Edolo",
  "Egna",
  "Elice",
  "Elini",
  "Ello",
  "Elmas",
  "Elva",
  "Emarèse",
  "Empoli",
  "Endine Gaiano",
  "Enego",
  "Enemonzo",
  "Enna",
  "Entracque",
  "Entratico",
  "Envie",
  "Episcopia",
  "Eraclea",
  "Erba",
  "Erbezzo",
  "Erbusco",
  "Erbè",
  "Erchie",
  "Ercolano",
  "Erice",
  "Erli",
  "Erto e Casso",
  "Erula",
  "Erve",
  "Esanatoglia",
  "Escalaplano",
  "Escolca",
  "Esine",
  "Esino Lario",
  "Esperia",
  "Esporlatu",
  "Este",
  "Esterzili",
  "Etroubles",
  "Eupilio",
  "Exilles",
  "Fabbrica Curone",
  "Fabbriche di Vergemoli",
  "Fabbrico",
  "Fabriano",
  "Fabrica di Roma",
  "Fabrizia",
  "Fabro",
  "Faedis",
  "Faedo Valtellino",
  "Faenza",
  "Faeto",
  "Fagagna",
  "Faggeto Lario",
  "Faggiano",
  "Fagnano Alto",
  "Fagnano Castello",
  "Fagnano Olona",
  "Fai della Paganella",
  "Faicchio",
  "Falcade",
  "Falciano del Massico",
  "Falconara Albanese",
  "Falconara Marittima",
  "Falcone",
  "Faleria",
  "Falerna",
  "Falerone",
  "Fallo",
  "Faloppio",
  "Falvaterra",
  "Falzes",
  "Fanano",
  "Fanna",
  "Fano",
  "Fano Adriano",
  "Fara Filiorum Petri",
  "Fara Gera d'Adda",
  "Fara in Sabina",
  "Fara Novarese",
  "Fara Olivana con Sola",
  "Fara San Martino",
  "Fara Vicentino",
  "Fardella",
  "Farigliano",
  "Farindola",
  "Farini",
  "Farnese",
  "Farra d'Isonzo",
  "Farra di Soligo",
  "Fasano",
  "Fascia",
  "Fauglia",
  "Faule",
  "Favale di Malvaro",
  "Favara",
  "Favignana",
  "Favria",
  "Feisoglio",
  "Feletto",
  "Felino",
  "Felitto",
  "Felizzano",
  "Feltre",
  "Fenegrò",
  "Fenestrelle",
  "Ferentillo",
  "Ferentino",
  "Ferla",
  "Fermignano",
  "Fermo",
  "Ferno",
  "Feroleto Antico",
  "Feroleto della Chiesa",
  "Ferrandina",
  "Ferrara",
  "Ferrara di Monte Baldo",
  "Ferrazzano",
  "Ferrera di Varese",
  "Ferrera Erbognone",
  "Ferrere",
  "Ferriere",
  "Ferruzzano",
  "Fiamignano",
  "Fiano",
  "Fiano Romano",
  "Fiastra",
  "Fiavè",
  "Ficarazzi",
  "Ficarolo",
  "Ficarra",
  "Ficulle",
  "Fidenza",
  "Fierozzo",
  "Fiesco",
  "Fiesole",
  "Fiesse",
  "Fiesso d'Artico",
  "Fiesso Umbertiano",
  "Figino Serenza",
  "Figline e Incisa Valdarno",
  "Figline Vegliaturo",
  "Filacciano",
  "Filadelfia",
  "Filago",
  "Filandari",
  "Filattiera",
  "Filettino",
  "Filetto",
  "Filiano",
  "Filighera",
  "Filignano",
  "Filogaso",
  "Filottrano",
  "Finale Emilia",
  "Finale Ligure",
  "Fino del Monte",
  "Fino Mornasco",
  "Fiorano al Serio",
  "Fiorano Canavese",
  "Fiorano Modenese",
  "Fiorenzuola d'Arda",
  "Firenze",
  "Firenzuola",
  "Firmo",
  "Fiscaglia",
  "Fisciano",
  "Fiuggi",
  "Fiumalbo",
  "Fiumara",
  "Fiume Veneto",
  "Fiumedinisi",
  "Fiumefreddo Bruzio",
  "Fiumefreddo di Sicilia",
  "Fiumicello Villa Vicentina",
  "Fiumicino",
  "Fiuminata",
  "Fivizzano",
  "Fiè allo Sciliar",
  "Flaibano",
  "Flero",
  "Floresta",
  "Floridia",
  "Florinas",
  "Flumeri",
  "Fluminimaggiore",
  "Flussio",
  "Fobello",
  "Foggia",
  "Foglianise",
  "Fogliano Redipuglia",
  "Foglizzo",
  "Foiano della Chiana",
  "Foiano di Val Fortore",
  "Folgaria",
  "Folignano",
  "Foligno",
  "Follina",
  "Follo",
  "Follonica",
  "Fombio",
  "Fondachelli-Fantina",
  "Fondi",
  "Fonni",
  "Fontainemore",
  "Fontana Liri",
  "Fontanafredda",
  "Fontanarosa",
  "Fontanelice",
  "Fontanella",
  "Fontanellato",
  "Fontanelle",
  "Fontaneto d'Agogna",
  "Fontanetto Po",
  "Fontanigorda",
  "Fontanile",
  "Fontaniva",
  "Fonte",
  "Fonte Nuova",
  "Fontecchio",
  "Fontechiari",
  "Fontegreca",
  "Fonteno",
  "Fontevivo",
  "Fonzaso",
  "Foppolo",
  "Forano",
  "Force",
  "Forchia",
  "Forcola",
  "Fordongianus",
  "Forenza",
  "Foresto Sparso",
  "Forgaria nel Friuli",
  "Forino",
  "Forio",
  "Forlimpopoli",
  "Forlì",
  "Forlì del Sannio",
  "Formazza",
  "Formello",
  "Formia",
  "Formicola",
  "Formigara",
  "Formigine",
  "Formigliana",
  "Fornace",
  "Fornelli",
  "Forni Avoltri",
  "Forni di Sopra",
  "Forni di Sotto",
  "Forno Canavese",
  "Fornovo di Taro",
  "Fornovo San Giovanni",
  "Forte dei Marmi",
  "Fortezza",
  "Fortunago",
  "Forza d'Agrò",
  "Fosciandora",
  "Fosdinovo",
  "Fossa",
  "Fossacesia",
  "Fossalta di Piave",
  "Fossalta di Portogruaro",
  "Fossalto",
  "Fossano",
  "Fossato di Vico",
  "Fossato Serralta",
  "Fossombrone",
  "Fossò",
  "Foza",
  "Frabosa Soprana",
  "Frabosa Sottana",
  "Fraconalto",
  "Fragagnano",
  "Fragneto l'Abate",
  "Fragneto Monforte",
  "Fraine",
  "Framura",
  "Francavilla al Mare",
  "Francavilla Angitola",
  "Francavilla Bisio",
  "Francavilla d'Ete",
  "Francavilla di Sicilia",
  "Francavilla Fontana",
  "Francavilla in Sinni",
  "Francavilla Marittima",
  "Francica",
  "Francofonte",
  "Francolise",
  "Frascaro",
  "Frascarolo",
  "Frascati",
  "Frascineto",
  "Frassilongo",
  "Frassinelle Polesine",
  "Frassinello Monferrato",
  "Frassineto Po",
  "Frassinetto",
  "Frassino",
  "Frassinoro",
  "Frasso Sabino",
  "Frasso Telesino",
  "Fratta Polesine",
  "Fratta Todina",
  "Frattamaggiore",
  "Frattaminore",
  "Fratte Rosa",
  "Frazzanò",
  "Fregona",
  "Fresagrandinaria",
  "Fresonara",
  "Frigento",
  "Frignano",
  "Frinco",
  "Frisa",
  "Frisanco",
  "Front",
  "Frontino",
  "Frontone",
  "Frosinone",
  "Frosolone",
  "Frossasco",
  "Frugarolo",
  "Fubine Monferrato",
  "Fucecchio",
  "Fuipiano Valle Imagna",
  "Fumane",
  "Fumone",
  "Funes",
  "Furci",
  "Furci Siculo",
  "Furnari",
  "Furore",
  "Furtei",
  "Fuscaldo",
  "Fusignano",
  "Fusine",
  "Futani",
  "Fénis",
  "Gabbioneta-Binanuova",
  "Gabiano",
  "Gabicce Mare",
  "Gaby",
  "Gadesco-Pieve Delmona",
  "Gadoni",
  "Gaeta",
  "Gaggi",
  "Gaggiano",
  "Gaggio Montano",
  "Gaglianico",
  "Gagliano Aterno",
  "Gagliano Castelferrato",
  "Gagliano del Capo",
  "Gagliato",
  "Gagliole",
  "Gaiarine",
  "Gaiba",
  "Gaiola",
  "Gaiole in Chianti",
  "Gairo",
  "Gais",
  "Galati Mamertino",
  "Galatina",
  "Galatone",
  "Galatro",
  "Galbiate",
  "Galeata",
  "Galgagnano",
  "Gallarate",
  "Gallese",
  "Galliate",
  "Galliate Lombardo",
  "Galliavola",
  "Gallicano",
  "Gallicano nel Lazio",
  "Gallicchio",
  "Galliera",
  "Galliera Veneta",
  "Gallinaro",
  "Gallio",
  "Gallipoli",
  "Gallo Matese",
  "Gallodoro",
  "Galluccio",
  "Galtellì",
  "Galzignano Terme",
  "Gamalero",
  "Gambara",
  "Gambarana",
  "Gambasca",
  "Gambassi Terme",
  "Gambatesa",
  "Gambellara",
  "Gamberale",
  "Gambettola",
  "Gambolò",
  "Gambugliano",
  "Gandellino",
  "Gandino",
  "Gandosso",
  "Gangi",
  "Garaguso",
  "Garbagna",
  "Garbagna Novarese",
  "Garbagnate Milanese",
  "Garbagnate Monastero",
  "Garda",
  "Gardone Riviera",
  "Gardone Val Trompia",
  "Garessio",
  "Gargallo",
  "Gargazzone",
  "Gargnano",
  "Garlasco",
  "Garlate",
  "Garlenda",
  "Garniga Terme",
  "Garzeno",
  "Garzigliana",
  "Gasperina",
  "Gassino Torinese",
  "Gattatico",
  "Gatteo",
  "Gattico-Veruno",
  "Gattinara",
  "Gavardo",
  "Gavello",
  "Gaverina Terme",
  "Gavi",
  "Gavignano",
  "Gavirate",
  "Gavoi",
  "Gavorrano",
  "Gazoldo degli Ippoliti",
  "Gazzada Schianno",
  "Gazzaniga",
  "Gazzo",
  "Gazzo Veronese",
  "Gazzola",
  "Gazzuolo",
  "Gela",
  "Gemmano",
  "Gemona del Friuli",
  "Gemonio",
  "Genazzano",
  "Genga",
  "Genivolta",
  "Genola",
  "Genoni",
  "Genova",
  "Genuri",
  "Genzano di Lucania",
  "Genzano di Roma",
  "Gera Lario",
  "Gerace",
  "Geraci Siculo",
  "Gerano",
  "Gerenzago",
  "Gerenzano",
  "Gergei",
  "Germagnano",
  "Germagno",
  "Germignaga",
  "Gerocarne",
  "Gerola Alta",
  "Gerre de' Caprioli",
  "Gesico",
  "Gessate",
  "Gessopalena",
  "Gesturi",
  "Gesualdo",
  "Ghedi",
  "Ghemme",
  "Ghiffa",
  "Ghilarza",
  "Ghisalba",
  "Ghislarengo",
  "Giacciano con Baruchella",
  "Giaglione",
  "Gianico",
  "Giano dell'Umbria",
  "Giano Vetusto",
  "Giardinello",
  "Giardini-Naxos",
  "Giarole",
  "Giarratana",
  "Giarre",
  "Giave",
  "Giaveno",
  "Giavera del Montello",
  "Giba",
  "Gibellina",
  "Gifflenga",
  "Giffone",
  "Giffoni Sei Casali",
  "Giffoni Valle Piana",
  "Gignese",
  "Gignod",
  "Gildone",
  "Gimigliano",
  "Ginestra",
  "Ginestra degli Schiavoni",
  "Ginosa",
  "Gioi",
  "Gioia dei Marsi",
  "Gioia del Colle",
  "Gioia Sannitica",
  "Gioia Tauro",
  "Gioiosa Ionica",
  "Gioiosa Marea",
  "Giove",
  "Giovinazzo",
  "Giovo",
  "Girasole",
  "Girifalco",
  "Gissi",
  "Giuggianello",
  "Giugliano in Campania",
  "Giuliana",
  "Giuliano di Roma",
  "Giuliano Teatino",
  "Giulianova",
  "Giungano",
  "Giurdignano",
  "Giussago",
  "Giussano",
  "Giustenice",
  "Giustino",
  "Giusvalla",
  "Givoletto",
  "Gizzeria",
  "Glorenza",
  "Godega di Sant'Urbano",
  "Godiasco Salice Terme",
  "Godrano",
  "Goito",
  "Golasecca",
  "Golferenzo",
  "Golfo Aranci",
  "Gombito",
  "Gonars",
  "Goni",
  "Gonnesa",
  "Gonnoscodina",
  "Gonnosfanadiga",
  "Gonnosnò",
  "Gonnostramatza",
  "Gonzaga",
  "Gordona",
  "Gorga",
  "Gorgo al Monticano",
  "Gorgoglione",
  "Gorgonzola",
  "Goriano Sicoli",
  "Gorizia",
  "Gorla Maggiore",
  "Gorla Minore",
  "Gorlago",
  "Gorle",
  "Gornate Olona",
  "Gorno",
  "Goro",
  "Gorreto",
  "Gorzegno",
  "Gosaldo",
  "Gossolengo",
  "Gottasecca",
  "Gottolengo",
  "Govone",
  "Gozzano",
  "Gradara",
  "Gradisca d'Isonzo",
  "Grado",
  "Gradoli",
  "Graffignana",
  "Graffignano",
  "Graglia",
  "Gragnano",
  "Gragnano Trebbiense",
  "Grammichele",
  "Grana",
  "Granarolo dell'Emilia",
  "Grandate",
  "Grandola ed Uniti",
  "Graniti",
  "Granozzo con Monticello",
  "Grantola",
  "Grantorto",
  "Granze",
  "Grassano",
  "Grassobbio",
  "Gratteri",
  "Gravedona ed Uniti",
  "Gravellona Lomellina",
  "Gravellona Toce",
  "Gravere",
  "Gravina di Catania",
  "Gravina in Puglia",
  "Grazzanise",
  "Grazzano Badoglio",
  "Greccio",
  "Greci",
  "Greggio",
  "Gremiasco",
  "Gressan",
  "Gressoney-La-Trinité",
  "Gressoney-Saint-Jean",
  "Greve in Chianti",
  "Grezzago",
  "Grezzana",
  "Griante",
  "Gricignano di Aversa",
  "Grignasco",
  "Grigno",
  "Grimacco",
  "Grimaldi",
  "Grinzane Cavour",
  "Grisignano di Zocco",
  "Grisolia",
  "Grizzana Morandi",
  "Grognardo",
  "Gromo",
  "Grondona",
  "Grone",
  "Grontardo",
  "Gropello Cairoli",
  "Gropparello",
  "Groscavallo",
  "Grosio",
  "Grosotto",
  "Grosseto",
  "Grosso",
  "Grottaferrata",
  "Grottaglie",
  "Grottaminarda",
  "Grottammare",
  "Grottazzolina",
  "Grotte",
  "Grotte di Castro",
  "Grotteria",
  "Grottole",
  "Grottolella",
  "Gruaro",
  "Grugliasco",
  "Grumello Cremonese ed Uniti",
  "Grumello del Monte",
  "Grumento Nova",
  "Grumo Appula",
  "Grumo Nevano",
  "Grumolo delle Abbadesse",
  "Guagnano",
  "Gualdo",
  "Gualdo Cattaneo",
  "Gualdo Tadino",
  "Gualtieri",
  "Gualtieri Sicaminò",
  "Guamaggiore",
  "Guanzate",
  "Guarcino",
  "Guarda Veneta",
  "Guardabosone",
  "Guardamiglio",
  "Guardavalle",
  "Guardea",
  "Guardia Lombardi",
  "Guardia Perticara",
  "Guardia Piemontese",
  "Guardia Sanframondi",
  "Guardiagrele",
  "Guardialfiera",
  "Guardiaregia",
  "Guardistallo",
  "Guarene",
  "Guasila",
  "Guastalla",
  "Guazzora",
  "Gubbio",
  "Gudo Visconti",
  "Guglionesi",
  "Guidizzolo",
  "Guidonia Montecelio",
  "Guiglia",
  "Guilmi",
  "Gurro",
  "Guspini",
  "Gussago",
  "Gussola",
  "Hône",
  "Idro",
  "Iglesias",
  "Igliano",
  "Ilbono",
  "Illasi",
  "Illorai",
  "Imbersago",
  "Imer",
  "Imola",
  "Imperia",
  "Impruneta",
  "Inarzo",
  "Incisa Scapaccino",
  "Incudine",
  "Induno Olona",
  "Ingria",
  "Intragna",
  "Introbio",
  "Introd",
  "Introdacqua",
  "Inverigo",
  "Inverno e Monteleone",
  "Inverso Pinasca",
  "Inveruno",
  "Invorio",
  "Inzago",
  "Ionadi",
  "Irgoli",
  "Irma",
  "Irsina",
  "Isasca",
  "Isca sullo Ionio",
  "Ischia",
  "Ischia di Castro",
  "Ischitella",
  "Iseo",
  "Isera",
  "Isernia",
  "Isili",
  "Isnello",
  "Isola d'Asti",
  "Isola del Cantone",
  "Isola del Giglio",
  "Isola del Gran Sasso d'Italia",
  "Isola del Liri",
  "Isola del Piano",
  "Isola della Scala",
  "Isola delle Femmine",
  "Isola di Capo Rizzuto",
  "Isola di Fondra",
  "Isola Dovarese",
  "Isola Rizza",
  "Isola Sant'Antonio",
  "Isola Vicentina",
  "Isolabella",
  "Isolabona",
  "Isole Tremiti",
  "Isorella",
  "Ispani",
  "Ispica",
  "Ispra",
  "Issiglio",
  "Issime",
  "Isso",
  "Issogne",
  "Istrana",
  "Itala",
  "Itri",
  "Ittireddu",
  "Ittiri",
  "Ivrea",
  "Izano",
  "Jacurso",
  "Jelsi",
  "Jenne",
  "Jerago con Orago",
  "Jerzu",
  "Jesi",
  "Jesolo",
  "Jolanda di Savoia",
  "Joppolo",
  "Joppolo Giancaxio",
  "Jovençan",
  "L'Aquila",
  "La Cassa",
  "La Loggia",
  "La Maddalena",
  "La Magdeleine",
  "La Morra",
  "La Salle",
  "La Spezia",
  "La Thuile",
  "La Valle",
  "La Valle Agordina",
  "La Valletta Brianza",
  "Labico",
  "Labro",
  "Lacchiarella",
  "Lacco Ameno",
  "Lacedonia",
  "Laces",
  "Laconi",
  "Ladispoli",
  "Laerru",
  "Laganadi",
  "Laghi",
  "Laglio",
  "Lagnasco",
  "Lago",
  "Lagonegro",
  "Lagosanto",
  "Lagundo",
  "Laigueglia",
  "Lainate",
  "Laino",
  "Laino Borgo",
  "Laino Castello",
  "Laion",
  "Laives",
  "Lajatico",
  "Lallio",
  "Lama dei Peligni",
  "Lama Mocogno",
  "Lambrugo",
  "Lamezia Terme",
  "Lamon",
  "Lampedusa e Linosa",
  "Lamporecchio",
  "Lamporo",
  "Lana",
  "Lanciano",
  "Landiona",
  "Landriano",
  "Langhirano",
  "Langosco",
  "Lanusei",
  "Lanuvio",
  "Lanzada",
  "Lanzo Torinese",
  "Lapedona",
  "Lapio",
  "Lappano",
  "Larciano",
  "Lardirago",
  "Lariano",
  "Larino",
  "Las Plassas",
  "Lasa",
  "Lascari",
  "Lasnigo",
  "Lastebasse",
  "Lastra a Signa",
  "Latera",
  "Laterina Pergine Valdarno",
  "Laterza",
  "Latiano",
  "Latina",
  "Latisana",
  "Latronico",
  "Lattarico",
  "Lauco",
  "Laureana Cilento",
  "Laureana di Borrello",
  "Lauregno",
  "Laurenzana",
  "Lauria",
  "Lauriano",
  "Laurino",
  "Laurito",
  "Lauro",
  "Lavagna",
  "Lavagno",
  "Lavarone",
  "Lavello",
  "Lavena Ponte Tresa",
  "Laveno-Mombello",
  "Lavenone",
  "Laviano",
  "Lavis",
  "Lazise",
  "Lazzate",
  "Lecce",
  "Lecce nei Marsi",
  "Lecco",
  "Ledro",
  "Leffe",
  "Leggiuno",
  "Legnago",
  "Legnano",
  "Legnaro",
  "Lei",
  "Leini",
  "Leivi",
  "Lemie",
  "Lendinara",
  "Leni",
  "Lenna",
  "Leno",
  "Lenola",
  "Lenta",
  "Lentate sul Seveso",
  "Lentella",
  "Lentini",
  "Leonessa",
  "Leonforte",
  "Leporano",
  "Lequile",
  "Lequio Berria",
  "Lequio Tanaro",
  "Lercara Friddi",
  "Lerici",
  "Lerma",
  "Lesa",
  "Lesegno",
  "Lesignano de' Bagni",
  "Lesina",
  "Lesmo",
  "Lessolo",
  "Lessona",
  "Lestizza",
  "Letino",
  "Letojanni",
  "Lettere",
  "Lettomanoppello",
  "Lettopalena",
  "Levanto",
  "Levate",
  "Leverano",
  "Levice",
  "Levico Terme",
  "Levone",
  "Lezzeno",
  "Liberi",
  "Librizzi",
  "Licata",
  "Licciana Nardi",
  "Licenza",
  "Licodia Eubea",
  "Lierna",
  "Lignana",
  "Lignano Sabbiadoro",
  "Lillianes",
  "Limana",
  "Limatola",
  "Limbadi",
  "Limbiate",
  "Limena",
  "Limido Comasco",
  "Limina",
  "Limone Piemonte",
  "Limone sul Garda",
  "Limosano",
  "Linarolo",
  "Linguaglossa",
  "Lioni",
  "Lipari",
  "Lipomo",
  "Lirio",
  "Liscate",
  "Liscia",
  "Lisciano Niccone",
  "Lisio",
  "Lissone",
  "Liveri",
  "Livigno",
  "Livinallongo del Col di Lana",
  "Livo (CO)",
  "Livo (TN)",
  "Livorno",
  "Livorno Ferraris",
  "Livraga",
  "Lizzanello",
  "Lizzano",
  "Lizzano in Belvedere",
  "Loano",
  "Loazzolo",
  "Locana",
  "Locate di Triulzi",
  "Locate Varesino",
  "Locatello",
  "Loceri",
  "Locorotondo",
  "Locri",
  "Loculi",
  "Lodi",
  "Lodi Vecchio",
  "Lodine",
  "Lodrino",
  "Lodè",
  "Lograto",
  "Loiano",
  "Loiri Porto San Paolo",
  "Lomagna",
  "Lomazzo",
  "Lombardore",
  "Lombriasco",
  "Lomello",
  "Lona-Lases",
  "Lonate Ceppino",
  "Lonate Pozzolo",
  "Lonato del Garda",
  "Londa",
  "Longano",
  "Longare",
  "Longarone",
  "Longhena",
  "Longi",
  "Longiano",
  "Longobardi",
  "Longobucco",
  "Longone al Segrino",
  "Longone Sabino",
  "Lonigo",
  "Loranzè",
  "Loreggia",
  "Loreglia",
  "Lorenzago di Cadore",
  "Loreo",
  "Loreto",
  "Loreto Aprutino",
  "Loria",
  "Loro Ciuffenna",
  "Loro Piceno",
  "Lorsica",
  "Losine",
  "Lotzorai",
  "Lovere",
  "Lovero",
  "Lozio",
  "Lozza",
  "Lozzo Atestino",
  "Lozzo di Cadore",
  "Lozzolo",
  "Lu e Cuccaro Monferrato",
  "Lubriano",
  "Lucca",
  "Lucca Sicula",
  "Lucera",
  "Lucignano",
  "Lucinasco",
  "Lucito",
  "Luco dei Marsi",
  "Lucoli",
  "Lugagnano Val d'Arda",
  "Lugnano in Teverina",
  "Lugo",
  "Lugo di Vicenza",
  "Luino",
  "Luisago",
  "Lula",
  "Lumarzo",
  "Lumezzane",
  "Lunamatrona",
  "Lunano",
  "Lungavilla",
  "Lungro",
  "Luni",
  "Luogosano",
  "Luogosanto",
  "Lupara",
  "Lurago d'Erba",
  "Lurago Marinone",
  "Lurano",
  "Luras",
  "Lurate Caccivio",
  "Lusciano",
  "Luserna",
  "Luserna San Giovanni",
  "Lusernetta",
  "Lusevera",
  "Lusia",
  "Lusiana Conco",
  "Lusigliè",
  "Luson",
  "Lustra",
  "Luvinate",
  "Luzzana",
  "Luzzara",
  "Luzzi",
  "Maccagno con Pino e Veddasca",
  "Maccastorna",
  "Macchia d'Isernia",
  "Macchia Valfortore",
  "Macchiagodena",
  "Macello",
  "Macerata",
  "Macerata Campania",
  "Macerata Feltria",
  "Macherio",
  "Maclodio",
  "Macomer",
  "Macra",
  "Macugnaga",
  "Maddaloni",
  "Madesimo",
  "Madignano",
  "Madone",
  "Madonna del Sasso",
  "Madruzzo",
  "Maenza",
  "Mafalda",
  "Magasa",
  "Magenta",
  "Maggiora",
  "Magherno",
  "Magione",
  "Magisano",
  "Magliano Alfieri",
  "Magliano Alpi",
  "Magliano de' Marsi",
  "Magliano di Tenna",
  "Magliano in Toscana",
  "Magliano Romano",
  "Magliano Sabina",
  "Magliano Vetere",
  "Maglie",
  "Magliolo",
  "Maglione",
  "Magnacavallo",
  "Magnago",
  "Magnano",
  "Magnano in Riviera",
  "Magomadas",
  "Magreglio",
  "Magrè sulla strada del vino",
  "Maida",
  "Maierato",
  "Maierà",
  "Maiolati Spontini",
  "Maiolo",
  "Maiori",
  "Mairago",
  "Mairano",
  "Maissana",
  "Majano",
  "Malagnino",
  "Malalbergo",
  "Malborghetto Valbruna",
  "Malcesine",
  "Malegno",
  "Maleo",
  "Malesco",
  "Maletto",
  "Malfa",
  "Malgesso",
  "Malgrate",
  "Malito",
  "Mallare",
  "Malles Venosta",
  "Malnate",
  "Malo",
  "Malonno",
  "Maltignano",
  "Malvagna",
  "Malvicino",
  "Malvito",
  "Malé",
  "Mammola",
  "Mamoiada",
  "Manciano",
  "Mandanici",
  "Mandas",
  "Mandatoriccio",
  "Mandela",
  "Mandello del Lario",
  "Mandello Vitta",
  "Manduria",
  "Manerba del Garda",
  "Manerbio",
  "Manfredonia",
  "Mango",
  "Mangone",
  "Maniace",
  "Maniago",
  "Manocalzati",
  "Manoppello",
  "Mansuè",
  "Manta",
  "Mantello",
  "Mantova",
  "Manzano",
  "Manziana",
  "Mapello",
  "Mappano",
  "Mara",
  "Maracalagonis",
  "Maranello",
  "Marano di Napoli",
  "Marano di Valpolicella",
  "Marano Equo",
  "Marano Lagunare",
  "Marano Marchesato",
  "Marano Principato",
  "Marano sul Panaro",
  "Marano Ticino",
  "Marano Vicentino",
  "Maranzana",
  "Maratea",
  "Marcallo con Casone",
  "Marcaria",
  "Marcedusa",
  "Marcellina",
  "Marcellinara",
  "Marcetelli",
  "Marcheno",
  "Marchirolo",
  "Marciana",
  "Marciana Marina",
  "Marcianise",
  "Marciano della Chiana",
  "Marcignago",
  "Marcon",
  "Marebbe",
  "Marene",
  "Mareno di Piave",
  "Marentino",
  "Maretto",
  "Margarita",
  "Margherita di Savoia",
  "Margno",
  "Mariana Mantovana",
  "Mariano Comense",
  "Mariano del Friuli",
  "Marianopoli",
  "Mariglianella",
  "Marigliano",
  "Marina di Gioiosa Ionica",
  "Marineo",
  "Marino",
  "Marlengo",
  "Marliana",
  "Marmentino",
  "Marmirolo",
  "Marmora",
  "Marnate",
  "Marone",
  "Maropati",
  "Marostica",
  "Marradi",
  "Marrubiu",
  "Marsaglia",
  "Marsala",
  "Marsciano",
  "Marsico Nuovo",
  "Marsicovetere",
  "Marta",
  "Martano",
  "Martellago",
  "Martello",
  "Martignacco",
  "Martignana di Po",
  "Martignano",
  "Martina Franca",
  "Martinengo",
  "Martiniana Po",
  "Martinsicuro",
  "Martirano",
  "Martirano Lombardo",
  "Martis",
  "Martone",
  "Marudo",
  "Maruggio",
  "Marzabotto",
  "Marzano",
  "Marzano Appio",
  "Marzano di Nola",
  "Marzi",
  "Marzio",
  "Masainas",
  "Masate",
  "Mascali",
  "Mascalucia",
  "Maschito",
  "Masciago Primo",
  "Maser",
  "Masera",
  "Maserada sul Piave",
  "Maserà di Padova",
  "Masi",
  "Masi Torello",
  "Masio",
  "Maslianico",
  "Masone",
  "Massa",
  "Massa d'Albe",
  "Massa di Somma",
  "Massa e Cozzile",
  "Massa Fermana",
  "Massa Lombarda",
  "Massa Lubrense",
  "Massa Marittima",
  "Massa Martana",
  "Massafra",
  "Massalengo",
  "Massanzago",
  "Massarosa",
  "Massazza",
  "Massello",
  "Masserano",
  "Massignano",
  "Massimeno",
  "Massimino",
  "Massino Visconti",
  "Massiola",
  "Masullas",
  "Matelica",
  "Matera",
  "Mathi",
  "Matino",
  "Matrice",
  "Mattie",
  "Mattinata",
  "Mazara del Vallo",
  "Mazzano",
  "Mazzano Romano",
  "Mazzarino",
  "Mazzarrone",
  "Mazzarrà Sant'Andrea",
  "Mazzin",
  "Mazzo di Valtellina",
  "Mazzè",
  "Meana di Susa",
  "Meana Sardo",
  "Meda",
  "Mede",
  "Medea",
  "Medesano",
  "Medicina",
  "Mediglia",
  "Medolago",
  "Medole",
  "Medolla",
  "Meduna di Livenza",
  "Meduno",
  "Megliadino San Vitale",
  "Meina",
  "Melara",
  "Melazzo",
  "Meldola",
  "Mele",
  "Melegnano",
  "Melendugno",
  "Meleti",
  "Melfi",
  "Melicucco",
  "Melicuccà",
  "Melilli",
  "Melissa",
  "Melissano",
  "Melito di Napoli",
  "Melito di Porto Salvo",
  "Melito Irpino",
  "Melizzano",
  "Melle",
  "Mello",
  "Melpignano",
  "Meltina",
  "Melzo",
  "Menaggio",
  "Menconico",
  "Mendatica",
  "Mendicino",
  "Menfi",
  "Mentana",
  "Meolo",
  "Merana",
  "Merano",
  "Merate",
  "Mercallo",
  "Mercatello sul Metauro",
  "Mercatino Conca",
  "Mercato San Severino",
  "Mercato Saraceno",
  "Mercenasco",
  "Mercogliano",
  "Mereto di Tomba",
  "Mergo",
  "Mergozzo",
  "Merlara",
  "Merlino",
  "Merone",
  "Merì",
  "Mesagne",
  "Mese",
  "Mesenzana",
  "Mesero",
  "Mesola",
  "Mesoraca",
  "Messina",
  "Mestrino",
  "Meta",
  "Mezzago",
  "Mezzana",
  "Mezzana Bigli",
  "Mezzana Mortigliengo",
  "Mezzana Rabattone",
  "Mezzane di Sotto",
  "Mezzanego",
  "Mezzanino",
  "Mezzano",
  "Mezzenile",
  "Mezzocorona",
  "Mezzojuso",
  "Mezzoldo",
  "Mezzolombardo",
  "Mezzomerico",
  "Miagliano",
  "Miane",
  "Miasino",
  "Miazzina",
  "Micigliano",
  "Miggiano",
  "Miglianico",
  "Miglierina",
  "Miglionico",
  "Mignanego",
  "Mignano Monte Lungo",
  "Milano",
  "Milazzo",
  "Milena",
  "Mileto",
  "Milis",
  "Militello in Val di Catania",
  "Militello Rosmarino",
  "Millesimo",
  "Milo",
  "Milzano",
  "Mineo",
  "Minerbe",
  "Minerbio",
  "Minervino di Lecce",
  "Minervino Murge",
  "Minori",
  "Minturno",
  "Minucciano",
  "Mioglia",
  "Mira",
  "Mirabella Eclano",
  "Mirabella Imbaccari",
  "Mirabello Monferrato",
  "Mirabello Sannitico",
  "Miradolo Terme",
  "Miranda",
  "Mirandola",
  "Mirano",
  "Mirto",
  "Misano Adriatico",
  "Misano di Gera d'Adda",
  "Misilmeri",
  "Misinto",
  "Missaglia",
  "Missanello",
  "Misterbianco",
  "Mistretta",
  "Moasca",
  "Moconesi",
  "Modena",
  "Modica",
  "Modigliana",
  "Modolo",
  "Modugno",
  "Moena",
  "Moggio",
  "Moggio Udinese",
  "Moglia",
  "Mogliano",
  "Mogliano Veneto",
  "Mogorella",
  "Mogoro",
  "Moiano",
  "Moimacco",
  "Moio Alcantara",
  "Moio de' Calvi",
  "Moio della Civitella",
  "Moiola",
  "Mola di Bari",
  "Molare",
  "Molazzana",
  "Molfetta",
  "Molina Aterno",
  "Molinara",
  "Molinella",
  "Molini di Triora",
  "Molino dei Torti",
  "Molise",
  "Moliterno",
  "Mollia",
  "Molochio",
  "Molteno",
  "Moltrasio",
  "Molveno",
  "Mombaldone",
  "Mombarcaro",
  "Mombaroccio",
  "Mombaruzzo",
  "Mombasiglio",
  "Mombello di Torino",
  "Mombello Monferrato",
  "Mombercelli",
  "Momo",
  "Mompantero",
  "Mompeo",
  "Momperone",
  "Monacilioni",
  "Monale",
  "Monasterace",
  "Monastero Bormida",
  "Monastero di Lanzo",
  "Monastero di Vasco",
  "Monasterolo Casotto",
  "Monasterolo del Castello",
  "Monasterolo di Savigliano",
  "Monastier di Treviso",
  "Monastir",
  "Moncalieri",
  "Moncalvo",
  "Moncenisio",
  "Moncestino",
  "Monchiero",
  "Monchio delle Corti",
  "Moncrivello",
  "Moncucco Torinese",
  "Mondaino",
  "Mondavio",
  "Mondolfo",
  "Mondovì",
  "Mondragone",
  "Moneglia",
  "Monesiglio",
  "Monfalcone",
  "Monforte d'Alba",
  "Monforte San Giorgio",
  "Monfumo",
  "Mongardino",
  "Monghidoro",
  "Mongiana",
  "Mongiardino Ligure",
  "Mongiuffi Melia",
  "Mongrando",
  "Mongrassano",
  "Monguelfo-Tesido",
  "Monguzzo",
  "Moniga del Garda",
  "Monleale",
  "Monno",
  "Monopoli",
  "Monreale",
  "Monrupino",
  "Monsampietro Morico",
  "Monsampolo del Tronto",
  "Monsano",
  "Monselice",
  "Monserrato",
  "Monsummano Terme",
  "Montabone",
  "Montacuto",
  "Montafia",
  "Montagano",
  "Montagna",
  "Montagna in Valtellina",
  "Montagnana",
  "Montagnareale",
  "Montaguto",
  "Montaione",
  "Montalbano Elicona",
  "Montalbano Jonico",
  "Montalcino",
  "Montaldeo",
  "Montaldo Bormida",
  "Montaldo di Mondovì",
  "Montaldo Roero",
  "Montaldo Scarampi",
  "Montaldo Torinese",
  "Montale",
  "Montalenghe",
  "Montallegro",
  "Montalto Carpasio",
  "Montalto delle Marche",
  "Montalto di Castro",
  "Montalto Dora",
  "Montalto Pavese",
  "Montalto Uffugo",
  "Montanaro",
  "Montanaso Lombardo",
  "Montanera",
  "Montano Antilia",
  "Montano Lucino",
  "Montappone",
  "Montaquila",
  "Montasola",
  "Montauro",
  "Montazzoli",
  "Monte Argentario",
  "Monte Castello di Vibio",
  "Monte Cavallo",
  "Monte Cerignone",
  "Monte Compatri",
  "Monte Cremasco",
  "Monte di Malo",
  "Monte di Procida",
  "Monte Giberto",
  "Monte Grimano Terme",
  "Monte Isola",
  "Monte Marenzo",
  "Monte Porzio",
  "Monte Porzio Catone",
  "Monte Rinaldo",
  "Monte Roberto",
  "Monte Romano",
  "Monte San Biagio",
  "Monte San Giacomo",
  "Monte San Giovanni Campano",
  "Monte San Giovanni in Sabina",
  "Monte San Giusto",
  "Monte San Martino",
  "Monte San Pietrangeli",
  "Monte San Pietro",
  "Monte San Savino",
  "Monte San Vito",
  "Monte Sant'Angelo",
  "Monte Santa Maria Tiberina",
  "Monte Urano",
  "Monte Vidon Combatte",
  "Monte Vidon Corrado",
  "Montebello della Battaglia",
  "Montebello di Bertona",
  "Montebello Jonico",
  "Montebello sul Sangro",
  "Montebello Vicentino",
  "Montebelluna",
  "Montebruno",
  "Montebuono",
  "Montecalvo in Foglia",
  "Montecalvo Irpino",
  "Montecalvo Versiggia",
  "Montecarlo",
  "Montecarotto",
  "Montecassiano",
  "Montecastello",
  "Montecastrilli",
  "Montecatini Val di Cecina",
  "Montecatini-Terme",
  "Montecchia di Crosara",
  "Montecchio",
  "Montecchio Emilia",
  "Montecchio Maggiore",
  "Montecchio Precalcino",
  "Montechiaro d'Acqui",
  "Montechiaro d'Asti",
  "Montechiarugolo",
  "Monteciccardo",
  "Montecilfone",
  "Montecopiolo",
  "Montecorice",
  "Montecorvino Pugliano",
  "Montecorvino Rovella",
  "Montecosaro",
  "Montecrestese",
  "Montecreto",
  "Montedinove",
  "Montedoro",
  "Montefalcione",
  "Montefalco",
  "Montefalcone Appennino",
  "Montefalcone di Val Fortore",
  "Montefalcone nel Sannio",
  "Montefano",
  "Montefelcino",
  "Monteferrante",
  "Montefiascone",
  "Montefino",
  "Montefiore Conca",
  "Montefiore dell'Aso",
  "Montefiorino",
  "Monteflavio",
  "Monteforte Cilento",
  "Monteforte d'Alpone",
  "Monteforte Irpino",
  "Montefortino",
  "Montefranco",
  "Montefredane",
  "Montefusco",
  "Montegabbione",
  "Montegalda",
  "Montegaldella",
  "Montegallo",
  "Montegioco",
  "Montegiordano",
  "Montegiorgio",
  "Montegranaro",
  "Montegridolfo",
  "Montegrino Valtravaglia",
  "Montegrosso d'Asti",
  "Montegrosso Pian Latte",
  "Montegrotto Terme",
  "Monteiasi",
  "Montelabbate",
  "Montelanico",
  "Montelapiano",
  "Monteleone d'Orvieto",
  "Monteleone di Fermo",
  "Monteleone di Puglia",
  "Monteleone di Spoleto",
  "Monteleone Rocca Doria",
  "Monteleone Sabino",
  "Montelepre",
  "Montelibretti",
  "Montella",
  "Montello",
  "Montelongo",
  "Montelparo",
  "Montelupo Albese",
  "Montelupo Fiorentino",
  "Montelupone",
  "Montemaggiore Belsito",
  "Montemagno",
  "Montemale di Cuneo",
  "Montemarano",
  "Montemarciano",
  "Montemarzino",
  "Montemesola",
  "Montemezzo",
  "Montemignaio",
  "Montemiletto",
  "Montemilone",
  "Montemitro",
  "Montemonaco",
  "Montemurlo",
  "Montemurro",
  "Montenars",
  "Montenero di Bisaccia",
  "Montenero Sabino",
  "Montenero Val Cocchiara",
  "Montenerodomo",
  "Monteodorisio",
  "Montepaone",
  "Monteparano",
  "Monteprandone",
  "Montepulciano",
  "Monterchi",
  "Montereale",
  "Montereale Valcellina",
  "Monterenzio",
  "Monteriggioni",
  "Monteroduni",
  "Monteroni d'Arbia",
  "Monteroni di Lecce",
  "Monterosi",
  "Monterosso al Mare",
  "Monterosso Almo",
  "Monterosso Calabro",
  "Monterosso Grana",
  "Monterotondo",
  "Monterotondo Marittimo",
  "Monterubbiano",
  "Montesano Salentino",
  "Montesano sulla Marcellana",
  "Montesarchio",
  "Montescaglioso",
  "Montescano",
  "Montescheno",
  "Montescudaio",
  "Montescudo-Monte Colombo",
  "Montese",
  "Montesegale",
  "Montesilvano",
  "Montespertoli",
  "Monteu da Po",
  "Monteu Roero",
  "Montevago",
  "Montevarchi",
  "Montevecchia",
  "Monteverde",
  "Monteverdi Marittimo",
  "Monteviale",
  "Montezemolo",
  "Monti",
  "Montiano",
  "Monticelli Brusati",
  "Monticelli d'Ongina",
  "Monticelli Pavese",
  "Monticello Brianza",
  "Monticello Conte Otto",
  "Monticello d'Alba",
  "Montichiari",
  "Monticiano",
  "Montieri",
  "Montiglio Monferrato",
  "Montignoso",
  "Montirone",
  "Montjovet",
  "Montodine",
  "Montoggio",
  "Montone",
  "Montopoli di Sabina",
  "Montopoli in Val d'Arno",
  "Montorfano",
  "Montorio al Vomano",
  "Montorio nei Frentani",
  "Montorio Romano",
  "Montoro",
  "Montorso Vicentino",
  "Montottone",
  "Montresta",
  "Montà",
  "Montù Beccaria",
  "Monvalle",
  "Monza",
  "Monzambano",
  "Monzuno",
  "Morano Calabro",
  "Morano sul Po",
  "Moransengo",
  "Moraro",
  "Morazzone",
  "Morbegno",
  "Morbello",
  "Morciano di Leuca",
  "Morciano di Romagna",
  "Morcone",
  "Mordano",
  "Morengo",
  "Mores",
  "Moresco",
  "Moretta",
  "Morfasso",
  "Morgano",
  "Morgex",
  "Morgongiori",
  "Mori",
  "Moriago della Battaglia",
  "Moricone",
  "Morigerati",
  "Morimondo",
  "Morino",
  "Moriondo Torinese",
  "Morlupo",
  "Mormanno",
  "Mornago",
  "Mornese",
  "Mornico al Serio",
  "Mornico Losana",
  "Morolo",
  "Morozzo",
  "Morra De Sanctis",
  "Morro d'Alba",
  "Morro d'Oro",
  "Morro Reatino",
  "Morrone del Sannio",
  "Morrovalle",
  "Morsano al Tagliamento",
  "Morsasco",
  "Mortara",
  "Mortegliano",
  "Morterone",
  "Moruzzo",
  "Moscazzano",
  "Moschiano",
  "Mosciano Sant'Angelo",
  "Moscufo",
  "Moso in Passiria",
  "Mossa",
  "Motta Baluffi",
  "Motta Camastra",
  "Motta d'Affermo",
  "Motta de' Conti",
  "Motta di Livenza",
  "Motta Montecorvino",
  "Motta San Giovanni",
  "Motta Sant'Anastasia",
  "Motta Santa Lucia",
  "Motta Visconti",
  "Mottafollone",
  "Mottalciata",
  "Motteggiana",
  "Mottola",
  "Mozzagrogna",
  "Mozzanica",
  "Mozzate",
  "Mozzecane",
  "Mozzo",
  "Muccia",
  "Muggia",
  "Muggiò",
  "Mugnano del Cardinale",
  "Mugnano di Napoli",
  "Mulazzano",
  "Mulazzo",
  "Mura",
  "Muravera",
  "Murazzano",
  "Murello",
  "Murialdo",
  "Murisengo",
  "Murlo",
  "Muro Leccese",
  "Muro Lucano",
  "Muros",
  "Muscoline",
  "Musei",
  "Musile di Piave",
  "Musso",
  "Mussolente",
  "Mussomeli",
  "Muzzana del Turgnano",
  "Muzzano",
  "Nago-Torbole",
  "Nalles",
  "Nanto",
  "Napoli",
  "Narbolia",
  "Narcao",
  "Nardodipace",
  "Nardò",
  "Narni",
  "Naro",
  "Narzole",
  "Nasino",
  "Naso",
  "Naturno",
  "Nave",
  "Navelli",
  "Naz-Sciaves",
  "Nazzano",
  "Ne",
  "Nebbiuno",
  "Negrar di Valpolicella",
  "Neirone",
  "Neive",
  "Nembro",
  "Nemi",
  "Nemoli",
  "Neoneli",
  "Nepi",
  "Nereto",
  "Nerola",
  "Nervesa della Battaglia",
  "Nerviano",
  "Nespolo",
  "Nesso",
  "Netro",
  "Nettuno",
  "Neviano",
  "Neviano degli Arduini",
  "Neviglie",
  "Niardo",
  "Nibbiola",
  "Nibionno",
  "Nichelino",
  "Nicolosi",
  "Nicorvo",
  "Nicosia",
  "Nicotera",
  "Niella Belbo",
  "Niella Tanaro",
  "Nimis",
  "Niscemi",
  "Nissoria",
  "Nizza di Sicilia",
  "Nizza Monferrato",
  "Noale",
  "Noasca",
  "Nocara",
  "Nocciano",
  "Nocera Inferiore",
  "Nocera Superiore",
  "Nocera Terinese",
  "Nocera Umbra",
  "Noceto",
  "Noci",
  "Nociglia",
  "Noepoli",
  "Nogara",
  "Nogaredo",
  "Nogarole Rocca",
  "Nogarole Vicentino",
  "Noicattaro",
  "Nola",
  "Nole",
  "Noli",
  "Nomaglio",
  "Nomi",
  "Nonantola",
  "None",
  "Nonio",
  "Noragugume",
  "Norbello",
  "Norcia",
  "Norma",
  "Nosate",
  "Notaresco",
  "Noto",
  "Nova Levante",
  "Nova Milanese",
  "Nova Ponente",
  "Nova Siri",
  "Novafeltria",
  "Novaledo",
  "Novalesa",
  "Novara",
  "Novara di Sicilia",
  "Novate Mezzola",
  "Novate Milanese",
  "Nove",
  "Novedrate",
  "Novella",
  "Novellara",
  "Novello",
  "Noventa di Piave",
  "Noventa Padovana",
  "Noventa Vicentina",
  "Novi di Modena",
  "Novi Ligure",
  "Novi Velia",
  "Noviglio",
  "Novoli",
  "Nucetto",
  "Nughedu San Nicolò",
  "Nughedu Santa Vittoria",
  "Nule",
  "Nulvi",
  "Numana",
  "Nuoro",
  "Nurachi",
  "Nuragus",
  "Nurallao",
  "Nuraminis",
  "Nureci",
  "Nurri",
  "Nus",
  "Nusco",
  "Nuvolento",
  "Nuvolera",
  "Nuxis",
  "Occhieppo Inferiore",
  "Occhieppo Superiore",
  "Occhiobello",
  "Occimiano",
  "Ocre",
  "Odalengo Grande",
  "Odalengo Piccolo",
  "Oderzo",
  "Odolo",
  "Ofena",
  "Offagna",
  "Offanengo",
  "Offida",
  "Offlaga",
  "Oggebbio",
  "Oggiona con Santo Stefano",
  "Oggiono",
  "Oglianico",
  "Ogliastro Cilento",
  "Olbia",
  "Olcenengo",
  "Oldenico",
  "Oleggio",
  "Oleggio Castello",
  "Olevano di Lomellina",
  "Olevano Romano",
  "Olevano sul Tusciano",
  "Olgiate Comasco",
  "Olgiate Molgora",
  "Olgiate Olona",
  "Olginate",
  "Oliena",
  "Oliva Gessi",
  "Olivadi",
  "Oliveri",
  "Oliveto Citra",
  "Oliveto Lario",
  "Oliveto Lucano",
  "Olivetta San Michele",
  "Olivola",
  "Ollastra",
  "Ollolai",
  "Ollomont",
  "Olmedo",
  "Olmeneta",
  "Olmo al Brembo",
  "Olmo Gentile",
  "Oltre il Colle",
  "Oltressenda Alta",
  "Oltrona di San Mamette",
  "Olzai",
  "Ome",
  "Omegna",
  "Omignano",
  "Onano",
  "Onanì",
  "Oncino",
  "Oneta",
  "Onifai",
  "Oniferi",
  "Ono San Pietro",
  "Onore",
  "Onzo",
  "Opera",
  "Opi",
  "Oppeano",
  "Oppido Lucano",
  "Oppido Mamertina",
  "Ora",
  "Orani",
  "Oratino",
  "Orbassano",
  "Orbetello",
  "Orciano Pisano",
  "Orco Feglino",
  "Ordona",
  "Orero",
  "Orgiano",
  "Orgosolo",
  "Oria",
  "Oricola",
  "Origgio",
  "Orino",
  "Orio al Serio",
  "Orio Canavese",
  "Orio Litta",
  "Oriolo",
  "Oriolo Romano",
  "Oristano",
  "Ormea",
  "Ormelle",
  "Ornago",
  "Ornavasso",
  "Ornica",
  "Orosei",
  "Orotelli",
  "Orria",
  "Orroli",
  "Orsago",
  "Orsara Bormida",
  "Orsara di Puglia",
  "Orsenigo",
  "Orsogna",
  "Orsomarso",
  "Orta di Atella",
  "Orta Nova",
  "Orta San Giulio",
  "Ortacesus",
  "Orte",
  "Ortelle",
  "Ortezzano",
  "Ortignano Raggiolo",
  "Ortisei",
  "Ortona",
  "Ortona dei Marsi",
  "Ortovero",
  "Ortucchio",
  "Ortueri",
  "Orune",
  "Orvieto",
  "Orvinio",
  "Orzinuovi",
  "Orzivecchi",
  "Osasco",
  "Osasio",
  "Oschiri",
  "Osidda",
  "Osiglia",
  "Osilo",
  "Osimo",
  "Osini",
  "Osio Sopra",
  "Osio Sotto",
  "Osnago",
  "Osoppo",
  "Ospedaletti",
  "Ospedaletto",
  "Ospedaletto d'Alpinolo",
  "Ospedaletto Euganeo",
  "Ospedaletto Lodigiano",
  "Ospitale di Cadore",
  "Ospitaletto",
  "Ossago Lodigiano",
  "Ossana",
  "Ossi",
  "Ossimo",
  "Ossona",
  "Ostana",
  "Ostellato",
  "Ostiano",
  "Ostiglia",
  "Ostra",
  "Ostra Vetere",
  "Ostuni",
  "Otranto",
  "Otricoli",
  "Ottana",
  "Ottati",
  "Ottaviano",
  "Ottiglio",
  "Ottobiano",
  "Ottone",
  "Oulx",
  "Ovada",
  "Ovaro",
  "Oviglio",
  "Ovindoli",
  "Ovodda",
  "Oyace",
  "Ozegna",
  "Ozieri",
  "Ozzano dell'Emilia",
  "Ozzano Monferrato",
  "Ozzero",
  "Pabillonis",
  "Pace del Mela",
  "Paceco",
  "Pacentro",
  "Pachino",
  "Paciano",
  "Padenghe sul Garda",
  "Paderna",
  "Paderno d'Adda",
  "Paderno Dugnano",
  "Paderno Franciacorta",
  "Paderno Ponchielli",
  "Padova",
  "Padria",
  "Padru",
  "Padula",
  "Paduli",
  "Paesana",
  "Paese",
  "Pagani",
  "Paganico Sabino",
  "Pagazzano",
  "Pagliara",
  "Paglieta",
  "Pagnacco",
  "Pagno",
  "Pagnona",
  "Pago del Vallo di Lauro",
  "Pago Veiano",
  "Paisco Loveno",
  "Paitone",
  "Paladina",
  "Palagano",
  "Palagianello",
  "Palagiano",
  "Palagonia",
  "Palaia",
  "Palanzano",
  "Palata",
  "Palau",
  "Palazzago",
  "Palazzo Adriano",
  "Palazzo Canavese",
  "Palazzo Pignano",
  "Palazzo San Gervasio",
  "Palazzolo Acreide",
  "Palazzolo dello Stella",
  "Palazzolo sull'Oglio",
  "Palazzolo Vercellese",
  "Palazzuolo sul Senio",
  "Palena",
  "Palermiti",
  "Palermo",
  "Palestrina",
  "Palestro",
  "Paliano",
  "Palizzi",
  "Pallagorio",
  "Pallanzeno",
  "Pallare",
  "Palma Campania",
  "Palma di Montechiaro",
  "Palmanova",
  "Palmariggi",
  "Palmas Arborea",
  "Palmi",
  "Palmiano",
  "Palmoli",
  "Palo del Colle",
  "Palombara Sabina",
  "Palombaro",
  "Palomonte",
  "Palosco",
  "Paludi",
  "Paluzza",
  "Palù",
  "Palù del Fersina",
  "Pamparato",
  "Pancalieri",
  "Pancarana",
  "Panchià",
  "Pandino",
  "Panettieri",
  "Panicale",
  "Pannarano",
  "Panni",
  "Pantelleria",
  "Pantigliate",
  "Paola",
  "Paolisi",
  "Papasidero",
  "Papozze",
  "Parabiago",
  "Parabita",
  "Paratico",
  "Parcines",
  "Parella",
  "Parenti",
  "Parete",
  "Pareto",
  "Parghelia",
  "Parlasco",
  "Parma",
  "Parodi Ligure",
  "Paroldo",
  "Parolise",
  "Parona",
  "Parrano",
  "Parre",
  "Partanna",
  "Partinico",
  "Paruzzaro",
  "Parzanica",
  "Pasian di Prato",
  "Pasiano di Pordenone",
  "Paspardo",
  "Passerano Marmorito",
  "Passignano sul Trasimeno",
  "Passirano",
  "Pastena",
  "Pastorano",
  "Pastrengo",
  "Pasturana",
  "Pasturo",
  "Paterno",
  "Paterno Calabro",
  "Paternopoli",
  "Paternò",
  "Patrica",
  "Pattada",
  "Patti",
  "Patù",
  "Pau",
  "Paularo",
  "Pauli Arbarei",
  "Paulilatino",
  "Paullo",
  "Paupisi",
  "Pavarolo",
  "Pavia",
  "Pavia di Udine",
  "Pavone Canavese",
  "Pavone del Mella",
  "Pavullo nel Frignano",
  "Pazzano",
  "Peccioli",
  "Pecetto di Valenza",
  "Pecetto Torinese",
  "Pedara",
  "Pedaso",
  "Pedavena",
  "Pedemonte",
  "Pederobba",
  "Pedesina",
  "Pedivigliano",
  "Pedrengo",
  "Peglio (CO)",
  "Peglio (PU)",
  "Pegognaga",
  "Peia",
  "Peio",
  "Pelago",
  "Pella",
  "Pellegrino Parmense",
  "Pellezzano",
  "Pellizzano",
  "Pelugo",
  "Penango",
  "Penna in Teverina",
  "Penna San Giovanni",
  "Penna Sant'Andrea",
  "Pennabilli",
  "Pennadomo",
  "Pennapiedimonte",
  "Penne",
  "Pentone",
  "Perano",
  "Perarolo di Cadore",
  "Perca",
  "Percile",
  "Perdasdefogu",
  "Perdaxius",
  "Perdifumo",
  "Pereto",
  "Perfugas",
  "Pergine Valsugana",
  "Pergola",
  "Perinaldo",
  "Perito",
  "Perledo",
  "Perletto",
  "Perlo",
  "Perloz",
  "Pernumia",
  "Pero",
  "Perosa Argentina",
  "Perosa Canavese",
  "Perrero",
  "Persico Dosimo",
  "Pertengo",
  "Pertica Alta",
  "Pertica Bassa",
  "Pertosa",
  "Pertusio",
  "Perugia",
  "Pesaro",
  "Pescaglia",
  "Pescantina",
  "Pescara",
  "Pescarolo ed Uniti",
  "Pescasseroli",
  "Pescate",
  "Pesche",
  "Peschici",
  "Peschiera Borromeo",
  "Peschiera del Garda",
  "Pescia",
  "Pescina",
  "Pesco Sannita",
  "Pescocostanzo",
  "Pescolanciano",
  "Pescopagano",
  "Pescopennataro",
  "Pescorocchiano",
  "Pescosansonesco",
  "Pescosolido",
  "Pessano con Bornago",
  "Pessina Cremonese",
  "Pessinetto",
  "Petacciato",
  "Petilia Policastro",
  "Petina",
  "Petralia Soprana",
  "Petralia Sottana",
  "Petrella Salto",
  "Petrella Tifernina",
  "Petriano",
  "Petriolo",
  "Petritoli",
  "Petrizzi",
  "Petronà",
  "Petrosino",
  "Petruro Irpino",
  "Pettenasco",
  "Pettinengo",
  "Pettineo",
  "Pettoranello del Molise",
  "Pettorano sul Gizio",
  "Pettorazza Grimani",
  "Peveragno",
  "Pezzana",
  "Pezzaze",
  "Pezzolo Valle Uzzone",
  "Piacenza",
  "Piacenza d'Adige",
  "Piadena Drizzona",
  "Piaggine",
  "Pian Camuno",
  "Piana Crixia",
  "Piana degli Albanesi",
  "Piana di Monte Verna",
  "Piancastagnaio",
  "Piancogno",
  "Piandimeleto",
  "Piane Crati",
  "Pianella",
  "Pianello del Lario",
  "Pianello Val Tidone",
  "Pianengo",
  "Pianezza",
  "Pianezze",
  "Pianfei",
  "Pianico",
  "Pianiga",
  "Piano di Sorrento",
  "Pianopoli",
  "Pianoro",
  "Piansano",
  "Piantedo",
  "Piario",
  "Piasco",
  "Piateda",
  "Piatto",
  "Piazza al Serchio",
  "Piazza Armerina",
  "Piazza Brembana",
  "Piazzatorre",
  "Piazzola sul Brenta",
  "Piazzolo",
  "Picciano",
  "Picerno",
  "Picinisco",
  "Pico",
  "Piea",
  "Piedicavallo",
  "Piedimonte Etneo",
  "Piedimonte Matese",
  "Piedimonte San Germano",
  "Piedimulera",
  "Piegaro",
  "Pienza",
  "Pieranica",
  "Pietra de' Giorgi",
  "Pietra Ligure",
  "Pietra Marazzi",
  "Pietrabbondante",
  "Pietrabruna",
  "Pietracamela",
  "Pietracatella",
  "Pietracupa",
  "Pietradefusi",
  "Pietraferrazzana",
  "Pietrafitta",
  "Pietragalla",
  "Pietralunga",
  "Pietramelara",
  "Pietramontecorvino",
  "Pietranico",
  "Pietrapaola",
  "Pietrapertosa",
  "Pietraperzia",
  "Pietraporzio",
  "Pietraroja",
  "Pietrarubbia",
  "Pietrasanta",
  "Pietrastornina",
  "Pietravairano",
  "Pietrelcina",
  "Pieve a Nievole",
  "Pieve Albignola",
  "Pieve d'Olmi",
  "Pieve del Cairo",
  "Pieve del Grappa",
  "Pieve di Bono-Prezzo",
  "Pieve di Cadore",
  "Pieve di Cento",
  "Pieve di Soligo",
  "Pieve di Teco",
  "Pieve Emanuele",
  "Pieve Fissiraga",
  "Pieve Fosciana",
  "Pieve Ligure",
  "Pieve Porto Morone",
  "Pieve San Giacomo",
  "Pieve Santo Stefano",
  "Pieve Tesino",
  "Pieve Torina",
  "Pieve Vergonte",
  "Pievepelago",
  "Piglio",
  "Pigna",
  "Pignataro Interamna",
  "Pignataro Maggiore",
  "Pignola",
  "Pignone",
  "Pigra",
  "Pila",
  "Pimentel",
  "Pimonte",
  "Pinarolo Po",
  "Pinasca",
  "Pincara",
  "Pinerolo",
  "Pineto",
  "Pino d'Asti",
  "Pino Torinese",
  "Pinzano al Tagliamento",
  "Pinzolo",
  "Piobbico",
  "Piobesi d'Alba",
  "Piobesi Torinese",
  "Piode",
  "Pioltello",
  "Piombino",
  "Piombino Dese",
  "Pioraco",
  "Piossasco",
  "Piove di Sacco",
  "Piovene Rocchette",
  "Piovà Massaia",
  "Piozzano",
  "Piozzo",
  "Piraino",
  "Pisa",
  "Pisano",
  "Piscina",
  "Piscinas",
  "Pisciotta",
  "Pisogne",
  "Pisoniano",
  "Pisticci",
  "Pistoia",
  "Pitigliano",
  "Piubega",
  "Piuro",
  "Piverone",
  "Pizzale",
  "Pizzighettone",
  "Pizzo",
  "Pizzoferrato",
  "Pizzoli",
  "Pizzone",
  "Pizzoni",
  "Placanica",
  "Plataci",
  "Platania",
  "Platì",
  "Plaus",
  "Plesio",
  "Ploaghe",
  "Plodio",
  "Pocapaglia",
  "Pocenia",
  "Podenzana",
  "Podenzano",
  "Pofi",
  "Poggiardo",
  "Poggibonsi",
  "Poggio a Caiano",
  "Poggio Bustone",
  "Poggio Catino",
  "Poggio Imperiale",
  "Poggio Mirteto",
  "Poggio Moiano",
  "Poggio Nativo",
  "Poggio Picenze",
  "Poggio Renatico",
  "Poggio Rusco",
  "Poggio San Lorenzo",
  "Poggio San Marcello",
  "Poggio San Vicino",
  "Poggio Sannita",
  "Poggio Torriana",
  "Poggiodomo",
  "Poggiofiorito",
  "Poggiomarino",
  "Poggioreale",
  "Poggiorsini",
  "Poggiridenti",
  "Pogliano Milanese",
  "Pognana Lario",
  "Pognano",
  "Pogno",
  "Poirino",
  "Pojana Maggiore",
  "Polaveno",
  "Polcenigo",
  "Polesella",
  "Polesine Zibello",
  "Poli",
  "Polia",
  "Policoro",
  "Polignano a Mare",
  "Polinago",
  "Polino",
  "Polistena",
  "Polizzi Generosa",
  "Polla",
  "Pollein",
  "Pollena Trocchia",
  "Pollenza",
  "Pollica",
  "Pollina",
  "Pollone",
  "Pollutri",
  "Polonghera",
  "Polpenazze del Garda",
  "Polverara",
  "Polverigi",
  "Pomarance",
  "Pomaretto",
  "Pomarico",
  "Pomaro Monferrato",
  "Pomarolo",
  "Pombia",
  "Pomezia",
  "Pomigliano d'Arco",
  "Pompei",
  "Pompeiana",
  "Pompiano",
  "Pomponesco",
  "Pompu",
  "Poncarale",
  "Ponderano",
  "Ponna",
  "Ponsacco",
  "Ponso",
  "Pont-Canavese",
  "Pont-Saint-Martin",
  "Pontassieve",
  "Pontboset",
  "Ponte",
  "Ponte Buggianese",
  "Ponte dell'Olio",
  "Ponte di Legno",
  "Ponte di Piave",
  "Ponte Gardena",
  "Ponte in Valtellina",
  "Ponte Lambro",
  "Ponte nelle Alpi",
  "Ponte Nizza",
  "Ponte Nossa",
  "Ponte San Nicolò",
  "Ponte San Pietro",
  "Pontebba",
  "Pontecagnano Faiano",
  "Pontecchio Polesine",
  "Pontechianale",
  "Pontecorvo",
  "Pontecurone",
  "Pontedassio",
  "Pontedera",
  "Pontelandolfo",
  "Pontelatone",
  "Pontelongo",
  "Pontenure",
  "Ponteranica",
  "Pontestura",
  "Pontevico",
  "Pontey",
  "Ponti",
  "Ponti sul Mincio",
  "Pontida",
  "Pontinia",
  "Pontinvrea",
  "Pontirolo Nuovo",
  "Pontoglio",
  "Pontremoli",
  "Ponza",
  "Ponzano di Fermo",
  "Ponzano Monferrato",
  "Ponzano Romano",
  "Ponzano Veneto",
  "Ponzone",
  "Popoli",
  "Poppi",
  "Porano",
  "Porcari",
  "Porcia",
  "Pordenone",
  "Porlezza",
  "Pornassio",
  "Porpetto",
  "Portacomaro",
  "Portalbera",
  "Porte",
  "Porte di Rendena",
  "Portici",
  "Portico di Caserta",
  "Portico e San Benedetto",
  "Portigliola",
  "Porto Azzurro",
  "Porto Ceresio",
  "Porto Cesareo",
  "Porto Empedocle",
  "Porto Mantovano",
  "Porto Recanati",
  "Porto San Giorgio",
  "Porto Sant'Elpidio",
  "Porto Tolle",
  "Porto Torres",
  "Porto Valtravaglia",
  "Porto Viro",
  "Portobuffolè",
  "Portocannone",
  "Portoferraio",
  "Portofino",
  "Portogruaro",
  "Portomaggiore",
  "Portopalo di Capo Passero",
  "Portoscuso",
  "Portovenere",
  "Portula",
  "Posada",
  "Posina",
  "Positano",
  "Possagno",
  "Posta",
  "Posta Fibreno",
  "Postal",
  "Postalesio",
  "Postiglione",
  "Postua",
  "Potenza",
  "Potenza Picena",
  "Pove del Grappa",
  "Povegliano",
  "Povegliano Veronese",
  "Poviglio",
  "Povoletto",
  "Pozzaglia Sabina",
  "Pozzaglio ed Uniti",
  "Pozzallo",
  "Pozzilli",
  "Pozzo d'Adda",
  "Pozzol Groppo",
  "Pozzolengo",
  "Pozzoleone",
  "Pozzolo Formigaro",
  "Pozzomaggiore",
  "Pozzonovo",
  "Pozzuoli",
  "Pozzuolo del Friuli",
  "Pozzuolo Martesana",
  "Pradalunga",
  "Pradamano",
  "Pradleves",
  "Pragelato",
  "Praia a Mare",
  "Praiano",
  "Pralboino",
  "Prali",
  "Pralormo",
  "Pralungo",
  "Pramaggiore",
  "Pramollo",
  "Prarolo",
  "Prarostino",
  "Prasco",
  "Prascorsano",
  "Prata Camportaccio",
  "Prata d'Ansidonia",
  "Prata di Pordenone",
  "Prata di Principato Ultra",
  "Prata Sannita",
  "Pratella",
  "Pratiglione",
  "Prato",
  "Prato allo Stelvio",
  "Prato Carnico",
  "Prato Sesia",
  "Pratola Peligna",
  "Pratola Serra",
  "Pratovecchio Stia",
  "Pravisdomini",
  "Pray",
  "Prazzo",
  "Precenicco",
  "Preci",
  "Predaia",
  "Predappio",
  "Predazzo",
  "Predoi",
  "Predore",
  "Predosa",
  "Preganziol",
  "Pregnana Milanese",
  "Prelà",
  "Premana",
  "Premariacco",
  "Premeno",
  "Premia",
  "Premilcuore",
  "Premolo",
  "Premosello-Chiovenda",
  "Preone",
  "Prepotto",
  "Preseglie",
  "Presenzano",
  "Presezzo",
  "Presicce-Acquarica",
  "Pressana",
  "Pretoro",
  "Prevalle",
  "Prezza",
  "Priero",
  "Prignano Cilento",
  "Prignano sulla Secchia",
  "Primaluna",
  "Primiero San Martino di Castrozza",
  "Priocca",
  "Priola",
  "Priolo Gargallo",
  "Priverno",
  "Prizzi",
  "Proceno",
  "Procida",
  "Propata",
  "Proserpio",
  "Prossedi",
  "Provaglio d'Iseo",
  "Provaglio Val Sabbia",
  "Proves",
  "Provvidenti",
  "Prunetto",
  "Pré-Saint-Didier",
  "Puegnago del Garda",
  "Puglianello",
  "Pula",
  "Pulfero",
  "Pulsano",
  "Pumenengo",
  "Pusiano",
  "Putifigari",
  "Putignano",
  "Quadrelle",
  "Quadri",
  "Quagliuzzo",
  "Qualiano",
  "Quaranti",
  "Quaregna Cerreto",
  "Quargnento",
  "Quarna Sopra",
  "Quarna Sotto",
  "Quarona",
  "Quarrata",
  "Quart",
  "Quarto",
  "Quarto d'Altino",
  "Quartu Sant'Elena",
  "Quartucciu",
  "Quassolo",
  "Quattordio",
  "Quattro Castella",
  "Quero Vas",
  "Quiliano",
  "Quincinetto",
  "Quindici",
  "Quingentole",
  "Quintano",
  "Quinto di Treviso",
  "Quinto Vercellese",
  "Quinto Vicentino",
  "Quinzano d'Oglio",
  "Quistello",
  "Rabbi",
  "Racale",
  "Racalmuto",
  "Racconigi",
  "Raccuja",
  "Racines",
  "Radda in Chianti",
  "Raddusa",
  "Radicofani",
  "Radicondoli",
  "Raffadali",
  "Ragalna",
  "Ragogna",
  "Ragusa",
  "Raiano",
  "Ramacca",
  "Rancio Valcuvia",
  "Ranco",
  "Randazzo",
  "Ranica",
  "Ranzanico",
  "Ranzo",
  "Rapagnano",
  "Rapallo",
  "Rapino",
  "Rapolano Terme",
  "Rapolla",
  "Rapone",
  "Rassa",
  "Rasun-Anterselva",
  "Rasura",
  "Ravanusa",
  "Ravarino",
  "Ravascletto",
  "Ravello",
  "Ravenna",
  "Raveo",
  "Raviscanina",
  "Re",
  "Rea",
  "Realmonte",
  "Reana del Rojale",
  "Reano",
  "Recale",
  "Recanati",
  "Recco",
  "Recetto",
  "Recoaro Terme",
  "Redavalle",
  "Redondesco",
  "Refrancore",
  "Refrontolo",
  "Regalbuto",
  "Reggello",
  "Reggio di Calabria",
  "Reggio nell'Emilia",
  "Reggiolo",
  "Reino",
  "Reitano",
  "Remanzacco",
  "Remedello",
  "Renate",
  "Rende",
  "Renon",
  "Resana",
  "Rescaldina",
  "Resia",
  "Resiutta",
  "Resuttano",
  "Retorbido",
  "Revello",
  "Revigliasco d'Asti",
  "Revine Lago",
  "Rezzago",
  "Rezzato",
  "Rezzo",
  "Rezzoaglio",
  "Rho",
  "Rhêmes-Notre-Dame",
  "Rhêmes-Saint-Georges",
  "Riace",
  "Rialto",
  "Riano",
  "Riardo",
  "Ribera",
  "Ribordone",
  "Ricadi",
  "Ricaldone",
  "Riccia",
  "Riccione",
  "Riccò del Golfo di Spezia",
  "Ricengo",
  "Ricigliano",
  "Riese Pio X",
  "Riesi",
  "Rieti",
  "Rifiano",
  "Rifreddo",
  "Rignano Flaminio",
  "Rignano Garganico",
  "Rignano sull'Arno",
  "Rigolato",
  "Rimella",
  "Rimini",
  "Rio",
  "Rio di Pusteria",
  "Rio Saliceto",
  "Riofreddo",
  "Riola Sardo",
  "Riolo Terme",
  "Riolunato",
  "Riomaggiore",
  "Rionero in Vulture",
  "Rionero Sannitico",
  "Ripa Teatina",
  "Ripabottoni",
  "Ripacandida",
  "Ripalimosani",
  "Ripalta Arpina",
  "Ripalta Cremasca",
  "Ripalta Guerina",
  "Riparbella",
  "Ripatransone",
  "Ripe San Ginesio",
  "Ripi",
  "Riposto",
  "Rittana",
  "Riva del Garda",
  "Riva del Po",
  "Riva di Solto",
  "Riva Ligure",
  "Riva presso Chieri",
  "Rivalba",
  "Rivalta Bormida",
  "Rivalta di Torino",
  "Rivamonte Agordino",
  "Rivanazzano Terme",
  "Rivara",
  "Rivarolo Canavese",
  "Rivarolo del Re ed Uniti",
  "Rivarolo Mantovano",
  "Rivarone",
  "Rivarossa",
  "Rive",
  "Rive d'Arcano",
  "Rivello",
  "Rivergaro",
  "Rivignano Teor",
  "Rivisondoli",
  "Rivodutri",
  "Rivoli",
  "Rivoli Veronese",
  "Rivolta d'Adda",
  "Rizziconi",
  "Roana",
  "Roaschia",
  "Roascio",
  "Roasio",
  "Roatto",
  "Robassomero",
  "Robbiate",
  "Robbio",
  "Robecchetto con Induno",
  "Robecco d'Oglio",
  "Robecco Pavese",
  "Robecco sul Naviglio",
  "Robella",
  "Robilante",
  "Roburent",
  "Rocca Canavese",
  "Rocca Canterano",
  "Rocca Cigliè",
  "Rocca d'Arazzo",
  "Rocca d'Arce",
  "Rocca d'Evandro",
  "Rocca de' Baldi",
  "Rocca de' Giorgi",
  "Rocca di Botte",
  "Rocca di Cambio",
  "Rocca di Cave",
  "Rocca di Mezzo",
  "Rocca di Neto",
  "Rocca di Papa",
  "Rocca Grimalda",
  "Rocca Imperiale",
  "Rocca Massima",
  "Rocca Pia",
  "Rocca Pietore",
  "Rocca Priora",
  "Rocca San Casciano",
  "Rocca San Felice",
  "Rocca San Giovanni",
  "Rocca Santa Maria",
  "Rocca Santo Stefano",
  "Rocca Sinibalda",
  "Rocca Susella",
  "Roccabascerana",
  "Roccabernarda",
  "Roccabianca",
  "Roccabruna",
  "Roccacasale",
  "Roccadaspide",
  "Roccafiorita",
  "Roccafluvione",
  "Roccaforte del Greco",
  "Roccaforte Ligure",
  "Roccaforte Mondovì",
  "Roccaforzata",
  "Roccafranca",
  "Roccagiovine",
  "Roccagloriosa",
  "Roccagorga",
  "Roccalbegna",
  "Roccalumera",
  "Roccamandolfi",
  "Roccamena",
  "Roccamonfina",
  "Roccamontepiano",
  "Roccamorice",
  "Roccanova",
  "Roccantica",
  "Roccapalumba",
  "Roccapiemonte",
  "Roccarainola",
  "Roccaraso",
  "Roccaromana",
  "Roccascalegna",
  "Roccasecca",
  "Roccasecca dei Volsci",
  "Roccasicura",
  "Roccasparvera",
  "Roccaspinalveti",
  "Roccastrada",
  "Roccavaldina",
  "Roccaverano",
  "Roccavignale",
  "Roccavione",
  "Roccavivara",
  "Roccella Ionica",
  "Roccella Valdemone",
  "Rocchetta a Volturno",
  "Rocchetta Belbo",
  "Rocchetta di Vara",
  "Rocchetta e Croce",
  "Rocchetta Ligure",
  "Rocchetta Nervina",
  "Rocchetta Palafea",
  "Rocchetta Sant'Antonio",
  "Rocchetta Tanaro",
  "Rodano",
  "Roddi",
  "Roddino",
  "Rodello",
  "Rodengo",
  "Rodengo Saiano",
  "Rodero",
  "Rodi Garganico",
  "Rodigo",
  "Rodì Milici",
  "Rofrano",
  "Rogeno",
  "Roggiano Gravina",
  "Roghudi",
  "Rogliano",
  "Rognano",
  "Rogno",
  "Rogolo",
  "Roiate",
  "Roio del Sangro",
  "Roisan",
  "Roletto",
  "Rolo",
  "Roma",
  "Romagnano al Monte",
  "Romagnano Sesia",
  "Romagnese",
  "Romana",
  "Romanengo",
  "Romano Canavese",
  "Romano d'Ezzelino",
  "Romano di Lombardia",
  "Romans d'Isonzo",
  "Rombiolo",
  "Romeno",
  "Romentino",
  "Rometta",
  "Ronago",
  "Roncade",
  "Roncadelle",
  "Roncaro",
  "Roncegno Terme",
  "Roncello",
  "Ronchi dei Legionari",
  "Ronchi Valsugana",
  "Ronchis",
  "Ronciglione",
  "Ronco all'Adige",
  "Ronco Biellese",
  "Ronco Briantino",
  "Ronco Canavese",
  "Ronco Scrivia",
  "Roncobello",
  "Roncoferraro",
  "Roncofreddo",
  "Roncola",
  "Roncà",
  "Rondanina",
  "Rondissone",
  "Ronsecco",
  "Ronzo-Chienis",
  "Ronzone",
  "Roppolo",
  "Rorà",
  "Rosarno",
  "Rosasco",
  "Rosate",
  "Rosazza",
  "Rosciano",
  "Roscigno",
  "Rose",
  "Rosello",
  "Roseto Capo Spulico",
  "Roseto degli Abruzzi",
  "Roseto Valfortore",
  "Rosignano Marittimo",
  "Rosignano Monferrato",
  "Rosolina",
  "Rosolini",
  "Rosora",
  "Rossa",
  "Rossana",
  "Rossano Veneto",
  "Rossiglione",
  "Rosta",
  "Rosà",
  "Rota d'Imagna",
  "Rota Greca",
  "Rotella",
  "Rotello",
  "Rotonda",
  "Rotondella",
  "Rotondi",
  "Rottofreno",
  "Rotzo",
  "Roure",
  "Rovasenda",
  "Rovato",
  "Rovegno",
  "Rovellasca",
  "Rovello Porro",
  "Roverbella",
  "Roverchiara",
  "Roveredo di Guà",
  "Roveredo in Piano",
  "Rovereto",
  "Roverè della Luna",
  "Roverè Veronese",
  "Rovescala",
  "Rovetta",
  "Roviano",
  "Rovigo",
  "Rovito",
  "Rovolon",
  "Rozzano",
  "Roè Volciano",
  "Rubano",
  "Rubiana",
  "Rubiera",
  "Ruda",
  "Rudiano",
  "Rueglio",
  "Ruffano",
  "Ruffia",
  "Ruffrè-Mendola",
  "Rufina",
  "Ruinas",
  "Rumo",
  "Ruoti",
  "Russi",
  "Rutigliano",
  "Rutino",
  "Ruviano",
  "Ruvo del Monte",
  "Ruvo di Puglia",
  "Sabaudia",
  "Sabbio Chiese",
  "Sabbioneta",
  "Sacco",
  "Saccolongo",
  "Sacile",
  "Sacrofano",
  "Sadali",
  "Sagama",
  "Sagliano Micca",
  "Sagrado",
  "Sagron Mis",
  "Saint-Christophe",
  "Saint-Denis",
  "Saint-Marcel",
  "Saint-Nicolas",
  "Saint-Oyen",
  "Saint-Pierre",
  "Saint-Rhémy-en-Bosses",
  "Saint-Vincent",
  "Sala Baganza",
  "Sala Biellese",
  "Sala Bolognese",
  "Sala Comacina",
  "Sala Consilina",
  "Sala Monferrato",
  "Salandra",
  "Salaparuta",
  "Salara",
  "Salasco",
  "Salassa",
  "Salbertrand",
  "Salcedo",
  "Salcito",
  "Sale",
  "Sale delle Langhe",
  "Sale Marasino",
  "Sale San Giovanni",
  "Salemi",
  "Salento",
  "Salerano Canavese",
  "Salerano sul Lambro",
  "Salerno",
  "Salgareda",
  "Sali Vercellese",
  "Salice Salentino",
  "Saliceto",
  "Salisano",
  "Salizzole",
  "Salle",
  "Salmour",
  "Salorno",
  "Salsomaggiore Terme",
  "Saltrio",
  "Saludecio",
  "Saluggia",
  "Salussola",
  "Saluzzo",
  "Salve",
  "Salvirola",
  "Salvitelle",
  "Salza di Pinerolo",
  "Salza Irpina",
  "Salzano",
  "Salò",
  "Samarate",
  "Samassi",
  "Samatzai",
  "Sambuca di Sicilia",
  "Sambuca Pistoiese",
  "Sambuci",
  "Sambuco",
  "Sammichele di Bari",
  "Samo",
  "Samolaco",
  "Samone (TN)",
  "Samone (TO)",
  "Sampeyre",
  "Samugheo",
  "San Bartolomeo al Mare",
  "San Bartolomeo in Galdo",
  "San Bartolomeo Val Cavargna",
  "San Basile",
  "San Basilio",
  "San Bassano",
  "San Bellino",
  "San Benedetto Belbo",
  "San Benedetto dei Marsi",
  "San Benedetto del Tronto",
  "San Benedetto in Perillis",
  "San Benedetto Po",
  "San Benedetto Ullano",
  "San Benedetto Val di Sambro",
  "San Benigno Canavese",
  "San Bernardino Verbano",
  "San Biagio della Cima",
  "San Biagio di Callalta",
  "San Biagio Platani",
  "San Biagio Saracinisco",
  "San Biase",
  "San Bonifacio",
  "San Buono",
  "San Calogero",
  "San Candido",
  "San Canzian d'Isonzo",
  "San Carlo Canavese",
  "San Casciano dei Bagni",
  "San Casciano in Val di Pesa",
  "San Cassiano",
  "San Cataldo",
  "San Cesareo",
  "San Cesario di Lecce",
  "San Cesario sul Panaro",
  "San Chirico Nuovo",
  "San Chirico Raparo",
  "San Cipirello",
  "San Cipriano d'Aversa",
  "San Cipriano Picentino",
  "San Cipriano Po",
  "San Clemente",
  "San Colombano al Lambro",
  "San Colombano Belmonte",
  "San Colombano Certenoli",
  "San Cono",
  "San Cosmo Albanese",
  "San Costantino Albanese",
  "San Costantino Calabro",
  "San Costanzo",
  "San Cristoforo",
  "San Damiano al Colle",
  "San Damiano d'Asti",
  "San Damiano Macra",
  "San Daniele del Friuli",
  "San Daniele Po",
  "San Demetrio Corone",
  "San Demetrio ne' Vestini",
  "San Didero",
  "San Donaci",
  "San Donato di Lecce",
  "San Donato di Ninea",
  "San Donato Milanese",
  "San Donato Val di Comino",
  "San Donà di Piave",
  "San Dorligo della Valle",
  "San Fele",
  "San Felice a Cancello",
  "San Felice Circeo",
  "San Felice del Benaco",
  "San Felice del Molise",
  "San Felice sul Panaro",
  "San Ferdinando",
  "San Ferdinando di Puglia",
  "San Fermo della Battaglia",
  "San Fili",
  "San Filippo del Mela",
  "San Fior",
  "San Fiorano",
  "San Floriano del Collio",
  "San Floro",
  "San Francesco al Campo",
  "San Fratello",
  "San Gavino Monreale",
  "San Gemini",
  "San Genesio Atesino",
  "San Genesio ed Uniti",
  "San Gennaro Vesuviano",
  "San Germano Chisone",
  "San Germano Vercellese",
  "San Gervasio Bresciano",
  "San Giacomo degli Schiavoni",
  "San Giacomo delle Segnate",
  "San Giacomo Filippo",
  "San Giacomo Vercellese",
  "San Gillio",
  "San Gimignano",
  "San Ginesio",
  "San Giorgio a Cremano",
  "San Giorgio a Liri",
  "San Giorgio Albanese",
  "San Giorgio Bigarello",
  "San Giorgio Canavese",
  "San Giorgio del Sannio",
  "San Giorgio della Richinvelda",
  "San Giorgio delle Pertiche",
  "San Giorgio di Lomellina",
  "San Giorgio di Nogaro",
  "San Giorgio di Piano",
  "San Giorgio in Bosco",
  "San Giorgio Ionico",
  "San Giorgio La Molara",
  "San Giorgio Lucano",
  "San Giorgio Monferrato",
  "San Giorgio Morgeto",
  "San Giorgio Piacentino",
  "San Giorgio Scarampi",
  "San Giorgio su Legnano",
  "San Giorio di Susa",
  "San Giovanni a Piro",
  "San Giovanni al Natisone",
  "San Giovanni Bianco",
  "San Giovanni del Dosso",
  "San Giovanni di Fassa",
  "San Giovanni di Gerace",
  "San Giovanni Gemini",
  "San Giovanni Ilarione",
  "San Giovanni in Croce",
  "San Giovanni in Fiore",
  "San Giovanni in Galdo",
  "San Giovanni in Marignano",
  "San Giovanni in Persiceto",
  "San Giovanni Incarico",
  "San Giovanni la Punta",
  "San Giovanni Lipioni",
  "San Giovanni Lupatoto",
  "San Giovanni Rotondo",
  "San Giovanni Suergiu",
  "San Giovanni Teatino",
  "San Giovanni Valdarno",
  "San Giuliano del Sannio",
  "San Giuliano di Puglia",
  "San Giuliano Milanese",
  "San Giuliano Terme",
  "San Giuseppe Jato",
  "San Giuseppe Vesuviano",
  "San Giustino",
  "San Giusto Canavese",
  "San Godenzo",
  "San Gregorio d'Ippona",
  "San Gregorio da Sassola",
  "San Gregorio di Catania",
  "San Gregorio Magno",
  "San Gregorio Matese",
  "San Gregorio nelle Alpi",
  "San Lazzaro di Savena",
  "San Leo",
  "San Leonardo",
  "San Leonardo in Passiria",
  "San Leucio del Sannio",
  "San Lorenzello",
  "San Lorenzo",
  "San Lorenzo al Mare",
  "San Lorenzo Bellizzi",
  "San Lorenzo del Vallo",
  "San Lorenzo di Sebato",
  "San Lorenzo Dorsino",
  "San Lorenzo in Campo",
  "San Lorenzo Isontino",
  "San Lorenzo Maggiore",
  "San Lorenzo Nuovo",
  "San Luca",
  "San Lucido",
  "San Lupo",
  "San Mango d'Aquino",
  "San Mango Piemonte",
  "San Mango sul Calore",
  "San Marcellino",
  "San Marcello",
  "San Marcello Piteglio",
  "San Marco Argentano",
  "San Marco d'Alunzio",
  "San Marco dei Cavoti",
  "San Marco Evangelista",
  "San Marco in Lamis",
  "San Marco la Catola",
  "San Martino al Tagliamento",
  "San Martino Alfieri",
  "San Martino Buon Albergo",
  "San Martino Canavese",
  "San Martino d'Agri",
  "San Martino dall'Argine",
  "San Martino del Lago",
  "San Martino di Finita",
  "San Martino di Lupari",
  "San Martino di Venezze",
  "San Martino in Badia",
  "San Martino in Passiria",
  "San Martino in Pensilis",
  "San Martino in Rio",
  "San Martino in Strada",
  "San Martino Sannita",
  "San Martino Siccomario",
  "San Martino sulla Marrucina",
  "San Martino Valle Caudina",
  "San Marzano di San Giuseppe",
  "San Marzano Oliveto",
  "San Marzano sul Sarno",
  "San Massimo",
  "San Maurizio Canavese",
  "San Maurizio d'Opaglio",
  "San Mauro Castelverde",
  "San Mauro Cilento",
  "San Mauro di Saline",
  "San Mauro Forte",
  "San Mauro la Bruca",
  "San Mauro Marchesato",
  "San Mauro Pascoli",
  "San Mauro Torinese",
  "San Michele al Tagliamento",
  "San Michele all'Adige",
  "San Michele di Ganzaria",
  "San Michele di Serino",
  "San Michele Mondovì",
  "San Michele Salentino",
  "San Miniato",
  "San Nazzaro",
  "San Nazzaro Sesia",
  "San Nazzaro Val Cavargna",
  "San Nicandro Garganico",
  "San Nicola Arcella",
  "San Nicola Baronia",
  "San Nicola da Crissa",
  "San Nicola dell'Alto",
  "San Nicola la Strada",
  "San Nicola Manfredi",
  "San Nicolò d'Arcidano",
  "San Nicolò di Comelico",
  "San Nicolò Gerrei",
  "San Pancrazio",
  "San Pancrazio Salentino",
  "San Paolo",
  "San Paolo Albanese",
  "San Paolo Bel Sito",
  "San Paolo d'Argon",
  "San Paolo di Civitate",
  "San Paolo di Jesi",
  "San Paolo Solbrito",
  "San Pellegrino Terme",
  "San Pier d'Isonzo",
  "San Pier Niceto",
  "San Piero Patti",
  "San Pietro a Maida",
  "San Pietro al Natisone",
  "San Pietro al Tanagro",
  "San Pietro Apostolo",
  "San Pietro Avellana",
  "San Pietro Clarenza",
  "San Pietro di Cadore",
  "San Pietro di Caridà",
  "San Pietro di Feletto",
  "San Pietro di Morubio",
  "San Pietro in Amantea",
  "San Pietro in Cariano",
  "San Pietro in Casale",
  "San Pietro in Cerro",
  "San Pietro in Gu",
  "San Pietro in Guarano",
  "San Pietro in Lama",
  "San Pietro Infine",
  "San Pietro Mosezzo",
  "San Pietro Mussolino",
  "San Pietro Val Lemina",
  "San Pietro Vernotico",
  "San Pietro Viminario",
  "San Pio delle Camere",
  "San Polo d'Enza",
  "San Polo dei Cavalieri",
  "San Polo di Piave",
  "San Polo Matese",
  "San Ponso",
  "San Possidonio",
  "San Potito Sannitico",
  "San Potito Ultra",
  "San Prisco",
  "San Procopio",
  "San Prospero",
  "San Quirico d'Orcia",
  "San Quirino",
  "San Raffaele Cimena",
  "San Roberto",
  "San Rocco al Porto",
  "San Romano in Garfagnana",
  "San Rufo",
  "San Salvatore di Fitalia",
  "San Salvatore Monferrato",
  "San Salvatore Telesino",
  "San Salvo",
  "San Sebastiano al Vesuvio",
  "San Sebastiano Curone",
  "San Sebastiano da Po",
  "San Secondo di Pinerolo",
  "San Secondo Parmense",
  "San Severino Lucano",
  "San Severino Marche",
  "San Severo",
  "San Siro",
  "San Sossio Baronia",
  "San Sostene",
  "San Sosti",
  "San Sperate",
  "San Stino di Livenza",
  "San Tammaro",
  "San Teodoro (ME)",
  "San Teodoro (SS)",
  "San Tomaso Agordino",
  "San Valentino in Abruzzo Citeriore",
  "San Valentino Torio",
  "San Venanzo",
  "San Vendemiano",
  "San Vero Milis",
  "San Vincenzo",
  "San Vincenzo La Costa",
  "San Vincenzo Valle Roveto",
  "San Vitaliano",
  "San Vito",
  "San Vito al Tagliamento",
  "San Vito al Torre",
  "San Vito Chietino",
  "San Vito dei Normanni",
  "San Vito di Cadore",
  "San Vito di Fagagna",
  "San Vito di Leguzzano",
  "San Vito Lo Capo",
  "San Vito Romano",
  "San Vito sullo Ionio",
  "San Vittore del Lazio",
  "San Vittore Olona",
  "San Zeno di Montagna",
  "San Zeno Naviglio",
  "San Zenone al Lambro",
  "San Zenone al Po",
  "San Zenone degli Ezzelini",
  "Sanarica",
  "Sandigliano",
  "Sandrigo",
  "Sanfront",
  "Sanfrè",
  "Sangano",
  "Sangiano",
  "Sangineto",
  "Sanguinetto",
  "Sanluri",
  "Sannazzaro de' Burgondi",
  "Sannicandro di Bari",
  "Sannicola",
  "Sanremo",
  "Sansepolcro",
  "Sant'Agapito",
  "Sant'Agata Bolognese",
  "Sant'Agata de' Goti",
  "Sant'Agata del Bianco",
  "Sant'Agata di Esaro",
  "Sant'Agata di Militello",
  "Sant'Agata di Puglia",
  "Sant'Agata Feltria",
  "Sant'Agata Fossili",
  "Sant'Agata li Battiati",
  "Sant'Agata sul Santerno",
  "Sant'Agnello",
  "Sant'Albano Stura",
  "Sant'Alessio con Vialone",
  "Sant'Alessio in Aspromonte",
  "Sant'Alessio Siculo",
  "Sant'Alfio",
  "Sant'Ambrogio di Torino",
  "Sant'Ambrogio di Valpolicella",
  "Sant'Ambrogio sul Garigliano",
  "Sant'Anastasia",
  "Sant'Anatolia di Narco",
  "Sant'Andrea Apostolo dello Ionio",
  "Sant'Andrea del Garigliano",
  "Sant'Andrea di Conza",
  "Sant'Andrea Frius",
  "Sant'Angelo a Cupolo",
  "Sant'Angelo a Fasanella",
  "Sant'Angelo a Scala",
  "Sant'Angelo all'Esca",
  "Sant'Angelo d'Alife",
  "Sant'Angelo dei Lombardi",
  "Sant'Angelo del Pesco",
  "Sant'Angelo di Brolo",
  "Sant'Angelo di Piove di Sacco",
  "Sant'Angelo in Pontano",
  "Sant'Angelo in Vado",
  "Sant'Angelo Le Fratte",
  "Sant'Angelo Limosano",
  "Sant'Angelo Lodigiano",
  "Sant'Angelo Lomellina",
  "Sant'Angelo Muxaro",
  "Sant'Angelo Romano",
  "Sant'Anna Arresi",
  "Sant'Anna d'Alfaedo",
  "Sant'Antimo",
  "Sant'Antioco",
  "Sant'Antonino di Susa",
  "Sant'Antonio Abate",
  "Sant'Antonio di Gallura",
  "Sant'Apollinare",
  "Sant'Arcangelo",
  "Sant'Arcangelo Trimonte",
  "Sant'Arpino",
  "Sant'Arsenio",
  "Sant'Egidio alla Vibrata",
  "Sant'Egidio del Monte Albino",
  "Sant'Elena",
  "Sant'Elena Sannita",
  "Sant'Elia a Pianisi",
  "Sant'Elia Fiumerapido",
  "Sant'Elpidio a Mare",
  "Sant'Eufemia a Maiella",
  "Sant'Eufemia d'Aspromonte",
  "Sant'Eusanio del Sangro",
  "Sant'Eusanio Forconese",
  "Sant'Ilario d'Enza",
  "Sant'Ilario dello Ionio",
  "Sant'Ippolito",
  "Sant'Olcese",
  "Sant'Omero",
  "Sant'Omobono Terme",
  "Sant'Onofrio",
  "Sant'Oreste",
  "Sant'Orsola Terme",
  "Sant'Urbano",
  "Santa Brigida",
  "Santa Caterina Albanese",
  "Santa Caterina dello Ionio",
  "Santa Caterina Villarmosa",
  "Santa Cesarea Terme",
  "Santa Cristina d'Aspromonte",
  "Santa Cristina e Bissone",
  "Santa Cristina Gela",
  "Santa Cristina Valgardena",
  "Santa Croce Camerina",
  "Santa Croce del Sannio",
  "Santa Croce di Magliano",
  "Santa Croce sull'Arno",
  "Santa Domenica Talao",
  "Santa Domenica Vittoria",
  "Santa Elisabetta",
  "Santa Fiora",
  "Santa Flavia",
  "Santa Giuletta",
  "Santa Giusta",
  "Santa Giustina",
  "Santa Giustina in Colle",
  "Santa Luce",
  "Santa Lucia del Mela",
  "Santa Lucia di Piave",
  "Santa Lucia di Serino",
  "Santa Margherita di Belice",
  "Santa Margherita di Staffora",
  "Santa Margherita Ligure",
  "Santa Maria a Monte",
  "Santa Maria a Vico",
  "Santa Maria Capua Vetere",
  "Santa Maria Coghinas",
  "Santa Maria del Cedro",
  "Santa Maria del Molise",
  "Santa Maria della Versa",
  "Santa Maria di Licodia",
  "Santa Maria di Sala",
  "Santa Maria Hoè",
  "Santa Maria Imbaro",
  "Santa Maria la Carità",
  "Santa Maria la Fossa",
  "Santa Maria la Longa",
  "Santa Maria Maggiore",
  "Santa Maria Nuova",
  "Santa Marina",
  "Santa Marina Salina",
  "Santa Marinella",
  "Santa Ninfa",
  "Santa Paolina",
  "Santa Severina",
  "Santa Sofia",
  "Santa Sofia d'Epiro",
  "Santa Teresa di Riva",
  "Santa Teresa Gallura",
  "Santa Venerina",
  "Santa Vittoria d'Alba",
  "Santa Vittoria in Matenano",
  "Santadi",
  "Santarcangelo di Romagna",
  "Sante Marie",
  "Santena",
  "Santeramo in Colle",
  "Santhià",
  "Santi Cosma e Damiano",
  "Santo Stefano al Mare",
  "Santo Stefano Belbo",
  "Santo Stefano d'Aveto",
  "Santo Stefano del Sole",
  "Santo Stefano di Cadore",
  "Santo Stefano di Camastra",
  "Santo Stefano di Magra",
  "Santo Stefano di Rogliano",
  "Santo Stefano di Sessanio",
  "Santo Stefano in Aspromonte",
  "Santo Stefano Lodigiano",
  "Santo Stefano Quisquina",
  "Santo Stefano Roero",
  "Santo Stefano Ticino",
  "Santomenna",
  "Santopadre",
  "Santorso",
  "Santu Lussurgiu",
  "Sanza",
  "Sanzeno",
  "Saonara",
  "Saponara",
  "Sappada",
  "Sapri",
  "Saracena",
  "Saracinesco",
  "Sarcedo",
  "Sarconi",
  "Sardara",
  "Sardigliano",
  "Sarego",
  "Sarentino",
  "Sarezzano",
  "Sarezzo",
  "Sarmato",
  "Sarmede",
  "Sarnano",
  "Sarnico",
  "Sarno",
  "Sarnonico",
  "Saronno",
  "Sarre",
  "Sarroch",
  "Sarsina",
  "Sarteano",
  "Sartirana Lomellina",
  "Sarule",
  "Sarzana",
  "Sassano",
  "Sassari",
  "Sassello",
  "Sassetta",
  "Sassinoro",
  "Sasso di Castalda",
  "Sasso Marconi",
  "Sassocorvaro Auditore",
  "Sassofeltrio",
  "Sassoferrato",
  "Sassuolo",
  "Satriano",
  "Satriano di Lucania",
  "Sauris",
  "Sauze d'Oulx",
  "Sauze di Cesana",
  "Sava",
  "Savelli",
  "Saviano",
  "Savigliano",
  "Savignano Irpino",
  "Savignano sul Panaro",
  "Savignano sul Rubicone",
  "Savignone",
  "Saviore dell'Adamello",
  "Savoca",
  "Savogna",
  "Savogna d'Isonzo",
  "Savoia di Lucania",
  "Savona",
  "Scafa",
  "Scafati",
  "Scagnello",
  "Scala",
  "Scala Coeli",
  "Scaldasole",
  "Scalea",
  "Scalenghe",
  "Scaletta Zanclea",
  "Scampitella",
  "Scandale",
  "Scandiano",
  "Scandicci",
  "Scandolara Ravara",
  "Scandolara Ripa d'Oglio",
  "Scandriglia",
  "Scanno",
  "Scano di Montiferro",
  "Scansano",
  "Scanzano Jonico",
  "Scanzorosciate",
  "Scapoli",
  "Scarlino",
  "Scarmagno",
  "Scarnafigi",
  "Scarperia e San Piero",
  "Scena",
  "Scerni",
  "Scheggia e Pascelupo",
  "Scheggino",
  "Schiavi di Abruzzo",
  "Schiavon",
  "Schignano",
  "Schilpario",
  "Schio",
  "Schivenoglia",
  "Sciacca",
  "Sciara",
  "Scicli",
  "Scido",
  "Scigliano",
  "Scilla",
  "Scillato",
  "Sciolze",
  "Scisciano",
  "Sclafani Bagni",
  "Scontrone",
  "Scopa",
  "Scopello",
  "Scoppito",
  "Scordia",
  "Scorrano",
  "Scorzè",
  "Scurcola Marsicana",
  "Scurelle",
  "Scurzolengo",
  "Seborga",
  "Secinaro",
  "Seclì",
  "Secugnago",
  "Sedegliano",
  "Sedico",
  "Sedilo",
  "Sedini",
  "Sedriano",
  "Sedrina",
  "Sefro",
  "Segariu",
  "Seggiano",
  "Segni",
  "Segonzano",
  "Segrate",
  "Segusino",
  "Selargius",
  "Selci",
  "Selegas",
  "Sella Giudicarie",
  "Sellano",
  "Sellero",
  "Sellia",
  "Sellia Marina",
  "Selva dei Molini",
  "Selva di Cadore",
  "Selva di Progno",
  "Selva di Val Gardena",
  "Selvazzano Dentro",
  "Selvino",
  "Semestene",
  "Semiana",
  "Seminara",
  "Semproniano",
  "Senago",
  "Senale-San Felice",
  "Senales",
  "Seneghe",
  "Senerchia",
  "Seniga",
  "Senigallia",
  "Senis",
  "Senise",
  "Senna Comasco",
  "Senna Lodigiana",
  "Sennariolo",
  "Sennori",
  "Senorbì",
  "Sepino",
  "Sequals",
  "Seravezza",
  "Serdiana",
  "Seregno",
  "Seren del Grappa",
  "Sergnano",
  "Seriate",
  "Serina",
  "Serino",
  "Serle",
  "Sermide e Felonica",
  "Sermoneta",
  "Sernaglia della Battaglia",
  "Sernio",
  "Serole",
  "Serra d'Aiello",
  "Serra de' Conti",
  "Serra Riccò",
  "Serra San Bruno",
  "Serra San Quirico",
  "Serra Sant'Abbondio",
  "Serracapriola",
  "Serradifalco",
  "Serralunga d'Alba",
  "Serralunga di Crea",
  "Serramanna",
  "Serramazzoni",
  "Serramezzana",
  "Serramonacesca",
  "Serrapetrona",
  "Serrara Fontana",
  "Serrastretta",
  "Serrata",
  "Serravalle a Po",
  "Serravalle di Chienti",
  "Serravalle Langhe",
  "Serravalle Pistoiese",
  "Serravalle Scrivia",
  "Serravalle Sesia",
  "Serre",
  "Serrenti",
  "Serri",
  "Serrone",
  "Sersale",
  "Servigliano",
  "Sessa Aurunca",
  "Sessa Cilento",
  "Sessame",
  "Sessano del Molise",
  "Sesta Godano",
  "Sestino",
  "Sesto",
  "Sesto al Reghena",
  "Sesto Calende",
  "Sesto Campano",
  "Sesto ed Uniti",
  "Sesto Fiorentino",
  "Sesto San Giovanni",
  "Sestola",
  "Sestri Levante",
  "Sestriere",
  "Sestu",
  "Settala",
  "Settefrati",
  "Settime",
  "Settimo Milanese",
  "Settimo Rottaro",
  "Settimo San Pietro",
  "Settimo Torinese",
  "Settimo Vittone",
  "Settingiano",
  "Setzu",
  "Seui",
  "Seulo",
  "Seveso",
  "Sezzadio",
  "Sezze",
  "Sfruz",
  "Sgonico",
  "Sgurgola",
  "Siamaggiore",
  "Siamanna",
  "Siano",
  "Siapiccia",
  "Sicignano degli Alburni",
  "Siculiana",
  "Siddi",
  "Siderno",
  "Siena",
  "Sigillo",
  "Signa",
  "Silandro",
  "Silanus",
  "Silea",
  "Siligo",
  "Siliqua",
  "Silius",
  "Sillano Giuncugnano",
  "Sillavengo",
  "Silvano d'Orba",
  "Silvano Pietra",
  "Silvi",
  "Simala",
  "Simaxis",
  "Simbario",
  "Simeri Crichi",
  "Sinagra",
  "Sinalunga",
  "Sindia",
  "Sini",
  "Sinio",
  "Siniscola",
  "Sinnai",
  "Sinopoli",
  "Siracusa",
  "Sirignano",
  "Siris",
  "Sirmione",
  "Sirolo",
  "Sirone",
  "Sirtori",
  "Sissa Trecasali",
  "Siurgus Donigala",
  "Siziano",
  "Sizzano",
  "Sluderno",
  "Smerillo",
  "Soave",
  "Socchieve",
  "Soddì",
  "Sogliano al Rubicone",
  "Sogliano Cavour",
  "Soglio",
  "Soiano del Lago",
  "Solagna",
  "Solarino",
  "Solaro",
  "Solarolo",
  "Solarolo Rainerio",
  "Solarussa",
  "Solbiate Arno",
  "Solbiate con Cagno",
  "Solbiate Olona",
  "Soldano",
  "Soleminis",
  "Solero",
  "Solesino",
  "Soleto",
  "Solferino",
  "Soliera",
  "Solignano",
  "Solofra",
  "Solonghello",
  "Solopaca",
  "Solto Collina",
  "Solza",
  "Somaglia",
  "Somano",
  "Somma Lombardo",
  "Somma Vesuviana",
  "Sommacampagna",
  "Sommariva del Bosco",
  "Sommariva Perno",
  "Sommatino",
  "Sommo",
  "Sona",
  "Soncino",
  "Sondalo",
  "Sondrio",
  "Songavazzo",
  "Sonico",
  "Sonnino",
  "Sora",
  "Soraga di Fassa",
  "Soragna",
  "Sorano",
  "Sorbo San Basile",
  "Sorbo Serpico",
  "Sorbolo Mezzani",
  "Sordevolo",
  "Sordio",
  "Soresina",
  "Sorgono",
  "Sorgà",
  "Sori",
  "Sorianello",
  "Soriano Calabro",
  "Soriano nel Cimino",
  "Sorico",
  "Soriso",
  "Sorisole",
  "Sormano",
  "Sorradile",
  "Sorrento",
  "Sorso",
  "Sortino",
  "Sospiro",
  "Sospirolo",
  "Sossano",
  "Sostegno",
  "Sotto il Monte Giovanni XXIII",
  "Sover",
  "Soverato",
  "Sovere",
  "Soveria Mannelli",
  "Soveria Simeri",
  "Soverzene",
  "Sovicille",
  "Sovico",
  "Sovizzo",
  "Sovramonte",
  "Sozzago",
  "Spadafora",
  "Spadola",
  "Sparanise",
  "Sparone",
  "Specchia",
  "Spello",
  "Sperlinga",
  "Sperlonga",
  "Sperone",
  "Spessa",
  "Spezzano Albanese",
  "Spezzano della Sila",
  "Spiazzo",
  "Spigno Monferrato",
  "Spigno Saturnia",
  "Spilamberto",
  "Spilimbergo",
  "Spilinga",
  "Spinadesco",
  "Spinazzola",
  "Spinea",
  "Spineda",
  "Spinete",
  "Spineto Scrivia",
  "Spinetoli",
  "Spino d'Adda",
  "Spinone al Lago",
  "Spinoso",
  "Spirano",
  "Spoleto",
  "Spoltore",
  "Spongano",
  "Spormaggiore",
  "Sporminore",
  "Spotorno",
  "Spresiano",
  "Spriana",
  "Squillace",
  "Squinzano",
  "Staffolo",
  "Stagno Lombardo",
  "Staiti",
  "Stalettì",
  "Stanghella",
  "Staranzano",
  "Statte",
  "Stazzano",
  "Stazzema",
  "Stazzona",
  "Stefanaconi",
  "Stella",
  "Stella Cilento",
  "Stellanello",
  "Stelvio",
  "Stenico",
  "Sternatia",
  "Stezzano",
  "Stienta",
  "Stigliano",
  "Stignano",
  "Stilo",
  "Stimigliano",
  "Stintino",
  "Stio",
  "Stornara",
  "Stornarella",
  "Storo",
  "Stra",
  "Stradella",
  "Strambinello",
  "Strambino",
  "Strangolagalli",
  "Stregna",
  "Strembo",
  "Stresa",
  "Strevi",
  "Striano",
  "Strona",
  "Stroncone",
  "Strongoli",
  "Stroppiana",
  "Stroppo",
  "Strozza",
  "Sturno",
  "Suardi",
  "Subbiano",
  "Subiaco",
  "Succivo",
  "Sueglio",
  "Suelli",
  "Suello",
  "Suisio",
  "Sulbiate",
  "Sulmona",
  "Sulzano",
  "Sumirago",
  "Summonte",
  "Suni",
  "Suno",
  "Supersano",
  "Supino",
  "Surano",
  "Surbo",
  "Susa",
  "Susegana",
  "Sustinente",
  "Sutera",
  "Sutri",
  "Sutrio",
  "Suvereto",
  "Suzzara",
  "Taceno",
  "Tadasuni",
  "Taggia",
  "Tagliacozzo",
  "Taglio di Po",
  "Tagliolo Monferrato",
  "Taibon Agordino",
  "Taino",
  "Taipana",
  "Talamello",
  "Talamona",
  "Talana",
  "Taleggio",
  "Talla",
  "Talmassons",
  "Tambre",
  "Taormina",
  "Tarano",
  "Taranta Peligna",
  "Tarantasca",
  "Taranto",
  "Tarcento",
  "Tarquinia",
  "Tarsia",
  "Tartano",
  "Tarvisio",
  "Tarzo",
  "Tassarolo",
  "Taurano",
  "Taurasi",
  "Taurianova",
  "Taurisano",
  "Tavagnacco",
  "Tavagnasco",
  "Tavazzano con Villavesco",
  "Tavenna",
  "Taverna",
  "Tavernerio",
  "Tavernola Bergamasca",
  "Tavernole sul Mella",
  "Taviano",
  "Tavigliano",
  "Tavoleto",
  "Tavullia",
  "Teana",
  "Teano",
  "Teggiano",
  "Teglio",
  "Teglio Veneto",
  "Telese Terme",
  "Telgate",
  "Telti",
  "Telve",
  "Telve di Sopra",
  "Tempio Pausania",
  "Temù",
  "Tenna",
  "Tenno",
  "Teolo",
  "Teora",
  "Teramo",
  "Terdobbiate",
  "Terelle",
  "Terento",
  "Terenzo",
  "Tergu",
  "Terlano",
  "Terlizzi",
  "Terme Vigliatore",
  "Termeno sulla strada del vino",
  "Termini Imerese",
  "Termoli",
  "Ternate",
  "Ternengo",
  "Terni",
  "Terno d'Isola",
  "Terracina",
  "Terragnolo",
  "Terralba",
  "Terranova da Sibari",
  "Terranova dei Passerini",
  "Terranova di Pollino",
  "Terranova Sappo Minulio",
  "Terranuova Bracciolini",
  "Terrasini",
  "Terrassa Padovana",
  "Terravecchia",
  "Terrazzo",
  "Terre d'Adige",
  "Terre del Reno",
  "Terre Roveresche",
  "Terricciola",
  "Terruggia",
  "Tertenia",
  "Terzigno",
  "Terzo",
  "Terzo d'Aquileia",
  "Terzolas",
  "Terzorio",
  "Tesero",
  "Tesimo",
  "Tessennano",
  "Testico",
  "Teti",
  "Teulada",
  "Teverola",
  "Tezze sul Brenta",
  "Thiene",
  "Thiesi",
  "Tiana",
  "Ticengo",
  "Ticineto",
  "Tiggiano",
  "Tiglieto",
  "Tigliole",
  "Tignale",
  "Tinnura",
  "Tione degli Abruzzi",
  "Tione di Trento",
  "Tirano",
  "Tires",
  "Tiriolo",
  "Tirolo",
  "Tissi",
  "Tito",
  "Tivoli",
  "Tizzano Val Parma",
  "Toano",
  "Tocco Caudio",
  "Tocco da Casauria",
  "Toceno",
  "Todi",
  "Toffia",
  "Toirano",
  "Tolentino",
  "Tolfa",
  "Tollegno",
  "Tollo",
  "Tolmezzo",
  "Tolve",
  "Tombolo",
  "Ton",
  "Tonara",
  "Tonco",
  "Tonengo",
  "Tonezza del Cimone",
  "Tora e Piccilli",
  "Torano Castello",
  "Torano Nuovo",
  "Torbole Casaglia",
  "Torcegno",
  "Torchiara",
  "Torchiarolo",
  "Torella dei Lombardi",
  "Torella del Sannio",
  "Torgiano",
  "Torgnon",
  "Torino",
  "Torino di Sangro",
  "Toritto",
  "Torlino Vimercati",
  "Tornaco",
  "Tornareccio",
  "Tornata",
  "Tornimparte",
  "Torno",
  "Tornolo",
  "Toro",
  "Torpè",
  "Torraca",
  "Torralba",
  "Torrazza Coste",
  "Torrazza Piemonte",
  "Torrazzo",
  "Torre Annunziata",
  "Torre Beretti e Castellaro",
  "Torre Boldone",
  "Torre Bormida",
  "Torre Cajetani",
  "Torre Canavese",
  "Torre d'Arese",
  "Torre d'Isola",
  "Torre de' Busi",
  "Torre de' Negri",
  "Torre de' Passeri",
  "Torre de' Picenardi",
  "Torre de' Roveri",
  "Torre del Greco",
  "Torre di Mosto",
  "Torre di Ruggiero",
  "Torre di Santa Maria",
  "Torre Le Nocelle",
  "Torre Mondovì",
  "Torre Orsaia",
  "Torre Pallavicina",
  "Torre Pellice",
  "Torre San Giorgio",
  "Torre San Patrizio",
  "Torre Santa Susanna",
  "Torreano",
  "Torrebelvicino",
  "Torrebruna",
  "Torrecuso",
  "Torreglia",
  "Torregrotta",
  "Torremaggiore",
  "Torrenova",
  "Torresina",
  "Torretta",
  "Torrevecchia Pia",
  "Torrevecchia Teatina",
  "Torri del Benaco",
  "Torri di Quartesolo",
  "Torri in Sabina",
  "Torrice",
  "Torricella",
  "Torricella del Pizzo",
  "Torricella in Sabina",
  "Torricella Peligna",
  "Torricella Sicura",
  "Torricella Verzate",
  "Torriglia",
  "Torrile",
  "Torrioni",
  "Torrita di Siena",
  "Torrita Tiberina",
  "Tortolì",
  "Tortona",
  "Tortora",
  "Tortorella",
  "Tortoreto",
  "Tortorici",
  "Torviscosa",
  "Toscolano-Maderno",
  "Tossicia",
  "Tovo di Sant'Agata",
  "Tovo San Giacomo",
  "Trabia",
  "Tradate",
  "Tramatza",
  "Trambileno",
  "Tramonti",
  "Tramonti di Sopra",
  "Tramonti di Sotto",
  "Tramutola",
  "Trana",
  "Trani",
  "Traona",
  "Trapani",
  "Trappeto",
  "Trarego Viggiona",
  "Trasacco",
  "Trasaghis",
  "Trasquera",
  "Tratalias",
  "Travacò Siccomario",
  "Travagliato",
  "Travedona-Monate",
  "Traversella",
  "Traversetolo",
  "Traves",
  "Travesio",
  "Travo",
  "Tre Ville",
  "Trebaseleghe",
  "Trebisacce",
  "Trecase",
  "Trecastagni",
  "Trecastelli",
  "Trecate",
  "Trecchina",
  "Trecenta",
  "Tredozio",
  "Treglio",
  "Tregnago",
  "Treia",
  "Treiso",
  "Tremestieri Etneo",
  "Tremezzina",
  "Tremosine sul Garda",
  "Trentinara",
  "Trento",
  "Trentola Ducenta",
  "Trenzano",
  "Treppo Grande",
  "Treppo Ligosullo",
  "Trepuzzi",
  "Trequanda",
  "Tresana",
  "Trescore Balneario",
  "Trescore Cremasco",
  "Tresignana",
  "Tresivio",
  "Tresnuraghes",
  "Trevenzuolo",
  "Trevi",
  "Trevi nel Lazio",
  "Trevico",
  "Treviglio",
  "Trevignano",
  "Trevignano Romano",
  "Treville",
  "Treviolo",
  "Treviso",
  "Treviso Bresciano",
  "Trezzano Rosa",
  "Trezzano sul Naviglio",
  "Trezzo sull'Adda",
  "Trezzo Tinella",
  "Trezzone",
  "Tribano",
  "Tribiano",
  "Tribogna",
  "Tricarico",
  "Tricase",
  "Tricerro",
  "Tricesimo",
  "Triei",
  "Trieste",
  "Triggiano",
  "Trigolo",
  "Trinitapoli",
  "Trinità",
  "Trinità d'Agultu e Vignola",
  "Trino",
  "Triora",
  "Tripi",
  "Trisobbio",
  "Trissino",
  "Triuggio",
  "Trivento",
  "Trivigliano",
  "Trivignano Udinese",
  "Trivigno",
  "Trivolzio",
  "Trodena nel parco naturale",
  "Trofarello",
  "Troia",
  "Troina",
  "Tromello",
  "Trontano",
  "Tronzano Lago Maggiore",
  "Tronzano Vercellese",
  "Tropea",
  "Trovo",
  "Truccazzano",
  "Tubre",
  "Tufara",
  "Tufillo",
  "Tufino",
  "Tufo",
  "Tuglie",
  "Tuili",
  "Tula",
  "Tuoro sul Trasimeno",
  "Turania",
  "Turano Lodigiano",
  "Turate",
  "Turbigo",
  "Turi",
  "Turri",
  "Turriaco",
  "Turrivalignani",
  "Tursi",
  "Tusa",
  "Tuscania",
  "Ubiale Clanezzo",
  "Uboldo",
  "Ucria",
  "Udine",
  "Ugento",
  "Uggiano la Chiesa",
  "Uggiate-Trevano",
  "Ulassai",
  "Ultimo",
  "Ulà Tirso",
  "Umbertide",
  "Umbriatico",
  "Urago d'Oglio",
  "Uras",
  "Urbana",
  "Urbania",
  "Urbe",
  "Urbino",
  "Urbisaglia",
  "Urgnano",
  "Uri",
  "Ururi",
  "Urzulei",
  "Uscio",
  "Usellus",
  "Usini",
  "Usmate Velate",
  "Ussana",
  "Ussaramanna",
  "Ussassai",
  "Usseaux",
  "Usseglio",
  "Ussita",
  "Ustica",
  "Uta",
  "Uzzano",
  "Vaccarizzo Albanese",
  "Vacone",
  "Vacri",
  "Vadena",
  "Vado Ligure",
  "Vagli Sotto",
  "Vaglia",
  "Vaglio Basilicata",
  "Vaglio Serra",
  "Vaiano",
  "Vaiano Cremasco",
  "Vaie",
  "Vailate",
  "Vairano Patenora",
  "Vajont",
  "Val Brembilla",
  "Val della Torre",
  "Val di Chy",
  "Val di Nizza",
  "Val di Vizze",
  "Val di Zoldo",
  "Val Liona",
  "Val Masino",
  "Val Rezzo",
  "Valbondione",
  "Valbrembo",
  "Valbrenta",
  "Valbrevenna",
  "Valbrona",
  "Valchiusa",
  "Valdagno",
  "Valdaone",
  "Valdaora",
  "Valdastico",
  "Valdengo",
  "Valderice",
  "Valdidentro",
  "Valdieri",
  "Valdilana",
  "Valdina",
  "Valdisotto",
  "Valdobbiadene",
  "Valduggia",
  "Valeggio",
  "Valeggio sul Mincio",
  "Valentano",
  "Valenza",
  "Valenzano",
  "Valera Fratta",
  "Valfabbrica",
  "Valfenera",
  "Valfloriana",
  "Valfornace",
  "Valfurva",
  "Valganna",
  "Valgioie",
  "Valgoglio",
  "Valgrana",
  "Valgreghentino",
  "Valgrisenche",
  "Valguarnera Caropepe",
  "Vallada Agordina",
  "Vallanzengo",
  "Vallarsa",
  "Vallata",
  "Valle Agricola",
  "Valle Aurina",
  "Valle Cannobina",
  "Valle Castellana",
  "Valle dell'Angelo",
  "Valle di Cadore",
  "Valle di Casies",
  "Valle di Maddaloni",
  "Valle Lomellina",
  "Valle Salimbene",
  "Valle San Nicolao",
  "Vallebona",
  "Vallecorsa",
  "Vallecrosia",
  "Valledolmo",
  "Valledoria",
  "Vallefiorita",
  "Vallefoglia",
  "Vallelaghi",
  "Vallelonga",
  "Vallelunga Pratameno",
  "Vallemaio",
  "Vallepietra",
  "Vallerano",
  "Vallermosa",
  "Vallerotonda",
  "Vallesaccarda",
  "Valleve",
  "Valli del Pasubio",
  "Vallinfreda",
  "Vallio Terme",
  "Vallo della Lucania",
  "Vallo di Nera",
  "Vallo Torinese",
  "Valloriate",
  "Valmacca",
  "Valmadrera",
  "Valmontone",
  "Valmorea",
  "Valmozzola",
  "Valnegra",
  "Valpelline",
  "Valperga",
  "Valprato Soana",
  "Valsamoggia",
  "Valsavarenche",
  "Valsinni",
  "Valsolda",
  "Valstrona",
  "Valtopina",
  "Valtorta",
  "Valtournenche",
  "Valva",
  "Valvarrone",
  "Valvasone Arzene",
  "Valverde",
  "Valvestino",
  "Vandoies",
  "Vanzaghello",
  "Vanzago",
  "Vanzone con San Carlo",
  "Vaprio d'Adda",
  "Vaprio d'Agogna",
  "Varallo",
  "Varallo Pombia",
  "Varano Borghi",
  "Varano de' Melegari",
  "Varapodio",
  "Varazze",
  "Varco Sabino",
  "Varedo",
  "Varenna",
  "Varese",
  "Varese Ligure",
  "Varisella",
  "Varmo",
  "Varna",
  "Varsi",
  "Varzi",
  "Varzo",
  "Vasanello",
  "Vasia",
  "Vasto",
  "Vastogirardi",
  "Vauda Canavese",
  "Vazzano",
  "Vazzola",
  "Vecchiano",
  "Vedano al Lambro",
  "Vedano Olona",
  "Vedelago",
  "Vedeseta",
  "Veduggio con Colzano",
  "Veggiano",
  "Veglie",
  "Veglio",
  "Vejano",
  "Veleso",
  "Velezzo Lomellina",
  "Velletri",
  "Vellezzo Bellini",
  "Velo d'Astico",
  "Velo Veronese",
  "Velturno",
  "Venafro",
  "Venaria Reale",
  "Venarotta",
  "Venasca",
  "Venaus",
  "Vendone",
  "Venegono Inferiore",
  "Venegono Superiore",
  "Venetico",
  "Venezia",
  "Veniano",
  "Venosa",
  "Ventasso",
  "Venticano",
  "Ventimiglia",
  "Ventimiglia di Sicilia",
  "Ventotene",
  "Venzone",
  "Verano",
  "Verano Brianza",
  "Verbania",
  "Verbicaro",
  "Vercana",
  "Verceia",
  "Vercelli",
  "Vercurago",
  "Verdellino",
  "Verdello",
  "Verderio",
  "Verduno",
  "Vergato",
  "Verghereto",
  "Vergiate",
  "Vermezzo con Zelo",
  "Vermiglio",
  "Vernante",
  "Vernasca",
  "Vernate",
  "Vernazza",
  "Vernio",
  "Vernole",
  "Verolanuova",
  "Verolavecchia",
  "Verolengo",
  "Veroli",
  "Verona",
  "Veronella",
  "Verrayes",
  "Verretto",
  "Verrone",
  "Verrua Po",
  "Verrua Savoia",
  "Verrès",
  "Vertemate con Minoprio",
  "Vertova",
  "Verucchio",
  "Vervio",
  "Verzegnis",
  "Verzino",
  "Verzuolo",
  "Vescovana",
  "Vescovato",
  "Vesime",
  "Vespolate",
  "Vessalico",
  "Vestenanova",
  "Vestignè",
  "Vestone",
  "Vetralla",
  "Vetto",
  "Vezza d'Alba",
  "Vezza d'Oglio",
  "Vezzano Ligure",
  "Vezzano sul Crostolo",
  "Vezzi Portio",
  "Viadana",
  "Viadanica",
  "Viagrande",
  "Viale",
  "Vialfrè",
  "Viano",
  "Viareggio",
  "Viarigi",
  "Vibo Valentia",
  "Vibonati",
  "Vicalvi",
  "Vicari",
  "Vicchio",
  "Vicenza",
  "Vico del Gargano",
  "Vico Equense",
  "Vico nel Lazio",
  "Vicoforte",
  "Vicoli",
  "Vicolungo",
  "Vicopisano",
  "Vicovaro",
  "Viddalba",
  "Vidigulfo",
  "Vidor",
  "Vidracco",
  "Vieste",
  "Vietri di Potenza",
  "Vietri sul Mare",
  "Vigano San Martino",
  "Viganò",
  "Vigarano Mainarda",
  "Vigasio",
  "Vigevano",
  "Viggianello",
  "Viggiano",
  "Viggiù",
  "Vighizzolo d'Este",
  "Vigliano Biellese",
  "Vigliano d'Asti",
  "Vignale Monferrato",
  "Vignanello",
  "Vignate",
  "Vignola",
  "Vignola-Falesina",
  "Vignole Borbera",
  "Vignolo",
  "Vignone",
  "Vigo di Cadore",
  "Vigodarzere",
  "Vigolo",
  "Vigolzone",
  "Vigone",
  "Vigonovo",
  "Vigonza",
  "Viguzzolo",
  "Villa Bartolomea",
  "Villa Basilica",
  "Villa Biscossi",
  "Villa Carcina",
  "Villa Castelli",
  "Villa Celiera",
  "Villa Collemandina",
  "Villa Cortese",
  "Villa d'Adda",
  "Villa d'Almè",
  "Villa d'Ogna",
  "Villa del Bosco",
  "Villa del Conte",
  "Villa di Briano",
  "Villa di Chiavenna",
  "Villa di Serio",
  "Villa di Tirano",
  "Villa Estense",
  "Villa Faraldi",
  "Villa Guardia",
  "Villa Lagarina",
  "Villa Latina",
  "Villa Literno",
  "Villa Minozzo",
  "Villa San Giovanni",
  "Villa San Giovanni in Tuscia",
  "Villa San Pietro",
  "Villa San Secondo",
  "Villa Sant'Angelo",
  "Villa Sant'Antonio",
  "Villa Santa Lucia",
  "Villa Santa Lucia degli Abruzzi",
  "Villa Santa Maria",
  "Villa Santina",
  "Villa Santo Stefano",
  "Villa Verde",
  "Villabassa",
  "Villabate",
  "Villachiara",
  "Villacidro",
  "Villadeati",
  "Villadose",
  "Villadossola",
  "Villafalletto",
  "Villafranca d'Asti",
  "Villafranca di Verona",
  "Villafranca in Lunigiana",
  "Villafranca Padovana",
  "Villafranca Piemonte",
  "Villafranca Sicula",
  "Villafranca Tirrena",
  "Villafrati",
  "Villaga",
  "Villagrande Strisaili",
  "Villalago",
  "Villalba",
  "Villalfonsina",
  "Villalvernia",
  "Villamagna",
  "Villamaina",
  "Villamar",
  "Villamarzana",
  "Villamassargia",
  "Villamiroglio",
  "Villandro",
  "Villanova Biellese",
  "Villanova Canavese",
  "Villanova d'Albenga",
  "Villanova d'Ardenghi",
  "Villanova d'Asti",
  "Villanova del Battista",
  "Villanova del Ghebbo",
  "Villanova del Sillaro",
  "Villanova di Camposampiero",
  "Villanova Marchesana",
  "Villanova Mondovì",
  "Villanova Monferrato",
  "Villanova Monteleone",
  "Villanova Solaro",
  "Villanova sull'Arda",
  "Villanova Truschedu",
  "Villanova Tulo",
  "Villanovaforru",
  "Villanovafranca",
  "Villanterio",
  "Villanuova sul Clisi",
  "Villaperuccio",
  "Villapiana",
  "Villaputzu",
  "Villar Dora",
  "Villar Focchiardo",
  "Villar Pellice",
  "Villar Perosa",
  "Villar San Costanzo",
  "Villarbasse",
  "Villarboit",
  "Villareggia",
  "Villaricca",
  "Villaromagnano",
  "Villarosa",
  "Villasalto",
  "Villasanta",
  "Villasimius",
  "Villasor",
  "Villaspeciosa",
  "Villastellone",
  "Villata",
  "Villaurbana",
  "Villavallelonga",
  "Villaverla",
  "Ville d'Anaunia",
  "Ville di Fiemme",
  "Villeneuve",
  "Villesse",
  "Villetta Barrea",
  "Villette",
  "Villimpenta",
  "Villongo",
  "Villorba",
  "Vilminore di Scalve",
  "Vimercate",
  "Vimodrone",
  "Vinadio",
  "Vinchiaturo",
  "Vinchio",
  "Vinci",
  "Vinovo",
  "Vinzaglio",
  "Viola",
  "Vione",
  "Vipiteno",
  "Virle Piemonte",
  "Visano",
  "Vische",
  "Visciano",
  "Visco",
  "Visone",
  "Visso",
  "Vistarino",
  "Vistrorio",
  "Vita",
  "Viterbo",
  "Viticuso",
  "Vito d'Asio",
  "Vitorchiano",
  "Vittoria",
  "Vittorio Veneto",
  "Vittorito",
  "Vittuone",
  "Vitulano",
  "Vitulazio",
  "Vivaro",
  "Vivaro Romano",
  "Viverone",
  "Vizzini",
  "Vizzola Ticino",
  "Vizzolo Predabissi",
  "Viù",
  "Vo'",
  "Vobarno",
  "Vobbia",
  "Vocca",
  "Vodo Cadore",
  "Voghera",
  "Voghiera",
  "Vogogna",
  "Volano",
  "Volla",
  "Volongo",
  "Volpago del Montello",
  "Volpara",
  "Volpedo",
  "Volpeglino",
  "Volpiano",
  "Volta Mantovana",
  "Voltaggio",
  "Voltago Agordino",
  "Volterra",
  "Voltido",
  "Volturara Appula",
  "Volturara Irpina",
  "Volturino",
  "Volvera",
  "Vottignasco",
  "Zaccanopoli",
  "Zafferana Etnea",
  "Zagarise",
  "Zagarolo",
  "Zambrone",
  "Zandobbio",
  "Zanica",
  "Zanè",
  "Zapponeta",
  "Zavattarello",
  "Zeccone",
  "Zeddiani",
  "Zelbio",
  "Zelo Buon Persico",
  "Zeme",
  "Zenevredo",
  "Zenson di Piave",
  "Zerba",
  "Zerbo",
  "Zerbolò",
  "Zerfaliu",
  "Zeri",
  "Zermeghedo",
  "Zero Branco",
  "Zevio",
  "Ziano di Fiemme",
  "Ziano Piacentino",
  "Zibido San Giacomo",
  "Zignago",
  "Zimella",
  "Zimone",
  "Zinasco",
  "Zoagli",
  "Zocca",
  "Zogno",
  "Zola Predosa",
  "Zollino",
  "Zone",
  "Zoppola",
  "Zoppè di Cadore",
  "Zovencedo",
  "Zubiena",
  "Zuccarello",
  "Zugliano",
  "Zuglio",
  "Zumaglia",
  "Zumpano",
  "Zungoli",
  "Zungri",
];

export const COMUNE_COORDS = {
  "Abano Terme": [45.35939, 11.78871],
  "Abbadia Cerreto": [45.31239, 9.59252],
  "Abbadia Lariana": [45.9005, 9.33455],
  "Abbadia San Salvatore": [42.88097, 11.67751],
  "Abbasanta": [40.1239, 8.82102],
  "Abbateggio": [42.22447, 14.01007],
  "Abbiategrasso": [45.39858, 8.91749],
  "Abetone Cutigliano": [44.1004, 10.7564],
  "Abriola": [40.50793, 15.8122],
  "Acate": [37.0264, 14.49373],
  "Accadia": [41.15812, 15.33092],
  "Acceglio": [44.47581, 6.99122],
  "Accettura": [40.4915, 16.15736],
  "Acciano": [42.17672, 13.71835],
  "Accumoli": [42.69478, 13.24769],
  "Acerenza": [40.79553, 15.94168],
  "Acerno": [40.7383, 15.05944],
  "Acerra": [40.94586, 14.37118],
  "Aci Bonaccorsi": [37.59789, 15.10861],
  "Aci Castello": [37.55582, 15.14523],
  "Aci Catena": [37.60268, 15.14224],
  "Aci Sant'Antonio": [37.60602, 15.12585],
  "Acireale": [37.61215, 15.16629],
  "Acquafondata": [41.54312, 13.95217],
  "Acquaformosa": [39.72177, 16.09008],
  "Acquafredda": [45.30717, 10.4119],
  "Acqualagna": [43.61673, 12.67087],
  "Acquanegra Cremonese": [45.16832, 9.88879],
  "Acquanegra sul Chiese": [45.1605, 10.43339],
  "Acquapendente": [42.74404, 11.86505],
  "Acquappesa": [39.49462, 15.95404],
  "Acquaro": [38.55558, 16.18996],
  "Acquasanta Terme": [42.76912, 13.4093],
  "Acquasparta": [42.69063, 12.54631],
  "Acquaviva Collecroce": [41.8679, 14.74674],
  "Acquaviva d'Isernia": [41.67211, 14.14986],
  "Acquaviva delle Fonti": [40.89657, 16.84189],
  "Acquaviva Picena": [42.94473, 13.81464],
  "Acquaviva Platani": [37.5717, 13.70014],
  "Acquedolci": [38.05636, 14.58806],
  "Acqui Terme": [44.67661, 8.46975],
  "Acri": [39.48836, 16.38155],
  "Acuto": [41.79187, 13.17303],
  "Adelfia": [41.00183, 16.872],
  "Adrano": [37.66181, 14.83269],
  "Adrara San Martino": [45.6982, 9.94825],
  "Adrara San Rocco": [45.71217, 9.95771],
  "Adria": [45.05466, 12.05645],
  "Adro": [45.62514, 9.95535],
  "Affi": [45.55158, 10.77315],
  "Affile": [41.88438, 13.09729],
  "Afragola": [40.92236, 14.30987],
  "Africo": [38.05016, 16.13038],
  "Agazzano": [44.94681, 9.52061],
  "Agerola": [40.63798, 14.54492],
  "Aggius": [40.92881, 9.06392],
  "Agira": [37.65721, 14.5238],
  "Agliana": [43.90279, 11.00653],
  "Agliano Terme": [44.7907, 8.2511],
  "Aglientu": [41.08162, 9.11301],
  "Agliè": [45.36343, 7.7686],
  "Agna": [45.16978, 11.95673],
  "Agnadello": [45.44714, 9.55921],
  "Agnana Calabra": [38.30236, 16.22515],
  "Agnone": [41.8061, 14.36657],
  "Agnosine": [45.64771, 10.35768],
  "Agordo": [46.28147, 12.03335],
  "Agosta": [41.982, 13.03208],
  "Agra": [46.03409, 8.77145],
  "Agrate Brianza": [45.57546, 9.35176],
  "Agrate Conturbia": [45.67598, 8.55993],
  "Agrigento": [37.30971, 13.58457],
  "Agropoli": [40.34963, 14.99159],
  "Agugliano": [43.54338, 13.3858],
  "Agugliaro": [45.32398, 11.5849],
  "Aicurzio": [45.6407, 9.41104],
  "Aidomaggiore": [40.17186, 8.85643],
  "Aidone": [37.416, 14.44789],
  "Aielli": [42.08022, 13.59028],
  "Aiello Calabro": [39.11697, 16.16705],
  "Aiello del Friuli": [45.87068, 13.36246],
  "Aiello del Sabato": [40.88916, 14.81983],
  "Aieta": [39.92835, 15.82365],
  "Ailano": [41.39076, 14.20352],
  "Ailoche": [45.69806, 8.22038],
  "Airasca": [44.91689, 7.48443],
  "Airola": [41.06633, 14.56141],
  "Airole": [43.87193, 7.55373],
  "Airuno": [45.75441, 9.42247],
  "Aisone": [44.31345, 7.22083],
  "Ala": [45.75677, 11.00475],
  "Ala di Stura": [45.31511, 7.30434],
  "Alagna": [45.16928, 8.88945],
  "Alagna Valsesia": [45.85333, 7.93813],
  "Alanno": [42.29443, 13.96933],
  "Alano di Piave": [45.90803, 11.90911],
  "Alassio": [44.00804, 8.17296],
  "Alatri": [41.72647, 13.34211],
  "Alba": [44.70092, 8.0357],
  "Alba Adriatica": [42.8346, 13.92095],
  "Albagiara": [39.78826, 8.86063],
  "Albairate": [45.41871, 8.93517],
  "Albanella": [40.47978, 15.11515],
  "Albano di Lucania": [40.583, 16.03616],
  "Albano Laziale": [41.72911, 12.6587],
  "Albano Sant'Alessandro": [45.68645, 9.76624],
  "Albano Vercellese": [45.42512, 8.38058],
  "Albaredo Arnaboldi": [45.10683, 9.24351],
  "Albaredo d'Adige": [45.31739, 11.26758],
  "Albaredo per San Marco": [46.10293, 9.59044],
  "Albareto": [44.44582, 9.70052],
  "Albaretto della Torre": [44.59592, 8.06408],
  "Albavilla": [45.80109, 9.1893],
  "Albenga": [44.04911, 8.21295],
  "Albera Ligure": [44.70092, 9.06843],
  "Alberobello": [40.78373, 17.23753],
  "Alberona": [41.43048, 15.12428],
  "Albese con Cassano": [45.79543, 9.16474],
  "Albettone": [45.35833, 11.58519],
  "Albi": [39.02456, 16.59721],
  "Albiano": [46.14521, 11.19377],
  "Albiano d'Ivrea": [45.43389, 7.94914],
  "Albiate": [45.65669, 9.26134],
  "Albidona": [39.92269, 16.47454],
  "Albignasego": [45.34641, 11.86838],
  "Albinea": [44.61963, 10.60206],
  "Albino": [45.76059, 9.79693],
  "Albiolo": [45.8068, 8.93736],
  "Albisola Superiore": [44.33969, 8.51034],
  "Albissola Marina": [44.32725, 8.50318],
  "Albizzate": [45.72374, 8.80355],
  "Albonese": [45.29285, 8.70613],
  "Albosaggia": [46.1474, 9.85465],
  "Albugnano": [45.07802, 7.97153],
  "Albuzzano": [45.18755, 9.27718],
  "Alcamo": [37.9806, 12.96497],
  "Alcara li Fusi": [38.02145, 14.70109],
  "Aldeno": [45.97729, 11.09132],
  "Aldino": [46.36784, 11.35403],
  "Ales": [39.76923, 8.81584],
  "Alessandria": [44.91297, 8.6154],
  "Alessandria del Carretto": [39.95854, 16.37828],
  "Alessandria della Rocca": [37.56973, 13.45349],
  "Alessano": [39.88496, 18.33718],
  "Alezio": [40.06011, 18.06223],
  "Alfano": [40.17767, 15.42591],
  "Alfedena": [41.73397, 14.03436],
  "Alfianello": [45.26759, 10.14825],
  "Alfiano Natta": [45.04723, 8.20846],
  "Alfonsine": [44.50632, 12.04065],
  "Alghero": [40.54844, 8.32608],
  "Algua": [45.82584, 9.72223],
  "Alia": [37.77858, 13.71313],
  "Aliano": [40.31396, 16.23105],
  "Alice Bel Colle": [44.72579, 8.4512],
  "Alice Castello": [45.36653, 8.07469],
  "Alife": [41.32714, 14.33616],
  "Alimena": [37.69213, 14.11367],
  "Aliminusa": [37.86417, 13.78104],
  "Allai": [39.95793, 8.85951],
  "Alleghe": [46.40628, 12.02055],
  "Allein": [45.813, 7.27248],
  "Allerona": [42.8117, 11.97386],
  "Alliste": [39.94751, 18.08951],
  "Allumiere": [42.15654, 11.90214],
  "Almenno San Bartolomeo": [45.74829, 9.57827],
  "Almenno San Salvatore": [45.74974, 9.58738],
  "Almese": [45.11766, 7.39518],
  "Almè": [45.74006, 9.61757],
  "Alonte": [45.36585, 11.42662],
  "Alpago": [46.1263, 12.3525],
  "Alpette": [45.40998, 7.5786],
  "Alpignano": [45.09447, 7.52427],
  "Alseno": [44.89633, 9.96455],
  "Alserio": [45.77869, 9.19837],
  "Alta Valle Intelvi": [45.9848, 9.0271],
  "Altamura": [40.82794, 16.55231],
  "Altare": [44.33478, 8.34393],
  "Altavalle": [46.1822, 11.2383],
  "Altavilla Irpina": [41.00583, 14.77746],
  "Altavilla Milicia": [38.04232, 13.55045],
  "Altavilla Monferrato": [44.9929, 8.37571],
  "Altavilla Silentina": [40.52717, 15.13759],
  "Altavilla Vicentina": [45.5128, 11.46461],
  "Altidona": [43.10672, 13.79441],
  "Altilia": [39.13011, 16.2527],
  "Altino": [42.10242, 14.33261],
  "Altissimo": [45.61513, 11.25123],
  "Altivole": [45.75399, 11.95579],
  "Alto": [44.10828, 8.00369],
  "Alto Reno Terme": [44.1601, 10.9733],
  "Altofonte": [38.04436, 13.29829],
  "Altomonte": [39.69821, 16.12925],
  "Altopascio": [43.81504, 10.67474],
  "Altopiano della Vigolana": [46.0065, 11.1997],
  "Alviano": [42.58773, 12.29565],
  "Alvignano": [41.24492, 14.33677],
  "Alvito": [41.68776, 13.74264],
  "Alzano Lombardo": [45.72747, 9.72581],
  "Alzano Scrivia": [45.01756, 8.88129],
  "Alzate Brianza": [45.76698, 9.18203],
  "Alà dei Sardi": [40.65069, 9.32918],
  "Alì": [38.02694, 15.41797],
  "Alì Terme": [38.00375, 15.42262],
  "Amalfi": [40.63424, 14.60521],
  "Amandola": [42.98043, 13.35571],
  "Amantea": [39.13287, 16.08001],
  "Amaro": [46.37362, 13.09474],
  "Amaroni": [38.79362, 16.44835],
  "Amaseno": [41.46812, 13.33578],
  "Amato": [38.94139, 16.46276],
  "Amatrice": [42.62938, 13.28839],
  "Ambivere": [45.71859, 9.54723],
  "Amblar-Don": [46.3902, 11.1375],
  "Ameglia": [44.06575, 9.95727],
  "Amelia": [42.5589, 12.41192],
  "Amendolara": [39.95101, 16.5841],
  "Ameno": [45.78878, 8.43943],
  "Amorosi": [41.20531, 14.46116],
  "Ampezzo": [46.41666, 12.79458],
  "Anacapri": [40.55142, 14.21654],
  "Anagni": [41.74394, 13.15452],
  "Ancarano": [42.83681, 13.7414],
  "Ancona": [43.61676, 13.51888],
  "Andali": [39.01394, 16.76705],
  "Andalo": [46.16488, 11.00329],
  "Andalo Valtellino": [46.13448, 9.47301],
  "Andezeno": [45.03586, 7.86995],
  "Andora": [43.95825, 8.14003],
  "Andorno Micca": [45.61556, 8.05332],
  "Andrano": [39.98359, 18.38681],
  "Andrate": [45.52837, 7.87384],
  "Andreis": [46.20181, 12.61456],
  "Andretta": [40.93255, 15.32147],
  "Andria": [41.22705, 16.29521],
  "Andriano": [46.52023, 11.23293],
  "Anela": [40.44354, 9.05666],
  "Anfo": [45.76575, 10.4938],
  "Angera": [45.77248, 8.57505],
  "Anghiari": [43.54053, 12.05684],
  "Angiari": [45.21802, 11.28372],
  "Angolo Terme": [45.89296, 10.14688],
  "Angri": [40.74322, 14.56844],
  "Angrogna": [44.84345, 7.22429],
  "Anguillara Sabazia": [42.09291, 12.26979],
  "Anguillara Veneta": [45.13874, 11.88603],
  "Annicco": [45.24474, 9.88185],
  "Annone di Brianza": [45.80522, 9.33099],
  "Annone Veneto": [45.79437, 12.68302],
  "Anoia": [38.4358, 16.08372],
  "Antegnate": [45.48444, 9.79245],
  "Anterivo": [46.27749, 11.36675],
  "Antey-Saint-André": [45.80496, 7.59321],
  "Anticoli Corrado": [42.00934, 12.99038],
  "Antignano": [44.84544, 8.13379],
  "Antillo": [37.97613, 15.24539],
  "Antonimina": [38.27298, 16.14824],
  "Antrodoco": [42.41753, 13.0802],
  "Antrona Schieranco": [46.06141, 8.1151],
  "Anversa degli Abruzzi": [41.99463, 13.80358],
  "Anzano del Parco": [45.77086, 9.19876],
  "Anzano di Puglia": [41.11957, 15.29034],
  "Anzi": [40.51449, 15.92393],
  "Anzio": [41.44805, 12.62872],
  "Anzola d'Ossola": [45.98948, 8.34746],
  "Anzola dell'Emilia": [44.54648, 11.19327],
  "Aosta": [45.7375, 7.32015],
  "Apecchio": [43.5583, 12.41964],
  "Apice": [41.11858, 14.93107],
  "Apiro": [43.39247, 13.13101],
  "Apollosa": [41.09342, 14.70452],
  "Appiano Gentile": [45.735, 8.97949],
  "Appiano sulla strada del vino": [46.45528, 11.25886],
  "Appignano": [43.36407, 13.34624],
  "Appignano del Tronto": [42.89909, 13.66604],
  "Aprica": [46.15335, 10.15206],
  "Apricale": [43.88047, 7.66047],
  "Apricena": [41.7854, 15.44324],
  "Aprigliano": [39.24054, 16.34081],
  "Aprilia": [41.59415, 12.64817],
  "Aquara": [40.44281, 15.25321],
  "Aquila d'Arroscia": [44.08369, 8.00538],
  "Aquileia": [45.76644, 13.36494],
  "Aquilonia": [40.98661, 15.47176],
  "Aquino": [41.49249, 13.704],
  "Aradeo": [40.1277, 18.13479],
  "Aragona": [37.40243, 13.61779],
  "Aramengo": [45.09973, 8.00198],
  "Arba": [46.14619, 12.79076],
  "Arborea": [39.77345, 8.58218],
  "Arborio": [45.49609, 8.38899],
  "Arbus": [39.52888, 8.60021],
  "Arcade": [45.78501, 12.21903],
  "Arce": [41.58778, 13.57406],
  "Arcene": [45.57551, 9.61368],
  "Arcevia": [43.5, 12.9396],
  "Archi": [42.08914, 14.38157],
  "Arcidosso": [42.87146, 11.53879],
  "Arcinazzo Romano": [41.88021, 13.1141],
  "Arcisate": [45.85937, 8.8598],
  "Arco": [45.91929, 10.88619],
  "Arcola": [44.11461, 9.90585],
  "Arcole": [45.35768, 11.28695],
  "Arconate": [45.54156, 8.85152],
  "Arcore": [45.62697, 9.32108],
  "Arcugnano": [45.49612, 11.55075],
  "Ardara": [40.62389, 8.80926],
  "Ardauli": [40.08729, 8.91123],
  "Ardea": [41.60929, 12.54537],
  "Ardenno": [46.17276, 9.65172],
  "Ardesio": [45.9382, 9.92965],
  "Ardore": [38.19172, 16.1684],
  "Arena": [38.56296, 16.21],
  "Arena Po": [45.09443, 9.36187],
  "Arenzano": [44.40179, 8.68226],
  "Arese": [45.54987, 9.07858],
  "Arezzo": [43.46643, 11.88229],
  "Argegno": [45.94508, 9.1274],
  "Argelato": [44.64233, 11.34765],
  "Argenta": [44.61444, 11.83704],
  "Argentera": [44.37959, 6.96938],
  "Arguello": [44.58293, 8.11068],
  "Argusto": [38.68081, 16.43588],
  "Ari": [42.29111, 14.26014],
  "Ariano Irpino": [41.15386, 15.09007],
  "Ariano nel Polesine": [44.94521, 12.12108],
  "Ariccia": [41.72002, 12.67058],
  "Arielli": [42.265, 14.30478],
  "Arienzo": [41.02554, 14.4938],
  "Arignano": [45.04403, 7.90245],
  "Aritzo": [39.95939, 9.19795],
  "Arizzano": [45.95561, 8.58311],
  "Arlena di Castro": [42.463, 11.82358],
  "Arluno": [45.50899, 8.95003],
  "Armeno": [45.82197, 8.43918],
  "Armento": [40.30519, 16.06648],
  "Armo": [44.08738, 7.91401],
  "Armungia": [39.52146, 9.3802],
  "Arnad": [45.64498, 7.72128],
  "Arnara": [41.58377, 13.38768],
  "Arnasco": [44.078, 8.10697],
  "Arnesano": [40.33536, 18.08966],
  "Arola": [45.80954, 8.35876],
  "Arona": [45.76039, 8.55949],
  "Arosio": [45.71665, 9.20767],
  "Arpaia": [41.03686, 14.55177],
  "Arpaise": [41.03063, 14.74371],
  "Arpino": [41.64813, 13.61079],
  "Arquata del Tronto": [42.77264, 13.29677],
  "Arquata Scrivia": [44.68674, 8.88574],
  "Arquà Petrarca": [45.27004, 11.7164],
  "Arquà Polesine": [45.00937, 11.74137],
  "Arre": [45.2161, 11.93184],
  "Arrone": [42.58315, 12.76963],
  "Arsago Seprio": [45.68799, 8.73103],
  "Arsiero": [45.80361, 11.35035],
  "Arsita": [42.50308, 13.78595],
  "Arsiè": [45.98442, 11.75714],
  "Arsoli": [42.04141, 13.01653],
  "Arta Terme": [46.47288, 13.02486],
  "Artegna": [46.24185, 13.15598],
  "Artena": [41.73866, 12.91536],
  "Artogne": [45.84832, 10.16452],
  "Arvier": [45.70356, 7.1693],
  "Arzachena": [41.07938, 9.38848],
  "Arzago d'Adda": [45.4797, 9.5643],
  "Arzana": [39.9185, 9.52836],
  "Arzano": [40.91063, 14.26921],
  "Arzergrande": [45.27341, 12.0465],
  "Arzignano": [45.52104, 11.33227],
  "Ascea": [40.14338, 15.18402],
  "Asciano": [43.23494, 11.55945],
  "Ascoli Piceno": [42.85322, 13.57691],
  "Ascoli Satriano": [41.20815, 15.56027],
  "Ascrea": [42.1957, 12.99672],
  "Asiago": [45.8757, 11.50912],
  "Asigliano Veneto": [45.30449, 11.44618],
  "Asigliano Vercellese": [45.26118, 8.40619],
  "Asola": [45.22055, 10.41432],
  "Asolo": [45.80217, 11.91237],
  "Assago": [45.40436, 9.13115],
  "Assemini": [39.28962, 9.00623],
  "Assisi": [43.07083, 12.6154],
  "Asso": [45.86166, 9.26942],
  "Assolo": [39.81074, 8.91563],
  "Assoro": [37.62816, 14.42409],
  "Asti": [44.89913, 8.20414],
  "Asuni": [39.87192, 8.94774],
  "Ateleta": [41.85504, 14.19778],
  "Atella": [40.87742, 15.65274],
  "Atena Lucana": [40.45464, 15.55816],
  "Atessa": [42.06735, 14.44309],
  "Atina": [41.61983, 13.80036],
  "Atrani": [40.63652, 14.60843],
  "Atri": [42.57971, 13.97542],
  "Atripalda": [40.918, 14.83665],
  "Attigliano": [42.51494, 12.28942],
  "Attimis": [46.18881, 13.30512],
  "Atzara": [39.99167, 9.0763],
  "Augusta": [37.23061, 15.21944],
  "Auletta": [40.55814, 15.42411],
  "Aulla": [44.20934, 9.96815],
  "Aurano": [45.99871, 8.588],
  "Aurigo": [43.98301, 7.92256],
  "Auronzo di Cadore": [46.55022, 12.44484],
  "Ausonia": [41.35425, 13.74886],
  "Austis": [40.07105, 9.0885],
  "Avegno": [44.38231, 9.15872],
  "Avelengo": [46.64671, 11.22475],
  "Avella": [40.96034, 14.59995],
  "Avellino": [40.91405, 14.79529],
  "Averara": [45.98855, 9.63115],
  "Aversa": [40.97308, 14.20627],
  "Avetrana": [40.34863, 17.72554],
  "Avezzano": [42.03068, 13.42675],
  "Aviano": [46.0672, 12.58818],
  "Aviatico": [45.79281, 9.76892],
  "Avigliana": [45.07936, 7.39632],
  "Avigliano": [40.72978, 15.7178],
  "Avigliano Umbro": [42.65508, 12.4281],
  "Avio": [45.73545, 10.94154],
  "Avise": [45.7087, 7.14133],
  "Avola": [36.90839, 15.13544],
  "Avolasca": [44.80297, 8.96524],
  "Ayas": [45.81404, 7.68816],
  "Aymavilles": [45.70137, 7.24055],
  "Azeglio": [45.42486, 7.99477],
  "Azzanello": [45.31312, 9.9197],
  "Azzano d'Asti": [44.8747, 8.26766],
  "Azzano Decimo": [45.88124, 12.71413],
  "Azzano Mella": [45.45482, 10.11359],
  "Azzano San Paolo": [45.66192, 9.67632],
  "Azzate": [45.78198, 8.79686],
  "Azzio": [45.88536, 8.7063],
  "Azzone": [45.97903, 10.11281],
  "Baceno": [46.26149, 8.31948],
  "Bacoli": [40.79709, 14.0784],
  "Badalucco": [43.91564, 7.84705],
  "Badesi": [40.96778, 8.87915],
  "Badia": [46.61068, 11.89342],
  "Badia Calavena": [45.56389, 11.15636],
  "Badia Pavese": [45.12117, 9.46855],
  "Badia Polesine": [45.09431, 11.49138],
  "Badia Tedalda": [43.70641, 12.18558],
  "Badolato": [38.56828, 16.5259],
  "Bagaladi": [38.02537, 15.82057],
  "Bagheria": [38.07888, 13.51098],
  "Bagnacavallo": [44.4163, 11.97697],
  "Bagnara Calabra": [38.28422, 15.80044],
  "Bagnara di Romagna": [44.38883, 11.82582],
  "Bagnaria": [44.82608, 9.12434],
  "Bagnaria Arsa": [45.88741, 13.3017],
  "Bagnasco": [44.30207, 8.04258],
  "Bagnatica": [45.66367, 9.78138],
  "Bagni di Lucca": [44.01055, 10.5912],
  "Bagno a Ripoli": [43.75142, 11.31939],
  "Bagno di Romagna": [43.85781, 11.97686],
  "Bagnoli del Trigno": [41.70462, 14.45823],
  "Bagnoli di Sopra": [45.18515, 11.88137],
  "Bagnoli Irpino": [40.83266, 15.06982],
  "Bagnolo Cremasco": [45.36154, 9.60916],
  "Bagnolo del Salento": [40.14817, 18.35271],
  "Bagnolo di Po": [45.01516, 11.49996],
  "Bagnolo in Piano": [44.76143, 10.6729],
  "Bagnolo Mella": [45.42902, 10.17928],
  "Bagnolo Piemonte": [44.7599, 7.31548],
  "Bagnolo San Vito": [45.09249, 10.88141],
  "Bagnone": [44.31539, 9.99443],
  "Bagnoregio": [42.62608, 12.0985],
  "Bagolino": [45.82123, 10.46894],
  "Baia e Latina": [41.30053, 14.25034],
  "Baiano": [40.95142, 14.61713],
  "Bairo": [45.38625, 7.75692],
  "Baiso": [44.49525, 10.59879],
  "Bajardo": [43.9035, 7.71823],
  "Balangero": [45.27003, 7.51931],
  "Baldichieri d'Asti": [44.907, 8.0911],
  "Baldissero Canavese": [45.4084, 7.74444],
  "Baldissero d'Alba": [44.75871, 7.91575],
  "Baldissero Torinese": [45.06842, 7.81781],
  "Balestrate": [38.05132, 13.00439],
  "Balestrino": [44.1249, 8.17459],
  "Ballabio": [45.89604, 9.42417],
  "Ballao": [39.54851, 9.35985],
  "Balme": [45.30229, 7.21831],
  "Balmuccia": [45.81835, 8.13826],
  "Balocco": [45.45553, 8.28103],
  "Balsorano": [41.80361, 13.56335],
  "Balvano": [40.65125, 15.51206],
  "Balzola": [45.1832, 8.40255],
  "Banari": [40.57198, 8.69753],
  "Banchette": [45.46085, 7.85656],
  "Bannio Anzino": [45.98447, 8.14619],
  "Banzi": [40.86034, 16.01329],
  "Baone": [45.24425, 11.68844],
  "Baradili": [39.72251, 8.8976],
  "Baragiano": [40.67957, 15.59421],
  "Baranello": [41.52682, 14.56052],
  "Barano d'Ischia": [40.71063, 13.91625],
  "Baranzate": [45.5273, 9.11387],
  "Barasso": [45.84047, 8.7581],
  "Baratili San Pietro": [39.9933, 8.55497],
  "Barbania": [45.2905, 7.63051],
  "Barbara": [43.5808, 13.02474],
  "Barbarano Romano": [42.25225, 12.06596],
  "Barbaresco": [44.72555, 8.08046],
  "Barbariga": [45.40397, 10.05674],
  "Barbata": [45.47491, 9.77623],
  "Barberino di Mugello": [44.00044, 11.23858],
  "Barbianello": [45.0757, 9.206],
  "Barbiano": [46.60365, 11.51987],
  "Barbona": [45.10656, 11.66058],
  "Barcellona Pozzo di Gotto": [38.14693, 15.21858],
  "Barcis": [46.19086, 12.56002],
  "Bard": [45.60796, 7.74663],
  "Bardello": [45.83504, 8.69825],
  "Bardi": [44.63281, 9.73199],
  "Bardineto": [44.1921, 8.12939],
  "Bardolino": [45.54709, 10.71967],
  "Bardonecchia": [45.07817, 6.70382],
  "Bareggio": [45.47646, 8.99382],
  "Barengo": [45.57478, 8.51201],
  "Baressa": [39.71468, 8.87405],
  "Barete": [42.45096, 13.28127],
  "Barga": [44.07305, 10.48478],
  "Bargagli": [44.44464, 9.08834],
  "Barge": [44.72522, 7.32339],
  "Barghe": [45.678, 10.40613],
  "Bari": [41.1256, 16.86737],
  "Bari Sardo": [39.84013, 9.6458],
  "Bariano": [45.51478, 9.70702],
  "Baricella": [44.64706, 11.53455],
  "Barile": [40.94608, 15.67273],
  "Barisciano": [42.32702, 13.59078],
  "Barlassina": [45.65612, 9.13051],
  "Barletta": [41.31956, 16.27718],
  "Barni": [45.91088, 9.26397],
  "Barolo": [44.60988, 7.94181],
  "Barone Canavese": [45.32773, 7.87056],
  "Baronissi": [40.74643, 14.77021],
  "Barrafranca": [37.37285, 14.20388],
  "Barrali": [39.47571, 9.10256],
  "Barrea": [41.75758, 13.99153],
  "Barumini": [39.70479, 9.00284],
  "Barzago": [45.75522, 9.31649],
  "Barzana": [45.73365, 9.56704],
  "Barzanò": [45.73464, 9.31678],
  "Barzio": [45.94647, 9.46834],
  "Basaluzzo": [44.76829, 8.70593],
  "Bascapè": [45.30464, 9.31542],
  "Baschi": [42.67013, 12.21628],
  "Basciano": [42.59571, 13.73863],
  "Baselga di Pinè": [46.12999, 11.24453],
  "Baselice": [41.39742, 14.97257],
  "Basiano": [45.57442, 9.4682],
  "Basicò": [38.0616, 15.06175],
  "Basiglio": [45.36272, 9.16147],
  "Basiliano": [46.0162, 13.1067],
  "Bassano Bresciano": [45.33019, 10.12685],
  "Bassano del Grappa": [45.76714, 11.73417],
  "Bassano in Teverina": [42.46308, 12.3084],
  "Bassano Romano": [42.21828, 12.19266],
  "Bassiano": [41.54934, 13.03225],
  "Bassignana": [45.00321, 8.73594],
  "Bastia Mondovì": [44.44139, 7.89332],
  "Bastia Umbra": [43.06651, 12.54926],
  "Bastida Pancarana": [45.0863, 9.09155],
  "Bastiglia": [44.72645, 10.99981],
  "Battaglia Terme": [45.28889, 11.77375],
  "Battifollo": [44.31917, 8.00948],
  "Battipaglia": [40.60768, 14.98344],
  "Battuda": [45.27358, 9.07741],
  "Baucina": [37.92513, 13.53724],
  "Bauladu": [40.01968, 8.67137],
  "Baunei": [40.03178, 9.66359],
  "Baveno": [45.90892, 8.50483],
  "Bedero Valcuvia": [45.91264, 8.79441],
  "Bedizzole": [45.51036, 10.42278],
  "Bedollo": [46.16142, 11.30322],
  "Bedonia": [44.5035, 9.63131],
  "Bedulita": [45.79064, 9.55092],
  "Bee": [45.96273, 8.58023],
  "Beinasco": [45.02208, 7.57916],
  "Beinette": [44.36567, 7.64571],
  "Belcastro": [39.01741, 16.78755],
  "Belfiore": [45.38037, 11.20842],
  "Belforte all'Isauro": [43.71701, 12.37563],
  "Belforte del Chienti": [43.16425, 13.23773],
  "Belforte Monferrato": [44.62437, 8.6616],
  "Belgioioso": [45.16274, 9.31603],
  "Belgirate": [45.83835, 8.57159],
  "Bella": [40.75859, 15.53779],
  "Bellagio": [45.9627, 9.2459],
  "Bellano": [46.04329, 9.30277],
  "Bellante": [42.7446, 13.80536],
  "Bellaria-Igea Marina": [44.1476, 12.45806],
  "Bellegra": [41.88108, 13.02805],
  "Bellino": [44.58061, 7.01716],
  "Bellinzago Lombardo": [45.54083, 9.44597],
  "Bellinzago Novarese": [45.5703, 8.63973],
  "Bellizzi": [40.62219, 14.94603],
  "Bellona": [41.16033, 14.22849],
  "Bellosguardo": [40.42182, 15.31021],
  "Belluno": [46.13838, 12.21704],
  "Bellusco": [45.61856, 9.41779],
  "Belmonte Calabro": [39.16056, 16.0779],
  "Belmonte Castello": [41.57826, 13.81174],
  "Belmonte del Sannio": [41.8251, 14.42349],
  "Belmonte in Sabina": [42.31826, 12.89269],
  "Belmonte Mezzagno": [38.04835, 13.39011],
  "Belmonte Piceno": [43.09152, 13.53882],
  "Belpasso": [37.59139, 14.97705],
  "Belsito": [39.17401, 16.28795],
  "Belvedere di Spinello": [39.21368, 16.88684],
  "Belvedere Langhe": [44.49457, 7.97417],
  "Belvedere Marittimo": [39.61804, 15.86132],
  "Belvedere Ostrense": [43.58044, 13.16682],
  "Belveglio": [44.83049, 8.3301],
  "Belvì": [39.96179, 9.18408],
  "Bema": [46.10832, 9.56456],
  "Bene Lario": [46.02863, 9.1836],
  "Bene Vagienna": [44.54524, 7.83283],
  "Benestare": [38.18656, 16.13932],
  "Benetutti": [40.45579, 9.16828],
  "Benevello": [44.62819, 8.10592],
  "Benevento": [41.1297, 14.78152],
  "Benna": [45.5124, 8.12515],
  "Bentivoglio": [44.63515, 11.41786],
  "Berbenno": [45.81171, 9.56832],
  "Berbenno di Valtellina": [46.16872, 9.74319],
  "Berceto": [44.50953, 9.9894],
  "Berchidda": [40.78635, 9.16401],
  "Beregazzo con Figliaro": [45.77588, 8.95088],
  "Bereguardo": [45.25745, 9.0245],
  "Bergamasco": [44.82711, 8.45521],
  "Bergamo": [45.69441, 9.66842],
  "Bergantino": [45.06038, 11.25302],
  "Bergeggi": [44.24906, 8.4441],
  "Bergolo": [44.54801, 8.18353],
  "Berlingo": [45.50277, 10.03295],
  "Bernalda": [40.40818, 16.68637],
  "Bernareggio": [45.65003, 9.40568],
  "Bernate Ticino": [45.47933, 8.81593],
  "Bernezzo": [44.38861, 7.43531],
  "Bertinoro": [44.14891, 12.13425],
  "Bertiolo": [45.9433, 13.05531],
  "Bertonico": [45.23389, 9.6686],
  "Berzano di San Pietro": [45.09491, 7.95405],
  "Berzano di Tortona": [44.87646, 8.9506],
  "Berzo Demo": [46.09287, 10.33301],
  "Berzo Inferiore": [45.93226, 10.27867],
  "Berzo San Fermo": [45.71817, 9.9003],
  "Besana in Brianza": [45.70076, 9.28851],
  "Besano": [45.88923, 8.88995],
  "Besate": [45.31225, 8.96732],
  "Besenello": [45.94569, 11.10619],
  "Besenzone": [44.98757, 9.95362],
  "Besnate": [45.70035, 8.7694],
  "Besozzo": [45.85162, 8.66515],
  "Bessude": [40.55568, 8.72722],
  "Bettola": [44.77616, 9.60538],
  "Bettona": [43.01296, 12.48493],
  "Beura-Cardezza": [46.07888, 8.29934],
  "Bevagna": [42.93394, 12.60913],
  "Beverino": [44.19407, 9.76928],
  "Bevilacqua": [45.23345, 11.39819],
  "Biancavilla": [37.64126, 14.86954],
  "Bianchi": [39.10081, 16.41066],
  "Bianco": [38.08886, 16.14854],
  "Biandrate": [45.45378, 8.46371],
  "Biandronno": [45.81939, 8.71233],
  "Bianzano": [45.77338, 9.91779],
  "Bianzone": [46.18393, 10.1093],
  "Bianzè": [45.30738, 8.12006],
  "Biassono": [45.62857, 9.27623],
  "Bibbiano": [44.66326, 10.47337],
  "Bibbiena": [43.69446, 11.81814],
  "Bibbona": [43.26944, 10.59818],
  "Bibiana": [44.79758, 7.28979],
  "Biccari": [41.39744, 15.1945],
  "Bicinicco": [45.931, 13.24991],
  "Bidonì": [40.113, 8.93512],
  "Biella": [45.56651, 8.05408],
  "Bienno": [45.93555, 10.29547],
  "Bieno": [46.08025, 11.55369],
  "Bientina": [43.71011, 10.61984],
  "Binago": [45.78469, 8.92257],
  "Binasco": [45.3322, 9.09966],
  "Binetto": [41.0242, 16.70846],
  "Bioglio": [45.60759, 8.13026],
  "Bionaz": [45.87407, 7.42307],
  "Bione": [45.67403, 10.34057],
  "Birori": [40.26605, 8.81549],
  "Bisaccia": [41.01318, 15.37502],
  "Bisacquino": [37.70579, 13.25873],
  "Bisceglie": [41.24246, 16.50261],
  "Bisegna": [41.92099, 13.75749],
  "Bisenti": [42.52878, 13.80369],
  "Bisignano": [39.51263, 16.28652],
  "Bistagno": [44.66179, 8.36859],
  "Bisuschio": [45.87241, 8.87036],
  "Bitetto": [41.03868, 16.74785],
  "Bitonto": [41.11002, 16.69432],
  "Bitritto": [41.04107, 16.8258],
  "Bitti": [40.47506, 9.38148],
  "Bivona": [37.61811, 13.4404],
  "Bivongi": [38.48167, 16.45339],
  "Bizzarone": [45.83504, 8.94596],
  "Bleggio Superiore": [46.02533, 10.83706],
  "Blello": [45.83692, 9.56434],
  "Blera": [42.27419, 12.02576],
  "Blessagno": [45.95989, 9.09739],
  "Blevio": [45.84064, 9.10486],
  "Blufi": [37.75231, 14.07674],
  "Boara Pisani": [45.10729, 11.78348],
  "Bobbio": [44.76641, 9.3866],
  "Bobbio Pellice": [44.80771, 7.1179],
  "Boca": [45.67829, 8.40871],
  "Bocchigliero": [39.41776, 16.75628],
  "Boccioleto": [45.82999, 8.11329],
  "Bocenago": [46.11843, 10.75909],
  "Bodio Lomnago": [45.78989, 8.75143],
  "Boffalora d'Adda": [45.35863, 9.49469],
  "Boffalora sopra Ticino": [45.46436, 8.82849],
  "Bogliasco": [44.37822, 9.06978],
  "Bognanco": [46.12278, 8.2064],
  "Bogogno": [45.66717, 8.5345],
  "Boissano": [44.13424, 8.22123],
  "Bojano": [41.48282, 14.47144],
  "Bolano": [44.18887, 9.89529],
  "Bolgare": [45.63186, 9.82024],
  "Bollate": [45.54384, 9.11766],
  "Bollengo": [45.47336, 7.94535],
  "Bologna": [44.49437, 11.34172],
  "Bolognano": [42.21702, 13.95982],
  "Bolognetta": [37.96472, 13.45568],
  "Bolognola": [42.99426, 13.22685],
  "Bolotana": [40.32786, 8.95889],
  "Bolsena": [42.64474, 11.98759],
  "Boltiere": [45.59978, 9.57823],
  "Bolzano": [46.49933, 11.35662],
  "Bolzano Novarese": [45.76283, 8.44415],
  "Bolzano Vicentino": [45.60073, 11.62207],
  "Bomarzo": [42.49102, 12.25137],
  "Bomba": [42.03518, 14.36623],
  "Bompensiere": [37.47263, 13.78064],
  "Bompietro": [37.74708, 14.09952],
  "Bomporto": [44.72738, 11.04279],
  "Bonarcado": [40.10082, 8.65453],
  "Bonassola": [44.18336, 9.5841],
  "Bonate Sopra": [45.68309, 9.55924],
  "Bonate Sotto": [45.66636, 9.56131],
  "Bonavigo": [45.25754, 11.27971],
  "Bondeno": [44.88522, 11.41846],
  "Bondone": [45.80542, 10.55126],
  "Bonea": [41.07494, 14.61856],
  "Bonefro": [41.70269, 14.9342],
  "Bonemerse": [45.11405, 10.07837],
  "Bonifati": [39.58691, 15.90507],
  "Bonito": [41.10231, 15.00287],
  "Bonnanaro": [40.53246, 8.76638],
  "Bono": [40.41691, 9.02975],
  "Bonorva": [40.41698, 8.76853],
  "Bonvicino": [44.50362, 8.01592],
  "Borbona": [42.51225, 13.13255],
  "Borca di Cadore": [46.43812, 12.21877],
  "Bordano": [46.31538, 13.10601],
  "Bordighera": [43.77976, 7.67189],
  "Bordolano": [45.29285, 9.98705],
  "Bore": [44.71901, 9.79436],
  "Boretto": [44.90454, 10.55344],
  "Borgarello": [45.23943, 9.14069],
  "Borgaro Torinese": [45.15198, 7.65789],
  "Borgetto": [38.04642, 13.14274],
  "Borghetto d'Arroscia": [44.05747, 7.98183],
  "Borghetto di Borbera": [44.73105, 8.94535],
  "Borghetto di Vara": [44.22352, 9.72161],
  "Borghetto Lodigiano": [45.21274, 9.49802],
  "Borghetto Santo Spirito": [44.11538, 8.24199],
  "Borghi": [44.03146, 12.35457],
  "Borgia": [38.82733, 16.51425],
  "Borgiallo": [45.41681, 7.66773],
  "Borgio Verezzi": [44.15987, 8.30456],
  "Borgo a Mozzano": [43.97852, 10.5436],
  "Borgo Chiese": [45.8906, 10.6013],
  "Borgo d'Ale": [45.34992, 8.05373],
  "Borgo di Terzo": [45.72096, 9.89141],
  "Borgo Lares": [46.0352, 10.7521],
  "Borgo Pace": [43.65817, 12.29462],
  "Borgo Priolo": [44.96651, 9.14841],
  "Borgo San Dalmazzo": [44.32876, 7.48746],
  "Borgo San Giacomo": [45.35012, 9.97102],
  "Borgo San Giovanni": [45.27564, 9.42534],
  "Borgo San Lorenzo": [43.95479, 11.38768],
  "Borgo San Martino": [45.08909, 8.52362],
  "Borgo San Siro": [45.23484, 8.91269],
  "Borgo Ticino": [45.68807, 8.60392],
  "Borgo Tossignano": [44.27731, 11.58923],
  "Borgo Val di Taro": [44.48803, 9.76767],
  "Borgo Valsugana": [46.05304, 11.45649],
  "Borgo Velino": [42.4056, 13.05849],
  "Borgo Vercelli": [45.35716, 8.46637],
  "Borgo Virgilio": [45.088, 10.775],
  "Borgofranco d'Ivrea": [45.51301, 7.85852],
  "Borgolavezzaro": [45.31838, 8.69927],
  "Borgomale": [44.62044, 8.13276],
  "Borgomanero": [45.69887, 8.46299],
  "Borgomaro": [43.9756, 7.9449],
  "Borgomasino": [45.36155, 7.9888],
  "Borgomezzavalle": [46.0532, 8.1968],
  "Borgone Susa": [45.12314, 7.24121],
  "Borgonovo Val Tidone": [45.01804, 9.44686],
  "Borgoratto Alessandrino": [44.83649, 8.53942],
  "Borgoratto Mormorolo": [44.93011, 9.19322],
  "Borgoricco": [45.53282, 11.9685],
  "Borgorose": [42.19339, 13.23257],
  "Borgosatollo": [45.47508, 10.23604],
  "Borgosesia": [45.71673, 8.27641],
  "Bormida": [44.27866, 8.23261],
  "Bormio": [46.47016, 10.3756],
  "Bornasco": [45.26638, 9.21836],
  "Borno": [45.94679, 10.20581],
  "Boroneddu": [40.11274, 8.86988],
  "Borore": [40.21541, 8.80332],
  "Borrello": [41.92041, 14.30326],
  "Borriana": [45.50597, 8.03958],
  "Borso del Grappa": [45.82099, 11.79931],
  "Bortigali": [40.28295, 8.83677],
  "Bortigiadas": [40.89145, 9.04327],
  "Borutta": [40.52228, 8.74374],
  "Borzonasca": [44.4222, 9.3868],
  "Bosa": [40.29915, 8.49783],
  "Bosaro": [45.00062, 11.76455],
  "Boschi Sant'Anna": [45.21946, 11.35793],
  "Bosco Chiesanuova": [45.62213, 11.02942],
  "Bosco Marengo": [44.82209, 8.67599],
  "Bosconero": [45.26856, 7.76507],
  "Boscoreale": [40.77532, 14.47527],
  "Boscotrecase": [40.77627, 14.46107],
  "Bosia": [44.60247, 8.1462],
  "Bosio": [44.64779, 8.79191],
  "Bosisio Parini": [45.80042, 9.28792],
  "Bosnasco": [45.064, 9.3569],
  "Bossico": [45.82701, 10.04487],
  "Bossolasco": [44.52679, 8.0575],
  "Botricello": [38.93734, 16.86127],
  "Botrugno": [40.06444, 18.32464],
  "Bottanuco": [45.64081, 9.50359],
  "Botticino": [45.5433, 10.3233],
  "Bottidda": [40.39067, 9.00697],
  "Bova": [37.99457, 15.9318],
  "Bova Marina": [37.93239, 15.92081],
  "Bovalino": [38.14669, 16.17412],
  "Bovegno": [45.79235, 10.27222],
  "Boves": [44.32982, 7.55199],
  "Bovezzo": [45.59163, 10.24349],
  "Boville Ernica": [41.64313, 13.47086],
  "Bovino": [41.24924, 15.34167],
  "Bovisio-Masciago": [45.61109, 9.14866],
  "Bovolenta": [45.26868, 11.94209],
  "Bovolone": [45.25799, 11.11706],
  "Bozzole": [45.06788, 8.60488],
  "Bozzolo": [45.10531, 10.48452],
  "Bra": [44.69818, 7.85475],
  "Bracca": [45.82266, 9.70781],
  "Bracciano": [42.10335, 12.17562],
  "Bracigliano": [40.82474, 14.71105],
  "Braies": [46.71973, 12.13257],
  "Brallo di Pregola": [44.73846, 9.28189],
  "Brancaleone": [37.96702, 16.10305],
  "Brandico": [45.45427, 10.05092],
  "Brandizzo": [45.17765, 7.84148],
  "Branzi": [46.00495, 9.75868],
  "Braone": [45.99021, 10.34243],
  "Brebbia": [45.82857, 8.64987],
  "Breda di Piave": [45.7241, 12.331],
  "Bregano": [45.82367, 8.69247],
  "Breganze": [45.70826, 11.56531],
  "Bregnano": [45.69896, 9.06252],
  "Brembate": [45.60388, 9.55516],
  "Brembate di Sopra": [45.71628, 9.57759],
  "Brembio": [45.2151, 9.5697],
  "Breme": [45.1279, 8.62332],
  "Brendola": [45.46936, 11.45522],
  "Brenna": [45.74164, 9.18775],
  "Brennero": [46.93772, 11.44323],
  "Breno": [45.95601, 10.30204],
  "Brenta": [45.89521, 8.68415],
  "Brentino Belluno": [45.65617, 10.89346],
  "Brentonico": [45.81887, 10.95493],
  "Brenzone sul Garda": [45.7089, 10.76747],
  "Brescello": [44.90154, 10.51601],
  "Brescia": [45.53993, 10.2191],
  "Bresimo": [46.41044, 10.96861],
  "Bressana Bottarone": [45.07364, 9.13508],
  "Bressanone": [46.71644, 11.65699],
  "Bressanvido": [45.64633, 11.63337],
  "Bresso": [45.5376, 9.18763],
  "Brezzo di Bedero": [45.97789, 8.71839],
  "Briaglia": [44.39512, 7.87699],
  "Briatico": [38.72445, 16.03416],
  "Bricherasio": [44.82558, 7.30289],
  "Brienno": [45.91174, 9.13139],
  "Brienza": [40.47737, 15.62813],
  "Briga Alta": [44.08322, 7.75076],
  "Briga Novarese": [45.73138, 8.45159],
  "Brignano Gera d'Adda": [45.54451, 9.6479],
  "Brignano-Frascata": [44.81195, 9.0408],
  "Brindisi": [40.63849, 17.94602],
  "Brindisi Montagna": [40.6099, 15.94007],
  "Brinzio": [45.88914, 8.78681],
  "Briona": [45.5422, 8.47982],
  "Brione": [45.64071, 10.14981],
  "Briosco": [45.70929, 9.2372],
  "Brisighella": [44.22135, 11.76902],
  "Brissago-Valtravaglia": [45.94962, 8.74641],
  "Brissogne": [45.72718, 7.40457],
  "Brittoli": [42.31648, 13.86094],
  "Brivio": [45.74212, 9.44833],
  "Broccostella": [41.70351, 13.63446],
  "Brogliano": [45.5884, 11.36445],
  "Brognaturo": [38.60153, 16.34248],
  "Brolo": [38.15685, 14.82772],
  "Brondello": [44.60006, 7.40514],
  "Broni": [45.06197, 9.2613],
  "Bronte": [37.78752, 14.8329],
  "Bronzolo": [46.4046, 11.31989],
  "Brossasco": [44.5703, 7.36044],
  "Brosso": [45.49276, 7.80333],
  "Brovello-Carpugnino": [45.84274, 8.53319],
  "Brozolo": [45.11742, 8.07128],
  "Brugherio": [45.55103, 9.30006],
  "Brugine": [45.2983, 11.99269],
  "Brugnato": [44.23687, 9.72502],
  "Brugnera": [45.89919, 12.5368],
  "Bruino": [45.02023, 7.46769],
  "Brumano": [45.85463, 9.50061],
  "Brunate": [45.81977, 9.09642],
  "Brunello": [45.76616, 8.7958],
  "Brunico": [46.79738, 11.9373],
  "Bruno": [44.79063, 8.44027],
  "Brusaporto": [45.67083, 9.76126],
  "Brusasco": [45.15596, 8.06009],
  "Brusciano": [40.92061, 14.42254],
  "Brusimpiano": [45.94719, 8.8896],
  "Brusnengo": [45.59613, 8.25254],
  "Brusson": [45.75862, 7.73281],
  "Bruzolo": [45.14312, 7.19398],
  "Bruzzano Zeffirio": [38.01262, 16.08134],
  "Bubbiano": [45.32733, 9.01337],
  "Bubbio": [44.66384, 8.29361],
  "Buccheri": [37.12651, 14.85047],
  "Bucchianico": [42.30434, 14.1807],
  "Bucciano": [41.07705, 14.56997],
  "Buccinasco": [45.42127, 9.10758],
  "Buccino": [40.63106, 15.36732],
  "Bucine": [43.47908, 11.61688],
  "Buddusò": [40.57857, 9.26086],
  "Budoia": [46.04292, 12.53265],
  "Budoni": [40.70672, 9.69976],
  "Budrio": [44.53752, 11.53564],
  "Buggerru": [39.397, 8.40083],
  "Buggiano": [43.87993, 10.72754],
  "Buglio in Monte": [46.18335, 9.67539],
  "Bugnara": [42.02216, 13.85871],
  "Buguggiate": [45.78526, 8.80676],
  "Buja": [46.20893, 13.12574],
  "Bulciago": [45.75086, 9.28389],
  "Bulgarograsso": [45.74813, 9.01101],
  "Bultei": [40.45708, 9.06149],
  "Bulzi": [40.84804, 8.82973],
  "Buonabitacolo": [40.26881, 15.61936],
  "Buonalbergo": [41.22131, 14.97735],
  "Buonconvento": [43.13793, 11.48191],
  "Buonvicino": [39.68892, 15.88391],
  "Burago di Molgora": [45.59592, 9.37907],
  "Burcei": [39.34651, 9.36159],
  "Burgio": [37.59887, 13.28954],
  "Burgos": [40.39062, 8.99369],
  "Buriasco": [44.87336, 7.41192],
  "Burolo": [45.48412, 7.93206],
  "Buronzo": [45.48212, 8.26833],
  "Busachi": [40.03329, 8.89808],
  "Busalla": [44.5708, 8.94498],
  "Busano": [45.32884, 7.65574],
  "Busca": [44.5137, 7.47352],
  "Buscate": [45.546, 8.81259],
  "Buscemi": [37.08523, 14.88416],
  "Buseto Palizzolo": [38.01217, 12.71132],
  "Busnago": [45.61717, 9.46619],
  "Bussero": [45.53792, 9.37205],
  "Busseto": [44.98133, 10.04132],
  "Bussi sul Tirino": [42.2104, 13.82665],
  "Busso": [41.55479, 14.5621],
  "Bussolengo": [45.47459, 10.84642],
  "Bussoleno": [45.13728, 7.14932],
  "Busto Arsizio": [45.61508, 8.85494],
  "Busto Garolfo": [45.54606, 8.88341],
  "Butera": [37.18643, 14.18628],
  "Buti": [43.72731, 10.58736],
  "Buttapietra": [45.34199, 10.9985],
  "Buttigliera Alta": [45.06702, 7.43678],
  "Buttigliera d'Asti": [45.02255, 7.95051],
  "Buttrio": [46.01309, 13.3304],
  "Cabella Ligure": [44.67308, 9.09629],
  "Cabiate": [45.6732, 9.1667],
  "Cabras": [39.92991, 8.53119],
  "Caccamo": [37.9318, 13.66353],
  "Caccuri": [39.2272, 16.78029],
  "Cadegliano-Viconago": [45.95878, 8.84467],
  "Cadelbosco di Sopra": [44.76293, 10.59438],
  "Cadeo": [44.96546, 9.85224],
  "Caderzone Terme": [46.12941, 10.75692],
  "Cadoneghe": [45.4478, 11.91007],
  "Cadorago": [45.7239, 9.03375],
  "Caerano di San Marco": [45.78527, 12.00116],
  "Cafasse": [45.24471, 7.51812],
  "Caggiano": [40.56716, 15.49648],
  "Cagli": [43.54638, 12.64801],
  "Cagliari": [39.21531, 9.11062],
  "Caglio": [45.87057, 9.23632],
  "Cagnano Amiterno": [42.45911, 13.2246],
  "Cagnano Varano": [41.82868, 15.7726],
  "Caianello": [41.30427, 14.07807],
  "Caiazzo": [41.17756, 14.36567],
  "Caines": [46.69652, 11.1753],
  "Caino": [45.61251, 10.31576],
  "Caiolo": [46.15232, 9.81706],
  "Cairano": [40.89635, 15.37015],
  "Cairate": [45.69203, 8.87081],
  "Cairo Montenotte": [44.39972, 8.27417],
  "Caivano": [40.95676, 14.30106],
  "Calabritto": [40.7836, 15.21975],
  "Calalzo di Cadore": [46.44728, 12.38057],
  "Calamandrana": [44.73655, 8.33563],
  "Calamonaci": [37.52534, 13.2909],
  "Calangianus": [40.92315, 9.19233],
  "Calanna": [38.18257, 15.72263],
  "Calasca-Castiglione": [46.00382, 8.17024],
  "Calascibetta": [37.58956, 14.27309],
  "Calascio": [42.32552, 13.6948],
  "Calasetta": [39.10727, 8.3654],
  "Calatabiano": [37.82333, 15.22775],
  "Calatafimi-Segesta": [37.91416, 12.86271],
  "Calcata": [42.21976, 12.42572],
  "Calceranica al Lago": [46.00375, 11.24238],
  "Calci": [43.72555, 10.51569],
  "Calciano": [40.58737, 16.19011],
  "Calcinaia": [43.68299, 10.61567],
  "Calcinate": [45.61977, 9.80155],
  "Calcinato": [45.45747, 10.41652],
  "Calcio": [45.50766, 9.85508],
  "Calco": [45.72538, 9.41788],
  "Caldaro sulla strada del vino": [46.41317, 11.24516],
  "Caldarola": [43.13845, 13.22627],
  "Calderara di Reno": [44.56608, 11.27202],
  "Caldes": [46.36513, 10.94281],
  "Caldiero": [45.4121, 11.18378],
  "Caldogno": [45.61198, 11.50046],
  "Caldonazzo": [45.9914, 11.26185],
  "Calendasco": [45.08774, 9.59382],
  "Calenzano": [43.86508, 11.16719],
  "Calestano": [44.60067, 10.12215],
  "Calice al Cornoviglio": [44.24248, 9.83583],
  "Calice Ligure": [44.20492, 8.29427],
  "Calimera": [40.25121, 18.28006],
  "Calitri": [40.90045, 15.43866],
  "Calizzano": [44.2352, 8.11537],
  "Callabiana": [45.63372, 8.09074],
  "Calliano (AT)": [45.00626, 8.25733],
  "Calliano (TN)": [45.93427, 11.09433],
  "Calolziocorte": [45.80179, 9.43211],
  "Calopezzati": [39.55889, 16.80171],
  "Calosso": [44.73948, 8.22719],
  "Caloveto": [39.50754, 16.75764],
  "Caltabellotta": [37.5769, 13.21565],
  "Caltagirone": [37.23809, 14.51274],
  "Caltanissetta": [37.49213, 14.06185],
  "Caltavuturo": [37.82031, 13.89007],
  "Caltignaga": [45.51709, 8.58791],
  "Calto": [44.99169, 11.356],
  "Caltrano": [45.77031, 11.46056],
  "Calusco d'Adda": [45.68835, 9.47138],
  "Caluso": [45.30786, 7.89151],
  "Calvagese della Riviera": [45.53922, 10.44602],
  "Calvanico": [40.77619, 14.82939],
  "Calvatone": [45.12883, 10.44206],
  "Calvello": [40.47525, 15.84722],
  "Calvene": [45.76589, 11.51223],
  "Calvenzano": [45.49463, 9.59816],
  "Calvera": [40.14871, 16.14362],
  "Calvi": [41.07243, 14.86691],
  "Calvi dell'Umbria": [42.40114, 12.56679],
  "Calvi Risorta": [41.2156, 14.13101],
  "Calvignano": [44.98267, 9.16884],
  "Calvignasco": [45.3318, 9.02087],
  "Calvisano": [45.34908, 10.34288],
  "Calvizzano": [40.90752, 14.18959],
  "Camagna Monferrato": [45.01785, 8.43034],
  "Camaiore": [43.9386, 10.30417],
  "Camandona": [45.64171, 8.10001],
  "Camastra": [37.25216, 13.79377],
  "Cambiago": [45.57337, 9.42417],
  "Cambiano": [44.97346, 7.77932],
  "Cambiasca": [45.96429, 8.54113],
  "Camburzano": [45.54421, 8.00331],
  "Camerana": [44.42266, 8.1408],
  "Camerano": [43.53093, 13.55303],
  "Camerano Casasco": [44.98866, 8.09088],
  "Camerata Cornello": [45.89956, 9.65566],
  "Camerata Nuova": [42.01845, 13.10813],
  "Camerata Picena": [43.5782, 13.35275],
  "Cameri": [45.50102, 8.66224],
  "Camerino": [43.13536, 13.06766],
  "Camerota": [40.03319, 15.37016],
  "Camigliano": [41.18289, 14.21036],
  "Camini": [38.43203, 16.48173],
  "Camino": [45.16221, 8.28704],
  "Camino al Tagliamento": [45.92745, 12.94465],
  "Camisano": [45.44259, 9.74619],
  "Camisano Vicentino": [45.52207, 11.71332],
  "Cammarata": [37.63273, 13.63798],
  "Camogli": [44.3468, 9.15714],
  "Campagna": [40.66561, 15.10702],
  "Campagna Lupia": [45.35344, 12.09813],
  "Campagnano di Roma": [42.14082, 12.38325],
  "Campagnatico": [42.88279, 11.27494],
  "Campagnola Cremasca": [45.39913, 9.66944],
  "Campagnola Emilia": [44.84131, 10.75917],
  "Campana": [39.40983, 16.82602],
  "Camparada": [45.655, 9.32238],
  "Campegine": [44.78138, 10.53112],
  "Campello sul Clitunno": [42.82008, 12.77693],
  "Campertogno": [45.79867, 8.03217],
  "Campi Bisenzio": [43.82057, 11.13784],
  "Campi Salentina": [40.39918, 18.0203],
  "Campiglia Cervo": [45.6577, 8.0121],
  "Campiglia dei Berici": [45.33669, 11.53902],
  "Campiglia Marittima": [43.05903, 10.61688],
  "Campiglione Fenile": [44.80212, 7.32504],
  "Campione d'Italia": [45.97008, 8.97075],
  "Campitello di Fassa": [46.47575, 11.74009],
  "Campli": [42.72636, 13.68636],
  "Campo Calabro": [38.2147, 15.65805],
  "Campo di Giove": [42.01193, 14.04454],
  "Campo di Trens": [46.87112, 11.48395],
  "Campo Ligure": [44.53839, 8.69763],
  "Campo nell'Elba": [42.74484, 10.23363],
  "Campo San Martino": [45.54786, 11.81195],
  "Campo Tures": [46.91992, 11.95188],
  "Campobasso": [41.55775, 14.65916],
  "Campobello di Licata": [37.25978, 13.91889],
  "Campobello di Mazara": [37.63459, 12.74409],
  "Campochiaro": [41.4487, 14.50564],
  "Campodarsego": [45.50231, 11.90728],
  "Campodenno": [46.25731, 11.03337],
  "Campodimele": [41.3898, 13.53023],
  "Campodipietra": [41.55759, 14.74693],
  "Campodolcino": [46.40213, 9.35431],
  "Campodoro": [45.49316, 11.75165],
  "Campofelice di Fitalia": [37.82622, 13.48457],
  "Campofelice di Roccella": [37.99201, 13.88585],
  "Campofilone": [43.07933, 13.81454],
  "Campofiorito": [37.75326, 13.26919],
  "Campoformido": [46.01983, 13.16005],
  "Campofranco": [37.51201, 13.71255],
  "Campogalliano": [44.69044, 10.84126],
  "Campolattaro": [41.28693, 14.73044],
  "Campoli Appennino": [41.73786, 13.67882],
  "Campoli del Monte Taburno": [41.13074, 14.64649],
  "Campolieto": [41.63517, 14.76695],
  "Campolongo Maggiore": [45.33141, 12.04809],
  "Campolongo Tapogliano": [45.86433, 13.39405],
  "Campomaggiore": [40.56711, 16.07368],
  "Campomarino": [41.95271, 15.03586],
  "Campomorone": [44.5067, 8.89268],
  "Camponogara": [45.38509, 12.07262],
  "Campora": [40.30525, 15.29275],
  "Camporeale": [37.897, 13.09531],
  "Camporgiano": [44.15865, 10.3338],
  "Camporosso": [43.81518, 7.62833],
  "Camporotondo di Fiastrone": [43.1318, 13.26553],
  "Camporotondo Etneo": [37.5674, 15.00596],
  "Camposampiero": [45.57184, 11.93199],
  "Camposano": [40.9559, 14.52498],
  "Camposanto": [44.7879, 11.13828],
  "Campospinoso": [45.0936, 9.24669],
  "Campotosto": [42.55736, 13.36989],
  "Camugnano": [44.16897, 11.08739],
  "Canal San Bovo": [46.15631, 11.73138],
  "Canale": [44.79721, 7.99141],
  "Canale d'Agordo": [46.36047, 11.91485],
  "Canale Monterano": [42.13667, 12.10353],
  "Canaro": [44.93535, 11.67653],
  "Canazei": [46.47683, 11.7713],
  "Cancellara": [40.73079, 15.92512],
  "Cancello ed Arnone": [41.07353, 14.02597],
  "Canda": [45.0339, 11.50859],
  "Candela": [41.13773, 15.51396],
  "Candelo": [45.5463, 8.1127],
  "Candia Canavese": [45.32817, 7.88661],
  "Candia Lomellina": [45.17474, 8.59816],
  "Candiana": [45.22041, 11.99123],
  "Candida": [40.94131, 14.87372],
  "Candidoni": [38.50499, 16.08572],
  "Candiolo": [44.96027, 7.60121],
  "Canegrate": [45.57255, 8.92457],
  "Canelli": [44.71988, 8.2882],
  "Canepina": [42.3808, 12.23365],
  "Caneva": [45.96855, 12.44903],
  "Canicattini Bagni": [37.03499, 15.06174],
  "Canicattì": [37.36024, 13.84999],
  "Canino": [42.46417, 11.74907],
  "Canischio": [45.37435, 7.59522],
  "Canistro": [41.94121, 13.41146],
  "Canna": [40.09477, 16.50524],
  "Cannalonga": [40.24358, 15.29261],
  "Cannara": [42.99544, 12.58326],
  "Cannero Riviera": [46.02206, 8.67933],
  "Canneto Pavese": [45.05116, 9.28098],
  "Canneto sull'Oglio": [45.15029, 10.37541],
  "Cannobio": [46.06172, 8.70019],
  "Cannole": [40.16786, 18.36351],
  "Canolo": [38.31514, 16.20037],
  "Canonica d'Adda": [45.57456, 9.54176],
  "Canosa di Puglia": [41.22539, 16.06264],
  "Canosa Sannita": [42.29529, 14.30187],
  "Canosio": [44.45533, 7.08139],
  "Canossa": [44.5925, 10.40842],
  "Cansano": [42.00461, 14.01096],
  "Cantagallo": [44.02827, 11.10781],
  "Cantalice": [42.4683, 12.90355],
  "Cantalupa": [44.94031, 7.3326],
  "Cantalupo in Sabina": [42.30787, 12.64677],
  "Cantalupo Ligure": [44.71897, 9.04436],
  "Cantalupo nel Sannio": [41.52197, 14.3924],
  "Cantarana": [44.90038, 8.03072],
  "Cantello": [45.82106, 8.89697],
  "Canterano": [41.94185, 13.03757],
  "Cantiano": [43.47366, 12.62723],
  "Cantoira": [45.34324, 7.38168],
  "Cantù": [45.73939, 9.12658],
  "Canzano": [42.64718, 13.80311],
  "Canzo": [45.85004, 9.2735],
  "Caorle": [45.59802, 12.88762],
  "Caorso": [45.04961, 9.87193],
  "Capaccio Paestum": [40.42303, 15.08075],
  "Capaci": [38.17084, 13.23935],
  "Capalbio": [42.45326, 11.42201],
  "Capannoli": [43.58387, 10.67865],
  "Capannori": [43.84892, 10.5748],
  "Capena": [42.14078, 12.53928],
  "Capergnanica": [45.33808, 9.64415],
  "Capestrano": [42.26742, 13.76828],
  "Capiago Intimiano": [45.77212, 9.12431],
  "Capistrano": [38.69067, 16.28869],
  "Capistrello": [41.96555, 13.38967],
  "Capitignano": [42.52023, 13.3008],
  "Capizzi": [37.84887, 14.47842],
  "Capizzone": [45.78452, 9.56853],
  "Capo d'Orlando": [38.1603, 14.74393],
  "Capo di Ponte": [46.03, 10.3428],
  "Capodimonte": [42.54894, 11.9063],
  "Capodrise": [41.04196, 14.30075],
  "Capoliveri": [42.74313, 10.38033],
  "Capolona": [43.56343, 11.85984],
  "Caponago": [45.56531, 9.37703],
  "Caporciano": [42.25186, 13.67134],
  "Caposele": [40.81363, 15.22615],
  "Capoterra": [39.17395, 8.9745],
  "Capovalle": [45.75407, 10.54484],
  "Cappadocia": [42.00706, 13.27923],
  "Cappella Cantone": [45.24652, 9.8381],
  "Cappella de' Picenardi": [45.15913, 10.23013],
  "Cappella Maggiore": [45.96901, 12.36259],
  "Cappelle sul Tavo": [42.46518, 14.10332],
  "Capracotta": [41.83385, 14.26425],
  "Capraia e Limite": [43.74246, 10.97643],
  "Capraia Isola": [43.04992, 9.84226],
  "Capralba": [45.44227, 9.64244],
  "Capranica": [42.25668, 12.17806],
  "Capranica Prenestina": [41.86207, 12.95235],
  "Caprarica di Lecce": [40.26289, 18.24503],
  "Caprarola": [42.32757, 12.23797],
  "Caprauna": [44.11582, 7.95494],
  "Caprese Michelangelo": [43.64399, 11.98577],
  "Caprezzo": [45.98065, 8.56129],
  "Capri": [40.55097, 14.24305],
  "Capri Leone": [38.10753, 14.70724],
  "Capriana": [46.26297, 11.33917],
  "Capriano del Colle": [45.45516, 10.12641],
  "Capriata d'Orba": [44.72997, 8.68894],
  "Capriate San Gervasio": [45.60917, 9.5273],
  "Capriati a Volturno": [41.46926, 14.14611],
  "Caprie": [45.11787, 7.33251],
  "Capriglia Irpina": [40.9558, 14.77544],
  "Capriglio": [45.00423, 8.00816],
  "Caprile": [45.69295, 8.21297],
  "Caprino Bergamasco": [45.74647, 9.48158],
  "Caprino Veronese": [45.60657, 10.79378],
  "Capriolo": [45.6398, 9.93602],
  "Capriva del Friuli": [45.94211, 13.51459],
  "Capua": [41.10763, 14.21085],
  "Capurso": [41.04789, 16.92021],
  "Caraffa del Bianco": [38.09217, 16.08542],
  "Caraffa di Catanzaro": [38.88036, 16.48725],
  "Caraglio": [44.41772, 7.42762],
  "Caramagna Piemonte": [44.78043, 7.74118],
  "Caramanico Terme": [42.15724, 14.00314],
  "Carapelle": [41.36284, 15.69371],
  "Carapelle Calvisio": [42.29915, 13.68321],
  "Carasco": [44.35131, 9.34404],
  "Carassai": [43.03215, 13.68373],
  "Carate Brianza": [45.67705, 9.23312],
  "Carate Urio": [45.87197, 9.1224],
  "Caravaggio": [45.49714, 9.64311],
  "Caravate": [45.87951, 8.65548],
  "Caravino": [45.39861, 7.96021],
  "Caravonica": [43.99234, 7.95888],
  "Carbognano": [42.33211, 12.26677],
  "Carbonara al Ticino": [45.16532, 9.05905],
  "Carbonara di Nola": [40.87512, 14.57608],
  "Carbonara Scrivia": [44.84977, 8.87078],
  "Carbonate": [45.68506, 8.9404],
  "Carbone": [40.14163, 16.0896],
  "Carbonera": [45.68157, 12.28902],
  "Carbonia": [39.16641, 8.52624],
  "Carcare": [44.35797, 8.29083],
  "Carceri": [45.19567, 11.62129],
  "Carcoforo": [45.90889, 8.0489],
  "Cardano al Campo": [45.64661, 8.77458],
  "Cardedu": [39.7958, 9.62541],
  "Cardeto": [38.0844, 15.76577],
  "Cardinale": [38.64241, 16.38614],
  "Cardito": [40.94648, 14.29534],
  "Cardè": [44.74418, 7.47822],
  "Careggine": [44.12081, 10.32439],
  "Carema": [45.58445, 7.8123],
  "Carenno": [45.80143, 9.46167],
  "Carentino": [44.82888, 8.47047],
  "Careri": [38.17863, 16.11621],
  "Caresana": [45.22108, 8.50649],
  "Caresanablot": [45.35735, 8.38877],
  "Carezzano": [44.80675, 8.90001],
  "Carfizzi": [39.30619, 16.97611],
  "Cargeghe": [40.66755, 8.61607],
  "Cariati": [39.49579, 16.94709],
  "Carife": [41.02744, 15.20813],
  "Carignano": [44.90667, 7.67534],
  "Carimate": [45.70269, 9.11525],
  "Carinaro": [40.98896, 14.217],
  "Carini": [38.13319, 13.18241],
  "Carinola": [41.18744, 13.98181],
  "Carisio": [45.40846, 8.19859],
  "Carisolo": [46.16905, 10.76386],
  "Carlantino": [41.59229, 14.97663],
  "Carlazzo": [46.0492, 9.15649],
  "Carlentini": [37.27598, 15.01477],
  "Carlino": [45.80228, 13.18811],
  "Carloforte": [39.14576, 8.30558],
  "Carlopoli": [39.05716, 16.45487],
  "Carmagnola": [44.84655, 7.71816],
  "Carmiano": [40.34555, 18.04547],
  "Carmignano": [43.81383, 11.01835],
  "Carmignano di Brenta": [45.62876, 11.70016],
  "Carnago": [45.71828, 8.83627],
  "Carnate": [45.65106, 9.37834],
  "Carobbio degli Angeli": [45.67046, 9.82863],
  "Carolei": [39.2531, 16.21861],
  "Carona": [46.02184, 9.78549],
  "Caronia": [38.02471, 14.44077],
  "Caronno Pertusella": [45.59682, 9.04787],
  "Caronno Varesino": [45.73879, 8.83099],
  "Carosino": [40.466, 17.39806],
  "Carovigno": [40.7071, 17.65939],
  "Carovilli": [41.71321, 14.29427],
  "Carpaneto Piacentino": [44.91505, 9.78845],
  "Carpanzano": [39.14766, 16.30357],
  "Carpegna": [43.78122, 12.33599],
  "Carpenedolo": [45.36119, 10.43153],
  "Carpeneto": [44.67726, 8.60632],
  "Carpi": [44.78248, 10.88526],
  "Carpiano": [45.34164, 9.27464],
  "Carpignano Salentino": [40.19794, 18.34057],
  "Carpignano Sesia": [45.53531, 8.41834],
  "Carpineti": [44.45468, 10.51955],
  "Carpineto della Nora": [42.33281, 13.85932],
  "Carpineto Romano": [41.60442, 13.0853],
  "Carpineto Sinello": [42.01364, 14.50777],
  "Carpino": [41.84463, 15.85563],
  "Carpinone": [41.5915, 14.32381],
  "Carrara": [44.0773, 10.09678],
  "Carrega Ligure": [44.61907, 9.17561],
  "Carro": [44.27271, 9.60826],
  "Carrodano": [44.24208, 9.65616],
  "Carrosio": [44.65941, 8.83233],
  "Carrè": [45.74741, 11.45877],
  "Carrù": [44.47859, 7.88006],
  "Carsoli": [42.09642, 13.08269],
  "Cartigliano": [45.7135, 11.69408],
  "Cartignano": [44.47708, 7.28769],
  "Cartoceto": [43.76458, 12.88377],
  "Cartosio": [44.5912, 8.41853],
  "Cartura": [45.26814, 11.86261],
  "Carugate": [45.5496, 9.33843],
  "Carugo": [45.70997, 9.18915],
  "Carunchio": [41.91698, 14.52671],
  "Carvico": [45.70686, 9.47983],
  "Carzano": [46.07088, 11.49363],
  "Casabona": [39.24846, 16.9583],
  "Casacalenda": [41.73956, 14.84713],
  "Casacanditella": [42.24832, 14.19883],
  "Casagiove": [41.08219, 14.3112],
  "Casal Cermelli": [44.8357, 8.62242],
  "Casal di Principe": [41.00735, 14.13056],
  "Casal Velino": [40.18895, 15.10958],
  "Casalanguida": [42.03727, 14.4964],
  "Casalattico": [41.62147, 13.72467],
  "Casalbeltrame": [45.43624, 8.46838],
  "Casalbordino": [42.15072, 14.58489],
  "Casalbore": [41.23421, 15.00406],
  "Casalborgone": [45.12996, 7.94044],
  "Casalbuono": [40.21446, 15.68297],
  "Casalbuttano ed Uniti": [45.25201, 9.96168],
  "Casalciprano": [41.58167, 14.52872],
  "Casalduni": [41.26029, 14.69521],
  "Casale Corte Cerro": [45.91678, 8.41506],
  "Casale Cremasco-Vidolasco": [45.43161, 9.7139],
  "Casale di Scodosia": [45.1878, 11.46637],
  "Casale Litta": [45.76739, 8.74034],
  "Casale Marittimo": [43.29725, 10.61553],
  "Casale Monferrato": [45.13503, 8.45261],
  "Casale sul Sile": [45.59747, 12.32563],
  "Casalecchio di Reno": [44.4812, 11.28247],
  "Casaleggio Boiro": [44.6343, 8.73168],
  "Casaleggio Novara": [45.4863, 8.49267],
  "Casaleone": [45.16977, 11.20022],
  "Casaletto Ceredano": [45.31813, 9.61679],
  "Casaletto di Sopra": [45.41862, 9.7813],
  "Casaletto Lodigiano": [45.29313, 9.36181],
  "Casaletto Spartano": [40.15165, 15.61856],
  "Casaletto Vaprio": [45.40728, 9.62904],
  "Casalfiumanese": [44.29763, 11.61621],
  "Casalgrande": [44.58987, 10.73927],
  "Casalgrasso": [44.8195, 7.62496],
  "Casali del Manco": [39.2854, 16.3373],
  "Casalincontrada": [42.28625, 14.13186],
  "Casalino": [45.35768, 8.52274],
  "Casalmaggiore": [44.98742, 10.41378],
  "Casalmaiocco": [45.35304, 9.37166],
  "Casalmorano": [45.28709, 9.89784],
  "Casalmoro": [45.259, 10.40798],
  "Casalnoceto": [44.91316, 8.98199],
  "Casalnuovo di Napoli": [40.91481, 14.35119],
  "Casalnuovo Monterotaro": [41.61838, 15.1024],
  "Casaloldo": [45.25257, 10.48214],
  "Casalpusterlengo": [45.1778, 9.65107],
  "Casalromano": [45.1973, 10.36511],
  "Casalserugo": [45.31632, 11.91481],
  "Casaluce": [41.00234, 14.19438],
  "Casalvecchio di Puglia": [41.59579, 15.11095],
  "Casalvecchio Siculo": [37.95821, 15.3235],
  "Casalvieri": [41.63142, 13.71316],
  "Casalvolone": [45.39946, 8.46436],
  "Casalzuigno": [45.90327, 8.70551],
  "Casamarciano": [40.93289, 14.55358],
  "Casamassima": [40.95538, 16.91807],
  "Casamicciola Terme": [40.74671, 13.90748],
  "Casandrino": [40.93574, 14.25138],
  "Casanova Elvo": [45.39953, 8.29331],
  "Casanova Lerrone": [44.03159, 8.04828],
  "Casanova Lonati": [45.09442, 9.21374],
  "Casape": [41.90641, 12.88614],
  "Casapesenna": [40.98904, 14.13303],
  "Casapinta": [45.61503, 8.1934],
  "Casaprota": [42.25185, 12.80366],
  "Casapulla": [41.07477, 14.28856],
  "Casarano": [40.00917, 18.16107],
  "Casargo": [46.03836, 9.38827],
  "Casarile": [45.31759, 9.1032],
  "Casarsa della Delizia": [45.95375, 12.84015],
  "Casarza Ligure": [44.27462, 9.45346],
  "Casasco": [44.82823, 9.00605],
  "Casatenovo": [45.69907, 9.31559],
  "Casatisma": [45.04569, 9.13096],
  "Casavatore": [40.90012, 14.27453],
  "Casazza": [45.75151, 9.90632],
  "Cascia": [42.71825, 13.01314],
  "Casciago": [45.83477, 8.78438],
  "Casciana Terme Lari": [43.5663, 10.5935],
  "Cascina": [43.67654, 10.54928],
  "Cascinette d'Ivrea": [45.47845, 7.9047],
  "Casei Gerola": [45.00631, 8.92707],
  "Caselette": [45.10588, 7.48321],
  "Casella": [44.535, 8.9992],
  "Caselle in Pittari": [40.17244, 15.54392],
  "Caselle Landi": [45.10377, 9.79199],
  "Caselle Lurani": [45.28043, 9.36014],
  "Caselle Torinese": [45.17717, 7.64819],
  "Caserta": [41.07466, 14.3324],
  "Casier": [45.63422, 12.25497],
  "Casignana": [38.09932, 16.09009],
  "Casina": [44.51164, 10.50046],
  "Casirate d'Adda": [45.49235, 9.5666],
  "Caslino d'Erba": [45.83756, 9.22712],
  "Casnate con Bernate": [45.75679, 9.07466],
  "Casnigo": [45.81635, 9.86745],
  "Casola di Napoli": [40.69436, 14.52864],
  "Casola in Lunigiana": [44.20117, 10.17572],
  "Casola Valsenio": [44.22352, 11.62308],
  "Casole d'Elsa": [43.3405, 11.04313],
  "Casoli": [42.11504, 14.29044],
  "Casorate Primo": [45.31192, 9.01814],
  "Casorate Sempione": [45.67171, 8.74032],
  "Casorezzo": [45.5242, 8.89905],
  "Casoria": [40.90566, 14.29026],
  "Casorzo": [45.02282, 8.33414],
  "Casperia": [42.33796, 12.6703],
  "Caspoggio": [46.26473, 9.86177],
  "Cassacco": [46.17385, 13.18611],
  "Cassago Brianza": [45.74049, 9.29483],
  "Cassano all'Ionio": [39.78187, 16.31921],
  "Cassano d'Adda": [45.52652, 9.52055],
  "Cassano delle Murge": [40.88973, 16.77175],
  "Cassano Irpino": [40.87019, 15.02612],
  "Cassano Magnago": [45.67438, 8.82083],
  "Cassano Valcuvia": [45.93258, 8.76818],
  "Cassaro": [37.10523, 14.94764],
  "Cassiglio": [45.96686, 9.61213],
  "Cassina de' Pecchi": [45.51997, 9.36445],
  "Cassina Rizzardi": [45.75104, 9.03039],
  "Cassina Valsassina": [45.93198, 9.47939],
  "Cassinasco": [44.68864, 8.30166],
  "Cassine": [44.74822, 8.52548],
  "Cassinelle": [44.60685, 8.56047],
  "Cassinetta di Lugagnano": [45.42213, 8.9068],
  "Cassino": [41.49268, 13.83013],
  "Cassola": [45.73259, 11.79893],
  "Cassolnovo": [45.36583, 8.80895],
  "Castagnaro": [45.1205, 11.41083],
  "Castagneto Carducci": [43.16066, 10.60997],
  "Castagneto Po": [45.16061, 7.88699],
  "Castagnito": [44.75648, 8.03015],
  "Castagnole delle Lanze": [44.75492, 8.14918],
  "Castagnole Monferrato": [44.96144, 8.30609],
  "Castagnole Piemonte": [44.89862, 7.56656],
  "Castana": [45.02703, 9.2719],
  "Castano Primo": [45.55121, 8.77636],
  "Casteggio": [45.0124, 9.12495],
  "Castegnato": [45.56212, 10.11684],
  "Castegnero": [45.4363, 11.59917],
  "Castel Baronia": [41.0472, 15.18836],
  "Castel Boglione": [44.72062, 8.3812],
  "Castel Bolognese": [44.31911, 11.79895],
  "Castel Campagnano": [41.1824, 14.453],
  "Castel Castagna": [42.54295, 13.71708],
  "Castel Condino": [45.91521, 10.60284],
  "Castel d'Aiano": [44.28065, 11.00131],
  "Castel d'Ario": [45.18572, 10.9714],
  "Castel d'Azzano": [45.35359, 10.944],
  "Castel del Giudice": [41.85498, 14.23148],
  "Castel del Monte": [42.36485, 13.72648],
  "Castel del Piano": [42.89305, 11.53774],
  "Castel del Rio": [44.21316, 11.50443],
  "Castel di Casio": [44.16306, 11.03637],
  "Castel di Ieri": [42.11406, 13.74076],
  "Castel di Iudica": [37.49444, 14.64945],
  "Castel di Lama": [42.86891, 13.7129],
  "Castel di Lucio": [37.88722, 14.31046],
  "Castel di Sangro": [41.78521, 14.10849],
  "Castel di Sasso": [41.19769, 14.28436],
  "Castel di Tora": [42.21549, 12.96433],
  "Castel Focognano": [43.65159, 11.83564],
  "Castel Frentano": [42.19622, 14.35662],
  "Castel Gabbiano": [45.46846, 9.71762],
  "Castel Gandolfo": [41.74676, 12.65046],
  "Castel Giorgio": [42.70779, 11.9796],
  "Castel Goffredo": [45.29795, 10.47463],
  "Castel Guelfo di Bologna": [44.43182, 11.67895],
  "Castel Ivano": [46.0683, 11.5211],
  "Castel Madama": [41.97566, 12.86857],
  "Castel Maggiore": [44.575, 11.36489],
  "Castel Mella": [45.4976, 10.14188],
  "Castel Morrone": [41.12029, 14.35762],
  "Castel Ritaldi": [42.82305, 12.67226],
  "Castel Rocchero": [44.7188, 8.41597],
  "Castel Rozzone": [45.55544, 9.62374],
  "Castel San Giorgio": [40.78015, 14.69777],
  "Castel San Giovanni": [45.05852, 9.43405],
  "Castel San Lorenzo": [40.41683, 15.22777],
  "Castel San Niccolò": [43.74104, 11.70459],
  "Castel San Pietro Romano": [41.84637, 12.89475],
  "Castel San Pietro Terme": [44.39812, 11.58918],
  "Castel San Vincenzo": [41.65504, 14.06252],
  "Castel Sant'Angelo": [42.39478, 13.02994],
  "Castel Sant'Elia": [42.24932, 12.36809],
  "Castel Viscardo": [42.75574, 12.00154],
  "Castel Vittorio": [43.92874, 7.67319],
  "Castel Volturno": [41.03461, 13.94094],
  "Castelbaldo": [45.12114, 11.45268],
  "Castelbelforte": [45.21408, 10.8922],
  "Castelbellino": [43.48784, 13.14607],
  "Castelbello-Ciardes": [46.62831, 10.90114],
  "Castelbianco": [44.11322, 8.0748],
  "Castelbottaccio": [41.75297, 14.70711],
  "Castelbuono": [37.93385, 14.08826],
  "Castelcivita": [40.49297, 15.233],
  "Castelcovati": [45.50607, 9.94319],
  "Castelcucco": [45.83318, 11.88383],
  "Casteldaccia": [38.05537, 13.53252],
  "Casteldelci": [43.79139, 12.15512],
  "Casteldelfino": [44.59097, 7.06903],
  "Casteldidone": [45.07068, 10.40578],
  "Castelfidardo": [43.46453, 13.5466],
  "Castelfiorentino": [43.60573, 10.97131],
  "Castelforte": [41.30023, 13.82275],
  "Castelfranci": [40.93068, 15.04099],
  "Castelfranco di Sotto": [43.6997, 10.74524],
  "Castelfranco Emilia": [44.59637, 11.05299],
  "Castelfranco in Miscano": [41.29687, 15.08257],
  "Castelfranco Piandiscò": [43.622, 11.5583],
  "Castelfranco Veneto": [45.67136, 11.9264],
  "Castelgomberto": [45.58593, 11.39447],
  "Castelgrande": [40.78522, 15.43306],
  "Castelguglielmo": [45.0257, 11.53728],
  "Castelguidone": [41.82349, 14.52299],
  "Castell'Alfero": [44.98271, 8.20945],
  "Castell'Arquato": [44.8512, 9.8676],
  "Castell'Azzara": [42.77354, 11.69777],
  "Castell'Umberto": [38.08458, 14.80688],
  "Castellabate": [40.28644, 14.9492],
  "Castellafiume": [41.98796, 13.33469],
  "Castellalto": [42.6754, 13.81746],
  "Castellammare del Golfo": [38.02638, 12.88044],
  "Castellammare di Stabia": [40.69453, 14.48032],
  "Castellamonte": [45.38334, 7.70987],
  "Castellana Grotte": [40.8825, 17.16979],
  "Castellana Sicula": [37.78176, 14.04409],
  "Castellaneta": [40.63026, 16.93207],
  "Castellania Coppi": [44.79885, 8.93045],
  "Castellanza": [45.61147, 8.89759],
  "Castellar Guidobono": [44.90627, 8.94674],
  "Castellarano": [44.50955, 10.73064],
  "Castellaro": [43.8647, 7.86832],
  "Castellazzo Bormida": [44.84547, 8.57712],
  "Castellazzo Novarese": [45.51399, 8.48871],
  "Castelleone": [45.2935, 9.76489],
  "Castelleone di Suasa": [43.60724, 12.97677],
  "Castellero": [44.92401, 8.07475],
  "Castelletto Cervo": [45.519, 8.2252],
  "Castelletto d'Erro": [44.62509, 8.39441],
  "Castelletto d'Orba": [44.68557, 8.70226],
  "Castelletto di Branduzzo": [45.07019, 9.09767],
  "Castelletto Merli": [45.0752, 8.24056],
  "Castelletto Molina": [44.75031, 8.43283],
  "Castelletto Monferrato": [44.97987, 8.56624],
  "Castelletto sopra Ticino": [45.71405, 8.64237],
  "Castelletto Stura": [44.44423, 7.63905],
  "Castelletto Uzzone": [44.49258, 8.18598],
  "Castelli": [42.48941, 13.71172],
  "Castelli Calepio": [45.64153, 9.90225],
  "Castellina in Chianti": [43.47001, 11.28566],
  "Castellina Marittima": [43.41197, 10.57549],
  "Castellinaldo d'Alba": [44.77533, 8.03154],
  "Castellino del Biferno": [41.7022, 14.73138],
  "Castellino Tanaro": [44.42777, 7.98189],
  "Castelliri": [41.67931, 13.55048],
  "Castello Cabiaglio": [45.89255, 8.75482],
  "Castello d'Agogna": [45.236, 8.68938],
  "Castello d'Argile": [44.68123, 11.2966],
  "Castello del Matese": [41.36675, 14.37791],
  "Castello dell'Acqua": [46.14549, 10.01579],
  "Castello di Annone": [44.87877, 8.31369],
  "Castello di Brianza": [45.75583, 9.34825],
  "Castello di Cisterna": [40.9167, 14.40789],
  "Castello di Godego": [45.69214, 11.88102],
  "Castello Tesino": [46.06242, 11.63371],
  "Castello-Molina di Fiemme": [46.28125, 11.43471],
  "Castellucchio": [45.14673, 10.64451],
  "Castelluccio dei Sauri": [41.3041, 15.47395],
  "Castelluccio Inferiore": [40.0051, 15.9729],
  "Castelluccio Superiore": [40.0096, 15.97672],
  "Castelluccio Valmaggiore": [41.34311, 15.20333],
  "Castelmagno": [44.40916, 7.21233],
  "Castelmarte": [45.83251, 9.23336],
  "Castelmassa": [45.01769, 11.3104],
  "Castelmauro": [41.8294, 14.71042],
  "Castelmezzano": [40.53067, 16.04814],
  "Castelmola": [37.85819, 15.27666],
  "Castelnovetto": [45.25438, 8.6114],
  "Castelnovo Bariano": [45.02669, 11.28626],
  "Castelnovo del Friuli": [46.19991, 12.90325],
  "Castelnovo di Sotto": [44.8116, 10.56368],
  "Castelnovo ne' Monti": [44.43749, 10.40326],
  "Castelnuovo": [46.05226, 11.4942],
  "Castelnuovo Belbo": [44.80181, 8.41226],
  "Castelnuovo Berardenga": [43.34549, 11.50314],
  "Castelnuovo Bocca d'Adda": [45.11237, 9.86941],
  "Castelnuovo Bormida": [44.74369, 8.5462],
  "Castelnuovo Bozzente": [45.76345, 8.94138],
  "Castelnuovo Calcea": [44.78822, 8.28564],
  "Castelnuovo Cilento": [40.21846, 15.17802],
  "Castelnuovo del Garda": [45.44038, 10.7637],
  "Castelnuovo della Daunia": [41.58268, 15.11835],
  "Castelnuovo di Ceva": [44.35331, 8.1302],
  "Castelnuovo di Conza": [40.81816, 15.32126],
  "Castelnuovo di Farfa": [42.23191, 12.7427],
  "Castelnuovo di Garfagnana": [44.11032, 10.41166],
  "Castelnuovo di Porto": [42.12579, 12.50045],
  "Castelnuovo di Val di Cecina": [43.2069, 10.90601],
  "Castelnuovo Don Bosco": [45.04134, 7.96362],
  "Castelnuovo Magra": [44.09847, 10.0182],
  "Castelnuovo Nigra": [45.43732, 7.69511],
  "Castelnuovo Parano": [41.37776, 13.75534],
  "Castelnuovo Rangone": [44.54913, 10.93965],
  "Castelnuovo Scrivia": [44.97942, 8.88163],
  "Castelpagano": [41.40252, 14.80668],
  "Castelpetroso": [41.55953, 14.34526],
  "Castelpizzuto": [41.5214, 14.29266],
  "Castelplanio": [43.49459, 13.08135],
  "Castelpoto": [41.14097, 14.69971],
  "Castelraimondo": [43.21, 13.0577],
  "Castelrotto": [46.56781, 11.55946],
  "Castelsantangelo sul Nera": [42.89447, 13.15308],
  "Castelsaraceno": [40.16503, 15.99271],
  "Castelsardo": [40.91582, 8.71333],
  "Castelseprio": [45.71695, 8.86127],
  "Castelsilano": [39.27061, 16.76687],
  "Castelspina": [44.80447, 8.58242],
  "Casteltermini": [37.54081, 13.6434],
  "Castelveccana": [45.94653, 8.66483],
  "Castelvecchio Calvisio": [42.31015, 13.68873],
  "Castelvecchio di Rocca Barbena": [44.13038, 8.11551],
  "Castelvecchio Subequo": [42.13147, 13.72883],
  "Castelvenere": [41.23461, 14.54744],
  "Castelverde": [45.18571, 9.99696],
  "Castelverrino": [41.76823, 14.39759],
  "Castelvetere in Val Fortore": [41.44197, 14.94213],
  "Castelvetere sul Calore": [40.92992, 14.98607],
  "Castelvetrano": [37.67916, 12.79164],
  "Castelvetro di Modena": [44.50347, 10.94303],
  "Castelvetro Piacentino": [45.09666, 9.98803],
  "Castelvisconti": [45.30568, 9.94221],
  "Castenaso": [44.50892, 11.46879],
  "Castenedolo": [45.47136, 10.30044],
  "Castiadas": [39.27561, 9.5236],
  "Castiglion Fibocchi": [43.52757, 11.76322],
  "Castiglion Fiorentino": [43.34164, 11.92387],
  "Castiglione a Casauria": [42.23628, 13.89399],
  "Castiglione Chiavarese": [44.27471, 9.51355],
  "Castiglione Cosentino": [39.35271, 16.28822],
  "Castiglione d'Adda": [45.21569, 9.69503],
  "Castiglione d'Orcia": [43.00438, 11.61639],
  "Castiglione dei Pepoli": [44.14166, 11.15391],
  "Castiglione del Genovesi": [40.72505, 14.84823],
  "Castiglione del Lago": [43.12728, 12.05358],
  "Castiglione della Pescaia": [42.76203, 10.87883],
  "Castiglione delle Stiviere": [45.3865, 10.49105],
  "Castiglione di Garfagnana": [44.14909, 10.41127],
  "Castiglione di Sicilia": [37.8827, 15.12239],
  "Castiglione Falletto": [44.62334, 7.97903],
  "Castiglione in Teverina": [42.64496, 12.20411],
  "Castiglione Messer Marino": [41.86694, 14.4517],
  "Castiglione Messer Raimondo": [42.53143, 13.88234],
  "Castiglione Olona": [45.75638, 8.86808],
  "Castiglione Tinella": [44.72605, 8.18943],
  "Castiglione Torinese": [45.12331, 7.81609],
  "Castignano": [42.93806, 13.62156],
  "Castilenti": [42.53336, 13.91777],
  "Castino": [44.617, 8.18121],
  "Castione Andevenno": [46.17286, 9.8003],
  "Castione della Presolana": [45.90775, 10.03641],
  "Castions di Strada": [45.90845, 13.18486],
  "Castiraga Vidardo": [45.25645, 9.40264],
  "Casto": [45.69509, 10.3206],
  "Castorano": [42.89833, 13.72762],
  "Castrezzato": [45.51109, 9.97672],
  "Castri di Lecce": [40.27267, 18.2668],
  "Castrignano de' Greci": [40.17485, 18.29525],
  "Castrignano del Capo": [39.82938, 18.35352],
  "Castro (BG)": [45.8038, 10.06877],
  "Castro (LE)": [40.0079, 18.42477],
  "Castro dei Volsci": [41.50866, 13.40667],
  "Castrocaro Terme e Terra del Sole": [44.17607, 11.95003],
  "Castrocielo": [41.53118, 13.69629],
  "Castrofilippo": [37.34869, 13.75018],
  "Castrolibero": [39.31002, 16.19454],
  "Castronno": [45.74696, 8.81289],
  "Castronovo di Sicilia": [37.67842, 13.60374],
  "Castronuovo di Sant'Andrea": [40.18854, 16.18609],
  "Castropignano": [41.61982, 14.5617],
  "Castroreale": [38.09848, 15.21103],
  "Castroregio": [39.99257, 16.47832],
  "Castrovillari": [39.81098, 16.2023],
  "Catania": [37.50288, 15.08705],
  "Catanzaro": [38.90598, 16.5944],
  "Catenanuova": [37.56792, 14.69146],
  "Catignano": [42.34603, 13.94977],
  "Cattolica": [43.96377, 12.74464],
  "Cattolica Eraclea": [37.43953, 13.3954],
  "Caulonia": [38.38139, 16.41049],
  "Cautano": [41.1492, 14.63797],
  "Cava de' Tirreni": [40.70081, 14.70597],
  "Cava Manara": [45.13887, 9.10711],
  "Cavaglietto": [45.6028, 8.50091],
  "Cavaglio d'Agogna": [45.61181, 8.48279],
  "Cavaglià": [45.40576, 8.09349],
  "Cavagnolo": [45.15207, 8.05131],
  "Cavaion Veronese": [45.53829, 10.77168],
  "Cavalese": [46.2913, 11.46043],
  "Cavallerleone": [44.73944, 7.66274],
  "Cavallermaggiore": [44.70786, 7.68775],
  "Cavallino": [40.31567, 18.1945],
  "Cavallino-Treporti": [45.45348, 12.45372],
  "Cavallirio": [45.66496, 8.39674],
  "Cavareno": [46.40792, 11.1366],
  "Cavargna": [46.09068, 9.11203],
  "Cavaria con Premezzo": [45.69455, 8.79768],
  "Cavarzere": [45.1368, 12.08371],
  "Cavaso del Tomba": [45.86034, 11.89521],
  "Cavasso Nuovo": [46.19403, 12.76881],
  "Cavatore": [44.63096, 8.45241],
  "Cavazzo Carnico": [46.36768, 13.04046],
  "Cave": [41.81808, 12.93179],
  "Cavedago": [46.18353, 11.02806],
  "Cavedine": [45.99392, 10.97082],
  "Cavenago d'Adda": [45.28397, 9.6018],
  "Cavenago di Brianza": [45.5853, 9.41488],
  "Cavernago": [45.6238, 9.76373],
  "Cavezzo": [44.8377, 11.0299],
  "Cavizzana": [46.36819, 10.95837],
  "Cavour": [44.78403, 7.37523],
  "Cavriago": [44.69486, 10.52673],
  "Cavriana": [45.34991, 10.601],
  "Cavriglia": [43.52369, 11.48906],
  "Cazzago Brabbia": [45.79535, 8.73528],
  "Cazzago San Martino": [45.58101, 10.02502],
  "Cazzano di Tramigna": [45.47244, 11.20349],
  "Cazzano Sant'Andrea": [45.81122, 9.88223],
  "Ceccano": [41.56856, 13.33364],
  "Cecima": [44.84781, 9.08169],
  "Cecina": [43.31218, 10.51937],
  "Cedegolo": [46.07576, 10.34999],
  "Cedrasco": [46.14931, 9.768],
  "Cefalà Diana": [37.91541, 13.46372],
  "Cefalù": [38.0397, 14.02202],
  "Ceggia": [45.68631, 12.63742],
  "Ceglie Messapica": [40.64697, 17.51709],
  "Celano": [42.08483, 13.54822],
  "Celenza sul Trigno": [41.87177, 14.58113],
  "Celenza Valfortore": [41.56213, 14.97751],
  "Celico": [39.31067, 16.34029],
  "Cella Dati": [45.09616, 10.22126],
  "Cella Monte": [45.0748, 8.39069],
  "Cellamare": [41.01842, 16.92907],
  "Cellara": [39.21796, 16.33277],
  "Cellarengo": [44.866, 7.945],
  "Cellatica": [45.58269, 10.17777],
  "Celle di Bulgheria": [40.09492, 15.40574],
  "Celle di Macra": [44.48257, 7.17967],
  "Celle di San Vito": [41.32507, 15.18122],
  "Celle Enomondo": [44.85663, 8.12297],
  "Celle Ligure": [44.34206, 8.54522],
  "Celleno": [42.5598, 12.12641],
  "Cellere": [42.50799, 11.76784],
  "Cellino Attanasio": [42.58627, 13.85952],
  "Cellino San Marco": [40.47428, 17.96964],
  "Cellole": [41.20444, 13.8549],
  "Cembra Lisignago": [46.1746, 11.2218],
  "Cenadi": [38.71725, 16.41006],
  "Cenate Sopra": [45.71174, 9.82418],
  "Cenate Sotto": [45.69843, 9.82395],
  "Cencenighe Agordino": [46.35125, 11.96626],
  "Cene": [45.77943, 9.82557],
  "Ceneselli": [45.01308, 11.36942],
  "Cengio": [44.38756, 8.20841],
  "Centallo": [44.50412, 7.59015],
  "Cento": [44.72756, 11.29061],
  "Centola": [40.06581, 15.30985],
  "Centrache": [38.72952, 16.43018],
  "Centuripe": [37.62031, 14.74143],
  "Cepagatti": [42.36462, 14.07304],
  "Ceppaloni": [41.04557, 14.76112],
  "Ceppo Morelli": [45.97137, 8.06671],
  "Ceprano": [41.54569, 13.51942],
  "Cerami": [37.81035, 14.50637],
  "Ceranesi": [44.50394, 8.8946],
  "Cerano": [45.41067, 8.78086],
  "Cerano d'Intelvi": [45.94446, 9.08764],
  "Ceranova": [45.26001, 9.24226],
  "Ceraso": [40.19296, 15.25855],
  "Cercemaggiore": [41.46031, 14.7221],
  "Cercenasco": [44.86126, 7.50126],
  "Cercepiccola": [41.45932, 14.66804],
  "Cerchiara di Calabria": [39.85915, 16.38164],
  "Cerchio": [42.06412, 13.60051],
  "Cercino": [46.15778, 9.50818],
  "Cercivento": [46.52713, 12.98772],
  "Cercola": [40.86005, 14.35891],
  "Cerda": [37.90386, 13.81537],
  "Cerea": [45.19202, 11.21287],
  "Ceregnano": [45.05007, 11.87058],
  "Cerenzia": [39.24504, 16.78281],
  "Ceres": [45.31308, 7.38934],
  "Ceresara": [45.26332, 10.56562],
  "Cereseto": [45.08601, 8.31694],
  "Ceresole Alba": [44.79952, 7.82057],
  "Ceresole Reale": [45.43262, 7.23254],
  "Cerete": [45.86769, 9.99497],
  "Ceretto Lomellina": [45.24482, 8.67241],
  "Cergnago": [45.19717, 8.76909],
  "Ceriale": [44.09636, 8.23207],
  "Ceriana": [43.88095, 7.77295],
  "Ceriano Laghetto": [45.62719, 9.07907],
  "Cerignale": [44.67749, 9.35097],
  "Cerignola": [41.26522, 15.90368],
  "Cerisano": [39.27455, 16.17836],
  "Cermenate": [45.69857, 9.08269],
  "Cermes": [46.63279, 11.14503],
  "Cermignano": [42.58862, 13.79238],
  "Cernobbio": [45.83962, 9.07435],
  "Cernusco Lombardone": [45.69049, 9.39755],
  "Cernusco sul Naviglio": [45.5242, 9.33503],
  "Cerreto d'Asti": [45.04977, 8.03676],
  "Cerreto d'Esi": [43.32074, 12.98515],
  "Cerreto di Spoleto": [42.81933, 12.91639],
  "Cerreto Grue": [44.84186, 8.93198],
  "Cerreto Guidi": [43.75967, 10.87758],
  "Cerreto Laziale": [41.94437, 12.98165],
  "Cerreto Sannita": [41.28322, 14.55689],
  "Cerretto Langhe": [44.57434, 8.09784],
  "Cerrina Monferrato": [45.12019, 8.21525],
  "Cerrione": [45.48091, 8.07399],
  "Cerro al Lambro": [45.33157, 9.33846],
  "Cerro al Volturno": [41.65408, 14.10315],
  "Cerro Maggiore": [45.59344, 8.95071],
  "Cerro Tanaro": [44.87267, 8.36021],
  "Cerro Veronese": [45.57418, 11.04159],
  "Cersosimo": [40.04571, 16.34928],
  "Certaldo": [43.54778, 11.04076],
  "Certosa di Pavia": [45.25434, 9.12742],
  "Cerva": [39.02032, 16.74247],
  "Cervara di Roma": [41.98808, 13.0677],
  "Cervarese Santa Croce": [45.40293, 11.6919],
  "Cervaro": [41.48104, 13.90505],
  "Cervasca": [44.38316, 7.46789],
  "Cervatto": [45.88308, 8.16235],
  "Cerveno": [46.00232, 10.32551],
  "Cervere": [44.63475, 7.79317],
  "Cervesina": [45.06117, 9.01776],
  "Cerveteri": [41.99824, 12.09897],
  "Cervia": [44.26093, 12.34982],
  "Cervicati": [39.54237, 16.12682],
  "Cervignano d'Adda": [45.37383, 9.42264],
  "Cervignano del Friuli": [45.82327, 13.33442],
  "Cervinara": [41.02074, 14.61722],
  "Cervino": [41.03971, 14.42434],
  "Cervo": [43.92534, 8.11439],
  "Cerzeto": [39.50771, 16.11398],
  "Cesa": [40.96254, 14.23045],
  "Cesana Brianza": [45.81946, 9.30076],
  "Cesana Torinese": [44.95241, 6.79423],
  "Cesano Boscone": [45.44594, 9.09327],
  "Cesano Maderno": [45.62648, 9.14803],
  "Cesara": [45.8351, 8.36593],
  "Cesarò": [37.84375, 14.71218],
  "Cesate": [45.59501, 9.07544],
  "Cesena": [44.13655, 12.24217],
  "Cesenatico": [44.19954, 12.39544],
  "Cesinali": [40.89613, 14.82976],
  "Cesio": [44.00771, 7.97497],
  "Cesiomaggiore": [46.08869, 11.98717],
  "Cessalto": [45.71275, 12.6138],
  "Cessaniti": [38.66395, 16.02959],
  "Cessapalombo": [43.1091, 13.25841],
  "Cessole": [44.64799, 8.2432],
  "Cetara": [40.64676, 14.70092],
  "Ceto": [46.00236, 10.35185],
  "Cetona": [42.96289, 11.90065],
  "Cetraro": [39.51621, 15.94302],
  "Ceva": [44.38624, 8.03522],
  "Cevo": [46.08019, 10.37038],
  "Challand-Saint-Anselme": [45.7164, 7.73656],
  "Challand-Saint-Victor": [45.68977, 7.70646],
  "Chambave": [45.74434, 7.54994],
  "Chamois": [45.83836, 7.62028],
  "Champdepraz": [45.68574, 7.65775],
  "Champorcher": [45.62361, 7.62079],
  "Charvensod": [45.72043, 7.32541],
  "Cherasco": [44.65223, 7.8582],
  "Cheremule": [40.5061, 8.72514],
  "Chialamberto": [45.36286, 7.3457],
  "Chiampo": [45.54485, 11.28166],
  "Chianche": [41.0437, 14.7909],
  "Chianciano Terme": [43.05884, 11.83181],
  "Chianni": [43.48583, 10.64255],
  "Chianocco": [45.14859, 7.16939],
  "Chiaramonte Gulfi": [37.03158, 14.70127],
  "Chiaramonti": [40.75182, 8.82],
  "Chiarano": [45.72841, 12.58214],
  "Chiaravalle": [43.59973, 13.32555],
  "Chiaravalle Centrale": [38.68408, 16.4142],
  "Chiari": [45.53684, 9.93053],
  "Chiaromonte": [40.12433, 16.21499],
  "Chiauci": [41.67806, 14.38553],
  "Chiavari": [44.31671, 9.32402],
  "Chiavenna": [46.32103, 9.40549],
  "Chiaverano": [45.4994, 7.90313],
  "Chienes": [46.80645, 11.83632],
  "Chieri": [45.01315, 7.82107],
  "Chies d'Alpago": [46.17266, 12.38684],
  "Chiesa in Valmalenco": [46.26377, 9.84833],
  "Chiesanuova": [45.41781, 7.65606],
  "Chiesina Uzzanese": [43.83917, 10.71951],
  "Chieti": [42.35103, 14.16755],
  "Chieuti": [41.84448, 15.16543],
  "Chieve": [45.3375, 9.61612],
  "Chignolo d'Isola": [45.66513, 9.52723],
  "Chignolo Po": [45.15251, 9.48821],
  "Chioggia": [45.22007, 12.27944],
  "Chiomonte": [45.11939, 6.98339],
  "Chions": [45.8623, 12.75235],
  "Chiopris-Viscone": [45.92452, 13.4025],
  "Chitignano": [43.66138, 11.88026],
  "Chiuduno": [45.6469, 9.85376],
  "Chiuppano": [45.7613, 11.46409],
  "Chiuro": [46.16956, 9.98921],
  "Chiusa": [46.64167, 11.56809],
  "Chiusa di Pesio": [44.32477, 7.67788],
  "Chiusa di San Michele": [45.10155, 7.32644],
  "Chiusa Sclafani": [37.67706, 13.26987],
  "Chiusaforte": [46.40822, 13.31049],
  "Chiusanico": [43.97324, 7.99164],
  "Chiusano d'Asti": [44.98505, 8.11781],
  "Chiusano di San Domenico": [40.93191, 14.91673],
  "Chiusavecchia": [43.96789, 7.98333],
  "Chiusdino": [43.15508, 11.08812],
  "Chiusi": [43.01673, 11.94762],
  "Chiusi della Verna": [43.69972, 11.93501],
  "Chivasso": [45.18856, 7.88714],
  "Châtillon": [45.74957, 7.61325],
  "Ciampino": [41.80288, 12.60169],
  "Cianciana": [37.51745, 13.43526],
  "Cibiana di Cadore": [46.3917, 12.29077],
  "Cicagna": [44.4086, 9.23595],
  "Cicala": [39.02308, 16.48636],
  "Cicciano": [40.96363, 14.5432],
  "Cicerale": [40.34368, 15.12672],
  "Ciciliano": [41.96124, 12.94164],
  "Cicognolo": [45.16762, 10.19404],
  "Ciconio": [45.33032, 7.75987],
  "Cigliano": [45.30956, 8.02149],
  "Cigliè": [44.43507, 7.92623],
  "Cigognola": [45.03309, 9.24377],
  "Cigole": [45.30993, 10.19137],
  "Cilavegna": [45.31043, 8.74368],
  "Cimadolmo": [45.7877, 12.3613],
  "Cimbergo": [46.02385, 10.36308],
  "Ciminna": [37.89726, 13.56195],
  "Ciminà": [38.24668, 16.14155],
  "Cimitile": [40.93972, 14.52673],
  "Cimolais": [46.28808, 12.4378],
  "Cimone": [45.97819, 11.06847],
  "Cinaglio": [44.97484, 8.10017],
  "Cineto Romano": [42.05024, 12.96392],
  "Cingia de' Botti": [45.08416, 10.27528],
  "Cingoli": [43.37428, 13.21647],
  "Cinigiano": [42.89108, 11.39417],
  "Cinisello Balsamo": [45.55836, 9.21357],
  "Cinisi": [38.1549, 13.10914],
  "Cino": [46.15843, 9.48531],
  "Cinquefrondi": [38.41619, 16.09663],
  "Cintano": [45.42805, 7.68662],
  "Cinte Tesino": [46.05437, 11.61619],
  "Cinto Caomaggiore": [45.82576, 12.78564],
  "Cinto Euganeo": [45.2913, 11.66112],
  "Cinzano": [45.0939, 7.92112],
  "Ciorlano": [41.45047, 14.15805],
  "Cipressa": [43.85295, 7.9341],
  "Circello": [41.35603, 14.80829],
  "Cirigliano": [40.39302, 16.17121],
  "Cirimido": [45.69881, 9.01109],
  "Ciriè": [45.23202, 7.60378],
  "Cirò": [39.38169, 17.05965],
  "Cirò Marina": [39.36529, 17.13084],
  "Cis": [46.40005, 11.00234],
  "Cisano Bergamasco": [45.74239, 9.47436],
  "Cisano sul Neva": [44.08729, 8.14496],
  "Ciserano": [45.58667, 9.60073],
  "Cislago": [45.66175, 8.97062],
  "Cisliano": [45.44605, 8.98608],
  "Cison di Valmarino": [45.97001, 12.14322],
  "Cissone": [44.5631, 8.03051],
  "Cisterna d'Asti": [44.82618, 8.00482],
  "Cisterna di Latina": [41.59277, 12.82827],
  "Cisternino": [40.73932, 17.42571],
  "Citerna": [43.49827, 12.11647],
  "Cittadella": [45.64858, 11.78365],
  "Cittaducale": [42.38666, 12.94815],
  "Cittanova": [38.35538, 16.08038],
  "Cittareale": [42.61762, 13.15983],
  "Cittiglio": [45.89466, 8.66871],
  "Città della Pieve": [42.95282, 12.00506],
  "Città di Castello": [43.45738, 12.23815],
  "Città Sant'Angelo": [42.51832, 14.05868],
  "Civate": [45.82585, 9.3474],
  "Civezza": [43.87934, 7.95128],
  "Civezzano": [46.09006, 11.17963],
  "Civiasco": [45.80669, 8.29279],
  "Cividale del Friuli": [46.09357, 13.43203],
  "Cividate al Piano": [45.55426, 9.8298],
  "Cividate Camuno": [45.94349, 10.27955],
  "Civita": [39.8277, 16.31319],
  "Civita Castellana": [42.28918, 12.41177],
  "Civita d'Antino": [41.88637, 13.47213],
  "Civitacampomarano": [41.78067, 14.69042],
  "Civitaluparella": [41.94484, 14.30305],
  "Civitanova del Sannio": [41.66771, 14.40422],
  "Civitanova Marche": [43.30668, 13.72803],
  "Civitaquana": [42.32624, 13.89728],
  "Civitavecchia": [42.09213, 11.79338],
  "Civitella Alfedena": [41.76532, 13.94055],
  "Civitella Casanova": [42.36472, 13.88895],
  "Civitella d'Agliano": [42.60623, 12.18796],
  "Civitella del Tronto": [42.77171, 13.66549],
  "Civitella di Romagna": [44.00686, 11.93826],
  "Civitella in Val di Chiana": [43.40321, 11.77091],
  "Civitella Messer Raimondo": [42.08787, 14.21556],
  "Civitella Paganico": [42.99397, 11.28162],
  "Civitella Roveto": [41.91622, 13.42688],
  "Civitella San Paolo": [42.19589, 12.5825],
  "Civo": [46.15635, 9.58121],
  "Claino con Osteno": [46.00692, 9.08434],
  "Claut": [46.26714, 12.51392],
  "Clauzetto": [46.22906, 12.91494],
  "Clavesana": [44.48215, 7.91198],
  "Claviere": [44.93862, 6.74931],
  "Cles": [46.3644, 11.03564],
  "Cleto": [39.11658, 16.16593],
  "Clivio": [45.86446, 8.93359],
  "Clusone": [45.89157, 9.94697],
  "Coassolo Torinese": [45.30071, 7.46133],
  "Coazze": [45.05142, 7.29464],
  "Coazzolo": [44.72821, 8.14514],
  "Coccaglio": [45.56238, 9.97696],
  "Cocconato": [45.08718, 8.03924],
  "Cocquio-Trevisago": [45.85788, 8.69655],
  "Cocullo": [42.03315, 13.77472],
  "Codevigo": [45.26796, 12.10332],
  "Codevilla": [44.964, 9.0555],
  "Codigoro": [44.83184, 12.10501],
  "Codogno": [45.16003, 9.70319],
  "Codognè": [45.87033, 12.4296],
  "Codroipo": [45.96181, 12.97693],
  "Codrongianos": [40.6581, 8.6801],
  "Coggiola": [45.68458, 8.18516],
  "Cogliate": [45.64575, 9.08185],
  "Cogne": [45.6081, 7.3559],
  "Cogoleto": [44.38947, 8.64633],
  "Cogollo del Cengio": [45.78633, 11.42068],
  "Cogorno": [44.32865, 9.35217],
  "Colazza": [45.79263, 8.49909],
  "Colere": [45.9739, 10.08572],
  "Colfelice": [41.55588, 13.60566],
  "Coli": [44.74342, 9.41282],
  "Colico": [46.13383, 9.37501],
  "Collalto Sabino": [42.13643, 13.04828],
  "Collarmele": [42.06133, 13.62643],
  "Collazzone": [42.89426, 12.43789],
  "Colle Brianza": [45.76169, 9.36591],
  "Colle d'Anchise": [41.50912, 14.51834],
  "Colle di Tora": [42.21208, 12.94778],
  "Colle di Val d'Elsa": [43.42121, 11.11775],
  "Colle San Magno": [41.54984, 13.69399],
  "Colle Sannita": [41.36377, 14.83296],
  "Colle Santa Lucia": [46.44729, 12.01429],
  "Colle Umberto": [45.94051, 12.34151],
  "Collebeato": [45.58567, 10.21389],
  "Collecchio": [44.7528, 10.2158],
  "Collecorvino": [42.45822, 14.01437],
  "Colledara": [42.53967, 13.67892],
  "Colledimacine": [42.00461, 14.20159],
  "Colledimezzo": [41.9857, 14.38107],
  "Colleferro": [41.73041, 13.00559],
  "Collegiove": [42.17488, 13.03707],
  "Collegno": [45.0774, 7.56913],
  "Collelongo": [41.88639, 13.58351],
  "Collepardo": [41.76119, 13.36771],
  "Collepasso": [40.07321, 18.16294],
  "Collepietro": [42.22096, 13.78056],
  "Colleretto Castelnuovo": [45.42141, 7.67898],
  "Colleretto Giacosa": [45.43289, 7.79996],
  "Collesalvetti": [43.58922, 10.47606],
  "Collesano": [37.92106, 13.93755],
  "Colletorto": [41.66318, 14.97294],
  "Collevecchio": [42.33544, 12.55272],
  "Colli a Volturno": [41.59903, 14.10392],
  "Colli al Metauro": [43.7546, 12.8982],
  "Colli del Tronto": [42.87801, 13.74816],
  "Colli sul Velino": [42.49898, 12.77971],
  "Colliano": [40.72519, 15.29243],
  "Collinas": [39.64089, 8.83685],
  "Collio": [45.81117, 10.33333],
  "Collobiano": [45.39713, 8.34854],
  "Colloredo di Monte Albano": [46.16601, 13.13797],
  "Colmurano": [43.16387, 13.35671],
  "Colobraro": [40.18798, 16.4234],
  "Cologna Veneta": [45.31069, 11.38439],
  "Cologne": [45.58561, 9.94305],
  "Cologno al Serio": [45.57941, 9.7061],
  "Cologno Monzese": [45.5298, 9.27517],
  "Colognola ai Colli": [45.43439, 11.18671],
  "Colonna": [41.83431, 12.75112],
  "Colonnella": [42.87177, 13.86757],
  "Colonno": [45.95773, 9.1541],
  "Colorina": [46.15185, 9.73346],
  "Colorno": [44.9288, 10.37565],
  "Colosimi": [39.11886, 16.39985],
  "Colturano": [45.3819, 9.34923],
  "Colverde": [45.8105, 9.00494],
  "Colzate": [45.81596, 9.85631],
  "Comabbio": [45.77264, 8.67467],
  "Comacchio": [44.69462, 12.18387],
  "Comano": [44.29723, 10.13488],
  "Comano Terme": [46.03166, 10.86885],
  "Comazzo": [45.44065, 9.46396],
  "Comeglians": [46.51358, 12.86792],
  "Comelico Superiore": [46.58875, 12.51601],
  "Comerio": [45.84262, 8.74709],
  "Comezzano-Cizzago": [45.47259, 9.94904],
  "Comignago": [45.71524, 8.56512],
  "Comiso": [36.94566, 14.60469],
  "Comitini": [37.40861, 13.64362],
  "Comiziano": [40.95251, 14.54935],
  "Commessaggio": [45.0346, 10.54534],
  "Commezzadura": [46.32122, 10.83926],
  "Como": [45.80999, 9.08516],
  "Compiano": [44.49596, 9.66243],
  "Comun Nuovo": [45.62325, 9.66474],
  "Comunanza": [42.95758, 13.41392],
  "Cona": [45.19296, 12.03912],
  "Conca Casale": [41.49446, 14.0067],
  "Conca dei Marini": [40.61788, 14.57425],
  "Conca della Campania": [41.33174, 13.99142],
  "Concamarise": [45.20736, 11.13883],
  "Concerviano": [42.32345, 12.98572],
  "Concesio": [45.60437, 10.21846],
  "Concordia Sagittaria": [45.75582, 12.84599],
  "Concordia sulla Secchia": [44.91224, 10.98281],
  "Concorezzo": [45.59106, 9.33866],
  "Condofuri": [38.00426, 15.85901],
  "Condove": [45.11714, 7.31073],
  "Condrò": [38.1757, 15.32649],
  "Conegliano": [45.88717, 12.29773],
  "Confienza": [45.33192, 8.5576],
  "Configni": [42.42363, 12.64235],
  "Conflenti": [39.0724, 16.28433],
  "Coniolo": [45.14691, 8.37205],
  "Conselice": [44.51266, 11.82906],
  "Conselve": [45.23224, 11.87569],
  "Contessa Entellina": [37.7282, 13.18404],
  "Contigliano": [42.41075, 12.76655],
  "Contrada": [40.86718, 14.77329],
  "Controguerra": [42.85567, 13.82057],
  "Controne": [40.50974, 15.20382],
  "Contursi Terme": [40.64915, 15.24109],
  "Contà": [46.3108, 11.0241],
  "Conversano": [40.96609, 17.11524],
  "Conza della Campania": [40.85725, 15.3357],
  "Conzano": [45.02054, 8.45606],
  "Copertino": [40.27186, 18.04782],
  "Copiano": [45.19748, 9.32091],
  "Copparo": [44.89548, 11.82872],
  "Corana": [45.06289, 8.96949],
  "Corato": [41.1538, 16.41327],
  "Corbara": [40.72278, 14.59253],
  "Corbetta": [45.46753, 8.9219],
  "Corbola": [45.00563, 12.07742],
  "Corchiano": [42.34559, 12.35664],
  "Corciano": [43.12855, 12.2864],
  "Cordenons": [45.98849, 12.70715],
  "Cordignano": [45.94895, 12.41545],
  "Cordovado": [45.85013, 12.88212],
  "Coreglia Antelminelli": [44.06453, 10.5253],
  "Coreglia Ligure": [44.39204, 9.26699],
  "Coreno Ausonio": [41.34629, 13.77732],
  "Corfinio": [42.12416, 13.84386],
  "Cori": [41.64242, 12.9132],
  "Coriano": [43.96441, 12.60253],
  "Corigliano d'Otranto": [40.15991, 18.26175],
  "Corinaldo": [43.64885, 13.04773],
  "Corio": [45.31274, 7.53256],
  "Corleone": [37.81204, 13.30158],
  "Corleto Monforte": [40.43759, 15.38083],
  "Corleto Perticara": [40.38382, 16.0425],
  "Cormano": [45.54301, 9.17254],
  "Cormons": [45.96066, 13.47364],
  "Corna Imagna": [45.83152, 9.54448],
  "Cornalba": [45.85024, 9.74464],
  "Cornale e Bastida": [45.0439, 8.91089],
  "Cornaredo": [45.50197, 9.02583],
  "Cornate d'Adda": [45.64876, 9.46389],
  "Cornedo all'Isarco": [46.49425, 11.39267],
  "Cornedo Vicentino": [45.61413, 11.3432],
  "Cornegliano Laudense": [45.2844, 9.47245],
  "Corneliano d'Alba": [44.73554, 7.96129],
  "Corniglio": [44.4762, 10.08869],
  "Corno di Rosazzo": [45.99682, 13.44168],
  "Corno Giovine": [45.13317, 9.75575],
  "Cornovecchio": [45.13614, 9.79762],
  "Cornuda": [45.83183, 12.00822],
  "Correggio": [44.77134, 10.78122],
  "Correzzana": [45.66785, 9.30446],
  "Correzzola": [45.2353, 12.0671],
  "Corrido": [46.04742, 9.13701],
  "Corridonia": [43.24819, 13.50887],
  "Corropoli": [42.82761, 13.83486],
  "Corsano": [39.88968, 18.3697],
  "Corsico": [45.43185, 9.10863],
  "Corsione": [45.00075, 8.14514],
  "Cortaccia sulla strada del vino": [46.31332, 11.22355],
  "Cortale": [38.84237, 16.41124],
  "Cortandone": [44.95969, 8.05757],
  "Cortanze": [45.01523, 8.08959],
  "Cortazzone": [44.97954, 8.06192],
  "Corte Brugnatella": [44.71247, 9.37972],
  "Corte de' Cortesi con Cignone": [45.27265, 10.00735],
  "Corte de' Frati": [45.22006, 10.09696],
  "Corte Franca": [45.6372, 10.00698],
  "Corte Palasio": [45.31328, 9.56277],
  "Cortemaggiore": [44.99677, 9.93103],
  "Cortemilia": [44.58086, 8.19187],
  "Corteno Golgi": [46.16597, 10.24224],
  "Cortenova": [45.99972, 9.38375],
  "Cortenuova": [45.53863, 9.7858],
  "Corteolona e Genzone": [45.1588, 9.3704],
  "Cortiglione": [44.82302, 8.35857],
  "Cortina d'Ampezzo": [46.53666, 12.1385],
  "Cortina sulla strada del vino": [46.26869, 11.22259],
  "Cortino": [42.62169, 13.50772],
  "Cortona": [43.27511, 11.98506],
  "Corvara": [42.27705, 13.88792],
  "Corvara in Badia": [46.55291, 11.87452],
  "Corvino San Quirico": [45.01556, 9.15892],
  "Corzano": [45.44425, 10.00779],
  "Coseano": [46.09681, 13.01869],
  "Cosenza": [39.29309, 16.2561],
  "Cosio d'Arroscia": [44.07582, 7.83117],
  "Cosio Valtellino": [46.13038, 9.54987],
  "Cosoleto": [38.27459, 15.92922],
  "Cossano Belbo": [44.66906, 8.19856],
  "Cossano Canavese": [45.38833, 7.99337],
  "Cossato": [45.5701, 8.1806],
  "Cosseria": [44.36851, 8.23446],
  "Cossignano": [42.98415, 13.68791],
  "Cossogno": [45.96398, 8.51002],
  "Cossoine": [40.43143, 8.71259],
  "Cossombrato": [44.99412, 8.13753],
  "Costa de' Nobili": [45.13242, 9.37879],
  "Costa di Mezzate": [45.66293, 9.79446],
  "Costa di Rovigo": [45.04881, 11.69408],
  "Costa Masnaga": [45.76962, 9.2763],
  "Costa Serina": [45.83101, 9.73922],
  "Costa Valle Imagna": [45.80079, 9.50566],
  "Costa Vescovato": [44.81821, 8.92902],
  "Costa Volpino": [45.82794, 10.09399],
  "Costabissara": [45.58545, 11.48766],
  "Costacciaro": [43.35891, 12.71192],
  "Costanzana": [45.2362, 8.37007],
  "Costarainera": [43.85454, 7.94124],
  "Costermano sul Garda": [45.58657, 10.73849],
  "Costigliole d'Asti": [44.78822, 8.18063],
  "Costigliole Saluzzo": [44.56461, 7.48494],
  "Cotignola": [44.38439, 11.94222],
  "Cotronei": [39.18959, 16.69678],
  "Cottanello": [42.40618, 12.68644],
  "Courmayeur": [45.79305, 6.97211],
  "Covo": [45.50113, 9.76854],
  "Cozzo": [45.19212, 8.6111],
  "Craco": [40.35862, 16.49379],
  "Crandola Valsassina": [46.02218, 9.3801],
  "Cravagliana": [45.84735, 8.20113],
  "Cravanzana": [44.57316, 8.12819],
  "Craveggia": [46.14064, 8.48979],
  "Creazzo": [45.53185, 11.47891],
  "Crecchio": [42.29857, 14.32676],
  "Credaro": [45.65845, 9.92901],
  "Credera Rubbiano": [45.30286, 9.65513],
  "Crema": [45.36329, 9.68736],
  "Cremella": [45.73994, 9.30341],
  "Cremenaga": [45.98924, 8.80659],
  "Cremeno": [45.93337, 9.47363],
  "Cremia": [46.0858, 9.27073],
  "Cremolino": [44.6375, 8.58584],
  "Cremona": [45.13337, 10.02421],
  "Cremosano": [45.39579, 9.64028],
  "Crescentino": [45.19233, 8.10258],
  "Crespadoro": [45.61942, 11.22603],
  "Crespiatica": [45.35706, 9.57461],
  "Crespina Lorenzana": [43.572, 10.561],
  "Crespino": [44.98332, 11.88645],
  "Cressa": [45.64799, 8.50748],
  "Crevacuore": [45.68584, 8.24713],
  "Crevalcore": [44.72264, 11.14703],
  "Crevoladossola": [46.15604, 8.30358],
  "Crispano": [40.95261, 14.28492],
  "Crispiano": [40.60523, 17.23103],
  "Crissolo": [44.6991, 7.15719],
  "Crocefieschi": [44.58482, 9.02282],
  "Crocetta del Montello": [45.82494, 12.03525],
  "Crodo": [46.22346, 8.32341],
  "Crognaleto": [42.54772, 13.47906],
  "Cropalati": [39.51563, 16.72606],
  "Cropani": [38.96821, 16.78283],
  "Crosia": [39.57011, 16.76988],
  "Crosio della Valle": [45.76163, 8.76757],
  "Crotone": [39.08037, 17.12539],
  "Crotta d'Adda": [45.16137, 9.85253],
  "Crova": [45.33004, 8.21193],
  "Croviana": [46.34464, 10.90455],
  "Crucoli": [39.42469, 17.0037],
  "Cuasso al Monte": [45.9144, 8.87982],
  "Cuccaro Vetere": [40.16404, 15.30678],
  "Cucciago": [45.73889, 9.0915],
  "Cuceglio": [45.35893, 7.81484],
  "Cuggiono": [45.50693, 8.82157],
  "Cugliate-Fabiasco": [45.94703, 8.82065],
  "Cuglieri": [40.18978, 8.56822],
  "Cugnoli": [42.3082, 13.93306],
  "Cumiana": [44.9828, 7.37438],
  "Cumignano sul Naviglio": [45.35455, 9.83632],
  "Cunardo": [45.93781, 8.80225],
  "Cuneo": [44.3933, 7.55117],
  "Cunico": [45.04044, 8.09721],
  "Cuorgnè": [45.39123, 7.64892],
  "Cupello": [42.07224, 14.6709],
  "Cupra Marittima": [43.02509, 13.85902],
  "Cupramontana": [43.44555, 13.11567],
  "Cura Carpignano": [45.21179, 9.25707],
  "Curcuris": [39.74636, 8.83141],
  "Cureggio": [45.67513, 8.46136],
  "Curiglia con Monteviasco": [46.06065, 8.80482],
  "Curinga": [38.82892, 16.31878],
  "Curino": [45.62759, 8.23589],
  "Curno": [45.69154, 9.61132],
  "Curon Venosta": [46.80669, 10.54217],
  "Cursi": [40.15011, 18.3141],
  "Curtarolo": [45.52212, 11.83222],
  "Curtatone": [45.13377, 10.71627],
  "Curti": [41.07449, 14.27656],
  "Cusago": [45.44667, 9.03351],
  "Cusano Milanino": [45.55073, 9.18157],
  "Cusano Mutri": [41.33756, 14.50879],
  "Cusino": [46.07438, 9.15275],
  "Cusio": [45.98943, 9.60348],
  "Custonaci": [38.07803, 12.67554],
  "Cutro": [39.03319, 16.98195],
  "Cutrofiano": [40.12722, 18.19991],
  "Cuveglio": [45.90597, 8.73584],
  "Cuvio": [45.89803, 8.73139],
  "Dairago": [45.5681, 8.86616],
  "Dalmine": [45.64797, 9.60117],
  "Dambel": [46.40491, 11.09302],
  "Danta di Cadore": [46.56695, 12.52005],
  "Darfo Boario Terme": [45.88347, 10.18048],
  "Dasà": [38.56537, 16.19645],
  "Davagna": [44.46474, 9.08669],
  "Daverio": [45.77711, 8.77151],
  "Davoli": [38.64896, 16.48682],
  "Dazio": [46.16072, 9.6002],
  "Decimomannu": [39.311, 8.96565],
  "Decimoputzu": [39.33508, 8.91892],
  "Decollatura": [39.04672, 16.3569],
  "Dego": [44.4496, 8.31038],
  "Deiva Marina": [44.21886, 9.52056],
  "Delebio": [46.13716, 9.45925],
  "Delia": [37.35606, 13.92763],
  "Delianuova": [38.24038, 15.91816],
  "Deliceto": [41.22268, 15.38733],
  "Dello": [45.41655, 10.07977],
  "Demonte": [44.31526, 7.29751],
  "Denice": [44.59866, 8.33401],
  "Denno": [46.27435, 11.05133],
  "Dernice": [44.7676, 9.05008],
  "Derovere": [45.11014, 10.24831],
  "Deruta": [42.98224, 12.4199],
  "Dervio": [46.07708, 9.30673],
  "Desana": [45.26873, 8.35745],
  "Desenzano del Garda": [45.46858, 10.54159],
  "Desio": [45.62012, 9.20883],
  "Desulo": [40.01123, 9.22871],
  "Diamante": [39.67633, 15.82176],
  "Diano Arentino": [43.948, 8.04227],
  "Diano Castello": [43.92418, 8.06666],
  "Diano d'Alba": [44.65139, 8.02767],
  "Diano Marina": [43.91003, 8.08179],
  "Diano San Pietro": [43.93116, 8.06879],
  "Dicomano": [43.8915, 11.52362],
  "Dignano": [46.08769, 12.93864],
  "Dimaro Folgarida": [46.3271, 10.8718],
  "Dinami": [38.52964, 16.1477],
  "Dipignano": [39.23767, 16.25225],
  "Diso": [40.00822, 18.38717],
  "Divignano": [45.66228, 8.6015],
  "Dizzasco": [45.94387, 9.10146],
  "Dobbiaco": [46.73551, 12.2202],
  "Doberdò del Lago": [45.84452, 13.54023],
  "Dogliani": [44.53009, 7.94517],
  "Dogliola": [41.94192, 14.63647],
  "Dogna": [46.44805, 13.31541],
  "Dolceacqua": [43.84812, 7.62347],
  "Dolcedo": [43.90694, 7.95178],
  "Dolcè": [45.60005, 10.8527],
  "Dolegna del Collio": [46.0317, 13.47926],
  "Dolianova": [39.37561, 9.17579],
  "Dolo": [45.42596, 12.07433],
  "Dolzago": [45.76837, 9.34365],
  "Domanico": [39.21523, 16.20735],
  "Domaso": [46.15195, 9.32847],
  "Domegge di Cadore": [46.4603, 12.41577],
  "Domicella": [40.87932, 14.58677],
  "Domodossola": [46.11529, 8.29204],
  "Domus de Maria": [38.94587, 8.86372],
  "Domusnovas": [39.32126, 8.65337],
  "Donato": [45.52829, 7.90758],
  "Dongo": [46.12303, 9.2795],
  "Donnas": [45.60348, 7.76744],
  "Donori": [39.43253, 9.12629],
  "Dorgali": [40.28929, 9.58812],
  "Dorio": [46.10173, 9.31937],
  "Dormelletto": [45.73016, 8.57318],
  "Dorno": [45.15485, 8.95195],
  "Dorzano": [45.42522, 8.09697],
  "Dosolo": [44.95375, 10.64141],
  "Dossena": [45.87917, 9.69696],
  "Dosso del Liro": [46.16368, 9.2737],
  "Doues": [45.81925, 7.30665],
  "Dovadola": [44.12162, 11.88747],
  "Dovera": [45.3635, 9.5382],
  "Dozza": [44.35944, 11.62868],
  "Dragoni": [41.2734, 14.30846],
  "Drapia": [38.66612, 15.91122],
  "Drena": [45.97117, 10.9446],
  "Drenchia": [46.17517, 13.62207],
  "Dresano": [45.37387, 9.36122],
  "Dro": [45.96255, 10.91182],
  "Dronero": [44.46698, 7.36332],
  "Druento": [45.13473, 7.5762],
  "Druogno": [46.13535, 8.43181],
  "Dualchi": [40.23038, 8.90023],
  "Dubino": [46.153, 9.46088],
  "Due Carrare": [45.29154, 11.8209],
  "Dueville": [45.63569, 11.54877],
  "Dugenta": [41.13519, 14.45373],
  "Duino Aurisina": [45.75423, 13.65969],
  "Dumenza": [46.02277, 8.78486],
  "Duno": [45.91406, 8.73854],
  "Durazzano": [41.0614, 14.4469],
  "Duronia": [41.6583, 14.45882],
  "Dusino San Michele": [44.92019, 7.97228],
  "Eboli": [40.61819, 15.05445],
  "Edolo": [46.17823, 10.33711],
  "Egna": [46.31387, 11.27283],
  "Elice": [42.51869, 13.96827],
  "Elini": [39.9, 9.53114],
  "Ello": [45.78782, 9.36569],
  "Elmas": [39.27089, 9.04885],
  "Elva": [44.53976, 7.08963],
  "Emarèse": [45.7247, 7.70044],
  "Empoli": [43.71908, 10.94718],
  "Endine Gaiano": [45.79019, 9.97649],
  "Enego": [45.93997, 11.70972],
  "Enemonzo": [46.4103, 12.87934],
  "Enna": [37.56706, 14.27909],
  "Entracque": [44.24076, 7.3978],
  "Entratico": [45.70548, 9.87477],
  "Envie": [44.68175, 7.37219],
  "Episcopia": [40.07446, 16.09814],
  "Eraclea": [45.57552, 12.67353],
  "Erba": [45.81194, 9.22318],
  "Erbezzo": [45.64171, 11.00056],
  "Erbusco": [45.59952, 9.97324],
  "Erbè": [45.24246, 10.96734],
  "Erchie": [40.43843, 17.73261],
  "Ercolano": [40.80928, 14.34571],
  "Erice": [38.0381, 12.58704],
  "Erli": [44.13656, 8.10533],
  "Erto e Casso": [46.27889, 12.37236],
  "Erula": [40.79133, 8.94169],
  "Erve": [45.82074, 9.44559],
  "Esanatoglia": [43.25146, 12.94617],
  "Escalaplano": [39.62628, 9.35509],
  "Escolca": [39.69908, 9.12371],
  "Esine": [45.92402, 10.25918],
  "Esino Lario": [45.99492, 9.33537],
  "Esperia": [41.38519, 13.68494],
  "Esporlatu": [40.38598, 8.99066],
  "Este": [45.22792, 11.65605],
  "Esterzili": [39.78062, 9.28523],
  "Etroubles": [45.8197, 7.23295],
  "Eupilio": [45.81692, 9.2677],
  "Exilles": [45.09749, 6.92962],
  "Fabbrica Curone": [44.75483, 9.15418],
  "Fabbriche di Vergemoli": [43.9973, 10.4275],
  "Fabbrico": [44.8716, 10.8095],
  "Fabriano": [43.33627, 12.90472],
  "Fabrica di Roma": [42.33473, 12.29518],
  "Fabrizia": [38.48358, 16.30309],
  "Fabro": [42.86345, 12.01294],
  "Faedis": [46.15244, 13.34411],
  "Faedo Valtellino": [46.15308, 9.90633],
  "Faenza": [44.28544, 11.8828],
  "Faeto": [41.32324, 15.16122],
  "Fagagna": [46.11326, 13.08394],
  "Faggeto Lario": [45.85808, 9.15984],
  "Faggiano": [40.42158, 17.3886],
  "Fagnano Alto": [42.25372, 13.57499],
  "Fagnano Castello": [39.56116, 16.05445],
  "Fagnano Olona": [45.6696, 8.87411],
  "Fai della Paganella": [46.17838, 11.06956],
  "Faicchio": [41.2784, 14.47949],
  "Falcade": [46.35827, 11.87276],
  "Falciano del Massico": [41.16755, 13.94886],
  "Falconara Albanese": [39.27438, 16.08828],
  "Falconara Marittima": [43.62329, 13.39393],
  "Falcone": [38.11643, 15.08229],
  "Faleria": [42.22625, 12.44319],
  "Falerna": [39.00219, 16.16835],
  "Falerone": [43.10784, 13.47391],
  "Fallo": [41.93897, 14.32239],
  "Faloppio": [45.81217, 8.9632],
  "Falvaterra": [41.50386, 13.52259],
  "Falzes": [46.81175, 11.88265],
  "Fanano": [44.2074, 10.79514],
  "Fanna": [46.18767, 12.75427],
  "Fano": [43.8434, 13.01966],
  "Fano Adriano": [42.55134, 13.53702],
  "Fara Filiorum Petri": [42.24897, 14.18612],
  "Fara Gera d'Adda": [45.55086, 9.53075],
  "Fara in Sabina": [42.20953, 12.72925],
  "Fara Novarese": [45.55512, 8.45911],
  "Fara Olivana con Sola": [45.49516, 9.74974],
  "Fara San Martino": [42.09025, 14.20545],
  "Fara Vicentino": [45.74045, 11.54623],
  "Fardella": [40.11411, 16.16671],
  "Farigliano": [44.5117, 7.91702],
  "Farindola": [42.44156, 13.82197],
  "Farini": [44.71334, 9.57071],
  "Farnese": [42.55018, 11.7245],
  "Farra d'Isonzo": [45.90713, 13.51794],
  "Farra di Soligo": [45.90543, 12.12658],
  "Fasano": [40.8344, 17.35899],
  "Fascia": [44.56449, 9.23627],
  "Fauglia": [43.567, 10.51604],
  "Faule": [44.80543, 7.58066],
  "Favale di Malvaro": [44.45204, 9.25803],
  "Favara": [37.31071, 13.65646],
  "Favignana": [37.93178, 12.32724],
  "Favria": [45.33285, 7.68801],
  "Feisoglio": [44.54336, 8.10418],
  "Feletto": [45.30549, 7.74711],
  "Felino": [44.69552, 10.24072],
  "Felitto": [40.3707, 15.24796],
  "Felizzano": [44.89804, 8.4358],
  "Feltre": [46.01783, 11.90991],
  "Fenegrò": [45.7016, 9.00273],
  "Fenestrelle": [45.0343, 7.05189],
  "Ferentillo": [42.62053, 12.78987],
  "Ferentino": [41.69232, 13.25285],
  "Ferla": [37.11861, 14.94147],
  "Fermignano": [43.67649, 12.64528],
  "Fermo": [43.16059, 13.7184],
  "Ferno": [45.61027, 8.75885],
  "Feroleto Antico": [38.96177, 16.38742],
  "Feroleto della Chiesa": [38.46609, 16.07012],
  "Ferrandina": [40.49291, 16.45683],
  "Ferrara": [44.83599, 11.61869],
  "Ferrara di Monte Baldo": [45.67567, 10.85428],
  "Ferrazzano": [41.53066, 14.67095],
  "Ferrera di Varese": [45.93233, 8.78818],
  "Ferrera Erbognone": [45.11329, 8.86377],
  "Ferrere": [44.8734, 7.99386],
  "Ferriere": [44.64567, 9.49808],
  "Ferruzzano": [38.03934, 16.08765],
  "Fiamignano": [42.26482, 13.12551],
  "Fiano": [45.21812, 7.51978],
  "Fiano Romano": [42.172, 12.59244],
  "Fiastra": [43.0368, 13.1565],
  "Fiavè": [46.00481, 10.84202],
  "Ficarazzi": [38.08835, 13.46321],
  "Ficarolo": [44.95198, 11.43256],
  "Ficarra": [38.11042, 14.82748],
  "Ficulle": [42.83632, 12.06634],
  "Fidenza": [44.86709, 10.06141],
  "Fierozzo": [46.11178, 11.31824],
  "Fiesco": [45.3364, 9.77855],
  "Fiesole": [43.80686, 11.29318],
  "Fiesse": [45.23334, 10.3217],
  "Fiesso d'Artico": [45.41658, 12.03081],
  "Fiesso Umbertiano": [44.96176, 11.60785],
  "Figino Serenza": [45.71163, 9.12719],
  "Figline e Incisa Valdarno": [43.6291, 11.4449],
  "Figline Vegliaturo": [39.22605, 16.3294],
  "Filacciano": [42.25518, 12.59771],
  "Filadelfia": [38.78356, 16.29343],
  "Filago": [45.63627, 9.55385],
  "Filandari": [38.61541, 16.03138],
  "Filattiera": [44.33128, 9.93688],
  "Filettino": [41.89024, 13.32412],
  "Filetto": [42.22593, 14.24429],
  "Filiano": [40.80923, 15.70685],
  "Filighera": [45.17734, 9.31407],
  "Filignano": [41.54512, 14.05631],
  "Filogaso": [38.68092, 16.23087],
  "Filottrano": [43.43568, 13.35128],
  "Finale Emilia": [44.83221, 11.29573],
  "Finale Ligure": [44.16902, 8.3436],
  "Fino del Monte": [45.89045, 9.99215],
  "Fino Mornasco": [45.74612, 9.04858],
  "Fiorano al Serio": [45.79948, 9.84166],
  "Fiorano Canavese": [45.46757, 7.82898],
  "Fiorano Modenese": [44.53909, 10.81142],
  "Fiorenzuola d'Arda": [44.92865, 9.90753],
  "Firenze": [43.76923, 11.25589],
  "Firenzuola": [44.1176, 11.37883],
  "Firmo": [39.72208, 16.17834],
  "Fiscaglia": [44.7988, 11.9754],
  "Fisciano": [40.77147, 14.79915],
  "Fiuggi": [41.80426, 13.22125],
  "Fiumalbo": [44.17952, 10.6474],
  "Fiumara": [38.21087, 15.69217],
  "Fiume Veneto": [45.92802, 12.73687],
  "Fiumedinisi": [38.02503, 15.38231],
  "Fiumefreddo Bruzio": [39.23589, 16.06635],
  "Fiumefreddo di Sicilia": [37.79293, 15.2082],
  "Fiumicino": [41.77221, 12.23687],
  "Fiuminata": [43.18864, 12.93168],
  "Fivizzano": [44.23706, 10.12283],
  "Fiè allo Sciliar": [46.51754, 11.5014],
  "Flaibano": [46.06005, 12.98114],
  "Flero": [45.48236, 10.17589],
  "Floresta": [37.9877, 14.90945],
  "Floridia": [37.08211, 15.15289],
  "Florinas": [40.64793, 8.6657],
  "Flumeri": [41.07341, 15.15352],
  "Fluminimaggiore": [39.4364, 8.49787],
  "Flussio": [40.26709, 8.54152],
  "Fobello": [45.88956, 8.15892],
  "Foggia": [41.46227, 15.54305],
  "Foglianise": [41.15697, 14.67156],
  "Fogliano Redipuglia": [45.86653, 13.48098],
  "Foglizzo": [45.27202, 7.82318],
  "Foiano della Chiana": [43.25249, 11.81847],
  "Foiano di Val Fortore": [41.35245, 14.97403],
  "Folgaria": [45.91663, 11.17014],
  "Folignano": [42.82104, 13.63258],
  "Foligno": [42.9557, 12.70359],
  "Follina": [45.95281, 12.11895],
  "Follo": [44.16271, 9.86215],
  "Follonica": [42.9226, 10.75988],
  "Fombio": [45.13679, 9.6836],
  "Fondachelli-Fantina": [37.98598, 15.17308],
  "Fondi": [41.35691, 13.42991],
  "Fonni": [40.12003, 9.25241],
  "Fontainemore": [45.649, 7.86097],
  "Fontana Liri": [41.61107, 13.54995],
  "Fontanafredda": [45.98891, 12.5478],
  "Fontanarosa": [41.02041, 15.02052],
  "Fontanelice": [44.25746, 11.55837],
  "Fontanella": [45.47222, 9.80045],
  "Fontanellato": [44.88246, 10.17342],
  "Fontanelle": [45.83092, 12.46824],
  "Fontaneto d'Agogna": [45.63986, 8.48458],
  "Fontanetto Po": [45.1934, 8.19172],
  "Fontanigorda": [44.54656, 9.30495],
  "Fontanile": [44.75338, 8.42219],
  "Fontaniva": [45.63638, 11.75286],
  "Fonte": [45.78794, 11.86728],
  "Fonte Nuova": [41.99627, 12.61887],
  "Fontecchio": [42.23164, 13.60659],
  "Fontechiari": [41.67003, 13.67655],
  "Fontegreca": [41.45653, 14.18385],
  "Fonteno": [45.75786, 10.01922],
  "Fontevivo": [44.85643, 10.17538],
  "Fonzaso": [46.0178, 11.7996],
  "Foppolo": [46.04394, 9.75498],
  "Forano": [42.29791, 12.59503],
  "Force": [42.963, 13.49105],
  "Forchia": [41.03021, 14.53684],
  "Forcola": [46.15823, 9.66107],
  "Fordongianus": [39.99492, 8.80797],
  "Forenza": [40.85937, 15.85714],
  "Foresto Sparso": [45.69511, 9.91368],
  "Forgaria nel Friuli": [46.22399, 12.9682],
  "Forino": [40.86174, 14.73717],
  "Forio": [40.73779, 13.85726],
  "Forlimpopoli": [44.18723, 12.12664],
  "Forlì": [44.22269, 12.04069],
  "Forlì del Sannio": [41.69525, 14.18119],
  "Formazza": [46.37673, 8.42673],
  "Formello": [42.08022, 12.40085],
  "Formia": [41.25569, 13.60593],
  "Formicola": [41.21072, 14.23299],
  "Formigara": [45.22306, 9.77074],
  "Formigine": [44.57598, 10.84019],
  "Formigliana": [45.42878, 8.29291],
  "Fornace": [46.11723, 11.2058],
  "Fornelli": [41.60635, 14.14095],
  "Forni Avoltri": [46.58518, 12.77691],
  "Forni di Sopra": [46.42382, 12.57846],
  "Forni di Sotto": [46.39363, 12.67181],
  "Forno Canavese": [45.34684, 7.58678],
  "Fornovo di Taro": [44.68926, 10.09873],
  "Fornovo San Giovanni": [45.49615, 9.6751],
  "Forte dei Marmi": [43.96018, 10.16671],
  "Fortezza": [46.78645, 11.61256],
  "Fortunago": [44.9216, 9.18469],
  "Forza d'Agrò": [37.91411, 15.33513],
  "Fosciandora": [44.11524, 10.45541],
  "Fosdinovo": [44.13438, 10.01906],
  "Fossa": [42.2933, 13.48782],
  "Fossacesia": [42.24538, 14.48006],
  "Fossalta di Piave": [45.64583, 12.51122],
  "Fossalta di Portogruaro": [45.79293, 12.90745],
  "Fossalto": [41.67319, 14.54519],
  "Fossano": [44.5494, 7.72487],
  "Fossato di Vico": [43.29434, 12.76165],
  "Fossato Serralta": [38.99573, 16.57984],
  "Fossombrone": [43.68885, 12.80571],
  "Fossò": [45.38586, 12.04802],
  "Foza": [45.89625, 11.63076],
  "Frabosa Soprana": [44.28747, 7.80709],
  "Frabosa Sottana": [44.30203, 7.79831],
  "Fraconalto": [44.59216, 8.87796],
  "Fragagnano": [40.4319, 17.47455],
  "Fragneto l'Abate": [41.25561, 14.782],
  "Fragneto Monforte": [41.24634, 14.76342],
  "Fraine": [41.90476, 14.48694],
  "Framura": [44.20892, 9.55436],
  "Francavilla al Mare": [42.41767, 14.29182],
  "Francavilla Angitola": [38.77802, 16.27067],
  "Francavilla Bisio": [44.73589, 8.73166],
  "Francavilla d'Ete": [43.191, 13.53995],
  "Francavilla di Sicilia": [37.90125, 15.13614],
  "Francavilla Fontana": [40.53288, 17.58338],
  "Francavilla in Sinni": [40.08168, 16.20324],
  "Francavilla Marittima": [39.81978, 16.38751],
  "Francica": [38.61831, 16.10169],
  "Francofonte": [37.23078, 14.88013],
  "Francolise": [41.18522, 14.05619],
  "Frascaro": [44.82711, 8.53265],
  "Frascarolo": [45.0469, 8.6828],
  "Frascati": [41.80599, 12.68079],
  "Frascineto": [39.83697, 16.26281],
  "Frassilongo": [46.08566, 11.29212],
  "Frassinelle Polesine": [44.99672, 11.6977],
  "Frassinello Monferrato": [45.03151, 8.38661],
  "Frassineto Po": [45.13402, 8.5361],
  "Frassinetto": [45.43603, 7.60568],
  "Frassino": [44.57136, 7.27564],
  "Frassinoro": [44.29537, 10.57313],
  "Frasso Sabino": [42.22967, 12.80531],
  "Frasso Telesino": [41.15753, 14.5274],
  "Fratta Polesine": [45.03169, 11.641],
  "Fratta Todina": [42.85754, 12.36643],
  "Frattamaggiore": [40.9412, 14.27258],
  "Frattaminore": [40.95565, 14.2709],
  "Fratte Rosa": [43.63196, 12.90097],
  "Frazzanò": [38.07234, 14.74475],
  "Fregona": [46.00747, 12.33942],
  "Fresagrandinaria": [41.97558, 14.66316],
  "Fresonara": [44.78274, 8.68484],
  "Frigento": [41.01199, 15.09769],
  "Frignano": [40.99497, 14.1795],
  "Frinco": [45.00559, 8.17537],
  "Frisa": [42.26097, 14.37062],
  "Frisanco": [46.21259, 12.72383],
  "Front": [45.27955, 7.6656],
  "Frontino": [43.76458, 12.37744],
  "Frontone": [43.51462, 12.73891],
  "Frosinone": [41.63965, 13.35117],
  "Frosolone": [41.60154, 14.44913],
  "Frossasco": [44.93362, 7.35077],
  "Frugarolo": [44.83899, 8.67906],
  "Fubine Monferrato": [44.96556, 8.42541],
  "Fucecchio": [43.72861, 10.81009],
  "Fuipiano Valle Imagna": [45.8571, 9.52497],
  "Fumane": [45.54317, 10.88211],
  "Fumone": [41.72795, 13.28946],
  "Funes": [46.64227, 11.68057],
  "Furci": [42.00849, 14.58655],
  "Furci Siculo": [37.9609, 15.37997],
  "Furnari": [38.10475, 15.12549],
  "Furore": [40.62023, 14.55018],
  "Furtei": [39.56298, 8.9439],
  "Fuscaldo": [39.41626, 16.03135],
  "Fusignano": [44.46802, 11.9593],
  "Fusine": [46.14947, 9.75011],
  "Futani": [40.15156, 15.32366],
  "Fénis": [45.7361, 7.4943],
  "Gabbioneta-Binanuova": [45.21582, 10.22168],
  "Gabiano": [45.15894, 8.19315],
  "Gabicce Mare": [43.96659, 12.75648],
  "Gaby": [45.71286, 7.88235],
  "Gadesco-Pieve Delmona": [45.1553, 10.11603],
  "Gadoni": [39.91271, 9.18309],
  "Gaeta": [41.21336, 13.57196],
  "Gaggi": [37.86086, 15.22056],
  "Gaggiano": [45.40572, 9.03452],
  "Gaggio Montano": [44.199, 10.93625],
  "Gaglianico": [45.5394, 8.07472],
  "Gagliano Aterno": [42.12626, 13.70086],
  "Gagliano Castelferrato": [37.71032, 14.53558],
  "Gagliano del Capo": [39.84653, 18.36948],
  "Gagliato": [38.67682, 16.46351],
  "Gagliole": [43.23946, 13.06808],
  "Gaiarine": [45.88046, 12.48168],
  "Gaiba": [44.9483, 11.4816],
  "Gaiola": [44.33525, 7.40676],
  "Gaiole in Chianti": [43.46876, 11.43348],
  "Gairo": [39.84763, 9.50619],
  "Gais": [46.83528, 11.94773],
  "Galati Mamertino": [38.03303, 14.77102],
  "Galatina": [40.17396, 18.17228],
  "Galatone": [40.14845, 18.07168],
  "Galatro": [38.46027, 16.10849],
  "Galbiate": [45.81435, 9.37444],
  "Galeata": [43.99642, 11.91037],
  "Galgagnano": [45.35788, 9.44296],
  "Gallarate": [45.66018, 8.7933],
  "Gallese": [42.37241, 12.40449],
  "Galliate": [45.4777, 8.69527],
  "Galliate Lombardo": [45.78629, 8.76853],
  "Galliavola": [45.09718, 8.81863],
  "Gallicano": [44.06047, 10.43566],
  "Gallicano nel Lazio": [41.87004, 12.82256],
  "Gallicchio": [40.28892, 16.13855],
  "Galliera": [44.74474, 11.43594],
  "Galliera Veneta": [45.66282, 11.82945],
  "Gallinaro": [41.65778, 13.79864],
  "Gallio": [45.89237, 11.54916],
  "Gallipoli": [40.05318, 17.97423],
  "Gallo Matese": [41.46499, 14.22519],
  "Gallodoro": [37.90168, 15.29382],
  "Galluccio": [41.34148, 13.95613],
  "Galtellì": [40.38663, 9.61671],
  "Galzignano Terme": [45.30858, 11.72825],
  "Gamalero": [44.80892, 8.54305],
  "Gambara": [45.25386, 10.29779],
  "Gambarana": [45.02873, 8.7628],
  "Gambasca": [44.62937, 7.34741],
  "Gambassi Terme": [43.53862, 10.95316],
  "Gambatesa": [41.50927, 14.91403],
  "Gambellara": [45.46025, 11.34145],
  "Gamberale": [41.90547, 14.20754],
  "Gambettola": [44.12001, 12.33907],
  "Gambolò": [45.2498, 8.86159],
  "Gambugliano": [45.58871, 11.44008],
  "Gandellino": [45.99066, 9.94595],
  "Gandino": [45.81129, 9.904],
  "Gandosso": [45.66236, 9.8899],
  "Gangi": [37.79815, 14.20525],
  "Garaguso": [40.54882, 16.22717],
  "Garbagna": [44.78094, 8.99904],
  "Garbagna Novarese": [45.38665, 8.65968],
  "Garbagnate Milanese": [45.57561, 9.07749],
  "Garbagnate Monastero": [45.77238, 9.30267],
  "Garda": [45.57497, 10.70702],
  "Gardone Riviera": [45.62009, 10.55799],
  "Gardone Val Trompia": [45.68909, 10.18222],
  "Garessio": [44.19729, 8.02988],
  "Gargallo": [45.7275, 8.42922],
  "Gargazzone": [46.58472, 11.20132],
  "Gargnano": [45.68981, 10.65994],
  "Garlasco": [45.19638, 8.92354],
  "Garlate": [45.80427, 9.40409],
  "Garlenda": [44.0336, 8.0968],
  "Garniga Terme": [46.00483, 11.08589],
  "Garzeno": [46.13409, 9.24986],
  "Garzigliana": [44.83678, 7.37473],
  "Gasperina": [38.73926, 16.50959],
  "Gassino Torinese": [45.12745, 7.8249],
  "Gattatico": [44.80623, 10.47375],
  "Gatteo": [44.10962, 12.38611],
  "Gattinara": [45.61734, 8.37128],
  "Gavardo": [45.58673, 10.43468],
  "Gavello": [45.02151, 11.91424],
  "Gaverina Terme": [45.75834, 9.88616],
  "Gavi": [44.6883, 8.80361],
  "Gavignano": [41.69808, 13.0526],
  "Gavirate": [45.84113, 8.72477],
  "Gavoi": [40.1588, 9.19498],
  "Gavorrano": [42.92519, 10.90568],
  "Gazoldo degli Ippoliti": [45.19989, 10.57958],
  "Gazzada Schianno": [45.78025, 8.82558],
  "Gazzaniga": [45.79743, 9.83573],
  "Gazzo": [45.58228, 11.70734],
  "Gazzo Veronese": [45.1425, 11.10362],
  "Gazzola": [44.9593, 9.54713],
  "Gazzuolo": [45.06885, 10.58185],
  "Gela": [37.06545, 14.25035],
  "Gemmano": [43.90433, 12.58283],
  "Gemona del Friuli": [46.27701, 13.13974],
  "Gemonio": [45.87742, 8.67885],
  "Genazzano": [41.83172, 12.97235],
  "Genga": [43.4296, 12.9351],
  "Genivolta": [45.33487, 9.87778],
  "Genola": [44.58769, 7.66273],
  "Genoni": [39.7945, 9.00985],
  "Genova": [44.41149, 8.9327],
  "Genuri": [39.7428, 8.92316],
  "Genzano di Lucania": [40.85036, 16.03154],
  "Genzano di Roma": [41.7069, 12.69132],
  "Gera Lario": [46.17063, 9.3711],
  "Gerace": [38.2716, 16.21816],
  "Geraci Siculo": [37.85899, 14.15415],
  "Gerano": [41.93382, 12.99397],
  "Gerenzago": [45.20356, 9.3622],
  "Gerenzano": [45.63844, 8.99858],
  "Gergei": [39.69955, 9.10176],
  "Germagnano": [45.26218, 7.46686],
  "Germagno": [45.89248, 8.38796],
  "Germignaga": [45.9934, 8.7268],
  "Gerocarne": [38.58715, 16.22069],
  "Gerola Alta": [46.06003, 9.55023],
  "Gerre de' Caprioli": [45.10681, 10.03838],
  "Gesico": [39.61514, 9.10637],
  "Gessate": [45.55549, 9.43675],
  "Gessopalena": [42.05635, 14.27375],
  "Gesturi": [39.73325, 9.0228],
  "Gesualdo": [41.00659, 15.07043],
  "Ghedi": [45.4022, 10.27693],
  "Ghemme": [45.59781, 8.42009],
  "Ghiffa": [45.95635, 8.61707],
  "Ghilarza": [40.12146, 8.83469],
  "Ghisalba": [45.59162, 9.75444],
  "Ghislarengo": [45.52932, 8.38432],
  "Giacciano con Baruchella": [45.06536, 11.45064],
  "Giaglione": [45.13969, 7.01414],
  "Gianico": [45.86531, 10.18397],
  "Giano dell'Umbria": [42.83371, 12.57718],
  "Giano Vetusto": [41.20408, 14.19311],
  "Giardinello": [38.08861, 13.15678],
  "Giardini-Naxos": [37.84023, 15.27742],
  "Giarole": [45.06065, 8.56786],
  "Giarratana": [37.04828, 14.79303],
  "Giarre": [37.73004, 15.1845],
  "Giave": [40.45202, 8.75054],
  "Giaveno": [45.04475, 7.35309],
  "Giavera del Montello": [45.79379, 12.16929],
  "Giba": [39.07134, 8.63609],
  "Gibellina": [37.80994, 12.86982],
  "Gifflenga": [45.49328, 8.23164],
  "Giffone": [38.43887, 16.15],
  "Giffoni Sei Casali": [40.71885, 14.90366],
  "Giffoni Valle Piana": [40.7175, 14.94331],
  "Gignese": [45.86057, 8.50989],
  "Gignod": [45.77825, 7.29618],
  "Gildone": [41.50953, 14.74023],
  "Gimigliano": [38.97544, 16.52912],
  "Ginestra": [40.93049, 15.73408],
  "Ginestra degli Schiavoni": [41.27943, 15.04238],
  "Ginosa": [40.57761, 16.75757],
  "Gioi": [40.28989, 15.21751],
  "Gioia dei Marsi": [41.95423, 13.69322],
  "Gioia del Colle": [40.80069, 16.92407],
  "Gioia Sannitica": [41.29965, 14.44381],
  "Gioia Tauro": [38.42988, 15.8973],
  "Gioiosa Ionica": [38.33632, 16.30252],
  "Gioiosa Marea": [38.17199, 14.89284],
  "Giove": [42.50929, 12.32505],
  "Giovinazzo": [41.18811, 16.67262],
  "Giovo": [46.15683, 11.15168],
  "Girasole": [39.95337, 9.66135],
  "Girifalco": [38.82241, 16.42555],
  "Gissi": [42.02082, 14.54653],
  "Giuggianello": [40.09395, 18.36869],
  "Giugliano in Campania": [40.92833, 14.20109],
  "Giuliana": [37.67427, 13.23787],
  "Giuliano di Roma": [41.53983, 13.27971],
  "Giuliano Teatino": [42.29314, 14.27543],
  "Giulianova": [42.75266, 13.95672],
  "Giungano": [40.3945, 15.10792],
  "Giurdignano": [40.12374, 18.43113],
  "Giussago": [45.28429, 9.13994],
  "Giussano": [45.69142, 9.20493],
  "Giustenice": [44.17233, 8.24622],
  "Giustino": [46.14878, 10.76848],
  "Giusvalla": [44.44948, 8.39373],
  "Givoletto": [45.15878, 7.49677],
  "Gizzeria": [38.97907, 16.20812],
  "Glorenza": [46.67117, 10.55568],
  "Godega di Sant'Urbano": [45.93173, 12.3978],
  "Godiasco Salice Terme": [44.89757, 9.05797],
  "Godrano": [37.90304, 13.42862],
  "Goito": [45.25522, 10.67547],
  "Golasecca": [45.69686, 8.6551],
  "Golferenzo": [44.96176, 9.30697],
  "Golfo Aranci": [41.00152, 9.62237],
  "Gombito": [45.26223, 9.73002],
  "Gonars": [45.89657, 13.23508],
  "Goni": [39.57811, 9.28645],
  "Gonnesa": [39.26515, 8.47142],
  "Gonnoscodina": [39.70069, 8.83584],
  "Gonnosfanadiga": [39.4934, 8.66171],
  "Gonnosnò": [39.76003, 8.87191],
  "Gonnostramatza": [39.68011, 8.83143],
  "Gonzaga": [44.95475, 10.82119],
  "Gordona": [46.29169, 9.36859],
  "Gorga": [41.65594, 13.11079],
  "Gorgo al Monticano": [45.78547, 12.55434],
  "Gorgoglione": [40.39461, 16.14311],
  "Gorgonzola": [45.53026, 9.40541],
  "Goriano Sicoli": [42.07983, 13.77339],
  "Gorizia": [45.9415, 13.62213],
  "Gorla Maggiore": [45.66609, 8.89352],
  "Gorla Minore": [45.64326, 8.89651],
  "Gorlago": [45.67653, 9.82917],
  "Gorle": [45.70243, 9.71878],
  "Gornate Olona": [45.73775, 8.8591],
  "Gorno": [45.8628, 9.8434],
  "Goro": [44.85382, 12.30276],
  "Gorreto": [44.60497, 9.29209],
  "Gorzegno": [44.51186, 8.13512],
  "Gosaldo": [46.22055, 11.95622],
  "Gossolengo": [45.00441, 9.61405],
  "Gottasecca": [44.4617, 8.16725],
  "Gottolengo": [45.29173, 10.27152],
  "Govone": [44.80486, 8.09996],
  "Gozzano": [45.74756, 8.43465],
  "Gradara": [43.94078, 12.773],
  "Gradisca d'Isonzo": [45.88889, 13.50376],
  "Grado": [45.67547, 13.38647],
  "Gradoli": [42.64374, 11.85609],
  "Graffignana": [45.21132, 9.45327],
  "Graffignano": [42.57319, 12.2048],
  "Graglia": [45.55789, 7.98112],
  "Gragnano": [40.68983, 14.52098],
  "Gragnano Trebbiense": [45.01213, 9.56912],
  "Grammichele": [37.21501, 14.63724],
  "Grana": [44.99805, 8.29912],
  "Granarolo dell'Emilia": [44.55342, 11.4477],
  "Grandate": [45.77389, 9.0583],
  "Grandola ed Uniti": [46.03132, 9.20713],
  "Graniti": [37.89133, 15.22671],
  "Granozzo con Monticello": [45.36014, 8.57414],
  "Grantola": [45.94961, 8.77077],
  "Grantorto": [45.59928, 11.73106],
  "Granze": [45.15431, 11.71328],
  "Grassano": [40.63354, 16.28428],
  "Grassobbio": [45.65484, 9.7277],
  "Gratteri": [37.96731, 13.97307],
  "Gravedona ed Uniti": [46.14811, 9.30623],
  "Gravellona Lomellina": [45.32885, 8.764],
  "Gravellona Toce": [45.92759, 8.43142],
  "Gravere": [45.12392, 7.02107],
  "Gravina di Catania": [37.56058, 15.06213],
  "Gravina in Puglia": [40.81941, 16.41621],
  "Grazzanise": [41.0902, 14.09823],
  "Grazzano Badoglio": [45.03892, 8.31356],
  "Greccio": [42.45369, 12.7691],
  "Greci": [41.24966, 15.16973],
  "Greggio": [45.4518, 8.38248],
  "Gremiasco": [44.79705, 9.10474],
  "Gressan": [45.72162, 7.28944],
  "Gressoney-La-Trinité": [45.82724, 7.82309],
  "Gressoney-Saint-Jean": [45.777, 7.82759],
  "Greve in Chianti": [43.58325, 11.31716],
  "Grezzago": [45.59198, 9.49442],
  "Grezzana": [45.54637, 11.04763],
  "Griante": [45.99694, 9.23501],
  "Gricignano di Aversa": [40.98152, 14.23286],
  "Grignasco": [45.6819, 8.33971],
  "Grigno": [46.01718, 11.63562],
  "Grimacco": [46.15642, 13.59339],
  "Grimaldi": [39.13972, 16.23468],
  "Grinzane Cavour": [44.65654, 7.98221],
  "Grisignano di Zocco": [45.47536, 11.69882],
  "Grisolia": [39.72645, 15.85376],
  "Grizzana Morandi": [44.25551, 11.15075],
  "Grognardo": [44.62994, 8.49151],
  "Gromo": [45.97039, 9.9299],
  "Grondona": [44.6972, 8.96254],
  "Grone": [45.72721, 9.90882],
  "Grontardo": [45.2014, 10.15162],
  "Gropello Cairoli": [45.17718, 8.99215],
  "Gropparello": [44.83228, 9.73033],
  "Groscavallo": [45.36895, 7.2823],
  "Grosio": [46.2973, 10.27572],
  "Grosotto": [46.27878, 10.25713],
  "Grosseto": [42.76027, 11.11356],
  "Grosso": [45.25637, 7.55663],
  "Grottaferrata": [41.78846, 12.66773],
  "Grottaglie": [40.53345, 17.42624],
  "Grottaminarda": [41.07097, 15.0601],
  "Grottammare": [42.98846, 13.86834],
  "Grottazzolina": [43.111, 13.60101],
  "Grotte": [37.40255, 13.69918],
  "Grotte di Castro": [42.67395, 11.87024],
  "Grotteria": [38.36846, 16.2652],
  "Grottole": [40.60201, 16.37666],
  "Grottolella": [40.97233, 14.78616],
  "Gruaro": [45.83072, 12.84003],
  "Grugliasco": [45.06211, 7.5778],
  "Grumello Cremonese ed Uniti": [45.19325, 9.86736],
  "Grumello del Monte": [45.63402, 9.86977],
  "Grumento Nova": [40.28241, 15.88806],
  "Grumo Appula": [41.01221, 16.71065],
  "Grumo Nevano": [40.93825, 14.25975],
  "Grumolo delle Abbadesse": [45.51623, 11.65898],
  "Guagnano": [40.40343, 17.94936],
  "Gualdo": [43.06736, 13.33794],
  "Gualdo Cattaneo": [42.90919, 12.55584],
  "Gualdo Tadino": [43.23095, 12.78483],
  "Gualtieri": [44.90496, 10.62949],
  "Gualtieri Sicaminò": [38.16307, 15.31676],
  "Guamaggiore": [39.56679, 9.07354],
  "Guanzate": [45.72431, 9.01095],
  "Guarcino": [41.79952, 13.3139],
  "Guarda Veneta": [44.97979, 11.80264],
  "Guardabosone": [45.70094, 8.25032],
  "Guardamiglio": [45.10906, 9.68131],
  "Guardavalle": [38.5059, 16.50627],
  "Guardea": [42.62353, 12.29724],
  "Guardia Lombardi": [40.95466, 15.20765],
  "Guardia Perticara": [40.36358, 16.09803],
  "Guardia Piemontese": [39.4652, 15.99969],
  "Guardia Sanframondi": [41.25652, 14.60001],
  "Guardiagrele": [42.19114, 14.22021],
  "Guardialfiera": [41.80251, 14.7933],
  "Guardiaregia": [41.43521, 14.54138],
  "Guardistallo": [43.31333, 10.63299],
  "Guarene": [44.7378, 8.03367],
  "Guasila": [39.56156, 9.04555],
  "Guastalla": [44.9224, 10.65404],
  "Guazzora": [45.0136, 8.84491],
  "Gubbio": [43.35352, 12.57876],
  "Gudo Visconti": [45.3732, 8.99925],
  "Guglionesi": [41.9107, 14.91394],
  "Guidizzolo": [45.31803, 10.58353],
  "Guidonia Montecelio": [42.00008, 12.72639],
  "Guiglia": [44.42798, 10.95727],
  "Guilmi": [41.99703, 14.47597],
  "Gurro": [46.08596, 8.57011],
  "Guspini": [39.53862, 8.62723],
  "Gussago": [45.59242, 10.15315],
  "Gussola": [45.00988, 10.34636],
  "Hône": [45.61186, 7.73573],
  "Idro": [45.73702, 10.47401],
  "Iglesias": [39.30993, 8.53147],
  "Igliano": [44.44353, 8.0125],
  "Ilbono": [39.89374, 9.54178],
  "Illasi": [45.46593, 11.18419],
  "Illorai": [40.35444, 9.00211],
  "Imbersago": [45.70529, 9.44461],
  "Imer": [46.15109, 11.7968],
  "Imola": [44.35307, 11.71416],
  "Imperia": [43.88571, 8.02785],
  "Impruneta": [43.68574, 11.25441],
  "Inarzo": [45.78678, 8.73643],
  "Incisa Scapaccino": [44.8084, 8.38095],
  "Incudine": [46.22211, 10.35819],
  "Induno Olona": [45.85197, 8.83857],
  "Ingria": [45.46629, 7.57086],
  "Intragna": [45.9953, 8.57634],
  "Introbio": [45.97631, 9.4518],
  "Introd": [45.69147, 7.18722],
  "Introdacqua": [42.00769, 13.89919],
  "Inverigo": [45.73293, 9.21494],
  "Inverno e Monteleone": [45.19858, 9.38426],
  "Inverso Pinasca": [44.94723, 7.21596],
  "Inveruno": [45.51294, 8.8536],
  "Invorio": [45.75591, 8.48674],
  "Inzago": [45.54115, 9.48225],
  "Ionadi": [38.62782, 16.05445],
  "Irgoli": [40.40932, 9.63053],
  "Irma": [45.7712, 10.28385],
  "Irsina": [40.74569, 16.24315],
  "Isasca": [44.58729, 7.38155],
  "Isca sullo Ionio": [38.60056, 16.51898],
  "Ischia": [40.74143, 13.94133],
  "Ischia di Castro": [42.54417, 11.75781],
  "Ischitella": [41.90431, 15.89974],
  "Iseo": [45.65983, 10.05004],
  "Isera": [45.88708, 11.00835],
  "Isernia": [41.58801, 14.22575],
  "Isili": [39.74181, 9.10666],
  "Isnello": [37.94398, 14.00607],
  "Isola d'Asti": [44.82948, 8.17721],
  "Isola del Cantone": [44.64585, 8.95597],
  "Isola del Giglio": [42.36571, 10.9009],
  "Isola del Gran Sasso d'Italia": [42.50254, 13.66201],
  "Isola del Liri": [41.67842, 13.57497],
  "Isola del Piano": [43.73716, 12.78293],
  "Isola della Scala": [45.27366, 11.00754],
  "Isola delle Femmine": [38.20059, 13.24621],
  "Isola di Capo Rizzuto": [38.95903, 17.09565],
  "Isola di Fondra": [45.98079, 9.74751],
  "Isola Dovarese": [45.17346, 10.31184],
  "Isola Rizza": [45.29144, 11.19871],
  "Isola Sant'Antonio": [45.03087, 8.85041],
  "Isola Vicentina": [45.62964, 11.44151],
  "Isolabella": [44.90664, 7.90927],
  "Isolabona": [43.87999, 7.63886],
  "Isole Tremiti": [42.12042, 15.50437],
  "Isorella": [45.30756, 10.31666],
  "Ispani": [40.08578, 15.56175],
  "Ispica": [36.78618, 14.90352],
  "Ispra": [45.81617, 8.61027],
  "Issiglio": [45.44681, 7.75416],
  "Issime": [45.68545, 7.85422],
  "Isso": [45.4763, 9.75897],
  "Issogne": [45.65395, 7.68442],
  "Istrana": [45.67767, 12.10328],
  "Itala": [38.05061, 15.43732],
  "Itri": [41.29092, 13.53126],
  "Ittireddu": [40.54399, 8.90206],
  "Ittiri": [40.59414, 8.56881],
  "Ivrea": [45.46619, 7.87597],
  "Izano": [45.35573, 9.75509],
  "Jacurso": [38.84737, 16.37859],
  "Jelsi": [41.51841, 14.7961],
  "Jenne": [41.88747, 13.16781],
  "Jerago con Orago": [45.70525, 8.79254],
  "Jerzu": [39.79284, 9.51852],
  "Jesi": [43.52282, 13.24383],
  "Jesolo": [45.5335, 12.63646],
  "Jolanda di Savoia": [44.88615, 11.97451],
  "Joppolo": [38.58391, 15.89747],
  "Joppolo Giancaxio": [37.38775, 13.5541],
  "Jovençan": [45.71396, 7.27498],
  "L'Aquila": [42.35122, 13.39844],
  "La Cassa": [45.18182, 7.51913],
  "La Loggia": [44.95668, 7.66771],
  "La Maddalena": [41.21292, 9.40661],
  "La Magdeleine": [45.8108, 7.6191],
  "La Morra": [44.63735, 7.93346],
  "La Salle": [45.74689, 7.0726],
  "La Spezia": [44.10705, 9.82819],
  "La Thuile": [45.71683, 6.94907],
  "La Valle": [46.65662, 11.92581],
  "La Valle Agordina": [46.28216, 12.0681],
  "La Valletta Brianza": [45.7386, 9.3641],
  "Labico": [41.78563, 12.88607],
  "Labro": [42.52577, 12.80017],
  "Lacchiarella": [45.32118, 9.13737],
  "Lacco Ameno": [40.75452, 13.88439],
  "Lacedonia": [41.04945, 15.42476],
  "Laces": [46.61764, 10.85947],
  "Laconi": [39.85394, 9.05224],
  "Ladispoli": [41.95488, 12.06999],
  "Laerru": [40.81825, 8.83598],
  "Laganadi": [38.17444, 15.74196],
  "Laghi": [45.82422, 11.27324],
  "Laglio": [45.88352, 9.14007],
  "Lagnasco": [44.62466, 7.55534],
  "Lago": [39.16655, 16.1491],
  "Lagonegro": [40.12255, 15.76315],
  "Lagosanto": [44.76541, 12.141],
  "Lagundo": [46.67754, 11.11776],
  "Laigueglia": [43.97462, 8.15814],
  "Lainate": [45.57146, 9.02714],
  "Laino": [45.9833, 9.07386],
  "Laino Borgo": [39.95478, 15.9723],
  "Laino Castello": [39.93445, 15.97444],
  "Laion": [46.60876, 11.5646],
  "Laives": [46.42649, 11.33847],
  "Lajatico": [43.47508, 10.72851],
  "Lallio": [45.66732, 9.62688],
  "Lama dei Peligni": [42.04248, 14.18876],
  "Lama Mocogno": [44.30831, 10.73062],
  "Lambrugo": [45.75847, 9.24151],
  "Lamezia Terme": [38.97522, 16.31939],
  "Lamon": [46.04727, 11.74863],
  "Lampedusa e Linosa": [35.50196, 12.60984],
  "Lamporecchio": [43.81697, 10.89679],
  "Lamporo": [45.23008, 8.09755],
  "Lana": [46.61611, 11.14529],
  "Lanciano": [42.23133, 14.39041],
  "Landiona": [45.49691, 8.42217],
  "Landriano": [45.31128, 9.25959],
  "Langhirano": [44.61445, 10.26642],
  "Langosco": [45.21533, 8.56284],
  "Lanusei": [39.87683, 9.5423],
  "Lanuvio": [41.67977, 12.70298],
  "Lanzada": [46.26939, 9.87391],
  "Lanzo Torinese": [45.27232, 7.47662],
  "Lapedona": [43.10975, 13.77215],
  "Lapio": [40.98449, 14.94786],
  "Lappano": [39.31927, 16.31383],
  "Larciano": [43.82466, 10.87719],
  "Lardirago": [45.23544, 9.23438],
  "Lariano": [41.72792, 12.83261],
  "Larino": [41.8002, 14.91074],
  "Las Plassas": [39.67834, 8.98359],
  "Lasa": [46.61787, 10.69756],
  "Lascari": [37.99988, 13.94112],
  "Lasnigo": [45.88069, 9.26407],
  "Lastebasse": [45.91615, 11.26973],
  "Lastra a Signa": [43.77012, 11.10606],
  "Latera": [42.62641, 11.82843],
  "Laterza": [40.62248, 16.79904],
  "Latiano": [40.55458, 17.71636],
  "Latina": [41.46759, 12.90368],
  "Latisana": [45.77596, 12.99529],
  "Latronico": [40.08856, 16.00907],
  "Lattarico": [39.46209, 16.1366],
  "Lauco": [46.42341, 12.93417],
  "Laureana Cilento": [40.3009, 15.03891],
  "Laureana di Borrello": [38.48956, 16.08188],
  "Lauregno": [46.45421, 11.06225],
  "Laurenzana": [40.45947, 15.97217],
  "Lauria": [40.04729, 15.83691],
  "Lauriano": [45.15846, 7.99167],
  "Laurino": [40.33674, 15.33665],
  "Laurito": [40.16853, 15.40827],
  "Lauro": [40.87828, 14.63235],
  "Lavagna": [44.30716, 9.34404],
  "Lavagno": [45.44067, 11.13167],
  "Lavarone": [45.93939, 11.2697],
  "Lavello": [41.04996, 15.80105],
  "Lavena Ponte Tresa": [45.96093, 8.86108],
  "Laveno-Mombello": [45.91579, 8.61536],
  "Lavenone": [45.73901, 10.43797],
  "Laviano": [40.78461, 15.30507],
  "Lavis": [46.13972, 11.11173],
  "Lazise": [45.50507, 10.73247],
  "Lazzate": [45.66878, 9.08419],
  "Lecce": [40.35354, 18.17191],
  "Lecce nei Marsi": [41.93295, 13.6872],
  "Lecco": [45.85576, 9.39339],
  "Ledro": [45.88871, 10.73311],
  "Leffe": [45.7998, 9.88526],
  "Leggiuno": [45.87563, 8.61933],
  "Legnago": [45.19139, 11.30752],
  "Legnano": [45.59414, 8.91855],
  "Legnaro": [45.34399, 11.96357],
  "Lei": [40.30752, 8.92023],
  "Leini": [45.18394, 7.71511],
  "Leivi": [44.34552, 9.31822],
  "Lemie": [45.22856, 7.29288],
  "Lendinara": [45.08347, 11.59869],
  "Leni": [38.55495, 14.82417],
  "Lenna": [45.94318, 9.6773],
  "Leno": [45.3675, 10.21742],
  "Lenola": [41.40949, 13.46182],
  "Lenta": [45.55556, 8.38445],
  "Lentate sul Seveso": [45.67822, 9.11924],
  "Lentella": [41.99721, 14.67654],
  "Lentini": [37.28451, 14.99934],
  "Leonessa": [42.56149, 12.9639],
  "Leonforte": [37.63918, 14.39207],
  "Leporano": [40.38387, 17.33264],
  "Lequile": [40.30715, 18.14099],
  "Lequio Berria": [44.6046, 8.09767],
  "Lequio Tanaro": [44.56023, 7.8836],
  "Lercara Friddi": [37.74749, 13.60284],
  "Lerici": [44.07603, 9.91098],
  "Lerma": [44.63497, 8.71252],
  "Lesa": [45.83011, 8.56484],
  "Lesegno": [44.40123, 7.96651],
  "Lesignano de' Bagni": [44.64403, 10.30166],
  "Lesina": [41.86339, 15.35506],
  "Lesmo": [45.64638, 9.30248],
  "Lessolo": [45.47616, 7.81422],
  "Lessona": [45.5861, 8.1962],
  "Lestizza": [45.95761, 13.14084],
  "Letino": [41.45233, 14.24998],
  "Letojanni": [37.88031, 15.30626],
  "Lettere": [40.70441, 14.54461],
  "Lettomanoppello": [42.23688, 14.03619],
  "Lettopalena": [42.00307, 14.1581],
  "Levanto": [44.16998, 9.61246],
  "Levate": [45.62522, 9.62447],
  "Leverano": [40.28662, 17.99624],
  "Levice": [44.53766, 8.15662],
  "Levico Terme": [46.01101, 11.30233],
  "Levone": [45.3181, 7.6059],
  "Lezzeno": [45.94546, 9.19109],
  "Liberi": [41.22277, 14.28221],
  "Librizzi": [38.09717, 14.95819],
  "Licata": [37.10157, 13.93718],
  "Licciana Nardi": [44.26498, 10.03854],
  "Licenza": [42.07436, 12.90172],
  "Licodia Eubea": [37.15573, 14.70332],
  "Lierna": [45.95615, 9.30694],
  "Lignana": [45.2853, 8.34605],
  "Lignano Sabbiadoro": [45.68825, 13.12982],
  "Lillianes": [45.63277, 7.84507],
  "Limana": [46.09914, 12.18027],
  "Limatola": [41.14093, 14.39438],
  "Limbadi": [38.5588, 15.96203],
  "Limbiate": [45.60503, 9.12303],
  "Limena": [45.47891, 11.84366],
  "Limido Comasco": [45.6897, 8.98271],
  "Limina": [37.94088, 15.27264],
  "Limone Piemonte": [44.20129, 7.57608],
  "Limone sul Garda": [45.81333, 10.7929],
  "Limosano": [41.67663, 14.62117],
  "Linarolo": [45.16021, 9.26789],
  "Linguaglossa": [37.84073, 15.14401],
  "Lioni": [40.87749, 15.18844],
  "Lipari": [38.46904, 14.95652],
  "Lipomo": [45.7948, 9.12148],
  "Lirio": [44.99401, 9.25554],
  "Liscate": [45.48132, 9.40947],
  "Liscia": [41.95546, 14.55501],
  "Lisciano Niccone": [43.24602, 12.14337],
  "Lisio": [44.3067, 7.97963],
  "Lissone": [45.61053, 9.24386],
  "Liveri": [40.90236, 14.56713],
  "Livigno": [46.53867, 10.13481],
  "Livinallongo del Col di Lana": [46.48148, 11.95439],
  "Livo (CO)": [46.16891, 9.3042],
  "Livo (TN)": [46.40555, 11.01917],
  "Livorno": [43.55235, 10.30868],
  "Livorno Ferraris": [45.28166, 8.082],
  "Livraga": [45.19263, 9.54481],
  "Lizzanello": [40.30354, 18.22214],
  "Lizzano": [40.39057, 17.44884],
  "Lizzano in Belvedere": [44.16164, 10.89366],
  "Loano": [44.12917, 8.25978],
  "Loazzolo": [44.66897, 8.25853],
  "Locana": [45.41699, 7.46126],
  "Locate di Triulzi": [45.35766, 9.22117],
  "Locate Varesino": [45.69035, 8.93082],
  "Locatello": [45.83222, 9.53255],
  "Loceri": [39.85671, 9.58207],
  "Locorotondo": [40.75238, 17.32662],
  "Locri": [38.23675, 16.26403],
  "Loculi": [40.40675, 9.61105],
  "Lodi": [45.31441, 9.50372],
  "Lodi Vecchio": [45.30071, 9.41485],
  "Lodine": [40.14776, 9.21936],
  "Lodrino": [45.71774, 10.2776],
  "Lodè": [40.59132, 9.53957],
  "Lograto": [45.48319, 10.05744],
  "Loiano": [44.27018, 11.32173],
  "Loiri Porto San Paolo": [40.84191, 9.49836],
  "Lomagna": [45.66759, 9.37567],
  "Lomazzo": [45.69902, 9.04015],
  "Lombardore": [45.23571, 7.73627],
  "Lombriasco": [44.8416, 7.63578],
  "Lomello": [45.12177, 8.79265],
  "Lona-Lases": [46.1468, 11.21882],
  "Lonate Ceppino": [45.70529, 8.87627],
  "Lonate Pozzolo": [45.60006, 8.75237],
  "Lonato del Garda": [45.46089, 10.48429],
  "Londa": [43.8601, 11.5672],
  "Longano": [41.52173, 14.24571],
  "Longare": [45.47876, 11.60702],
  "Longarone": [46.2666, 12.3],
  "Longhena": [45.43814, 10.05966],
  "Longi": [38.02717, 14.75261],
  "Longiano": [44.07409, 12.32692],
  "Longobardi": [39.20742, 16.07682],
  "Longobucco": [39.44872, 16.60949],
  "Longone al Segrino": [45.81725, 9.251],
  "Longone Sabino": [42.27243, 12.96549],
  "Lonigo": [45.38883, 11.38743],
  "Loranzè": [45.44223, 7.81087],
  "Loreggia": [45.5882, 11.94403],
  "Loreglia": [45.90636, 8.37103],
  "Lorenzago di Cadore": [46.48011, 12.45905],
  "Loreo": [45.0636, 12.18923],
  "Loreto": [43.44028, 13.60793],
  "Loreto Aprutino": [42.43235, 13.98748],
  "Loria": [45.72836, 11.86653],
  "Loro Ciuffenna": [43.59331, 11.63154],
  "Loro Piceno": [43.1661, 13.41619],
  "Lorsica": [44.43234, 9.27433],
  "Losine": [45.98359, 10.31751],
  "Lotzorai": [39.96939, 9.66253],
  "Lovere": [45.81289, 10.0716],
  "Lovero": [46.23084, 10.2303],
  "Lozio": [45.98564, 10.26089],
  "Lozza": [45.77548, 8.85706],
  "Lozzo Atestino": [45.29111, 11.63137],
  "Lozzo di Cadore": [46.48468, 12.44297],
  "Lozzolo": [45.62259, 8.32208],
  "Lubriano": [42.63535, 12.10712],
  "Lucca": [43.84432, 10.50151],
  "Lucca Sicula": [37.57846, 13.30671],
  "Lucera": [41.50615, 15.33296],
  "Lucignano": [43.27549, 11.74707],
  "Lucinasco": [43.96778, 7.96275],
  "Lucito": [41.7318, 14.68822],
  "Luco dei Marsi": [41.96189, 13.46899],
  "Lucoli": [42.29102, 13.33772],
  "Lugagnano Val d'Arda": [44.82253, 9.82645],
  "Lugnano in Teverina": [42.57429, 12.33032],
  "Lugo": [44.42083, 11.91148],
  "Lugo di Vicenza": [45.75313, 11.52286],
  "Luino": [46.00249, 8.74243],
  "Luisago": [45.76122, 9.04346],
  "Lula": [40.47129, 9.48504],
  "Lumarzo": [44.44357, 9.13732],
  "Lumezzane": [45.65015, 10.26176],
  "Lunamatrona": [39.64909, 8.9027],
  "Lunano": [43.73047, 12.44099],
  "Lungavilla": [45.04491, 9.07859],
  "Lungro": [39.74407, 16.12175],
  "Luni": [44.08497, 10.04203],
  "Luogosano": [40.98777, 14.99037],
  "Luogosanto": [41.05064, 9.20553],
  "Lupara": [41.76214, 14.73323],
  "Lurago d'Erba": [45.75349, 9.22474],
  "Lurago Marinone": [45.70781, 8.98395],
  "Lurano": [45.56503, 9.63944],
  "Luras": [40.93619, 9.17501],
  "Lurate Caccivio": [45.76555, 9.00068],
  "Lusciano": [40.96968, 14.19169],
  "Luserna": [45.92193, 11.32439],
  "Luserna San Giovanni": [44.81432, 7.24579],
  "Lusernetta": [44.80237, 7.25024],
  "Lusevera": [46.26468, 13.2604],
  "Lusia": [45.10104, 11.66302],
  "Lusigliè": [45.31857, 7.76647],
  "Luson": [46.74589, 11.76072],
  "Lustra": [40.2884, 15.06832],
  "Luvinate": [45.83956, 8.77246],
  "Luzzana": [45.71598, 9.87987],
  "Luzzara": [44.96009, 10.68588],
  "Luzzi": [39.44634, 16.28818],
  "Maccagno con Pino e Veddasca": [46.0426, 8.74237],
  "Maccastorna": [45.14663, 9.85253],
  "Macchia d'Isernia": [41.56281, 14.16747],
  "Macchia Valfortore": [41.59333, 14.91122],
  "Macchiagodena": [41.55926, 14.40583],
  "Macello": [44.85118, 7.40079],
  "Macerata": [43.30024, 13.45307],
  "Macerata Campania": [41.0631, 14.27444],
  "Macerata Feltria": [43.80308, 12.44278],
  "Macherio": [45.64131, 9.27121],
  "Maclodio": [45.47674, 10.04178],
  "Macomer": [40.26505, 8.7825],
  "Macra": [44.49986, 7.1792],
  "Macugnaga": [45.96863, 7.96782],
  "Maddaloni": [41.03861, 14.38382],
  "Madesimo": [46.42815, 9.34418],
  "Madignano": [45.34335, 9.72762],
  "Madone": [45.652, 9.54995],
  "Madonna del Sasso": [45.79235, 8.36814],
  "Madruzzo": [46.026, 10.9841],
  "Maenza": [41.52275, 13.18068],
  "Mafalda": [41.94151, 14.71253],
  "Magasa": [45.78148, 10.6164],
  "Magenta": [45.46611, 8.88343],
  "Maggiora": [45.69075, 8.42099],
  "Magherno": [45.22245, 9.3295],
  "Magione": [43.14261, 12.20541],
  "Magisano": [39.01488, 16.62866],
  "Magliano Alfieri": [44.76647, 8.06781],
  "Magliano Alpi": [44.4581, 7.79955],
  "Magliano de' Marsi": [42.09229, 13.36479],
  "Magliano di Tenna": [43.13858, 13.58622],
  "Magliano in Toscana": [42.59856, 11.29354],
  "Magliano Romano": [42.15986, 12.4363],
  "Magliano Sabina": [42.36133, 12.48099],
  "Magliano Vetere": [40.34702, 15.23635],
  "Maglie": [40.12102, 18.29886],
  "Magliolo": [44.19164, 8.25019],
  "Maglione": [45.3477, 8.01174],
  "Magnacavallo": [45.00462, 11.18474],
  "Magnago": [45.5806, 8.80053],
  "Magnano": [45.4627, 8.00513],
  "Magnano in Riviera": [46.22963, 13.1766],
  "Magomadas": [40.2642, 8.5254],
  "Magreglio": [45.92002, 9.26189],
  "Magrè sulla strada del vino": [46.28687, 11.20897],
  "Maida": [38.85827, 16.36548],
  "Maierato": [38.70707, 16.19233],
  "Maierà": [39.71613, 15.85041],
  "Maiolati Spontini": [43.47734, 13.11911],
  "Maiolo": [43.87363, 12.31087],
  "Maiori": [40.65087, 14.64223],
  "Mairago": [45.25226, 9.5785],
  "Mairano": [45.4502, 10.07631],
  "Maissana": [44.33667, 9.53502],
  "Majano": [46.18537, 13.07554],
  "Malagnino": [45.13495, 10.11423],
  "Malalbergo": [44.71891, 11.53398],
  "Malborghetto Valbruna": [46.50677, 13.44002],
  "Malcesine": [45.76285, 10.80782],
  "Malegno": [45.95071, 10.27241],
  "Maleo": [45.16821, 9.76454],
  "Malesco": [46.12665, 8.50036],
  "Maletto": [37.8295, 14.86629],
  "Malfa": [38.577, 14.83604],
  "Malgesso": [45.82769, 8.67614],
  "Malgrate": [45.85188, 9.37341],
  "Malito": [39.15887, 16.24647],
  "Mallare": [44.29147, 8.29758],
  "Malles Venosta": [46.68954, 10.5448],
  "Malnate": [45.79953, 8.88111],
  "Malo": [45.65864, 11.40444],
  "Malonno": [46.11867, 10.31478],
  "Maltignano": [42.83163, 13.68718],
  "Malvagna": [37.91866, 15.05435],
  "Malvicino": [44.55966, 8.41407],
  "Malvito": [39.60105, 16.05341],
  "Malé": [46.3527, 10.91248],
  "Mammola": [38.36207, 16.24052],
  "Mamoiada": [40.21439, 9.28394],
  "Manciano": [42.58734, 11.51546],
  "Mandanici": [38.0023, 15.31711],
  "Mandas": [39.65698, 9.1298],
  "Mandatoriccio": [39.47023, 16.8367],
  "Mandela": [42.03194, 12.92375],
  "Mandello del Lario": [45.91727, 9.31952],
  "Mandello Vitta": [45.49523, 8.45919],
  "Manduria": [40.39897, 17.63431],
  "Manerba del Garda": [45.5501, 10.55143],
  "Manerbio": [45.3543, 10.13902],
  "Manfredonia": [41.62847, 15.91921],
  "Mango": [44.68461, 8.15033],
  "Mangone": [39.20437, 16.33262],
  "Maniace": [37.86201, 14.80775],
  "Maniago": [46.17105, 12.70817],
  "Manocalzati": [40.94143, 14.84913],
  "Manoppello": [42.26106, 14.06045],
  "Mansuè": [45.82212, 12.53759],
  "Manta": [44.61433, 7.48626],
  "Mantello": [46.1529, 9.48805],
  "Mantova": [45.15727, 10.79277],
  "Manzano": [45.98999, 13.3848],
  "Manziana": [42.12945, 12.12825],
  "Mapello": [45.7094, 9.54573],
  "Mappano": [45.1475, 7.707],
  "Mara": [40.4107, 8.63691],
  "Maracalagonis": [39.28523, 9.2282],
  "Maranello": [44.52512, 10.86745],
  "Marano di Napoli": [40.89863, 14.19036],
  "Marano di Valpolicella": [45.55384, 10.91541],
  "Marano Equo": [41.99466, 13.01686],
  "Marano Lagunare": [45.76718, 13.16762],
  "Marano Marchesato": [39.31506, 16.17362],
  "Marano Principato": [39.30129, 16.17425],
  "Marano sul Panaro": [44.45612, 10.96629],
  "Marano Ticino": [45.62982, 8.63194],
  "Marano Vicentino": [45.69239, 11.43029],
  "Maranzana": [44.75977, 8.47682],
  "Maratea": [39.99578, 15.72462],
  "Marcallo con Casone": [45.48437, 8.8675],
  "Marcaria": [45.11962, 10.53359],
  "Marcedusa": [39.02703, 16.8358],
  "Marcellina": [42.023, 12.80725],
  "Marcellinara": [38.92927, 16.49443],
  "Marcetelli": [42.22679, 13.04723],
  "Marcheno": [45.706, 10.2142],
  "Marchirolo": [45.95159, 8.83577],
  "Marciana": [42.79, 10.16797],
  "Marciana Marina": [42.80472, 10.19683],
  "Marcianise": [41.03555, 14.29945],
  "Marciano della Chiana": [43.30513, 11.78636],
  "Marcignago": [45.25435, 9.07737],
  "Marcon": [45.55447, 12.29937],
  "Marebbe": [46.69754, 11.9327],
  "Marene": [44.6615, 7.72915],
  "Mareno di Piave": [45.84086, 12.35219],
  "Marentino": [45.058, 7.87333],
  "Maretto": [44.94436, 8.03424],
  "Margarita": [44.40265, 7.68686],
  "Margherita di Savoia": [41.37262, 16.14889],
  "Margno": [46.03048, 9.37998],
  "Mariana Mantovana": [45.19403, 10.48762],
  "Mariano Comense": [45.6971, 9.18251],
  "Mariano del Friuli": [45.91671, 13.4611],
  "Marianopoli": [37.59883, 13.91508],
  "Mariglianella": [40.92662, 14.43852],
  "Marigliano": [40.92524, 14.45702],
  "Marina di Gioiosa Ionica": [38.30332, 16.32907],
  "Marineo": [37.95268, 13.41411],
  "Marino": [41.7697, 12.65861],
  "Marlengo": [46.65479, 11.14042],
  "Marliana": [43.93406, 10.77006],
  "Marmentino": [45.75283, 10.28194],
  "Marmirolo": [45.22234, 10.75731],
  "Marmora": [44.45749, 7.0945],
  "Marnate": [45.62848, 8.90387],
  "Marone": [45.73709, 10.09156],
  "Maropati": [38.44266, 16.09651],
  "Marostica": [45.74739, 11.65595],
  "Marradi": [44.07546, 11.61277],
  "Marrubiu": [39.74888, 8.63626],
  "Marsaglia": [44.45218, 7.98299],
  "Marsala": [37.79917, 12.43495],
  "Marsciano": [42.9102, 12.33954],
  "Marsico Nuovo": [40.4192, 15.73423],
  "Marsicovetere": [40.37461, 15.82638],
  "Marta": [42.535, 11.92516],
  "Martano": [40.20384, 18.30121],
  "Martellago": [45.54613, 12.15989],
  "Martello": [46.56632, 10.7826],
  "Martignacco": [46.09821, 13.13039],
  "Martignana di Po": [45.0109, 10.37927],
  "Martignano": [40.23748, 18.25893],
  "Martina Franca": [40.70493, 17.33897],
  "Martinengo": [45.57167, 9.76737],
  "Martiniana Po": [44.62642, 7.36632],
  "Martinsicuro": [42.88556, 13.91574],
  "Martirano": [39.08303, 16.24759],
  "Martirano Lombardo": [39.07573, 16.23105],
  "Martis": [40.77889, 8.80866],
  "Martone": [38.35375, 16.28731],
  "Marudo": [45.25256, 9.37499],
  "Maruggio": [40.31997, 17.57036],
  "Marzabotto": [44.34039, 11.20514],
  "Marzano": [45.24759, 9.29458],
  "Marzano Appio": [41.31628, 14.03933],
  "Marzano di Nola": [40.90021, 14.58179],
  "Marzi": [39.17063, 16.30705],
  "Marzio": [45.93784, 8.85777],
  "Masainas": [39.05155, 8.6306],
  "Masate": [45.56842, 9.46651],
  "Mascali": [37.7575, 15.19536],
  "Mascalucia": [37.57306, 15.05302],
  "Maschito": [40.90673, 15.83143],
  "Masciago Primo": [45.91642, 8.7808],
  "Maser": [45.80745, 11.972],
  "Masera": [46.13697, 8.32648],
  "Maserada sul Piave": [45.74969, 12.31849],
  "Maserà di Padova": [45.32017, 11.86353],
  "Masi": [45.10842, 11.49175],
  "Masi Torello": [44.79404, 11.79527],
  "Masio": [44.86939, 8.40801],
  "Maslianico": [45.84256, 9.04847],
  "Masone": [44.50364, 8.71169],
  "Massa": [44.03674, 10.14174],
  "Massa d'Albe": [42.10899, 13.3922],
  "Massa di Somma": [40.84661, 14.3774],
  "Massa e Cozzile": [43.90992, 10.74467],
  "Massa Fermana": [43.15042, 13.47564],
  "Massa Lombarda": [44.44657, 11.82821],
  "Massa Lubrense": [40.61112, 14.34404],
  "Massa Marittima": [43.0502, 10.88793],
  "Massa Martana": [42.77556, 12.52301],
  "Massafra": [40.5882, 17.11246],
  "Massalengo": [45.26352, 9.48985],
  "Massanzago": [45.55532, 12.00426],
  "Massarosa": [43.8685, 10.34181],
  "Massazza": [45.49207, 8.16516],
  "Massello": [44.95856, 7.05631],
  "Masserano": [45.5957, 8.22327],
  "Massignano": [43.05086, 13.79702],
  "Massimeno": [46.14231, 10.77301],
  "Massimino": [44.29939, 8.07116],
  "Massino Visconti": [45.8219, 8.53881],
  "Massiola": [45.91224, 8.31968],
  "Masullas": [39.70146, 8.77925],
  "Matelica": [43.25661, 13.00952],
  "Matera": [40.66751, 16.59793],
  "Mathi": [45.25664, 7.54132],
  "Matino": [40.03264, 18.13411],
  "Matrice": [41.6124, 14.711],
  "Mattie": [45.11871, 7.11215],
  "Mattinata": [41.71053, 16.05144],
  "Mazara del Vallo": [37.65135, 12.58972],
  "Mazzano": [45.5036, 10.35979],
  "Mazzano Romano": [42.20467, 12.39943],
  "Mazzarino": [37.305, 14.21424],
  "Mazzarrone": [37.08401, 14.5616],
  "Mazzarrà Sant'Andrea": [38.0898, 15.13586],
  "Mazzin": [46.47036, 11.72841],
  "Mazzo di Valtellina": [46.25648, 10.2548],
  "Mazzè": [45.29854, 7.937],
  "Meana di Susa": [45.12073, 7.06814],
  "Meana Sardo": [39.94761, 9.06887],
  "Meda": [45.66155, 9.15527],
  "Mede": [45.09694, 8.73661],
  "Medea": [45.9167, 13.42393],
  "Medesano": [44.75682, 10.13996],
  "Medicina": [44.47644, 11.64048],
  "Mediglia": [45.40123, 9.32377],
  "Medolago": [45.67277, 9.49354],
  "Medole": [45.32707, 10.50745],
  "Medolla": [44.84894, 11.07148],
  "Meduna di Livenza": [45.80525, 12.6135],
  "Meduno": [46.21673, 12.78653],
  "Megliadino San Vitale": [45.19237, 11.52412],
  "Meina": [45.79003, 8.5376],
  "Melara": [45.06185, 11.19773],
  "Melazzo": [44.64399, 8.4269],
  "Meldola": [44.12697, 12.06062],
  "Mele": [44.4454, 8.74803],
  "Melegnano": [45.35753, 9.32425],
  "Melendugno": [40.26684, 18.33705],
  "Meleti": [45.1188, 9.83678],
  "Melfi": [40.99444, 15.65291],
  "Melicucco": [38.43396, 16.05978],
  "Melicuccà": [38.3022, 15.88192],
  "Melilli": [37.17851, 15.12675],
  "Melissa": [39.30519, 17.02282],
  "Melissano": [39.97355, 18.12362],
  "Melito di Napoli": [40.92403, 14.2327],
  "Melito di Porto Salvo": [37.92087, 15.78509],
  "Melito Irpino": [41.1029, 15.05389],
  "Melizzano": [41.16133, 14.50444],
  "Melle": [44.56206, 7.32058],
  "Mello": [46.15463, 9.54426],
  "Melpignano": [40.15476, 18.28945],
  "Meltina": [46.58638, 11.25557],
  "Melzo": [45.49793, 9.42398],
  "Menaggio": [46.0211, 9.23891],
  "Menconico": [44.79595, 9.27906],
  "Mendatica": [44.07637, 7.80556],
  "Mendicino": [39.26212, 16.19289],
  "Menfi": [37.59822, 12.96641],
  "Mentana": [42.03371, 12.63722],
  "Meolo": [45.61903, 12.45266],
  "Merana": [44.5178, 8.29752],
  "Merano": [46.67176, 11.16184],
  "Merate": [45.69854, 9.41001],
  "Mercallo": [45.74673, 8.6721],
  "Mercatello sul Metauro": [43.64751, 12.33675],
  "Mercatino Conca": [43.87043, 12.4935],
  "Mercato San Severino": [40.78629, 14.75358],
  "Mercato Saraceno": [43.95701, 12.19584],
  "Mercenasco": [45.35698, 7.88257],
  "Mercogliano": [40.92012, 14.73613],
  "Mereto di Tomba": [46.05112, 13.04784],
  "Mergo": [43.47142, 13.03739],
  "Mergozzo": [45.96098, 8.45293],
  "Merlara": [45.16699, 11.44224],
  "Merlino": [45.4329, 9.42988],
  "Merone": [45.78638, 9.24512],
  "Merì": [38.16794, 15.24644],
  "Mesagne": [40.55459, 17.80858],
  "Mese": [46.30445, 9.37946],
  "Mesenzana": [45.94702, 8.75881],
  "Mesero": [45.49827, 8.85388],
  "Mesola": [44.92249, 12.22924],
  "Mesoraca": [39.08252, 16.79386],
  "Messina": [38.19396, 15.55572],
  "Mestrino": [45.44354, 11.75879],
  "Meta": [40.64403, 14.41269],
  "Mezzago": [45.62597, 9.43948],
  "Mezzana": [46.31581, 10.80277],
  "Mezzana Bigli": [45.06088, 8.84596],
  "Mezzana Mortigliengo": [45.62596, 8.18945],
  "Mezzana Rabattone": [45.09471, 9.03229],
  "Mezzane di Sotto": [45.48107, 11.12756],
  "Mezzanego": [44.3837, 9.37691],
  "Mezzanino": [45.12639, 9.20681],
  "Mezzano": [46.15453, 11.80595],
  "Mezzenile": [45.2924, 7.39502],
  "Mezzocorona": [46.21649, 11.1185],
  "Mezzojuso": [37.8645, 13.46451],
  "Mezzoldo": [46.0122, 9.66567],
  "Mezzolombardo": [46.21351, 11.09052],
  "Mezzomerico": [45.62028, 8.60462],
  "Miagliano": [45.61414, 8.04377],
  "Miane": [45.94291, 12.09097],
  "Miasino": [45.80219, 8.43036],
  "Miazzina": [45.97522, 8.52392],
  "Micigliano": [42.45095, 13.05493],
  "Miggiano": [39.96507, 18.30685],
  "Miglianico": [42.35951, 14.29154],
  "Miglierina": [38.94761, 16.47246],
  "Miglionico": [40.56577, 16.50158],
  "Mignanego": [44.52764, 8.91468],
  "Mignano Monte Lungo": [41.40673, 13.98743],
  "Milano": [45.46679, 9.19035],
  "Milazzo": [38.22087, 15.24274],
  "Milena": [37.47145, 13.73628],
  "Mileto": [38.60321, 16.0599],
  "Milis": [40.04931, 8.63718],
  "Militello in Val di Catania": [37.27481, 14.794],
  "Militello Rosmarino": [38.04636, 14.67604],
  "Millesimo": [44.36442, 8.20582],
  "Milo": [37.72334, 15.11607],
  "Milzano": [45.27554, 10.20044],
  "Mineo": [37.26487, 14.69111],
  "Minerbe": [45.24176, 11.3407],
  "Minerbio": [44.6252, 11.4908],
  "Minervino di Lecce": [40.0926, 18.42237],
  "Minervino Murge": [41.08919, 16.07967],
  "Minori": [40.64967, 14.62615],
  "Minturno": [41.26245, 13.74656],
  "Minucciano": [44.17031, 10.20756],
  "Mioglia": [44.48986, 8.41127],
  "Mira": [45.43288, 12.12337],
  "Mirabella Eclano": [41.04138, 14.99218],
  "Mirabella Imbaccari": [37.32444, 14.44603],
  "Mirabello Monferrato": [45.03575, 8.52345],
  "Mirabello Sannitico": [41.51529, 14.67208],
  "Miradolo Terme": [45.17164, 9.44317],
  "Miranda": [41.6439, 14.24623],
  "Mirandola": [44.88708, 11.06608],
  "Mirano": [45.49292, 12.10917],
  "Mirto": [38.08512, 14.75285],
  "Misano Adriatico": [43.97336, 12.69324],
  "Misano di Gera d'Adda": [45.46855, 9.6206],
  "Misilmeri": [38.03514, 13.45155],
  "Misinto": [45.66463, 9.07748],
  "Missaglia": [45.70851, 9.33431],
  "Missanello": [40.2822, 16.16521],
  "Misterbianco": [37.52084, 15.00637],
  "Mistretta": [37.93049, 14.36235],
  "Moasca": [44.76255, 8.27794],
  "Moconesi": [44.41953, 9.21235],
  "Modena": [44.646, 10.92615],
  "Modica": [36.85885, 14.76136],
  "Modigliana": [44.15627, 11.7926],
  "Modolo": [40.27408, 8.52782],
  "Modugno": [41.0827, 16.78027],
  "Moena": [46.37661, 11.66022],
  "Moggio": [45.93125, 9.49004],
  "Moggio Udinese": [46.40992, 13.19492],
  "Moglia": [44.93034, 10.91193],
  "Mogliano": [43.186, 13.48082],
  "Mogliano Veneto": [45.56159, 12.23645],
  "Mogorella": [39.86312, 8.85827],
  "Mogoro": [39.68411, 8.77458],
  "Moiano": [41.07824, 14.54636],
  "Moimacco": [46.09167, 13.38114],
  "Moio Alcantara": [37.89884, 15.05053],
  "Moio de' Calvi": [45.95144, 9.70058],
  "Moio della Civitella": [40.24505, 15.2704],
  "Moiola": [44.31969, 7.38887],
  "Mola di Bari": [41.06093, 17.08172],
  "Molare": [44.62062, 8.60108],
  "Molazzana": [44.07259, 10.41844],
  "Molfetta": [41.20503, 16.60063],
  "Molina Aterno": [42.14805, 13.73575],
  "Molinara": [41.29376, 14.9099],
  "Molinella": [44.62037, 11.67032],
  "Molini di Triora": [43.99014, 7.77433],
  "Molino dei Torti": [45.02354, 8.89203],
  "Molise": [41.63058, 14.49382],
  "Moliterno": [40.24207, 15.86876],
  "Mollia": [45.81528, 8.03097],
  "Molochio": [38.30483, 16.03184],
  "Molteno": [45.77707, 9.30659],
  "Moltrasio": [45.85915, 9.09584],
  "Molveno": [46.14289, 10.96625],
  "Mombaldone": [44.56924, 8.3292],
  "Mombarcaro": [44.46776, 8.08509],
  "Mombaroccio": [43.79684, 12.85488],
  "Mombaruzzo": [44.77103, 8.44867],
  "Mombasiglio": [44.36331, 7.97],
  "Mombello di Torino": [45.0464, 7.91955],
  "Mombello Monferrato": [45.13303, 8.25088],
  "Mombercelli": [44.81698, 8.29443],
  "Momo": [45.57391, 8.55537],
  "Mompantero": [45.13991, 7.05797],
  "Mompeo": [42.24771, 12.75117],
  "Momperone": [44.83864, 9.03448],
  "Monacilioni": [41.61043, 14.81045],
  "Monale": [44.9361, 8.07164],
  "Monasterace": [38.45364, 16.55275],
  "Monastero Bormida": [44.64752, 8.32462],
  "Monastero di Lanzo": [45.30142, 7.43913],
  "Monastero di Vasco": [44.34018, 7.82276],
  "Monasterolo Casotto": [44.33084, 7.94114],
  "Monasterolo del Castello": [45.76326, 9.93136],
  "Monasterolo di Savigliano": [44.68634, 7.62077],
  "Monastier di Treviso": [45.64952, 12.43574],
  "Monastir": [39.38719, 9.04409],
  "Moncalieri": [45.00093, 7.68525],
  "Moncalvo": [45.0514, 8.26347],
  "Moncenisio": [45.20529, 6.98356],
  "Moncestino": [45.15485, 8.1584],
  "Monchiero": [44.57305, 7.91814],
  "Monchio delle Corti": [44.41237, 10.1232],
  "Moncrivello": [45.33123, 7.99586],
  "Moncucco Torinese": [45.06788, 7.93216],
  "Mondaino": [43.85603, 12.67138],
  "Mondavio": [43.67454, 12.9686],
  "Mondolfo": [43.75152, 13.09546],
  "Mondovì": [44.38718, 7.81981],
  "Mondragone": [41.11294, 13.88716],
  "Moneglia": [44.23855, 9.49013],
  "Monesiglio": [44.4649, 8.11638],
  "Monfalcone": [45.80923, 13.53265],
  "Monforte d'Alba": [44.58234, 7.96841],
  "Monforte San Giorgio": [38.15687, 15.38352],
  "Monfumo": [45.83047, 11.92035],
  "Mongardino": [44.84884, 8.2187],
  "Monghidoro": [44.21944, 11.31663],
  "Mongiana": [38.51344, 16.31924],
  "Mongiardino Ligure": [44.63856, 9.06126],
  "Mongiuffi Melia": [37.9042, 15.27493],
  "Mongrando": [45.51923, 8.00725],
  "Mongrassano": [39.52715, 16.11145],
  "Monguelfo-Tesido": [46.75694, 12.10478],
  "Monguzzo": [45.78283, 9.23217],
  "Moniga del Garda": [45.53052, 10.53704],
  "Monleale": [44.88507, 8.98437],
  "Monno": [46.21262, 10.33804],
  "Monopoli": [40.95258, 17.3021],
  "Monreale": [38.08233, 13.2917],
  "Monrupino": [45.71887, 13.80116],
  "Monsampietro Morico": [43.06767, 13.55584],
  "Monsampolo del Tronto": [42.89747, 13.79095],
  "Monsano": [43.56348, 13.25031],
  "Monselice": [45.23947, 11.75011],
  "Monserrato": [39.25407, 9.14344],
  "Monsummano Terme": [43.8716, 10.81442],
  "Montabone": [44.6986, 8.39031],
  "Montacuto": [44.76675, 9.10687],
  "Montafia": [44.9892, 8.02515],
  "Montagano": [41.64635, 14.67377],
  "Montagna": [46.33135, 11.30273],
  "Montagna in Valtellina": [46.17825, 9.90065],
  "Montagnana": [45.23198, 11.46715],
  "Montagnareale": [38.13246, 14.94771],
  "Montaguto": [41.24905, 15.25016],
  "Montaione": [43.55228, 10.91225],
  "Montalbano Elicona": [38.02371, 15.01413],
  "Montalbano Jonico": [40.28805, 16.56884],
  "Montalcino": [43.0592, 11.4906],
  "Montaldeo": [44.66654, 8.73068],
  "Montaldo Bormida": [44.68346, 8.58901],
  "Montaldo di Mondovì": [44.31947, 7.86584],
  "Montaldo Roero": [44.76857, 7.92447],
  "Montaldo Scarampi": [44.8286, 8.25739],
  "Montaldo Torinese": [45.06636, 7.85089],
  "Montale": [43.93474, 11.02227],
  "Montalenghe": [45.33772, 7.83986],
  "Montallegro": [37.39109, 13.35068],
  "Montalto delle Marche": [42.98737, 13.60713],
  "Montalto di Castro": [42.35323, 11.60418],
  "Montalto Dora": [45.49362, 7.86379],
  "Montalto Pavese": [44.97961, 9.20734],
  "Montalto Uffugo": [39.40552, 16.15847],
  "Montanaro": [45.23289, 7.85283],
  "Montanaso Lombardo": [45.33528, 9.46309],
  "Montanera": [44.46198, 7.66557],
  "Montano Antilia": [40.16238, 15.36151],
  "Montano Lucino": [45.7863, 9.04128],
  "Montappone": [43.13551, 13.46936],
  "Montaquila": [41.56641, 14.11671],
  "Montasola": [42.38556, 12.68099],
  "Montauro": [38.74978, 16.50979],
  "Montazzoli": [41.94819, 14.42936],
  "Monte Argentario": [42.43915, 11.11584],
  "Monte Castello di Vibio": [42.84032, 12.35227],
  "Monte Cavallo": [42.99356, 13.00116],
  "Monte Cerignone": [43.84099, 12.41263],
  "Monte Compatri": [41.80828, 12.737],
  "Monte Cremasco": [45.37224, 9.57286],
  "Monte di Malo": [45.66037, 11.36141],
  "Monte di Procida": [40.79501, 14.0539],
  "Monte Giberto": [43.09128, 13.63086],
  "Monte Grimano Terme": [43.86544, 12.47285],
  "Monte Isola": [45.71499, 10.0793],
  "Monte Marenzo": [45.77094, 9.45353],
  "Monte Porzio": [43.68987, 13.04519],
  "Monte Porzio Catone": [41.8156, 12.71666],
  "Monte Rinaldo": [43.02836, 13.58091],
  "Monte Roberto": [43.48144, 13.13851],
  "Monte Romano": [42.26792, 11.89878],
  "Monte San Biagio": [41.35297, 13.35115],
  "Monte San Giacomo": [40.34139, 15.54367],
  "Monte San Giovanni Campano": [41.63905, 13.51586],
  "Monte San Giovanni in Sabina": [42.32818, 12.77768],
  "Monte San Giusto": [43.23601, 13.59428],
  "Monte San Martino": [43.03117, 13.43937],
  "Monte San Pietrangeli": [43.19179, 13.57961],
  "Monte San Pietro": [44.45776, 11.19969],
  "Monte San Savino": [43.33139, 11.72534],
  "Monte San Vito": [43.60058, 13.27097],
  "Monte Sant'Angelo": [41.70618, 15.95813],
  "Monte Santa Maria Tiberina": [43.43681, 12.16292],
  "Monte Urano": [43.20622, 13.67111],
  "Monte Vidon Combatte": [43.04965, 13.63071],
  "Monte Vidon Corrado": [43.1214, 13.48448],
  "Montebello della Battaglia": [44.9997, 9.10101],
  "Montebello di Bertona": [42.41652, 13.86965],
  "Montebello Jonico": [37.98169, 15.75827],
  "Montebello sul Sangro": [41.98663, 14.32504],
  "Montebello Vicentino": [45.45759, 11.38584],
  "Montebelluna": [45.77613, 12.04511],
  "Montebruno": [44.52709, 9.24979],
  "Montebuono": [42.36591, 12.59771],
  "Montecalvo in Foglia": [43.81155, 12.63158],
  "Montecalvo Irpino": [41.1942, 15.03162],
  "Montecalvo Versiggia": [44.9704, 9.28399],
  "Montecarlo": [43.85036, 10.66857],
  "Montecarotto": [43.52636, 13.06453],
  "Montecassiano": [43.36375, 13.43594],
  "Montecastello": [44.94895, 8.68661],
  "Montecastrilli": [42.64979, 12.48779],
  "Montecatini Val di Cecina": [43.39201, 10.74816],
  "Montecatini-Terme": [43.8841, 10.77278],
  "Montecchia di Crosara": [45.4854, 11.25318],
  "Montecchio": [42.66238, 12.288],
  "Montecchio Emilia": [44.70014, 10.44658],
  "Montecchio Maggiore": [45.50582, 11.40734],
  "Montecchio Precalcino": [45.66395, 11.56163],
  "Montechiaro d'Acqui": [44.59498, 8.37967],
  "Montechiaro d'Asti": [45.00822, 8.11238],
  "Montechiarugolo": [44.69358, 10.42246],
  "Monteciccardo": [43.8193, 12.80826],
  "Montecilfone": [41.9019, 14.83761],
  "Montecopiolo": [43.84127, 12.35938],
  "Montecorice": [40.23444, 14.98504],
  "Montecorvino Pugliano": [40.67615, 14.93026],
  "Montecorvino Rovella": [40.6958, 14.97694],
  "Montecosaro": [43.31685, 13.63525],
  "Montecrestese": [46.16548, 8.32648],
  "Montecreto": [44.24896, 10.72073],
  "Montedinove": [42.97074, 13.58697],
  "Montedoro": [37.45374, 13.81638],
  "Montefalcione": [40.96407, 14.88451],
  "Montefalco": [42.89392, 12.65252],
  "Montefalcone Appennino": [42.9877, 13.45957],
  "Montefalcone di Val Fortore": [41.3261, 15.00925],
  "Montefalcone nel Sannio": [41.86487, 14.63891],
  "Montefano": [43.41192, 13.43975],
  "Montefelcino": [43.73507, 12.8332],
  "Monteferrante": [41.95457, 14.38819],
  "Montefiascone": [42.53761, 12.03037],
  "Montefino": [42.54481, 13.88443],
  "Montefiore Conca": [43.89067, 12.61126],
  "Montefiore dell'Aso": [43.05162, 13.7509],
  "Montefiorino": [44.35945, 10.62533],
  "Monteflavio": [42.11099, 12.8307],
  "Monteforte Cilento": [40.36469, 15.19461],
  "Monteforte d'Alpone": [45.42226, 11.28505],
  "Monteforte Irpino": [40.89001, 14.71388],
  "Montefortino": [42.94264, 13.34124],
  "Montefranco": [42.59705, 12.76661],
  "Montefredane": [40.96033, 14.81299],
  "Montefusco": [41.03769, 14.85521],
  "Montegabbione": [42.92124, 12.09253],
  "Montegalda": [45.44352, 11.67286],
  "Montegaldella": [45.43608, 11.67409],
  "Montegallo": [42.84219, 13.33299],
  "Montegioco": [44.8378, 8.95408],
  "Montegiordano": [40.04408, 16.53245],
  "Montegiorgio": [43.13003, 13.53779],
  "Montegranaro": [43.23339, 13.6326],
  "Montegridolfo": [43.85906, 12.68914],
  "Montegrino Valtravaglia": [45.97345, 8.76812],
  "Montegrosso d'Asti": [44.82241, 8.23874],
  "Montegrosso Pian Latte": [44.06661, 7.81784],
  "Montegrotto Terme": [45.33174, 11.78364],
  "Monteiasi": [40.50212, 17.37904],
  "Montelabbate": [43.84907, 12.79076],
  "Montelanico": [41.64954, 13.03955],
  "Montelapiano": [41.96128, 14.34235],
  "Monteleone d'Orvieto": [42.91646, 12.05156],
  "Monteleone di Fermo": [43.04743, 13.52881],
  "Monteleone di Puglia": [41.16479, 15.26002],
  "Monteleone di Spoleto": [42.65112, 12.95159],
  "Monteleone Rocca Doria": [40.47188, 8.55994],
  "Monteleone Sabino": [42.23258, 12.85902],
  "Montelepre": [38.08979, 13.17327],
  "Montelibretti": [42.13494, 12.73888],
  "Montella": [40.84229, 15.01666],
  "Montello": [45.67091, 9.80506],
  "Montelongo": [41.73584, 14.94867],
  "Montelparo": [43.018, 13.53537],
  "Montelupo Albese": [44.62307, 8.04638],
  "Montelupo Fiorentino": [43.72947, 11.02076],
  "Montelupone": [43.34438, 13.56712],
  "Montemaggiore Belsito": [37.84789, 13.76258],
  "Montemagno": [44.98403, 8.32401],
  "Montemale di Cuneo": [44.43769, 7.37281],
  "Montemarano": [40.91982, 14.99692],
  "Montemarciano": [43.64009, 13.31023],
  "Montemarzino": [44.84849, 8.99313],
  "Montemesola": [40.5623, 17.3354],
  "Montemezzo": [46.17849, 9.37698],
  "Montemignaio": [43.74012, 11.61991],
  "Montemiletto": [41.01147, 14.90719],
  "Montemilone": [41.02707, 15.96716],
  "Montemitro": [41.88803, 14.64676],
  "Montemonaco": [42.8995, 13.32696],
  "Montemurlo": [43.9269, 11.03714],
  "Montemurro": [40.2992, 15.99391],
  "Montenars": [46.25673, 13.18037],
  "Montenero di Bisaccia": [41.95725, 14.78121],
  "Montenero Sabino": [42.28124, 12.81317],
  "Montenero Val Cocchiara": [41.71473, 14.06618],
  "Montenerodomo": [41.9766, 14.2518],
  "Monteodorisio": [42.08808, 14.65273],
  "Montepaone": [38.72169, 16.49865],
  "Monteparano": [40.4441, 17.4137],
  "Monteprandone": [42.9201, 13.83574],
  "Montepulciano": [43.09255, 11.7807],
  "Monterchi": [43.4856, 12.1119],
  "Montereale": [42.52407, 13.24509],
  "Montereale Valcellina": [46.15518, 12.65606],
  "Monterenzio": [44.32528, 11.40501],
  "Monteriggioni": [43.39306, 11.21861],
  "Monteroduni": [41.5228, 14.17571],
  "Monteroni d'Arbia": [43.23109, 11.42187],
  "Monteroni di Lecce": [40.32882, 18.09755],
  "Monterosi": [42.19559, 12.30994],
  "Monterosso al Mare": [44.1463, 9.65614],
  "Monterosso Almo": [37.08888, 14.76257],
  "Monterosso Calabro": [38.71793, 16.28739],
  "Monterosso Grana": [44.40889, 7.32392],
  "Monterotondo": [42.05132, 12.61625],
  "Monterotondo Marittimo": [43.14551, 10.85585],
  "Monterubbiano": [43.08541, 13.71643],
  "Montesano Salentino": [39.97592, 18.32186],
  "Montesano sulla Marcellana": [40.27558, 15.70119],
  "Montesarchio": [41.06364, 14.64054],
  "Montescaglioso": [40.55204, 16.66391],
  "Montescano": [45.0318, 9.29734],
  "Montescheno": [46.0666, 8.23291],
  "Montescudaio": [43.32635, 10.62779],
  "Montescudo-Monte Colombo": [43.9211, 12.5533],
  "Montese": [44.26747, 10.94037],
  "Montesegale": [44.90637, 9.1269],
  "Montesilvano": [42.51413, 14.14938],
  "Montespertoli": [43.64313, 11.07533],
  "Monteu da Po": [45.15054, 8.01478],
  "Monteu Roero": [44.78024, 7.93087],
  "Montevago": [37.70262, 12.99018],
  "Montevarchi": [43.52361, 11.56747],
  "Montevecchia": [45.70546, 9.38065],
  "Monteverde": [40.99981, 15.53274],
  "Monteverdi Marittimo": [43.17701, 10.71525],
  "Monteviale": [45.56076, 11.4579],
  "Montezemolo": [44.37824, 8.14147],
  "Monti": [40.80515, 9.32588],
  "Montiano": [44.08351, 12.30424],
  "Monticelli Brusati": [45.63426, 10.0979],
  "Monticelli d'Ongina": [45.08985, 9.93327],
  "Monticelli Pavese": [45.11051, 9.51274],
  "Monticello Brianza": [45.71069, 9.31504],
  "Monticello Conte Otto": [45.59526, 11.58047],
  "Monticello d'Alba": [44.71829, 7.94101],
  "Montichiari": [45.41225, 10.39528],
  "Monticiano": [43.13937, 11.17973],
  "Montieri": [43.13049, 11.01621],
  "Montiglio Monferrato": [45.06741, 8.09774],
  "Montignoso": [44.01815, 10.17648],
  "Montirone": [45.44377, 10.23111],
  "Montjovet": [45.70422, 7.67419],
  "Montodine": [45.28626, 9.7108],
  "Montoggio": [44.51558, 9.0442],
  "Montone": [43.36372, 12.32684],
  "Montopoli di Sabina": [42.24471, 12.69191],
  "Montopoli in Val d'Arno": [43.66859, 10.76043],
  "Montorfano": [45.7854, 9.1445],
  "Montorio al Vomano": [42.58305, 13.63132],
  "Montorio nei Frentani": [41.75894, 14.93225],
  "Montorio Romano": [42.13727, 12.80593],
  "Montoro": [40.8216, 14.76],
  "Montorso Vicentino": [45.48965, 11.36222],
  "Montottone": [43.06196, 13.58481],
  "Montresta": [40.37371, 8.49987],
  "Montà": [44.81309, 7.96001],
  "Montù Beccaria": [45.03883, 9.31242],
  "Monvalle": [45.85759, 8.63205],
  "Monza": [45.58439, 9.27358],
  "Monzambano": [45.38711, 10.69314],
  "Monzuno": [44.27681, 11.27144],
  "Morano Calabro": [39.8418, 16.13535],
  "Morano sul Po": [45.16404, 8.36562],
  "Moransengo": [45.11524, 8.02487],
  "Moraro": [45.93022, 13.49529],
  "Morazzone": [45.76916, 8.82937],
  "Morbegno": [46.13046, 9.56978],
  "Morbello": [44.60348, 8.51001],
  "Morciano di Leuca": [39.84697, 18.3114],
  "Morciano di Romagna": [43.91374, 12.64594],
  "Morcone": [41.3402, 14.66405],
  "Mordano": [44.39772, 11.81053],
  "Morengo": [45.532, 9.70221],
  "Mores": [40.54944, 8.83367],
  "Moresco": [43.08571, 13.73244],
  "Moretta": [44.76391, 7.53692],
  "Morfasso": [44.72167, 9.70325],
  "Morgano": [45.63436, 12.08348],
  "Morgex": [45.75698, 7.03607],
  "Morgongiori": [39.74615, 8.76773],
  "Mori": [45.85195, 10.97549],
  "Moriago della Battaglia": [45.86691, 12.1066],
  "Moricone": [42.1166, 12.77394],
  "Morigerati": [40.14056, 15.55508],
  "Morimondo": [45.35379, 8.95608],
  "Morino": [41.86476, 13.45754],
  "Moriondo Torinese": [45.03906, 7.94406],
  "Morlupo": [42.14283, 12.50441],
  "Mormanno": [39.88973, 15.9876],
  "Mornago": [45.74759, 8.7524],
  "Mornese": [44.63908, 8.75619],
  "Mornico al Serio": [45.59055, 9.80871],
  "Mornico Losana": [45.00922, 9.20647],
  "Morolo": [41.63784, 13.19702],
  "Morozzo": [44.42304, 7.71045],
  "Morra De Sanctis": [40.92312, 15.24397],
  "Morro d'Alba": [43.60113, 13.21405],
  "Morro d'Oro": [42.66403, 13.91962],
  "Morro Reatino": [42.52585, 12.83216],
  "Morrone del Sannio": [41.71216, 14.77826],
  "Morrovalle": [43.31469, 13.58003],
  "Morsano al Tagliamento": [45.85783, 12.92903],
  "Morsasco": [44.66457, 8.5491],
  "Mortara": [45.25184, 8.73807],
  "Mortegliano": [45.94489, 13.17209],
  "Morterone": [45.87625, 9.48276],
  "Moruzzo": [46.11968, 13.12372],
  "Moscazzano": [45.29358, 9.68132],
  "Moschiano": [40.87467, 14.65948],
  "Mosciano Sant'Angelo": [42.74998, 13.88789],
  "Moscufo": [42.42851, 14.05508],
  "Moso in Passiria": [46.83012, 11.169],
  "Mossa": [45.93843, 13.5479],
  "Motta Baluffi": [45.05446, 10.25959],
  "Motta Camastra": [37.89569, 15.1725],
  "Motta d'Affermo": [37.98129, 14.30206],
  "Motta de' Conti": [45.1915, 8.52077],
  "Motta di Livenza": [45.77664, 12.61025],
  "Motta Montecorvino": [41.50734, 15.11338],
  "Motta San Giovanni": [38.00176, 15.69732],
  "Motta Sant'Anastasia": [37.5121, 14.96977],
  "Motta Santa Lucia": [39.09208, 16.29287],
  "Motta Visconti": [45.29019, 8.993],
  "Mottafollone": [39.64706, 16.06664],
  "Mottalciata": [45.50864, 8.20749],
  "Motteggiana": [45.03144, 10.76444],
  "Mottola": [40.63321, 17.03829],
  "Mozzagrogna": [42.21283, 14.44468],
  "Mozzanica": [45.4771, 9.69376],
  "Mozzate": [45.67499, 8.95594],
  "Mozzecane": [45.30971, 10.81771],
  "Mozzo": [45.70018, 9.60903],
  "Muccia": [43.0821, 13.04405],
  "Muggia": [45.60439, 13.7673],
  "Muggiò": [45.59366, 9.22956],
  "Mugnano del Cardinale": [40.93963, 14.64256],
  "Mugnano di Napoli": [40.90951, 14.20649],
  "Mulazzano": [45.37215, 9.39793],
  "Mulazzo": [44.32166, 9.90708],
  "Mura": [45.71307, 10.34201],
  "Muravera": [39.42158, 9.5747],
  "Murazzano": [44.47375, 8.01885],
  "Murello": [44.75296, 7.60094],
  "Murialdo": [44.31617, 8.16136],
  "Murisengo": [45.08345, 8.13747],
  "Murlo": [43.16849, 11.3911],
  "Muro Leccese": [40.09999, 18.33935],
  "Muro Lucano": [40.75282, 15.4837],
  "Muros": [40.67911, 8.61529],
  "Muscoline": [45.56439, 10.46033],
  "Musei": [39.30234, 8.66693],
  "Musile di Piave": [45.62231, 12.56334],
  "Musso": [46.11082, 9.27368],
  "Mussolente": [45.77897, 11.80118],
  "Mussomeli": [37.58022, 13.75403],
  "Muzzana del Turgnano": [45.81743, 13.1278],
  "Muzzano": [45.56061, 7.9865],
  "Nago-Torbole": [45.87058, 10.87605],
  "Nalles": [46.5411, 11.20423],
  "Nanto": [45.42526, 11.59156],
  "Napoli": [40.83957, 14.25085],
  "Narbolia": [40.04771, 8.575],
  "Narcao": [39.16739, 8.67731],
  "Nardodipace": [38.47418, 16.34296],
  "Nardò": [40.17594, 18.0312],
  "Narni": [42.51926, 12.51529],
  "Naro": [37.29606, 13.79204],
  "Narzole": [44.59416, 7.87052],
  "Nasino": [44.11511, 8.02784],
  "Naso": [38.12194, 14.7882],
  "Naturno": [46.65104, 11.00533],
  "Nave": [45.58468, 10.27905],
  "Navelli": [42.23627, 13.73031],
  "Naz-Sciaves": [46.77053, 11.66585],
  "Nazzano": [42.22865, 12.59725],
  "Ne": [44.34437, 9.39842],
  "Nebbiuno": [45.80608, 8.52424],
  "Negrar di Valpolicella": [45.53066, 10.93783],
  "Neirone": [44.45425, 9.1909],
  "Neive": [44.72632, 8.1155],
  "Nembro": [45.74353, 9.75893],
  "Nemi": [41.72016, 12.71443],
  "Nemoli": [40.06594, 15.79927],
  "Neoneli": [40.0615, 8.94401],
  "Nepi": [42.24237, 12.34881],
  "Nereto": [42.82034, 13.818],
  "Nerola": [42.16202, 12.78665],
  "Nervesa della Battaglia": [45.82449, 12.20742],
  "Nerviano": [45.55399, 8.97085],
  "Nespolo": [42.15575, 13.06948],
  "Nesso": [45.91073, 9.159],
  "Netro": [45.53803, 7.9479],
  "Nettuno": [41.45749, 12.66142],
  "Neviano": [40.10543, 18.11905],
  "Neviano degli Arduini": [44.58365, 10.31775],
  "Neviglie": [44.69212, 8.11598],
  "Niardo": [45.97873, 10.3359],
  "Nibbiola": [45.37179, 8.65635],
  "Nibionno": [45.75312, 9.26396],
  "Nichelino": [44.99519, 7.64737],
  "Nicolosi": [37.61414, 15.02671],
  "Nicorvo": [45.28515, 8.66719],
  "Nicosia": [37.74805, 14.39855],
  "Nicotera": [38.54359, 15.9319],
  "Niella Belbo": [44.51329, 8.07912],
  "Niella Tanaro": [44.41483, 7.92136],
  "Nimis": [46.20034, 13.26531],
  "Niscemi": [37.14528, 14.38504],
  "Nissoria": [37.65516, 14.44936],
  "Nizza di Sicilia": [37.98886, 15.40794],
  "Nizza Monferrato": [44.77362, 8.3565],
  "Noale": [45.55055, 12.07041],
  "Noasca": [45.45305, 7.31354],
  "Nocara": [40.09894, 16.48354],
  "Nocciano": [42.334, 13.9841],
  "Nocera Inferiore": [40.74358, 14.64142],
  "Nocera Superiore": [40.74157, 14.67118],
  "Nocera Terinese": [39.03745, 16.164],
  "Nocera Umbra": [43.11095, 12.79032],
  "Noceto": [44.81026, 10.17719],
  "Noci": [40.79482, 17.12248],
  "Nociglia": [40.03625, 18.33034],
  "Noepoli": [40.08717, 16.32807],
  "Nogara": [45.17784, 11.06091],
  "Nogaredo": [45.91201, 11.02309],
  "Nogarole Rocca": [45.29164, 10.88371],
  "Nogarole Vicentino": [45.55948, 11.28793],
  "Noicattaro": [41.0339, 16.98484],
  "Nola": [40.92633, 14.52683],
  "Nole": [45.24524, 7.57012],
  "Noli": [44.20566, 8.41618],
  "Nomaglio": [45.53518, 7.85972],
  "Nomi": [45.92896, 11.07126],
  "Nonantola": [44.67778, 11.04312],
  "None": [44.93231, 7.54124],
  "Nonio": [45.84506, 8.3768],
  "Noragugume": [40.22475, 8.91997],
  "Norbello": [40.13396, 8.83225],
  "Norcia": [42.79236, 13.09285],
  "Norma": [41.58528, 12.97252],
  "Nosate": [45.55078, 8.72647],
  "Notaresco": [42.65903, 13.89404],
  "Noto": [36.8917, 15.0667],
  "Nova Levante": [46.42979, 11.53555],
  "Nova Milanese": [45.58699, 9.20172],
  "Nova Ponente": [46.41411, 11.4256],
  "Nova Siri": [40.14713, 16.53877],
  "Novafeltria": [43.89584, 12.28927],
  "Novaledo": [46.02258, 11.3658],
  "Novalesa": [45.18764, 7.01467],
  "Novara": [45.44589, 8.62192],
  "Novara di Sicilia": [38.01625, 15.13194],
  "Novate Mezzola": [46.22198, 9.44682],
  "Novate Milanese": [45.53282, 9.13588],
  "Nove": [45.72461, 11.67925],
  "Novedrate": [45.69758, 9.12349],
  "Novellara": [44.84513, 10.73189],
  "Novello": [44.58716, 7.92766],
  "Noventa di Piave": [45.66286, 12.52968],
  "Noventa Padovana": [45.41603, 11.95289],
  "Noventa Vicentina": [45.29091, 11.54046],
  "Novi di Modena": [44.89357, 10.90134],
  "Novi Ligure": [44.76018, 8.7871],
  "Novi Velia": [40.22457, 15.28711],
  "Noviglio": [45.35609, 9.07078],
  "Novoli": [40.37587, 18.04878],
  "Nucetto": [44.3394, 8.05892],
  "Nughedu San Nicolò": [40.55627, 9.02206],
  "Nughedu Santa Vittoria": [40.10207, 8.9543],
  "Nule": [40.46091, 9.18729],
  "Nulvi": [40.78058, 8.74457],
  "Numana": [43.51347, 13.62151],
  "Nuoro": [40.32319, 9.3303],
  "Nurachi": [39.97379, 8.53991],
  "Nuragus": [39.77664, 9.03864],
  "Nurallao": [39.79497, 9.07838],
  "Nuraminis": [39.44163, 9.0132],
  "Nureci": [39.8241, 8.97397],
  "Nurri": [39.7108, 9.22862],
  "Nus": [45.73921, 7.46694],
  "Nusco": [40.88614, 15.08447],
  "Nuvolento": [45.54783, 10.38328],
  "Nuvolera": [45.53333, 10.37016],
  "Nuxis": [39.15524, 8.73994],
  "Occhieppo Inferiore": [45.55322, 8.02256],
  "Occhieppo Superiore": [45.56478, 8.00472],
  "Occhiobello": [44.91937, 11.57945],
  "Occimiano": [45.06018, 8.50666],
  "Ocre": [42.28382, 13.47303],
  "Odalengo Grande": [45.10952, 8.16672],
  "Odalengo Piccolo": [45.07193, 8.20952],
  "Oderzo": [45.78089, 12.49313],
  "Odolo": [45.64856, 10.38825],
  "Ofena": [42.32815, 13.75886],
  "Offagna": [43.52726, 13.44148],
  "Offanengo": [45.3816, 9.74132],
  "Offida": [42.9352, 13.69193],
  "Offlaga": [45.38652, 10.11631],
  "Oggebbio": [45.99691, 8.65288],
  "Oggiona con Santo Stefano": [45.6973, 8.81847],
  "Oggiono": [45.79191, 9.35098],
  "Oglianico": [45.34257, 7.69274],
  "Ogliastro Cilento": [40.35113, 15.04638],
  "Olbia": [40.92318, 9.50486],
  "Olcenengo": [45.36359, 8.31139],
  "Oldenico": [45.40235, 8.38272],
  "Oleggio": [45.59669, 8.63736],
  "Oleggio Castello": [45.74932, 8.52971],
  "Olevano di Lomellina": [45.21322, 8.71747],
  "Olevano Romano": [41.86073, 13.03248],
  "Olevano sul Tusciano": [40.65736, 15.02199],
  "Olgiate Comasco": [45.78583, 8.96748],
  "Olgiate Molgora": [45.72978, 9.40299],
  "Olgiate Olona": [45.62777, 8.89079],
  "Olginate": [45.80228, 9.41032],
  "Oliena": [40.27132, 9.40595],
  "Oliva Gessi": [45.00533, 9.17363],
  "Olivadi": [38.72581, 16.42099],
  "Oliveri": [38.12463, 15.05948],
  "Oliveto Citra": [40.69162, 15.23612],
  "Oliveto Lario": [45.92998, 9.28397],
  "Oliveto Lucano": [40.53626, 16.1851],
  "Olivetta San Michele": [43.87981, 7.5155],
  "Olivola": [45.03769, 8.36696],
  "Ollastra": [39.95123, 8.73467],
  "Ollolai": [40.16919, 9.18122],
  "Ollomont": [45.8491, 7.3109],
  "Olmedo": [40.65004, 8.38262],
  "Olmeneta": [45.23447, 10.02474],
  "Olmo al Brembo": [45.96954, 9.64894],
  "Olmo Gentile": [44.58556, 8.24703],
  "Oltre il Colle": [45.89272, 9.76684],
  "Oltressenda Alta": [45.91448, 9.94422],
  "Oltrona di San Mamette": [45.75806, 8.97598],
  "Olzai": [40.18285, 9.14888],
  "Ome": [45.6249, 10.12416],
  "Omegna": [45.87562, 8.40893],
  "Omignano": [40.24932, 15.08407],
  "Onano": [42.69372, 11.81498],
  "Onanì": [40.48439, 9.44087],
  "Oncino": [44.6765, 7.19025],
  "Oneta": [45.87142, 9.81928],
  "Onifai": [40.4072, 9.65132],
  "Oniferi": [40.27218, 9.17026],
  "Ono San Pietro": [46.01645, 10.32924],
  "Onore": [45.89258, 10.00998],
  "Onzo": [44.06959, 8.05141],
  "Opera": [45.37791, 9.21146],
  "Opi": [41.77947, 13.83],
  "Oppeano": [45.3079, 11.17835],
  "Oppido Lucano": [40.766, 15.99007],
  "Oppido Mamertina": [38.29261, 15.9856],
  "Ora": [46.34812, 11.29832],
  "Orani": [40.25007, 9.17746],
  "Oratino": [41.58604, 14.58452],
  "Orbassano": [45.00703, 7.53696],
  "Orbetello": [42.43737, 11.20943],
  "Orciano Pisano": [43.49126, 10.51011],
  "Orco Feglino": [44.21957, 8.32516],
  "Ordona": [41.31537, 15.62856],
  "Orero": [44.40723, 9.2746],
  "Orgiano": [45.35159, 11.46648],
  "Orgosolo": [40.20532, 9.35551],
  "Oria": [40.50271, 17.64607],
  "Oricola": [42.04988, 13.0389],
  "Origgio": [45.59963, 9.01782],
  "Orino": [45.88179, 8.71293],
  "Orio al Serio": [45.67573, 9.69151],
  "Orio Canavese": [45.32849, 7.8603],
  "Orio Litta": [45.15721, 9.55531],
  "Oriolo": [40.05294, 16.44449],
  "Oriolo Romano": [42.15846, 12.13807],
  "Oristano": [39.90381, 8.59118],
  "Ormea": [44.14859, 7.91069],
  "Ormelle": [45.77874, 12.42014],
  "Ornago": [45.59832, 9.42201],
  "Ornavasso": [45.96919, 8.41577],
  "Ornica": [45.98891, 9.57845],
  "Orosei": [40.3786, 9.69713],
  "Orotelli": [40.30282, 9.11228],
  "Orria": [40.29944, 15.17141],
  "Orroli": [39.69394, 9.25194],
  "Orsago": [45.93088, 12.4236],
  "Orsara Bormida": [44.69009, 8.56244],
  "Orsara di Puglia": [41.28115, 15.26581],
  "Orsenigo": [45.7783, 9.18506],
  "Orsogna": [42.21867, 14.2821],
  "Orsomarso": [39.79908, 15.90785],
  "Orta di Atella": [40.96645, 14.26935],
  "Orta Nova": [41.32606, 15.70726],
  "Orta San Giulio": [45.79916, 8.40568],
  "Ortacesus": [39.53645, 9.08563],
  "Orte": [42.46045, 12.38639],
  "Ortelle": [40.03424, 18.39302],
  "Ortezzano": [43.03158, 13.6075],
  "Ortignano Raggiolo": [43.68151, 11.75251],
  "Ortisei": [46.57611, 11.6718],
  "Ortona": [42.35564, 14.40348],
  "Ortona dei Marsi": [41.99781, 13.72917],
  "Ortovero": [44.05383, 8.09109],
  "Ortucchio": [41.95488, 13.64541],
  "Ortueri": [40.03608, 8.98548],
  "Orune": [40.40613, 9.36974],
  "Orvieto": [42.71818, 12.10831],
  "Orvinio": [42.13156, 12.93747],
  "Orzinuovi": [45.4025, 9.92177],
  "Orzivecchi": [45.42089, 9.96045],
  "Osasco": [44.84947, 7.34317],
  "Osasio": [44.86946, 7.60753],
  "Oschiri": [40.71948, 9.09839],
  "Osidda": [40.52415, 9.21879],
  "Osiglia": [44.28079, 8.20062],
  "Osilo": [40.74402, 8.67133],
  "Osimo": [43.48619, 13.48191],
  "Osini": [39.822, 9.49729],
  "Osio Sopra": [45.62977, 9.59192],
  "Osio Sotto": [45.61618, 9.59271],
  "Osnago": [45.67573, 9.38802],
  "Osoppo": [46.25421, 13.08076],
  "Ospedaletti": [43.80074, 7.7177],
  "Ospedaletto": [46.04363, 11.5529],
  "Ospedaletto d'Alpinolo": [40.93919, 14.74555],
  "Ospedaletto Euganeo": [45.22253, 11.61059],
  "Ospedaletto Lodigiano": [45.16923, 9.58096],
  "Ospitale di Cadore": [46.3291, 12.32348],
  "Ospitaletto": [45.55686, 10.07517],
  "Ossago Lodigiano": [45.24487, 9.53648],
  "Ossana": [46.30628, 10.73804],
  "Ossi": [40.67634, 8.59067],
  "Ossimo": [45.94575, 10.22848],
  "Ossona": [45.50399, 8.89458],
  "Ostana": [44.69222, 7.18848],
  "Ostellato": [44.74541, 11.94083],
  "Ostiano": [45.2218, 10.24873],
  "Ostiglia": [45.06891, 11.13143],
  "Ostra": [43.61268, 13.15839],
  "Ostra Vetere": [43.60371, 13.05736],
  "Ostuni": [40.7322, 17.57783],
  "Otranto": [40.14635, 18.49114],
  "Otricoli": [42.42334, 12.4783],
  "Ottana": [40.23499, 9.04544],
  "Ottati": [40.46332, 15.31534],
  "Ottaviano": [40.84936, 14.47744],
  "Ottiglio": [45.05183, 8.33915],
  "Ottobiano": [45.15127, 8.83215],
  "Ottone": [44.62242, 9.33212],
  "Oulx": [45.03127, 6.83222],
  "Ovada": [44.63747, 8.64639],
  "Ovaro": [46.48426, 12.86519],
  "Oviglio": [44.8598, 8.48672],
  "Ovindoli": [42.13312, 13.51768],
  "Ovodda": [40.09619, 9.16097],
  "Oyace": [45.8507, 7.38251],
  "Ozegna": [45.34901, 7.74313],
  "Ozieri": [40.58498, 8.99838],
  "Ozzano dell'Emilia": [44.44484, 11.4782],
  "Ozzano Monferrato": [45.10189, 8.37623],
  "Ozzero": [45.36877, 8.92293],
  "Pabillonis": [39.59572, 8.71933],
  "Pace del Mela": [38.18013, 15.3057],
  "Paceco": [37.98109, 12.5571],
  "Pacentro": [42.05108, 13.99339],
  "Pachino": [36.71609, 15.09315],
  "Paciano": [43.02209, 12.07101],
  "Padenghe sul Garda": [45.50945, 10.50836],
  "Paderna": [44.82073, 8.89],
  "Paderno d'Adda": [45.68025, 9.44739],
  "Paderno Dugnano": [45.56855, 9.16607],
  "Paderno Franciacorta": [45.59041, 10.07776],
  "Paderno Ponchielli": [45.23876, 9.92758],
  "Padova": [45.40693, 11.87609],
  "Padria": [40.39801, 8.63044],
  "Padru": [40.76705, 9.52254],
  "Padula": [40.34105, 15.65952],
  "Paduli": [41.1686, 14.8873],
  "Paesana": [44.68545, 7.27656],
  "Paese": [45.67164, 12.15354],
  "Pagani": [40.74107, 14.61944],
  "Paganico Sabino": [42.18955, 12.99749],
  "Pagazzano": [45.53359, 9.67331],
  "Pagliara": [37.98659, 15.3595],
  "Paglieta": [42.16271, 14.49852],
  "Pagnacco": [46.12418, 13.18812],
  "Pagno": [44.61374, 7.42994],
  "Pagnona": [46.05982, 9.40244],
  "Pago del Vallo di Lauro": [40.89678, 14.60519],
  "Pago Veiano": [41.24653, 14.87351],
  "Paisco Loveno": [46.07887, 10.29276],
  "Paitone": [45.553, 10.39994],
  "Paladina": [45.72721, 9.60638],
  "Palagano": [44.32072, 10.64775],
  "Palagianello": [40.61116, 16.97802],
  "Palagiano": [40.57851, 17.0372],
  "Palagonia": [37.32766, 14.74576],
  "Palaia": [43.60482, 10.77308],
  "Palanzano": [44.43535, 10.1924],
  "Palata": [41.88848, 14.78674],
  "Palau": [41.17769, 9.38303],
  "Palazzago": [45.75123, 9.53731],
  "Palazzo Adriano": [37.68162, 13.37966],
  "Palazzo Canavese": [45.45748, 7.97805],
  "Palazzo Pignano": [45.38905, 9.57793],
  "Palazzo San Gervasio": [40.93061, 15.98079],
  "Palazzolo Acreide": [37.06188, 14.90383],
  "Palazzolo dello Stella": [45.80437, 13.07946],
  "Palazzolo sull'Oglio": [45.59848, 9.88582],
  "Palazzolo Vercellese": [45.1845, 8.23282],
  "Palazzuolo sul Senio": [44.11227, 11.54729],
  "Palena": [41.98345, 14.13777],
  "Palermiti": [38.74827, 16.45199],
  "Palermo": [38.1157, 13.36236],
  "Palestrina": [41.83943, 12.88916],
  "Palestro": [45.30584, 8.53468],
  "Paliano": [41.80489, 13.05934],
  "Palizzi": [37.91928, 15.98332],
  "Pallagorio": [39.30832, 16.91335],
  "Pallanzeno": [46.04347, 8.25786],
  "Pallare": [44.32763, 8.27496],
  "Palma Campania": [40.86703, 14.55634],
  "Palma di Montechiaro": [37.19168, 13.76368],
  "Palmanova": [45.90476, 13.30987],
  "Palmariggi": [40.13163, 18.38131],
  "Palmas Arborea": [39.876, 8.64568],
  "Palmi": [38.35738, 15.84982],
  "Palmiano": [42.89932, 13.45855],
  "Palmoli": [41.93877, 14.58073],
  "Palo del Colle": [41.05665, 16.70401],
  "Palombara Sabina": [42.06655, 12.76511],
  "Palombaro": [42.12414, 14.22996],
  "Palomonte": [40.66016, 15.29174],
  "Palosco": [45.58347, 9.83787],
  "Paludi": [39.53102, 16.67857],
  "Paluzza": [46.52895, 13.01543],
  "Palù": [45.32469, 11.15457],
  "Palù del Fersina": [46.12991, 11.35213],
  "Pamparato": [44.27713, 7.91385],
  "Pancalieri": [44.83047, 7.58816],
  "Pancarana": [45.07523, 9.05106],
  "Panchià": [46.28568, 11.54223],
  "Pandino": [45.40668, 9.55269],
  "Panettieri": [39.06007, 16.45375],
  "Panicale": [43.02936, 12.10063],
  "Pannarano": [41.01129, 14.70242],
  "Panni": [41.22026, 15.27708],
  "Pantelleria": [36.83189, 11.94474],
  "Pantigliate": [45.43969, 9.35393],
  "Paola": [39.35994, 16.04152],
  "Paolisi": [41.03731, 14.57918],
  "Papasidero": [39.87159, 15.90581],
  "Papozze": [44.98787, 12.03106],
  "Parabiago": [45.55801, 8.95239],
  "Parabita": [40.04541, 18.1266],
  "Paratico": [45.6616, 9.95762],
  "Parcines": [46.68442, 11.07351],
  "Parella": [45.42999, 7.79103],
  "Parenti": [39.1628, 16.41276],
  "Parete": [40.95651, 14.16422],
  "Pareto": [44.51574, 8.38287],
  "Parghelia": [38.68184, 15.92424],
  "Parlasco": [46.01813, 9.34538],
  "Parma": [44.80107, 10.32835],
  "Parodi Ligure": [44.67082, 8.75862],
  "Paroldo": [44.43167, 8.07132],
  "Parolise": [40.93089, 14.88242],
  "Parona": [45.28261, 8.74982],
  "Parrano": [42.86353, 12.1057],
  "Parre": [45.87707, 9.8919],
  "Partanna": [37.7214, 12.88966],
  "Partinico": [38.04808, 13.11522],
  "Paruzzaro": [45.74869, 8.51346],
  "Parzanica": [45.73811, 10.0359],
  "Pasian di Prato": [46.04925, 13.1908],
  "Pasiano di Pordenone": [45.85133, 12.62742],
  "Paspardo": [46.02987, 10.37106],
  "Passerano Marmorito": [45.05639, 8.01879],
  "Passignano sul Trasimeno": [43.18495, 12.13688],
  "Passirano": [45.59815, 10.06403],
  "Pastena": [41.46795, 13.49202],
  "Pastorano": [41.18228, 14.20148],
  "Pastrengo": [45.49218, 10.80027],
  "Pasturana": [44.75068, 8.74904],
  "Pasturo": [45.95138, 9.44344],
  "Paterno": [40.37741, 15.73215],
  "Paterno Calabro": [39.22515, 16.2631],
  "Paternopoli": [40.97417, 15.03493],
  "Paternò": [37.57697, 14.90252],
  "Patrica": [41.59213, 13.24387],
  "Pattada": [40.58281, 9.1121],
  "Patti": [38.13978, 14.96404],
  "Patù": [39.83965, 18.33874],
  "Pau": [39.79272, 8.8031],
  "Paularo": [46.53032, 13.11669],
  "Pauli Arbarei": [39.66034, 8.92265],
  "Paulilatino": [40.08656, 8.76049],
  "Paullo": [45.41702, 9.3994],
  "Paupisi": [41.19662, 14.66457],
  "Pavarolo": [45.06893, 7.83476],
  "Pavia": [45.18509, 9.16016],
  "Pavia di Udine": [45.97819, 13.28122],
  "Pavone Canavese": [45.43526, 7.85398],
  "Pavone del Mella": [45.30332, 10.20805],
  "Pavullo nel Frignano": [44.33947, 10.83399],
  "Pazzano": [38.47716, 16.45052],
  "Peccioli": [43.54801, 10.72105],
  "Pecetto di Valenza": [44.98972, 8.67047],
  "Pecetto Torinese": [45.01956, 7.7487],
  "Pedara": [37.6172, 15.06022],
  "Pedaso": [43.09802, 13.84092],
  "Pedavena": [46.03939, 11.88144],
  "Pedemonte": [45.90852, 11.30588],
  "Pederobba": [45.86084, 11.98582],
  "Pedesina": [46.08222, 9.54953],
  "Pedivigliano": [39.11034, 16.30486],
  "Pedrengo": [45.69843, 9.73414],
  "Peglio (CO)": [46.16018, 9.29479],
  "Peglio (PU)": [43.69604, 12.49604],
  "Pegognaga": [44.9961, 10.85905],
  "Peia": [45.79967, 9.89708],
  "Peio": [46.35529, 10.68908],
  "Pelago": [43.77025, 11.50636],
  "Pella": [45.79707, 8.38312],
  "Pellegrino Parmense": [44.73333, 9.92684],
  "Pellezzano": [40.72587, 14.75783],
  "Pellizzano": [46.30939, 10.76057],
  "Pelugo": [46.08811, 10.72334],
  "Penango": [45.03326, 8.25013],
  "Penna in Teverina": [42.49302, 12.35539],
  "Penna San Giovanni": [43.05657, 13.42374],
  "Penna Sant'Andrea": [42.59363, 13.77151],
  "Pennabilli": [43.81831, 12.26477],
  "Pennadomo": [42.00447, 14.32326],
  "Pennapiedimonte": [42.15198, 14.19492],
  "Penne": [42.45804, 13.92739],
  "Pentone": [38.98499, 16.58213],
  "Perano": [42.10784, 14.3965],
  "Perarolo di Cadore": [46.39739, 12.3553],
  "Perca": [46.79146, 11.98322],
  "Percile": [42.09466, 12.91041],
  "Perdasdefogu": [39.67798, 9.44161],
  "Perdaxius": [39.16149, 8.60999],
  "Perdifumo": [40.26694, 15.01652],
  "Pereto": [42.05807, 13.10151],
  "Perfugas": [40.83024, 8.88347],
  "Pergine Valsugana": [46.06032, 11.24049],
  "Pergola": [43.56288, 12.83599],
  "Perinaldo": [43.8662, 7.67424],
  "Perito": [40.29854, 15.14746],
  "Perledo": [46.01529, 9.29557],
  "Perletto": [44.599, 8.21408],
  "Perlo": [44.33309, 8.08361],
  "Perloz": [45.61311, 7.8086],
  "Pernumia": [45.25705, 11.78694],
  "Pero": [45.5108, 9.08902],
  "Perosa Argentina": [44.9581, 7.19237],
  "Perosa Canavese": [45.39716, 7.82926],
  "Perrero": [44.93746, 7.11527],
  "Persico Dosimo": [45.18462, 10.10336],
  "Pertengo": [45.23562, 8.41763],
  "Pertica Alta": [45.74265, 10.34429],
  "Pertica Bassa": [45.75333, 10.37304],
  "Pertosa": [40.54321, 15.44853],
  "Pertusio": [45.3534, 7.63872],
  "Perugia": [43.10676, 12.38825],
  "Pesaro": [43.91014, 12.91346],
  "Pescaglia": [43.96642, 10.41128],
  "Pescantina": [45.48256, 10.86724],
  "Pescara": [42.46458, 14.21365],
  "Pescarolo ed Uniti": [45.19704, 10.1851],
  "Pescasseroli": [41.80863, 13.78922],
  "Pescate": [45.82997, 9.39454],
  "Pesche": [41.61124, 14.28164],
  "Peschici": [41.9466, 16.01572],
  "Peschiera Borromeo": [45.43177, 9.31109],
  "Peschiera del Garda": [45.43914, 10.69194],
  "Pescia": [43.90316, 10.68859],
  "Pescina": [42.02607, 13.66006],
  "Pesco Sannita": [41.23436, 14.81092],
  "Pescocostanzo": [41.89027, 14.06578],
  "Pescolanciano": [41.67886, 14.33684],
  "Pescopagano": [40.83589, 15.39692],
  "Pescopennataro": [41.87825, 14.29485],
  "Pescorocchiano": [42.20606, 13.1485],
  "Pescosansonesco": [42.25404, 13.88437],
  "Pescosolido": [41.74972, 13.65573],
  "Pessano con Bornago": [45.55028, 9.38762],
  "Pessina Cremonese": [45.18504, 10.24812],
  "Pessinetto": [45.29054, 7.40285],
  "Petacciato": [42.01345, 14.8601],
  "Petilia Policastro": [39.11065, 16.79271],
  "Petina": [40.5314, 15.37018],
  "Petralia Soprana": [37.79634, 14.10825],
  "Petralia Sottana": [37.80594, 14.09222],
  "Petrella Salto": [42.29456, 13.06836],
  "Petrella Tifernina": [41.69133, 14.69493],
  "Petriano": [43.78031, 12.73335],
  "Petriolo": [43.22103, 13.46563],
  "Petritoli": [43.06699, 13.65617],
  "Petrizzi": [38.70249, 16.47401],
  "Petronà": [39.03948, 16.75617],
  "Petrosino": [37.71277, 12.49232],
  "Petruro Irpino": [41.03159, 14.79729],
  "Pettenasco": [45.81732, 8.40858],
  "Pettinengo": [45.614, 8.1053],
  "Pettineo": [37.96661, 14.29122],
  "Pettoranello del Molise": [41.57358, 14.27698],
  "Pettorano sul Gizio": [41.97281, 13.96035],
  "Pettorazza Grimani": [45.13602, 11.9888],
  "Peveragno": [44.33001, 7.61714],
  "Pezzana": [45.26206, 8.4842],
  "Pezzaze": [45.77493, 10.23922],
  "Pezzolo Valle Uzzone": [44.53928, 8.19411],
  "Piacenza": [45.05193, 9.69263],
  "Piacenza d'Adige": [45.12743, 11.54716],
  "Piaggine": [40.34318, 15.37724],
  "Pian Camuno": [45.84372, 10.15748],
  "Piana Crixia": [44.48527, 8.30751],
  "Piana degli Albanesi": [37.99447, 13.28199],
  "Piana di Monte Verna": [41.16756, 14.33405],
  "Piancastagnaio": [42.84944, 11.69182],
  "Piancogno": [45.9188, 10.22051],
  "Piandimeleto": [43.72416, 12.41513],
  "Piane Crati": [39.2348, 16.32298],
  "Pianella": [42.39631, 14.04605],
  "Pianello del Lario": [46.10038, 9.27647],
  "Pianello Val Tidone": [44.94837, 9.40479],
  "Pianengo": [45.40047, 9.69281],
  "Pianezza": [45.10062, 7.54636],
  "Pianezze": [45.73872, 11.62486],
  "Pianfei": [44.37049, 7.70976],
  "Pianico": [45.811, 10.04354],
  "Pianiga": [45.4556, 12.03004],
  "Piano di Sorrento": [40.6339, 14.41322],
  "Pianopoli": [38.95437, 16.38918],
  "Pianoro": [44.38511, 11.34326],
  "Piansano": [42.51789, 11.82825],
  "Piantedo": [46.13393, 9.4315],
  "Piario": [45.89596, 9.92644],
  "Piasco": [44.56856, 7.45741],
  "Piateda": [46.15975, 9.93889],
  "Piatto": [45.5918, 8.13519],
  "Piazza al Serchio": [44.18257, 10.30002],
  "Piazza Armerina": [37.38421, 14.36604],
  "Piazza Brembana": [45.94632, 9.67735],
  "Piazzatorre": [45.99001, 9.68557],
  "Piazzola sul Brenta": [45.54173, 11.78645],
  "Piazzolo": [45.97907, 9.67228],
  "Picciano": [42.47481, 13.99135],
  "Picerno": [40.6371, 15.63601],
  "Picinisco": [41.64683, 13.86717],
  "Pico": [41.45171, 13.55871],
  "Piea": [45.02529, 8.07209],
  "Piedicavallo": [45.68961, 7.95606],
  "Piedimonte Etneo": [37.80767, 15.17821],
  "Piedimonte Matese": [41.35594, 14.37422],
  "Piedimonte San Germano": [41.49737, 13.75034],
  "Piedimulera": [46.02709, 8.25981],
  "Piegaro": [42.97051, 12.08582],
  "Pienza": [43.07633, 11.67996],
  "Pieranica": [45.42516, 9.61072],
  "Pietra de' Giorgi": [45.02083, 9.22976],
  "Pietra Ligure": [44.14886, 8.28283],
  "Pietra Marazzi": [44.94414, 8.67055],
  "Pietrabbondante": [41.7487, 14.38776],
  "Pietrabruna": [43.88997, 7.90348],
  "Pietracamela": [42.52323, 13.55376],
  "Pietracatella": [41.58157, 14.87345],
  "Pietracupa": [41.68229, 14.52115],
  "Pietradefusi": [41.03741, 14.88931],
  "Pietraferrazzana": [41.96963, 14.37371],
  "Pietrafitta": [39.26192, 16.33876],
  "Pietragalla": [40.74811, 15.88239],
  "Pietralunga": [43.44219, 12.43684],
  "Pietramelara": [41.26686, 14.18614],
  "Pietramontecorvino": [41.54313, 15.12978],
  "Pietranico": [42.27624, 13.91085],
  "Pietrapaola": [39.48683, 16.81598],
  "Pietrapertosa": [40.51565, 16.06349],
  "Pietraperzia": [37.42163, 14.13691],
  "Pietraporzio": [44.34401, 7.03194],
  "Pietraroja": [41.34732, 14.54987],
  "Pietrarubbia": [43.8042, 12.3774],
  "Pietrasanta": [43.95956, 10.22769],
  "Pietrastornina": [40.99204, 14.72957],
  "Pietravairano": [41.32195, 14.16222],
  "Pietrelcina": [41.19688, 14.84875],
  "Pieve a Nievole": [43.87898, 10.79466],
  "Pieve Albignola": [45.11313, 8.96031],
  "Pieve d'Olmi": [45.09183, 10.12206],
  "Pieve del Cairo": [45.04897, 8.8051],
  "Pieve di Bono-Prezzo": [45.9431, 10.6413],
  "Pieve di Cadore": [46.42937, 12.37484],
  "Pieve di Cento": [44.71363, 11.307],
  "Pieve di Soligo": [45.90001, 12.17468],
  "Pieve di Teco": [44.047, 7.91522],
  "Pieve Emanuele": [45.35118, 9.19969],
  "Pieve Fissiraga": [45.26269, 9.45925],
  "Pieve Fosciana": [44.13063, 10.41069],
  "Pieve Ligure": [44.37467, 9.08689],
  "Pieve Porto Morone": [45.11251, 9.43846],
  "Pieve San Giacomo": [45.12808, 10.18674],
  "Pieve Santo Stefano": [43.6685, 12.04175],
  "Pieve Tesino": [46.06901, 11.61057],
  "Pieve Torina": [43.04433, 13.05039],
  "Pieve Vergonte": [46.00556, 8.26849],
  "Pievepelago": [44.20703, 10.61698],
  "Piglio": [41.83016, 13.14555],
  "Pigna": [43.93301, 7.66338],
  "Pignataro Interamna": [41.43728, 13.78895],
  "Pignataro Maggiore": [41.18929, 14.17125],
  "Pignola": [40.57403, 15.78496],
  "Pignone": [44.17916, 9.72405],
  "Pigra": [45.95735, 9.12646],
  "Pila": [45.77025, 8.08082],
  "Pimentel": [39.48453, 9.0656],
  "Pimonte": [40.67369, 14.51345],
  "Pinarolo Po": [45.06603, 9.16481],
  "Pinasca": [44.94266, 7.22767],
  "Pincara": [44.99305, 11.61154],
  "Pinerolo": [44.88733, 7.332],
  "Pineto": [42.60828, 14.06747],
  "Pino d'Asti": [45.05819, 7.98626],
  "Pino Torinese": [45.04352, 7.77217],
  "Pinzano al Tagliamento": [46.18314, 12.94601],
  "Pinzolo": [46.16001, 10.76661],
  "Piobbico": [43.58882, 12.51035],
  "Piobesi d'Alba": [44.73491, 7.97851],
  "Piobesi Torinese": [44.93306, 7.61193],
  "Piode": [45.76977, 8.05309],
  "Pioltello": [45.49678, 9.32814],
  "Piombino": [42.92197, 10.52741],
  "Piombino Dese": [45.60764, 11.99851],
  "Pioraco": [43.17878, 12.98484],
  "Piossasco": [44.9907, 7.46276],
  "Piove di Sacco": [45.29611, 12.03516],
  "Piovene Rocchette": [45.75878, 11.43021],
  "Piovà Massaia": [45.05449, 8.05094],
  "Piozzano": [44.9254, 9.49437],
  "Piozzo": [44.51576, 7.89242],
  "Piraino": [38.1619, 14.86317],
  "Pisa": [43.71553, 10.40127],
  "Pisano": [45.79355, 8.51044],
  "Piscina": [44.91946, 7.4259],
  "Piscinas": [39.07544, 8.666],
  "Pisciotta": [40.10773, 15.23371],
  "Pisogne": [45.8048, 10.1089],
  "Pisoniano": [41.90815, 12.959],
  "Pisticci": [40.39073, 16.55864],
  "Pistoia": [43.93346, 10.91734],
  "Pitigliano": [42.63492, 11.66942],
  "Piubega": [45.22757, 10.53503],
  "Piuro": [46.32947, 9.42085],
  "Piverone": [45.44754, 8.0071],
  "Pizzale": [45.03431, 9.04731],
  "Pizzighettone": [45.18665, 9.78313],
  "Pizzo": [38.73591, 16.16159],
  "Pizzoferrato": [41.92228, 14.23727],
  "Pizzoli": [42.43621, 13.2954],
  "Pizzone": [41.66678, 14.03575],
  "Pizzoni": [38.62342, 16.24949],
  "Placanica": [38.4098, 16.45345],
  "Plataci": [39.9007, 16.43148],
  "Platania": [39.00442, 16.31877],
  "Platì": [38.22028, 16.04397],
  "Plaus": [46.65569, 11.04237],
  "Plesio": [46.04418, 9.22786],
  "Ploaghe": [40.66573, 8.7493],
  "Plodio": [44.35653, 8.24352],
  "Pocapaglia": [44.71946, 7.88719],
  "Pocenia": [45.83723, 13.09849],
  "Podenzana": [44.20637, 9.94122],
  "Podenzano": [44.95486, 9.68531],
  "Pofi": [41.56545, 13.41528],
  "Poggiardo": [40.05343, 18.37686],
  "Poggibonsi": [43.46687, 11.14663],
  "Poggio a Caiano": [43.81629, 11.05585],
  "Poggio Bustone": [42.50214, 12.8858],
  "Poggio Catino": [42.29507, 12.69181],
  "Poggio Imperiale": [41.8219, 15.36586],
  "Poggio Mirteto": [42.26459, 12.68365],
  "Poggio Moiano": [42.20187, 12.87712],
  "Poggio Nativo": [42.21582, 12.79533],
  "Poggio Picenze": [42.32068, 13.5422],
  "Poggio Renatico": [44.76471, 11.48545],
  "Poggio Rusco": [44.97743, 11.11882],
  "Poggio San Lorenzo": [42.2529, 12.84551],
  "Poggio San Marcello": [43.5116, 13.07705],
  "Poggio San Vicino": [43.37471, 13.07884],
  "Poggio Sannita": [41.77861, 14.41318],
  "Poggio Torriana": [43.985, 12.3868],
  "Poggiodomo": [42.71168, 12.93472],
  "Poggiofiorito": [42.25411, 14.32128],
  "Poggiomarino": [40.79867, 14.54081],
  "Poggioreale": [37.76215, 13.03394],
  "Poggiorsini": [40.91494, 16.25245],
  "Poggiridenti": [46.17587, 9.92866],
  "Pogliano Milanese": [45.53726, 8.99355],
  "Pognana Lario": [45.8774, 9.15784],
  "Pognano": [45.5859, 9.64199],
  "Pogno": [45.75667, 8.38307],
  "Poirino": [44.9212, 7.84362],
  "Pojana Maggiore": [45.29207, 11.50138],
  "Polaveno": [45.6612, 10.12425],
  "Polcenigo": [46.03057, 12.50174],
  "Polesella": [44.96255, 11.75509],
  "Polesine Zibello": [45.0194, 10.1307],
  "Poli": [41.88717, 12.89329],
  "Polia": [38.75092, 16.31405],
  "Policoro": [40.20872, 16.66969],
  "Polignano a Mare": [40.99216, 17.21913],
  "Polinago": [44.34436, 10.72311],
  "Polino": [42.58481, 12.8438],
  "Polistena": [38.40797, 16.07618],
  "Polizzi Generosa": [37.81291, 13.99947],
  "Polla": [40.5142, 15.49326],
  "Pollein": [45.72805, 7.35717],
  "Pollena Trocchia": [40.85809, 14.37874],
  "Pollenza": [43.26782, 13.3476],
  "Pollica": [40.19071, 15.05734],
  "Pollina": [37.99425, 14.14658],
  "Pollone": [45.58354, 8.00093],
  "Pollutri": [42.1373, 14.59413],
  "Polonghera": [44.80335, 7.59607],
  "Polpenazze del Garda": [45.54719, 10.50463],
  "Polverara": [45.31061, 11.9574],
  "Polverigi": [43.52521, 13.39412],
  "Pomarance": [43.30012, 10.87382],
  "Pomaretto": [44.95507, 7.1822],
  "Pomarico": [40.51782, 16.54625],
  "Pomaro Monferrato": [45.06392, 8.59519],
  "Pomarolo": [45.9268, 11.04306],
  "Pombia": [45.64927, 8.63239],
  "Pomezia": [41.67003, 12.50163],
  "Pomigliano d'Arco": [40.9069, 14.39336],
  "Pompei": [40.74842, 14.50001],
  "Pompeiana": [43.85278, 7.88853],
  "Pompiano": [45.43278, 9.98715],
  "Pomponesco": [44.92807, 10.59042],
  "Pompu": [39.72488, 8.79572],
  "Poncarale": [45.46051, 10.17396],
  "Ponderano": [45.53855, 8.05681],
  "Ponna": [45.98964, 9.09401],
  "Ponsacco": [43.62021, 10.63361],
  "Ponso": [45.19215, 11.58636],
  "Pont-Canavese": [45.42073, 7.59357],
  "Pont-Saint-Martin": [45.59981, 7.7978],
  "Pontassieve": [43.77581, 11.43987],
  "Pontboset": [45.60643, 7.68765],
  "Ponte": [41.21302, 14.68997],
  "Ponte Buggianese": [43.84276, 10.74745],
  "Ponte dell'Olio": [44.8679, 9.64285],
  "Ponte di Legno": [46.25647, 10.51146],
  "Ponte di Piave": [45.71602, 12.46396],
  "Ponte Gardena": [46.59707, 11.53034],
  "Ponte in Valtellina": [46.17439, 9.97749],
  "Ponte Lambro": [45.82699, 9.22492],
  "Ponte nelle Alpi": [46.173, 12.30136],
  "Ponte Nizza": [44.85187, 9.09737],
  "Ponte Nossa": [45.86954, 9.8874],
  "Ponte San Nicolò": [45.36412, 11.93066],
  "Ponte San Pietro": [45.69899, 9.5869],
  "Pontebba": [46.50664, 13.30384],
  "Pontecagnano Faiano": [40.64297, 14.8734],
  "Pontecchio Polesine": [45.01917, 11.81157],
  "Pontechianale": [44.62199, 7.02831],
  "Pontecorvo": [41.4574, 13.66537],
  "Pontecurone": [44.95884, 8.93594],
  "Pontedassio": [43.94044, 8.01269],
  "Pontedera": [43.66393, 10.63601],
  "Pontelandolfo": [41.2885, 14.69074],
  "Pontelatone": [41.19344, 14.25105],
  "Pontelongo": [45.25029, 12.01911],
  "Pontenure": [44.99964, 9.78615],
  "Ponteranica": [45.73074, 9.65476],
  "Pontestura": [45.14364, 8.33254],
  "Pontevico": [45.2736, 10.08503],
  "Pontey": [45.7379, 7.59135],
  "Ponti": [44.62742, 8.36523],
  "Ponti sul Mincio": [45.41156, 10.68746],
  "Pontida": [45.73148, 9.50045],
  "Pontinia": [41.40823, 13.04403],
  "Pontinvrea": [44.4449, 8.43457],
  "Pontirolo Nuovo": [45.56867, 9.56781],
  "Pontoglio": [45.57062, 9.85265],
  "Pontremoli": [44.37739, 9.88295],
  "Ponza": [40.89487, 12.96868],
  "Ponzano di Fermo": [43.10192, 13.65864],
  "Ponzano Monferrato": [45.08446, 8.26622],
  "Ponzano Romano": [42.2582, 12.57186],
  "Ponzano Veneto": [45.71909, 12.20711],
  "Ponzone": [44.58641, 8.45961],
  "Popoli": [42.17117, 13.83311],
  "Poppi": [43.72454, 11.76531],
  "Porano": [42.68703, 12.10199],
  "Porcari": [43.83966, 10.61671],
  "Porcia": [45.95806, 12.61375],
  "Pordenone": [45.95444, 12.66003],
  "Porlezza": [46.03641, 9.11981],
  "Pornassio": [44.07027, 7.87095],
  "Porpetto": [45.85923, 13.21547],
  "Portacomaro": [44.95711, 8.25851],
  "Portalbera": [45.09941, 9.3226],
  "Porte": [44.88757, 7.26799],
  "Porte di Rendena": [46.0626, 10.7121],
  "Portici": [40.82376, 14.35421],
  "Portico di Caserta": [41.05649, 14.28054],
  "Portico e San Benedetto": [44.02587, 11.78092],
  "Portigliola": [38.22769, 16.20285],
  "Porto Azzurro": [42.76458, 10.39873],
  "Porto Ceresio": [45.90402, 8.90628],
  "Porto Cesareo": [40.26035, 17.89966],
  "Porto Empedocle": [37.28847, 13.52747],
  "Porto Mantovano": [45.18878, 10.79001],
  "Porto Recanati": [43.42983, 13.66489],
  "Porto San Giorgio": [43.18444, 13.79639],
  "Porto Sant'Elpidio": [43.25799, 13.75807],
  "Porto Tolle": [44.95253, 12.33458],
  "Porto Torres": [40.83723, 8.40123],
  "Porto Valtravaglia": [45.96082, 8.68034],
  "Porto Viro": [45.02597, 12.21812],
  "Portobuffolè": [45.85392, 12.53845],
  "Portocannone": [41.91426, 15.0122],
  "Portoferraio": [42.81527, 10.3312],
  "Portofino": [44.30409, 9.20723],
  "Portogruaro": [45.77577, 12.83741],
  "Portomaggiore": [44.69781, 11.80578],
  "Portopalo di Capo Passero": [36.68333, 15.13397],
  "Portoscuso": [39.20388, 8.37902],
  "Portovenere": [44.05579, 9.83701],
  "Portula": [45.67532, 8.17908],
  "Posada": [40.63326, 9.718],
  "Posina": [45.79039, 11.26119],
  "Positano": [40.62889, 14.48362],
  "Possagno": [45.85469, 11.88144],
  "Posta": [42.52345, 13.09624],
  "Posta Fibreno": [41.69339, 13.69688],
  "Postal": [46.60963, 11.19155],
  "Postalesio": [46.17378, 9.77656],
  "Postiglione": [40.55724, 15.23304],
  "Postua": [45.71419, 8.2315],
  "Potenza": [40.63947, 15.80515],
  "Potenza Picena": [43.36626, 13.62026],
  "Pove del Grappa": [45.7989, 11.72905],
  "Povegliano": [45.75996, 12.20589],
  "Povegliano Veronese": [45.34726, 10.88093],
  "Poviglio": [44.84081, 10.54152],
  "Povoletto": [46.1181, 13.29846],
  "Pozzaglia Sabina": [42.15979, 12.96455],
  "Pozzaglio ed Uniti": [45.20097, 10.04847],
  "Pozzallo": [36.72659, 14.84616],
  "Pozzilli": [41.51146, 14.06192],
  "Pozzo d'Adda": [45.57395, 9.49955],
  "Pozzol Groppo": [44.87746, 9.02931],
  "Pozzolengo": [45.40286, 10.62709],
  "Pozzoleone": [45.64912, 11.67926],
  "Pozzolo Formigaro": [44.79387, 8.78155],
  "Pozzomaggiore": [40.39932, 8.65658],
  "Pozzonovo": [45.19826, 11.79015],
  "Pozzuoli": [40.84682, 14.09089],
  "Pozzuolo del Friuli": [45.98408, 13.19657],
  "Pozzuolo Martesana": [45.5124, 9.452],
  "Pradalunga": [45.74797, 9.78433],
  "Pradamano": [46.03125, 13.29943],
  "Pradleves": [44.4186, 7.28209],
  "Pragelato": [45.01628, 6.94229],
  "Praia a Mare": [39.89532, 15.77978],
  "Praiano": [40.61145, 14.53258],
  "Pralboino": [45.26809, 10.21488],
  "Prali": [44.89041, 7.04904],
  "Pralormo": [44.86136, 7.90066],
  "Pralungo": [45.59093, 8.03806],
  "Pramaggiore": [45.81219, 12.73462],
  "Pramollo": [44.90459, 7.2117],
  "Prarolo": [45.28223, 8.47934],
  "Prarostino": [44.86584, 7.26972],
  "Prasco": [44.64241, 8.55285],
  "Prascorsano": [45.36766, 7.61571],
  "Prata Camportaccio": [46.30639, 9.395],
  "Prata d'Ansidonia": [42.27824, 13.60628],
  "Prata di Pordenone": [45.89394, 12.59726],
  "Prata di Principato Ultra": [40.9865, 14.83708],
  "Prata Sannita": [41.43227, 14.20345],
  "Pratella": [41.40579, 14.17913],
  "Pratiglione": [45.35365, 7.59609],
  "Prato": [43.88062, 11.09703],
  "Prato allo Stelvio": [46.61756, 10.58959],
  "Prato Carnico": [46.52015, 12.79766],
  "Prato Sesia": [45.64788, 8.37377],
  "Pratola Peligna": [42.09736, 13.87243],
  "Pratola Serra": [40.9854, 14.85232],
  "Pratovecchio Stia": [43.7982, 11.7084],
  "Pravisdomini": [45.81756, 12.69215],
  "Pray": [45.67617, 8.20873],
  "Prazzo": [44.48308, 7.05543],
  "Precenicco": [45.78971, 13.07871],
  "Preci": [42.87868, 13.03872],
  "Predaia": [46.3234, 11.0731],
  "Predappio": [44.10181, 11.9805],
  "Predazzo": [46.31256, 11.60278],
  "Predoi": [47.0385, 12.10287],
  "Predore": [45.68066, 10.0195],
  "Predosa": [44.75273, 8.65924],
  "Preganziol": [45.60142, 12.23509],
  "Pregnana Milanese": [45.51744, 9.01002],
  "Prelà": [43.92622, 7.93699],
  "Premana": [46.05224, 9.42311],
  "Premariacco": [46.05897, 13.39425],
  "Premeno": [45.97712, 8.59146],
  "Premia": [46.26884, 8.33953],
  "Premilcuore": [43.97642, 11.77569],
  "Premolo": [45.8686, 9.87533],
  "Premosello-Chiovenda": [46.00274, 8.32942],
  "Preone": [46.39518, 12.86798],
  "Prepotto": [46.04593, 13.47949],
  "Preseglie": [45.66534, 10.39293],
  "Presenzano": [41.37746, 14.07857],
  "Presezzo": [45.69162, 9.56671],
  "Pressana": [45.28479, 11.40198],
  "Pretoro": [42.21678, 14.1425],
  "Prevalle": [45.54706, 10.42122],
  "Prezza": [42.05775, 13.8332],
  "Priero": [44.37662, 8.09242],
  "Prignano Cilento": [40.32987, 15.06923],
  "Prignano sulla Secchia": [44.43599, 10.68952],
  "Primaluna": [45.98688, 9.42947],
  "Primiero San Martino di Castrozza": [46.1771, 11.8298],
  "Priocca": [44.79131, 8.06273],
  "Priola": [44.24598, 8.02242],
  "Priolo Gargallo": [37.15942, 15.18829],
  "Priverno": [41.474, 13.18065],
  "Prizzi": [37.72165, 13.43099],
  "Proceno": [42.75721, 11.83044],
  "Procida": [40.76579, 14.02404],
  "Propata": [44.56472, 9.18488],
  "Proserpio": [45.82765, 9.24887],
  "Prossedi": [41.51691, 13.26106],
  "Provaglio d'Iseo": [45.63778, 10.04215],
  "Provaglio Val Sabbia": [45.68858, 10.43393],
  "Proves": [46.47618, 11.02232],
  "Provvidenti": [41.71856, 14.82236],
  "Prunetto": [44.48945, 8.14431],
  "Pré-Saint-Didier": [45.76376, 6.98635],
  "Puegnago del Garda": [45.57047, 10.50991],
  "Puglianello": [41.22179, 14.45023],
  "Pula": [39.0107, 9.00077],
  "Pulfero": [46.17324, 13.48427],
  "Pulsano": [40.38297, 17.3525],
  "Pumenengo": [45.4803, 9.86773],
  "Pusiano": [45.81478, 9.28214],
  "Putifigari": [40.56251, 8.46066],
  "Putignano": [40.84964, 17.1191],
  "Quadrelle": [40.9471, 14.63819],
  "Quadri": [41.92582, 14.28838],
  "Quagliuzzo": [45.42649, 7.78184],
  "Qualiano": [40.9202, 14.15087],
  "Quaranti": [44.75105, 8.44908],
  "Quargnento": [44.94484, 8.48771],
  "Quarna Sopra": [45.87305, 8.37224],
  "Quarna Sotto": [45.86823, 8.36388],
  "Quarona": [45.75985, 8.26542],
  "Quarrata": [43.84759, 10.97861],
  "Quart": [45.74068, 7.4156],
  "Quarto": [40.8777, 14.14351],
  "Quarto d'Altino": [45.58155, 12.37143],
  "Quartu Sant'Elena": [39.24108, 9.18534],
  "Quartucciu": [39.25428, 9.18003],
  "Quassolo": [45.52493, 7.83248],
  "Quattordio": [44.89921, 8.40599],
  "Quattro Castella": [44.63577, 10.47269],
  "Quero Vas": [45.9405, 11.9208],
  "Quiliano": [44.29342, 8.41138],
  "Quincinetto": [45.56081, 7.80577],
  "Quindici": [40.86251, 14.64824],
  "Quingentole": [45.03988, 11.04575],
  "Quintano": [45.42024, 9.61844],
  "Quinto di Treviso": [45.646, 12.16602],
  "Quinto Vercellese": [45.38048, 8.36218],
  "Quinto Vicentino": [45.57306, 11.62503],
  "Quinzano d'Oglio": [45.31369, 10.00872],
  "Quistello": [45.00907, 10.98044],
  "Rabbi": [46.39825, 10.85066],
  "Racale": [39.95746, 18.0906],
  "Racalmuto": [37.40771, 13.73142],
  "Racconigi": [44.76782, 7.67598],
  "Raccuja": [38.05561, 14.91065],
  "Racines": [46.88271, 11.37851],
  "Radda in Chianti": [43.48654, 11.37441],
  "Raddusa": [37.47292, 14.53173],
  "Radicofani": [42.89699, 11.76638],
  "Radicondoli": [43.26112, 11.04132],
  "Raffadali": [37.4049, 13.53109],
  "Ragalna": [37.63013, 14.93914],
  "Ragogna": [46.17713, 12.97823],
  "Ragusa": [36.92509, 14.7307],
  "Raiano": [42.1028, 13.80833],
  "Ramacca": [37.38487, 14.69378],
  "Rancio Valcuvia": [45.91633, 8.7702],
  "Ranco": [45.79845, 8.57473],
  "Randazzo": [37.87791, 14.94605],
  "Ranica": [45.72696, 9.71461],
  "Ranzanico": [45.7886, 9.93612],
  "Ranzo": [44.05956, 8.01447],
  "Rapagnano": [43.16101, 13.5928],
  "Rapallo": [44.35017, 9.23175],
  "Rapino": [42.2117, 14.18759],
  "Rapolano Terme": [43.28653, 11.60416],
  "Rapolla": [40.97718, 15.67282],
  "Rapone": [40.84647, 15.49812],
  "Rassa": [45.76863, 8.01419],
  "Rasun-Anterselva": [46.78077, 12.04933],
  "Rasura": [46.10074, 9.55292],
  "Ravanusa": [37.26824, 13.97248],
  "Ravarino": [44.72447, 11.1],
  "Ravascletto": [46.52562, 12.92223],
  "Ravello": [40.65284, 14.61365],
  "Ravenna": [44.41722, 12.19914],
  "Raveo": [46.43469, 12.87001],
  "Raviscanina": [41.37052, 14.24282],
  "Re": [46.13056, 8.54437],
  "Rea": [45.11387, 9.15434],
  "Realmonte": [37.30681, 13.46279],
  "Reana del Rojale": [46.14936, 13.24368],
  "Reano": [45.05171, 7.42955],
  "Recale": [41.05639, 14.30302],
  "Recanati": [43.40383, 13.54884],
  "Recco": [44.36219, 9.14355],
  "Recetto": [45.46081, 8.43609],
  "Recoaro Terme": [45.70512, 11.22603],
  "Redavalle": [45.03773, 9.20402],
  "Redondesco": [45.16667, 10.51285],
  "Refrancore": [44.93758, 8.34271],
  "Refrontolo": [45.92514, 12.20793],
  "Regalbuto": [37.65263, 14.6408],
  "Reggello": [43.68255, 11.53638],
  "Reggio di Calabria": [38.10923, 15.64345],
  "Reggio nell'Emilia": [44.69735, 10.63008],
  "Reggiolo": [44.91859, 10.80428],
  "Reino": [41.29228, 14.82258],
  "Reitano": [37.97308, 14.34445],
  "Remanzacco": [46.08524, 13.32479],
  "Remedello": [45.2789, 10.37196],
  "Renate": [45.72266, 9.28467],
  "Rende": [39.33154, 16.18041],
  "Renon": [46.53671, 11.46302],
  "Resana": [45.63432, 11.95553],
  "Rescaldina": [45.61655, 8.94755],
  "Resia": [46.37347, 13.30575],
  "Resiutta": [46.39323, 13.2201],
  "Resuttano": [37.68013, 14.03105],
  "Retorbido": [44.94923, 9.03635],
  "Revello": [44.65466, 7.38901],
  "Revigliasco d'Asti": [44.85873, 8.15836],
  "Revine Lago": [45.99209, 12.23175],
  "Rezzago": [45.86673, 9.2486],
  "Rezzato": [45.51341, 10.31849],
  "Rezzo": [44.02031, 7.87216],
  "Rezzoaglio": [44.52571, 9.38666],
  "Rho": [45.52891, 9.04022],
  "Rhêmes-Notre-Dame": [45.56971, 7.11853],
  "Rhêmes-Saint-Georges": [45.65526, 7.15525],
  "Riace": [38.41806, 16.48085],
  "Rialto": [44.21961, 8.27472],
  "Riano": [42.09139, 12.52273],
  "Riardo": [41.26399, 14.14904],
  "Ribera": [37.50382, 13.26866],
  "Ribordone": [45.43161, 7.50242],
  "Ricadi": [38.62421, 15.86639],
  "Ricaldone": [44.73209, 8.46963],
  "Riccia": [41.48655, 14.83638],
  "Riccione": [44.00003, 12.65506],
  "Riccò del Golfo di Spezia": [44.15556, 9.76342],
  "Ricengo": [45.40555, 9.72366],
  "Ricigliano": [40.66809, 15.48361],
  "Riese Pio X": [45.72967, 11.91677],
  "Riesi": [37.28338, 14.08221],
  "Rieti": [42.40488, 12.86206],
  "Rifiano": [46.70159, 11.18034],
  "Rifreddo": [44.6505, 7.3491],
  "Rignano Flaminio": [42.20974, 12.48071],
  "Rignano Garganico": [41.67717, 15.58785],
  "Rignano sull'Arno": [43.72206, 11.45352],
  "Rigolato": [46.5496, 12.85407],
  "Rimella": [45.90794, 8.18259],
  "Rimini": [44.0609, 12.56563],
  "Rio di Pusteria": [46.79703, 11.6678],
  "Rio Saliceto": [44.80932, 10.8029],
  "Riofreddo": [42.06137, 12.99949],
  "Riola Sardo": [39.99655, 8.53847],
  "Riolo Terme": [44.27616, 11.72455],
  "Riolunato": [44.23049, 10.65303],
  "Riomaggiore": [44.09973, 9.73815],
  "Rionero in Vulture": [40.927, 15.6738],
  "Rionero Sannitico": [41.71225, 14.13994],
  "Ripa Teatina": [42.35748, 14.23365],
  "Ripabottoni": [41.68855, 14.80653],
  "Ripacandida": [40.91285, 15.72739],
  "Ripalimosani": [41.61126, 14.6628],
  "Ripalta Arpina": [45.30163, 9.7273],
  "Ripalta Cremasca": [45.33549, 9.69086],
  "Ripalta Guerina": [45.30599, 9.70454],
  "Riparbella": [43.36468, 10.5997],
  "Ripatransone": [43.00017, 13.76265],
  "Ripe San Ginesio": [43.14305, 13.3675],
  "Ripi": [41.61272, 13.42649],
  "Riposto": [37.73182, 15.20384],
  "Rittana": [44.35057, 7.40064],
  "Riva del Garda": [45.88504, 10.83889],
  "Riva di Solto": [45.77417, 10.03938],
  "Riva Ligure": [43.83752, 7.88171],
  "Riva presso Chieri": [44.98628, 7.8692],
  "Rivalba": [45.11881, 7.88704],
  "Rivalta Bormida": [44.71138, 8.55026],
  "Rivalta di Torino": [45.03455, 7.52329],
  "Rivamonte Agordino": [46.25344, 12.02448],
  "Rivanazzano Terme": [44.93053, 9.01645],
  "Rivara": [45.33232, 7.62506],
  "Rivarolo Canavese": [45.33279, 7.72522],
  "Rivarolo del Re ed Uniti": [45.02786, 10.46879],
  "Rivarolo Mantovano": [45.07056, 10.43101],
  "Rivarone": [44.97766, 8.71569],
  "Rivarossa": [45.25128, 7.7172],
  "Rive": [45.21257, 8.41832],
  "Rive d'Arcano": [46.12595, 13.03098],
  "Rivello": [40.07722, 15.75776],
  "Rivergaro": [44.91071, 9.59756],
  "Rivignano Teor": [45.8676, 13.0526],
  "Rivisondoli": [41.8704, 14.06636],
  "Rivodutri": [42.51604, 12.85515],
  "Rivoli": [45.07063, 7.53394],
  "Rivoli Veronese": [45.57115, 10.81251],
  "Rivolta d'Adda": [45.46964, 9.51357],
  "Rizziconi": [38.41185, 15.95876],
  "Roana": [45.86856, 11.4783],
  "Roaschia": [44.27013, 7.45614],
  "Roascio": [44.41716, 8.02255],
  "Roasio": [45.60862, 8.28893],
  "Roatto": [44.9515, 8.02661],
  "Robassomero": [45.20008, 7.57016],
  "Robbiate": [45.68882, 9.43981],
  "Robbio": [45.28912, 8.59396],
  "Robecchetto con Induno": [45.53494, 8.76292],
  "Robecco d'Oglio": [45.26007, 10.0786],
  "Robecco Pavese": [45.04842, 9.14865],
  "Robecco sul Naviglio": [45.43757, 8.89041],
  "Robella": [45.10233, 8.10006],
  "Robilante": [44.29423, 7.51116],
  "Roburent": [44.305, 7.89021],
  "Rocca Canavese": [45.30941, 7.57854],
  "Rocca Canterano": [41.95497, 13.02387],
  "Rocca Cigliè": [44.44409, 7.95115],
  "Rocca d'Arazzo": [44.87388, 8.28582],
  "Rocca d'Arce": [41.58753, 13.58374],
  "Rocca d'Evandro": [41.3947, 13.89662],
  "Rocca de' Baldi": [44.43018, 7.7457],
  "Rocca de' Giorgi": [44.97158, 9.25217],
  "Rocca di Botte": [42.02627, 13.06822],
  "Rocca di Cambio": [42.23678, 13.4894],
  "Rocca di Cave": [41.84634, 12.94559],
  "Rocca di Mezzo": [42.20779, 13.51866],
  "Rocca di Neto": [39.19171, 17.00234],
  "Rocca di Papa": [41.762, 12.70842],
  "Rocca Grimalda": [44.6711, 8.64729],
  "Rocca Imperiale": [40.11057, 16.57535],
  "Rocca Massima": [41.67837, 12.91986],
  "Rocca Pia": [41.93479, 13.97694],
  "Rocca Pietore": [46.43471, 11.97754],
  "Rocca Priora": [41.79422, 12.76325],
  "Rocca San Casciano": [44.06145, 11.84223],
  "Rocca San Felice": [40.95101, 15.16512],
  "Rocca San Giovanni": [42.2511, 14.46495],
  "Rocca Santa Maria": [42.68584, 13.52689],
  "Rocca Santo Stefano": [41.91052, 13.02447],
  "Rocca Sinibalda": [42.27422, 12.92576],
  "Rocca Susella": [44.91276, 9.09597],
  "Roccabascerana": [41.0181, 14.71646],
  "Roccabernarda": [39.13395, 16.87173],
  "Roccabianca": [45.00812, 10.21812],
  "Roccabruna": [44.4763, 7.34075],
  "Roccacasale": [42.12231, 13.88998],
  "Roccadaspide": [40.42605, 15.19428],
  "Roccafiorita": [37.92988, 15.26847],
  "Roccafluvione": [42.86127, 13.47522],
  "Roccaforte del Greco": [38.04591, 15.8996],
  "Roccaforte Ligure": [44.67771, 9.02777],
  "Roccaforte Mondovì": [44.31843, 7.74588],
  "Roccaforzata": [40.43769, 17.38887],
  "Roccafranca": [45.46414, 9.91198],
  "Roccagiovine": [42.05023, 12.8986],
  "Roccagloriosa": [40.10605, 15.43758],
  "Roccagorga": [41.52611, 13.15534],
  "Roccalbegna": [42.78414, 11.50925],
  "Roccalumera": [37.97509, 15.39453],
  "Roccamandolfi": [41.49291, 14.3495],
  "Roccamena": [37.83859, 13.1553],
  "Roccamonfina": [41.28683, 13.97905],
  "Roccamontepiano": [42.24764, 14.12187],
  "Roccamorice": [42.21377, 14.02388],
  "Roccanova": [40.21423, 16.2051],
  "Roccantica": [42.3208, 12.69233],
  "Roccapalumba": [37.80607, 13.63945],
  "Roccapiemonte": [40.76237, 14.69268],
  "Roccarainola": [40.97242, 14.56206],
  "Roccaraso": [41.84627, 14.07856],
  "Roccaromana": [41.274, 14.2232],
  "Roccascalegna": [42.06215, 14.3067],
  "Roccasecca": [41.55184, 13.66862],
  "Roccasecca dei Volsci": [41.47983, 13.21249],
  "Roccasicura": [41.6982, 14.23175],
  "Roccasparvera": [44.34166, 7.44134],
  "Roccaspinalveti": [41.93808, 14.47121],
  "Roccastrada": [43.01121, 11.16743],
  "Roccavaldina": [38.1823, 15.37498],
  "Roccaverano": [44.59299, 8.27193],
  "Roccavignale": [44.36189, 8.19201],
  "Roccavione": [44.31441, 7.48126],
  "Roccavivara": [41.83483, 14.59927],
  "Roccella Ionica": [38.32525, 16.40347],
  "Roccella Valdemone": [37.93275, 15.00952],
  "Rocchetta a Volturno": [41.6243, 14.08589],
  "Rocchetta Belbo": [44.63713, 8.17527],
  "Rocchetta di Vara": [44.25119, 9.75689],
  "Rocchetta e Croce": [41.23716, 14.15765],
  "Rocchetta Ligure": [44.70655, 9.05003],
  "Rocchetta Nervina": [43.89018, 7.60029],
  "Rocchetta Palafea": [44.70695, 8.34572],
  "Rocchetta Sant'Antonio": [41.10279, 15.45988],
  "Rocchetta Tanaro": [44.85887, 8.34433],
  "Rodano": [45.47318, 9.35708],
  "Roddi": [44.67845, 7.97611],
  "Roddino": [44.57411, 8.01874],
  "Rodello": [44.63061, 8.05932],
  "Rodengo": [46.77932, 11.69496],
  "Rodengo Saiano": [45.60059, 10.1093],
  "Rodero": [45.82263, 8.91339],
  "Rodi Garganico": [41.92814, 15.88123],
  "Rodigo": [45.19936, 10.6243],
  "Rodì Milici": [38.11046, 15.16957],
  "Rofrano": [40.21047, 15.42723],
  "Rogeno": [45.78332, 9.26696],
  "Roggiano Gravina": [39.61648, 16.15813],
  "Roghudi": [37.92499, 15.76537],
  "Rogliano": [39.18006, 16.32532],
  "Rognano": [45.28882, 9.08992],
  "Rogno": [45.85782, 10.13344],
  "Rogolo": [46.1363, 9.48793],
  "Roiate": [41.87412, 13.06445],
  "Roio del Sangro": [41.91164, 14.37281],
  "Roisan": [45.78442, 7.31058],
  "Roletto": [44.92525, 7.33067],
  "Rolo": [44.8872, 10.85635],
  "Roma": [41.89277, 12.48367],
  "Romagnano al Monte": [40.62795, 15.43453],
  "Romagnano Sesia": [45.63335, 8.38288],
  "Romagnese": [44.83723, 9.32948],
  "Romana": [40.48435, 8.58656],
  "Romanengo": [45.37735, 9.78546],
  "Romano Canavese": [45.39134, 7.8679],
  "Romano d'Ezzelino": [45.77455, 11.7707],
  "Romano di Lombardia": [45.51945, 9.75317],
  "Romans d'Isonzo": [45.89049, 13.43904],
  "Rombiolo": [38.59762, 16.00158],
  "Romeno": [46.3944, 11.12019],
  "Romentino": [45.4626, 8.72085],
  "Rometta": [38.17266, 15.41549],
  "Ronago": [45.82977, 8.9825],
  "Roncade": [45.63038, 12.37395],
  "Roncadelle": [45.52806, 10.15131],
  "Roncaro": [45.22573, 9.27692],
  "Roncegno Terme": [46.05099, 11.40969],
  "Roncello": [45.60488, 9.45696],
  "Ronchi dei Legionari": [45.826, 13.50071],
  "Ronchi Valsugana": [46.06714, 11.4343],
  "Ronchis": [45.80581, 12.99607],
  "Ronciglione": [42.29172, 12.21573],
  "Ronco all'Adige": [45.3357, 11.24641],
  "Ronco Biellese": [45.58161, 8.09888],
  "Ronco Briantino": [45.66778, 9.40072],
  "Ronco Canavese": [45.49943, 7.54567],
  "Ronco Scrivia": [44.6082, 8.95499],
  "Roncobello": [45.95644, 9.74782],
  "Roncoferraro": [45.13324, 10.95101],
  "Roncofreddo": [44.04188, 12.31809],
  "Roncola": [45.76925, 9.56103],
  "Roncà": [45.47945, 11.29014],
  "Rondanina": [44.56236, 9.21761],
  "Rondissone": [45.24679, 7.96582],
  "Ronsecco": [45.2535, 8.27777],
  "Ronzo-Chienis": [45.8908, 10.94991],
  "Ronzone": [46.42334, 11.15],
  "Roppolo": [45.42041, 8.06865],
  "Rorà": [44.7923, 7.19849],
  "Rosarno": [38.48761, 15.98283],
  "Rosasco": [45.2503, 8.57927],
  "Rosate": [45.34835, 9.01681],
  "Rosazza": [45.67613, 7.97753],
  "Rosciano": [42.32248, 14.0472],
  "Roscigno": [40.40037, 15.34454],
  "Rose": [39.39925, 16.29788],
  "Rosello": [41.90157, 14.349],
  "Roseto Capo Spulico": [39.98665, 16.60127],
  "Roseto degli Abruzzi": [42.68017, 14.01156],
  "Roseto Valfortore": [41.37073, 15.09485],
  "Rosignano Marittimo": [43.40533, 10.47269],
  "Rosignano Monferrato": [45.07985, 8.39906],
  "Rosolina": [45.07589, 12.24613],
  "Rosolini": [36.82035, 14.95353],
  "Rosora": [43.48276, 13.06919],
  "Rossa": [45.83355, 8.12565],
  "Rossana": [44.5425, 7.43261],
  "Rossano Veneto": [45.70507, 11.7999],
  "Rossiglione": [44.56211, 8.67054],
  "Rosta": [45.07142, 7.46397],
  "Rosà": [45.72476, 11.76155],
  "Rota d'Imagna": [45.83415, 9.51153],
  "Rota Greca": [39.46701, 16.11351],
  "Rotella": [42.95453, 13.56093],
  "Rotello": [41.74891, 15.00524],
  "Rotonda": [39.95197, 16.03619],
  "Rotondella": [40.17256, 16.52562],
  "Rotondi": [41.03403, 14.5964],
  "Rottofreno": [45.05705, 9.55041],
  "Rotzo": [45.8639, 11.40042],
  "Roure": [45.00108, 7.12909],
  "Rovasenda": [45.53679, 8.31362],
  "Rovato": [45.56809, 9.99764],
  "Rovegno": [44.57711, 9.27867],
  "Rovellasca": [45.66794, 9.0523],
  "Rovello Porro": [45.6544, 9.03982],
  "Roverbella": [45.26504, 10.76451],
  "Roverchiara": [45.27242, 11.24789],
  "Roveredo di Guà": [45.27273, 11.44268],
  "Roveredo in Piano": [46.00954, 12.61755],
  "Rovereto": [45.88648, 11.04518],
  "Roverè della Luna": [46.24999, 11.16961],
  "Roverè Veronese": [45.59334, 11.06566],
  "Rovescala": [45.01375, 9.35013],
  "Rovetta": [45.89111, 9.9849],
  "Roviano": [42.02614, 12.99453],
  "Rovigo": [45.07107, 11.79007],
  "Rovito": [39.3099, 16.32272],
  "Rovolon": [45.38575, 11.65217],
  "Rozzano": [45.38102, 9.15293],
  "Roè Volciano": [45.62401, 10.49404],
  "Rubano": [45.42671, 11.7866],
  "Rubiana": [45.1392, 7.3824],
  "Rubiera": [44.6533, 10.78326],
  "Ruda": [45.83698, 13.39969],
  "Rudiano": [45.48852, 9.88423],
  "Rueglio": [45.46785, 7.75582],
  "Ruffano": [39.98357, 18.2468],
  "Ruffia": [44.70725, 7.60244],
  "Ruffrè-Mendola": [46.41451, 11.17747],
  "Rufina": [43.82664, 11.48792],
  "Ruinas": [39.90577, 8.89642],
  "Rumo": [46.44107, 11.01733],
  "Ruoti": [40.71745, 15.67622],
  "Russi": [44.37242, 12.03289],
  "Rutigliano": [41.01072, 17.00799],
  "Rutino": [40.29988, 15.07009],
  "Ruviano": [41.21063, 14.40983],
  "Ruvo del Monte": [40.84734, 15.5413],
  "Ruvo di Puglia": [41.117, 16.48485],
  "Sabaudia": [41.30012, 13.02491],
  "Sabbio Chiese": [45.65676, 10.41553],
  "Sabbioneta": [44.99976, 10.48991],
  "Sacco": [40.38178, 15.37291],
  "Saccolongo": [45.40568, 11.74356],
  "Sacile": [45.95428, 12.50304],
  "Sacrofano": [42.10575, 12.44782],
  "Sadali": [39.81435, 9.2726],
  "Sagama": [40.26099, 8.57809],
  "Sagliano Micca": [45.62281, 8.04528],
  "Sagrado": [45.87646, 13.48521],
  "Sagron Mis": [46.19493, 11.94328],
  "Saint-Christophe": [45.74833, 7.35781],
  "Saint-Denis": [45.75218, 7.55719],
  "Saint-Marcel": [45.73242, 7.44829],
  "Saint-Nicolas": [45.71662, 7.16789],
  "Saint-Oyen": [45.82462, 7.21241],
  "Saint-Pierre": [45.71043, 7.22629],
  "Saint-Rhémy-en-Bosses": [45.82306, 7.18206],
  "Saint-Vincent": [45.75022, 7.6475],
  "Sala Baganza": [44.71553, 10.22824],
  "Sala Biellese": [45.50832, 7.95549],
  "Sala Bolognese": [44.6298, 11.27687],
  "Sala Comacina": [45.96426, 9.166],
  "Sala Consilina": [40.40266, 15.59084],
  "Sala Monferrato": [45.0754, 8.35818],
  "Salandra": [40.52555, 16.31965],
  "Salaparuta": [37.75698, 13.00627],
  "Salara": [44.98422, 11.42607],
  "Salasco": [45.32529, 8.26378],
  "Salassa": [45.35956, 7.68939],
  "Salbertrand": [45.07237, 6.88369],
  "Salcedo": [45.75846, 11.56576],
  "Salcito": [41.74736, 14.51082],
  "Sale": [44.98475, 8.80897],
  "Sale delle Langhe": [44.39706, 8.08346],
  "Sale Marasino": [45.71409, 10.11289],
  "Sale San Giovanni": [44.39938, 8.07861],
  "Salemi": [37.816, 12.80151],
  "Salento": [40.24899, 15.18842],
  "Salerano Canavese": [45.45644, 7.8499],
  "Salerano sul Lambro": [45.29457, 9.38568],
  "Salerno": [40.67822, 14.7594],
  "Salgareda": [45.70343, 12.49468],
  "Sali Vercellese": [45.30933, 8.32968],
  "Salice Salentino": [40.38483, 17.96517],
  "Saliceto": [44.41328, 8.16679],
  "Salisano": [42.25748, 12.74562],
  "Salizzole": [45.24277, 11.08381],
  "Salle": [42.17704, 13.95924],
  "Salmour": [44.57815, 7.79212],
  "Salorno": [46.23911, 11.21297],
  "Salsomaggiore Terme": [44.81568, 9.97809],
  "Saltrio": [45.87356, 8.92438],
  "Saludecio": [43.87267, 12.66881],
  "Saluggia": [45.23583, 8.01114],
  "Salussola": [45.44931, 8.10889],
  "Saluzzo": [44.64702, 7.49085],
  "Salve": [39.86183, 18.29408],
  "Salvirola": [45.35458, 9.78036],
  "Salvitelle": [40.59106, 15.45931],
  "Salza di Pinerolo": [44.94054, 7.05324],
  "Salza Irpina": [40.91803, 14.8911],
  "Salzano": [45.52127, 12.09771],
  "Salò": [45.60714, 10.53231],
  "Samarate": [45.63093, 8.7826],
  "Samassi": [39.482, 8.90736],
  "Samatzai": [39.47981, 9.03366],
  "Sambuca di Sicilia": [37.64742, 13.11073],
  "Sambuca Pistoiese": [44.10405, 10.999],
  "Sambuci": [41.98627, 12.9374],
  "Sambuco": [44.33734, 7.07781],
  "Sammichele di Bari": [40.8879, 16.95448],
  "Samo": [38.07413, 16.0563],
  "Samolaco": [46.24422, 9.39512],
  "Samone (TN)": [46.08187, 11.52038],
  "Samone (TO)": [45.44929, 7.84564],
  "Sampeyre": [44.57938, 7.18887],
  "Samugheo": [39.94719, 8.93961],
  "San Bartolomeo al Mare": [43.92851, 8.10217],
  "San Bartolomeo in Galdo": [41.40978, 15.01508],
  "San Bartolomeo Val Cavargna": [46.0825, 9.14622],
  "San Basile": [39.81097, 16.16361],
  "San Basilio": [39.53738, 9.19837],
  "San Bassano": [45.24651, 9.81349],
  "San Bellino": [45.02849, 11.58904],
  "San Benedetto Belbo": [44.48989, 8.05785],
  "San Benedetto dei Marsi": [42.00645, 13.62331],
  "San Benedetto del Tronto": [42.94363, 13.88291],
  "San Benedetto in Perillis": [42.18278, 13.76976],
  "San Benedetto Po": [45.04107, 10.92849],
  "San Benedetto Ullano": [39.42629, 16.12333],
  "San Benedetto Val di Sambro": [44.21557, 11.23307],
  "San Benigno Canavese": [45.22396, 7.78266],
  "San Bernardino Verbano": [45.95679, 8.52018],
  "San Biagio della Cima": [43.81879, 7.64985],
  "San Biagio di Callalta": [45.68476, 12.37749],
  "San Biagio Platani": [37.50899, 13.52423],
  "San Biagio Saracinisco": [41.6135, 13.92767],
  "San Biase": [41.71493, 14.58944],
  "San Bonifacio": [45.39592, 11.26992],
  "San Buono": [41.98062, 14.56935],
  "San Calogero": [38.57066, 16.01328],
  "San Candido": [46.73242, 12.28204],
  "San Canzian d'Isonzo": [45.80955, 13.4434],
  "San Carlo Canavese": [45.24815, 7.61016],
  "San Casciano dei Bagni": [42.87132, 11.87536],
  "San Casciano in Val di Pesa": [43.65656, 11.18439],
  "San Cassiano": [40.05392, 18.32998],
  "San Cataldo": [37.48716, 13.99048],
  "San Cesareo": [41.82147, 12.80071],
  "San Cesario di Lecce": [40.30187, 18.16031],
  "San Cesario sul Panaro": [44.56157, 11.03417],
  "San Chirico Nuovo": [40.67692, 16.07946],
  "San Chirico Raparo": [40.19058, 16.07642],
  "San Cipirello": [37.96023, 13.1817],
  "San Cipriano d'Aversa": [40.99969, 14.13457],
  "San Cipriano Picentino": [40.7204, 14.87236],
  "San Cipriano Po": [45.10909, 9.28086],
  "San Clemente": [43.93225, 12.62561],
  "San Colombano al Lambro": [45.18133, 9.48925],
  "San Colombano Belmonte": [45.38144, 7.61845],
  "San Colombano Certenoli": [44.37173, 9.31312],
  "San Cono": [37.28994, 14.366],
  "San Cosmo Albanese": [39.58234, 16.42057],
  "San Costantino Albanese": [40.0353, 16.30451],
  "San Costantino Calabro": [38.63339, 16.07082],
  "San Costanzo": [43.76312, 13.06951],
  "San Cristoforo": [44.69241, 8.75],
  "San Damiano al Colle": [45.02712, 9.34857],
  "San Damiano d'Asti": [44.83464, 8.06523],
  "San Damiano Macra": [44.48841, 7.25631],
  "San Daniele del Friuli": [46.16097, 13.01133],
  "San Daniele Po": [45.06727, 10.17634],
  "San Demetrio Corone": [39.56767, 16.36319],
  "San Demetrio ne' Vestini": [42.28805, 13.55877],
  "San Didero": [45.13516, 7.21516],
  "San Donaci": [40.44678, 17.92215],
  "San Donato di Lecce": [40.26813, 18.18352],
  "San Donato di Ninea": [39.71189, 16.0482],
  "San Donato Milanese": [45.41696, 9.26615],
  "San Donato Val di Comino": [41.70815, 13.81378],
  "San Donà di Piave": [45.62946, 12.56428],
  "San Dorligo della Valle": [45.60794, 13.85675],
  "San Fele": [40.81921, 15.53923],
  "San Felice a Cancello": [41.01179, 14.48097],
  "San Felice Circeo": [41.23348, 13.0887],
  "San Felice del Benaco": [45.58275, 10.55377],
  "San Felice del Molise": [41.8908, 14.70066],
  "San Felice sul Panaro": [44.83932, 11.1414],
  "San Ferdinando": [38.48384, 15.91566],
  "San Ferdinando di Puglia": [41.30079, 16.06884],
  "San Fermo della Battaglia": [45.8096, 9.0485],
  "San Fili": [39.33763, 16.14233],
  "San Filippo del Mela": [38.16929, 15.27181],
  "San Fior": [45.92084, 12.35841],
  "San Fiorano": [45.13594, 9.72192],
  "San Floriano del Collio": [45.9822, 13.58533],
  "San Floro": [38.8377, 16.5186],
  "San Francesco al Campo": [45.22554, 7.65566],
  "San Fratello": [38.01289, 14.59623],
  "San Gavino Monreale": [39.54873, 8.79228],
  "San Gemini": [42.61338, 12.54625],
  "San Genesio Atesino": [46.53565, 11.33158],
  "San Genesio ed Uniti": [45.23285, 9.17987],
  "San Gennaro Vesuviano": [40.86119, 14.52929],
  "San Germano Chisone": [44.89872, 7.24086],
  "San Germano Vercellese": [45.35018, 8.25095],
  "San Gervasio Bresciano": [45.30602, 10.14967],
  "San Giacomo degli Schiavoni": [41.96493, 14.94762],
  "San Giacomo delle Segnate": [44.97181, 11.03316],
  "San Giacomo Filippo": [46.33714, 9.37043],
  "San Giacomo Vercellese": [45.49741, 8.32535],
  "San Gillio": [45.14206, 7.53383],
  "San Gimignano": [43.46777, 11.04318],
  "San Ginesio": [43.10801, 13.31673],
  "San Giorgio a Cremano": [40.82921, 14.33393],
  "San Giorgio a Liri": [41.40687, 13.76662],
  "San Giorgio Albanese": [39.58075, 16.45453],
  "San Giorgio Bigarello": [45.16527, 10.8459],
  "San Giorgio Canavese": [45.33544, 7.79426],
  "San Giorgio del Sannio": [41.06241, 14.85356],
  "San Giorgio della Richinvelda": [46.04541, 12.86774],
  "San Giorgio delle Pertiche": [45.542, 11.90993],
  "San Giorgio di Lomellina": [45.17381, 8.79112],
  "San Giorgio di Nogaro": [45.83302, 13.20699],
  "San Giorgio di Piano": [44.64698, 11.37514],
  "San Giorgio in Bosco": [45.59317, 11.80655],
  "San Giorgio Ionico": [40.45939, 17.38354],
  "San Giorgio La Molara": [41.27117, 14.91764],
  "San Giorgio Lucano": [40.11417, 16.38952],
  "San Giorgio Monferrato": [45.10779, 8.41486],
  "San Giorgio Morgeto": [38.38702, 16.10355],
  "San Giorgio Piacentino": [44.95411, 9.73755],
  "San Giorgio Scarampi": [44.61132, 8.24202],
  "San Giorgio su Legnano": [45.57653, 8.91648],
  "San Giorio di Susa": [45.12842, 7.17753],
  "San Giovanni a Piro": [40.05044, 15.44984],
  "San Giovanni al Natisone": [45.98092, 13.40396],
  "San Giovanni Bianco": [45.87456, 9.65182],
  "San Giovanni del Dosso": [44.96609, 11.08112],
  "San Giovanni di Gerace": [38.36577, 16.2779],
  "San Giovanni Gemini": [37.62994, 13.6412],
  "San Giovanni Ilarione": [45.52093, 11.23578],
  "San Giovanni in Croce": [45.07745, 10.37841],
  "San Giovanni in Fiore": [39.25365, 16.69732],
  "San Giovanni in Galdo": [41.5884, 14.74754],
  "San Giovanni in Marignano": [43.93899, 12.71246],
  "San Giovanni in Persiceto": [44.63877, 11.1878],
  "San Giovanni Incarico": [41.50302, 13.55719],
  "San Giovanni la Punta": [37.57707, 15.0943],
  "San Giovanni Lipioni": [41.84279, 14.56198],
  "San Giovanni Lupatoto": [45.38009, 11.05019],
  "San Giovanni Rotondo": [41.70781, 15.72664],
  "San Giovanni Suergiu": [39.11025, 8.5221],
  "San Giovanni Teatino": [42.42198, 14.18675],
  "San Giovanni Valdarno": [43.56674, 11.52963],
  "San Giuliano del Sannio": [41.45613, 14.63964],
  "San Giuliano di Puglia": [41.68526, 14.96369],
  "San Giuliano Milanese": [45.40023, 9.28492],
  "San Giuliano Terme": [43.76334, 10.44249],
  "San Giuseppe Jato": [37.96819, 13.18116],
  "San Giuseppe Vesuviano": [40.83426, 14.50618],
  "San Giustino": [43.54865, 12.17675],
  "San Giusto Canavese": [45.31221, 7.80833],
  "San Godenzo": [43.92628, 11.61962],
  "San Gregorio d'Ippona": [38.6433, 16.10174],
  "San Gregorio da Sassola": [41.91816, 12.87253],
  "San Gregorio di Catania": [37.56488, 15.10846],
  "San Gregorio Magno": [40.65616, 15.39941],
  "San Gregorio Matese": [41.38556, 14.37217],
  "San Gregorio nelle Alpi": [46.10324, 12.02628],
  "San Lazzaro di Savena": [44.47048, 11.40806],
  "San Leo": [43.89618, 12.34328],
  "San Leonardo": [46.12167, 13.52452],
  "San Leonardo in Passiria": [46.81168, 11.24329],
  "San Leucio del Sannio": [41.07269, 14.75768],
  "San Lorenzello": [41.27603, 14.54117],
  "San Lorenzo": [38.01064, 15.83384],
  "San Lorenzo al Mare": [43.85361, 7.96388],
  "San Lorenzo Bellizzi": [39.88923, 16.32823],
  "San Lorenzo del Vallo": [39.66686, 16.29473],
  "San Lorenzo di Sebato": [46.78353, 11.90177],
  "San Lorenzo Dorsino": [46.0775, 10.9095],
  "San Lorenzo in Campo": [43.60342, 12.94543],
  "San Lorenzo Isontino": [45.93269, 13.52672],
  "San Lorenzo Maggiore": [41.2503, 14.62567],
  "San Lorenzo Nuovo": [42.68559, 11.9061],
  "San Luca": [38.14513, 16.06726],
  "San Lucido": [39.3082, 16.05094],
  "San Lupo": [41.26045, 14.63511],
  "San Mango d'Aquino": [39.06008, 16.18971],
  "San Mango Piemonte": [40.70024, 14.83919],
  "San Mango sul Calore": [40.9589, 14.97251],
  "San Marcellino": [40.98671, 14.17391],
  "San Marcello": [43.57674, 13.20621],
  "San Marcello Piteglio": [44.0574, 10.7929],
  "San Marco Argentano": [39.55682, 16.11787],
  "San Marco d'Alunzio": [38.07305, 14.69884],
  "San Marco dei Cavoti": [41.30601, 14.88068],
  "San Marco Evangelista": [41.03761, 14.34321],
  "San Marco in Lamis": [41.71296, 15.63843],
  "San Marco la Catola": [41.5257, 15.00632],
  "San Martino al Tagliamento": [46.02082, 12.86385],
  "San Martino Alfieri": [44.81852, 8.10937],
  "San Martino Buon Albergo": [45.42215, 11.09313],
  "San Martino Canavese": [45.39459, 7.81836],
  "San Martino d'Agri": [40.23695, 16.05066],
  "San Martino dall'Argine": [45.1007, 10.52015],
  "San Martino del Lago": [45.07243, 10.31566],
  "San Martino di Finita": [39.49069, 16.10712],
  "San Martino di Lupari": [45.65068, 11.85327],
  "San Martino di Venezze": [45.13131, 11.86853],
  "San Martino in Badia": [46.68189, 11.89802],
  "San Martino in Passiria": [46.78261, 11.22696],
  "San Martino in Pensilis": [41.87003, 15.01058],
  "San Martino in Rio": [44.7327, 10.78466],
  "San Martino in Strada": [45.27079, 9.53053],
  "San Martino Sannita": [41.06546, 14.83492],
  "San Martino Siccomario": [45.15716, 9.13452],
  "San Martino sulla Marrucina": [42.22504, 14.21412],
  "San Martino Valle Caudina": [41.02546, 14.66486],
  "San Marzano di San Giuseppe": [40.45095, 17.50559],
  "San Marzano Oliveto": [44.75322, 8.29616],
  "San Marzano sul Sarno": [40.77461, 14.58798],
  "San Massimo": [41.49267, 14.40981],
  "San Maurizio Canavese": [45.21912, 7.63075],
  "San Maurizio d'Opaglio": [45.77247, 8.39096],
  "San Mauro Castelverde": [37.91446, 14.19009],
  "San Mauro Cilento": [40.22628, 15.04476],
  "San Mauro di Saline": [45.56521, 11.11247],
  "San Mauro Forte": [40.48722, 16.25234],
  "San Mauro la Bruca": [40.12159, 15.286],
  "San Mauro Marchesato": [39.10277, 16.92254],
  "San Mauro Pascoli": [44.10703, 12.41549],
  "San Mauro Torinese": [45.1031, 7.76633],
  "San Michele al Tagliamento": [45.76387, 12.99494],
  "San Michele all'Adige": [46.19266, 11.13405],
  "San Michele di Ganzaria": [37.27947, 14.42612],
  "San Michele di Serino": [40.87717, 14.8555],
  "San Michele Mondovì": [44.37653, 7.90825],
  "San Michele Salentino": [40.62901, 17.63151],
  "San Miniato": [43.67941, 10.85239],
  "San Nazzaro": [41.04971, 14.85679],
  "San Nazzaro Sesia": [45.43813, 8.42357],
  "San Nazzaro Val Cavargna": [46.08923, 9.13065],
  "San Nicandro Garganico": [41.83891, 15.56128],
  "San Nicola Arcella": [39.84579, 15.79365],
  "San Nicola Baronia": [41.05945, 15.19813],
  "San Nicola da Crissa": [38.66438, 16.28625],
  "San Nicola dell'Alto": [39.2882, 16.97576],
  "San Nicola la Strada": [41.05449, 14.33135],
  "San Nicola Manfredi": [41.07247, 14.82443],
  "San Nicolò d'Arcidano": [39.68529, 8.64669],
  "San Nicolò di Comelico": [46.58223, 12.52757],
  "San Nicolò Gerrei": [39.49571, 9.30129],
  "San Pancrazio": [46.5869, 11.08504],
  "San Pancrazio Salentino": [40.41722, 17.83835],
  "San Paolo": [45.3713, 10.02462],
  "San Paolo Albanese": [40.03567, 16.33498],
  "San Paolo Bel Sito": [40.91272, 14.54839],
  "San Paolo d'Argon": [45.68764, 9.80175],
  "San Paolo di Civitate": [41.74075, 15.2589],
  "San Paolo di Jesi": [43.45488, 13.17357],
  "San Paolo Solbrito": [44.95227, 7.97278],
  "San Pellegrino Terme": [45.83833, 9.66331],
  "San Pier d'Isonzo": [45.84595, 13.46066],
  "San Pier Niceto": [38.15873, 15.35152],
  "San Piero Patti": [38.05068, 14.96622],
  "San Pietro a Maida": [38.84636, 16.34771],
  "San Pietro al Natisone": [46.12759, 13.48543],
  "San Pietro al Tanagro": [40.45404, 15.48754],
  "San Pietro Apostolo": [39.00471, 16.469],
  "San Pietro Avellana": [41.78882, 14.18348],
  "San Pietro Clarenza": [37.57233, 15.02419],
  "San Pietro di Cadore": [46.57068, 12.58599],
  "San Pietro di Caridà": [38.52169, 16.13243],
  "San Pietro di Feletto": [45.91304, 12.25163],
  "San Pietro di Morubio": [45.24818, 11.23224],
  "San Pietro in Amantea": [39.13658, 16.11243],
  "San Pietro in Cariano": [45.51731, 10.88646],
  "San Pietro in Casale": [44.70263, 11.40619],
  "San Pietro in Cerro": [45.02133, 9.95138],
  "San Pietro in Gu": [45.61349, 11.66923],
  "San Pietro in Guarano": [39.34474, 16.31211],
  "San Pietro in Lama": [40.30916, 18.13187],
  "San Pietro Infine": [41.44589, 13.95698],
  "San Pietro Mosezzo": [45.45561, 8.54347],
  "San Pietro Mussolino": [45.5873, 11.25814],
  "San Pietro Val Lemina": [44.90733, 7.31356],
  "San Pietro Vernotico": [40.48837, 17.99717],
  "San Pietro Viminario": [45.24502, 11.81834],
  "San Pio delle Camere": [42.28623, 13.65481],
  "San Polo d'Enza": [44.6265, 10.4209],
  "San Polo dei Cavalieri": [42.01231, 12.84005],
  "San Polo di Piave": [45.79119, 12.39415],
  "San Polo Matese": [41.45936, 14.49376],
  "San Ponso": [45.35082, 7.66752],
  "San Possidonio": [44.89099, 10.99679],
  "San Potito Sannitico": [41.33832, 14.39298],
  "San Potito Ultra": [40.92796, 14.87124],
  "San Prisco": [41.0859, 14.2787],
  "San Procopio": [38.28174, 15.88943],
  "San Prospero": [44.7879, 11.02289],
  "San Quirico d'Orcia": [43.06027, 11.60328],
  "San Quirino": [46.03637, 12.68031],
  "San Raffaele Cimena": [45.14722, 7.8487],
  "San Roberto": [38.21145, 15.73556],
  "San Rocco al Porto": [45.08047, 9.69829],
  "San Romano in Garfagnana": [44.16896, 10.34544],
  "San Rufo": [40.43435, 15.46166],
  "San Salvatore di Fitalia": [38.07054, 14.77746],
  "San Salvatore Monferrato": [44.99481, 8.56669],
  "San Salvatore Telesino": [41.2358, 14.49488],
  "San Salvo": [42.04556, 14.73141],
  "San Sebastiano al Vesuvio": [40.84106, 14.37178],
  "San Sebastiano Curone": [44.78561, 9.06524],
  "San Sebastiano da Po": [45.16644, 7.95347],
  "San Secondo di Pinerolo": [44.86657, 7.29865],
  "San Secondo Parmense": [44.91915, 10.22691],
  "San Severino Lucano": [40.01829, 16.1419],
  "San Severino Marche": [43.22886, 13.17711],
  "San Severo": [41.68587, 15.38074],
  "San Siro": [46.05522, 9.25851],
  "San Sossio Baronia": [41.06694, 15.20329],
  "San Sostene": [38.63733, 16.48752],
  "San Sosti": [39.65815, 16.02916],
  "San Sperate": [39.35669, 9.00656],
  "San Stino di Livenza": [45.73054, 12.67956],
  "San Tammaro": [41.07669, 14.23202],
  "San Teodoro (ME)": [37.84781, 14.69937],
  "San Teodoro (SS)": [40.77122, 9.67191],
  "San Tomaso Agordino": [46.3812, 11.97527],
  "San Valentino in Abruzzo Citeriore": [42.2327, 13.98721],
  "San Valentino Torio": [40.79182, 14.60094],
  "San Venanzo": [42.86885, 12.26621],
  "San Vendemiano": [45.89125, 12.33902],
  "San Vero Milis": [40.01279, 8.59915],
  "San Vincenzo": [43.10085, 10.53824],
  "San Vincenzo La Costa": [39.36476, 16.15089],
  "San Vincenzo Valle Roveto": [41.83373, 13.52379],
  "San Vitaliano": [40.92293, 14.48219],
  "San Vito": [39.44159, 9.54163],
  "San Vito al Tagliamento": [45.91497, 12.85474],
  "San Vito al Torre": [45.89571, 13.37021],
  "San Vito Chietino": [42.30261, 14.44572],
  "San Vito dei Normanni": [40.65646, 17.70328],
  "San Vito di Cadore": [46.46015, 12.20479],
  "San Vito di Fagagna": [46.0882, 13.05694],
  "San Vito di Leguzzano": [45.68175, 11.37619],
  "San Vito Lo Capo": [38.1731, 12.73502],
  "San Vito Romano": [41.88277, 12.98334],
  "San Vito sullo Ionio": [38.71061, 16.40712],
  "San Vittore del Lazio": [41.46432, 13.93554],
  "San Vittore Olona": [45.5876, 8.94382],
  "San Zeno di Montagna": [45.63795, 10.73236],
  "San Zeno Naviglio": [45.49134, 10.21455],
  "San Zenone al Lambro": [45.32648, 9.35836],
  "San Zenone al Po": [45.10855, 9.36114],
  "San Zenone degli Ezzelini": [45.77892, 11.84034],
  "Sanarica": [40.08763, 18.34938],
  "Sandigliano": [45.52149, 8.07594],
  "Sandrigo": [45.66132, 11.60278],
  "Sanfront": [44.64584, 7.32025],
  "Sanfrè": [44.75219, 7.80355],
  "Sangano": [45.02624, 7.45054],
  "Sangiano": [45.87629, 8.63179],
  "Sangineto": [39.60367, 15.91251],
  "Sanguinetto": [45.18275, 11.15118],
  "Sanluri": [39.5618, 8.89898],
  "Sannazzaro de' Burgondi": [45.10316, 8.90829],
  "Sannicandro di Bari": [41.00069, 16.79941],
  "Sannicola": [40.09387, 18.06406],
  "Sanremo": [43.821, 7.78463],
  "Sansepolcro": [43.57015, 12.14132],
  "Sant'Agapito": [41.54374, 14.22177],
  "Sant'Agata Bolognese": [44.66454, 11.13381],
  "Sant'Agata de' Goti": [41.0908, 14.50381],
  "Sant'Agata del Bianco": [38.09242, 16.08251],
  "Sant'Agata di Esaro": [39.62091, 15.98238],
  "Sant'Agata di Militello": [38.06952, 14.63368],
  "Sant'Agata di Puglia": [41.15032, 15.37939],
  "Sant'Agata Feltria": [43.86404, 12.20845],
  "Sant'Agata Fossili": [44.78591, 8.91893],
  "Sant'Agata li Battiati": [37.55865, 15.08023],
  "Sant'Agata sul Santerno": [44.44233, 11.86165],
  "Sant'Agnello": [40.63474, 14.39764],
  "Sant'Albano Stura": [44.50993, 7.72105],
  "Sant'Alessio con Vialone": [45.2221, 9.22506],
  "Sant'Alessio in Aspromonte": [38.1722, 15.75731],
  "Sant'Alessio Siculo": [37.91758, 15.34478],
  "Sant'Alfio": [37.74407, 15.14411],
  "Sant'Ambrogio di Torino": [45.09969, 7.35931],
  "Sant'Ambrogio di Valpolicella": [45.52463, 10.83368],
  "Sant'Ambrogio sul Garigliano": [41.39037, 13.86912],
  "Sant'Anastasia": [40.86701, 14.40212],
  "Sant'Anatolia di Narco": [42.73312, 12.83601],
  "Sant'Andrea Apostolo dello Ionio": [38.62326, 16.52858],
  "Sant'Andrea del Garigliano": [41.36585, 13.84191],
  "Sant'Andrea di Conza": [40.84413, 15.37174],
  "Sant'Andrea Frius": [39.47953, 9.17316],
  "Sant'Angelo a Cupolo": [41.06798, 14.80351],
  "Sant'Angelo a Fasanella": [40.45704, 15.34366],
  "Sant'Angelo a Scala": [40.97592, 14.7397],
  "Sant'Angelo all'Esca": [41.00652, 14.99316],
  "Sant'Angelo d'Alife": [41.36264, 14.25966],
  "Sant'Angelo dei Lombardi": [40.92741, 15.1765],
  "Sant'Angelo del Pesco": [41.88316, 14.25579],
  "Sant'Angelo di Brolo": [38.1132, 14.88215],
  "Sant'Angelo di Piove di Sacco": [45.34616, 12.00774],
  "Sant'Angelo in Pontano": [43.09929, 13.39548],
  "Sant'Angelo in Vado": [43.6649, 12.41327],
  "Sant'Angelo Le Fratte": [40.54625, 15.55914],
  "Sant'Angelo Limosano": [41.69279, 14.60374],
  "Sant'Angelo Lodigiano": [45.23812, 9.40958],
  "Sant'Angelo Lomellina": [45.24662, 8.64314],
  "Sant'Angelo Muxaro": [37.47919, 13.54428],
  "Sant'Angelo Romano": [42.03402, 12.71303],
  "Sant'Anna Arresi": [39.00504, 8.64231],
  "Sant'Anna d'Alfaedo": [45.62713, 10.95108],
  "Sant'Antimo": [40.93327, 14.23603],
  "Sant'Antioco": [39.06673, 8.45509],
  "Sant'Antonino di Susa": [45.10708, 7.27351],
  "Sant'Antonio Abate": [40.72247, 14.54695],
  "Sant'Antonio di Gallura": [40.99103, 9.3013],
  "Sant'Apollinare": [41.40195, 13.83064],
  "Sant'Arcangelo": [40.24729, 16.27605],
  "Sant'Arcangelo Trimonte": [41.16901, 14.93883],
  "Sant'Arpino": [40.95788, 14.25232],
  "Sant'Arsenio": [40.4711, 15.48641],
  "Sant'Egidio alla Vibrata": [42.82549, 13.71649],
  "Sant'Egidio del Monte Albino": [40.73592, 14.59895],
  "Sant'Elena": [45.18616, 11.70957],
  "Sant'Elena Sannita": [41.57673, 14.47196],
  "Sant'Elia a Pianisi": [41.6218, 14.87533],
  "Sant'Elia Fiumerapido": [41.53966, 13.86541],
  "Sant'Elpidio a Mare": [43.22917, 13.68653],
  "Sant'Eufemia a Maiella": [42.12539, 14.02771],
  "Sant'Eufemia d'Aspromonte": [38.26208, 15.85473],
  "Sant'Eusanio del Sangro": [42.16822, 14.33198],
  "Sant'Eusanio Forconese": [42.2887, 13.52439],
  "Sant'Ilario d'Enza": [44.7606, 10.45143],
  "Sant'Ilario dello Ionio": [38.22084, 16.19253],
  "Sant'Ippolito": [43.68483, 12.87103],
  "Sant'Olcese": [44.48367, 8.96768],
  "Sant'Omero": [42.78666, 13.8029],
  "Sant'Omobono Terme": [45.8168, 9.5187],
  "Sant'Onofrio": [38.69652, 16.14284],
  "Sant'Oreste": [42.23405, 12.51988],
  "Sant'Orsola Terme": [46.1082, 11.30256],
  "Sant'Urbano": [45.11338, 11.61975],
  "Santa Brigida": [45.98128, 9.62344],
  "Santa Caterina Albanese": [39.58578, 16.07068],
  "Santa Caterina dello Ionio": [38.53498, 16.52101],
  "Santa Caterina Villarmosa": [37.59175, 14.03189],
  "Santa Cesarea Terme": [40.03786, 18.46336],
  "Santa Cristina d'Aspromonte": [38.25427, 15.97004],
  "Santa Cristina e Bissone": [45.15679, 9.40114],
  "Santa Cristina Gela": [37.98509, 13.32752],
  "Santa Cristina Valgardena": [46.55853, 11.72133],
  "Santa Croce Camerina": [36.82854, 14.52544],
  "Santa Croce del Sannio": [41.38793, 14.73229],
  "Santa Croce di Magliano": [41.71252, 14.99113],
  "Santa Croce sull'Arno": [43.71144, 10.77839],
  "Santa Domenica Talao": [39.81957, 15.85543],
  "Santa Domenica Vittoria": [37.91555, 14.96189],
  "Santa Elisabetta": [37.43158, 13.5549],
  "Santa Fiora": [42.83136, 11.58575],
  "Santa Flavia": [38.08217, 13.525],
  "Santa Giuletta": [45.03384, 9.18159],
  "Santa Giusta": [39.87845, 8.60863],
  "Santa Giustina": [46.08338, 12.04245],
  "Santa Giustina in Colle": [45.56364, 11.90618],
  "Santa Luce": [43.4725, 10.56482],
  "Santa Lucia del Mela": [38.13999, 15.28318],
  "Santa Lucia di Piave": [45.84918, 12.28427],
  "Santa Lucia di Serino": [40.87328, 14.87201],
  "Santa Margherita di Belice": [37.69197, 13.02402],
  "Santa Margherita di Staffora": [44.77079, 9.24056],
  "Santa Margherita Ligure": [44.33487, 9.20992],
  "Santa Maria a Monte": [43.69867, 10.69237],
  "Santa Maria a Vico": [41.02724, 14.4635],
  "Santa Maria Capua Vetere": [41.07755, 14.26158],
  "Santa Maria Coghinas": [40.90429, 8.86309],
  "Santa Maria del Cedro": [39.74889, 15.83624],
  "Santa Maria del Molise": [41.5527, 14.37055],
  "Santa Maria della Versa": [44.98469, 9.29994],
  "Santa Maria di Licodia": [37.61618, 14.8874],
  "Santa Maria di Sala": [45.50475, 12.03547],
  "Santa Maria Hoè": [45.74363, 9.3715],
  "Santa Maria Imbaro": [42.21994, 14.44707],
  "Santa Maria la Carità": [40.721, 14.51294],
  "Santa Maria la Fossa": [41.09329, 14.1311],
  "Santa Maria la Longa": [45.93307, 13.28861],
  "Santa Maria Maggiore": [46.13505, 8.46687],
  "Santa Maria Nuova": [43.49594, 13.31053],
  "Santa Marina": [40.1052, 15.54153],
  "Santa Marina Salina": [38.55942, 14.8717],
  "Santa Marinella": [42.03357, 11.85414],
  "Santa Ninfa": [37.77382, 12.88022],
  "Santa Paolina": [41.02202, 14.8463],
  "Santa Severina": [39.14784, 16.91496],
  "Santa Sofia": [43.9469, 11.90796],
  "Santa Sofia d'Epiro": [39.54597, 16.32883],
  "Santa Teresa di Riva": [37.94571, 15.36795],
  "Santa Teresa Gallura": [41.23983, 9.18836],
  "Santa Venerina": [37.68698, 15.13888],
  "Santa Vittoria d'Alba": [44.69653, 7.93316],
  "Santa Vittoria in Matenano": [43.01995, 13.49672],
  "Santadi": [39.09369, 8.71648],
  "Santarcangelo di Romagna": [44.06289, 12.44702],
  "Sante Marie": [42.10286, 13.20298],
  "Santena": [44.94969, 7.77316],
  "Santeramo in Colle": [40.79462, 16.75254],
  "Santhià": [45.36692, 8.17435],
  "Santi Cosma e Damiano": [41.29983, 13.81402],
  "Santo Stefano al Mare": [43.83725, 7.89908],
  "Santo Stefano Belbo": [44.70749, 8.23102],
  "Santo Stefano d'Aveto": [44.54783, 9.45093],
  "Santo Stefano del Sole": [40.89414, 14.86674],
  "Santo Stefano di Cadore": [46.55777, 12.54967],
  "Santo Stefano di Camastra": [38.01635, 14.34833],
  "Santo Stefano di Magra": [44.16241, 9.9151],
  "Santo Stefano di Rogliano": [39.19223, 16.32079],
  "Santo Stefano di Sessanio": [42.34224, 13.64652],
  "Santo Stefano in Aspromonte": [38.16738, 15.78935],
  "Santo Stefano Lodigiano": [45.12207, 9.74305],
  "Santo Stefano Quisquina": [37.6247, 13.49032],
  "Santo Stefano Roero": [44.78882, 7.93991],
  "Santo Stefano Ticino": [45.48778, 8.91935],
  "Santomenna": [40.80708, 15.32026],
  "Santopadre": [41.60307, 13.63484],
  "Santorso": [45.73769, 11.38873],
  "Santu Lussurgiu": [40.13731, 8.65197],
  "Sanza": [40.24464, 15.55331],
  "Sanzeno": [46.37442, 11.06806],
  "Saonara": [45.37199, 11.98492],
  "Saponara": [38.19387, 15.43425],
  "Sapri": [40.07393, 15.63073],
  "Saracena": [39.77527, 16.15619],
  "Saracinesco": [42.00407, 12.9523],
  "Sarcedo": [45.70807, 11.52619],
  "Sarconi": [40.24784, 15.88823],
  "Sardara": [39.61372, 8.82062],
  "Sardigliano": [44.7543, 8.90767],
  "Sarego": [45.40713, 11.40502],
  "Sarentino": [46.6427, 11.35624],
  "Sarezzano": [44.86756, 8.91536],
  "Sarezzo": [45.65378, 10.20298],
  "Sarmato": [45.06042, 9.49149],
  "Sarmede": [45.9785, 12.38636],
  "Sarnano": [43.03548, 13.30107],
  "Sarnico": [45.668, 9.95835],
  "Sarno": [40.81533, 14.6189],
  "Sarnonico": [46.42004, 11.14141],
  "Saronno": [45.62374, 9.0364],
  "Sarre": [45.71794, 7.25765],
  "Sarroch": [39.06354, 9.01116],
  "Sarsina": [43.91858, 12.14086],
  "Sarteano": [42.9896, 11.86917],
  "Sartirana Lomellina": [45.11434, 8.66185],
  "Sarule": [40.22896, 9.166],
  "Sarzana": [44.11293, 9.95968],
  "Sassano": [40.34208, 15.56594],
  "Sassari": [40.72668, 8.55967],
  "Sassello": [44.47904, 8.48995],
  "Sassetta": [43.12836, 10.64399],
  "Sassinoro": [41.37467, 14.66231],
  "Sasso di Castalda": [40.48649, 15.67791],
  "Sasso Marconi": [44.39438, 11.24492],
  "Sassofeltrio": [43.89244, 12.5093],
  "Sassoferrato": [43.436, 12.85865],
  "Sassuolo": [44.54033, 10.7827],
  "Satriano": [38.66778, 16.48291],
  "Satriano di Lucania": [40.54506, 15.63631],
  "Sauris": [46.46664, 12.70813],
  "Sauze d'Oulx": [45.02809, 6.85825],
  "Sauze di Cesana": [44.94045, 6.8605],
  "Sava": [40.40332, 17.55623],
  "Savelli": [39.3123, 16.78082],
  "Saviano": [40.91113, 14.50962],
  "Savigliano": [44.64802, 7.65748],
  "Savignano Irpino": [41.22824, 15.17744],
  "Savignano sul Panaro": [44.47959, 11.03376],
  "Savignano sul Rubicone": [44.0921, 12.39908],
  "Savignone": [44.56374, 8.98796],
  "Saviore dell'Adamello": [46.08049, 10.39821],
  "Savoca": [37.95607, 15.33979],
  "Savogna": [46.15971, 13.5337],
  "Savogna d'Isonzo": [45.90174, 13.57097],
  "Savoia di Lucania": [40.56997, 15.55225],
  "Savona": [44.3075, 8.48111],
  "Scafa": [42.26787, 14.00213],
  "Scafati": [40.74806, 14.52624],
  "Scagnello": [44.33231, 7.98679],
  "Scala": [40.65594, 14.60707],
  "Scala Coeli": [39.44882, 16.88589],
  "Scaldasole": [45.12494, 8.91019],
  "Scalea": [39.80643, 15.79101],
  "Scalenghe": [44.88831, 7.49797],
  "Scaletta Zanclea": [38.04286, 15.45933],
  "Scampitella": [41.09224, 15.29645],
  "Scandale": [39.12314, 16.95853],
  "Scandiano": [44.59939, 10.68822],
  "Scandicci": [43.75823, 11.18133],
  "Scandolara Ravara": [45.05309, 10.30213],
  "Scandolara Ripa d'Oglio": [45.2217, 10.15714],
  "Scandriglia": [42.16506, 12.8421],
  "Scanno": [41.90233, 13.88116],
  "Scano di Montiferro": [40.21682, 8.58352],
  "Scansano": [42.68789, 11.33315],
  "Scanzano Jonico": [40.25032, 16.69091],
  "Scanzorosciate": [45.71187, 9.7368],
  "Scapoli": [41.6153, 14.05881],
  "Scarlino": [42.9073, 10.85194],
  "Scarmagno": [45.38583, 7.84071],
  "Scarnafigi": [44.68176, 7.56693],
  "Scarperia e San Piero": [43.996, 11.356],
  "Scena": [46.69005, 11.18729],
  "Scerni": [42.11177, 14.56908],
  "Scheggia e Pascelupo": [43.40374, 12.668],
  "Scheggino": [42.71259, 12.83119],
  "Schiavi di Abruzzo": [41.81571, 14.4854],
  "Schiavon": [45.69775, 11.64428],
  "Schignano": [45.92791, 9.10236],
  "Schilpario": [46.00956, 10.15452],
  "Schio": [45.71306, 11.35694],
  "Schivenoglia": [44.99115, 11.07748],
  "Sciacca": [37.50777, 13.08293],
  "Sciara": [37.91464, 13.76261],
  "Scicli": [36.79359, 14.7059],
  "Scido": [38.24385, 15.93202],
  "Scigliano": [39.12823, 16.30671],
  "Scilla": [38.25335, 15.71526],
  "Scillato": [37.8567, 13.90683],
  "Sciolze": [45.09504, 7.87766],
  "Scisciano": [40.91741, 14.48282],
  "Sclafani Bagni": [37.82113, 13.8546],
  "Scontrone": [41.7462, 14.03905],
  "Scopa": [45.79171, 8.11316],
  "Scopello": [45.77367, 8.09484],
  "Scoppito": [42.37107, 13.25648],
  "Scordia": [37.29649, 14.84609],
  "Scorrano": [40.09008, 18.29836],
  "Scorzè": [45.57204, 12.10887],
  "Scurcola Marsicana": [42.06446, 13.3424],
  "Scurelle": [46.06448, 11.50759],
  "Scurzolengo": [44.96571, 8.27826],
  "Seborga": [43.82588, 7.69416],
  "Secinaro": [42.15253, 13.67903],
  "Seclì": [40.13157, 18.10496],
  "Secugnago": [45.23034, 9.59142],
  "Sedegliano": [46.01349, 12.97607],
  "Sedico": [46.11087, 12.09709],
  "Sedilo": [40.17485, 8.92092],
  "Sedini": [40.85018, 8.81716],
  "Sedriano": [45.48756, 8.97088],
  "Sedrina": [45.77992, 9.62346],
  "Sefro": [43.14625, 12.94926],
  "Segariu": [39.56393, 8.98332],
  "Seggiano": [42.92799, 11.55731],
  "Segni": [41.69145, 13.02317],
  "Segonzano": [46.19036, 11.25877],
  "Segrate": [45.49082, 9.29293],
  "Segusino": [45.9167, 11.95407],
  "Selargius": [39.2537, 9.16556],
  "Selci": [42.31972, 12.62267],
  "Selegas": [39.5685, 9.1039],
  "Sella Giudicarie": [45.9836, 10.6692],
  "Sellano": [42.88883, 12.92707],
  "Sellero": [46.06872, 10.33812],
  "Sellia": [38.98167, 16.62821],
  "Sellia Marina": [38.90366, 16.74501],
  "Selva dei Molini": [46.8913, 11.86059],
  "Selva di Cadore": [46.45152, 12.03442],
  "Selva di Progno": [45.61232, 11.13882],
  "Selva di Val Gardena": [46.55599, 11.75881],
  "Selvazzano Dentro": [45.39452, 11.78098],
  "Selvino": [45.78075, 9.75013],
  "Semestene": [40.39817, 8.72612],
  "Semiana": [45.13737, 8.72971],
  "Seminara": [38.3361, 15.8705],
  "Semproniano": [42.73025, 11.54169],
  "Senago": [45.5752, 9.11743],
  "Senale-San Felice": [46.49216, 11.13248],
  "Senales": [46.7054, 10.90957],
  "Seneghe": [40.08064, 8.61147],
  "Senerchia": [40.74133, 15.20502],
  "Seniga": [45.24361, 10.17716],
  "Senigallia": [43.71483, 13.21778],
  "Senis": [39.82164, 8.93955],
  "Senise": [40.14354, 16.28973],
  "Senna Comasco": [45.76333, 9.10733],
  "Senna Lodigiana": [45.14725, 9.59358],
  "Sennariolo": [40.21244, 8.55629],
  "Sennori": [40.78814, 8.59526],
  "Senorbì": [39.53305, 9.13201],
  "Sepino": [41.40712, 14.61903],
  "Sequals": [46.16621, 12.82658],
  "Seravezza": [43.99519, 10.22844],
  "Serdiana": [39.37354, 9.15692],
  "Seregno": [45.65021, 9.20177],
  "Seren del Grappa": [45.98879, 11.84358],
  "Sergnano": [45.42812, 9.70479],
  "Seriate": [45.68354, 9.71764],
  "Serina": [45.87138, 9.73009],
  "Serino": [40.85519, 14.87231],
  "Serle": [45.56174, 10.36887],
  "Sermide e Felonica": [45.00603, 11.29897],
  "Sermoneta": [41.54973, 12.98383],
  "Sernaglia della Battaglia": [45.87277, 12.13183],
  "Sernio": [46.22511, 10.20333],
  "Serole": [44.55375, 8.25972],
  "Serra d'Aiello": [39.09004, 16.12612],
  "Serra de' Conti": [43.54258, 13.03777],
  "Serra Riccò": [44.50785, 8.93604],
  "Serra San Bruno": [38.57357, 16.32695],
  "Serra San Quirico": [43.44758, 13.01483],
  "Serra Sant'Abbondio": [43.49085, 12.77062],
  "Serracapriola": [41.81008, 15.16195],
  "Serradifalco": [37.45654, 13.88251],
  "Serralunga d'Alba": [44.60922, 8.00061],
  "Serralunga di Crea": [45.10074, 8.28186],
  "Serramanna": [39.42465, 8.92128],
  "Serramazzoni": [44.42124, 10.79019],
  "Serramezzana": [40.24454, 15.03229],
  "Serramonacesca": [42.24772, 14.09369],
  "Serrapetrona": [43.17692, 13.18937],
  "Serrara Fontana": [40.71186, 13.89311],
  "Serrastretta": [39.01259, 16.41807],
  "Serrata": [38.51277, 16.10157],
  "Serravalle a Po": [45.06565, 11.07981],
  "Serravalle di Chienti": [43.07185, 12.95202],
  "Serravalle Langhe": [44.56092, 8.05766],
  "Serravalle Pistoiese": [43.90559, 10.83198],
  "Serravalle Scrivia": [44.71947, 8.85899],
  "Serravalle Sesia": [45.68615, 8.31148],
  "Serre": [40.58119, 15.1878],
  "Serrenti": [39.49272, 8.975],
  "Serri": [39.7012, 9.14759],
  "Serrone": [41.84067, 13.09655],
  "Sersale": [39.01215, 16.72561],
  "Servigliano": [43.08078, 13.49218],
  "Sessa Aurunca": [41.24311, 13.93279],
  "Sessa Cilento": [40.25929, 15.07527],
  "Sessame": [44.66894, 8.33783],
  "Sessano del Molise": [41.63835, 14.33197],
  "Sesta Godano": [44.294, 9.67572],
  "Sestino": [43.70842, 12.29697],
  "Sesto": [46.7021, 12.35032],
  "Sesto al Reghena": [45.84857, 12.81652],
  "Sesto Calende": [45.72379, 8.63164],
  "Sesto Campano": [41.42109, 14.07736],
  "Sesto ed Uniti": [45.1755, 9.91671],
  "Sesto Fiorentino": [43.83219, 11.19843],
  "Sesto San Giovanni": [45.53353, 9.23651],
  "Sestola": [44.23015, 10.77138],
  "Sestri Levante": [44.2699, 9.39316],
  "Sestriere": [44.95765, 6.87655],
  "Sestu": [39.30032, 9.09195],
  "Settala": [45.45469, 9.38688],
  "Settefrati": [41.67028, 13.85022],
  "Settime": [44.96409, 8.11289],
  "Settimo Milanese": [45.48074, 9.05677],
  "Settimo Rottaro": [45.4049, 7.99223],
  "Settimo San Pietro": [39.29178, 9.18403],
  "Settimo Torinese": [45.13699, 7.77124],
  "Settimo Vittone": [45.54811, 7.83172],
  "Settingiano": [38.91414, 16.5133],
  "Setzu": [39.72373, 8.93976],
  "Seui": [39.83975, 9.32406],
  "Seulo": [39.86796, 9.23848],
  "Seveso": [45.64735, 9.13851],
  "Sezzadio": [44.78559, 8.57273],
  "Sezze": [41.49794, 13.05877],
  "Sfruz": [46.33717, 11.11547],
  "Sgonico": [45.73658, 13.74957],
  "Sgurgola": [41.67072, 13.14979],
  "Siamaggiore": [39.94874, 8.63615],
  "Siamanna": [39.92019, 8.75962],
  "Siano": [40.80099, 14.69362],
  "Siapiccia": [39.92643, 8.76176],
  "Sicignano degli Alburni": [40.55934, 15.30596],
  "Siculiana": [37.33648, 13.42004],
  "Siddi": [39.66997, 8.88943],
  "Siderno": [38.2687, 16.29759],
  "Siena": [43.31816, 11.33191],
  "Sigillo": [43.33128, 12.74077],
  "Signa": [43.78239, 11.09756],
  "Silandro": [46.62793, 10.77314],
  "Silanus": [40.29045, 8.88945],
  "Silea": [45.65505, 12.29875],
  "Siligo": [40.57724, 8.72557],
  "Siliqua": [39.29994, 8.80893],
  "Silius": [39.51748, 9.29587],
  "Sillano Giuncugnano": [44.225, 10.3024],
  "Sillavengo": [45.52045, 8.44053],
  "Silvano d'Orba": [44.68557, 8.67101],
  "Silvano Pietra": [45.03997, 8.94818],
  "Silvi": [42.55681, 14.11396],
  "Simala": [39.71929, 8.82963],
  "Simaxis": [39.93034, 8.6909],
  "Simbario": [38.6108, 16.33827],
  "Simeri Crichi": [38.95526, 16.64617],
  "Sinagra": [38.08324, 14.84953],
  "Sinalunga": [43.21239, 11.73606],
  "Sindia": [40.29607, 8.65939],
  "Sini": [39.75247, 8.90636],
  "Sinio": [44.59948, 8.02156],
  "Siniscola": [40.57501, 9.69428],
  "Sinnai": [39.29749, 9.20553],
  "Sinopoli": [38.2635, 15.87742],
  "Siracusa": [37.05992, 15.29333],
  "Sirignano": [40.94768, 14.62882],
  "Siris": [39.71281, 8.77488],
  "Sirmione": [45.46231, 10.60947],
  "Sirolo": [43.52602, 13.61604],
  "Sirone": [45.77255, 9.32365],
  "Sirtori": [45.73528, 9.33386],
  "Sissa Trecasali": [44.9583, 10.2591],
  "Siurgus Donigala": [39.59921, 9.18513],
  "Siziano": [45.32017, 9.19872],
  "Sizzano": [45.57735, 8.43733],
  "Sluderno": [46.66423, 10.58534],
  "Smerillo": [43.00445, 13.44547],
  "Soave": [45.42262, 11.24862],
  "Socchieve": [46.40336, 12.82351],
  "Soddì": [40.12902, 8.87719],
  "Sogliano al Rubicone": [44.00488, 12.30014],
  "Sogliano Cavour": [40.14623, 18.19941],
  "Soglio": [44.99743, 8.07812],
  "Soiano del Lago": [45.53667, 10.51363],
  "Solagna": [45.81692, 11.718],
  "Solarino": [37.10124, 15.1191],
  "Solaro": [45.61677, 9.07952],
  "Solarolo": [44.36017, 11.84375],
  "Solarolo Rainerio": [45.08126, 10.35709],
  "Solarussa": [39.95316, 8.67076],
  "Solbiate Arno": [45.72057, 8.81347],
  "Solbiate Olona": [45.6536, 8.88734],
  "Soldano": [43.82672, 7.65408],
  "Soleminis": [39.34814, 9.18135],
  "Solero": [44.91976, 8.50771],
  "Solesino": [45.17773, 11.74225],
  "Soleto": [40.18758, 18.20719],
  "Solferino": [45.37181, 10.57298],
  "Soliera": [44.73814, 10.92473],
  "Solignano": [44.61511, 9.9794],
  "Solofra": [40.83056, 14.84651],
  "Solonghello": [45.13095, 8.28184],
  "Solopaca": [41.19401, 14.55292],
  "Solto Collina": [45.78224, 10.02593],
  "Solza": [45.67777, 9.49031],
  "Somaglia": [45.14699, 9.63789],
  "Somano": [44.53589, 8.0114],
  "Somma Lombardo": [45.68378, 8.70435],
  "Somma Vesuviana": [40.86831, 14.43975],
  "Sommacampagna": [45.4071, 10.8404],
  "Sommariva del Bosco": [44.77129, 7.78427],
  "Sommariva Perno": [44.74319, 7.90558],
  "Sommatino": [37.33386, 13.99122],
  "Sommo": [45.13223, 9.08378],
  "Sona": [45.43403, 10.83267],
  "Soncino": [45.39989, 9.87356],
  "Sondalo": [46.33203, 10.32368],
  "Sondrio": [46.17099, 9.87147],
  "Songavazzo": [45.88092, 9.98982],
  "Sonico": [46.16331, 10.35211],
  "Sonnino": [41.41424, 13.24169],
  "Sora": [41.72008, 13.61363],
  "Soraga di Fassa": [46.39604, 11.66881],
  "Soragna": [44.9269, 10.12232],
  "Sorano": [42.68173, 11.71383],
  "Sorbo San Basile": [39.0194, 16.56937],
  "Sorbo Serpico": [40.91685, 14.88709],
  "Sordevolo": [45.5715, 7.97529],
  "Sordio": [45.3402, 9.36687],
  "Soresina": [45.28864, 9.85426],
  "Sorgono": [40.0278, 9.10371],
  "Sorgà": [45.21203, 10.98054],
  "Sori": [44.37279, 9.10437],
  "Sorianello": [38.59225, 16.23287],
  "Soriano Calabro": [38.59645, 16.23011],
  "Soriano nel Cimino": [42.41893, 12.23472],
  "Sorico": [46.17212, 9.37979],
  "Soriso": [45.74227, 8.40936],
  "Sorisole": [45.74474, 9.66254],
  "Sormano": [45.87944, 9.24708],
  "Sorradile": [40.10665, 8.93277],
  "Sorrento": [40.62823, 14.37853],
  "Sorso": [40.79698, 8.57786],
  "Sortino": [37.16257, 15.03283],
  "Sospiro": [45.10566, 10.15926],
  "Sospirolo": [46.142, 12.07316],
  "Sossano": [45.35857, 11.50994],
  "Sostegno": [45.65353, 8.26899],
  "Sotto il Monte Giovanni XXIII": [45.7057, 9.49887],
  "Sover": [46.22118, 11.31533],
  "Soverato": [38.68848, 16.54941],
  "Sovere": [45.82416, 10.02553],
  "Soveria Mannelli": [39.08409, 16.37342],
  "Soveria Simeri": [38.94626, 16.68044],
  "Soverzene": [46.20377, 12.30371],
  "Sovicille": [43.28019, 11.22834],
  "Sovico": [45.64936, 9.26489],
  "Sovizzo": [45.52659, 11.44311],
  "Sovramonte": [46.05659, 11.78655],
  "Sozzago": [45.39782, 8.72098],
  "Spadafora": [38.22208, 15.37414],
  "Spadola": [38.60364, 16.33651],
  "Sparanise": [41.19057, 14.09637],
  "Sparone": [45.4133, 7.54421],
  "Specchia": [39.93884, 18.29608],
  "Spello": [42.99251, 12.67126],
  "Sperlinga": [37.7649, 14.35337],
  "Sperlonga": [41.25735, 13.43615],
  "Sperone": [40.95192, 14.60282],
  "Spessa": [45.11374, 9.34923],
  "Spezzano Albanese": [39.66184, 16.30857],
  "Spezzano della Sila": [39.2978, 16.33736],
  "Spiazzo": [46.10285, 10.7368],
  "Spigno Monferrato": [44.54303, 8.3353],
  "Spigno Saturnia": [41.30554, 13.73423],
  "Spilamberto": [44.53371, 11.02374],
  "Spilimbergo": [46.11212, 12.90567],
  "Spilinga": [38.62855, 15.90584],
  "Spinadesco": [45.14822, 9.92829],
  "Spinazzola": [40.96944, 16.08927],
  "Spinea": [45.49171, 12.1647],
  "Spineda": [45.06039, 10.51651],
  "Spinete": [41.54338, 14.48755],
  "Spineto Scrivia": [44.83763, 8.87238],
  "Spinetoli": [42.88934, 13.77341],
  "Spino d'Adda": [45.40052, 9.49243],
  "Spinone al Lago": [45.76476, 9.92154],
  "Spinoso": [40.26538, 15.96615],
  "Spirano": [45.58217, 9.67099],
  "Spoleto": [42.73448, 12.7383],
  "Spoltore": [42.45569, 14.14148],
  "Spongano": [40.01313, 18.36379],
  "Spormaggiore": [46.21858, 11.04823],
  "Sporminore": [46.23712, 11.03119],
  "Spotorno": [44.22717, 8.41946],
  "Spresiano": [45.77943, 12.2593],
  "Spriana": [46.22015, 9.86447],
  "Squillace": [38.78125, 16.51924],
  "Squinzano": [40.43444, 18.04582],
  "Staffolo": [43.43286, 13.18632],
  "Stagno Lombardo": [45.07323, 10.08796],
  "Staiti": [38.00005, 16.0335],
  "Stalettì": [38.76618, 16.54099],
  "Stanghella": [45.13493, 11.75641],
  "Staranzano": [45.80551, 13.50028],
  "Statte": [40.56357, 17.20062],
  "Stazzano": [44.72726, 8.86739],
  "Stazzema": [43.99712, 10.29563],
  "Stazzona": [46.13899, 9.27726],
  "Stefanaconi": [38.6762, 16.12717],
  "Stella": [44.39689, 8.49308],
  "Stella Cilento": [40.23161, 15.0933],
  "Stellanello": [44.00032, 8.05933],
  "Stelvio": [46.5977, 10.54555],
  "Stenico": [46.05301, 10.8536],
  "Sternatia": [40.22165, 18.22385],
  "Stezzano": [45.64976, 9.65102],
  "Stienta": [44.9382, 11.54404],
  "Stigliano": [40.4025, 16.22805],
  "Stignano": [38.4182, 16.47048],
  "Stilo": [38.4756, 16.46707],
  "Stimigliano": [42.29776, 12.56569],
  "Stintino": [40.93699, 8.22629],
  "Stio": [40.31081, 15.25521],
  "Stornara": [41.28816, 15.76781],
  "Stornarella": [41.25638, 15.73022],
  "Storo": [45.84927, 10.58019],
  "Stra": [45.40991, 12.00488],
  "Stradella": [45.07531, 9.29517],
  "Strambinello": [45.42324, 7.76866],
  "Strambino": [45.38459, 7.88063],
  "Strangolagalli": [41.6011, 13.4919],
  "Stregna": [46.12694, 13.57794],
  "Strembo": [46.12001, 10.75161],
  "Stresa": [45.88389, 8.54073],
  "Strevi": [44.69866, 8.52246],
  "Striano": [40.81386, 14.57789],
  "Strona": [45.6207, 8.16928],
  "Stroncone": [42.49825, 12.66275],
  "Strongoli": [39.2675, 17.05273],
  "Stroppiana": [45.2314, 8.45348],
  "Stroppo": [44.50564, 7.12591],
  "Strozza": [45.77425, 9.57786],
  "Sturno": [41.02217, 15.11248],
  "Suardi": [45.02945, 8.74305],
  "Subbiano": [43.57556, 11.87028],
  "Subiaco": [41.92523, 13.09974],
  "Succivo": [40.96551, 14.25317],
  "Sueglio": [46.08569, 9.3331],
  "Suelli": [39.56198, 9.13191],
  "Suello": [45.81855, 9.30816],
  "Suisio": [45.65979, 9.50127],
  "Sulbiate": [45.63483, 9.42148],
  "Sulmona": [42.04781, 13.92406],
  "Sulzano": [45.69074, 10.10278],
  "Sumirago": [45.74028, 8.77937],
  "Summonte": [40.95009, 14.74698],
  "Suni": [40.27974, 8.55028],
  "Suno": [45.63115, 8.54092],
  "Supersano": [40.02006, 18.23893],
  "Supino": [41.60899, 13.22333],
  "Surano": [40.02834, 18.34162],
  "Surbo": [40.39755, 18.13159],
  "Susa": [45.13525, 7.04642],
  "Susegana": [45.8509, 12.25004],
  "Sustinente": [45.06881, 11.01814],
  "Sutera": [37.52558, 13.7313],
  "Sutri": [42.24202, 12.22484],
  "Sutrio": [46.51228, 12.98993],
  "Suvereto": [43.07925, 10.67911],
  "Suzzara": [44.99023, 10.74562],
  "Taceno": [46.02095, 9.36514],
  "Tadasuni": [40.1107, 8.88261],
  "Taggia": [43.84363, 7.85052],
  "Tagliacozzo": [42.06871, 13.25549],
  "Taglio di Po": [45.00805, 12.20917],
  "Tagliolo Monferrato": [44.63908, 8.66825],
  "Taibon Agordino": [46.2988, 12.01331],
  "Taino": [45.76499, 8.61659],
  "Taipana": [46.25301, 13.34526],
  "Talamello": [43.9049, 12.28613],
  "Talamona": [46.13751, 9.60947],
  "Talana": [40.04117, 9.49692],
  "Taleggio": [45.89403, 9.56481],
  "Talla": [43.602, 11.78713],
  "Talmassons": [45.92967, 13.11591],
  "Tambre": [46.12934, 12.42312],
  "Taormina": [37.85113, 15.28308],
  "Tarano": [42.35584, 12.59489],
  "Taranta Peligna": [42.01988, 14.16912],
  "Tarantasca": [44.49342, 7.54506],
  "Taranto": [40.47355, 17.23238],
  "Tarcento": [46.21556, 13.222],
  "Tarquinia": [42.25445, 11.75823],
  "Tarsia": [39.61728, 16.27302],
  "Tartano": [46.10532, 9.67931],
  "Tarvisio": [46.50611, 13.57332],
  "Tarzo": [45.97297, 12.23218],
  "Tassarolo": [44.72659, 8.7695],
  "Taurano": [40.88402, 14.63611],
  "Taurasi": [41.0068, 14.95789],
  "Taurianova": [38.35256, 16.01302],
  "Taurisano": [39.95562, 18.21438],
  "Tavagnacco": [46.10113, 13.2148],
  "Tavagnasco": [45.54322, 7.82261],
  "Tavazzano con Villavesco": [45.3275, 9.4097],
  "Tavenna": [41.90864, 14.76327],
  "Taverna": [39.02, 16.58247],
  "Tavernerio": [45.79755, 9.15043],
  "Tavernola Bergamasca": [45.70922, 10.04533],
  "Tavernole sul Mella": [45.74808, 10.24025],
  "Taviano": [39.98299, 18.08849],
  "Tavigliano": [45.62363, 8.05319],
  "Tavoleto": [43.84623, 12.59264],
  "Tavullia": [43.89794, 12.7532],
  "Teana": [40.12493, 16.15017],
  "Teano": [41.24967, 14.06868],
  "Teggiano": [40.37965, 15.54041],
  "Teglio": [46.17226, 10.06328],
  "Teglio Veneto": [45.81602, 12.88433],
  "Telese Terme": [41.2195, 14.53112],
  "Telgate": [45.62729, 9.85342],
  "Telti": [40.87611, 9.35247],
  "Telve": [46.07145, 11.47889],
  "Telve di Sopra": [46.07231, 11.47256],
  "Tempio Pausania": [40.9032, 9.10323],
  "Temù": [46.24975, 10.47047],
  "Tenna": [46.01458, 11.2663],
  "Tenno": [45.9186, 10.83264],
  "Teolo": [45.36679, 11.70863],
  "Teora": [40.85109, 15.25279],
  "Teramo": [42.65892, 13.7044],
  "Terdobbiate": [45.37635, 8.6951],
  "Terelle": [41.55357, 13.77894],
  "Terento": [46.82895, 11.77657],
  "Terenzo": [44.61001, 10.08764],
  "Tergu": [40.86291, 8.71241],
  "Terlano": [46.52883, 11.24964],
  "Terlizzi": [41.13091, 16.54213],
  "Terme Vigliatore": [38.13673, 15.16241],
  "Termeno sulla strada del vino": [46.3414, 11.23935],
  "Termini Imerese": [37.98681, 13.69594],
  "Termoli": [42.00271, 14.99554],
  "Ternate": [45.78238, 8.6948],
  "Ternengo": [45.59011, 8.11494],
  "Terni": [42.56071, 12.64669],
  "Terno d'Isola": [45.6836, 9.53143],
  "Terracina": [41.2919, 13.24879],
  "Terragnolo": [45.8787, 11.15304],
  "Terralba": [39.7202, 8.63618],
  "Terranova da Sibari": [39.65582, 16.3438],
  "Terranova dei Passerini": [45.19868, 9.67829],
  "Terranova di Pollino": [39.97681, 16.29827],
  "Terranova Sappo Minulio": [38.32175, 16.00747],
  "Terranuova Bracciolini": [43.55095, 11.58583],
  "Terrasini": [38.15295, 13.08239],
  "Terrassa Padovana": [45.24543, 11.90358],
  "Terravecchia": [39.46367, 16.94752],
  "Terrazzo": [45.17333, 11.39847],
  "Terre del Reno": [44.7932, 11.3892],
  "Terre Roveresche": [43.6876, 12.9641],
  "Terricciola": [43.52464, 10.67604],
  "Terruggia": [45.08306, 8.44218],
  "Tertenia": [39.69698, 9.57724],
  "Terzigno": [40.80768, 14.49767],
  "Terzo": [44.66954, 8.42105],
  "Terzo d'Aquileia": [45.80061, 13.34633],
  "Terzolas": [46.36137, 10.92612],
  "Terzorio": [43.85284, 7.89825],
  "Tesero": [46.28934, 11.51119],
  "Tesimo": [46.56409, 11.16913],
  "Tessennano": [42.48041, 11.79232],
  "Testico": [44.00537, 8.03097],
  "Teti": [40.09644, 9.11926],
  "Teulada": [38.96813, 8.77251],
  "Teverola": [40.99332, 14.20835],
  "Tezze sul Brenta": [45.68743, 11.70438],
  "Thiene": [45.70731, 11.47835],
  "Thiesi": [40.52202, 8.72058],
  "Tiana": [40.0674, 9.14888],
  "Ticengo": [45.36915, 9.82821],
  "Ticineto": [45.09749, 8.55555],
  "Tiggiano": [39.90279, 18.36723],
  "Tiglieto": [44.52536, 8.62045],
  "Tigliole": [44.88727, 8.07547],
  "Tignale": [45.73952, 10.72185],
  "Tinnura": [40.26925, 8.54821],
  "Tione degli Abruzzi": [42.20389, 13.63575],
  "Tione di Trento": [46.03171, 10.72326],
  "Tirano": [46.21687, 10.17531],
  "Tires": [46.46717, 11.5277],
  "Tiriolo": [38.94621, 16.50752],
  "Tirolo": [46.69045, 11.15358],
  "Tissi": [40.67875, 8.56237],
  "Tito": [40.58289, 15.67776],
  "Tivoli": [41.9635, 12.79847],
  "Tizzano Val Parma": [44.52086, 10.19894],
  "Toano": [44.37638, 10.55895],
  "Tocco Caudio": [41.12515, 14.63248],
  "Tocco da Casauria": [42.21793, 13.91385],
  "Toceno": [46.14344, 8.46756],
  "Todi": [42.78225, 12.4069],
  "Toffia": [42.21251, 12.75237],
  "Toirano": [44.12692, 8.20719],
  "Tolentino": [43.20873, 13.2843],
  "Tolfa": [42.14958, 11.93776],
  "Tollegno": [45.59445, 8.05326],
  "Tollo": [42.3395, 14.31774],
  "Tolmezzo": [46.40578, 13.01488],
  "Tolve": [40.69092, 16.01173],
  "Tombolo": [45.64719, 11.82529],
  "Ton": [46.2659, 11.0857],
  "Tonara": [40.02477, 9.17357],
  "Tonco": [45.02411, 8.18984],
  "Tonengo": [45.11794, 8.0021],
  "Tonezza del Cimone": [45.85817, 11.34624],
  "Tora e Piccilli": [41.33835, 14.02195],
  "Torano Castello": [39.5049, 16.14472],
  "Torano Nuovo": [42.82337, 13.77702],
  "Torbole Casaglia": [45.50831, 10.10503],
  "Torcegno": [46.07328, 11.45002],
  "Torchiara": [40.32162, 15.0537],
  "Torchiarolo": [40.48028, 18.05525],
  "Torella dei Lombardi": [40.94218, 15.11455],
  "Torella del Sannio": [41.64044, 14.52156],
  "Torgiano": [43.02573, 12.43398],
  "Torgnon": [45.80147, 7.57121],
  "Torino": [45.07327, 7.68069],
  "Torino di Sangro": [42.18812, 14.54089],
  "Toritto": [40.99582, 16.67887],
  "Torlino Vimercati": [45.41851, 9.59681],
  "Tornaco": [45.35736, 8.71791],
  "Tornareccio": [42.03638, 14.41281],
  "Tornata": [45.10467, 10.43085],
  "Tornimparte": [42.29095, 13.30033],
  "Torno": [45.85871, 9.11892],
  "Tornolo": [44.48491, 9.62449],
  "Toro": [41.57394, 14.76595],
  "Torpè": [40.62868, 9.67845],
  "Torraca": [40.11099, 15.63632],
  "Torralba": [40.51425, 8.76198],
  "Torrazza Coste": [44.97655, 9.08645],
  "Torrazza Piemonte": [45.21521, 7.9749],
  "Torrazzo": [45.4981, 7.9554],
  "Torre Annunziata": [40.75817, 14.44759],
  "Torre Beretti e Castellaro": [45.05997, 8.67031],
  "Torre Boldone": [45.71609, 9.70773],
  "Torre Bormida": [44.5631, 8.15561],
  "Torre Cajetani": [41.78922, 13.26304],
  "Torre Canavese": [45.39182, 7.76054],
  "Torre d'Arese": [45.2424, 9.31682],
  "Torre d'Isola": [45.21746, 9.0764],
  "Torre de' Negri": [45.15066, 9.3356],
  "Torre de' Passeri": [42.24496, 13.92788],
  "Torre de' Picenardi": [45.144, 10.28686],
  "Torre de' Roveri": [45.69951, 9.77221],
  "Torre del Greco": [40.78669, 14.36552],
  "Torre di Mosto": [45.69072, 12.71064],
  "Torre di Ruggiero": [38.65308, 16.3728],
  "Torre di Santa Maria": [46.23262, 9.8521],
  "Torre Le Nocelle": [41.02076, 14.91263],
  "Torre Mondovì": [44.35204, 7.90035],
  "Torre Orsaia": [40.13094, 15.47144],
  "Torre Pallavicina": [45.44146, 9.86263],
  "Torre Pellice": [44.82074, 7.22398],
  "Torre San Giorgio": [44.73582, 7.52994],
  "Torre San Patrizio": [43.18445, 13.60753],
  "Torre Santa Susanna": [40.46385, 17.74281],
  "Torreano": [46.13021, 13.43248],
  "Torrebelvicino": [45.71664, 11.30659],
  "Torrebruna": [41.868, 14.54115],
  "Torrecuso": [41.18589, 14.68102],
  "Torreglia": [45.33603, 11.72466],
  "Torregrotta": [38.19166, 15.35232],
  "Torremaggiore": [41.69049, 15.28697],
  "Torrenova": [38.09113, 14.67734],
  "Torresina": [44.43221, 8.03476],
  "Torretta": [38.13118, 13.23314],
  "Torrevecchia Pia": [45.28287, 9.29793],
  "Torrevecchia Teatina": [42.37953, 14.20607],
  "Torri del Benaco": [45.60808, 10.68522],
  "Torri di Quartesolo": [45.51956, 11.61629],
  "Torri in Sabina": [42.35308, 12.63847],
  "Torrice": [41.62951, 13.39811],
  "Torricella": [40.355, 17.50175],
  "Torricella del Pizzo": [45.02004, 10.29565],
  "Torricella in Sabina": [42.26075, 12.86972],
  "Torricella Peligna": [42.02183, 14.26112],
  "Torricella Sicura": [42.65691, 13.65508],
  "Torricella Verzate": [45.0156, 9.17584],
  "Torriglia": [44.51902, 9.15778],
  "Torrile": [44.89061, 10.35508],
  "Torrioni": [41.0341, 14.81351],
  "Torrita di Siena": [43.16664, 11.77189],
  "Torrita Tiberina": [42.23678, 12.61741],
  "Tortolì": [39.92543, 9.6573],
  "Tortona": [44.89474, 8.86016],
  "Tortora": [39.9221, 15.76829],
  "Tortorella": [40.14236, 15.60625],
  "Tortoreto": [42.80398, 13.91333],
  "Tortorici": [38.03054, 14.82486],
  "Torviscosa": [45.82348, 13.2746],
  "Toscolano-Maderno": [45.64168, 10.60625],
  "Tossicia": [42.54576, 13.64881],
  "Tovo di Sant'Agata": [46.24504, 10.24667],
  "Tovo San Giacomo": [44.1767, 8.26854],
  "Trabia": [37.99576, 13.65541],
  "Tradate": [45.71376, 8.90569],
  "Tramatza": [40.00288, 8.64862],
  "Trambileno": [45.8697, 11.07341],
  "Tramonti": [40.69484, 14.64019],
  "Tramonti di Sopra": [46.30997, 12.78961],
  "Tramonti di Sotto": [46.28495, 12.79582],
  "Tramutola": [40.32123, 15.78759],
  "Trana": [45.0371, 7.4173],
  "Trani": [41.27409, 16.41722],
  "Traona": [46.14688, 9.52678],
  "Trapani": [38.0185, 12.51366],
  "Trappeto": [38.06656, 13.03653],
  "Trarego Viggiona": [46.03389, 8.66399],
  "Trasacco": [41.9581, 13.53881],
  "Trasaghis": [46.28236, 13.07538],
  "Trasquera": [46.21248, 8.214],
  "Tratalias": [39.10311, 8.57759],
  "Travacò Siccomario": [45.15248, 9.16152],
  "Travagliato": [45.52338, 10.08022],
  "Travedona-Monate": [45.80571, 8.67726],
  "Traversella": [45.50941, 7.75041],
  "Traversetolo": [44.63975, 10.38164],
  "Traves": [45.27058, 7.42975],
  "Travesio": [46.19647, 12.87197],
  "Travo": [44.86104, 9.54284],
  "Tre Ville": [46.0545, 10.7783],
  "Trebaseleghe": [45.59161, 12.0514],
  "Trebisacce": [39.8668, 16.53046],
  "Trecase": [40.76987, 14.43595],
  "Trecastagni": [37.617, 15.0792],
  "Trecastelli": [43.6718, 13.1064],
  "Trecate": [45.4319, 8.73506],
  "Trecchina": [40.0266, 15.77972],
  "Trecenta": [45.03086, 11.46046],
  "Tredozio": [44.07935, 11.7437],
  "Treglio": [42.26734, 14.42487],
  "Tregnago": [45.51664, 11.16462],
  "Treia": [43.31128, 13.3123],
  "Treiso": [44.68937, 8.08685],
  "Tremestieri Etneo": [37.57584, 15.07214],
  "Tremezzina": [45.98231, 9.2135],
  "Tremosine sul Garda": [45.76696, 10.75381],
  "Trentinara": [40.40068, 15.10736],
  "Trento": [46.06894, 11.12123],
  "Trentola Ducenta": [40.97565, 14.17562],
  "Trenzano": [45.47595, 10.01571],
  "Treppo Grande": [46.19098, 13.15702],
  "Trepuzzi": [40.40516, 18.07369],
  "Trequanda": [43.18865, 11.66777],
  "Tresana": [44.23824, 9.95156],
  "Trescore Balneario": [45.69509, 9.84277],
  "Trescore Cremasco": [45.40166, 9.62544],
  "Tresivio": [46.1747, 9.94538],
  "Tresnuraghes": [40.25093, 8.51882],
  "Trevenzuolo": [45.27131, 10.93304],
  "Trevi": [42.87713, 12.7477],
  "Trevi nel Lazio": [41.86223, 13.24811],
  "Trevico": [41.04808, 15.23292],
  "Treviglio": [45.52176, 9.59265],
  "Trevignano": [45.74266, 12.08907],
  "Trevignano Romano": [42.15576, 12.24515],
  "Treville": [45.09714, 8.35976],
  "Treviolo": [45.67162, 9.61127],
  "Treviso": [45.66755, 12.24507],
  "Treviso Bresciano": [45.71274, 10.462],
  "Trezzano Rosa": [45.58498, 9.48954],
  "Trezzano sul Naviglio": [45.41868, 9.06914],
  "Trezzo sull'Adda": [45.61015, 9.51924],
  "Trezzo Tinella": [44.67695, 8.10758],
  "Trezzone": [46.17146, 9.35534],
  "Tribano": [45.2106, 11.83326],
  "Tribiano": [45.4042, 9.36826],
  "Tribogna": [44.41627, 9.1956],
  "Tricarico": [40.61896, 16.14058],
  "Tricase": [39.93495, 18.35076],
  "Tricerro": [45.2338, 8.32515],
  "Tricesimo": [46.16222, 13.21252],
  "Triei": [40.03693, 9.64122],
  "Trieste": [45.64944, 13.76814],
  "Triggiano": [41.06531, 16.92503],
  "Trigolo": [45.32926, 9.81162],
  "Trinitapoli": [41.35957, 16.08555],
  "Trinità": [44.50747, 7.75804],
  "Trinità d'Agultu e Vignola": [40.98564, 8.91371],
  "Trino": [45.19421, 8.2969],
  "Triora": [43.99381, 7.76211],
  "Tripi": [38.04934, 15.09943],
  "Trisobbio": [44.6623, 8.58628],
  "Trissino": [45.56514, 11.37422],
  "Triuggio": [45.65919, 9.26445],
  "Trivento": [41.7841, 14.55097],
  "Trivigliano": [41.77595, 13.27282],
  "Trivignano Udinese": [45.94149, 13.34749],
  "Trivigno": [40.58094, 15.98929],
  "Trivolzio": [45.26094, 9.04708],
  "Trodena nel parco naturale": [46.32293, 11.34934],
  "Trofarello": [44.98596, 7.7403],
  "Troia": [41.36167, 15.30811],
  "Troina": [37.78502, 14.60045],
  "Tromello": [45.21184, 8.8696],
  "Trontano": [46.12225, 8.33448],
  "Tronzano Lago Maggiore": [46.09147, 8.73552],
  "Tronzano Vercellese": [45.34279, 8.17469],
  "Tropea": [38.67863, 15.89789],
  "Trovo": [45.28285, 9.03577],
  "Truccazzano": [45.48357, 9.46626],
  "Tubre": [46.64602, 10.46436],
  "Tufara": [41.48185, 14.94578],
  "Tufillo": [41.91633, 14.62636],
  "Tufino": [40.95559, 14.56517],
  "Tufo": [41.00995, 14.82425],
  "Tuglie": [40.07018, 18.10299],
  "Tuili": [39.71467, 8.96018],
  "Tula": [40.73373, 8.98668],
  "Tuoro sul Trasimeno": [43.20876, 12.07174],
  "Turania": [42.13743, 13.00977],
  "Turano Lodigiano": [45.24824, 9.62272],
  "Turate": [45.65507, 9.00121],
  "Turbigo": [45.52847, 8.73521],
  "Turi": [40.91562, 17.01911],
  "Turri": [39.7031, 8.91816],
  "Turriaco": [45.82089, 13.44482],
  "Turrivalignani": [42.26296, 14.02868],
  "Tursi": [40.2465, 16.47721],
  "Tusa": [37.98457, 14.23853],
  "Tuscania": [42.41672, 11.87564],
  "Ubiale Clanezzo": [45.78339, 9.61669],
  "Uboldo": [45.61071, 9.00307],
  "Ucria": [38.04563, 14.88092],
  "Udine": [46.06256, 13.23484],
  "Ugento": [39.92857, 18.16168],
  "Uggiano la Chiesa": [40.09952, 18.45399],
  "Uggiate-Trevano": [45.8233, 8.96175],
  "Ulassai": [39.81157, 9.49991],
  "Ultimo": [46.54883, 11.00307],
  "Ulà Tirso": [40.04502, 8.90543],
  "Umbertide": [43.30646, 12.32693],
  "Umbriatico": [39.35281, 16.91719],
  "Urago d'Oglio": [45.51333, 9.87035],
  "Uras": [39.69835, 8.70108],
  "Urbana": [45.19085, 11.44356],
  "Urbania": [43.66838, 12.52427],
  "Urbe": [44.48775, 8.59239],
  "Urbino": [43.72512, 12.6373],
  "Urbisaglia": [43.19704, 13.37679],
  "Urgnano": [45.59854, 9.68918],
  "Uri": [40.63792, 8.4865],
  "Ururi": [41.81518, 15.01183],
  "Urzulei": [40.09361, 9.50735],
  "Uscio": [44.4132, 9.16329],
  "Usellus": [39.80828, 8.85263],
  "Usini": [40.66372, 8.54057],
  "Usmate Velate": [45.65066, 9.36146],
  "Ussana": [39.39275, 9.07771],
  "Ussaramanna": [39.69128, 8.9103],
  "Ussassai": [39.81056, 9.39348],
  "Usseaux": [45.0485, 7.02687],
  "Usseglio": [45.23272, 7.21722],
  "Ussita": [42.94408, 13.13846],
  "Ustica": [38.71008, 13.19284],
  "Uta": [39.29306, 8.95298],
  "Uzzano": [43.88172, 10.70908],
  "Vaccarizzo Albanese": [39.58707, 16.43323],
  "Vacone": [42.38627, 12.63579],
  "Vacri": [42.29778, 14.23279],
  "Vadena": [46.4145, 11.30518],
  "Vado Ligure": [44.26934, 8.43628],
  "Vagli Sotto": [44.11439, 10.2804],
  "Vaglia": [43.90657, 11.28136],
  "Vaglio Basilicata": [40.6658, 15.92],
  "Vaglio Serra": [44.79654, 8.33893],
  "Vaiano": [43.96865, 11.12331],
  "Vaiano Cremasco": [45.3725, 9.59127],
  "Vaie": [45.10189, 7.28663],
  "Vailate": [45.46162, 9.60501],
  "Vairano Patenora": [41.33307, 14.13173],
  "Vajont": [46.14661, 12.69803],
  "Val Brembilla": [45.8211, 9.59647],
  "Val della Torre": [45.15556, 7.44941],
  "Val di Nizza": [44.87933, 9.16683],
  "Val di Vizze": [46.89971, 11.46247],
  "Val di Zoldo": [46.3487, 12.183],
  "Val Liona": [45.4208, 11.4641],
  "Val Masino": [46.21108, 9.63664],
  "Val Rezzo": [46.07229, 9.11062],
  "Valbondione": [46.03798, 10.01262],
  "Valbrembo": [45.71643, 9.60837],
  "Valbrevenna": [44.55653, 9.06503],
  "Valbrona": [45.87779, 9.29677],
  "Valdagno": [45.64538, 11.29948],
  "Valdaone": [45.9481, 10.6221],
  "Valdaora": [46.76141, 12.03097],
  "Valdastico": [45.88325, 11.36335],
  "Valdengo": [45.57111, 8.13615],
  "Valderice": [38.03795, 12.61749],
  "Valdidentro": [46.48933, 10.29681],
  "Valdieri": [44.27764, 7.39614],
  "Valdina": [38.1935, 15.37074],
  "Valdisotto": [46.43167, 10.35511],
  "Valdobbiadene": [45.9013, 11.99524],
  "Valduggia": [45.72639, 8.32786],
  "Valeggio": [45.15064, 8.86129],
  "Valeggio sul Mincio": [45.35364, 10.73445],
  "Valentano": [42.5692, 11.81838],
  "Valenza": [45.01447, 8.64623],
  "Valenzano": [41.04215, 16.88758],
  "Valera Fratta": [45.25682, 9.33351],
  "Valfabbrica": [43.15941, 12.60129],
  "Valfenera": [44.89687, 7.9651],
  "Valfloriana": [46.24897, 11.34214],
  "Valfornace": [43.0649, 13.0839],
  "Valfurva": [46.46308, 10.41086],
  "Valganna": [45.90277, 8.82395],
  "Valgioie": [45.07601, 7.33964],
  "Valgoglio": [45.9756, 9.91394],
  "Valgrana": [44.40961, 7.38061],
  "Valgreghentino": [45.76944, 9.4132],
  "Valgrisenche": [45.63034, 7.06476],
  "Valguarnera Caropepe": [37.49668, 14.38816],
  "Vallada Agordina": [46.36815, 11.93092],
  "Vallanzengo": [45.60349, 8.1483],
  "Vallarsa": [45.78259, 11.11763],
  "Vallata": [41.03692, 15.25136],
  "Valle Agricola": [41.42428, 14.25593],
  "Valle Aurina": [46.99686, 11.9808],
  "Valle Castellana": [42.73541, 13.49763],
  "Valle dell'Angelo": [40.34377, 15.36869],
  "Valle di Cadore": [46.41704, 12.32782],
  "Valle di Casies": [46.81103, 12.2272],
  "Valle di Maddaloni": [41.08011, 14.41679],
  "Valle Lomellina": [45.14712, 8.66496],
  "Valle Salimbene": [45.16963, 9.23298],
  "Valle San Nicolao": [45.60703, 8.14077],
  "Vallebona": [43.81328, 7.66684],
  "Vallecorsa": [41.44466, 13.40577],
  "Vallecrosia": [43.79318, 7.64379],
  "Valledolmo": [37.74708, 13.82826],
  "Valledoria": [40.92776, 8.82245],
  "Vallefiorita": [38.77635, 16.46438],
  "Vallefoglia": [43.8264, 12.8013],
  "Vallelaghi": [46.08, 11.0005],
  "Vallelonga": [38.64696, 16.29599],
  "Vallelunga Pratameno": [37.68021, 13.83047],
  "Vallemaio": [41.3661, 13.81155],
  "Vallepietra": [41.9268, 13.23085],
  "Vallerano": [42.38378, 12.26396],
  "Vallermosa": [39.36309, 8.79624],
  "Vallerotonda": [41.55217, 13.9126],
  "Vallesaccarda": [41.06441, 15.25197],
  "Valleve": [46.0282, 9.74323],
  "Valli del Pasubio": [45.7418, 11.25986],
  "Vallinfreda": [42.08449, 12.99541],
  "Vallio Terme": [45.60923, 10.39578],
  "Vallo della Lucania": [40.22878, 15.26707],
  "Vallo di Nera": [42.76932, 12.86221],
  "Vallo Torinese": [45.2235, 7.49929],
  "Valloriate": [44.33815, 7.37457],
  "Valmacca": [45.10046, 8.58234],
  "Valmadrera": [45.84698, 9.36027],
  "Valmontone": [41.77688, 12.91775],
  "Valmorea": [45.81329, 8.93063],
  "Valmozzola": [44.56826, 9.88488],
  "Valnegra": [45.94912, 9.68947],
  "Valpelline": [45.82642, 7.32855],
  "Valperga": [45.37027, 7.65679],
  "Valprato Soana": [45.52237, 7.54897],
  "Valsamoggia": [44.5031, 11.0804],
  "Valsavarenche": [45.59199, 7.20831],
  "Valsinni": [40.17067, 16.44199],
  "Valsolda": [46.02446, 9.05613],
  "Valstrona": [45.90729, 8.34082],
  "Valtopina": [43.05904, 12.75447],
  "Valtorta": [45.97758, 9.53501],
  "Valtournenche": [45.87708, 7.62271],
  "Valva": [40.73971, 15.26989],
  "Valvasone Arzene": [46.0022, 12.8477],
  "Valverde": [37.579, 15.12482],
  "Valvestino": [45.76184, 10.59482],
  "Vandoies": [46.81615, 11.72213],
  "Vanzaghello": [45.57776, 8.78556],
  "Vanzago": [45.52649, 9.00065],
  "Vanzone con San Carlo": [45.97997, 8.11036],
  "Vaprio d'Adda": [45.57646, 9.53347],
  "Vaprio d'Agogna": [45.60353, 8.55405],
  "Varallo": [45.81404, 8.25621],
  "Varallo Pombia": [45.6667, 8.63305],
  "Varano Borghi": [45.77779, 8.70194],
  "Varano de' Melegari": [44.68707, 10.01428],
  "Varapodio": [38.31465, 15.98323],
  "Varazze": [44.36, 8.5764],
  "Varco Sabino": [42.23963, 13.01996],
  "Varedo": [45.59805, 9.15706],
  "Varenna": [46.01061, 9.28359],
  "Varese": [45.81702, 8.82287],
  "Varese Ligure": [44.37773, 9.59568],
  "Varisella": [45.20984, 7.48903],
  "Varmo": [45.88674, 12.98815],
  "Varna": [46.74006, 11.63584],
  "Varsi": [44.66291, 9.84568],
  "Varzi": [44.822, 9.19627],
  "Varzo": [46.20673, 8.25548],
  "Vasanello": [42.41816, 12.34649],
  "Vasia": [43.93302, 7.95411],
  "Vasto": [42.11221, 14.70792],
  "Vastogirardi": [41.77424, 14.25943],
  "Vauda Canavese": [45.27924, 7.61821],
  "Vazzano": [38.63354, 16.246],
  "Vazzola": [45.83784, 12.37919],
  "Vecchiano": [43.7816, 10.3866],
  "Vedano al Lambro": [45.60953, 9.27289],
  "Vedano Olona": [45.77671, 8.88636],
  "Vedelago": [45.68707, 12.01832],
  "Vedeseta": [45.88946, 9.54266],
  "Veduggio con Colzano": [45.73579, 9.26761],
  "Veggiano": [45.44789, 11.71371],
  "Veglie": [40.33506, 17.96574],
  "Veglio": [45.64008, 8.11414],
  "Vejano": [42.2163, 12.09528],
  "Veleso": [45.90875, 9.18088],
  "Velezzo Lomellina": [45.16371, 8.73721],
  "Velletri": [41.68638, 12.7772],
  "Vellezzo Bellini": [45.26953, 9.10213],
  "Velo d'Astico": [45.78865, 11.36619],
  "Velo Veronese": [45.60528, 11.09589],
  "Velturno": [46.66947, 11.6001],
  "Venafro": [41.48619, 14.04511],
  "Venaria Reale": [45.13254, 7.6315],
  "Venarotta": [42.88118, 13.49282],
  "Venasca": [44.56254, 7.39495],
  "Venaus": [45.1547, 7.01195],
  "Vendone": [44.07401, 8.07426],
  "Venegono Inferiore": [45.73588, 8.89943],
  "Venegono Superiore": [45.74912, 8.90172],
  "Venetico": [38.21905, 15.3648],
  "Venezia": [45.4349, 12.33845],
  "Veniano": [45.71629, 8.98499],
  "Venosa": [40.96455, 15.82328],
  "Ventasso": [44.3698, 10.3244],
  "Venticano": [41.04615, 14.91752],
  "Ventimiglia": [43.79004, 7.60863],
  "Ventimiglia di Sicilia": [37.92614, 13.56791],
  "Ventotene": [40.79636, 13.43305],
  "Venzone": [46.33369, 13.13902],
  "Verano": [46.60511, 11.22574],
  "Verano Brianza": [45.68465, 9.22961],
  "Verbania": [45.92145, 8.55108],
  "Verbicaro": [39.75489, 15.91112],
  "Vercana": [46.16002, 9.33043],
  "Verceia": [46.19663, 9.45276],
  "Vercelli": [45.32398, 8.42323],
  "Vercurago": [45.81075, 9.4248],
  "Verdellino": [45.60418, 9.61534],
  "Verdello": [45.60652, 9.62702],
  "Verderio": [45.663, 9.44182],
  "Verduno": [44.66812, 7.93377],
  "Vergato": [44.28394, 11.11278],
  "Verghereto": [43.79565, 12.00588],
  "Vergiate": [45.72454, 8.6954],
  "Vermiglio": [46.29883, 10.69285],
  "Vernante": [44.24556, 7.5337],
  "Vernasca": [44.79993, 9.82959],
  "Vernate": [45.31588, 9.06043],
  "Vernazza": [44.13523, 9.68373],
  "Vernio": [44.05334, 11.15576],
  "Vernole": [40.28846, 18.29874],
  "Verolanuova": [45.32578, 10.07665],
  "Verolavecchia": [45.33052, 10.05181],
  "Verolengo": [45.18905, 7.96716],
  "Veroli": [41.691, 13.41788],
  "Verona": [45.43839, 10.99353],
  "Veronella": [45.32308, 11.32049],
  "Verrayes": [45.76144, 7.53225],
  "Verretto": [45.04004, 9.1077],
  "Verrone": [45.50394, 8.11972],
  "Verrua Po": [45.11133, 9.17317],
  "Verrua Savoia": [45.15655, 8.09315],
  "Verrès": [45.66873, 7.68994],
  "Vertemate con Minoprio": [45.72517, 9.07217],
  "Vertova": [45.80859, 9.84987],
  "Verucchio": [43.98371, 12.42138],
  "Vervio": [46.25285, 10.24053],
  "Verzegnis": [46.38961, 12.99357],
  "Verzino": [39.31248, 16.86168],
  "Verzuolo": [44.59955, 7.48313],
  "Vescovana": [45.13395, 11.70804],
  "Vescovato": [45.17637, 10.16812],
  "Vesime": [44.6372, 8.22823],
  "Vespolate": [45.34947, 8.66904],
  "Vessalico": [44.04623, 7.96225],
  "Vestenanova": [45.57345, 11.22762],
  "Vestignè": [45.3867, 7.95388],
  "Vestone": [45.7096, 10.4037],
  "Vetralla": [42.32082, 12.05352],
  "Vetto": [44.48405, 10.33924],
  "Vezza d'Alba": [44.7639, 7.99609],
  "Vezza d'Oglio": [46.24012, 10.40008],
  "Vezzano Ligure": [44.14136, 9.88448],
  "Vezzano sul Crostolo": [44.60092, 10.54644],
  "Vezzi Portio": [44.22895, 8.36195],
  "Viadana": [44.92612, 10.52143],
  "Viadanica": [45.68553, 9.96132],
  "Viagrande": [37.61059, 15.09633],
  "Viale": [44.99927, 8.05229],
  "Vialfrè": [45.38084, 7.81817],
  "Viano": [44.54829, 10.62041],
  "Viareggio": [43.86694, 10.24981],
  "Viarigi": [44.98045, 8.35869],
  "Vibo Valentia": [38.67624, 16.10158],
  "Vibonati": [40.1032, 15.57994],
  "Vicalvi": [41.6765, 13.70593],
  "Vicari": [37.82658, 13.57075],
  "Vicchio": [43.93378, 11.46544],
  "Vicenza": [45.5475, 11.54597],
  "Vico del Gargano": [41.89687, 15.95552],
  "Vico Equense": [40.66443, 14.42534],
  "Vico nel Lazio": [41.77679, 13.3416],
  "Vicoforte": [44.37496, 7.86499],
  "Vicoli": [42.33985, 13.89515],
  "Vicolungo": [45.47883, 8.46132],
  "Vicopisano": [43.69975, 10.58439],
  "Vicovaro": [42.01448, 12.89153],
  "Viddalba": [40.91706, 8.89458],
  "Vidigulfo": [45.29187, 9.23483],
  "Vidor": [45.86346, 12.03883],
  "Vidracco": [45.43045, 7.75902],
  "Vieste": [41.88161, 16.18063],
  "Vietri di Potenza": [40.59962, 15.50702],
  "Vietri sul Mare": [40.67203, 14.72816],
  "Vigano San Martino": [45.72609, 9.89576],
  "Viganò": [45.72607, 9.3242],
  "Vigarano Mainarda": [44.84176, 11.50032],
  "Vigasio": [45.31745, 10.94334],
  "Vigevano": [45.31761, 8.85988],
  "Viggianello": [39.97299, 16.08804],
  "Viggiano": [40.34026, 15.90337],
  "Viggiù": [45.87201, 8.90704],
  "Vighizzolo d'Este": [45.17633, 11.62374],
  "Vigliano Biellese": [45.56216, 8.10994],
  "Vigliano d'Asti": [44.83511, 8.23189],
  "Vignale Monferrato": [45.01093, 8.39654],
  "Vignanello": [42.38384, 12.27807],
  "Vignate": [45.49637, 9.37704],
  "Vignola": [44.47954, 11.01076],
  "Vignola-Falesina": [46.04392, 11.27817],
  "Vignole Borbera": [44.70829, 8.89056],
  "Vignolo": [44.35956, 7.46989],
  "Vignone": [45.96044, 8.56639],
  "Vigo di Cadore": [46.49967, 12.47122],
  "Vigodarzere": [45.46063, 11.87883],
  "Vigolo": [45.71642, 10.02631],
  "Vigolzone": [44.91152, 9.66979],
  "Vigone": [44.84236, 7.49452],
  "Vigonovo": [45.38543, 12.00775],
  "Vigonza": [45.44364, 11.98306],
  "Viguzzolo": [44.90492, 8.92008],
  "Villa Bartolomea": [45.15928, 11.35333],
  "Villa Basilica": [43.92778, 10.6451],
  "Villa Biscossi": [45.08996, 8.78669],
  "Villa Carcina": [45.63142, 10.19527],
  "Villa Castelli": [40.57717, 17.47589],
  "Villa Celiera": [42.38069, 13.8592],
  "Villa Collemandina": [44.15958, 10.39757],
  "Villa Cortese": [45.5655, 8.88569],
  "Villa d'Adda": [45.71283, 9.46461],
  "Villa d'Almè": [45.74634, 9.61792],
  "Villa d'Ogna": [45.90754, 9.93053],
  "Villa del Bosco": [45.62029, 8.28265],
  "Villa del Conte": [45.58349, 11.85935],
  "Villa di Briano": [40.99834, 14.16848],
  "Villa di Chiavenna": [46.33124, 9.48897],
  "Villa di Serio": [45.72011, 9.7342],
  "Villa di Tirano": [46.20268, 10.13321],
  "Villa Estense": [45.1722, 11.66719],
  "Villa Faraldi": [43.96709, 8.09147],
  "Villa Guardia": [45.77473, 9.02592],
  "Villa Lagarina": [45.91604, 11.03185],
  "Villa Latina": [41.61382, 13.83736],
  "Villa Literno": [41.00974, 14.07411],
  "Villa Minozzo": [44.36521, 10.46719],
  "Villa San Giovanni": [38.21917, 15.63692],
  "Villa San Giovanni in Tuscia": [42.28352, 12.05294],
  "Villa San Pietro": [39.03383, 8.99508],
  "Villa San Secondo": [45.00518, 8.13526],
  "Villa Sant'Angelo": [42.27003, 13.53754],
  "Villa Sant'Antonio": [39.85816, 8.90128],
  "Villa Santa Lucia": [41.5091, 13.76979],
  "Villa Santa Lucia degli Abruzzi": [42.33303, 13.77819],
  "Villa Santa Maria": [41.95121, 14.35065],
  "Villa Santina": [46.41546, 12.92401],
  "Villa Santo Stefano": [41.51692, 13.31096],
  "Villa Verde": [39.79604, 8.82102],
  "Villabassa": [46.73776, 12.16907],
  "Villabate": [38.07564, 13.44209],
  "Villachiara": [45.35687, 9.92961],
  "Villacidro": [39.45597, 8.73213],
  "Villadeati": [45.07244, 8.1697],
  "Villadose": [45.07367, 11.88967],
  "Villadossola": [46.06771, 8.26013],
  "Villafalletto": [44.54428, 7.53889],
  "Villafranca d'Asti": [44.91367, 8.03221],
  "Villafranca di Verona": [45.3508, 10.84674],
  "Villafranca in Lunigiana": [44.29198, 9.95103],
  "Villafranca Padovana": [45.49499, 11.79716],
  "Villafranca Piemonte": [44.78128, 7.50451],
  "Villafranca Sicula": [37.58683, 13.29094],
  "Villafranca Tirrena": [38.23545, 15.4325],
  "Villafrati": [37.90807, 13.48672],
  "Villaga": [45.40229, 11.53399],
  "Villagrande Strisaili": [39.96182, 9.50642],
  "Villalago": [41.93601, 13.83577],
  "Villalba": [37.65498, 13.84393],
  "Villalfonsina": [42.1648, 14.57409],
  "Villalvernia": [44.81761, 8.85664],
  "Villamagna": [42.33323, 14.23673],
  "Villamaina": [40.97122, 15.08818],
  "Villamar": [39.61787, 8.96202],
  "Villamarzana": [45.01096, 11.69227],
  "Villamassargia": [39.27558, 8.64037],
  "Villamiroglio": [45.13445, 8.16976],
  "Villandro": [46.63141, 11.53983],
  "Villanova Biellese": [45.48275, 8.1927],
  "Villanova Canavese": [45.24294, 7.55354],
  "Villanova d'Albenga": [44.0459, 8.14308],
  "Villanova d'Ardenghi": [45.17134, 9.04324],
  "Villanova d'Asti": [44.94189, 7.93722],
  "Villanova del Battista": [41.12245, 15.15847],
  "Villanova del Ghebbo": [45.05561, 11.64439],
  "Villanova del Sillaro": [45.23731, 9.48089],
  "Villanova di Camposampiero": [45.48964, 11.97277],
  "Villanova Marchesana": [44.99126, 11.96702],
  "Villanova Mondovì": [44.34446, 7.76209],
  "Villanova Monferrato": [45.18179, 8.47847],
  "Villanova Monteleone": [40.50357, 8.47038],
  "Villanova Solaro": [44.72964, 7.57603],
  "Villanova sull'Arda": [45.02582, 9.99742],
  "Villanova Truschedu": [39.98959, 8.75257],
  "Villanova Tulo": [39.77989, 9.21507],
  "Villanovaforru": [39.63268, 8.86861],
  "Villanovafranca": [39.64512, 9.00142],
  "Villanterio": [45.22072, 9.36041],
  "Villanuova sul Clisi": [45.60166, 10.45371],
  "Villaperuccio": [39.11158, 8.67224],
  "Villapiana": [39.84696, 16.45512],
  "Villaputzu": [39.44009, 9.57483],
  "Villar Dora": [45.11784, 7.38382],
  "Villar Focchiardo": [45.10972, 7.22669],
  "Villar Pellice": [44.80859, 7.15828],
  "Villar Perosa": [44.92019, 7.24927],
  "Villar San Costanzo": [44.48301, 7.3803],
  "Villarbasse": [45.04487, 7.468],
  "Villarboit": [45.43665, 8.33687],
  "Villareggia": [45.31101, 7.9785],
  "Villaricca": [40.92181, 14.19482],
  "Villaromagnano": [44.85109, 8.88713],
  "Villarosa": [37.58792, 14.17423],
  "Villasalto": [39.49376, 9.38877],
  "Villasanta": [45.60427, 9.30195],
  "Villasimius": [39.14238, 9.52037],
  "Villasor": [39.38069, 8.94065],
  "Villaspeciosa": [39.31281, 8.92693],
  "Villastellone": [44.92155, 7.74535],
  "Villata": [45.38561, 8.4326],
  "Villaurbana": [39.88618, 8.7781],
  "Villavallelonga": [41.86735, 13.62454],
  "Villaverla": [45.65498, 11.49359],
  "Ville d'Anaunia": [46.3298, 11.024],
  "Villeneuve": [45.70275, 7.20774],
  "Villesse": [45.85978, 13.43813],
  "Villetta Barrea": [41.7766, 13.92775],
  "Villette": [46.13129, 8.53408],
  "Villimpenta": [45.14494, 11.02939],
  "Villongo": [45.67239, 9.93475],
  "Villorba": [45.71287, 12.26036],
  "Vilminore di Scalve": [45.99795, 10.09529],
  "Vimercate": [45.61317, 9.36975],
  "Vimodrone": [45.51433, 9.28709],
  "Vinadio": [44.30709, 7.17434],
  "Vinchiaturo": [41.4933, 14.58657],
  "Vinchio": [44.80741, 8.3173],
  "Vinci": [43.78714, 10.92649],
  "Vinovo": [44.94878, 7.63424],
  "Vinzaglio": [45.32366, 8.51841],
  "Viola": [44.29048, 7.96624],
  "Vione": [46.24881, 10.4478],
  "Vipiteno": [46.89797, 11.43179],
  "Virle Piemonte": [44.86594, 7.56889],
  "Visano": [45.31626, 10.36908],
  "Vische": [45.33157, 7.95138],
  "Visciano": [40.92373, 14.58724],
  "Visco": [45.89154, 13.34788],
  "Visone": [44.66206, 8.50328],
  "Visso": [42.93076, 13.08831],
  "Vistarino": [45.21148, 9.30646],
  "Vistrorio": [45.4411, 7.76942],
  "Vita": [37.86843, 12.81459],
  "Viterbo": [42.41738, 12.10473],
  "Viticuso": [41.52461, 13.96868],
  "Vito d'Asio": [46.23334, 12.95853],
  "Vitorchiano": [42.47031, 12.17422],
  "Vittoria": [36.94879, 14.53801],
  "Vittorio Veneto": [45.98992, 12.29614],
  "Vittorito": [42.12545, 13.81617],
  "Vittuone": [45.48777, 8.9533],
  "Vitulano": [41.17285, 14.65005],
  "Vitulazio": [41.16413, 14.21899],
  "Vivaro": [46.07419, 12.77641],
  "Vivaro Romano": [42.10032, 13.00664],
  "Viverone": [45.4256, 8.05066],
  "Vizzini": [37.16103, 14.74852],
  "Vizzola Ticino": [45.63123, 8.68505],
  "Vizzolo Predabissi": [45.357, 9.34658],
  "Viù": [45.23894, 7.37647],
  "Vo'": [45.32854, 11.64098],
  "Vobarno": [45.647, 10.49656],
  "Vobbia": [44.59977, 9.03982],
  "Vocca": [45.83098, 8.18753],
  "Vodo Cadore": [46.4181, 12.25032],
  "Voghera": [44.99313, 9.00852],
  "Voghiera": [44.75814, 11.75125],
  "Vogogna": [46.00783, 8.29549],
  "Volano": [45.91719, 11.06079],
  "Volla": [40.87951, 14.34632],
  "Volongo": [45.21155, 10.30251],
  "Volpago del Montello": [45.77745, 12.11866],
  "Volpara": [44.95379, 9.29748],
  "Volpedo": [44.8888, 8.98338],
  "Volpeglino": [44.89305, 8.95896],
  "Volpiano": [45.2019, 7.77555],
  "Volta Mantovana": [45.31958, 10.65949],
  "Voltaggio": [44.62013, 8.84266],
  "Voltago Agordino": [46.27198, 12.00493],
  "Volterra": [43.40171, 10.85941],
  "Voltido": [45.11176, 10.33339],
  "Volturara Appula": [41.49501, 15.05176],
  "Volturara Irpina": [40.87882, 14.91717],
  "Volturino": [41.47818, 15.12438],
  "Volvera": [44.95502, 7.5123],
  "Vottignasco": [44.56481, 7.57821],
  "Zaccanopoli": [38.6641, 15.93069],
  "Zafferana Etnea": [37.69471, 15.10338],
  "Zagarise": [38.99975, 16.6606],
  "Zagarolo": [41.83987, 12.82964],
  "Zambrone": [38.69878, 15.98982],
  "Zandobbio": [45.68654, 9.85241],
  "Zanica": [45.64196, 9.68097],
  "Zanè": [45.72061, 11.45408],
  "Zapponeta": [41.45582, 15.95523],
  "Zavattarello": [44.86874, 9.26544],
  "Zeccone": [45.26093, 9.19841],
  "Zeddiani": [39.98958, 8.59549],
  "Zelbio": [45.90503, 9.18089],
  "Zelo Buon Persico": [45.41161, 9.42923],
  "Zeme": [45.19493, 8.66631],
  "Zenevredo": [45.0539, 9.32664],
  "Zenson di Piave": [45.67824, 12.4926],
  "Zerba": [44.66562, 9.28771],
  "Zerbo": [45.11055, 9.39545],
  "Zerbolò": [45.20676, 9.01439],
  "Zerfaliu": [39.95802, 8.70755],
  "Zeri": [44.35292, 9.7635],
  "Zermeghedo": [45.47543, 11.36889],
  "Zero Branco": [45.59934, 12.16411],
  "Zevio": [45.37556, 11.13534],
  "Ziano di Fiemme": [46.28647, 11.56112],
  "Ziano Piacentino": [45.00223, 9.40264],
  "Zibido San Giacomo": [45.35966, 9.10588],
  "Zignago": [44.27754, 9.74496],
  "Zimella": [45.36352, 11.33921],
  "Zimone": [45.44945, 8.03735],
  "Zinasco": [45.12825, 9.0285],
  "Zoagli": [44.33703, 9.26724],
  "Zocca": [44.34506, 10.99528],
  "Zogno": [45.79482, 9.66792],
  "Zola Predosa": [44.49224, 11.21818],
  "Zollino": [40.20523, 18.25138],
  "Zone": [45.7622, 10.11661],
  "Zoppola": [45.96639, 12.7704],
  "Zoppè di Cadore": [46.38639, 12.17264],
  "Zovencedo": [45.428, 11.50266],
  "Zubiena": [45.49283, 7.99733],
  "Zuccarello": [44.11135, 8.11566],
  "Zugliano": [45.73361, 11.52143],
  "Zuglio": [46.46095, 13.02643],
  "Zumaglia": [45.59478, 8.0887],
  "Zumpano": [39.31063, 16.29351],
  "Zungoli": [41.12766, 15.20256],
  "Zungri": [38.65678, 15.98364],
};

// value/plain-name -> { p: provincia, s: sigla, r: regione }
export const COMUNE_INFO = {
  "Abano Terme": { p: "Padova", s: "PD", r: "Veneto" },
  "Abbadia Cerreto": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Abbadia Lariana": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Abbadia San Salvatore": { p: "Siena", s: "SI", r: "Toscana" },
  "Abbasanta": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Abbateggio": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Abbiategrasso": { p: "Milano", s: "MI", r: "Lombardia" },
  "Abetone Cutigliano": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Abriola": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Acate": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Accadia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Acceglio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Accettura": { p: "Matera", s: "MT", r: "Basilicata" },
  "Acciano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Accumoli": { p: "Rieti", s: "RI", r: "Lazio" },
  "Acerenza": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Acerno": { p: "Salerno", s: "SA", r: "Campania" },
  "Acerra": { p: "Napoli", s: "NA", r: "Campania" },
  "Aci Bonaccorsi": { p: "Catania", s: "CT", r: "Sicilia" },
  "Aci Castello": { p: "Catania", s: "CT", r: "Sicilia" },
  "Aci Catena": { p: "Catania", s: "CT", r: "Sicilia" },
  "Aci Sant'Antonio": { p: "Catania", s: "CT", r: "Sicilia" },
  "Acireale": { p: "Catania", s: "CT", r: "Sicilia" },
  "Acquafondata": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Acquaformosa": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Acquafredda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Acqualagna": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Acquanegra Cremonese": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Acquanegra sul Chiese": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Acquapendente": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Acquappesa": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Acquaro": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Acquasanta Terme": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Acquasparta": { p: "Terni", s: "TR", r: "Umbria" },
  "Acquaviva Collecroce": { p: "Campobasso", s: "CB", r: "Molise" },
  "Acquaviva d'Isernia": { p: "Isernia", s: "IS", r: "Molise" },
  "Acquaviva delle Fonti": { p: "Bari", s: "BA", r: "Puglia" },
  "Acquaviva Picena": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Acquaviva Platani": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Acquedolci": { p: "Messina", s: "ME", r: "Sicilia" },
  "Acqui Terme": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Acri": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Acuto": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Adelfia": { p: "Bari", s: "BA", r: "Puglia" },
  "Adrano": { p: "Catania", s: "CT", r: "Sicilia" },
  "Adrara San Martino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Adrara San Rocco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Adria": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Adro": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Affi": { p: "Verona", s: "VR", r: "Veneto" },
  "Affile": { p: "Roma", s: "RM", r: "Lazio" },
  "Afragola": { p: "Napoli", s: "NA", r: "Campania" },
  "Africo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Agazzano": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Agerola": { p: "Napoli", s: "NA", r: "Campania" },
  "Aggius": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Agira": { p: "Enna", s: "EN", r: "Sicilia" },
  "Agliana": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Agliano Terme": { p: "Asti", s: "AT", r: "Piemonte" },
  "Aglientu": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Agliè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Agna": { p: "Padova", s: "PD", r: "Veneto" },
  "Agnadello": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Agnana Calabra": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Agnone": { p: "Isernia", s: "IS", r: "Molise" },
  "Agnosine": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Agordo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Agosta": { p: "Roma", s: "RM", r: "Lazio" },
  "Agra": { p: "Varese", s: "VA", r: "Lombardia" },
  "Agrate Brianza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Agrate Conturbia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Agrigento": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Agropoli": { p: "Salerno", s: "SA", r: "Campania" },
  "Agugliano": { p: "Ancona", s: "AN", r: "Marche" },
  "Agugliaro": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Aicurzio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Aidomaggiore": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Aidone": { p: "Enna", s: "EN", r: "Sicilia" },
  "Aielli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Aiello Calabro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Aiello del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Aiello del Sabato": { p: "Avellino", s: "AV", r: "Campania" },
  "Aieta": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Ailano": { p: "Caserta", s: "CE", r: "Campania" },
  "Ailoche": { p: "Biella", s: "BI", r: "Piemonte" },
  "Airasca": { p: "Torino", s: "TO", r: "Piemonte" },
  "Airola": { p: "Benevento", s: "BN", r: "Campania" },
  "Airole": { p: "Imperia", s: "IM", r: "Liguria" },
  "Airuno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Aisone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ala": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ala di Stura": { p: "Torino", s: "TO", r: "Piemonte" },
  "Alagna": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Alagna Valsesia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Alanno": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Alano di Piave": { p: "Belluno", s: "BL", r: "Veneto" },
  "Alassio": { p: "Savona", s: "SV", r: "Liguria" },
  "Alatri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Alba Adriatica": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Albagiara": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Albairate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Albanella": { p: "Salerno", s: "SA", r: "Campania" },
  "Albano di Lucania": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Albano Laziale": { p: "Roma", s: "RM", r: "Lazio" },
  "Albano Sant'Alessandro": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Albano Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Albaredo Arnaboldi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Albaredo d'Adige": { p: "Verona", s: "VR", r: "Veneto" },
  "Albaredo per San Marco": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Albareto": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Albaretto della Torre": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Albavilla": { p: "Como", s: "CO", r: "Lombardia" },
  "Albenga": { p: "Savona", s: "SV", r: "Liguria" },
  "Albera Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Alberobello": { p: "Bari", s: "BA", r: "Puglia" },
  "Alberona": { p: "Foggia", s: "FG", r: "Puglia" },
  "Albese con Cassano": { p: "Como", s: "CO", r: "Lombardia" },
  "Albettone": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Albi": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Albiano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Albiano d'Ivrea": { p: "Torino", s: "TO", r: "Piemonte" },
  "Albiate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Albidona": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Albignasego": { p: "Padova", s: "PD", r: "Veneto" },
  "Albinea": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Albino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Albiolo": { p: "Como", s: "CO", r: "Lombardia" },
  "Albisola Superiore": { p: "Savona", s: "SV", r: "Liguria" },
  "Albissola Marina": { p: "Savona", s: "SV", r: "Liguria" },
  "Albizzate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Albonese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Albosaggia": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Albugnano": { p: "Asti", s: "AT", r: "Piemonte" },
  "Albuzzano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Alcamo": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Alcara li Fusi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Aldeno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Aldino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Ales": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Alessandria": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Alessandria del Carretto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Alessandria della Rocca": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Alessano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Alezio": { p: "Lecce", s: "LE", r: "Puglia" },
  "Alfano": { p: "Salerno", s: "SA", r: "Campania" },
  "Alfedena": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Alfianello": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Alfiano Natta": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Alfonsine": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Alghero": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Algua": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Alia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Aliano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Alice Bel Colle": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Alice Castello": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Alife": { p: "Caserta", s: "CE", r: "Campania" },
  "Alimena": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Aliminusa": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Allai": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Alleghe": { p: "Belluno", s: "BL", r: "Veneto" },
  "Allein": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Allerona": { p: "Terni", s: "TR", r: "Umbria" },
  "Alliste": { p: "Lecce", s: "LE", r: "Puglia" },
  "Allumiere": { p: "Roma", s: "RM", r: "Lazio" },
  "Alluvioni Piovera": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Almenno San Bartolomeo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Almenno San Salvatore": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Almese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Almè": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Alonte": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Alpago": { p: "Belluno", s: "BL", r: "Veneto" },
  "Alpette": { p: "Torino", s: "TO", r: "Piemonte" },
  "Alpignano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Alseno": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Alserio": { p: "Como", s: "CO", r: "Lombardia" },
  "Alta Val Tidone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Alta Valle Intelvi": { p: "Como", s: "CO", r: "Lombardia" },
  "Altamura": { p: "Bari", s: "BA", r: "Puglia" },
  "Altare": { p: "Savona", s: "SV", r: "Liguria" },
  "Altavalle": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Altavilla Irpina": { p: "Avellino", s: "AV", r: "Campania" },
  "Altavilla Milicia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Altavilla Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Altavilla Silentina": { p: "Salerno", s: "SA", r: "Campania" },
  "Altavilla Vicentina": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Altidona": { p: "Fermo", s: "FM", r: "Marche" },
  "Altilia": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Altino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Altissimo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Altivole": { p: "Treviso", s: "TV", r: "Veneto" },
  "Alto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Alto Reno Terme": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Alto Sermenza": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Altofonte": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Altomonte": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Altopascio": { p: "Lucca", s: "LU", r: "Toscana" },
  "Altopiano della Vigolana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Alviano": { p: "Terni", s: "TR", r: "Umbria" },
  "Alvignano": { p: "Caserta", s: "CE", r: "Campania" },
  "Alvito": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Alzano Lombardo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Alzano Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Alzate Brianza": { p: "Como", s: "CO", r: "Lombardia" },
  "Alà dei Sardi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Alì": { p: "Messina", s: "ME", r: "Sicilia" },
  "Alì Terme": { p: "Messina", s: "ME", r: "Sicilia" },
  "Amalfi": { p: "Salerno", s: "SA", r: "Campania" },
  "Amandola": { p: "Fermo", s: "FM", r: "Marche" },
  "Amantea": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Amaro": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Amaroni": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Amaseno": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Amato": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Amatrice": { p: "Rieti", s: "RI", r: "Lazio" },
  "Ambivere": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Amblar-Don": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ameglia": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Amelia": { p: "Terni", s: "TR", r: "Umbria" },
  "Amendolara": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Ameno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Amorosi": { p: "Benevento", s: "BN", r: "Campania" },
  "Ampezzo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Anacapri": { p: "Napoli", s: "NA", r: "Campania" },
  "Anagni": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Ancarano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Ancona": { p: "Ancona", s: "AN", r: "Marche" },
  "Andali": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Andalo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Andalo Valtellino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Andezeno": { p: "Torino", s: "TO", r: "Piemonte" },
  "Andora": { p: "Savona", s: "SV", r: "Liguria" },
  "Andorno Micca": { p: "Biella", s: "BI", r: "Piemonte" },
  "Andrano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Andrate": { p: "Torino", s: "TO", r: "Piemonte" },
  "Andreis": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Andretta": { p: "Avellino", s: "AV", r: "Campania" },
  "Andria": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Andriano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Anela": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Anfo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Angera": { p: "Varese", s: "VA", r: "Lombardia" },
  "Anghiari": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Angiari": { p: "Verona", s: "VR", r: "Veneto" },
  "Angolo Terme": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Angri": { p: "Salerno", s: "SA", r: "Campania" },
  "Angrogna": { p: "Torino", s: "TO", r: "Piemonte" },
  "Anguillara Sabazia": { p: "Roma", s: "RM", r: "Lazio" },
  "Anguillara Veneta": { p: "Padova", s: "PD", r: "Veneto" },
  "Annicco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Annone di Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Annone Veneto": { p: "Venezia", s: "VE", r: "Veneto" },
  "Anoia": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Antegnate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Anterivo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Antey-Saint-André": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Anticoli Corrado": { p: "Roma", s: "RM", r: "Lazio" },
  "Antignano": { p: "Asti", s: "AT", r: "Piemonte" },
  "Antillo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Antonimina": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Antrodoco": { p: "Rieti", s: "RI", r: "Lazio" },
  "Antrona Schieranco": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Anversa degli Abruzzi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Anzano del Parco": { p: "Como", s: "CO", r: "Lombardia" },
  "Anzano di Puglia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Anzi": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Anzio": { p: "Roma", s: "RM", r: "Lazio" },
  "Anzola d'Ossola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Anzola dell'Emilia": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Aosta": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Apecchio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Apice": { p: "Benevento", s: "BN", r: "Campania" },
  "Apiro": { p: "Macerata", s: "MC", r: "Marche" },
  "Apollosa": { p: "Benevento", s: "BN", r: "Campania" },
  "Appiano Gentile": { p: "Como", s: "CO", r: "Lombardia" },
  "Appiano sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Appignano": { p: "Macerata", s: "MC", r: "Marche" },
  "Appignano del Tronto": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Aprica": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Apricale": { p: "Imperia", s: "IM", r: "Liguria" },
  "Apricena": { p: "Foggia", s: "FG", r: "Puglia" },
  "Aprigliano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Aprilia": { p: "Latina", s: "LT", r: "Lazio" },
  "Aquara": { p: "Salerno", s: "SA", r: "Campania" },
  "Aquila d'Arroscia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Aquileia": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Aquilonia": { p: "Avellino", s: "AV", r: "Campania" },
  "Aquino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Aradeo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Aragona": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Aramengo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Arba": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Arborea": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Arborio": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Arbus": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Arcade": { p: "Treviso", s: "TV", r: "Veneto" },
  "Arce": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Arcene": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Arcevia": { p: "Ancona", s: "AN", r: "Marche" },
  "Archi": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Arcidosso": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Arcinazzo Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Arcisate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Arco": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Arcola": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Arcole": { p: "Verona", s: "VR", r: "Veneto" },
  "Arconate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Arcore": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Arcugnano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Ardara": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ardauli": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ardea": { p: "Roma", s: "RM", r: "Lazio" },
  "Ardenno": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Ardesio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ardore": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Arena": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Arena Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Arenzano": { p: "Genova", s: "GE", r: "Liguria" },
  "Arese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Arezzo": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Argegno": { p: "Como", s: "CO", r: "Lombardia" },
  "Argelato": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Argenta": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Argentera": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Arguello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Argusto": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Ari": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Ariano Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Ariano nel Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Ariccia": { p: "Roma", s: "RM", r: "Lazio" },
  "Arielli": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Arienzo": { p: "Caserta", s: "CE", r: "Campania" },
  "Arignano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Aritzo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Arizzano": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Arlena di Castro": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Arluno": { p: "Milano", s: "MI", r: "Lombardia" },
  "Armeno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Armento": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Armo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Armungia": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Arnad": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Arnara": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Arnasco": { p: "Savona", s: "SV", r: "Liguria" },
  "Arnesano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Arola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Arona": { p: "Novara", s: "NO", r: "Piemonte" },
  "Arosio": { p: "Como", s: "CO", r: "Lombardia" },
  "Arpaia": { p: "Benevento", s: "BN", r: "Campania" },
  "Arpaise": { p: "Benevento", s: "BN", r: "Campania" },
  "Arpino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Arquata del Tronto": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Arquata Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Arquà Petrarca": { p: "Padova", s: "PD", r: "Veneto" },
  "Arquà Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Arre": { p: "Padova", s: "PD", r: "Veneto" },
  "Arrone": { p: "Terni", s: "TR", r: "Umbria" },
  "Arsago Seprio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Arsiero": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Arsita": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Arsiè": { p: "Belluno", s: "BL", r: "Veneto" },
  "Arsoli": { p: "Roma", s: "RM", r: "Lazio" },
  "Arta Terme": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Artegna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Artena": { p: "Roma", s: "RM", r: "Lazio" },
  "Artogne": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Arvier": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Arzachena": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Arzago d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Arzana": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Arzano": { p: "Napoli", s: "NA", r: "Campania" },
  "Arzergrande": { p: "Padova", s: "PD", r: "Veneto" },
  "Arzignano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Ascea": { p: "Salerno", s: "SA", r: "Campania" },
  "Asciano": { p: "Siena", s: "SI", r: "Toscana" },
  "Ascoli Piceno": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Ascoli Satriano": { p: "Foggia", s: "FG", r: "Puglia" },
  "Ascrea": { p: "Rieti", s: "RI", r: "Lazio" },
  "Asiago": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Asigliano Veneto": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Asigliano Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Asola": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Asolo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Assago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Assemini": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Assisi": { p: "Perugia", s: "PG", r: "Umbria" },
  "Asso": { p: "Como", s: "CO", r: "Lombardia" },
  "Assolo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Assoro": { p: "Enna", s: "EN", r: "Sicilia" },
  "Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Asuni": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ateleta": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Atella": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Atena Lucana": { p: "Salerno", s: "SA", r: "Campania" },
  "Atessa": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Atina": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Atrani": { p: "Salerno", s: "SA", r: "Campania" },
  "Atri": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Atripalda": { p: "Avellino", s: "AV", r: "Campania" },
  "Attigliano": { p: "Terni", s: "TR", r: "Umbria" },
  "Attimis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Atzara": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Augusta": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Auletta": { p: "Salerno", s: "SA", r: "Campania" },
  "Aulla": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Aurano": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Aurigo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Auronzo di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Ausonia": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Austis": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Avegno": { p: "Genova", s: "GE", r: "Liguria" },
  "Avelengo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Avella": { p: "Avellino", s: "AV", r: "Campania" },
  "Avellino": { p: "Avellino", s: "AV", r: "Campania" },
  "Averara": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Aversa": { p: "Caserta", s: "CE", r: "Campania" },
  "Avetrana": { p: "Taranto", s: "TA", r: "Puglia" },
  "Avezzano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Aviano": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Aviatico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Avigliana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Avigliano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Avigliano Umbro": { p: "Terni", s: "TR", r: "Umbria" },
  "Avio": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Avise": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Avola": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Avolasca": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ayas": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Aymavilles": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Azeglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Azzanello": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Azzano d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Azzano Decimo": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Azzano Mella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Azzano San Paolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Azzate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Azzio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Azzone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Baceno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Bacoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Badalucco": { p: "Imperia", s: "IM", r: "Liguria" },
  "Badesi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Badia": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Badia Calavena": { p: "Verona", s: "VR", r: "Veneto" },
  "Badia Pavese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Badia Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Badia Tedalda": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Badolato": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Bagaladi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bagheria": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Bagnacavallo": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Bagnara Calabra": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bagnara di Romagna": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Bagnaria": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bagnaria Arsa": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bagnasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bagnatica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bagni di Lucca": { p: "Lucca", s: "LU", r: "Toscana" },
  "Bagno a Ripoli": { p: "Firenze", s: "FI", r: "Toscana" },
  "Bagno di Romagna": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Bagnoli del Trigno": { p: "Isernia", s: "IS", r: "Molise" },
  "Bagnoli di Sopra": { p: "Padova", s: "PD", r: "Veneto" },
  "Bagnoli Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Bagnolo Cremasco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Bagnolo del Salento": { p: "Lecce", s: "LE", r: "Puglia" },
  "Bagnolo di Po": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Bagnolo in Piano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Bagnolo Mella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bagnolo Piemonte": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bagnolo San Vito": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Bagnone": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Bagnoregio": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Bagolino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Baia e Latina": { p: "Caserta", s: "CE", r: "Campania" },
  "Baiano": { p: "Avellino", s: "AV", r: "Campania" },
  "Bairo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Baiso": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Bajardo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Balangero": { p: "Torino", s: "TO", r: "Piemonte" },
  "Baldichieri d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Baldissero Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Baldissero d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Baldissero Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Balestrate": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Balestrino": { p: "Savona", s: "SV", r: "Liguria" },
  "Ballabio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Ballao": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Balme": { p: "Torino", s: "TO", r: "Piemonte" },
  "Balmuccia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Balocco": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Balsorano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Balvano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Balzola": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Banari": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Banchette": { p: "Torino", s: "TO", r: "Piemonte" },
  "Bannio Anzino": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Banzi": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Baone": { p: "Padova", s: "PD", r: "Veneto" },
  "Baradili": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Baragiano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Baranello": { p: "Campobasso", s: "CB", r: "Molise" },
  "Barano d'Ischia": { p: "Napoli", s: "NA", r: "Campania" },
  "Baranzate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Barasso": { p: "Varese", s: "VA", r: "Lombardia" },
  "Baratili San Pietro": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Barbania": { p: "Torino", s: "TO", r: "Piemonte" },
  "Barbara": { p: "Ancona", s: "AN", r: "Marche" },
  "Barbarano Mossano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Barbarano Romano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Barbaresco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Barbariga": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Barbata": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Barberino di Mugello": { p: "Firenze", s: "FI", r: "Toscana" },
  "Barberino Tavarnelle": { p: "Firenze", s: "FI", r: "Toscana" },
  "Barbianello": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Barbiano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Barbona": { p: "Padova", s: "PD", r: "Veneto" },
  "Barcellona Pozzo di Gotto": { p: "Messina", s: "ME", r: "Sicilia" },
  "Barcis": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Bard": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Bardello": { p: "Varese", s: "VA", r: "Lombardia" },
  "Bardi": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Bardineto": { p: "Savona", s: "SV", r: "Liguria" },
  "Bardolino": { p: "Verona", s: "VR", r: "Veneto" },
  "Bardonecchia": { p: "Torino", s: "TO", r: "Piemonte" },
  "Bareggio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Barengo": { p: "Novara", s: "NO", r: "Piemonte" },
  "Baressa": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Barete": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Barga": { p: "Lucca", s: "LU", r: "Toscana" },
  "Bargagli": { p: "Genova", s: "GE", r: "Liguria" },
  "Barge": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Barghe": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bari": { p: "Bari", s: "BA", r: "Puglia" },
  "Bari Sardo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bariano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Baricella": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Barile": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Barisciano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Barlassina": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Barletta": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Barni": { p: "Como", s: "CO", r: "Lombardia" },
  "Barolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Barone Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Baronissi": { p: "Salerno", s: "SA", r: "Campania" },
  "Barrafranca": { p: "Enna", s: "EN", r: "Sicilia" },
  "Barrali": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Barrea": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Barumini": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Barzago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Barzana": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Barzanò": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Barzio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Basaluzzo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bascapè": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Baschi": { p: "Terni", s: "TR", r: "Umbria" },
  "Basciano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Baselga di Pinè": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Baselice": { p: "Benevento", s: "BN", r: "Campania" },
  "Basiano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Basicò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Basiglio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Basiliano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bassano Bresciano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bassano del Grappa": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Bassano in Teverina": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Bassano Romano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Bassiano": { p: "Latina", s: "LT", r: "Lazio" },
  "Bassignana": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bastia Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bastia Umbra": { p: "Perugia", s: "PG", r: "Umbria" },
  "Bastida Pancarana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bastiglia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Battaglia Terme": { p: "Padova", s: "PD", r: "Veneto" },
  "Battifollo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Battipaglia": { p: "Salerno", s: "SA", r: "Campania" },
  "Battuda": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Baucina": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Bauladu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Baunei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Baveno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Bedero Valcuvia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Bedizzole": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bedollo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Bedonia": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Bedulita": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bee": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Beinasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Beinette": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Belcastro": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Belfiore": { p: "Verona", s: "VR", r: "Veneto" },
  "Belforte all'Isauro": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Belforte del Chienti": { p: "Macerata", s: "MC", r: "Marche" },
  "Belforte Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Belgioioso": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Belgirate": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Bella": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Bellagio": { p: "Como", s: "CO", r: "Lombardia" },
  "Bellano": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Bellante": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Bellaria-Igea Marina": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Bellegra": { p: "Roma", s: "RM", r: "Lazio" },
  "Bellino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bellinzago Lombardo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Bellinzago Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Bellizzi": { p: "Salerno", s: "SA", r: "Campania" },
  "Bellona": { p: "Caserta", s: "CE", r: "Campania" },
  "Bellosguardo": { p: "Salerno", s: "SA", r: "Campania" },
  "Belluno": { p: "Belluno", s: "BL", r: "Veneto" },
  "Bellusco": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Belmonte Calabro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Belmonte Castello": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Belmonte del Sannio": { p: "Isernia", s: "IS", r: "Molise" },
  "Belmonte in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Belmonte Mezzagno": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Belmonte Piceno": { p: "Fermo", s: "FM", r: "Marche" },
  "Belpasso": { p: "Catania", s: "CT", r: "Sicilia" },
  "Belsito": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Belvedere di Spinello": { p: "Crotone", s: "KR", r: "Calabria" },
  "Belvedere Langhe": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Belvedere Marittimo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Belvedere Ostrense": { p: "Ancona", s: "AN", r: "Marche" },
  "Belveglio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Belvì": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bema": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Bene Lario": { p: "Como", s: "CO", r: "Lombardia" },
  "Bene Vagienna": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Benestare": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Benetutti": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Benevello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Benevento": { p: "Benevento", s: "BN", r: "Campania" },
  "Benna": { p: "Biella", s: "BI", r: "Piemonte" },
  "Bentivoglio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Berbenno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Berbenno di Valtellina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Berceto": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Berchidda": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Beregazzo con Figliaro": { p: "Como", s: "CO", r: "Lombardia" },
  "Bereguardo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bergamasco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bergamo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bergantino": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Bergeggi": { p: "Savona", s: "SV", r: "Liguria" },
  "Bergolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Berlingo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bernalda": { p: "Matera", s: "MT", r: "Basilicata" },
  "Bernareggio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Bernate Ticino": { p: "Milano", s: "MI", r: "Lombardia" },
  "Bernezzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bertinoro": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Bertiolo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bertonico": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Berzano di San Pietro": { p: "Asti", s: "AT", r: "Piemonte" },
  "Berzano di Tortona": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Berzo Demo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Berzo Inferiore": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Berzo San Fermo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Besana in Brianza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Besano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Besate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Besenello": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Besenzone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Besnate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Besozzo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Bessude": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bettola": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Bettona": { p: "Perugia", s: "PG", r: "Umbria" },
  "Beura-Cardezza": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Bevagna": { p: "Perugia", s: "PG", r: "Umbria" },
  "Beverino": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Bevilacqua": { p: "Verona", s: "VR", r: "Veneto" },
  "Biancavilla": { p: "Catania", s: "CT", r: "Sicilia" },
  "Bianchi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Bianco": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Biandrate": { p: "Novara", s: "NO", r: "Piemonte" },
  "Biandronno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Bianzano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bianzone": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Bianzè": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Biassono": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Bibbiano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Bibbiena": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Bibbona": { p: "Livorno", s: "LI", r: "Toscana" },
  "Bibiana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Biccari": { p: "Foggia", s: "FG", r: "Puglia" },
  "Bicinicco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bidonì": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Biella": { p: "Biella", s: "BI", r: "Piemonte" },
  "Bienno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bieno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Bientina": { p: "Pisa", s: "PI", r: "Toscana" },
  "Binago": { p: "Como", s: "CO", r: "Lombardia" },
  "Binasco": { p: "Milano", s: "MI", r: "Lombardia" },
  "Binetto": { p: "Bari", s: "BA", r: "Puglia" },
  "Bioglio": { p: "Biella", s: "BI", r: "Piemonte" },
  "Bionaz": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Bione": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Birori": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bisaccia": { p: "Avellino", s: "AV", r: "Campania" },
  "Bisacquino": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Bisceglie": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Bisegna": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Bisenti": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Bisignano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Bistagno": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bisuschio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Bitetto": { p: "Bari", s: "BA", r: "Puglia" },
  "Bitonto": { p: "Bari", s: "BA", r: "Puglia" },
  "Bitritto": { p: "Bari", s: "BA", r: "Puglia" },
  "Bitti": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bivona": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Bivongi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bizzarone": { p: "Como", s: "CO", r: "Lombardia" },
  "Bleggio Superiore": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Blello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Blera": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Blessagno": { p: "Como", s: "CO", r: "Lombardia" },
  "Blevio": { p: "Como", s: "CO", r: "Lombardia" },
  "Blufi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Boara Pisani": { p: "Padova", s: "PD", r: "Veneto" },
  "Bobbio": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Bobbio Pellice": { p: "Torino", s: "TO", r: "Piemonte" },
  "Boca": { p: "Novara", s: "NO", r: "Piemonte" },
  "Bocchigliero": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Boccioleto": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Bocenago": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Bodio Lomnago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Boffalora d'Adda": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Boffalora sopra Ticino": { p: "Milano", s: "MI", r: "Lombardia" },
  "Bogliasco": { p: "Genova", s: "GE", r: "Liguria" },
  "Bognanco": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Bogogno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Boissano": { p: "Savona", s: "SV", r: "Liguria" },
  "Bojano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Bolano": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Bolgare": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bollate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Bollengo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Bologna": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Bolognano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Bolognetta": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Bolognola": { p: "Macerata", s: "MC", r: "Marche" },
  "Bolotana": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bolsena": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Boltiere": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bolzano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Bolzano Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Bolzano Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Bomarzo": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Bomba": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Bompensiere": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Bompietro": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Bomporto": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Bonarcado": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Bonassola": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Bonate Sopra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bonate Sotto": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bonavigo": { p: "Verona", s: "VR", r: "Veneto" },
  "Bondeno": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Bondone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Bonea": { p: "Benevento", s: "BN", r: "Campania" },
  "Bonefro": { p: "Campobasso", s: "CB", r: "Molise" },
  "Bonemerse": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Bonifati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Bonito": { p: "Avellino", s: "AV", r: "Campania" },
  "Bonnanaro": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bono": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bonorva": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bonvicino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Borbona": { p: "Rieti", s: "RI", r: "Lazio" },
  "Borca di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Bordano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bordighera": { p: "Imperia", s: "IM", r: "Liguria" },
  "Bordolano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Bore": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Boretto": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Borgarello": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Borgaro Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Borgetto": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Borghetto d'Arroscia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Borghetto di Borbera": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Borghetto di Vara": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Borghetto Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Borghetto Santo Spirito": { p: "Savona", s: "SV", r: "Liguria" },
  "Borghi": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Borgia": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Borgiallo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Borgio Verezzi": { p: "Savona", s: "SV", r: "Liguria" },
  "Borgo a Mozzano": { p: "Lucca", s: "LU", r: "Toscana" },
  "Borgo Chiese": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Borgo d'Ale": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Borgo d'Anaunia": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Borgo di Terzo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Borgo Lares": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Borgo Mantovano": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Borgo Pace": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Borgo Priolo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Borgo San Dalmazzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Borgo San Giacomo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Borgo San Giovanni": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Borgo San Lorenzo": { p: "Firenze", s: "FI", r: "Toscana" },
  "Borgo San Martino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Borgo San Siro": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Borgo Ticino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Borgo Tossignano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Borgo Val di Taro": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Borgo Valbelluna": { p: "Belluno", s: "BL", r: "Veneto" },
  "Borgo Valsugana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Borgo Velino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Borgo Veneto": { p: "Padova", s: "PD", r: "Veneto" },
  "Borgo Vercelli": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Borgo Virgilio": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Borgocarbonara": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Borgofranco d'Ivrea": { p: "Torino", s: "TO", r: "Piemonte" },
  "Borgolavezzaro": { p: "Novara", s: "NO", r: "Piemonte" },
  "Borgomale": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Borgomanero": { p: "Novara", s: "NO", r: "Piemonte" },
  "Borgomaro": { p: "Imperia", s: "IM", r: "Liguria" },
  "Borgomasino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Borgomezzavalle": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Borgone Susa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Borgonovo Val Tidone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Borgoratto Alessandrino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Borgoratto Mormorolo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Borgoricco": { p: "Padova", s: "PD", r: "Veneto" },
  "Borgorose": { p: "Rieti", s: "RI", r: "Lazio" },
  "Borgosatollo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Borgosesia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Bormida": { p: "Savona", s: "SV", r: "Liguria" },
  "Bormio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Bornasco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Borno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Boroneddu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Borore": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Borrello": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Borriana": { p: "Biella", s: "BI", r: "Piemonte" },
  "Borso del Grappa": { p: "Treviso", s: "TV", r: "Veneto" },
  "Bortigali": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Bortigiadas": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Borutta": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Borzonasca": { p: "Genova", s: "GE", r: "Liguria" },
  "Bosa": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Bosaro": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Boschi Sant'Anna": { p: "Verona", s: "VR", r: "Veneto" },
  "Bosco Chiesanuova": { p: "Verona", s: "VR", r: "Veneto" },
  "Bosco Marengo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bosconero": { p: "Torino", s: "TO", r: "Piemonte" },
  "Boscoreale": { p: "Napoli", s: "NA", r: "Campania" },
  "Boscotrecase": { p: "Napoli", s: "NA", r: "Campania" },
  "Bosia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bosio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bosisio Parini": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Bosnasco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bossico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bossolasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Botricello": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Botrugno": { p: "Lecce", s: "LE", r: "Puglia" },
  "Bottanuco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Botticino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bottidda": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bova": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bova Marina": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bovalino": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bovegno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Boves": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bovezzo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Boville Ernica": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Bovino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Bovisio-Masciago": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Bovolenta": { p: "Padova", s: "PD", r: "Veneto" },
  "Bovolone": { p: "Verona", s: "VR", r: "Veneto" },
  "Bozzole": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Bozzolo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Bra": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Bracca": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Bracciano": { p: "Roma", s: "RM", r: "Lazio" },
  "Bracigliano": { p: "Salerno", s: "SA", r: "Campania" },
  "Braies": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Brallo di Pregola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Brancaleone": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Brandico": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Brandizzo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Branzi": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Braone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Brebbia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Breda di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Bregano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Breganze": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Bregnano": { p: "Como", s: "CO", r: "Lombardia" },
  "Brembate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Brembate di Sopra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Brembio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Breme": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Brendola": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Brenna": { p: "Como", s: "CO", r: "Lombardia" },
  "Brennero": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Breno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Brenta": { p: "Varese", s: "VA", r: "Lombardia" },
  "Brentino Belluno": { p: "Verona", s: "VR", r: "Veneto" },
  "Brentonico": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Brenzone sul Garda": { p: "Verona", s: "VR", r: "Veneto" },
  "Brescello": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Brescia": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Bresimo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Bressana Bottarone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bressanone": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Bressanvido": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Bresso": { p: "Milano", s: "MI", r: "Lombardia" },
  "Brezzo di Bedero": { p: "Varese", s: "VA", r: "Lombardia" },
  "Briaglia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Briatico": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Bricherasio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Brienno": { p: "Como", s: "CO", r: "Lombardia" },
  "Brienza": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Briga Alta": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Briga Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Brignano Gera d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Brignano-Frascata": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Brindisi": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Brindisi Montagna": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Brinzio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Briona": { p: "Novara", s: "NO", r: "Piemonte" },
  "Brione": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Briosco": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Brisighella": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Brissago-Valtravaglia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Brissogne": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Brittoli": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Brivio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Broccostella": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Brogliano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Brognaturo": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Brolo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Brondello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Broni": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Bronte": { p: "Catania", s: "CT", r: "Sicilia" },
  "Bronzolo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Brossasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Brosso": { p: "Torino", s: "TO", r: "Piemonte" },
  "Brovello-Carpugnino": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Brozolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Brugherio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Brugine": { p: "Padova", s: "PD", r: "Veneto" },
  "Brugnato": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Brugnera": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Bruino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Brumano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Brunate": { p: "Como", s: "CO", r: "Lombardia" },
  "Brunello": { p: "Varese", s: "VA", r: "Lombardia" },
  "Brunico": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Bruno": { p: "Asti", s: "AT", r: "Piemonte" },
  "Brusaporto": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Brusasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Brusciano": { p: "Napoli", s: "NA", r: "Campania" },
  "Brusimpiano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Brusnengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Brusson": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Bruzolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Bruzzano Zeffirio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Bubbiano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Bubbio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Buccheri": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Bucchianico": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Bucciano": { p: "Benevento", s: "BN", r: "Campania" },
  "Buccinasco": { p: "Milano", s: "MI", r: "Lombardia" },
  "Buccino": { p: "Salerno", s: "SA", r: "Campania" },
  "Bucine": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Buddusò": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Budoia": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Budoni": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Budrio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Buggerru": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Buggiano": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Buglio in Monte": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Bugnara": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Buguggiate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Buja": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Bulciago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Bulgarograsso": { p: "Como", s: "CO", r: "Lombardia" },
  "Bultei": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Bulzi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Buonabitacolo": { p: "Salerno", s: "SA", r: "Campania" },
  "Buonalbergo": { p: "Benevento", s: "BN", r: "Campania" },
  "Buonconvento": { p: "Siena", s: "SI", r: "Toscana" },
  "Buonvicino": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Burago di Molgora": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Burcei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Burgio": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Burgos": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Buriasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Burolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Buronzo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Busachi": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Busalla": { p: "Genova", s: "GE", r: "Liguria" },
  "Busano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Busca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Buscate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Buscemi": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Buseto Palizzolo": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Busnago": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Bussero": { p: "Milano", s: "MI", r: "Lombardia" },
  "Busseto": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Bussi sul Tirino": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Busso": { p: "Campobasso", s: "CB", r: "Molise" },
  "Bussolengo": { p: "Verona", s: "VR", r: "Veneto" },
  "Bussoleno": { p: "Torino", s: "TO", r: "Piemonte" },
  "Busto Arsizio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Busto Garolfo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Butera": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Buti": { p: "Pisa", s: "PI", r: "Toscana" },
  "Buttapietra": { p: "Verona", s: "VR", r: "Veneto" },
  "Buttigliera Alta": { p: "Torino", s: "TO", r: "Piemonte" },
  "Buttigliera d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Buttrio": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cabella Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cabiate": { p: "Como", s: "CO", r: "Lombardia" },
  "Cabras": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Caccamo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Caccuri": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cadegliano-Viconago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cadelbosco di Sopra": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Cadeo": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Caderzone Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cadoneghe": { p: "Padova", s: "PD", r: "Veneto" },
  "Cadorago": { p: "Como", s: "CO", r: "Lombardia" },
  "Cadrezzate con Osmate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Caerano di San Marco": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cafasse": { p: "Torino", s: "TO", r: "Piemonte" },
  "Caggiano": { p: "Salerno", s: "SA", r: "Campania" },
  "Cagli": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Cagliari": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Caglio": { p: "Como", s: "CO", r: "Lombardia" },
  "Cagnano Amiterno": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cagnano Varano": { p: "Foggia", s: "FG", r: "Puglia" },
  "Caianello": { p: "Caserta", s: "CE", r: "Campania" },
  "Caiazzo": { p: "Caserta", s: "CE", r: "Campania" },
  "Caines": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Caino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Caiolo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cairano": { p: "Avellino", s: "AV", r: "Campania" },
  "Cairate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cairo Montenotte": { p: "Savona", s: "SV", r: "Liguria" },
  "Caivano": { p: "Napoli", s: "NA", r: "Campania" },
  "Calabritto": { p: "Avellino", s: "AV", r: "Campania" },
  "Calalzo di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Calamandrana": { p: "Asti", s: "AT", r: "Piemonte" },
  "Calamonaci": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Calangianus": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Calanna": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Calasca-Castiglione": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Calascibetta": { p: "Enna", s: "EN", r: "Sicilia" },
  "Calascio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Calasetta": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Calatabiano": { p: "Catania", s: "CT", r: "Sicilia" },
  "Calatafimi-Segesta": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Calcata": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Calceranica al Lago": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Calci": { p: "Pisa", s: "PI", r: "Toscana" },
  "Calciano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Calcinaia": { p: "Pisa", s: "PI", r: "Toscana" },
  "Calcinate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Calcinato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Calcio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Calco": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Caldaro sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Caldarola": { p: "Macerata", s: "MC", r: "Marche" },
  "Calderara di Reno": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Caldes": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Caldiero": { p: "Verona", s: "VR", r: "Veneto" },
  "Caldogno": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Caldonazzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Calendasco": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Calenzano": { p: "Firenze", s: "FI", r: "Toscana" },
  "Calestano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Calice al Cornoviglio": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Calice Ligure": { p: "Savona", s: "SV", r: "Liguria" },
  "Calimera": { p: "Lecce", s: "LE", r: "Puglia" },
  "Calitri": { p: "Avellino", s: "AV", r: "Campania" },
  "Calizzano": { p: "Savona", s: "SV", r: "Liguria" },
  "Callabiana": { p: "Biella", s: "BI", r: "Piemonte" },
  "Calliano": { p: "Asti", s: "AT", r: "Piemonte" },
  "Calliano (AT)": { p: "Asti", s: "AT", r: "Piemonte" },
  "Calliano (TN)": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Calolziocorte": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Calopezzati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Calosso": { p: "Asti", s: "AT", r: "Piemonte" },
  "Caloveto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Caltabellotta": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Caltagirone": { p: "Catania", s: "CT", r: "Sicilia" },
  "Caltanissetta": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Caltavuturo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Caltignaga": { p: "Novara", s: "NO", r: "Piemonte" },
  "Calto": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Caltrano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Calusco d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Caluso": { p: "Torino", s: "TO", r: "Piemonte" },
  "Calvagese della Riviera": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Calvanico": { p: "Salerno", s: "SA", r: "Campania" },
  "Calvatone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Calvello": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Calvene": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Calvenzano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Calvera": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Calvi": { p: "Benevento", s: "BN", r: "Campania" },
  "Calvi dell'Umbria": { p: "Terni", s: "TR", r: "Umbria" },
  "Calvi Risorta": { p: "Caserta", s: "CE", r: "Campania" },
  "Calvignano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Calvignasco": { p: "Milano", s: "MI", r: "Lombardia" },
  "Calvisano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Calvizzano": { p: "Napoli", s: "NA", r: "Campania" },
  "Camagna Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Camaiore": { p: "Lucca", s: "LU", r: "Toscana" },
  "Camandona": { p: "Biella", s: "BI", r: "Piemonte" },
  "Camastra": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Cambiago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cambiano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cambiasca": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Camburzano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Camerana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Camerano": { p: "Ancona", s: "AN", r: "Marche" },
  "Camerano Casasco": { p: "Asti", s: "AT", r: "Piemonte" },
  "Camerata Cornello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Camerata Nuova": { p: "Roma", s: "RM", r: "Lazio" },
  "Camerata Picena": { p: "Ancona", s: "AN", r: "Marche" },
  "Cameri": { p: "Novara", s: "NO", r: "Piemonte" },
  "Camerino": { p: "Macerata", s: "MC", r: "Marche" },
  "Camerota": { p: "Salerno", s: "SA", r: "Campania" },
  "Camigliano": { p: "Caserta", s: "CE", r: "Campania" },
  "Camini": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Camino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Camino al Tagliamento": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Camisano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Camisano Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Cammarata": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Camogli": { p: "Genova", s: "GE", r: "Liguria" },
  "Campagna": { p: "Salerno", s: "SA", r: "Campania" },
  "Campagna Lupia": { p: "Venezia", s: "VE", r: "Veneto" },
  "Campagnano di Roma": { p: "Roma", s: "RM", r: "Lazio" },
  "Campagnatico": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Campagnola Cremasca": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Campagnola Emilia": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Campana": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Camparada": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Campegine": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Campello sul Clitunno": { p: "Perugia", s: "PG", r: "Umbria" },
  "Campertogno": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Campi Bisenzio": { p: "Firenze", s: "FI", r: "Toscana" },
  "Campi Salentina": { p: "Lecce", s: "LE", r: "Puglia" },
  "Campiglia Cervo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Campiglia dei Berici": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Campiglia Marittima": { p: "Livorno", s: "LI", r: "Toscana" },
  "Campiglione Fenile": { p: "Torino", s: "TO", r: "Piemonte" },
  "Campione d'Italia": { p: "Como", s: "CO", r: "Lombardia" },
  "Campitello di Fassa": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Campli": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Campo Calabro": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Campo di Giove": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Campo di Trens": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Campo Ligure": { p: "Genova", s: "GE", r: "Liguria" },
  "Campo nell'Elba": { p: "Livorno", s: "LI", r: "Toscana" },
  "Campo San Martino": { p: "Padova", s: "PD", r: "Veneto" },
  "Campo Tures": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Campobasso": { p: "Campobasso", s: "CB", r: "Molise" },
  "Campobello di Licata": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Campobello di Mazara": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Campochiaro": { p: "Campobasso", s: "CB", r: "Molise" },
  "Campodarsego": { p: "Padova", s: "PD", r: "Veneto" },
  "Campodenno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Campodimele": { p: "Latina", s: "LT", r: "Lazio" },
  "Campodipietra": { p: "Campobasso", s: "CB", r: "Molise" },
  "Campodolcino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Campodoro": { p: "Padova", s: "PD", r: "Veneto" },
  "Campofelice di Fitalia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Campofelice di Roccella": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Campofilone": { p: "Fermo", s: "FM", r: "Marche" },
  "Campofiorito": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Campoformido": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Campofranco": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Campogalliano": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Campolattaro": { p: "Benevento", s: "BN", r: "Campania" },
  "Campoli Appennino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Campoli del Monte Taburno": { p: "Benevento", s: "BN", r: "Campania" },
  "Campolieto": { p: "Campobasso", s: "CB", r: "Molise" },
  "Campolongo Maggiore": { p: "Venezia", s: "VE", r: "Veneto" },
  "Campolongo Tapogliano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Campomaggiore": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Campomarino": { p: "Campobasso", s: "CB", r: "Molise" },
  "Campomorone": { p: "Genova", s: "GE", r: "Liguria" },
  "Camponogara": { p: "Venezia", s: "VE", r: "Veneto" },
  "Campora": { p: "Salerno", s: "SA", r: "Campania" },
  "Camporeale": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Camporgiano": { p: "Lucca", s: "LU", r: "Toscana" },
  "Camporosso": { p: "Imperia", s: "IM", r: "Liguria" },
  "Camporotondo di Fiastrone": { p: "Macerata", s: "MC", r: "Marche" },
  "Camporotondo Etneo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Camposampiero": { p: "Padova", s: "PD", r: "Veneto" },
  "Camposano": { p: "Napoli", s: "NA", r: "Campania" },
  "Camposanto": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Campospinoso": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Campotosto": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Camugnano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Canal San Bovo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Canale": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Canale d'Agordo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Canale Monterano": { p: "Roma", s: "RM", r: "Lazio" },
  "Canaro": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Canazei": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cancellara": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Cancello ed Arnone": { p: "Caserta", s: "CE", r: "Campania" },
  "Canda": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Candela": { p: "Foggia", s: "FG", r: "Puglia" },
  "Candelo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Candia Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Candia Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Candiana": { p: "Padova", s: "PD", r: "Veneto" },
  "Candida": { p: "Avellino", s: "AV", r: "Campania" },
  "Candidoni": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Candiolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Canegrate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Canelli": { p: "Asti", s: "AT", r: "Piemonte" },
  "Canepina": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Caneva": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Canicattini Bagni": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Canicattì": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Canino": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Canischio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Canistro": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Canna": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cannalonga": { p: "Salerno", s: "SA", r: "Campania" },
  "Cannara": { p: "Perugia", s: "PG", r: "Umbria" },
  "Cannero Riviera": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Canneto Pavese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Canneto sull'Oglio": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Cannobio": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Cannole": { p: "Lecce", s: "LE", r: "Puglia" },
  "Canolo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Canonica d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Canosa di Puglia": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Canosa Sannita": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Canosio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Canossa": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Cansano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cantagallo": { p: "Prato", s: "PO", r: "Toscana" },
  "Cantalice": { p: "Rieti", s: "RI", r: "Lazio" },
  "Cantalupa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cantalupo in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Cantalupo Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cantalupo nel Sannio": { p: "Isernia", s: "IS", r: "Molise" },
  "Cantarana": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cantello": { p: "Varese", s: "VA", r: "Lombardia" },
  "Canterano": { p: "Roma", s: "RM", r: "Lazio" },
  "Cantiano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Cantoira": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cantù": { p: "Como", s: "CO", r: "Lombardia" },
  "Canzano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Canzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Caorle": { p: "Venezia", s: "VE", r: "Veneto" },
  "Caorso": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Capaccio Paestum": { p: "Salerno", s: "SA", r: "Campania" },
  "Capaci": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Capalbio": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Capannoli": { p: "Pisa", s: "PI", r: "Toscana" },
  "Capannori": { p: "Lucca", s: "LU", r: "Toscana" },
  "Capena": { p: "Roma", s: "RM", r: "Lazio" },
  "Capergnanica": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Capestrano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Capiago Intimiano": { p: "Como", s: "CO", r: "Lombardia" },
  "Capistrano": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Capistrello": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Capitignano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Capizzi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Capizzone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Capo d'Orlando": { p: "Messina", s: "ME", r: "Sicilia" },
  "Capo di Ponte": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Capodimonte": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Capodrise": { p: "Caserta", s: "CE", r: "Campania" },
  "Capoliveri": { p: "Livorno", s: "LI", r: "Toscana" },
  "Capolona": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Caponago": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Caporciano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Caposele": { p: "Avellino", s: "AV", r: "Campania" },
  "Capoterra": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Capovalle": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cappadocia": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cappella Cantone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cappella de' Picenardi": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cappella Maggiore": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cappelle sul Tavo": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Capracotta": { p: "Isernia", s: "IS", r: "Molise" },
  "Capraia e Limite": { p: "Firenze", s: "FI", r: "Toscana" },
  "Capraia Isola": { p: "Livorno", s: "LI", r: "Toscana" },
  "Capralba": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Capranica": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Capranica Prenestina": { p: "Roma", s: "RM", r: "Lazio" },
  "Caprarica di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "Caprarola": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Caprauna": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Caprese Michelangelo": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Caprezzo": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Capri": { p: "Napoli", s: "NA", r: "Campania" },
  "Capri Leone": { p: "Messina", s: "ME", r: "Sicilia" },
  "Capriana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Capriano del Colle": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Capriata d'Orba": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Capriate San Gervasio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Capriati a Volturno": { p: "Caserta", s: "CE", r: "Campania" },
  "Caprie": { p: "Torino", s: "TO", r: "Piemonte" },
  "Capriglia Irpina": { p: "Avellino", s: "AV", r: "Campania" },
  "Capriglio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Caprile": { p: "Biella", s: "BI", r: "Piemonte" },
  "Caprino Bergamasco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Caprino Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Capriolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Capriva del Friuli": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Capua": { p: "Caserta", s: "CE", r: "Campania" },
  "Capurso": { p: "Bari", s: "BA", r: "Puglia" },
  "Caraffa del Bianco": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Caraffa di Catanzaro": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Caraglio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Caramagna Piemonte": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Caramanico Terme": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Carapelle": { p: "Foggia", s: "FG", r: "Puglia" },
  "Carapelle Calvisio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Carasco": { p: "Genova", s: "GE", r: "Liguria" },
  "Carassai": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Carate Brianza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Carate Urio": { p: "Como", s: "CO", r: "Lombardia" },
  "Caravaggio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Caravate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Caravino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Caravonica": { p: "Imperia", s: "IM", r: "Liguria" },
  "Carbognano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Carbonara al Ticino": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Carbonara di Nola": { p: "Napoli", s: "NA", r: "Campania" },
  "Carbonara Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Carbonate": { p: "Como", s: "CO", r: "Lombardia" },
  "Carbone": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Carbonera": { p: "Treviso", s: "TV", r: "Veneto" },
  "Carbonia": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Carcare": { p: "Savona", s: "SV", r: "Liguria" },
  "Carceri": { p: "Padova", s: "PD", r: "Veneto" },
  "Carcoforo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cardano al Campo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cardedu": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Cardeto": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cardinale": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Cardito": { p: "Napoli", s: "NA", r: "Campania" },
  "Cardè": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Careggine": { p: "Lucca", s: "LU", r: "Toscana" },
  "Carema": { p: "Torino", s: "TO", r: "Piemonte" },
  "Carenno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Carentino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Careri": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Caresana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Caresanablot": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Carezzano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Carfizzi": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cargeghe": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Cariati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Carife": { p: "Avellino", s: "AV", r: "Campania" },
  "Carignano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Carimate": { p: "Como", s: "CO", r: "Lombardia" },
  "Carinaro": { p: "Caserta", s: "CE", r: "Campania" },
  "Carini": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Carinola": { p: "Caserta", s: "CE", r: "Campania" },
  "Carisio": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Carisolo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Carlantino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Carlazzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Carlentini": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Carlino": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Carloforte": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Carlopoli": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Carmagnola": { p: "Torino", s: "TO", r: "Piemonte" },
  "Carmiano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Carmignano": { p: "Prato", s: "PO", r: "Toscana" },
  "Carmignano di Brenta": { p: "Padova", s: "PD", r: "Veneto" },
  "Carnago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Carnate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Carobbio degli Angeli": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Carolei": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Carona": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Caronia": { p: "Messina", s: "ME", r: "Sicilia" },
  "Caronno Pertusella": { p: "Varese", s: "VA", r: "Lombardia" },
  "Caronno Varesino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Carosino": { p: "Taranto", s: "TA", r: "Puglia" },
  "Carovigno": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Carovilli": { p: "Isernia", s: "IS", r: "Molise" },
  "Carpaneto Piacentino": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Carpanzano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Carpegna": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Carpenedolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Carpeneto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Carpi": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Carpiano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Carpignano Salentino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Carpignano Sesia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Carpineti": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Carpineto della Nora": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Carpineto Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Carpineto Sinello": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Carpino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Carpinone": { p: "Isernia", s: "IS", r: "Molise" },
  "Carrara": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Carrega Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Carro": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Carrodano": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Carrosio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Carrè": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Carrù": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Carsoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cartigliano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Cartignano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cartoceto": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Cartosio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cartura": { p: "Padova", s: "PD", r: "Veneto" },
  "Carugate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Carugo": { p: "Como", s: "CO", r: "Lombardia" },
  "Carunchio": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Carvico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Carzano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Casabona": { p: "Crotone", s: "KR", r: "Calabria" },
  "Casacalenda": { p: "Campobasso", s: "CB", r: "Molise" },
  "Casacanditella": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Casagiove": { p: "Caserta", s: "CE", r: "Campania" },
  "Casal Cermelli": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casal di Principe": { p: "Caserta", s: "CE", r: "Campania" },
  "Casal Velino": { p: "Salerno", s: "SA", r: "Campania" },
  "Casalanguida": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Casalattico": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Casalbeltrame": { p: "Novara", s: "NO", r: "Piemonte" },
  "Casalbordino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Casalbore": { p: "Avellino", s: "AV", r: "Campania" },
  "Casalborgone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Casalbuono": { p: "Salerno", s: "SA", r: "Campania" },
  "Casalbuttano ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casalciprano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Casalduni": { p: "Benevento", s: "BN", r: "Campania" },
  "Casale Corte Cerro": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Casale Cremasco-Vidolasco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casale di Scodosia": { p: "Padova", s: "PD", r: "Veneto" },
  "Casale Litta": { p: "Varese", s: "VA", r: "Lombardia" },
  "Casale Marittimo": { p: "Pisa", s: "PI", r: "Toscana" },
  "Casale Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casale sul Sile": { p: "Treviso", s: "TV", r: "Veneto" },
  "Casalecchio di Reno": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Casaleggio Boiro": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casaleggio Novara": { p: "Novara", s: "NO", r: "Piemonte" },
  "Casaleone": { p: "Verona", s: "VR", r: "Veneto" },
  "Casaletto Ceredano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casaletto di Sopra": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casaletto Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Casaletto Spartano": { p: "Salerno", s: "SA", r: "Campania" },
  "Casaletto Vaprio": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casalfiumanese": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Casalgrande": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Casalgrasso": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Casali del Manco": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Casalincontrada": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Casalino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Casalmaggiore": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casalmaiocco": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Casalmorano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Casalmoro": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Casalnoceto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casalnuovo di Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Casalnuovo Monterotaro": { p: "Foggia", s: "FG", r: "Puglia" },
  "Casaloldo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Casalpusterlengo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Casalromano": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Casalserugo": { p: "Padova", s: "PD", r: "Veneto" },
  "Casaluce": { p: "Caserta", s: "CE", r: "Campania" },
  "Casalvecchio di Puglia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Casalvecchio Siculo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Casalvieri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Casalvolone": { p: "Novara", s: "NO", r: "Piemonte" },
  "Casalzuigno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Casamarciano": { p: "Napoli", s: "NA", r: "Campania" },
  "Casamassima": { p: "Bari", s: "BA", r: "Puglia" },
  "Casamicciola Terme": { p: "Napoli", s: "NA", r: "Campania" },
  "Casandrino": { p: "Napoli", s: "NA", r: "Campania" },
  "Casanova Elvo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Casanova Lerrone": { p: "Savona", s: "SV", r: "Liguria" },
  "Casanova Lonati": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Casape": { p: "Roma", s: "RM", r: "Lazio" },
  "Casapesenna": { p: "Caserta", s: "CE", r: "Campania" },
  "Casapinta": { p: "Biella", s: "BI", r: "Piemonte" },
  "Casaprota": { p: "Rieti", s: "RI", r: "Lazio" },
  "Casapulla": { p: "Caserta", s: "CE", r: "Campania" },
  "Casarano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Casargo": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Casarile": { p: "Milano", s: "MI", r: "Lombardia" },
  "Casarsa della Delizia": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Casarza Ligure": { p: "Genova", s: "GE", r: "Liguria" },
  "Casasco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casatenovo": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Casatisma": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Casavatore": { p: "Napoli", s: "NA", r: "Campania" },
  "Casazza": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cascia": { p: "Perugia", s: "PG", r: "Umbria" },
  "Casciago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Casciana Terme Lari": { p: "Pisa", s: "PI", r: "Toscana" },
  "Cascina": { p: "Pisa", s: "PI", r: "Toscana" },
  "Cascinette d'Ivrea": { p: "Torino", s: "TO", r: "Piemonte" },
  "Casei Gerola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Caselette": { p: "Torino", s: "TO", r: "Piemonte" },
  "Casella": { p: "Genova", s: "GE", r: "Liguria" },
  "Caselle in Pittari": { p: "Salerno", s: "SA", r: "Campania" },
  "Caselle Landi": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Caselle Lurani": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Caselle Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Caserta": { p: "Caserta", s: "CE", r: "Campania" },
  "Casier": { p: "Treviso", s: "TV", r: "Veneto" },
  "Casignana": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Casina": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Casirate d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Caslino d'Erba": { p: "Como", s: "CO", r: "Lombardia" },
  "Casnate con Bernate": { p: "Como", s: "CO", r: "Lombardia" },
  "Casnigo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Casola di Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Casola in Lunigiana": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Casola Valsenio": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Casole d'Elsa": { p: "Siena", s: "SI", r: "Toscana" },
  "Casoli": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Casorate Primo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Casorate Sempione": { p: "Varese", s: "VA", r: "Lombardia" },
  "Casorezzo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Casoria": { p: "Napoli", s: "NA", r: "Campania" },
  "Casorzo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Casperia": { p: "Rieti", s: "RI", r: "Lazio" },
  "Caspoggio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cassacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cassago Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cassano all'Ionio": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cassano d'Adda": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cassano delle Murge": { p: "Bari", s: "BA", r: "Puglia" },
  "Cassano Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Cassano Magnago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cassano Spinola": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cassano Valcuvia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cassaro": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Cassiglio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cassina de' Pecchi": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cassina Rizzardi": { p: "Como", s: "CO", r: "Lombardia" },
  "Cassina Valsassina": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cassinasco": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cassine": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cassinelle": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cassinetta di Lugagnano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cassino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Cassola": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Cassolnovo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castagnaro": { p: "Verona", s: "VR", r: "Veneto" },
  "Castagneto Carducci": { p: "Livorno", s: "LI", r: "Toscana" },
  "Castagneto Po": { p: "Torino", s: "TO", r: "Piemonte" },
  "Castagnito": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castagnole delle Lanze": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castagnole Monferrato": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castagnole Piemonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Castana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castano Primo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Casteggio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castegnato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castegnero": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Castel Baronia": { p: "Avellino", s: "AV", r: "Campania" },
  "Castel Boglione": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castel Bolognese": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Castel Campagnano": { p: "Caserta", s: "CE", r: "Campania" },
  "Castel Castagna": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Castel Condino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Castel d'Aiano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel d'Ario": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Castel d'Azzano": { p: "Verona", s: "VR", r: "Veneto" },
  "Castel del Giudice": { p: "Isernia", s: "IS", r: "Molise" },
  "Castel del Monte": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castel del Piano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Castel del Rio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel di Casio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel di Ieri": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castel di Iudica": { p: "Catania", s: "CT", r: "Sicilia" },
  "Castel di Lama": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Castel di Lucio": { p: "Messina", s: "ME", r: "Sicilia" },
  "Castel di Sangro": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castel di Sasso": { p: "Caserta", s: "CE", r: "Campania" },
  "Castel di Tora": { p: "Rieti", s: "RI", r: "Lazio" },
  "Castel Focognano": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Castel Frentano": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Castel Gabbiano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Castel Gandolfo": { p: "Roma", s: "RM", r: "Lazio" },
  "Castel Giorgio": { p: "Terni", s: "TR", r: "Umbria" },
  "Castel Goffredo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Castel Guelfo di Bologna": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel Ivano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Castel Madama": { p: "Roma", s: "RM", r: "Lazio" },
  "Castel Maggiore": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel Mella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castel Morrone": { p: "Caserta", s: "CE", r: "Campania" },
  "Castel Ritaldi": { p: "Perugia", s: "PG", r: "Umbria" },
  "Castel Rocchero": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castel Rozzone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Castel San Giorgio": { p: "Salerno", s: "SA", r: "Campania" },
  "Castel San Giovanni": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Castel San Lorenzo": { p: "Salerno", s: "SA", r: "Campania" },
  "Castel San Niccolò": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Castel San Pietro Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Castel San Pietro Terme": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castel San Vincenzo": { p: "Isernia", s: "IS", r: "Molise" },
  "Castel Sant'Angelo": { p: "Rieti", s: "RI", r: "Lazio" },
  "Castel Sant'Elia": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Castel Viscardo": { p: "Terni", s: "TR", r: "Umbria" },
  "Castel Vittorio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Castel Volturno": { p: "Caserta", s: "CE", r: "Campania" },
  "Castelbaldo": { p: "Padova", s: "PD", r: "Veneto" },
  "Castelbelforte": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Castelbellino": { p: "Ancona", s: "AN", r: "Marche" },
  "Castelbello-Ciardes": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Castelbianco": { p: "Savona", s: "SV", r: "Liguria" },
  "Castelbottaccio": { p: "Campobasso", s: "CB", r: "Molise" },
  "Castelbuono": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Castelcivita": { p: "Salerno", s: "SA", r: "Campania" },
  "Castelcovati": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castelcucco": { p: "Treviso", s: "TV", r: "Veneto" },
  "Casteldaccia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Casteldelci": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Casteldelfino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Casteldidone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Castelfidardo": { p: "Ancona", s: "AN", r: "Marche" },
  "Castelfiorentino": { p: "Firenze", s: "FI", r: "Toscana" },
  "Castelforte": { p: "Latina", s: "LT", r: "Lazio" },
  "Castelfranci": { p: "Avellino", s: "AV", r: "Campania" },
  "Castelfranco di Sotto": { p: "Pisa", s: "PI", r: "Toscana" },
  "Castelfranco Emilia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Castelfranco in Miscano": { p: "Benevento", s: "BN", r: "Campania" },
  "Castelfranco Piandiscò": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Castelfranco Veneto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Castelgerundo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Castelgomberto": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Castelgrande": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castelguglielmo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Castelguidone": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Castell'Alfero": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castell'Arquato": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Castell'Azzara": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Castell'Umberto": { p: "Messina", s: "ME", r: "Sicilia" },
  "Castellabate": { p: "Salerno", s: "SA", r: "Campania" },
  "Castellafiume": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castellalto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Castellammare del Golfo": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Castellammare di Stabia": { p: "Napoli", s: "NA", r: "Campania" },
  "Castellamonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Castellana Grotte": { p: "Bari", s: "BA", r: "Puglia" },
  "Castellana Sicula": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Castellaneta": { p: "Taranto", s: "TA", r: "Puglia" },
  "Castellania Coppi": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castellanza": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castellar Guidobono": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castellarano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Castellaro": { p: "Imperia", s: "IM", r: "Liguria" },
  "Castellazzo Bormida": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castellazzo Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Castelleone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Castelleone di Suasa": { p: "Ancona", s: "AN", r: "Marche" },
  "Castellero": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castelletto Cervo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Castelletto d'Erro": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelletto d'Orba": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelletto di Branduzzo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castelletto Merli": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelletto Molina": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castelletto Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelletto sopra Ticino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Castelletto Stura": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castelletto Uzzone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castelli": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Castelli Calepio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Castellina in Chianti": { p: "Siena", s: "SI", r: "Toscana" },
  "Castellina Marittima": { p: "Pisa", s: "PI", r: "Toscana" },
  "Castellinaldo d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castellino del Biferno": { p: "Campobasso", s: "CB", r: "Molise" },
  "Castellino Tanaro": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castelliri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Castello Cabiaglio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castello d'Agogna": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castello d'Argile": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castello del Matese": { p: "Caserta", s: "CE", r: "Campania" },
  "Castello dell'Acqua": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Castello di Annone": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castello di Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Castello di Cisterna": { p: "Napoli", s: "NA", r: "Campania" },
  "Castello di Godego": { p: "Treviso", s: "TV", r: "Veneto" },
  "Castello Tesino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Castello-Molina di Fiemme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Castellucchio": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Castelluccio dei Sauri": { p: "Foggia", s: "FG", r: "Puglia" },
  "Castelluccio Inferiore": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castelluccio Superiore": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castelluccio Valmaggiore": { p: "Foggia", s: "FG", r: "Puglia" },
  "Castelmagno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castelmarte": { p: "Como", s: "CO", r: "Lombardia" },
  "Castelmassa": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Castelmauro": { p: "Campobasso", s: "CB", r: "Molise" },
  "Castelmezzano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castelmola": { p: "Messina", s: "ME", r: "Sicilia" },
  "Castelnovetto": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Castelnovo Bariano": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Castelnovo del Friuli": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Castelnovo di Sotto": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Castelnovo ne' Monti": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Castelnuovo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Castelnuovo Belbo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castelnuovo Berardenga": { p: "Siena", s: "SI", r: "Toscana" },
  "Castelnuovo Bocca d'Adda": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Castelnuovo Bormida": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelnuovo Bozzente": { p: "Como", s: "CO", r: "Lombardia" },
  "Castelnuovo Calcea": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castelnuovo Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Castelnuovo del Garda": { p: "Verona", s: "VR", r: "Veneto" },
  "Castelnuovo della Daunia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Castelnuovo di Ceva": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castelnuovo di Conza": { p: "Salerno", s: "SA", r: "Campania" },
  "Castelnuovo di Farfa": { p: "Rieti", s: "RI", r: "Lazio" },
  "Castelnuovo di Garfagnana": { p: "Lucca", s: "LU", r: "Toscana" },
  "Castelnuovo di Porto": { p: "Roma", s: "RM", r: "Lazio" },
  "Castelnuovo di Val di Cecina": { p: "Pisa", s: "PI", r: "Toscana" },
  "Castelnuovo Don Bosco": { p: "Asti", s: "AT", r: "Piemonte" },
  "Castelnuovo Magra": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Castelnuovo Nigra": { p: "Torino", s: "TO", r: "Piemonte" },
  "Castelnuovo Parano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Castelnuovo Rangone": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Castelnuovo Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Castelpagano": { p: "Benevento", s: "BN", r: "Campania" },
  "Castelpetroso": { p: "Isernia", s: "IS", r: "Molise" },
  "Castelpizzuto": { p: "Isernia", s: "IS", r: "Molise" },
  "Castelplanio": { p: "Ancona", s: "AN", r: "Marche" },
  "Castelpoto": { p: "Benevento", s: "BN", r: "Campania" },
  "Castelraimondo": { p: "Macerata", s: "MC", r: "Marche" },
  "Castelrotto": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Castelsantangelo sul Nera": { p: "Macerata", s: "MC", r: "Marche" },
  "Castelsaraceno": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castelsardo": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Castelseprio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castelsilano": { p: "Crotone", s: "KR", r: "Calabria" },
  "Castelspina": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Casteltermini": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Castelveccana": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castelvecchio Calvisio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castelvecchio di Rocca Barbena": { p: "Savona", s: "SV", r: "Liguria" },
  "Castelvecchio Subequo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Castelvenere": { p: "Benevento", s: "BN", r: "Campania" },
  "Castelverde": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Castelverrino": { p: "Isernia", s: "IS", r: "Molise" },
  "Castelvetere in Val Fortore": { p: "Benevento", s: "BN", r: "Campania" },
  "Castelvetere sul Calore": { p: "Avellino", s: "AV", r: "Campania" },
  "Castelvetrano": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Castelvetro di Modena": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Castelvetro Piacentino": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Castelvisconti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Castenaso": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castenedolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castiadas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Castiglion Fibocchi": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Castiglion Fiorentino": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Castiglione a Casauria": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Castiglione Chiavarese": { p: "Genova", s: "GE", r: "Liguria" },
  "Castiglione Cosentino": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Castiglione d'Adda": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Castiglione d'Orcia": { p: "Siena", s: "SI", r: "Toscana" },
  "Castiglione dei Pepoli": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Castiglione del Genovesi": { p: "Salerno", s: "SA", r: "Campania" },
  "Castiglione del Lago": { p: "Perugia", s: "PG", r: "Umbria" },
  "Castiglione della Pescaia": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Castiglione delle Stiviere": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Castiglione di Garfagnana": { p: "Lucca", s: "LU", r: "Toscana" },
  "Castiglione di Sicilia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Castiglione Falletto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castiglione in Teverina": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Castiglione Messer Marino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Castiglione Messer Raimondo": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Castiglione Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castiglione Tinella": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castiglione Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Castignano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Castilenti": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Castino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Castione Andevenno": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Castione della Presolana": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Castions di Strada": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Castiraga Vidardo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Casto": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castorano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Castrezzato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Castri di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "Castrignano de' Greci": { p: "Lecce", s: "LE", r: "Puglia" },
  "Castrignano del Capo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Castro": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Castro (BG)": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Castro (LE)": { p: "Lecce", s: "LE", r: "Puglia" },
  "Castro dei Volsci": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Castrocaro Terme e Terra del Sole": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Castrocielo": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Castrofilippo": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Castrolibero": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Castronno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Castronovo di Sicilia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Castronuovo di Sant'Andrea": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Castropignano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Castroreale": { p: "Messina", s: "ME", r: "Sicilia" },
  "Castroregio": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Castrovillari": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Catania": { p: "Catania", s: "CT", r: "Sicilia" },
  "Catanzaro": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Catenanuova": { p: "Enna", s: "EN", r: "Sicilia" },
  "Catignano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Cattolica": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Cattolica Eraclea": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Caulonia": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cautano": { p: "Benevento", s: "BN", r: "Campania" },
  "Cava de' Tirreni": { p: "Salerno", s: "SA", r: "Campania" },
  "Cava Manara": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cavaglietto": { p: "Novara", s: "NO", r: "Piemonte" },
  "Cavaglio d'Agogna": { p: "Novara", s: "NO", r: "Piemonte" },
  "Cavaglià": { p: "Biella", s: "BI", r: "Piemonte" },
  "Cavagnolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cavaion Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Cavalese": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cavallerleone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cavallermaggiore": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cavallino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Cavallino-Treporti": { p: "Venezia", s: "VE", r: "Veneto" },
  "Cavallirio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Cavareno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cavargna": { p: "Como", s: "CO", r: "Lombardia" },
  "Cavaria con Premezzo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cavarzere": { p: "Venezia", s: "VE", r: "Veneto" },
  "Cavaso del Tomba": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cavasso Nuovo": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Cavatore": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cavazzo Carnico": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cave": { p: "Roma", s: "RM", r: "Lazio" },
  "Cavedago": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cavedine": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cavenago d'Adda": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Cavenago di Brianza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Cavernago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cavezzo": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Cavizzana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cavour": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cavriago": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Cavriana": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Cavriglia": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Cazzago Brabbia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cazzago San Martino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cazzano di Tramigna": { p: "Verona", s: "VR", r: "Veneto" },
  "Cazzano Sant'Andrea": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ceccano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Cecima": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cecina": { p: "Livorno", s: "LI", r: "Toscana" },
  "Cedegolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cedrasco": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cefalà Diana": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Cefalù": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Ceggia": { p: "Venezia", s: "VE", r: "Veneto" },
  "Ceglie Messapica": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Celano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Celenza sul Trigno": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Celenza Valfortore": { p: "Foggia", s: "FG", r: "Puglia" },
  "Celico": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cella Dati": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cella Monte": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cellamare": { p: "Bari", s: "BA", r: "Puglia" },
  "Cellara": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cellarengo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cellatica": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Celle di Bulgheria": { p: "Salerno", s: "SA", r: "Campania" },
  "Celle di Macra": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Celle di San Vito": { p: "Foggia", s: "FG", r: "Puglia" },
  "Celle Enomondo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Celle Ligure": { p: "Savona", s: "SV", r: "Liguria" },
  "Celleno": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Cellere": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Cellino Attanasio": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Cellino San Marco": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Cellio con Breia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cellole": { p: "Caserta", s: "CE", r: "Campania" },
  "Cembra Lisignago": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cenadi": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Cenate Sopra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cenate Sotto": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cencenighe Agordino": { p: "Belluno", s: "BL", r: "Veneto" },
  "Cene": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ceneselli": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Cengio": { p: "Savona", s: "SV", r: "Liguria" },
  "Centallo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cento": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Centola": { p: "Salerno", s: "SA", r: "Campania" },
  "Centrache": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Centro Valle Intelvi": { p: "Como", s: "CO", r: "Lombardia" },
  "Centuripe": { p: "Enna", s: "EN", r: "Sicilia" },
  "Cepagatti": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Ceppaloni": { p: "Benevento", s: "BN", r: "Campania" },
  "Ceppo Morelli": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Ceprano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Cerami": { p: "Enna", s: "EN", r: "Sicilia" },
  "Ceranesi": { p: "Genova", s: "GE", r: "Liguria" },
  "Cerano": { p: "Novara", s: "NO", r: "Piemonte" },
  "Cerano d'Intelvi": { p: "Como", s: "CO", r: "Lombardia" },
  "Ceranova": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Ceraso": { p: "Salerno", s: "SA", r: "Campania" },
  "Cercemaggiore": { p: "Campobasso", s: "CB", r: "Molise" },
  "Cercenasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cercepiccola": { p: "Campobasso", s: "CB", r: "Molise" },
  "Cerchiara di Calabria": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cerchio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cercino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cercivento": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cercola": { p: "Napoli", s: "NA", r: "Campania" },
  "Cerda": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Cerea": { p: "Verona", s: "VR", r: "Veneto" },
  "Ceregnano": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Cerenzia": { p: "Crotone", s: "KR", r: "Calabria" },
  "Ceres": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ceresara": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Cereseto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ceresole Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ceresole Reale": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cerete": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ceretto Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cergnago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Ceriale": { p: "Savona", s: "SV", r: "Liguria" },
  "Ceriana": { p: "Imperia", s: "IM", r: "Liguria" },
  "Ceriano Laghetto": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Cerignale": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Cerignola": { p: "Foggia", s: "FG", r: "Puglia" },
  "Cerisano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cermenate": { p: "Como", s: "CO", r: "Lombardia" },
  "Cermes": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Cermignano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Cernobbio": { p: "Como", s: "CO", r: "Lombardia" },
  "Cernusco Lombardone": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cernusco sul Naviglio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cerreto d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cerreto d'Esi": { p: "Ancona", s: "AN", r: "Marche" },
  "Cerreto di Spoleto": { p: "Perugia", s: "PG", r: "Umbria" },
  "Cerreto Grue": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cerreto Guidi": { p: "Firenze", s: "FI", r: "Toscana" },
  "Cerreto Laziale": { p: "Roma", s: "RM", r: "Lazio" },
  "Cerreto Sannita": { p: "Benevento", s: "BN", r: "Campania" },
  "Cerretto Langhe": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cerrina Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cerrione": { p: "Biella", s: "BI", r: "Piemonte" },
  "Cerro al Lambro": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cerro al Volturno": { p: "Isernia", s: "IS", r: "Molise" },
  "Cerro Maggiore": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cerro Tanaro": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cerro Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Cersosimo": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Certaldo": { p: "Firenze", s: "FI", r: "Toscana" },
  "Certosa di Pavia": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cerva": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Cervara di Roma": { p: "Roma", s: "RM", r: "Lazio" },
  "Cervarese Santa Croce": { p: "Padova", s: "PD", r: "Veneto" },
  "Cervaro": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Cervasca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cervatto": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cerveno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cervere": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cervesina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cerveteri": { p: "Roma", s: "RM", r: "Lazio" },
  "Cervia": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Cervicati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cervignano d'Adda": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Cervignano del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cervinara": { p: "Avellino", s: "AV", r: "Campania" },
  "Cervino": { p: "Caserta", s: "CE", r: "Campania" },
  "Cervo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Cerzeto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cesa": { p: "Caserta", s: "CE", r: "Campania" },
  "Cesana Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cesana Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cesano Boscone": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cesano Maderno": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Cesara": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Cesarò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Cesate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cesena": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Cesenatico": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Cesinali": { p: "Avellino", s: "AV", r: "Campania" },
  "Cesio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Cesiomaggiore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Cessalto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cessaniti": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Cessapalombo": { p: "Macerata", s: "MC", r: "Marche" },
  "Cessole": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cetara": { p: "Salerno", s: "SA", r: "Campania" },
  "Ceto": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cetona": { p: "Siena", s: "SI", r: "Toscana" },
  "Cetraro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Ceva": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cevo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Challand-Saint-Anselme": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Challand-Saint-Victor": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Chambave": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Chamois": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Champdepraz": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Champorcher": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Charvensod": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Cherasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cheremule": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Chialamberto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chiampo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Chianche": { p: "Avellino", s: "AV", r: "Campania" },
  "Chianciano Terme": { p: "Siena", s: "SI", r: "Toscana" },
  "Chianni": { p: "Pisa", s: "PI", r: "Toscana" },
  "Chianocco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chiaramonte Gulfi": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Chiaramonti": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Chiarano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Chiaravalle": { p: "Ancona", s: "AN", r: "Marche" },
  "Chiaravalle Centrale": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Chiari": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Chiaromonte": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Chiauci": { p: "Isernia", s: "IS", r: "Molise" },
  "Chiavari": { p: "Genova", s: "GE", r: "Liguria" },
  "Chiavenna": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Chiaverano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chienes": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Chieri": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chies d'Alpago": { p: "Belluno", s: "BL", r: "Veneto" },
  "Chiesa in Valmalenco": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Chiesanuova": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chiesina Uzzanese": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Chieti": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Chieuti": { p: "Foggia", s: "FG", r: "Puglia" },
  "Chieve": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Chignolo d'Isola": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Chignolo Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Chioggia": { p: "Venezia", s: "VE", r: "Veneto" },
  "Chiomonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chions": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Chiopris-Viscone": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Chitignano": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Chiuduno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Chiuppano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Chiuro": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Chiusa": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Chiusa di Pesio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Chiusa di San Michele": { p: "Torino", s: "TO", r: "Piemonte" },
  "Chiusa Sclafani": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Chiusaforte": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Chiusanico": { p: "Imperia", s: "IM", r: "Liguria" },
  "Chiusano d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Chiusano di San Domenico": { p: "Avellino", s: "AV", r: "Campania" },
  "Chiusavecchia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Chiusdino": { p: "Siena", s: "SI", r: "Toscana" },
  "Chiusi": { p: "Siena", s: "SI", r: "Toscana" },
  "Chiusi della Verna": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Chivasso": { p: "Torino", s: "TO", r: "Piemonte" },
  "Châtillon": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Ciampino": { p: "Roma", s: "RM", r: "Lazio" },
  "Cianciana": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Cibiana di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Cicagna": { p: "Genova", s: "GE", r: "Liguria" },
  "Cicala": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Cicciano": { p: "Napoli", s: "NA", r: "Campania" },
  "Cicerale": { p: "Salerno", s: "SA", r: "Campania" },
  "Ciciliano": { p: "Roma", s: "RM", r: "Lazio" },
  "Cicognolo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ciconio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cigliano": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cigliè": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cigognola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cigole": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cilavegna": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cimadolmo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cimbergo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ciminna": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Ciminà": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cimitile": { p: "Napoli", s: "NA", r: "Campania" },
  "Cimolais": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Cimone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cinaglio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cineto Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Cingia de' Botti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cingoli": { p: "Macerata", s: "MC", r: "Marche" },
  "Cinigiano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Cinisello Balsamo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cinisi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Cino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cinquefrondi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cintano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cinte Tesino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cinto Caomaggiore": { p: "Venezia", s: "VE", r: "Veneto" },
  "Cinto Euganeo": { p: "Padova", s: "PD", r: "Veneto" },
  "Cinzano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ciorlano": { p: "Caserta", s: "CE", r: "Campania" },
  "Cipressa": { p: "Imperia", s: "IM", r: "Liguria" },
  "Circello": { p: "Benevento", s: "BN", r: "Campania" },
  "Cirigliano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Cirimido": { p: "Como", s: "CO", r: "Lombardia" },
  "Ciriè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cirò": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cirò Marina": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cis": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cisano Bergamasco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cisano sul Neva": { p: "Savona", s: "SV", r: "Liguria" },
  "Ciserano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cislago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cisliano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cison di Valmarino": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cissone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cisterna d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cisterna di Latina": { p: "Latina", s: "LT", r: "Lazio" },
  "Cisternino": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Citerna": { p: "Perugia", s: "PG", r: "Umbria" },
  "Cittadella": { p: "Padova", s: "PD", r: "Veneto" },
  "Cittaducale": { p: "Rieti", s: "RI", r: "Lazio" },
  "Cittanova": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cittareale": { p: "Rieti", s: "RI", r: "Lazio" },
  "Cittiglio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Città della Pieve": { p: "Perugia", s: "PG", r: "Umbria" },
  "Città di Castello": { p: "Perugia", s: "PG", r: "Umbria" },
  "Città Sant'Angelo": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Civate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Civezza": { p: "Imperia", s: "IM", r: "Liguria" },
  "Civezzano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Civiasco": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cividale del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cividate al Piano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cividate Camuno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Civita": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Civita Castellana": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Civita d'Antino": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Civitacampomarano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Civitaluparella": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Civitanova del Sannio": { p: "Isernia", s: "IS", r: "Molise" },
  "Civitanova Marche": { p: "Macerata", s: "MC", r: "Marche" },
  "Civitaquana": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Civitavecchia": { p: "Roma", s: "RM", r: "Lazio" },
  "Civitella Alfedena": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Civitella Casanova": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Civitella d'Agliano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Civitella del Tronto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Civitella di Romagna": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Civitella in Val di Chiana": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Civitella Messer Raimondo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Civitella Paganico": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Civitella Roveto": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Civitella San Paolo": { p: "Roma", s: "RM", r: "Lazio" },
  "Civo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Claino con Osteno": { p: "Como", s: "CO", r: "Lombardia" },
  "Claut": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Clauzetto": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Clavesana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Claviere": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cles": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Cleto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Clivio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Clusone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Coassolo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Coazze": { p: "Torino", s: "TO", r: "Piemonte" },
  "Coazzolo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Coccaglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cocconato": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cocquio-Trevisago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cocullo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Codevigo": { p: "Padova", s: "PD", r: "Veneto" },
  "Codevilla": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Codigoro": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Codogno": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Codognè": { p: "Treviso", s: "TV", r: "Veneto" },
  "Codroipo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Codrongianos": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Coggiola": { p: "Biella", s: "BI", r: "Piemonte" },
  "Cogliate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Cogne": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Cogoleto": { p: "Genova", s: "GE", r: "Liguria" },
  "Cogollo del Cengio": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Cogorno": { p: "Genova", s: "GE", r: "Liguria" },
  "Colazza": { p: "Novara", s: "NO", r: "Piemonte" },
  "Colceresa": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Colere": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Colfelice": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Coli": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Colico": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Collalto Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Collarmele": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Collazzone": { p: "Perugia", s: "PG", r: "Umbria" },
  "Colle Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Colle d'Anchise": { p: "Campobasso", s: "CB", r: "Molise" },
  "Colle di Tora": { p: "Rieti", s: "RI", r: "Lazio" },
  "Colle di Val d'Elsa": { p: "Siena", s: "SI", r: "Toscana" },
  "Colle San Magno": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Colle Sannita": { p: "Benevento", s: "BN", r: "Campania" },
  "Colle Santa Lucia": { p: "Belluno", s: "BL", r: "Veneto" },
  "Colle Umberto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Collebeato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Collecchio": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Collecorvino": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Colledara": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Colledimacine": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Colledimezzo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Colleferro": { p: "Roma", s: "RM", r: "Lazio" },
  "Collegiove": { p: "Rieti", s: "RI", r: "Lazio" },
  "Collegno": { p: "Torino", s: "TO", r: "Piemonte" },
  "Collelongo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Collepardo": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Collepasso": { p: "Lecce", s: "LE", r: "Puglia" },
  "Collepietro": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Colleretto Castelnuovo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Colleretto Giacosa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Collesalvetti": { p: "Livorno", s: "LI", r: "Toscana" },
  "Collesano": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Colletorto": { p: "Campobasso", s: "CB", r: "Molise" },
  "Collevecchio": { p: "Rieti", s: "RI", r: "Lazio" },
  "Colli a Volturno": { p: "Isernia", s: "IS", r: "Molise" },
  "Colli al Metauro": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Colli del Tronto": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Colli sul Velino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Colli Verdi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Colliano": { p: "Salerno", s: "SA", r: "Campania" },
  "Collinas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Collio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Collobiano": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Colloredo di Monte Albano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Colmurano": { p: "Macerata", s: "MC", r: "Marche" },
  "Colobraro": { p: "Matera", s: "MT", r: "Basilicata" },
  "Cologna Veneta": { p: "Verona", s: "VR", r: "Veneto" },
  "Cologne": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cologno al Serio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cologno Monzese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Colognola ai Colli": { p: "Verona", s: "VR", r: "Veneto" },
  "Colonna": { p: "Roma", s: "RM", r: "Lazio" },
  "Colonnella": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Colonno": { p: "Como", s: "CO", r: "Lombardia" },
  "Colorina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Colorno": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Colosimi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Colturano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Colverde": { p: "Como", s: "CO", r: "Lombardia" },
  "Colzate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Comabbio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Comacchio": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Comano": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Comano Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Comazzo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Comeglians": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Comelico Superiore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Comerio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Comezzano-Cizzago": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Comignago": { p: "Novara", s: "NO", r: "Piemonte" },
  "Comiso": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Comitini": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Comiziano": { p: "Napoli", s: "NA", r: "Campania" },
  "Commessaggio": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Commezzadura": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Como": { p: "Como", s: "CO", r: "Lombardia" },
  "Compiano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Comun Nuovo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Comunanza": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Cona": { p: "Venezia", s: "VE", r: "Veneto" },
  "Conca Casale": { p: "Isernia", s: "IS", r: "Molise" },
  "Conca dei Marini": { p: "Salerno", s: "SA", r: "Campania" },
  "Conca della Campania": { p: "Caserta", s: "CE", r: "Campania" },
  "Concamarise": { p: "Verona", s: "VR", r: "Veneto" },
  "Concerviano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Concesio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Concordia Sagittaria": { p: "Venezia", s: "VE", r: "Veneto" },
  "Concordia sulla Secchia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Concorezzo": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Condofuri": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Condove": { p: "Torino", s: "TO", r: "Piemonte" },
  "Condrò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Conegliano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Confienza": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Configni": { p: "Rieti", s: "RI", r: "Lazio" },
  "Conflenti": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Coniolo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Conselice": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Conselve": { p: "Padova", s: "PD", r: "Veneto" },
  "Contessa Entellina": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Contigliano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Contrada": { p: "Avellino", s: "AV", r: "Campania" },
  "Controguerra": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Controne": { p: "Salerno", s: "SA", r: "Campania" },
  "Contursi Terme": { p: "Salerno", s: "SA", r: "Campania" },
  "Contà": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Conversano": { p: "Bari", s: "BA", r: "Puglia" },
  "Conza della Campania": { p: "Avellino", s: "AV", r: "Campania" },
  "Conzano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Copertino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Copiano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Copparo": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Corana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Corato": { p: "Bari", s: "BA", r: "Puglia" },
  "Corbara": { p: "Salerno", s: "SA", r: "Campania" },
  "Corbetta": { p: "Milano", s: "MI", r: "Lombardia" },
  "Corbola": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Corchiano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Corciano": { p: "Perugia", s: "PG", r: "Umbria" },
  "Cordenons": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Cordignano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Cordovado": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Coreglia Antelminelli": { p: "Lucca", s: "LU", r: "Toscana" },
  "Coreglia Ligure": { p: "Genova", s: "GE", r: "Liguria" },
  "Coreno Ausonio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Corfinio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Cori": { p: "Latina", s: "LT", r: "Lazio" },
  "Coriano": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Corigliano d'Otranto": { p: "Lecce", s: "LE", r: "Puglia" },
  "Corigliano-Rossano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Corinaldo": { p: "Ancona", s: "AN", r: "Marche" },
  "Corio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Corleone": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Corleto Monforte": { p: "Salerno", s: "SA", r: "Campania" },
  "Corleto Perticara": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Cormano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cormons": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Corna Imagna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cornalba": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cornale e Bastida": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cornaredo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cornate d'Adda": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Cornedo all'Isarco": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Cornedo Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Cornegliano Laudense": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Corneliano d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Corniglio": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Corno di Rosazzo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Corno Giovine": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Cornovecchio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Cornuda": { p: "Treviso", s: "TV", r: "Veneto" },
  "Correggio": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Correzzana": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Correzzola": { p: "Padova", s: "PD", r: "Veneto" },
  "Corrido": { p: "Como", s: "CO", r: "Lombardia" },
  "Corridonia": { p: "Macerata", s: "MC", r: "Marche" },
  "Corropoli": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Corsano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Corsico": { p: "Milano", s: "MI", r: "Lombardia" },
  "Corsione": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cortaccia sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Cortale": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Cortandone": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cortanze": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cortazzone": { p: "Asti", s: "AT", r: "Piemonte" },
  "Corte Brugnatella": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Corte de' Cortesi con Cignone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Corte de' Frati": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Corte Franca": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Corte Palasio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Cortemaggiore": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Cortemilia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Corteno Golgi": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Cortenova": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cortenuova": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Corteolona e Genzone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Cortiglione": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cortina d'Ampezzo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Cortina sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Cortino": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Cortona": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Corvara": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Corvara in Badia": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Corvino San Quirico": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Corzano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Coseano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Cosenza": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cosio d'Arroscia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Cosio Valtellino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Cosoleto": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Cossano Belbo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cossano Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cossato": { p: "Biella", s: "BI", r: "Piemonte" },
  "Cosseria": { p: "Savona", s: "SV", r: "Liguria" },
  "Cossignano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Cossogno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Cossoine": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Cossombrato": { p: "Asti", s: "AT", r: "Piemonte" },
  "Costa de' Nobili": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Costa di Mezzate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Costa di Rovigo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Costa Masnaga": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Costa Serina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Costa Valle Imagna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Costa Vescovato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Costa Volpino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Costabissara": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Costacciaro": { p: "Perugia", s: "PG", r: "Umbria" },
  "Costanzana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Costarainera": { p: "Imperia", s: "IM", r: "Liguria" },
  "Costermano sul Garda": { p: "Verona", s: "VR", r: "Veneto" },
  "Costigliole d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Costigliole Saluzzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cotignola": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Cotronei": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cottanello": { p: "Rieti", s: "RI", r: "Lazio" },
  "Courmayeur": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Covo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Cozzo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Craco": { p: "Matera", s: "MT", r: "Basilicata" },
  "Crandola Valsassina": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cravagliana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Cravanzana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Craveggia": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Creazzo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Crecchio": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Credaro": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Credera Rubbiano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Crema": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cremella": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cremenaga": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cremeno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Cremia": { p: "Como", s: "CO", r: "Lombardia" },
  "Cremolino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Cremona": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cremosano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Crescentino": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Crespadoro": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Crespiatica": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Crespina Lorenzana": { p: "Pisa", s: "PI", r: "Toscana" },
  "Crespino": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Cressa": { p: "Novara", s: "NO", r: "Piemonte" },
  "Crevacuore": { p: "Biella", s: "BI", r: "Piemonte" },
  "Crevalcore": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Crevoladossola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Crispano": { p: "Napoli", s: "NA", r: "Campania" },
  "Crispiano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Crissolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Crocefieschi": { p: "Genova", s: "GE", r: "Liguria" },
  "Crocetta del Montello": { p: "Treviso", s: "TV", r: "Veneto" },
  "Crodo": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Crognaleto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Cropalati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Cropani": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Crosia": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Crosio della Valle": { p: "Varese", s: "VA", r: "Lombardia" },
  "Crotone": { p: "Crotone", s: "KR", r: "Calabria" },
  "Crotta d'Adda": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Crova": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Croviana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Crucoli": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cuasso al Monte": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cuccaro Vetere": { p: "Salerno", s: "SA", r: "Campania" },
  "Cucciago": { p: "Como", s: "CO", r: "Lombardia" },
  "Cuceglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cuggiono": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cugliate-Fabiasco": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cuglieri": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Cugnoli": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Cumiana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cumignano sul Naviglio": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Cunardo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cuneo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Cunico": { p: "Asti", s: "AT", r: "Piemonte" },
  "Cuorgnè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Cupello": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Cupra Marittima": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Cupramontana": { p: "Ancona", s: "AN", r: "Marche" },
  "Cura Carpignano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Curcuris": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Cureggio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Curiglia con Monteviasco": { p: "Varese", s: "VA", r: "Lombardia" },
  "Curinga": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Curino": { p: "Biella", s: "BI", r: "Piemonte" },
  "Curno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Curon Venosta": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Cursi": { p: "Lecce", s: "LE", r: "Puglia" },
  "Curtarolo": { p: "Padova", s: "PD", r: "Veneto" },
  "Curtatone": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Curti": { p: "Caserta", s: "CE", r: "Campania" },
  "Cusago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cusano Milanino": { p: "Milano", s: "MI", r: "Lombardia" },
  "Cusano Mutri": { p: "Benevento", s: "BN", r: "Campania" },
  "Cusino": { p: "Como", s: "CO", r: "Lombardia" },
  "Cusio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Custonaci": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Cutro": { p: "Crotone", s: "KR", r: "Calabria" },
  "Cutrofiano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Cuveglio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Cuvio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Dairago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Dalmine": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Dambel": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Danta di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Darfo Boario Terme": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Dasà": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Davagna": { p: "Genova", s: "GE", r: "Liguria" },
  "Daverio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Davoli": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Dazio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Decimomannu": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Decimoputzu": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Decollatura": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Dego": { p: "Savona", s: "SV", r: "Liguria" },
  "Deiva Marina": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Delebio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Delia": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Delianuova": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Deliceto": { p: "Foggia", s: "FG", r: "Puglia" },
  "Dello": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Demonte": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Denice": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Denno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Dernice": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Derovere": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Deruta": { p: "Perugia", s: "PG", r: "Umbria" },
  "Dervio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Desana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Desenzano del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Desio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Desulo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Diamante": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Diano Arentino": { p: "Imperia", s: "IM", r: "Liguria" },
  "Diano Castello": { p: "Imperia", s: "IM", r: "Liguria" },
  "Diano d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Diano Marina": { p: "Imperia", s: "IM", r: "Liguria" },
  "Diano San Pietro": { p: "Imperia", s: "IM", r: "Liguria" },
  "Dicomano": { p: "Firenze", s: "FI", r: "Toscana" },
  "Dignano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Dimaro Folgarida": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Dinami": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Dipignano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Diso": { p: "Lecce", s: "LE", r: "Puglia" },
  "Divignano": { p: "Novara", s: "NO", r: "Piemonte" },
  "Dizzasco": { p: "Como", s: "CO", r: "Lombardia" },
  "Dobbiaco": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Doberdò del Lago": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Dogliani": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Dogliola": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Dogna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Dolceacqua": { p: "Imperia", s: "IM", r: "Liguria" },
  "Dolcedo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Dolcè": { p: "Verona", s: "VR", r: "Veneto" },
  "Dolegna del Collio": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Dolianova": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Dolo": { p: "Venezia", s: "VE", r: "Veneto" },
  "Dolzago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Domanico": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Domaso": { p: "Como", s: "CO", r: "Lombardia" },
  "Domegge di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Domicella": { p: "Avellino", s: "AV", r: "Campania" },
  "Domodossola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Domus de Maria": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Domusnovas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Donato": { p: "Biella", s: "BI", r: "Piemonte" },
  "Dongo": { p: "Como", s: "CO", r: "Lombardia" },
  "Donnas": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Donori": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Dorgali": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Dorio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Dormelletto": { p: "Novara", s: "NO", r: "Piemonte" },
  "Dorno": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Dorzano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Dosolo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Dossena": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Dosso del Liro": { p: "Como", s: "CO", r: "Lombardia" },
  "Doues": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Dovadola": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Dovera": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Dozza": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Dragoni": { p: "Caserta", s: "CE", r: "Campania" },
  "Drapia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Drena": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Drenchia": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Dresano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Dro": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Dronero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Druento": { p: "Torino", s: "TO", r: "Piemonte" },
  "Druogno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Dualchi": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Dubino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Due Carrare": { p: "Padova", s: "PD", r: "Veneto" },
  "Dueville": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Dugenta": { p: "Benevento", s: "BN", r: "Campania" },
  "Duino Aurisina": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "Dumenza": { p: "Varese", s: "VA", r: "Lombardia" },
  "Duno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Durazzano": { p: "Benevento", s: "BN", r: "Campania" },
  "Duronia": { p: "Campobasso", s: "CB", r: "Molise" },
  "Dusino San Michele": { p: "Asti", s: "AT", r: "Piemonte" },
  "Eboli": { p: "Salerno", s: "SA", r: "Campania" },
  "Edolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Egna": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Elice": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Elini": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ello": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Elmas": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Elva": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Emarèse": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Empoli": { p: "Firenze", s: "FI", r: "Toscana" },
  "Endine Gaiano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Enego": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Enemonzo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Enna": { p: "Enna", s: "EN", r: "Sicilia" },
  "Entracque": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Entratico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Envie": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Episcopia": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Eraclea": { p: "Venezia", s: "VE", r: "Veneto" },
  "Erba": { p: "Como", s: "CO", r: "Lombardia" },
  "Erbezzo": { p: "Verona", s: "VR", r: "Veneto" },
  "Erbusco": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Erbè": { p: "Verona", s: "VR", r: "Veneto" },
  "Erchie": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Ercolano": { p: "Napoli", s: "NA", r: "Campania" },
  "Erice": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Erli": { p: "Savona", s: "SV", r: "Liguria" },
  "Erto e Casso": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Erula": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Erve": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Esanatoglia": { p: "Macerata", s: "MC", r: "Marche" },
  "Escalaplano": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Escolca": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Esine": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Esino Lario": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Esperia": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Esporlatu": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Este": { p: "Padova", s: "PD", r: "Veneto" },
  "Esterzili": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Etroubles": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Eupilio": { p: "Como", s: "CO", r: "Lombardia" },
  "Exilles": { p: "Torino", s: "TO", r: "Piemonte" },
  "Fabbrica Curone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Fabbriche di Vergemoli": { p: "Lucca", s: "LU", r: "Toscana" },
  "Fabbrico": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Fabriano": { p: "Ancona", s: "AN", r: "Marche" },
  "Fabrica di Roma": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Fabrizia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Fabro": { p: "Terni", s: "TR", r: "Umbria" },
  "Faedis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Faedo Valtellino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Faenza": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Faeto": { p: "Foggia", s: "FG", r: "Puglia" },
  "Fagagna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Faggeto Lario": { p: "Como", s: "CO", r: "Lombardia" },
  "Faggiano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Fagnano Alto": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Fagnano Castello": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Fagnano Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Fai della Paganella": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Faicchio": { p: "Benevento", s: "BN", r: "Campania" },
  "Falcade": { p: "Belluno", s: "BL", r: "Veneto" },
  "Falciano del Massico": { p: "Caserta", s: "CE", r: "Campania" },
  "Falconara Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Falconara Marittima": { p: "Ancona", s: "AN", r: "Marche" },
  "Falcone": { p: "Messina", s: "ME", r: "Sicilia" },
  "Faleria": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Falerna": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Falerone": { p: "Fermo", s: "FM", r: "Marche" },
  "Fallo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Faloppio": { p: "Como", s: "CO", r: "Lombardia" },
  "Falvaterra": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Falzes": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Fanano": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Fanna": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Fano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Fano Adriano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Fara Filiorum Petri": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Fara Gera d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fara in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Fara Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Fara Olivana con Sola": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fara San Martino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Fara Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Fardella": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Farigliano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Farindola": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Farini": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Farnese": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Farra d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Farra di Soligo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Fasano": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Fascia": { p: "Genova", s: "GE", r: "Liguria" },
  "Fauglia": { p: "Pisa", s: "PI", r: "Toscana" },
  "Faule": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Favale di Malvaro": { p: "Genova", s: "GE", r: "Liguria" },
  "Favara": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Favignana": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Favria": { p: "Torino", s: "TO", r: "Piemonte" },
  "Feisoglio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Feletto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Felino": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Felitto": { p: "Salerno", s: "SA", r: "Campania" },
  "Felizzano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Feltre": { p: "Belluno", s: "BL", r: "Veneto" },
  "Fenegrò": { p: "Como", s: "CO", r: "Lombardia" },
  "Fenestrelle": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ferentillo": { p: "Terni", s: "TR", r: "Umbria" },
  "Ferentino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Ferla": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Fermignano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Fermo": { p: "Fermo", s: "FM", r: "Marche" },
  "Ferno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Feroleto Antico": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Feroleto della Chiesa": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Ferrandina": { p: "Matera", s: "MT", r: "Basilicata" },
  "Ferrara": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Ferrara di Monte Baldo": { p: "Verona", s: "VR", r: "Veneto" },
  "Ferrazzano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Ferrera di Varese": { p: "Varese", s: "VA", r: "Lombardia" },
  "Ferrera Erbognone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Ferrere": { p: "Asti", s: "AT", r: "Piemonte" },
  "Ferriere": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Ferruzzano": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Fiamignano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Fiano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Fiano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Fiastra": { p: "Macerata", s: "MC", r: "Marche" },
  "Fiavè": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ficarazzi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Ficarolo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Ficarra": { p: "Messina", s: "ME", r: "Sicilia" },
  "Ficulle": { p: "Terni", s: "TR", r: "Umbria" },
  "Fidenza": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Fierozzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Fiesco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Fiesole": { p: "Firenze", s: "FI", r: "Toscana" },
  "Fiesse": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Fiesso d'Artico": { p: "Venezia", s: "VE", r: "Veneto" },
  "Fiesso Umbertiano": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Figino Serenza": { p: "Como", s: "CO", r: "Lombardia" },
  "Figline e Incisa Valdarno": { p: "Firenze", s: "FI", r: "Toscana" },
  "Figline Vegliaturo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Filacciano": { p: "Roma", s: "RM", r: "Lazio" },
  "Filadelfia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Filago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Filandari": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Filattiera": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Filettino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Filetto": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Filiano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Filighera": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Filignano": { p: "Isernia", s: "IS", r: "Molise" },
  "Filogaso": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Filottrano": { p: "Ancona", s: "AN", r: "Marche" },
  "Finale Emilia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Finale Ligure": { p: "Savona", s: "SV", r: "Liguria" },
  "Fino del Monte": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fino Mornasco": { p: "Como", s: "CO", r: "Lombardia" },
  "Fiorano al Serio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fiorano Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Fiorano Modenese": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Fiorenzuola d'Arda": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Firenze": { p: "Firenze", s: "FI", r: "Toscana" },
  "Firenzuola": { p: "Firenze", s: "FI", r: "Toscana" },
  "Firmo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Fiscaglia": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Fisciano": { p: "Salerno", s: "SA", r: "Campania" },
  "Fiuggi": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Fiumalbo": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Fiumara": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Fiume Veneto": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Fiumedinisi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Fiumefreddo Bruzio": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Fiumefreddo di Sicilia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Fiumicello Villa Vicentina": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Fiumicino": { p: "Roma", s: "RM", r: "Lazio" },
  "Fiuminata": { p: "Macerata", s: "MC", r: "Marche" },
  "Fivizzano": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Fiè allo Sciliar": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Flaibano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Flero": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Floresta": { p: "Messina", s: "ME", r: "Sicilia" },
  "Floridia": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Florinas": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Flumeri": { p: "Avellino", s: "AV", r: "Campania" },
  "Fluminimaggiore": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Flussio": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Fobello": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Foggia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Foglianise": { p: "Benevento", s: "BN", r: "Campania" },
  "Fogliano Redipuglia": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Foglizzo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Foiano della Chiana": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Foiano di Val Fortore": { p: "Benevento", s: "BN", r: "Campania" },
  "Folgaria": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Folignano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Foligno": { p: "Perugia", s: "PG", r: "Umbria" },
  "Follina": { p: "Treviso", s: "TV", r: "Veneto" },
  "Follo": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Follonica": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Fombio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Fondachelli-Fantina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Fondi": { p: "Latina", s: "LT", r: "Lazio" },
  "Fonni": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Fontainemore": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Fontana Liri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Fontanafredda": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Fontanarosa": { p: "Avellino", s: "AV", r: "Campania" },
  "Fontanelice": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Fontanella": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fontanellato": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Fontanelle": { p: "Treviso", s: "TV", r: "Veneto" },
  "Fontaneto d'Agogna": { p: "Novara", s: "NO", r: "Piemonte" },
  "Fontanetto Po": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Fontanigorda": { p: "Genova", s: "GE", r: "Liguria" },
  "Fontanile": { p: "Asti", s: "AT", r: "Piemonte" },
  "Fontaniva": { p: "Padova", s: "PD", r: "Veneto" },
  "Fonte": { p: "Treviso", s: "TV", r: "Veneto" },
  "Fonte Nuova": { p: "Roma", s: "RM", r: "Lazio" },
  "Fontecchio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Fontechiari": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Fontegreca": { p: "Caserta", s: "CE", r: "Campania" },
  "Fonteno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fontevivo": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Fonzaso": { p: "Belluno", s: "BL", r: "Veneto" },
  "Foppolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Forano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Force": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Forchia": { p: "Benevento", s: "BN", r: "Campania" },
  "Forcola": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Fordongianus": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Forenza": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Foresto Sparso": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Forgaria nel Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Forino": { p: "Avellino", s: "AV", r: "Campania" },
  "Forio": { p: "Napoli", s: "NA", r: "Campania" },
  "Forlimpopoli": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Forlì": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Forlì del Sannio": { p: "Isernia", s: "IS", r: "Molise" },
  "Formazza": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Formello": { p: "Roma", s: "RM", r: "Lazio" },
  "Formia": { p: "Latina", s: "LT", r: "Lazio" },
  "Formicola": { p: "Caserta", s: "CE", r: "Campania" },
  "Formigara": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Formigine": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Formigliana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Fornace": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Fornelli": { p: "Isernia", s: "IS", r: "Molise" },
  "Forni Avoltri": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Forni di Sopra": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Forni di Sotto": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Forno Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Fornovo di Taro": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Fornovo San Giovanni": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Forte dei Marmi": { p: "Lucca", s: "LU", r: "Toscana" },
  "Fortezza": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Fortunago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Forza d'Agrò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Fosciandora": { p: "Lucca", s: "LU", r: "Toscana" },
  "Fosdinovo": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Fossa": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Fossacesia": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Fossalta di Piave": { p: "Venezia", s: "VE", r: "Veneto" },
  "Fossalta di Portogruaro": { p: "Venezia", s: "VE", r: "Veneto" },
  "Fossalto": { p: "Campobasso", s: "CB", r: "Molise" },
  "Fossano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Fossato di Vico": { p: "Perugia", s: "PG", r: "Umbria" },
  "Fossato Serralta": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Fossombrone": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Fossò": { p: "Venezia", s: "VE", r: "Veneto" },
  "Foza": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Frabosa Soprana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Frabosa Sottana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Fraconalto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Fragagnano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Fragneto l'Abate": { p: "Benevento", s: "BN", r: "Campania" },
  "Fragneto Monforte": { p: "Benevento", s: "BN", r: "Campania" },
  "Fraine": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Framura": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Francavilla al Mare": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Francavilla Angitola": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Francavilla Bisio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Francavilla d'Ete": { p: "Fermo", s: "FM", r: "Marche" },
  "Francavilla di Sicilia": { p: "Messina", s: "ME", r: "Sicilia" },
  "Francavilla Fontana": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Francavilla in Sinni": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Francavilla Marittima": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Francica": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Francofonte": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Francolise": { p: "Caserta", s: "CE", r: "Campania" },
  "Frascaro": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Frascarolo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Frascati": { p: "Roma", s: "RM", r: "Lazio" },
  "Frascineto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Frassilongo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Frassinelle Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Frassinello Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Frassineto Po": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Frassinetto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Frassino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Frassinoro": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Frasso Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Frasso Telesino": { p: "Benevento", s: "BN", r: "Campania" },
  "Fratta Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Fratta Todina": { p: "Perugia", s: "PG", r: "Umbria" },
  "Frattamaggiore": { p: "Napoli", s: "NA", r: "Campania" },
  "Frattaminore": { p: "Napoli", s: "NA", r: "Campania" },
  "Fratte Rosa": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Frazzanò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Fregona": { p: "Treviso", s: "TV", r: "Veneto" },
  "Fresagrandinaria": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Fresonara": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Frigento": { p: "Avellino", s: "AV", r: "Campania" },
  "Frignano": { p: "Caserta", s: "CE", r: "Campania" },
  "Frinco": { p: "Asti", s: "AT", r: "Piemonte" },
  "Frisa": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Frisanco": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Front": { p: "Torino", s: "TO", r: "Piemonte" },
  "Frontino": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Frontone": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Frosinone": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Frosolone": { p: "Isernia", s: "IS", r: "Molise" },
  "Frossasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Frugarolo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Fubine Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Fucecchio": { p: "Firenze", s: "FI", r: "Toscana" },
  "Fuipiano Valle Imagna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Fumane": { p: "Verona", s: "VR", r: "Veneto" },
  "Fumone": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Funes": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Furci": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Furci Siculo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Furnari": { p: "Messina", s: "ME", r: "Sicilia" },
  "Furore": { p: "Salerno", s: "SA", r: "Campania" },
  "Furtei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Fuscaldo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Fusignano": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Fusine": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Futani": { p: "Salerno", s: "SA", r: "Campania" },
  "Fénis": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Gabbioneta-Binanuova": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Gabiano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gabicce Mare": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Gaby": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Gadesco-Pieve Delmona": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Gadoni": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Gaeta": { p: "Latina", s: "LT", r: "Lazio" },
  "Gaggi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Gaggiano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Gaggio Montano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Gaglianico": { p: "Biella", s: "BI", r: "Piemonte" },
  "Gagliano Aterno": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Gagliano Castelferrato": { p: "Enna", s: "EN", r: "Sicilia" },
  "Gagliano del Capo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Gagliato": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Gagliole": { p: "Macerata", s: "MC", r: "Marche" },
  "Gaiarine": { p: "Treviso", s: "TV", r: "Veneto" },
  "Gaiba": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Gaiola": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gaiole in Chianti": { p: "Siena", s: "SI", r: "Toscana" },
  "Gairo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Gais": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Galati Mamertino": { p: "Messina", s: "ME", r: "Sicilia" },
  "Galatina": { p: "Lecce", s: "LE", r: "Puglia" },
  "Galatone": { p: "Lecce", s: "LE", r: "Puglia" },
  "Galatro": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Galbiate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Galeata": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Galgagnano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Gallarate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gallese": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Galliate": { p: "Novara", s: "NO", r: "Piemonte" },
  "Galliate Lombardo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Galliavola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gallicano": { p: "Lucca", s: "LU", r: "Toscana" },
  "Gallicano nel Lazio": { p: "Roma", s: "RM", r: "Lazio" },
  "Gallicchio": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Galliera": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Galliera Veneta": { p: "Padova", s: "PD", r: "Veneto" },
  "Gallinaro": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Gallio": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Gallipoli": { p: "Lecce", s: "LE", r: "Puglia" },
  "Gallo Matese": { p: "Caserta", s: "CE", r: "Campania" },
  "Gallodoro": { p: "Messina", s: "ME", r: "Sicilia" },
  "Galluccio": { p: "Caserta", s: "CE", r: "Campania" },
  "Galtellì": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Galzignano Terme": { p: "Padova", s: "PD", r: "Veneto" },
  "Gamalero": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gambara": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Gambarana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gambasca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gambassi Terme": { p: "Firenze", s: "FI", r: "Toscana" },
  "Gambatesa": { p: "Campobasso", s: "CB", r: "Molise" },
  "Gambellara": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Gamberale": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Gambettola": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Gambolò": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gambugliano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Gandellino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gandino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gandosso": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gangi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Garaguso": { p: "Matera", s: "MT", r: "Basilicata" },
  "Garbagna": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Garbagna Novarese": { p: "Novara", s: "NO", r: "Piemonte" },
  "Garbagnate Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Garbagnate Monastero": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Garda": { p: "Verona", s: "VR", r: "Veneto" },
  "Gardone Riviera": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Gardone Val Trompia": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Garessio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gargallo": { p: "Novara", s: "NO", r: "Piemonte" },
  "Gargazzone": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Gargnano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Garlasco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Garlate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Garlenda": { p: "Savona", s: "SV", r: "Liguria" },
  "Garniga Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Garzeno": { p: "Como", s: "CO", r: "Lombardia" },
  "Garzigliana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Gasperina": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Gassino Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Gattatico": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Gatteo": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Gattico-Veruno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Gattinara": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Gavardo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Gavello": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Gaverina Terme": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gavi": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gavignano": { p: "Roma", s: "RM", r: "Lazio" },
  "Gavirate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gavoi": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Gavorrano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Gazoldo degli Ippoliti": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Gazzada Schianno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gazzaniga": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gazzo": { p: "Padova", s: "PD", r: "Veneto" },
  "Gazzo Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Gazzola": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Gazzuolo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Gela": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Gemmano": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Gemona del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Gemonio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Genazzano": { p: "Roma", s: "RM", r: "Lazio" },
  "Genga": { p: "Ancona", s: "AN", r: "Marche" },
  "Genivolta": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Genola": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Genoni": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Genova": { p: "Genova", s: "GE", r: "Liguria" },
  "Genuri": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Genzano di Lucania": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Genzano di Roma": { p: "Roma", s: "RM", r: "Lazio" },
  "Gera Lario": { p: "Como", s: "CO", r: "Lombardia" },
  "Gerace": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Geraci Siculo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Gerano": { p: "Roma", s: "RM", r: "Lazio" },
  "Gerenzago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gerenzano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gergei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Germagnano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Germagno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Germignaga": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gerocarne": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Gerola Alta": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Gerre de' Caprioli": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Gesico": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gessate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Gessopalena": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Gesturi": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gesualdo": { p: "Avellino", s: "AV", r: "Campania" },
  "Ghedi": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ghemme": { p: "Novara", s: "NO", r: "Piemonte" },
  "Ghiffa": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Ghilarza": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ghisalba": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ghislarengo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Giacciano con Baruchella": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Giaglione": { p: "Torino", s: "TO", r: "Piemonte" },
  "Gianico": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Giano dell'Umbria": { p: "Perugia", s: "PG", r: "Umbria" },
  "Giano Vetusto": { p: "Caserta", s: "CE", r: "Campania" },
  "Giardinello": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Giardini-Naxos": { p: "Messina", s: "ME", r: "Sicilia" },
  "Giarole": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Giarratana": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Giarre": { p: "Catania", s: "CT", r: "Sicilia" },
  "Giave": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Giaveno": { p: "Torino", s: "TO", r: "Piemonte" },
  "Giavera del Montello": { p: "Treviso", s: "TV", r: "Veneto" },
  "Giba": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gibellina": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Gifflenga": { p: "Biella", s: "BI", r: "Piemonte" },
  "Giffone": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Giffoni Sei Casali": { p: "Salerno", s: "SA", r: "Campania" },
  "Giffoni Valle Piana": { p: "Salerno", s: "SA", r: "Campania" },
  "Gignese": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Gignod": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Gildone": { p: "Campobasso", s: "CB", r: "Molise" },
  "Gimigliano": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Ginestra": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Ginestra degli Schiavoni": { p: "Benevento", s: "BN", r: "Campania" },
  "Ginosa": { p: "Taranto", s: "TA", r: "Puglia" },
  "Gioi": { p: "Salerno", s: "SA", r: "Campania" },
  "Gioia dei Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Gioia del Colle": { p: "Bari", s: "BA", r: "Puglia" },
  "Gioia Sannitica": { p: "Caserta", s: "CE", r: "Campania" },
  "Gioia Tauro": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Gioiosa Ionica": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Gioiosa Marea": { p: "Messina", s: "ME", r: "Sicilia" },
  "Giove": { p: "Terni", s: "TR", r: "Umbria" },
  "Giovinazzo": { p: "Bari", s: "BA", r: "Puglia" },
  "Giovo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Girasole": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Girifalco": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Gissi": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Giuggianello": { p: "Lecce", s: "LE", r: "Puglia" },
  "Giugliano in Campania": { p: "Napoli", s: "NA", r: "Campania" },
  "Giuliana": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Giuliano di Roma": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Giuliano Teatino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Giulianova": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Giungano": { p: "Salerno", s: "SA", r: "Campania" },
  "Giurdignano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Giussago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Giussano": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Giustenice": { p: "Savona", s: "SV", r: "Liguria" },
  "Giustino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Giusvalla": { p: "Savona", s: "SV", r: "Liguria" },
  "Givoletto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Gizzeria": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Glorenza": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Godega di Sant'Urbano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Godiasco Salice Terme": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Godrano": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Goito": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Golasecca": { p: "Varese", s: "VA", r: "Lombardia" },
  "Golferenzo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Golfo Aranci": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Gombito": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Gonars": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Goni": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gonnesa": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gonnoscodina": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Gonnosfanadiga": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gonnosnò": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Gonnostramatza": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Gonzaga": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Gordona": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Gorga": { p: "Roma", s: "RM", r: "Lazio" },
  "Gorgo al Monticano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Gorgoglione": { p: "Matera", s: "MT", r: "Basilicata" },
  "Gorgonzola": { p: "Milano", s: "MI", r: "Lombardia" },
  "Goriano Sicoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Gorizia": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Gorla Maggiore": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gorla Minore": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gorlago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gorle": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gornate Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Gorno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Goro": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Gorreto": { p: "Genova", s: "GE", r: "Liguria" },
  "Gorzegno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gosaldo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Gossolengo": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Gottasecca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gottolengo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Govone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Gozzano": { p: "Novara", s: "NO", r: "Piemonte" },
  "Gradara": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Gradisca d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Grado": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Gradoli": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Graffignana": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Graffignano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Graglia": { p: "Biella", s: "BI", r: "Piemonte" },
  "Gragnano": { p: "Napoli", s: "NA", r: "Campania" },
  "Gragnano Trebbiense": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Grammichele": { p: "Catania", s: "CT", r: "Sicilia" },
  "Grana": { p: "Asti", s: "AT", r: "Piemonte" },
  "Granarolo dell'Emilia": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Grandate": { p: "Como", s: "CO", r: "Lombardia" },
  "Grandola ed Uniti": { p: "Como", s: "CO", r: "Lombardia" },
  "Graniti": { p: "Messina", s: "ME", r: "Sicilia" },
  "Granozzo con Monticello": { p: "Novara", s: "NO", r: "Piemonte" },
  "Grantola": { p: "Varese", s: "VA", r: "Lombardia" },
  "Grantorto": { p: "Padova", s: "PD", r: "Veneto" },
  "Granze": { p: "Padova", s: "PD", r: "Veneto" },
  "Grassano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Grassobbio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Gratteri": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Gravedona ed Uniti": { p: "Como", s: "CO", r: "Lombardia" },
  "Gravellona Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gravellona Toce": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Gravere": { p: "Torino", s: "TO", r: "Piemonte" },
  "Gravina di Catania": { p: "Catania", s: "CT", r: "Sicilia" },
  "Gravina in Puglia": { p: "Bari", s: "BA", r: "Puglia" },
  "Grazzanise": { p: "Caserta", s: "CE", r: "Campania" },
  "Grazzano Badoglio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Greccio": { p: "Rieti", s: "RI", r: "Lazio" },
  "Greci": { p: "Avellino", s: "AV", r: "Campania" },
  "Greggio": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Gremiasco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gressan": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Gressoney-La-Trinité": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Gressoney-Saint-Jean": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Greve in Chianti": { p: "Firenze", s: "FI", r: "Toscana" },
  "Grezzago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Grezzana": { p: "Verona", s: "VR", r: "Veneto" },
  "Griante": { p: "Como", s: "CO", r: "Lombardia" },
  "Gricignano di Aversa": { p: "Caserta", s: "CE", r: "Campania" },
  "Grignasco": { p: "Novara", s: "NO", r: "Piemonte" },
  "Grigno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Grimacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Grimaldi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Grinzane Cavour": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Grisignano di Zocco": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Grisolia": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Grizzana Morandi": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Grognardo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gromo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Grondona": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Grone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Grontardo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Gropello Cairoli": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Gropparello": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Groscavallo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Grosio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Grosotto": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Grosseto": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Grosso": { p: "Torino", s: "TO", r: "Piemonte" },
  "Grottaferrata": { p: "Roma", s: "RM", r: "Lazio" },
  "Grottaglie": { p: "Taranto", s: "TA", r: "Puglia" },
  "Grottaminarda": { p: "Avellino", s: "AV", r: "Campania" },
  "Grottammare": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Grottazzolina": { p: "Fermo", s: "FM", r: "Marche" },
  "Grotte": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Grotte di Castro": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Grotteria": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Grottole": { p: "Matera", s: "MT", r: "Basilicata" },
  "Grottolella": { p: "Avellino", s: "AV", r: "Campania" },
  "Gruaro": { p: "Venezia", s: "VE", r: "Veneto" },
  "Grugliasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Grumello Cremonese ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Grumello del Monte": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Grumento Nova": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Grumo Appula": { p: "Bari", s: "BA", r: "Puglia" },
  "Grumo Nevano": { p: "Napoli", s: "NA", r: "Campania" },
  "Grumolo delle Abbadesse": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Guagnano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Gualdo": { p: "Macerata", s: "MC", r: "Marche" },
  "Gualdo Cattaneo": { p: "Perugia", s: "PG", r: "Umbria" },
  "Gualdo Tadino": { p: "Perugia", s: "PG", r: "Umbria" },
  "Gualtieri": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Gualtieri Sicaminò": { p: "Messina", s: "ME", r: "Sicilia" },
  "Guamaggiore": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Guanzate": { p: "Como", s: "CO", r: "Lombardia" },
  "Guarcino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Guarda Veneta": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Guardabosone": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Guardamiglio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Guardavalle": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Guardea": { p: "Terni", s: "TR", r: "Umbria" },
  "Guardia Lombardi": { p: "Avellino", s: "AV", r: "Campania" },
  "Guardia Perticara": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Guardia Piemontese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Guardia Sanframondi": { p: "Benevento", s: "BN", r: "Campania" },
  "Guardiagrele": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Guardialfiera": { p: "Campobasso", s: "CB", r: "Molise" },
  "Guardiaregia": { p: "Campobasso", s: "CB", r: "Molise" },
  "Guardistallo": { p: "Pisa", s: "PI", r: "Toscana" },
  "Guarene": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Guasila": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Guastalla": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Guazzora": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Gubbio": { p: "Perugia", s: "PG", r: "Umbria" },
  "Gudo Visconti": { p: "Milano", s: "MI", r: "Lombardia" },
  "Guglionesi": { p: "Campobasso", s: "CB", r: "Molise" },
  "Guidizzolo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Guidonia Montecelio": { p: "Roma", s: "RM", r: "Lazio" },
  "Guiglia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Guilmi": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Gurro": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Guspini": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Gussago": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Gussola": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Hône": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Idro": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Iglesias": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Igliano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ilbono": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Illasi": { p: "Verona", s: "VR", r: "Veneto" },
  "Illorai": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Imbersago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Imer": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Imola": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Imperia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Impruneta": { p: "Firenze", s: "FI", r: "Toscana" },
  "Inarzo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Incisa Scapaccino": { p: "Asti", s: "AT", r: "Piemonte" },
  "Incudine": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Induno Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Ingria": { p: "Torino", s: "TO", r: "Piemonte" },
  "Intragna": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Introbio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Introd": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Introdacqua": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Inverigo": { p: "Como", s: "CO", r: "Lombardia" },
  "Inverno e Monteleone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Inverso Pinasca": { p: "Torino", s: "TO", r: "Piemonte" },
  "Inveruno": { p: "Milano", s: "MI", r: "Lombardia" },
  "Invorio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Inzago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Ionadi": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Irgoli": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Irma": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Irsina": { p: "Matera", s: "MT", r: "Basilicata" },
  "Isasca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Isca sullo Ionio": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Ischia": { p: "Napoli", s: "NA", r: "Campania" },
  "Ischia di Castro": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Ischitella": { p: "Foggia", s: "FG", r: "Puglia" },
  "Iseo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Isera": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Isernia": { p: "Isernia", s: "IS", r: "Molise" },
  "Isili": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Isnello": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Isola d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Isola del Cantone": { p: "Genova", s: "GE", r: "Liguria" },
  "Isola del Giglio": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Isola del Gran Sasso d'Italia": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Isola del Liri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Isola del Piano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Isola della Scala": { p: "Verona", s: "VR", r: "Veneto" },
  "Isola delle Femmine": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Isola di Capo Rizzuto": { p: "Crotone", s: "KR", r: "Calabria" },
  "Isola di Fondra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Isola Dovarese": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Isola Rizza": { p: "Verona", s: "VR", r: "Veneto" },
  "Isola Sant'Antonio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Isola Vicentina": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Isolabella": { p: "Torino", s: "TO", r: "Piemonte" },
  "Isolabona": { p: "Imperia", s: "IM", r: "Liguria" },
  "Isole Tremiti": { p: "Foggia", s: "FG", r: "Puglia" },
  "Isorella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ispani": { p: "Salerno", s: "SA", r: "Campania" },
  "Ispica": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Ispra": { p: "Varese", s: "VA", r: "Lombardia" },
  "Issiglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Issime": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Isso": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Issogne": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Istrana": { p: "Treviso", s: "TV", r: "Veneto" },
  "Itala": { p: "Messina", s: "ME", r: "Sicilia" },
  "Itri": { p: "Latina", s: "LT", r: "Lazio" },
  "Ittireddu": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ittiri": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ivrea": { p: "Torino", s: "TO", r: "Piemonte" },
  "Izano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Jacurso": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Jelsi": { p: "Campobasso", s: "CB", r: "Molise" },
  "Jenne": { p: "Roma", s: "RM", r: "Lazio" },
  "Jerago con Orago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Jerzu": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Jesi": { p: "Ancona", s: "AN", r: "Marche" },
  "Jesolo": { p: "Venezia", s: "VE", r: "Veneto" },
  "Jolanda di Savoia": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Joppolo": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Joppolo Giancaxio": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Jovençan": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "L'Aquila": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "La Cassa": { p: "Torino", s: "TO", r: "Piemonte" },
  "La Loggia": { p: "Torino", s: "TO", r: "Piemonte" },
  "La Maddalena": { p: "Sassari", s: "SS", r: "Sardegna" },
  "La Magdeleine": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "La Morra": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "La Salle": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "La Spezia": { p: "La Spezia", s: "SP", r: "Liguria" },
  "La Thuile": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "La Valle": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "La Valle Agordina": { p: "Belluno", s: "BL", r: "Veneto" },
  "La Valletta Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Labico": { p: "Roma", s: "RM", r: "Lazio" },
  "Labro": { p: "Rieti", s: "RI", r: "Lazio" },
  "Lacchiarella": { p: "Milano", s: "MI", r: "Lombardia" },
  "Lacco Ameno": { p: "Napoli", s: "NA", r: "Campania" },
  "Lacedonia": { p: "Avellino", s: "AV", r: "Campania" },
  "Laces": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Laconi": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ladispoli": { p: "Roma", s: "RM", r: "Lazio" },
  "Laerru": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Laganadi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Laghi": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Laglio": { p: "Como", s: "CO", r: "Lombardia" },
  "Lagnasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Lago": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Lagonegro": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Lagosanto": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Lagundo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Laigueglia": { p: "Savona", s: "SV", r: "Liguria" },
  "Lainate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Laino": { p: "Como", s: "CO", r: "Lombardia" },
  "Laino Borgo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Laino Castello": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Laion": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Laives": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Lajatico": { p: "Pisa", s: "PI", r: "Toscana" },
  "Lallio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Lama dei Peligni": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Lama Mocogno": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Lambrugo": { p: "Como", s: "CO", r: "Lombardia" },
  "Lamezia Terme": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Lamon": { p: "Belluno", s: "BL", r: "Veneto" },
  "Lampedusa e Linosa": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Lamporecchio": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Lamporo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Lana": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Lanciano": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Landiona": { p: "Novara", s: "NO", r: "Piemonte" },
  "Landriano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Langhirano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Langosco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Lanusei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lanuvio": { p: "Roma", s: "RM", r: "Lazio" },
  "Lanzada": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Lanzo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lapedona": { p: "Fermo", s: "FM", r: "Marche" },
  "Lapio": { p: "Avellino", s: "AV", r: "Campania" },
  "Lappano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Larciano": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Lardirago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Lariano": { p: "Roma", s: "RM", r: "Lazio" },
  "Larino": { p: "Campobasso", s: "CB", r: "Molise" },
  "Las Plassas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Lasa": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Lascari": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Lasnigo": { p: "Como", s: "CO", r: "Lombardia" },
  "Lastebasse": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Lastra a Signa": { p: "Firenze", s: "FI", r: "Toscana" },
  "Latera": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Laterina Pergine Valdarno": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Laterza": { p: "Taranto", s: "TA", r: "Puglia" },
  "Latiano": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Latina": { p: "Latina", s: "LT", r: "Lazio" },
  "Latisana": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Latronico": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Lattarico": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Lauco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Laureana Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Laureana di Borrello": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Lauregno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Laurenzana": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Lauria": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Lauriano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Laurino": { p: "Salerno", s: "SA", r: "Campania" },
  "Laurito": { p: "Salerno", s: "SA", r: "Campania" },
  "Lauro": { p: "Avellino", s: "AV", r: "Campania" },
  "Lavagna": { p: "Genova", s: "GE", r: "Liguria" },
  "Lavagno": { p: "Verona", s: "VR", r: "Veneto" },
  "Lavarone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Lavello": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Lavena Ponte Tresa": { p: "Varese", s: "VA", r: "Lombardia" },
  "Laveno-Mombello": { p: "Varese", s: "VA", r: "Lombardia" },
  "Lavenone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Laviano": { p: "Salerno", s: "SA", r: "Campania" },
  "Lavis": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Lazise": { p: "Verona", s: "VR", r: "Veneto" },
  "Lazzate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "Lecce nei Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Lecco": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Ledro": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Leffe": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Leggiuno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Legnago": { p: "Verona", s: "VR", r: "Veneto" },
  "Legnano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Legnaro": { p: "Padova", s: "PD", r: "Veneto" },
  "Lei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Leini": { p: "Torino", s: "TO", r: "Piemonte" },
  "Leivi": { p: "Genova", s: "GE", r: "Liguria" },
  "Lemie": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lendinara": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Leni": { p: "Messina", s: "ME", r: "Sicilia" },
  "Lenna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Leno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Lenola": { p: "Latina", s: "LT", r: "Lazio" },
  "Lenta": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Lentate sul Seveso": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Lentella": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Lentini": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Leonessa": { p: "Rieti", s: "RI", r: "Lazio" },
  "Leonforte": { p: "Enna", s: "EN", r: "Sicilia" },
  "Leporano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Lequile": { p: "Lecce", s: "LE", r: "Puglia" },
  "Lequio Berria": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Lequio Tanaro": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Lercara Friddi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Lerici": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Lerma": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Lesa": { p: "Novara", s: "NO", r: "Piemonte" },
  "Lesegno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Lesignano de' Bagni": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Lesina": { p: "Foggia", s: "FG", r: "Puglia" },
  "Lesmo": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Lessolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lessona": { p: "Biella", s: "BI", r: "Piemonte" },
  "Lestizza": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Letino": { p: "Caserta", s: "CE", r: "Campania" },
  "Letojanni": { p: "Messina", s: "ME", r: "Sicilia" },
  "Lettere": { p: "Napoli", s: "NA", r: "Campania" },
  "Lettomanoppello": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Lettopalena": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Levanto": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Levate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Leverano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Levice": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Levico Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Levone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lezzeno": { p: "Como", s: "CO", r: "Lombardia" },
  "Liberi": { p: "Caserta", s: "CE", r: "Campania" },
  "Librizzi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Licata": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Licciana Nardi": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Licenza": { p: "Roma", s: "RM", r: "Lazio" },
  "Licodia Eubea": { p: "Catania", s: "CT", r: "Sicilia" },
  "Lierna": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Lignana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Lignano Sabbiadoro": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Lillianes": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Limana": { p: "Belluno", s: "BL", r: "Veneto" },
  "Limatola": { p: "Benevento", s: "BN", r: "Campania" },
  "Limbadi": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Limbiate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Limena": { p: "Padova", s: "PD", r: "Veneto" },
  "Limido Comasco": { p: "Como", s: "CO", r: "Lombardia" },
  "Limina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Limone Piemonte": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Limone sul Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Limosano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Linarolo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Linguaglossa": { p: "Catania", s: "CT", r: "Sicilia" },
  "Lioni": { p: "Avellino", s: "AV", r: "Campania" },
  "Lipari": { p: "Messina", s: "ME", r: "Sicilia" },
  "Lipomo": { p: "Como", s: "CO", r: "Lombardia" },
  "Lirio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Liscate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Liscia": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Lisciano Niccone": { p: "Perugia", s: "PG", r: "Umbria" },
  "Lisio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Lissone": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Liveri": { p: "Napoli", s: "NA", r: "Campania" },
  "Livigno": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Livinallongo del Col di Lana": { p: "Belluno", s: "BL", r: "Veneto" },
  "Livo": { p: "Como", s: "CO", r: "Lombardia" },
  "Livo (CO)": { p: "Como", s: "CO", r: "Lombardia" },
  "Livo (TN)": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Livorno": { p: "Livorno", s: "LI", r: "Toscana" },
  "Livorno Ferraris": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Livraga": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Lizzanello": { p: "Lecce", s: "LE", r: "Puglia" },
  "Lizzano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Lizzano in Belvedere": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Loano": { p: "Savona", s: "SV", r: "Liguria" },
  "Loazzolo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Locana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Locate di Triulzi": { p: "Milano", s: "MI", r: "Lombardia" },
  "Locate Varesino": { p: "Como", s: "CO", r: "Lombardia" },
  "Locatello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Loceri": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Locorotondo": { p: "Bari", s: "BA", r: "Puglia" },
  "Locri": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Loculi": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lodi": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Lodi Vecchio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Lodine": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lodrino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Lodè": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lograto": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Loiano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Loiri Porto San Paolo": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Lomagna": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Lomazzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Lombardore": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lombriasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lomello": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Lona-Lases": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Lonate Ceppino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Lonate Pozzolo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Lonato del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Londa": { p: "Firenze", s: "FI", r: "Toscana" },
  "Longano": { p: "Isernia", s: "IS", r: "Molise" },
  "Longare": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Longarone": { p: "Belluno", s: "BL", r: "Veneto" },
  "Longhena": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Longi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Longiano": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Longobardi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Longobucco": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Longone al Segrino": { p: "Como", s: "CO", r: "Lombardia" },
  "Longone Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Lonigo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Loranzè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Loreggia": { p: "Padova", s: "PD", r: "Veneto" },
  "Loreglia": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Lorenzago di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Loreo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Loreto": { p: "Ancona", s: "AN", r: "Marche" },
  "Loreto Aprutino": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Loria": { p: "Treviso", s: "TV", r: "Veneto" },
  "Loro Ciuffenna": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Loro Piceno": { p: "Macerata", s: "MC", r: "Marche" },
  "Lorsica": { p: "Genova", s: "GE", r: "Liguria" },
  "Losine": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Lotzorai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lovere": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Lovero": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Lozio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Lozza": { p: "Varese", s: "VA", r: "Lombardia" },
  "Lozzo Atestino": { p: "Padova", s: "PD", r: "Veneto" },
  "Lozzo di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Lozzolo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Lu e Cuccaro Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Lubriano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Lucca": { p: "Lucca", s: "LU", r: "Toscana" },
  "Lucca Sicula": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Lucera": { p: "Foggia", s: "FG", r: "Puglia" },
  "Lucignano": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Lucinasco": { p: "Imperia", s: "IM", r: "Liguria" },
  "Lucito": { p: "Campobasso", s: "CB", r: "Molise" },
  "Luco dei Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Lucoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Lugagnano Val d'Arda": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Lugnano in Teverina": { p: "Terni", s: "TR", r: "Umbria" },
  "Lugo": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Lugo di Vicenza": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Luino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Luisago": { p: "Como", s: "CO", r: "Lombardia" },
  "Lula": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Lumarzo": { p: "Genova", s: "GE", r: "Liguria" },
  "Lumezzane": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Lunamatrona": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Lunano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Lungavilla": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Lungro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Luni": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Luogosano": { p: "Avellino", s: "AV", r: "Campania" },
  "Luogosanto": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Lupara": { p: "Campobasso", s: "CB", r: "Molise" },
  "Lurago d'Erba": { p: "Como", s: "CO", r: "Lombardia" },
  "Lurago Marinone": { p: "Como", s: "CO", r: "Lombardia" },
  "Lurano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Luras": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Lurate Caccivio": { p: "Como", s: "CO", r: "Lombardia" },
  "Lusciano": { p: "Caserta", s: "CE", r: "Campania" },
  "Luserna": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Luserna San Giovanni": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lusernetta": { p: "Torino", s: "TO", r: "Piemonte" },
  "Lusevera": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Lusia": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Lusiana Conco": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Lusigliè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Luson": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Lustra": { p: "Salerno", s: "SA", r: "Campania" },
  "Luvinate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Luzzana": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Luzzara": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Luzzi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Maccagno con Pino e Veddasca": { p: "Varese", s: "VA", r: "Lombardia" },
  "Maccastorna": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Macchia d'Isernia": { p: "Isernia", s: "IS", r: "Molise" },
  "Macchia Valfortore": { p: "Campobasso", s: "CB", r: "Molise" },
  "Macchiagodena": { p: "Isernia", s: "IS", r: "Molise" },
  "Macello": { p: "Torino", s: "TO", r: "Piemonte" },
  "Macerata": { p: "Macerata", s: "MC", r: "Marche" },
  "Macerata Campania": { p: "Caserta", s: "CE", r: "Campania" },
  "Macerata Feltria": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Macherio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Maclodio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Macomer": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Macra": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Macugnaga": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Maddaloni": { p: "Caserta", s: "CE", r: "Campania" },
  "Madesimo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Madignano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Madone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Madonna del Sasso": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Madruzzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Maenza": { p: "Latina", s: "LT", r: "Lazio" },
  "Mafalda": { p: "Campobasso", s: "CB", r: "Molise" },
  "Magasa": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Magenta": { p: "Milano", s: "MI", r: "Lombardia" },
  "Maggiora": { p: "Novara", s: "NO", r: "Piemonte" },
  "Magherno": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Magione": { p: "Perugia", s: "PG", r: "Umbria" },
  "Magisano": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Magliano Alfieri": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Magliano Alpi": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Magliano de' Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Magliano di Tenna": { p: "Fermo", s: "FM", r: "Marche" },
  "Magliano in Toscana": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Magliano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Magliano Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Magliano Vetere": { p: "Salerno", s: "SA", r: "Campania" },
  "Maglie": { p: "Lecce", s: "LE", r: "Puglia" },
  "Magliolo": { p: "Savona", s: "SV", r: "Liguria" },
  "Maglione": { p: "Torino", s: "TO", r: "Piemonte" },
  "Magnacavallo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Magnago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Magnano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Magnano in Riviera": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Magomadas": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Magreglio": { p: "Como", s: "CO", r: "Lombardia" },
  "Magrè sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Maida": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Maierato": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Maierà": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Maiolati Spontini": { p: "Ancona", s: "AN", r: "Marche" },
  "Maiolo": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Maiori": { p: "Salerno", s: "SA", r: "Campania" },
  "Mairago": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Mairano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Maissana": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Majano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Malagnino": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Malalbergo": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Malborghetto Valbruna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Malcesine": { p: "Verona", s: "VR", r: "Veneto" },
  "Malegno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Maleo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Malesco": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Maletto": { p: "Catania", s: "CT", r: "Sicilia" },
  "Malfa": { p: "Messina", s: "ME", r: "Sicilia" },
  "Malgesso": { p: "Varese", s: "VA", r: "Lombardia" },
  "Malgrate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Malito": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Mallare": { p: "Savona", s: "SV", r: "Liguria" },
  "Malles Venosta": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Malnate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Malo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Malonno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Maltignano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Malvagna": { p: "Messina", s: "ME", r: "Sicilia" },
  "Malvicino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Malvito": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Malé": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mammola": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Mamoiada": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Manciano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Mandanici": { p: "Messina", s: "ME", r: "Sicilia" },
  "Mandas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Mandatoriccio": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Mandela": { p: "Roma", s: "RM", r: "Lazio" },
  "Mandello del Lario": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Mandello Vitta": { p: "Novara", s: "NO", r: "Piemonte" },
  "Manduria": { p: "Taranto", s: "TA", r: "Puglia" },
  "Manerba del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Manerbio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Manfredonia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Mango": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mangone": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Maniace": { p: "Catania", s: "CT", r: "Sicilia" },
  "Maniago": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Manocalzati": { p: "Avellino", s: "AV", r: "Campania" },
  "Manoppello": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Mansuè": { p: "Treviso", s: "TV", r: "Veneto" },
  "Manta": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mantello": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Mantova": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Manzano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Manziana": { p: "Roma", s: "RM", r: "Lazio" },
  "Mapello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Mappano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mara": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Maracalagonis": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Maranello": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Marano di Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Marano di Valpolicella": { p: "Verona", s: "VR", r: "Veneto" },
  "Marano Equo": { p: "Roma", s: "RM", r: "Lazio" },
  "Marano Lagunare": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Marano Marchesato": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Marano Principato": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Marano sul Panaro": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Marano Ticino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Marano Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Maranzana": { p: "Asti", s: "AT", r: "Piemonte" },
  "Maratea": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Marcallo con Casone": { p: "Milano", s: "MI", r: "Lombardia" },
  "Marcaria": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Marcedusa": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Marcellina": { p: "Roma", s: "RM", r: "Lazio" },
  "Marcellinara": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Marcetelli": { p: "Rieti", s: "RI", r: "Lazio" },
  "Marcheno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Marchirolo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Marciana": { p: "Livorno", s: "LI", r: "Toscana" },
  "Marciana Marina": { p: "Livorno", s: "LI", r: "Toscana" },
  "Marcianise": { p: "Caserta", s: "CE", r: "Campania" },
  "Marciano della Chiana": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Marcignago": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Marcon": { p: "Venezia", s: "VE", r: "Veneto" },
  "Marebbe": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Marene": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mareno di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Marentino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Maretto": { p: "Asti", s: "AT", r: "Piemonte" },
  "Margarita": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Margherita di Savoia": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Margno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Mariana Mantovana": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Mariano Comense": { p: "Como", s: "CO", r: "Lombardia" },
  "Mariano del Friuli": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Marianopoli": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Mariglianella": { p: "Napoli", s: "NA", r: "Campania" },
  "Marigliano": { p: "Napoli", s: "NA", r: "Campania" },
  "Marina di Gioiosa Ionica": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Marineo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Marino": { p: "Roma", s: "RM", r: "Lazio" },
  "Marlengo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Marliana": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Marmentino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Marmirolo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Marmora": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Marnate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Marone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Maropati": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Marostica": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Marradi": { p: "Firenze", s: "FI", r: "Toscana" },
  "Marrubiu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Marsaglia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Marsala": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Marsciano": { p: "Perugia", s: "PG", r: "Umbria" },
  "Marsico Nuovo": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Marsicovetere": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Marta": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Martano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Martellago": { p: "Venezia", s: "VE", r: "Veneto" },
  "Martello": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Martignacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Martignana di Po": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Martignano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Martina Franca": { p: "Taranto", s: "TA", r: "Puglia" },
  "Martinengo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Martiniana Po": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Martinsicuro": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Martirano": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Martirano Lombardo": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Martis": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Martone": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Marudo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Maruggio": { p: "Taranto", s: "TA", r: "Puglia" },
  "Marzabotto": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Marzano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Marzano Appio": { p: "Caserta", s: "CE", r: "Campania" },
  "Marzano di Nola": { p: "Avellino", s: "AV", r: "Campania" },
  "Marzi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Marzio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Masainas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Masate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Mascali": { p: "Catania", s: "CT", r: "Sicilia" },
  "Mascalucia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Maschito": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Masciago Primo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Maser": { p: "Treviso", s: "TV", r: "Veneto" },
  "Masera": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Maserada sul Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Maserà di Padova": { p: "Padova", s: "PD", r: "Veneto" },
  "Masi": { p: "Padova", s: "PD", r: "Veneto" },
  "Masi Torello": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Masio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Maslianico": { p: "Como", s: "CO", r: "Lombardia" },
  "Masone": { p: "Genova", s: "GE", r: "Liguria" },
  "Massa": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Massa d'Albe": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Massa di Somma": { p: "Napoli", s: "NA", r: "Campania" },
  "Massa e Cozzile": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Massa Fermana": { p: "Fermo", s: "FM", r: "Marche" },
  "Massa Lombarda": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Massa Lubrense": { p: "Napoli", s: "NA", r: "Campania" },
  "Massa Marittima": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Massa Martana": { p: "Perugia", s: "PG", r: "Umbria" },
  "Massafra": { p: "Taranto", s: "TA", r: "Puglia" },
  "Massalengo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Massanzago": { p: "Padova", s: "PD", r: "Veneto" },
  "Massarosa": { p: "Lucca", s: "LU", r: "Toscana" },
  "Massazza": { p: "Biella", s: "BI", r: "Piemonte" },
  "Massello": { p: "Torino", s: "TO", r: "Piemonte" },
  "Masserano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Massignano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Massimeno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Massimino": { p: "Savona", s: "SV", r: "Liguria" },
  "Massino Visconti": { p: "Novara", s: "NO", r: "Piemonte" },
  "Massiola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Masullas": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Matelica": { p: "Macerata", s: "MC", r: "Marche" },
  "Matera": { p: "Matera", s: "MT", r: "Basilicata" },
  "Mathi": { p: "Torino", s: "TO", r: "Piemonte" },
  "Matino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Matrice": { p: "Campobasso", s: "CB", r: "Molise" },
  "Mattie": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mattinata": { p: "Foggia", s: "FG", r: "Puglia" },
  "Mazara del Vallo": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Mazzano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Mazzano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Mazzarino": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Mazzarrone": { p: "Catania", s: "CT", r: "Sicilia" },
  "Mazzarrà Sant'Andrea": { p: "Messina", s: "ME", r: "Sicilia" },
  "Mazzin": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mazzo di Valtellina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Mazzè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Meana di Susa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Meana Sardo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Meda": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Mede": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Medea": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Medesano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Medicina": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Mediglia": { p: "Milano", s: "MI", r: "Lombardia" },
  "Medolago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Medole": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Medolla": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Meduna di Livenza": { p: "Treviso", s: "TV", r: "Veneto" },
  "Meduno": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Megliadino San Vitale": { p: "Padova", s: "PD", r: "Veneto" },
  "Meina": { p: "Novara", s: "NO", r: "Piemonte" },
  "Melara": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Melazzo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Meldola": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Mele": { p: "Genova", s: "GE", r: "Liguria" },
  "Melegnano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Melendugno": { p: "Lecce", s: "LE", r: "Puglia" },
  "Meleti": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Melfi": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Melicucco": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Melicuccà": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Melilli": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Melissa": { p: "Crotone", s: "KR", r: "Calabria" },
  "Melissano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Melito di Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Melito di Porto Salvo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Melito Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Melizzano": { p: "Benevento", s: "BN", r: "Campania" },
  "Melle": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mello": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Melpignano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Meltina": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Melzo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Menaggio": { p: "Como", s: "CO", r: "Lombardia" },
  "Menconico": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Mendatica": { p: "Imperia", s: "IM", r: "Liguria" },
  "Mendicino": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Menfi": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Mentana": { p: "Roma", s: "RM", r: "Lazio" },
  "Meolo": { p: "Venezia", s: "VE", r: "Veneto" },
  "Merana": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Merano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Merate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Mercallo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Mercatello sul Metauro": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Mercatino Conca": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Mercato San Severino": { p: "Salerno", s: "SA", r: "Campania" },
  "Mercato Saraceno": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Mercenasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mercogliano": { p: "Avellino", s: "AV", r: "Campania" },
  "Mereto di Tomba": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Mergo": { p: "Ancona", s: "AN", r: "Marche" },
  "Mergozzo": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Merlara": { p: "Padova", s: "PD", r: "Veneto" },
  "Merlino": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Merone": { p: "Como", s: "CO", r: "Lombardia" },
  "Merì": { p: "Messina", s: "ME", r: "Sicilia" },
  "Mesagne": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Mese": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Mesenzana": { p: "Varese", s: "VA", r: "Lombardia" },
  "Mesero": { p: "Milano", s: "MI", r: "Lombardia" },
  "Mesola": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Mesoraca": { p: "Crotone", s: "KR", r: "Calabria" },
  "Messina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Mestrino": { p: "Padova", s: "PD", r: "Veneto" },
  "Meta": { p: "Napoli", s: "NA", r: "Campania" },
  "Mezzago": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Mezzana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mezzana Bigli": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Mezzana Mortigliengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Mezzana Rabattone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Mezzane di Sotto": { p: "Verona", s: "VR", r: "Veneto" },
  "Mezzanego": { p: "Genova", s: "GE", r: "Liguria" },
  "Mezzanino": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Mezzano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mezzenile": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mezzocorona": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mezzojuso": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Mezzoldo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Mezzolombardo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mezzomerico": { p: "Novara", s: "NO", r: "Piemonte" },
  "Miagliano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Miane": { p: "Treviso", s: "TV", r: "Veneto" },
  "Miasino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Miazzina": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Micigliano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Miggiano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Miglianico": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Miglierina": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Miglionico": { p: "Matera", s: "MT", r: "Basilicata" },
  "Mignanego": { p: "Genova", s: "GE", r: "Liguria" },
  "Mignano Monte Lungo": { p: "Caserta", s: "CE", r: "Campania" },
  "Milano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Milazzo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Milena": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Mileto": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Milis": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Militello in Val di Catania": { p: "Catania", s: "CT", r: "Sicilia" },
  "Militello Rosmarino": { p: "Messina", s: "ME", r: "Sicilia" },
  "Millesimo": { p: "Savona", s: "SV", r: "Liguria" },
  "Milo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Milzano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Mineo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Minerbe": { p: "Verona", s: "VR", r: "Veneto" },
  "Minerbio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Minervino di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "Minervino Murge": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Minori": { p: "Salerno", s: "SA", r: "Campania" },
  "Minturno": { p: "Latina", s: "LT", r: "Lazio" },
  "Minucciano": { p: "Lucca", s: "LU", r: "Toscana" },
  "Mioglia": { p: "Savona", s: "SV", r: "Liguria" },
  "Mira": { p: "Venezia", s: "VE", r: "Veneto" },
  "Mirabella Eclano": { p: "Avellino", s: "AV", r: "Campania" },
  "Mirabella Imbaccari": { p: "Catania", s: "CT", r: "Sicilia" },
  "Mirabello Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Mirabello Sannitico": { p: "Campobasso", s: "CB", r: "Molise" },
  "Miradolo Terme": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Miranda": { p: "Isernia", s: "IS", r: "Molise" },
  "Mirandola": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Mirano": { p: "Venezia", s: "VE", r: "Veneto" },
  "Mirto": { p: "Messina", s: "ME", r: "Sicilia" },
  "Misano Adriatico": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Misano di Gera d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Misilmeri": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Misinto": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Missaglia": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Missanello": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Misterbianco": { p: "Catania", s: "CT", r: "Sicilia" },
  "Mistretta": { p: "Messina", s: "ME", r: "Sicilia" },
  "Moasca": { p: "Asti", s: "AT", r: "Piemonte" },
  "Moconesi": { p: "Genova", s: "GE", r: "Liguria" },
  "Modena": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Modica": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Modigliana": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Modolo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Modugno": { p: "Bari", s: "BA", r: "Puglia" },
  "Moena": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Moggio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Moggio Udinese": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Moglia": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Mogliano": { p: "Macerata", s: "MC", r: "Marche" },
  "Mogliano Veneto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Mogorella": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Mogoro": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Moiano": { p: "Benevento", s: "BN", r: "Campania" },
  "Moimacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Moio Alcantara": { p: "Messina", s: "ME", r: "Sicilia" },
  "Moio de' Calvi": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Moio della Civitella": { p: "Salerno", s: "SA", r: "Campania" },
  "Moiola": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mola di Bari": { p: "Bari", s: "BA", r: "Puglia" },
  "Molare": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Molazzana": { p: "Lucca", s: "LU", r: "Toscana" },
  "Molfetta": { p: "Bari", s: "BA", r: "Puglia" },
  "Molina Aterno": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Molinara": { p: "Benevento", s: "BN", r: "Campania" },
  "Molinella": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Molini di Triora": { p: "Imperia", s: "IM", r: "Liguria" },
  "Molino dei Torti": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Molise": { p: "Campobasso", s: "CB", r: "Molise" },
  "Moliterno": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Mollia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Molochio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Molteno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Moltrasio": { p: "Como", s: "CO", r: "Lombardia" },
  "Molveno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Mombaldone": { p: "Asti", s: "AT", r: "Piemonte" },
  "Mombarcaro": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mombaroccio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Mombaruzzo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Mombasiglio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mombello di Torino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mombello Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Mombercelli": { p: "Asti", s: "AT", r: "Piemonte" },
  "Momo": { p: "Novara", s: "NO", r: "Piemonte" },
  "Mompantero": { p: "Torino", s: "TO", r: "Piemonte" },
  "Mompeo": { p: "Rieti", s: "RI", r: "Lazio" },
  "Momperone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Monacilioni": { p: "Campobasso", s: "CB", r: "Molise" },
  "Monale": { p: "Asti", s: "AT", r: "Piemonte" },
  "Monasterace": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Monastero Bormida": { p: "Asti", s: "AT", r: "Piemonte" },
  "Monastero di Lanzo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Monastero di Vasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monasterolo Casotto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monasterolo del Castello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Monasterolo di Savigliano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monastier di Treviso": { p: "Treviso", s: "TV", r: "Veneto" },
  "Monastir": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Moncalieri": { p: "Torino", s: "TO", r: "Piemonte" },
  "Moncalvo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Moncenisio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Moncestino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Monchiero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monchio delle Corti": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Moncrivello": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Moncucco Torinese": { p: "Asti", s: "AT", r: "Piemonte" },
  "Mondaino": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Mondavio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Mondolfo": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Mondragone": { p: "Caserta", s: "CE", r: "Campania" },
  "Moneglia": { p: "Genova", s: "GE", r: "Liguria" },
  "Monesiglio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monfalcone": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Monforte d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monforte San Giorgio": { p: "Messina", s: "ME", r: "Sicilia" },
  "Monfumo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Mongardino": { p: "Asti", s: "AT", r: "Piemonte" },
  "Monghidoro": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Mongiana": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Mongiardino Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Mongiuffi Melia": { p: "Messina", s: "ME", r: "Sicilia" },
  "Mongrando": { p: "Biella", s: "BI", r: "Piemonte" },
  "Mongrassano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Monguelfo-Tesido": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Monguzzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Moniga del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Monleale": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Monno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Monopoli": { p: "Bari", s: "BA", r: "Puglia" },
  "Monreale": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Monrupino": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "Monsampietro Morico": { p: "Fermo", s: "FM", r: "Marche" },
  "Monsampolo del Tronto": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Monsano": { p: "Ancona", s: "AN", r: "Marche" },
  "Monselice": { p: "Padova", s: "PD", r: "Veneto" },
  "Monserrato": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Monsummano Terme": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Montabone": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montacuto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montafia": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montagano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montagna": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Montagna in Valtellina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Montagnana": { p: "Padova", s: "PD", r: "Veneto" },
  "Montagnareale": { p: "Messina", s: "ME", r: "Sicilia" },
  "Montaguto": { p: "Avellino", s: "AV", r: "Campania" },
  "Montaione": { p: "Firenze", s: "FI", r: "Toscana" },
  "Montalbano Elicona": { p: "Messina", s: "ME", r: "Sicilia" },
  "Montalbano Jonico": { p: "Matera", s: "MT", r: "Basilicata" },
  "Montalcino": { p: "Siena", s: "SI", r: "Toscana" },
  "Montaldeo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montaldo Bormida": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montaldo di Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montaldo Roero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montaldo Scarampi": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montaldo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Montale": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Montalenghe": { p: "Torino", s: "TO", r: "Piemonte" },
  "Montallegro": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Montalto Carpasio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Montalto delle Marche": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montalto di Castro": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Montalto Dora": { p: "Torino", s: "TO", r: "Piemonte" },
  "Montalto Pavese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Montalto Uffugo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Montanaro": { p: "Torino", s: "TO", r: "Piemonte" },
  "Montanaso Lombardo": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Montanera": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montano Antilia": { p: "Salerno", s: "SA", r: "Campania" },
  "Montano Lucino": { p: "Como", s: "CO", r: "Lombardia" },
  "Montappone": { p: "Fermo", s: "FM", r: "Marche" },
  "Montaquila": { p: "Isernia", s: "IS", r: "Molise" },
  "Montasola": { p: "Rieti", s: "RI", r: "Lazio" },
  "Montauro": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Montazzoli": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Monte Argentario": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Monte Castello di Vibio": { p: "Perugia", s: "PG", r: "Umbria" },
  "Monte Cavallo": { p: "Macerata", s: "MC", r: "Marche" },
  "Monte Cerignone": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Monte Compatri": { p: "Roma", s: "RM", r: "Lazio" },
  "Monte Cremasco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Monte di Malo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Monte di Procida": { p: "Napoli", s: "NA", r: "Campania" },
  "Monte Giberto": { p: "Fermo", s: "FM", r: "Marche" },
  "Monte Grimano Terme": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Monte Isola": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Monte Marenzo": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Monte Porzio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Monte Porzio Catone": { p: "Roma", s: "RM", r: "Lazio" },
  "Monte Rinaldo": { p: "Fermo", s: "FM", r: "Marche" },
  "Monte Roberto": { p: "Ancona", s: "AN", r: "Marche" },
  "Monte Romano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Monte San Biagio": { p: "Latina", s: "LT", r: "Lazio" },
  "Monte San Giacomo": { p: "Salerno", s: "SA", r: "Campania" },
  "Monte San Giovanni Campano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Monte San Giovanni in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Monte San Giusto": { p: "Macerata", s: "MC", r: "Marche" },
  "Monte San Martino": { p: "Macerata", s: "MC", r: "Marche" },
  "Monte San Pietrangeli": { p: "Fermo", s: "FM", r: "Marche" },
  "Monte San Pietro": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Monte San Savino": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Monte San Vito": { p: "Ancona", s: "AN", r: "Marche" },
  "Monte Sant'Angelo": { p: "Foggia", s: "FG", r: "Puglia" },
  "Monte Santa Maria Tiberina": { p: "Perugia", s: "PG", r: "Umbria" },
  "Monte Urano": { p: "Fermo", s: "FM", r: "Marche" },
  "Monte Vidon Combatte": { p: "Fermo", s: "FM", r: "Marche" },
  "Monte Vidon Corrado": { p: "Fermo", s: "FM", r: "Marche" },
  "Montebello della Battaglia": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Montebello di Bertona": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Montebello Jonico": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Montebello sul Sangro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Montebello Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montebelluna": { p: "Treviso", s: "TV", r: "Veneto" },
  "Montebruno": { p: "Genova", s: "GE", r: "Liguria" },
  "Montebuono": { p: "Rieti", s: "RI", r: "Lazio" },
  "Montecalvo in Foglia": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Montecalvo Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Montecalvo Versiggia": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Montecarlo": { p: "Lucca", s: "LU", r: "Toscana" },
  "Montecarotto": { p: "Ancona", s: "AN", r: "Marche" },
  "Montecassiano": { p: "Macerata", s: "MC", r: "Marche" },
  "Montecastello": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montecastrilli": { p: "Terni", s: "TR", r: "Umbria" },
  "Montecatini Val di Cecina": { p: "Pisa", s: "PI", r: "Toscana" },
  "Montecatini-Terme": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Montecchia di Crosara": { p: "Verona", s: "VR", r: "Veneto" },
  "Montecchio": { p: "Terni", s: "TR", r: "Umbria" },
  "Montecchio Emilia": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Montecchio Maggiore": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montecchio Precalcino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montechiaro d'Acqui": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montechiaro d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montechiarugolo": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Monteciccardo": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Montecilfone": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montecopiolo": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Montecorice": { p: "Salerno", s: "SA", r: "Campania" },
  "Montecorvino Pugliano": { p: "Salerno", s: "SA", r: "Campania" },
  "Montecorvino Rovella": { p: "Salerno", s: "SA", r: "Campania" },
  "Montecosaro": { p: "Macerata", s: "MC", r: "Marche" },
  "Montecrestese": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Montecreto": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Montedinove": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montedoro": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Montefalcione": { p: "Avellino", s: "AV", r: "Campania" },
  "Montefalco": { p: "Perugia", s: "PG", r: "Umbria" },
  "Montefalcone Appennino": { p: "Fermo", s: "FM", r: "Marche" },
  "Montefalcone di Val Fortore": { p: "Benevento", s: "BN", r: "Campania" },
  "Montefalcone nel Sannio": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montefano": { p: "Macerata", s: "MC", r: "Marche" },
  "Montefelcino": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Monteferrante": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Montefiascone": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Montefino": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Montefiore Conca": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Montefiore dell'Aso": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montefiorino": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Monteflavio": { p: "Roma", s: "RM", r: "Lazio" },
  "Monteforte Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Monteforte d'Alpone": { p: "Verona", s: "VR", r: "Veneto" },
  "Monteforte Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Montefortino": { p: "Fermo", s: "FM", r: "Marche" },
  "Montefranco": { p: "Terni", s: "TR", r: "Umbria" },
  "Montefredane": { p: "Avellino", s: "AV", r: "Campania" },
  "Montefusco": { p: "Avellino", s: "AV", r: "Campania" },
  "Montegabbione": { p: "Terni", s: "TR", r: "Umbria" },
  "Montegalda": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montegaldella": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montegallo": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montegioco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montegiordano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Montegiorgio": { p: "Fermo", s: "FM", r: "Marche" },
  "Montegranaro": { p: "Fermo", s: "FM", r: "Marche" },
  "Montegridolfo": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Montegrino Valtravaglia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Montegrosso d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montegrosso Pian Latte": { p: "Imperia", s: "IM", r: "Liguria" },
  "Montegrotto Terme": { p: "Padova", s: "PD", r: "Veneto" },
  "Monteiasi": { p: "Taranto", s: "TA", r: "Puglia" },
  "Montelabbate": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Montelanico": { p: "Roma", s: "RM", r: "Lazio" },
  "Montelapiano": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Monteleone d'Orvieto": { p: "Terni", s: "TR", r: "Umbria" },
  "Monteleone di Fermo": { p: "Fermo", s: "FM", r: "Marche" },
  "Monteleone di Puglia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Monteleone di Spoleto": { p: "Perugia", s: "PG", r: "Umbria" },
  "Monteleone Rocca Doria": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Monteleone Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Montelepre": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Montelibretti": { p: "Roma", s: "RM", r: "Lazio" },
  "Montella": { p: "Avellino", s: "AV", r: "Campania" },
  "Montello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Montelongo": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montelparo": { p: "Fermo", s: "FM", r: "Marche" },
  "Montelupo Albese": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montelupo Fiorentino": { p: "Firenze", s: "FI", r: "Toscana" },
  "Montelupone": { p: "Macerata", s: "MC", r: "Marche" },
  "Montemaggiore Belsito": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Montemagno": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montemale di Cuneo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montemarano": { p: "Avellino", s: "AV", r: "Campania" },
  "Montemarciano": { p: "Ancona", s: "AN", r: "Marche" },
  "Montemarzino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Montemesola": { p: "Taranto", s: "TA", r: "Puglia" },
  "Montemezzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Montemignaio": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Montemiletto": { p: "Avellino", s: "AV", r: "Campania" },
  "Montemilone": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Montemitro": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montemonaco": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montemurlo": { p: "Prato", s: "PO", r: "Toscana" },
  "Montemurro": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Montenars": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Montenero di Bisaccia": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montenero Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Montenero Val Cocchiara": { p: "Isernia", s: "IS", r: "Molise" },
  "Montenerodomo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Monteodorisio": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Montepaone": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Monteparano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Monteprandone": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Montepulciano": { p: "Siena", s: "SI", r: "Toscana" },
  "Monterchi": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Montereale": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Montereale Valcellina": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Monterenzio": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Monteriggioni": { p: "Siena", s: "SI", r: "Toscana" },
  "Monteroduni": { p: "Isernia", s: "IS", r: "Molise" },
  "Monteroni d'Arbia": { p: "Siena", s: "SI", r: "Toscana" },
  "Monteroni di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "Monterosi": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Monterosso al Mare": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Monterosso Almo": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Monterosso Calabro": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Monterosso Grana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monterotondo": { p: "Roma", s: "RM", r: "Lazio" },
  "Monterotondo Marittimo": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Monterubbiano": { p: "Fermo", s: "FM", r: "Marche" },
  "Montesano Salentino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Montesano sulla Marcellana": { p: "Salerno", s: "SA", r: "Campania" },
  "Montesarchio": { p: "Benevento", s: "BN", r: "Campania" },
  "Montescaglioso": { p: "Matera", s: "MT", r: "Basilicata" },
  "Montescano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Montescheno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Montescudaio": { p: "Pisa", s: "PI", r: "Toscana" },
  "Montescudo-Monte Colombo": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Montese": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Montesegale": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Montesilvano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Montespertoli": { p: "Firenze", s: "FI", r: "Toscana" },
  "Monteu da Po": { p: "Torino", s: "TO", r: "Piemonte" },
  "Monteu Roero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montevago": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Montevarchi": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Montevecchia": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Monteverde": { p: "Avellino", s: "AV", r: "Campania" },
  "Monteverdi Marittimo": { p: "Pisa", s: "PI", r: "Toscana" },
  "Monteviale": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montezemolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Monti": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Montiano": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Monticelli Brusati": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Monticelli d'Ongina": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Monticelli Pavese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Monticello Brianza": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Monticello Conte Otto": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Monticello d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montichiari": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Monticiano": { p: "Siena", s: "SI", r: "Toscana" },
  "Montieri": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Montiglio Monferrato": { p: "Asti", s: "AT", r: "Piemonte" },
  "Montignoso": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Montirone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Montjovet": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Montodine": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Montoggio": { p: "Genova", s: "GE", r: "Liguria" },
  "Montone": { p: "Perugia", s: "PG", r: "Umbria" },
  "Montopoli di Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Montopoli in Val d'Arno": { p: "Pisa", s: "PI", r: "Toscana" },
  "Montorfano": { p: "Como", s: "CO", r: "Lombardia" },
  "Montorio al Vomano": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Montorio nei Frentani": { p: "Campobasso", s: "CB", r: "Molise" },
  "Montorio Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Montoro": { p: "Avellino", s: "AV", r: "Campania" },
  "Montorso Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Montottone": { p: "Fermo", s: "FM", r: "Marche" },
  "Montresta": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Montà": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Montù Beccaria": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Monvalle": { p: "Varese", s: "VA", r: "Lombardia" },
  "Monza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Monzambano": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Monzuno": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Morano Calabro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Morano sul Po": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Moransengo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Moraro": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Morazzone": { p: "Varese", s: "VA", r: "Lombardia" },
  "Morbegno": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Morbello": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Morciano di Leuca": { p: "Lecce", s: "LE", r: "Puglia" },
  "Morciano di Romagna": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Morcone": { p: "Benevento", s: "BN", r: "Campania" },
  "Mordano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Morengo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Mores": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Moresco": { p: "Fermo", s: "FM", r: "Marche" },
  "Moretta": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Morfasso": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Morgano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Morgex": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Morgongiori": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Mori": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Moriago della Battaglia": { p: "Treviso", s: "TV", r: "Veneto" },
  "Moricone": { p: "Roma", s: "RM", r: "Lazio" },
  "Morigerati": { p: "Salerno", s: "SA", r: "Campania" },
  "Morimondo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Morino": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Moriondo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Morlupo": { p: "Roma", s: "RM", r: "Lazio" },
  "Mormanno": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Mornago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Mornese": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Mornico al Serio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Mornico Losana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Morolo": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Morozzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Morra De Sanctis": { p: "Avellino", s: "AV", r: "Campania" },
  "Morro d'Alba": { p: "Ancona", s: "AN", r: "Marche" },
  "Morro d'Oro": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Morro Reatino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Morrone del Sannio": { p: "Campobasso", s: "CB", r: "Molise" },
  "Morrovalle": { p: "Macerata", s: "MC", r: "Marche" },
  "Morsano al Tagliamento": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Morsasco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Mortara": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Mortegliano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Morterone": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Moruzzo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Moscazzano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Moschiano": { p: "Avellino", s: "AV", r: "Campania" },
  "Mosciano Sant'Angelo": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Moscufo": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Moso in Passiria": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Mossa": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Motta Baluffi": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Motta Camastra": { p: "Messina", s: "ME", r: "Sicilia" },
  "Motta d'Affermo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Motta de' Conti": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Motta di Livenza": { p: "Treviso", s: "TV", r: "Veneto" },
  "Motta Montecorvino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Motta San Giovanni": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Motta Sant'Anastasia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Motta Santa Lucia": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Motta Visconti": { p: "Milano", s: "MI", r: "Lombardia" },
  "Mottafollone": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Mottalciata": { p: "Biella", s: "BI", r: "Piemonte" },
  "Motteggiana": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Mottola": { p: "Taranto", s: "TA", r: "Puglia" },
  "Mozzagrogna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Mozzanica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Mozzate": { p: "Como", s: "CO", r: "Lombardia" },
  "Mozzecane": { p: "Verona", s: "VR", r: "Veneto" },
  "Mozzo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Muccia": { p: "Macerata", s: "MC", r: "Marche" },
  "Muggia": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "Muggiò": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Mugnano del Cardinale": { p: "Avellino", s: "AV", r: "Campania" },
  "Mugnano di Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Mulazzano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Mulazzo": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Mura": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Muravera": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Murazzano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Murello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Murialdo": { p: "Savona", s: "SV", r: "Liguria" },
  "Murisengo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Murlo": { p: "Siena", s: "SI", r: "Toscana" },
  "Muro Leccese": { p: "Lecce", s: "LE", r: "Puglia" },
  "Muro Lucano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Muros": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Muscoline": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Musei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Musile di Piave": { p: "Venezia", s: "VE", r: "Veneto" },
  "Musso": { p: "Como", s: "CO", r: "Lombardia" },
  "Mussolente": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Mussomeli": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Muzzana del Turgnano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Muzzano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Nago-Torbole": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Nalles": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Nanto": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Napoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Narbolia": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Narcao": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Nardodipace": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Nardò": { p: "Lecce", s: "LE", r: "Puglia" },
  "Narni": { p: "Terni", s: "TR", r: "Umbria" },
  "Naro": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Narzole": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Nasino": { p: "Savona", s: "SV", r: "Liguria" },
  "Naso": { p: "Messina", s: "ME", r: "Sicilia" },
  "Naturno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Nave": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Navelli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Naz-Sciaves": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Nazzano": { p: "Roma", s: "RM", r: "Lazio" },
  "Ne": { p: "Genova", s: "GE", r: "Liguria" },
  "Nebbiuno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Negrar di Valpolicella": { p: "Verona", s: "VR", r: "Veneto" },
  "Neirone": { p: "Genova", s: "GE", r: "Liguria" },
  "Neive": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Nembro": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Nemi": { p: "Roma", s: "RM", r: "Lazio" },
  "Nemoli": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Neoneli": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Nepi": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Nereto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Nerola": { p: "Roma", s: "RM", r: "Lazio" },
  "Nervesa della Battaglia": { p: "Treviso", s: "TV", r: "Veneto" },
  "Nerviano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Nespolo": { p: "Rieti", s: "RI", r: "Lazio" },
  "Nesso": { p: "Como", s: "CO", r: "Lombardia" },
  "Netro": { p: "Biella", s: "BI", r: "Piemonte" },
  "Nettuno": { p: "Roma", s: "RM", r: "Lazio" },
  "Neviano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Neviano degli Arduini": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Neviglie": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Niardo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Nibbiola": { p: "Novara", s: "NO", r: "Piemonte" },
  "Nibionno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Nichelino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Nicolosi": { p: "Catania", s: "CT", r: "Sicilia" },
  "Nicorvo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Nicosia": { p: "Enna", s: "EN", r: "Sicilia" },
  "Nicotera": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Niella Belbo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Niella Tanaro": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Nimis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Niscemi": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Nissoria": { p: "Enna", s: "EN", r: "Sicilia" },
  "Nizza di Sicilia": { p: "Messina", s: "ME", r: "Sicilia" },
  "Nizza Monferrato": { p: "Asti", s: "AT", r: "Piemonte" },
  "Noale": { p: "Venezia", s: "VE", r: "Veneto" },
  "Noasca": { p: "Torino", s: "TO", r: "Piemonte" },
  "Nocara": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Nocciano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Nocera Inferiore": { p: "Salerno", s: "SA", r: "Campania" },
  "Nocera Superiore": { p: "Salerno", s: "SA", r: "Campania" },
  "Nocera Terinese": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Nocera Umbra": { p: "Perugia", s: "PG", r: "Umbria" },
  "Noceto": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Noci": { p: "Bari", s: "BA", r: "Puglia" },
  "Nociglia": { p: "Lecce", s: "LE", r: "Puglia" },
  "Noepoli": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Nogara": { p: "Verona", s: "VR", r: "Veneto" },
  "Nogaredo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Nogarole Rocca": { p: "Verona", s: "VR", r: "Veneto" },
  "Nogarole Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Noicattaro": { p: "Bari", s: "BA", r: "Puglia" },
  "Nola": { p: "Napoli", s: "NA", r: "Campania" },
  "Nole": { p: "Torino", s: "TO", r: "Piemonte" },
  "Noli": { p: "Savona", s: "SV", r: "Liguria" },
  "Nomaglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Nomi": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Nonantola": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "None": { p: "Torino", s: "TO", r: "Piemonte" },
  "Nonio": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Noragugume": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Norbello": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Norcia": { p: "Perugia", s: "PG", r: "Umbria" },
  "Norma": { p: "Latina", s: "LT", r: "Lazio" },
  "Nosate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Notaresco": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Noto": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Nova Levante": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Nova Milanese": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Nova Ponente": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Nova Siri": { p: "Matera", s: "MT", r: "Basilicata" },
  "Novafeltria": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Novaledo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Novalesa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Novara": { p: "Novara", s: "NO", r: "Piemonte" },
  "Novara di Sicilia": { p: "Messina", s: "ME", r: "Sicilia" },
  "Novate Mezzola": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Novate Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Nove": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Novedrate": { p: "Como", s: "CO", r: "Lombardia" },
  "Novella": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Novellara": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Novello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Noventa di Piave": { p: "Venezia", s: "VE", r: "Veneto" },
  "Noventa Padovana": { p: "Padova", s: "PD", r: "Veneto" },
  "Noventa Vicentina": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Novi di Modena": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Novi Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Novi Velia": { p: "Salerno", s: "SA", r: "Campania" },
  "Noviglio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Novoli": { p: "Lecce", s: "LE", r: "Puglia" },
  "Nucetto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Nughedu San Nicolò": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Nughedu Santa Vittoria": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Nule": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Nulvi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Numana": { p: "Ancona", s: "AN", r: "Marche" },
  "Nuoro": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Nurachi": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Nuragus": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Nurallao": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Nuraminis": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Nureci": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Nurri": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Nus": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Nusco": { p: "Avellino", s: "AV", r: "Campania" },
  "Nuvolento": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Nuvolera": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Nuxis": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Occhieppo Inferiore": { p: "Biella", s: "BI", r: "Piemonte" },
  "Occhieppo Superiore": { p: "Biella", s: "BI", r: "Piemonte" },
  "Occhiobello": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Occimiano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ocre": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Odalengo Grande": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Odalengo Piccolo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Oderzo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Odolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ofena": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Offagna": { p: "Ancona", s: "AN", r: "Marche" },
  "Offanengo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Offida": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Offlaga": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Oggebbio": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Oggiona con Santo Stefano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Oggiono": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Oglianico": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ogliastro Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Olbia": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Olcenengo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Oldenico": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Oleggio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Oleggio Castello": { p: "Novara", s: "NO", r: "Piemonte" },
  "Olevano di Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Olevano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Olevano sul Tusciano": { p: "Salerno", s: "SA", r: "Campania" },
  "Olgiate Comasco": { p: "Como", s: "CO", r: "Lombardia" },
  "Olgiate Molgora": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Olgiate Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Olginate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Oliena": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oliva Gessi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Olivadi": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Oliveri": { p: "Messina", s: "ME", r: "Sicilia" },
  "Oliveto Citra": { p: "Salerno", s: "SA", r: "Campania" },
  "Oliveto Lario": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Oliveto Lucano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Olivetta San Michele": { p: "Imperia", s: "IM", r: "Liguria" },
  "Olivola": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ollastra": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ollolai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ollomont": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Olmedo": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Olmeneta": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Olmo al Brembo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Olmo Gentile": { p: "Asti", s: "AT", r: "Piemonte" },
  "Oltre il Colle": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Oltressenda Alta": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Oltrona di San Mamette": { p: "Como", s: "CO", r: "Lombardia" },
  "Olzai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ome": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Omegna": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Omignano": { p: "Salerno", s: "SA", r: "Campania" },
  "Onano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Onanì": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oncino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Oneta": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Onifai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oniferi": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ono San Pietro": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Onore": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Onzo": { p: "Savona", s: "SV", r: "Liguria" },
  "Opera": { p: "Milano", s: "MI", r: "Lombardia" },
  "Opi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Oppeano": { p: "Verona", s: "VR", r: "Veneto" },
  "Oppido Lucano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Oppido Mamertina": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Ora": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Orani": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oratino": { p: "Campobasso", s: "CB", r: "Molise" },
  "Orbassano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Orbetello": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Orciano Pisano": { p: "Pisa", s: "PI", r: "Toscana" },
  "Orco Feglino": { p: "Savona", s: "SV", r: "Liguria" },
  "Ordona": { p: "Foggia", s: "FG", r: "Puglia" },
  "Orero": { p: "Genova", s: "GE", r: "Liguria" },
  "Orgiano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Orgosolo": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oria": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Oricola": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Origgio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Orino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Orio al Serio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Orio Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Orio Litta": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Oriolo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Oriolo Romano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Oristano": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Ormea": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ormelle": { p: "Treviso", s: "TV", r: "Veneto" },
  "Ornago": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Ornavasso": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Ornica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Orosei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Orotelli": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Orria": { p: "Salerno", s: "SA", r: "Campania" },
  "Orroli": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Orsago": { p: "Treviso", s: "TV", r: "Veneto" },
  "Orsara Bormida": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Orsara di Puglia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Orsenigo": { p: "Como", s: "CO", r: "Lombardia" },
  "Orsogna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Orsomarso": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Orta di Atella": { p: "Caserta", s: "CE", r: "Campania" },
  "Orta Nova": { p: "Foggia", s: "FG", r: "Puglia" },
  "Orta San Giulio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Ortacesus": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Orte": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Ortelle": { p: "Lecce", s: "LE", r: "Puglia" },
  "Ortezzano": { p: "Fermo", s: "FM", r: "Marche" },
  "Ortignano Raggiolo": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Ortisei": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Ortona": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Ortona dei Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Ortovero": { p: "Savona", s: "SV", r: "Liguria" },
  "Ortucchio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Ortueri": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Orune": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Orvieto": { p: "Terni", s: "TR", r: "Umbria" },
  "Orvinio": { p: "Rieti", s: "RI", r: "Lazio" },
  "Orzinuovi": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Orzivecchi": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Osasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Osasio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Oschiri": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Osidda": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Osiglia": { p: "Savona", s: "SV", r: "Liguria" },
  "Osilo": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Osimo": { p: "Ancona", s: "AN", r: "Marche" },
  "Osini": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Osio Sopra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Osio Sotto": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Osnago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Osoppo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Ospedaletti": { p: "Imperia", s: "IM", r: "Liguria" },
  "Ospedaletto": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ospedaletto d'Alpinolo": { p: "Avellino", s: "AV", r: "Campania" },
  "Ospedaletto Euganeo": { p: "Padova", s: "PD", r: "Veneto" },
  "Ospedaletto Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Ospitale di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Ospitaletto": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ossago Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Ossana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ossi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ossimo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ossona": { p: "Milano", s: "MI", r: "Lombardia" },
  "Ostana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ostellato": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Ostiano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ostiglia": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Ostra": { p: "Ancona", s: "AN", r: "Marche" },
  "Ostra Vetere": { p: "Ancona", s: "AN", r: "Marche" },
  "Ostuni": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Otranto": { p: "Lecce", s: "LE", r: "Puglia" },
  "Otricoli": { p: "Terni", s: "TR", r: "Umbria" },
  "Ottana": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ottati": { p: "Salerno", s: "SA", r: "Campania" },
  "Ottaviano": { p: "Napoli", s: "NA", r: "Campania" },
  "Ottiglio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ottobiano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Ottone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Oulx": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ovada": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ovaro": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Oviglio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ovindoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Ovodda": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Oyace": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Ozegna": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ozieri": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ozzano dell'Emilia": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Ozzano Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ozzero": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pabillonis": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Pace del Mela": { p: "Messina", s: "ME", r: "Sicilia" },
  "Paceco": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Pacentro": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pachino": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Paciano": { p: "Perugia", s: "PG", r: "Umbria" },
  "Padenghe sul Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Paderna": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Paderno d'Adda": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Paderno Dugnano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Paderno Franciacorta": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Paderno Ponchielli": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Padova": { p: "Padova", s: "PD", r: "Veneto" },
  "Padria": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Padru": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Padula": { p: "Salerno", s: "SA", r: "Campania" },
  "Paduli": { p: "Benevento", s: "BN", r: "Campania" },
  "Paesana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Paese": { p: "Treviso", s: "TV", r: "Veneto" },
  "Pagani": { p: "Salerno", s: "SA", r: "Campania" },
  "Paganico Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Pagazzano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pagliara": { p: "Messina", s: "ME", r: "Sicilia" },
  "Paglieta": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Pagnacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pagno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pagnona": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Pago del Vallo di Lauro": { p: "Avellino", s: "AV", r: "Campania" },
  "Pago Veiano": { p: "Benevento", s: "BN", r: "Campania" },
  "Paisco Loveno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Paitone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Paladina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Palagano": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Palagianello": { p: "Taranto", s: "TA", r: "Puglia" },
  "Palagiano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Palagonia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Palaia": { p: "Pisa", s: "PI", r: "Toscana" },
  "Palanzano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Palata": { p: "Campobasso", s: "CB", r: "Molise" },
  "Palau": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Palazzago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Palazzo Adriano": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Palazzo Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Palazzo Pignano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Palazzo San Gervasio": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Palazzolo Acreide": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Palazzolo dello Stella": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Palazzolo sull'Oglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Palazzolo Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Palazzuolo sul Senio": { p: "Firenze", s: "FI", r: "Toscana" },
  "Palena": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Palermiti": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Palermo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Palestrina": { p: "Roma", s: "RM", r: "Lazio" },
  "Palestro": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Paliano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Palizzi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Pallagorio": { p: "Crotone", s: "KR", r: "Calabria" },
  "Pallanzeno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Pallare": { p: "Savona", s: "SV", r: "Liguria" },
  "Palma Campania": { p: "Napoli", s: "NA", r: "Campania" },
  "Palma di Montechiaro": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Palmanova": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Palmariggi": { p: "Lecce", s: "LE", r: "Puglia" },
  "Palmas Arborea": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Palmi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Palmiano": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Palmoli": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Palo del Colle": { p: "Bari", s: "BA", r: "Puglia" },
  "Palombara Sabina": { p: "Roma", s: "RM", r: "Lazio" },
  "Palombaro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Palomonte": { p: "Salerno", s: "SA", r: "Campania" },
  "Palosco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Paludi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Paluzza": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Palù": { p: "Verona", s: "VR", r: "Veneto" },
  "Palù del Fersina": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pamparato": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pancalieri": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pancarana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Panchià": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pandino": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Panettieri": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Panicale": { p: "Perugia", s: "PG", r: "Umbria" },
  "Pannarano": { p: "Benevento", s: "BN", r: "Campania" },
  "Panni": { p: "Foggia", s: "FG", r: "Puglia" },
  "Pantelleria": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Pantigliate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Paola": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Paolisi": { p: "Benevento", s: "BN", r: "Campania" },
  "Papasidero": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Papozze": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Parabiago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Parabita": { p: "Lecce", s: "LE", r: "Puglia" },
  "Paratico": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Parcines": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Parella": { p: "Torino", s: "TO", r: "Piemonte" },
  "Parenti": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Parete": { p: "Caserta", s: "CE", r: "Campania" },
  "Pareto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Parghelia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Parlasco": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Parma": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Parodi Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Paroldo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Parolise": { p: "Avellino", s: "AV", r: "Campania" },
  "Parona": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Parrano": { p: "Terni", s: "TR", r: "Umbria" },
  "Parre": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Partanna": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Partinico": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Paruzzaro": { p: "Novara", s: "NO", r: "Piemonte" },
  "Parzanica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pasian di Prato": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pasiano di Pordenone": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Paspardo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Passerano Marmorito": { p: "Asti", s: "AT", r: "Piemonte" },
  "Passignano sul Trasimeno": { p: "Perugia", s: "PG", r: "Umbria" },
  "Passirano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pastena": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pastorano": { p: "Caserta", s: "CE", r: "Campania" },
  "Pastrengo": { p: "Verona", s: "VR", r: "Veneto" },
  "Pasturana": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pasturo": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Paterno": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Paterno Calabro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Paternopoli": { p: "Avellino", s: "AV", r: "Campania" },
  "Paternò": { p: "Catania", s: "CT", r: "Sicilia" },
  "Patrica": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pattada": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Patti": { p: "Messina", s: "ME", r: "Sicilia" },
  "Patù": { p: "Lecce", s: "LE", r: "Puglia" },
  "Pau": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Paularo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pauli Arbarei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Paulilatino": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Paullo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Paupisi": { p: "Benevento", s: "BN", r: "Campania" },
  "Pavarolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pavia": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pavia di Udine": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pavone Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pavone del Mella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pavullo nel Frignano": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Pazzano": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Peccioli": { p: "Pisa", s: "PI", r: "Toscana" },
  "Pecetto di Valenza": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pecetto Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pedara": { p: "Catania", s: "CT", r: "Sicilia" },
  "Pedaso": { p: "Fermo", s: "FM", r: "Marche" },
  "Pedavena": { p: "Belluno", s: "BL", r: "Veneto" },
  "Pedemonte": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Pederobba": { p: "Treviso", s: "TV", r: "Veneto" },
  "Pedesina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Pedivigliano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Pedrengo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Peglio": { p: "Como", s: "CO", r: "Lombardia" },
  "Peglio (CO)": { p: "Como", s: "CO", r: "Lombardia" },
  "Peglio (PU)": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Pegognaga": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Peia": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Peio": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pelago": { p: "Firenze", s: "FI", r: "Toscana" },
  "Pella": { p: "Novara", s: "NO", r: "Piemonte" },
  "Pellegrino Parmense": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Pellezzano": { p: "Salerno", s: "SA", r: "Campania" },
  "Pellizzano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pelugo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Penango": { p: "Asti", s: "AT", r: "Piemonte" },
  "Penna in Teverina": { p: "Terni", s: "TR", r: "Umbria" },
  "Penna San Giovanni": { p: "Macerata", s: "MC", r: "Marche" },
  "Penna Sant'Andrea": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Pennabilli": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Pennadomo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Pennapiedimonte": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Penne": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Pentone": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Perano": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Perarolo di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Perca": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Percile": { p: "Roma", s: "RM", r: "Lazio" },
  "Perdasdefogu": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Perdaxius": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Perdifumo": { p: "Salerno", s: "SA", r: "Campania" },
  "Pereto": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Perfugas": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Pergine Valsugana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pergola": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Perinaldo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Perito": { p: "Salerno", s: "SA", r: "Campania" },
  "Perledo": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Perletto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Perlo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Perloz": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Pernumia": { p: "Padova", s: "PD", r: "Veneto" },
  "Pero": { p: "Milano", s: "MI", r: "Lombardia" },
  "Perosa Argentina": { p: "Torino", s: "TO", r: "Piemonte" },
  "Perosa Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Perrero": { p: "Torino", s: "TO", r: "Piemonte" },
  "Persico Dosimo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pertengo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Pertica Alta": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pertica Bassa": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pertosa": { p: "Salerno", s: "SA", r: "Campania" },
  "Pertusio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Perugia": { p: "Perugia", s: "PG", r: "Umbria" },
  "Pesaro": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Pescaglia": { p: "Lucca", s: "LU", r: "Toscana" },
  "Pescantina": { p: "Verona", s: "VR", r: "Veneto" },
  "Pescara": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Pescarolo ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pescasseroli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pescate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Pesche": { p: "Isernia", s: "IS", r: "Molise" },
  "Peschici": { p: "Foggia", s: "FG", r: "Puglia" },
  "Peschiera Borromeo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Peschiera del Garda": { p: "Verona", s: "VR", r: "Veneto" },
  "Pescia": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Pescina": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pesco Sannita": { p: "Benevento", s: "BN", r: "Campania" },
  "Pescocostanzo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pescolanciano": { p: "Isernia", s: "IS", r: "Molise" },
  "Pescopagano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Pescopennataro": { p: "Isernia", s: "IS", r: "Molise" },
  "Pescorocchiano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Pescosansonesco": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Pescosolido": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pessano con Bornago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pessina Cremonese": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pessinetto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Petacciato": { p: "Campobasso", s: "CB", r: "Molise" },
  "Petilia Policastro": { p: "Crotone", s: "KR", r: "Calabria" },
  "Petina": { p: "Salerno", s: "SA", r: "Campania" },
  "Petralia Soprana": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Petralia Sottana": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Petrella Salto": { p: "Rieti", s: "RI", r: "Lazio" },
  "Petrella Tifernina": { p: "Campobasso", s: "CB", r: "Molise" },
  "Petriano": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Petriolo": { p: "Macerata", s: "MC", r: "Marche" },
  "Petritoli": { p: "Fermo", s: "FM", r: "Marche" },
  "Petrizzi": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Petronà": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Petrosino": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Petruro Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Pettenasco": { p: "Novara", s: "NO", r: "Piemonte" },
  "Pettinengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Pettineo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Pettoranello del Molise": { p: "Isernia", s: "IS", r: "Molise" },
  "Pettorano sul Gizio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pettorazza Grimani": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Peveragno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pezzana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Pezzaze": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pezzolo Valle Uzzone": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Piacenza": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Piacenza d'Adige": { p: "Padova", s: "PD", r: "Veneto" },
  "Piadena Drizzona": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Piaggine": { p: "Salerno", s: "SA", r: "Campania" },
  "Pian Camuno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Piana Crixia": { p: "Savona", s: "SV", r: "Liguria" },
  "Piana degli Albanesi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Piana di Monte Verna": { p: "Caserta", s: "CE", r: "Campania" },
  "Piancastagnaio": { p: "Siena", s: "SI", r: "Toscana" },
  "Piancogno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Piandimeleto": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Piane Crati": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Pianella": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Pianello del Lario": { p: "Como", s: "CO", r: "Lombardia" },
  "Pianello Val Tidone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Pianengo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pianezza": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pianezze": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Pianfei": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pianico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pianiga": { p: "Venezia", s: "VE", r: "Veneto" },
  "Piano di Sorrento": { p: "Napoli", s: "NA", r: "Campania" },
  "Pianopoli": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Pianoro": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Piansano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Piantedo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Piario": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Piasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Piateda": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Piatto": { p: "Biella", s: "BI", r: "Piemonte" },
  "Piazza al Serchio": { p: "Lucca", s: "LU", r: "Toscana" },
  "Piazza Armerina": { p: "Enna", s: "EN", r: "Sicilia" },
  "Piazza Brembana": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Piazzatorre": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Piazzola sul Brenta": { p: "Padova", s: "PD", r: "Veneto" },
  "Piazzolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Picciano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Picerno": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Picinisco": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pico": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Piea": { p: "Asti", s: "AT", r: "Piemonte" },
  "Piedicavallo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Piedimonte Etneo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Piedimonte Matese": { p: "Caserta", s: "CE", r: "Campania" },
  "Piedimonte San Germano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Piedimulera": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Piegaro": { p: "Perugia", s: "PG", r: "Umbria" },
  "Pienza": { p: "Siena", s: "SI", r: "Toscana" },
  "Pieranica": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pietra de' Giorgi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pietra Ligure": { p: "Savona", s: "SV", r: "Liguria" },
  "Pietra Marazzi": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pietrabbondante": { p: "Isernia", s: "IS", r: "Molise" },
  "Pietrabruna": { p: "Imperia", s: "IM", r: "Liguria" },
  "Pietracamela": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Pietracatella": { p: "Campobasso", s: "CB", r: "Molise" },
  "Pietracupa": { p: "Campobasso", s: "CB", r: "Molise" },
  "Pietradefusi": { p: "Avellino", s: "AV", r: "Campania" },
  "Pietraferrazzana": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Pietrafitta": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Pietragalla": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Pietralunga": { p: "Perugia", s: "PG", r: "Umbria" },
  "Pietramelara": { p: "Caserta", s: "CE", r: "Campania" },
  "Pietramontecorvino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Pietranico": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Pietrapaola": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Pietrapertosa": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Pietraperzia": { p: "Enna", s: "EN", r: "Sicilia" },
  "Pietraporzio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pietraroja": { p: "Benevento", s: "BN", r: "Campania" },
  "Pietrarubbia": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Pietrasanta": { p: "Lucca", s: "LU", r: "Toscana" },
  "Pietrastornina": { p: "Avellino", s: "AV", r: "Campania" },
  "Pietravairano": { p: "Caserta", s: "CE", r: "Campania" },
  "Pietrelcina": { p: "Benevento", s: "BN", r: "Campania" },
  "Pieve a Nievole": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Pieve Albignola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pieve d'Olmi": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pieve del Cairo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pieve del Grappa": { p: "Treviso", s: "TV", r: "Veneto" },
  "Pieve di Bono-Prezzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pieve di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Pieve di Cento": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Pieve di Soligo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Pieve di Teco": { p: "Imperia", s: "IM", r: "Liguria" },
  "Pieve Emanuele": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pieve Fissiraga": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Pieve Fosciana": { p: "Lucca", s: "LU", r: "Toscana" },
  "Pieve Ligure": { p: "Genova", s: "GE", r: "Liguria" },
  "Pieve Porto Morone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pieve San Giacomo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pieve Santo Stefano": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Pieve Tesino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pieve Torina": { p: "Macerata", s: "MC", r: "Marche" },
  "Pieve Vergonte": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Pievepelago": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Piglio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pigna": { p: "Imperia", s: "IM", r: "Liguria" },
  "Pignataro Interamna": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pignataro Maggiore": { p: "Caserta", s: "CE", r: "Campania" },
  "Pignola": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Pignone": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Pigra": { p: "Como", s: "CO", r: "Lombardia" },
  "Pila": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Pimentel": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Pimonte": { p: "Napoli", s: "NA", r: "Campania" },
  "Pinarolo Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pinasca": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pincara": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Pinerolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pineto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Pino d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Pino Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pinzano al Tagliamento": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Pinzolo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Piobbico": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Piobesi d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Piobesi Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Piode": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Pioltello": { p: "Milano", s: "MI", r: "Lombardia" },
  "Piombino": { p: "Livorno", s: "LI", r: "Toscana" },
  "Piombino Dese": { p: "Padova", s: "PD", r: "Veneto" },
  "Pioraco": { p: "Macerata", s: "MC", r: "Marche" },
  "Piossasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Piove di Sacco": { p: "Padova", s: "PD", r: "Veneto" },
  "Piovene Rocchette": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Piovà Massaia": { p: "Asti", s: "AT", r: "Piemonte" },
  "Piozzano": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Piozzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Piraino": { p: "Messina", s: "ME", r: "Sicilia" },
  "Pisa": { p: "Pisa", s: "PI", r: "Toscana" },
  "Pisano": { p: "Novara", s: "NO", r: "Piemonte" },
  "Piscina": { p: "Torino", s: "TO", r: "Piemonte" },
  "Piscinas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Pisciotta": { p: "Salerno", s: "SA", r: "Campania" },
  "Pisogne": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pisoniano": { p: "Roma", s: "RM", r: "Lazio" },
  "Pisticci": { p: "Matera", s: "MT", r: "Basilicata" },
  "Pistoia": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Pitigliano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Piubega": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Piuro": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Piverone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pizzale": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Pizzighettone": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pizzo": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Pizzoferrato": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Pizzoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pizzone": { p: "Isernia", s: "IS", r: "Molise" },
  "Pizzoni": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Placanica": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Plataci": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Platania": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Platì": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Plaus": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Plesio": { p: "Como", s: "CO", r: "Lombardia" },
  "Ploaghe": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Plodio": { p: "Savona", s: "SV", r: "Liguria" },
  "Pocapaglia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pocenia": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Podenzana": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Podenzano": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Pofi": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Poggiardo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Poggibonsi": { p: "Siena", s: "SI", r: "Toscana" },
  "Poggio a Caiano": { p: "Prato", s: "PO", r: "Toscana" },
  "Poggio Bustone": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio Catino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio Imperiale": { p: "Foggia", s: "FG", r: "Puglia" },
  "Poggio Mirteto": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio Moiano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio Nativo": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio Picenze": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Poggio Renatico": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Poggio Rusco": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Poggio San Lorenzo": { p: "Rieti", s: "RI", r: "Lazio" },
  "Poggio San Marcello": { p: "Ancona", s: "AN", r: "Marche" },
  "Poggio San Vicino": { p: "Macerata", s: "MC", r: "Marche" },
  "Poggio Sannita": { p: "Isernia", s: "IS", r: "Molise" },
  "Poggio Torriana": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Poggiodomo": { p: "Perugia", s: "PG", r: "Umbria" },
  "Poggiofiorito": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Poggiomarino": { p: "Napoli", s: "NA", r: "Campania" },
  "Poggioreale": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Poggiorsini": { p: "Bari", s: "BA", r: "Puglia" },
  "Poggiridenti": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Pogliano Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pognana Lario": { p: "Como", s: "CO", r: "Lombardia" },
  "Pognano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pogno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Poirino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pojana Maggiore": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Polaveno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Polcenigo": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Polesella": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Polesine Zibello": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Poli": { p: "Roma", s: "RM", r: "Lazio" },
  "Polia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Policoro": { p: "Matera", s: "MT", r: "Basilicata" },
  "Polignano a Mare": { p: "Bari", s: "BA", r: "Puglia" },
  "Polinago": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Polino": { p: "Terni", s: "TR", r: "Umbria" },
  "Polistena": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Polizzi Generosa": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Polla": { p: "Salerno", s: "SA", r: "Campania" },
  "Pollein": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Pollena Trocchia": { p: "Napoli", s: "NA", r: "Campania" },
  "Pollenza": { p: "Macerata", s: "MC", r: "Marche" },
  "Pollica": { p: "Salerno", s: "SA", r: "Campania" },
  "Pollina": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Pollone": { p: "Biella", s: "BI", r: "Piemonte" },
  "Pollutri": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Polonghera": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Polpenazze del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Polverara": { p: "Padova", s: "PD", r: "Veneto" },
  "Polverigi": { p: "Ancona", s: "AN", r: "Marche" },
  "Pomarance": { p: "Pisa", s: "PI", r: "Toscana" },
  "Pomaretto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pomarico": { p: "Matera", s: "MT", r: "Basilicata" },
  "Pomaro Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pomarolo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Pombia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Pomezia": { p: "Roma", s: "RM", r: "Lazio" },
  "Pomigliano d'Arco": { p: "Napoli", s: "NA", r: "Campania" },
  "Pompei": { p: "Napoli", s: "NA", r: "Campania" },
  "Pompeiana": { p: "Imperia", s: "IM", r: "Liguria" },
  "Pompiano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pomponesco": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Pompu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Poncarale": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ponderano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Ponna": { p: "Como", s: "CO", r: "Lombardia" },
  "Ponsacco": { p: "Pisa", s: "PI", r: "Toscana" },
  "Ponso": { p: "Padova", s: "PD", r: "Veneto" },
  "Pont-Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pont-Saint-Martin": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Pontassieve": { p: "Firenze", s: "FI", r: "Toscana" },
  "Pontboset": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Ponte": { p: "Benevento", s: "BN", r: "Campania" },
  "Ponte Buggianese": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Ponte dell'Olio": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Ponte di Legno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Ponte di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Ponte Gardena": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Ponte in Valtellina": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Ponte Lambro": { p: "Como", s: "CO", r: "Lombardia" },
  "Ponte nelle Alpi": { p: "Belluno", s: "BL", r: "Veneto" },
  "Ponte Nizza": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Ponte Nossa": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ponte San Nicolò": { p: "Padova", s: "PD", r: "Veneto" },
  "Ponte San Pietro": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pontebba": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pontecagnano Faiano": { p: "Salerno", s: "SA", r: "Campania" },
  "Pontecchio Polesine": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Pontechianale": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pontecorvo": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Pontecurone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pontedassio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Pontedera": { p: "Pisa", s: "PI", r: "Toscana" },
  "Pontelandolfo": { p: "Benevento", s: "BN", r: "Campania" },
  "Pontelatone": { p: "Caserta", s: "CE", r: "Campania" },
  "Pontelongo": { p: "Padova", s: "PD", r: "Veneto" },
  "Pontenure": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Ponteranica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pontestura": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pontevico": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pontey": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Ponti": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ponti sul Mincio": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Pontida": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pontinia": { p: "Latina", s: "LT", r: "Lazio" },
  "Pontinvrea": { p: "Savona", s: "SV", r: "Liguria" },
  "Pontirolo Nuovo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pontoglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pontremoli": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Ponza": { p: "Latina", s: "LT", r: "Lazio" },
  "Ponzano di Fermo": { p: "Fermo", s: "FM", r: "Marche" },
  "Ponzano Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Ponzano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Ponzano Veneto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Ponzone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Popoli": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Poppi": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Porano": { p: "Terni", s: "TR", r: "Umbria" },
  "Porcari": { p: "Lucca", s: "LU", r: "Toscana" },
  "Porcia": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Pordenone": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Porlezza": { p: "Como", s: "CO", r: "Lombardia" },
  "Pornassio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Porpetto": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Portacomaro": { p: "Asti", s: "AT", r: "Piemonte" },
  "Portalbera": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Porte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Porte di Rendena": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Portici": { p: "Napoli", s: "NA", r: "Campania" },
  "Portico di Caserta": { p: "Caserta", s: "CE", r: "Campania" },
  "Portico e San Benedetto": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Portigliola": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Porto Azzurro": { p: "Livorno", s: "LI", r: "Toscana" },
  "Porto Ceresio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Porto Cesareo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Porto Empedocle": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Porto Mantovano": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Porto Recanati": { p: "Macerata", s: "MC", r: "Marche" },
  "Porto San Giorgio": { p: "Fermo", s: "FM", r: "Marche" },
  "Porto Sant'Elpidio": { p: "Fermo", s: "FM", r: "Marche" },
  "Porto Tolle": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Porto Torres": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Porto Valtravaglia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Porto Viro": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Portobuffolè": { p: "Treviso", s: "TV", r: "Veneto" },
  "Portocannone": { p: "Campobasso", s: "CB", r: "Molise" },
  "Portoferraio": { p: "Livorno", s: "LI", r: "Toscana" },
  "Portofino": { p: "Genova", s: "GE", r: "Liguria" },
  "Portogruaro": { p: "Venezia", s: "VE", r: "Veneto" },
  "Portomaggiore": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Portopalo di Capo Passero": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Portoscuso": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Portovenere": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Portula": { p: "Biella", s: "BI", r: "Piemonte" },
  "Posada": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Posina": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Positano": { p: "Salerno", s: "SA", r: "Campania" },
  "Possagno": { p: "Treviso", s: "TV", r: "Veneto" },
  "Posta": { p: "Rieti", s: "RI", r: "Lazio" },
  "Posta Fibreno": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Postal": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Postalesio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Postiglione": { p: "Salerno", s: "SA", r: "Campania" },
  "Postua": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Potenza": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Potenza Picena": { p: "Macerata", s: "MC", r: "Marche" },
  "Pove del Grappa": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Povegliano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Povegliano Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Poviglio": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Povoletto": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pozzaglia Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Pozzaglio ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Pozzallo": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Pozzilli": { p: "Isernia", s: "IS", r: "Molise" },
  "Pozzo d'Adda": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pozzol Groppo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pozzolengo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Pozzoleone": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Pozzolo Formigaro": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Pozzomaggiore": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Pozzonovo": { p: "Padova", s: "PD", r: "Veneto" },
  "Pozzuoli": { p: "Napoli", s: "NA", r: "Campania" },
  "Pozzuolo del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pozzuolo Martesana": { p: "Milano", s: "MI", r: "Lombardia" },
  "Pradalunga": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pradamano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pradleves": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pragelato": { p: "Torino", s: "TO", r: "Piemonte" },
  "Praia a Mare": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Praiano": { p: "Salerno", s: "SA", r: "Campania" },
  "Pralboino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Prali": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pralormo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Pralungo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Pramaggiore": { p: "Venezia", s: "VE", r: "Veneto" },
  "Pramollo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Prarolo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Prarostino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Prasco": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Prascorsano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Prata Camportaccio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Prata d'Ansidonia": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Prata di Pordenone": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Prata di Principato Ultra": { p: "Avellino", s: "AV", r: "Campania" },
  "Prata Sannita": { p: "Caserta", s: "CE", r: "Campania" },
  "Pratella": { p: "Caserta", s: "CE", r: "Campania" },
  "Pratiglione": { p: "Torino", s: "TO", r: "Piemonte" },
  "Prato": { p: "Prato", s: "PO", r: "Toscana" },
  "Prato allo Stelvio": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Prato Carnico": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Prato Sesia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Pratola Peligna": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Pratola Serra": { p: "Avellino", s: "AV", r: "Campania" },
  "Pratovecchio Stia": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Pravisdomini": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Pray": { p: "Biella", s: "BI", r: "Piemonte" },
  "Prazzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Precenicco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Preci": { p: "Perugia", s: "PG", r: "Umbria" },
  "Predaia": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Predappio": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Predazzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Predoi": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Predore": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Predosa": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Preganziol": { p: "Treviso", s: "TV", r: "Veneto" },
  "Pregnana Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Prelà": { p: "Imperia", s: "IM", r: "Liguria" },
  "Premana": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Premariacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Premeno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Premia": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Premilcuore": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Premolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Premosello-Chiovenda": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Preone": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Prepotto": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Preseglie": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Presenzano": { p: "Caserta", s: "CE", r: "Campania" },
  "Presezzo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Presicce-Acquarica": { p: "Lecce", s: "LE", r: "Puglia" },
  "Pressana": { p: "Verona", s: "VR", r: "Veneto" },
  "Pretoro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Prevalle": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Prezza": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Priero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Prignano Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Prignano sulla Secchia": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Primaluna": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Primiero San Martino di Castrozza": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Priocca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Priola": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Priolo Gargallo": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Priverno": { p: "Latina", s: "LT", r: "Lazio" },
  "Prizzi": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Proceno": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Procida": { p: "Napoli", s: "NA", r: "Campania" },
  "Propata": { p: "Genova", s: "GE", r: "Liguria" },
  "Proserpio": { p: "Como", s: "CO", r: "Lombardia" },
  "Prossedi": { p: "Latina", s: "LT", r: "Lazio" },
  "Provaglio d'Iseo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Provaglio Val Sabbia": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Proves": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Provvidenti": { p: "Campobasso", s: "CB", r: "Molise" },
  "Prunetto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Pré-Saint-Didier": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Puegnago del Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Puglianello": { p: "Benevento", s: "BN", r: "Campania" },
  "Pula": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Pulfero": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Pulsano": { p: "Taranto", s: "TA", r: "Puglia" },
  "Pumenengo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Pusiano": { p: "Como", s: "CO", r: "Lombardia" },
  "Putifigari": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Putignano": { p: "Bari", s: "BA", r: "Puglia" },
  "Quadrelle": { p: "Avellino", s: "AV", r: "Campania" },
  "Quadri": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Quagliuzzo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Qualiano": { p: "Napoli", s: "NA", r: "Campania" },
  "Quaranti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Quaregna Cerreto": { p: "Biella", s: "BI", r: "Piemonte" },
  "Quargnento": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Quarna Sopra": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Quarna Sotto": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Quarona": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Quarrata": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Quart": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Quarto": { p: "Napoli", s: "NA", r: "Campania" },
  "Quarto d'Altino": { p: "Venezia", s: "VE", r: "Veneto" },
  "Quartu Sant'Elena": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Quartucciu": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Quassolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Quattordio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Quattro Castella": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Quero Vas": { p: "Belluno", s: "BL", r: "Veneto" },
  "Quiliano": { p: "Savona", s: "SV", r: "Liguria" },
  "Quincinetto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Quindici": { p: "Avellino", s: "AV", r: "Campania" },
  "Quingentole": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Quintano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Quinto di Treviso": { p: "Treviso", s: "TV", r: "Veneto" },
  "Quinto Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Quinto Vicentino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Quinzano d'Oglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Quistello": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Rabbi": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Racale": { p: "Lecce", s: "LE", r: "Puglia" },
  "Racalmuto": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Racconigi": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Raccuja": { p: "Messina", s: "ME", r: "Sicilia" },
  "Racines": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Radda in Chianti": { p: "Siena", s: "SI", r: "Toscana" },
  "Raddusa": { p: "Catania", s: "CT", r: "Sicilia" },
  "Radicofani": { p: "Siena", s: "SI", r: "Toscana" },
  "Radicondoli": { p: "Siena", s: "SI", r: "Toscana" },
  "Raffadali": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Ragalna": { p: "Catania", s: "CT", r: "Sicilia" },
  "Ragogna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Ragusa": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Raiano": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Ramacca": { p: "Catania", s: "CT", r: "Sicilia" },
  "Rancio Valcuvia": { p: "Varese", s: "VA", r: "Lombardia" },
  "Ranco": { p: "Varese", s: "VA", r: "Lombardia" },
  "Randazzo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Ranica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ranzanico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Ranzo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Rapagnano": { p: "Fermo", s: "FM", r: "Marche" },
  "Rapallo": { p: "Genova", s: "GE", r: "Liguria" },
  "Rapino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Rapolano Terme": { p: "Siena", s: "SI", r: "Toscana" },
  "Rapolla": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Rapone": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Rassa": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Rasun-Anterselva": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Rasura": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Ravanusa": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Ravarino": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Ravascletto": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Ravello": { p: "Salerno", s: "SA", r: "Campania" },
  "Ravenna": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Raveo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Raviscanina": { p: "Caserta", s: "CE", r: "Campania" },
  "Re": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Rea": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Realmonte": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Reana del Rojale": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Reano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Recale": { p: "Caserta", s: "CE", r: "Campania" },
  "Recanati": { p: "Macerata", s: "MC", r: "Marche" },
  "Recco": { p: "Genova", s: "GE", r: "Liguria" },
  "Recetto": { p: "Novara", s: "NO", r: "Piemonte" },
  "Recoaro Terme": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Redavalle": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Redondesco": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Refrancore": { p: "Asti", s: "AT", r: "Piemonte" },
  "Refrontolo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Regalbuto": { p: "Enna", s: "EN", r: "Sicilia" },
  "Reggello": { p: "Firenze", s: "FI", r: "Toscana" },
  "Reggio di Calabria": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Reggio nell'Emilia": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Reggiolo": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Reino": { p: "Benevento", s: "BN", r: "Campania" },
  "Reitano": { p: "Messina", s: "ME", r: "Sicilia" },
  "Remanzacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Remedello": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Renate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Rende": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Renon": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Resana": { p: "Treviso", s: "TV", r: "Veneto" },
  "Rescaldina": { p: "Milano", s: "MI", r: "Lombardia" },
  "Resia": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Resiutta": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Resuttano": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Retorbido": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Revello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Revigliasco d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Revine Lago": { p: "Treviso", s: "TV", r: "Veneto" },
  "Rezzago": { p: "Como", s: "CO", r: "Lombardia" },
  "Rezzato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Rezzo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Rezzoaglio": { p: "Genova", s: "GE", r: "Liguria" },
  "Rho": { p: "Milano", s: "MI", r: "Lombardia" },
  "Rhêmes-Notre-Dame": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Rhêmes-Saint-Georges": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Riace": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Rialto": { p: "Savona", s: "SV", r: "Liguria" },
  "Riano": { p: "Roma", s: "RM", r: "Lazio" },
  "Riardo": { p: "Caserta", s: "CE", r: "Campania" },
  "Ribera": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Ribordone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ricadi": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Ricaldone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Riccia": { p: "Campobasso", s: "CB", r: "Molise" },
  "Riccione": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Riccò del Golfo di Spezia": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Ricengo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ricigliano": { p: "Salerno", s: "SA", r: "Campania" },
  "Riese Pio X": { p: "Treviso", s: "TV", r: "Veneto" },
  "Riesi": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Rieti": { p: "Rieti", s: "RI", r: "Lazio" },
  "Rifiano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Rifreddo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rignano Flaminio": { p: "Roma", s: "RM", r: "Lazio" },
  "Rignano Garganico": { p: "Foggia", s: "FG", r: "Puglia" },
  "Rignano sull'Arno": { p: "Firenze", s: "FI", r: "Toscana" },
  "Rigolato": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Rimella": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Rimini": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Rio": { p: "Livorno", s: "LI", r: "Toscana" },
  "Rio di Pusteria": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Rio Saliceto": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Riofreddo": { p: "Roma", s: "RM", r: "Lazio" },
  "Riola Sardo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Riolo Terme": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Riolunato": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Riomaggiore": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Rionero in Vulture": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Rionero Sannitico": { p: "Isernia", s: "IS", r: "Molise" },
  "Ripa Teatina": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Ripabottoni": { p: "Campobasso", s: "CB", r: "Molise" },
  "Ripacandida": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Ripalimosani": { p: "Campobasso", s: "CB", r: "Molise" },
  "Ripalta Arpina": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ripalta Cremasca": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ripalta Guerina": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Riparbella": { p: "Pisa", s: "PI", r: "Toscana" },
  "Ripatransone": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Ripe San Ginesio": { p: "Macerata", s: "MC", r: "Marche" },
  "Ripi": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Riposto": { p: "Catania", s: "CT", r: "Sicilia" },
  "Rittana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Riva del Garda": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Riva del Po": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Riva di Solto": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Riva Ligure": { p: "Imperia", s: "IM", r: "Liguria" },
  "Riva presso Chieri": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivalba": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivalta Bormida": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Rivalta di Torino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivamonte Agordino": { p: "Belluno", s: "BL", r: "Veneto" },
  "Rivanazzano Terme": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Rivara": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivarolo Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivarolo del Re ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Rivarolo Mantovano": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Rivarone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Rivarossa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rive": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Rive d'Arcano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Rivello": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Rivergaro": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Rivignano Teor": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Rivisondoli": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Rivodutri": { p: "Rieti", s: "RI", r: "Lazio" },
  "Rivoli": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rivoli Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Rivolta d'Adda": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Rizziconi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Roana": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Roaschia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roascio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roasio": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Roatto": { p: "Asti", s: "AT", r: "Piemonte" },
  "Robassomero": { p: "Torino", s: "TO", r: "Piemonte" },
  "Robbiate": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Robbio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Robecchetto con Induno": { p: "Milano", s: "MI", r: "Lombardia" },
  "Robecco d'Oglio": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Robecco Pavese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Robecco sul Naviglio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Robella": { p: "Asti", s: "AT", r: "Piemonte" },
  "Robilante": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roburent": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rocca Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rocca Canterano": { p: "Roma", s: "RM", r: "Lazio" },
  "Rocca Cigliè": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rocca d'Arazzo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Rocca d'Arce": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Rocca d'Evandro": { p: "Caserta", s: "CE", r: "Campania" },
  "Rocca de' Baldi": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rocca de' Giorgi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Rocca di Botte": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Rocca di Cambio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Rocca di Cave": { p: "Roma", s: "RM", r: "Lazio" },
  "Rocca di Mezzo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Rocca di Neto": { p: "Crotone", s: "KR", r: "Calabria" },
  "Rocca di Papa": { p: "Roma", s: "RM", r: "Lazio" },
  "Rocca Grimalda": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Rocca Imperiale": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Rocca Massima": { p: "Latina", s: "LT", r: "Lazio" },
  "Rocca Pia": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Rocca Pietore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Rocca Priora": { p: "Roma", s: "RM", r: "Lazio" },
  "Rocca San Casciano": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Rocca San Felice": { p: "Avellino", s: "AV", r: "Campania" },
  "Rocca San Giovanni": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Rocca Santa Maria": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Rocca Santo Stefano": { p: "Roma", s: "RM", r: "Lazio" },
  "Rocca Sinibalda": { p: "Rieti", s: "RI", r: "Lazio" },
  "Rocca Susella": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Roccabascerana": { p: "Avellino", s: "AV", r: "Campania" },
  "Roccabernarda": { p: "Crotone", s: "KR", r: "Calabria" },
  "Roccabianca": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Roccabruna": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roccacasale": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Roccadaspide": { p: "Salerno", s: "SA", r: "Campania" },
  "Roccafiorita": { p: "Messina", s: "ME", r: "Sicilia" },
  "Roccafluvione": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Roccaforte del Greco": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Roccaforte Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Roccaforte Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roccaforzata": { p: "Taranto", s: "TA", r: "Puglia" },
  "Roccafranca": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Roccagiovine": { p: "Roma", s: "RM", r: "Lazio" },
  "Roccagloriosa": { p: "Salerno", s: "SA", r: "Campania" },
  "Roccagorga": { p: "Latina", s: "LT", r: "Lazio" },
  "Roccalbegna": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Roccalumera": { p: "Messina", s: "ME", r: "Sicilia" },
  "Roccamandolfi": { p: "Isernia", s: "IS", r: "Molise" },
  "Roccamena": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Roccamonfina": { p: "Caserta", s: "CE", r: "Campania" },
  "Roccamontepiano": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Roccamorice": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Roccanova": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Roccantica": { p: "Rieti", s: "RI", r: "Lazio" },
  "Roccapalumba": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Roccapiemonte": { p: "Salerno", s: "SA", r: "Campania" },
  "Roccarainola": { p: "Napoli", s: "NA", r: "Campania" },
  "Roccaraso": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Roccaromana": { p: "Caserta", s: "CE", r: "Campania" },
  "Roccascalegna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Roccasecca": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Roccasecca dei Volsci": { p: "Latina", s: "LT", r: "Lazio" },
  "Roccasicura": { p: "Isernia", s: "IS", r: "Molise" },
  "Roccasparvera": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roccaspinalveti": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Roccastrada": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Roccavaldina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Roccaverano": { p: "Asti", s: "AT", r: "Piemonte" },
  "Roccavignale": { p: "Savona", s: "SV", r: "Liguria" },
  "Roccavione": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roccavivara": { p: "Campobasso", s: "CB", r: "Molise" },
  "Roccella Ionica": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Roccella Valdemone": { p: "Messina", s: "ME", r: "Sicilia" },
  "Rocchetta a Volturno": { p: "Isernia", s: "IS", r: "Molise" },
  "Rocchetta Belbo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rocchetta di Vara": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Rocchetta e Croce": { p: "Caserta", s: "CE", r: "Campania" },
  "Rocchetta Ligure": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Rocchetta Nervina": { p: "Imperia", s: "IM", r: "Liguria" },
  "Rocchetta Palafea": { p: "Asti", s: "AT", r: "Piemonte" },
  "Rocchetta Sant'Antonio": { p: "Foggia", s: "FG", r: "Puglia" },
  "Rocchetta Tanaro": { p: "Asti", s: "AT", r: "Piemonte" },
  "Rodano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Roddi": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Roddino": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rodello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rodengo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Rodengo Saiano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Rodero": { p: "Como", s: "CO", r: "Lombardia" },
  "Rodi Garganico": { p: "Foggia", s: "FG", r: "Puglia" },
  "Rodigo": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Rodì Milici": { p: "Messina", s: "ME", r: "Sicilia" },
  "Rofrano": { p: "Salerno", s: "SA", r: "Campania" },
  "Rogeno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Roggiano Gravina": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Roghudi": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Rogliano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Rognano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Rogno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Rogolo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Roiate": { p: "Roma", s: "RM", r: "Lazio" },
  "Roio del Sangro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Roisan": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Roletto": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rolo": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Roma": { p: "Roma", s: "RM", r: "Lazio" },
  "Romagnano al Monte": { p: "Salerno", s: "SA", r: "Campania" },
  "Romagnano Sesia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Romagnese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Romana": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Romanengo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Romano Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Romano d'Ezzelino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Romano di Lombardia": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Romans d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Rombiolo": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Romeno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Romentino": { p: "Novara", s: "NO", r: "Piemonte" },
  "Rometta": { p: "Messina", s: "ME", r: "Sicilia" },
  "Ronago": { p: "Como", s: "CO", r: "Lombardia" },
  "Roncade": { p: "Treviso", s: "TV", r: "Veneto" },
  "Roncadelle": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Roncaro": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Roncegno Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Roncello": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Ronchi dei Legionari": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Ronchi Valsugana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ronchis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Ronciglione": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Ronco all'Adige": { p: "Verona", s: "VR", r: "Veneto" },
  "Ronco Biellese": { p: "Biella", s: "BI", r: "Piemonte" },
  "Ronco Briantino": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Ronco Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ronco Scrivia": { p: "Genova", s: "GE", r: "Liguria" },
  "Roncobello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Roncoferraro": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Roncofreddo": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Roncola": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Roncà": { p: "Verona", s: "VR", r: "Veneto" },
  "Rondanina": { p: "Genova", s: "GE", r: "Liguria" },
  "Rondissone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ronsecco": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Ronzo-Chienis": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ronzone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Roppolo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Rorà": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rosarno": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Rosasco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Rosate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Rosazza": { p: "Biella", s: "BI", r: "Piemonte" },
  "Rosciano": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Roscigno": { p: "Salerno", s: "SA", r: "Campania" },
  "Rose": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Rosello": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Roseto Capo Spulico": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Roseto degli Abruzzi": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Roseto Valfortore": { p: "Foggia", s: "FG", r: "Puglia" },
  "Rosignano Marittimo": { p: "Livorno", s: "LI", r: "Toscana" },
  "Rosignano Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Rosolina": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Rosolini": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Rosora": { p: "Ancona", s: "AN", r: "Marche" },
  "Rossa": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Rossana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Rossano Veneto": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Rossiglione": { p: "Genova", s: "GE", r: "Liguria" },
  "Rosta": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rosà": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Rota d'Imagna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Rota Greca": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Rotella": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Rotello": { p: "Campobasso", s: "CB", r: "Molise" },
  "Rotonda": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Rotondella": { p: "Matera", s: "MT", r: "Basilicata" },
  "Rotondi": { p: "Avellino", s: "AV", r: "Campania" },
  "Rottofreno": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Rotzo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Roure": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rovasenda": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Rovato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Rovegno": { p: "Genova", s: "GE", r: "Liguria" },
  "Rovellasca": { p: "Como", s: "CO", r: "Lombardia" },
  "Rovello Porro": { p: "Como", s: "CO", r: "Lombardia" },
  "Roverbella": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Roverchiara": { p: "Verona", s: "VR", r: "Veneto" },
  "Roveredo di Guà": { p: "Verona", s: "VR", r: "Veneto" },
  "Roveredo in Piano": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Rovereto": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Roverè della Luna": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Roverè Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Rovescala": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Rovetta": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Roviano": { p: "Roma", s: "RM", r: "Lazio" },
  "Rovigo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Rovito": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Rovolon": { p: "Padova", s: "PD", r: "Veneto" },
  "Rozzano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Roè Volciano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Rubano": { p: "Padova", s: "PD", r: "Veneto" },
  "Rubiana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Rubiera": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Ruda": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Rudiano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Rueglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ruffano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Ruffia": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Ruffrè-Mendola": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Rufina": { p: "Firenze", s: "FI", r: "Toscana" },
  "Ruinas": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Rumo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ruoti": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Russi": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Rutigliano": { p: "Bari", s: "BA", r: "Puglia" },
  "Rutino": { p: "Salerno", s: "SA", r: "Campania" },
  "Ruviano": { p: "Caserta", s: "CE", r: "Campania" },
  "Ruvo del Monte": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Ruvo di Puglia": { p: "Bari", s: "BA", r: "Puglia" },
  "Sabaudia": { p: "Latina", s: "LT", r: "Lazio" },
  "Sabbio Chiese": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sabbioneta": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Sacco": { p: "Salerno", s: "SA", r: "Campania" },
  "Saccolongo": { p: "Padova", s: "PD", r: "Veneto" },
  "Sacile": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Sacrofano": { p: "Roma", s: "RM", r: "Lazio" },
  "Sadali": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sagama": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sagliano Micca": { p: "Biella", s: "BI", r: "Piemonte" },
  "Sagrado": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Sagron Mis": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Saint-Christophe": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Denis": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Marcel": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Nicolas": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Oyen": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Pierre": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Rhémy-en-Bosses": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Saint-Vincent": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Sala Baganza": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Sala Biellese": { p: "Biella", s: "BI", r: "Piemonte" },
  "Sala Bolognese": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Sala Comacina": { p: "Como", s: "CO", r: "Lombardia" },
  "Sala Consilina": { p: "Salerno", s: "SA", r: "Campania" },
  "Sala Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Salandra": { p: "Matera", s: "MT", r: "Basilicata" },
  "Salaparuta": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Salara": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Salasco": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Salassa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Salbertrand": { p: "Torino", s: "TO", r: "Piemonte" },
  "Salcedo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Salcito": { p: "Campobasso", s: "CB", r: "Molise" },
  "Sale": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Sale delle Langhe": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sale Marasino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sale San Giovanni": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Salemi": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Salento": { p: "Salerno", s: "SA", r: "Campania" },
  "Salerano Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Salerano sul Lambro": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Salerno": { p: "Salerno", s: "SA", r: "Campania" },
  "Salgareda": { p: "Treviso", s: "TV", r: "Veneto" },
  "Sali Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Salice Salentino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Saliceto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Salisano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Salizzole": { p: "Verona", s: "VR", r: "Veneto" },
  "Salle": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Salmour": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Salorno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Salsomaggiore Terme": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Saltrio": { p: "Varese", s: "VA", r: "Lombardia" },
  "Saludecio": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Saluggia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Salussola": { p: "Biella", s: "BI", r: "Piemonte" },
  "Saluzzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Salve": { p: "Lecce", s: "LE", r: "Puglia" },
  "Salvirola": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Salvitelle": { p: "Salerno", s: "SA", r: "Campania" },
  "Salza di Pinerolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Salza Irpina": { p: "Avellino", s: "AV", r: "Campania" },
  "Salzano": { p: "Venezia", s: "VE", r: "Veneto" },
  "Salò": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Samarate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Samassi": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Samatzai": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sambuca di Sicilia": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Sambuca Pistoiese": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Sambuci": { p: "Roma", s: "RM", r: "Lazio" },
  "Sambuco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sammichele di Bari": { p: "Bari", s: "BA", r: "Puglia" },
  "Samo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Samolaco": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Samone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Samone (TN)": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Samone (TO)": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sampeyre": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Samugheo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "San Bartolomeo al Mare": { p: "Imperia", s: "IM", r: "Liguria" },
  "San Bartolomeo in Galdo": { p: "Benevento", s: "BN", r: "Campania" },
  "San Bartolomeo Val Cavargna": { p: "Como", s: "CO", r: "Lombardia" },
  "San Basile": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Basilio": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Bassano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "San Bellino": { p: "Rovigo", s: "RO", r: "Veneto" },
  "San Benedetto Belbo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "San Benedetto dei Marsi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "San Benedetto del Tronto": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "San Benedetto in Perillis": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "San Benedetto Po": { p: "Mantova", s: "MN", r: "Lombardia" },
  "San Benedetto Ullano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Benedetto Val di Sambro": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "San Benigno Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Bernardino Verbano": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "San Biagio della Cima": { p: "Imperia", s: "IM", r: "Liguria" },
  "San Biagio di Callalta": { p: "Treviso", s: "TV", r: "Veneto" },
  "San Biagio Platani": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "San Biagio Saracinisco": { p: "Frosinone", s: "FR", r: "Lazio" },
  "San Biase": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Bonifacio": { p: "Verona", s: "VR", r: "Veneto" },
  "San Buono": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Calogero": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "San Candido": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Canzian d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "San Carlo Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Casciano dei Bagni": { p: "Siena", s: "SI", r: "Toscana" },
  "San Casciano in Val di Pesa": { p: "Firenze", s: "FI", r: "Toscana" },
  "San Cassiano": { p: "Lecce", s: "LE", r: "Puglia" },
  "San Cataldo": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "San Cesareo": { p: "Roma", s: "RM", r: "Lazio" },
  "San Cesario di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "San Cesario sul Panaro": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "San Chirico Nuovo": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Chirico Raparo": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Cipirello": { p: "Palermo", s: "PA", r: "Sicilia" },
  "San Cipriano d'Aversa": { p: "Caserta", s: "CE", r: "Campania" },
  "San Cipriano Picentino": { p: "Salerno", s: "SA", r: "Campania" },
  "San Cipriano Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Clemente": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "San Colombano al Lambro": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Colombano Belmonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Colombano Certenoli": { p: "Genova", s: "GE", r: "Liguria" },
  "San Cono": { p: "Catania", s: "CT", r: "Sicilia" },
  "San Cosmo Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Costantino Albanese": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Costantino Calabro": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "San Costanzo": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "San Cristoforo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "San Damiano al Colle": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Damiano d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "San Damiano Macra": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "San Daniele del Friuli": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Daniele Po": { p: "Cremona", s: "CR", r: "Lombardia" },
  "San Demetrio Corone": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Demetrio ne' Vestini": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "San Didero": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Donaci": { p: "Brindisi", s: "BR", r: "Puglia" },
  "San Donato di Lecce": { p: "Lecce", s: "LE", r: "Puglia" },
  "San Donato di Ninea": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Donato Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Donato Val di Comino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "San Donà di Piave": { p: "Venezia", s: "VE", r: "Veneto" },
  "San Dorligo della Valle": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "San Fele": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Felice a Cancello": { p: "Caserta", s: "CE", r: "Campania" },
  "San Felice Circeo": { p: "Latina", s: "LT", r: "Lazio" },
  "San Felice del Benaco": { p: "Brescia", s: "BS", r: "Lombardia" },
  "San Felice del Molise": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Felice sul Panaro": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "San Ferdinando": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Ferdinando di Puglia": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "San Fermo della Battaglia": { p: "Como", s: "CO", r: "Lombardia" },
  "San Fili": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Filippo del Mela": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Fior": { p: "Treviso", s: "TV", r: "Veneto" },
  "San Fiorano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "San Floriano del Collio": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "San Floro": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Francesco al Campo": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Fratello": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Gavino Monreale": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Gemini": { p: "Terni", s: "TR", r: "Umbria" },
  "San Genesio Atesino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Genesio ed Uniti": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Gennaro Vesuviano": { p: "Napoli", s: "NA", r: "Campania" },
  "San Germano Chisone": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Germano Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "San Gervasio Bresciano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "San Giacomo degli Schiavoni": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Giacomo delle Segnate": { p: "Mantova", s: "MN", r: "Lombardia" },
  "San Giacomo Filippo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "San Giacomo Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "San Gillio": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Gimignano": { p: "Siena", s: "SI", r: "Toscana" },
  "San Ginesio": { p: "Macerata", s: "MC", r: "Marche" },
  "San Giorgio a Cremano": { p: "Napoli", s: "NA", r: "Campania" },
  "San Giorgio a Liri": { p: "Frosinone", s: "FR", r: "Lazio" },
  "San Giorgio Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Giorgio Bigarello": { p: "Mantova", s: "MN", r: "Lombardia" },
  "San Giorgio Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Giorgio del Sannio": { p: "Benevento", s: "BN", r: "Campania" },
  "San Giorgio della Richinvelda": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "San Giorgio delle Pertiche": { p: "Padova", s: "PD", r: "Veneto" },
  "San Giorgio di Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Giorgio di Nogaro": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Giorgio di Piano": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "San Giorgio in Bosco": { p: "Padova", s: "PD", r: "Veneto" },
  "San Giorgio Ionico": { p: "Taranto", s: "TA", r: "Puglia" },
  "San Giorgio La Molara": { p: "Benevento", s: "BN", r: "Campania" },
  "San Giorgio Lucano": { p: "Matera", s: "MT", r: "Basilicata" },
  "San Giorgio Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "San Giorgio Morgeto": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Giorgio Piacentino": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "San Giorgio Scarampi": { p: "Asti", s: "AT", r: "Piemonte" },
  "San Giorgio su Legnano": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Giorio di Susa": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Giovanni a Piro": { p: "Salerno", s: "SA", r: "Campania" },
  "San Giovanni al Natisone": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Giovanni Bianco": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "San Giovanni del Dosso": { p: "Mantova", s: "MN", r: "Lombardia" },
  "San Giovanni di Fassa": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "San Giovanni di Gerace": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Giovanni Gemini": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "San Giovanni Ilarione": { p: "Verona", s: "VR", r: "Veneto" },
  "San Giovanni in Croce": { p: "Cremona", s: "CR", r: "Lombardia" },
  "San Giovanni in Fiore": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Giovanni in Galdo": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Giovanni in Marignano": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "San Giovanni in Persiceto": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "San Giovanni Incarico": { p: "Frosinone", s: "FR", r: "Lazio" },
  "San Giovanni la Punta": { p: "Catania", s: "CT", r: "Sicilia" },
  "San Giovanni Lipioni": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Giovanni Lupatoto": { p: "Verona", s: "VR", r: "Veneto" },
  "San Giovanni Rotondo": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Giovanni Suergiu": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Giovanni Teatino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Giovanni Valdarno": { p: "Arezzo", s: "AR", r: "Toscana" },
  "San Giuliano del Sannio": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Giuliano di Puglia": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Giuliano Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Giuliano Terme": { p: "Pisa", s: "PI", r: "Toscana" },
  "San Giuseppe Jato": { p: "Palermo", s: "PA", r: "Sicilia" },
  "San Giuseppe Vesuviano": { p: "Napoli", s: "NA", r: "Campania" },
  "San Giustino": { p: "Perugia", s: "PG", r: "Umbria" },
  "San Giusto Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Godenzo": { p: "Firenze", s: "FI", r: "Toscana" },
  "San Gregorio d'Ippona": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "San Gregorio da Sassola": { p: "Roma", s: "RM", r: "Lazio" },
  "San Gregorio di Catania": { p: "Catania", s: "CT", r: "Sicilia" },
  "San Gregorio Magno": { p: "Salerno", s: "SA", r: "Campania" },
  "San Gregorio Matese": { p: "Caserta", s: "CE", r: "Campania" },
  "San Gregorio nelle Alpi": { p: "Belluno", s: "BL", r: "Veneto" },
  "San Lazzaro di Savena": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "San Leo": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "San Leonardo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Leonardo in Passiria": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Leucio del Sannio": { p: "Benevento", s: "BN", r: "Campania" },
  "San Lorenzello": { p: "Benevento", s: "BN", r: "Campania" },
  "San Lorenzo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Lorenzo al Mare": { p: "Imperia", s: "IM", r: "Liguria" },
  "San Lorenzo Bellizzi": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Lorenzo del Vallo": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Lorenzo di Sebato": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Lorenzo Dorsino": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "San Lorenzo in Campo": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "San Lorenzo Isontino": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "San Lorenzo Maggiore": { p: "Benevento", s: "BN", r: "Campania" },
  "San Lorenzo Nuovo": { p: "Viterbo", s: "VT", r: "Lazio" },
  "San Luca": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Lucido": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Lupo": { p: "Benevento", s: "BN", r: "Campania" },
  "San Mango d'Aquino": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Mango Piemonte": { p: "Salerno", s: "SA", r: "Campania" },
  "San Mango sul Calore": { p: "Avellino", s: "AV", r: "Campania" },
  "San Marcellino": { p: "Caserta", s: "CE", r: "Campania" },
  "San Marcello": { p: "Ancona", s: "AN", r: "Marche" },
  "San Marcello Piteglio": { p: "Pistoia", s: "PT", r: "Toscana" },
  "San Marco Argentano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Marco d'Alunzio": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Marco dei Cavoti": { p: "Benevento", s: "BN", r: "Campania" },
  "San Marco Evangelista": { p: "Caserta", s: "CE", r: "Campania" },
  "San Marco in Lamis": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Marco la Catola": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Martino al Tagliamento": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "San Martino Alfieri": { p: "Asti", s: "AT", r: "Piemonte" },
  "San Martino Buon Albergo": { p: "Verona", s: "VR", r: "Veneto" },
  "San Martino Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Martino d'Agri": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Martino dall'Argine": { p: "Mantova", s: "MN", r: "Lombardia" },
  "San Martino del Lago": { p: "Cremona", s: "CR", r: "Lombardia" },
  "San Martino di Finita": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Martino di Lupari": { p: "Padova", s: "PD", r: "Veneto" },
  "San Martino di Venezze": { p: "Rovigo", s: "RO", r: "Veneto" },
  "San Martino in Badia": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Martino in Passiria": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Martino in Pensilis": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Martino in Rio": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "San Martino in Strada": { p: "Lodi", s: "LO", r: "Lombardia" },
  "San Martino Sannita": { p: "Benevento", s: "BN", r: "Campania" },
  "San Martino Siccomario": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Martino sulla Marrucina": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Martino Valle Caudina": { p: "Avellino", s: "AV", r: "Campania" },
  "San Marzano di San Giuseppe": { p: "Taranto", s: "TA", r: "Puglia" },
  "San Marzano Oliveto": { p: "Asti", s: "AT", r: "Piemonte" },
  "San Marzano sul Sarno": { p: "Salerno", s: "SA", r: "Campania" },
  "San Massimo": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Maurizio Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Maurizio d'Opaglio": { p: "Novara", s: "NO", r: "Piemonte" },
  "San Mauro Castelverde": { p: "Palermo", s: "PA", r: "Sicilia" },
  "San Mauro Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "San Mauro di Saline": { p: "Verona", s: "VR", r: "Veneto" },
  "San Mauro Forte": { p: "Matera", s: "MT", r: "Basilicata" },
  "San Mauro la Bruca": { p: "Salerno", s: "SA", r: "Campania" },
  "San Mauro Marchesato": { p: "Crotone", s: "KR", r: "Calabria" },
  "San Mauro Pascoli": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "San Mauro Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Michele al Tagliamento": { p: "Venezia", s: "VE", r: "Veneto" },
  "San Michele all'Adige": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "San Michele di Ganzaria": { p: "Catania", s: "CT", r: "Sicilia" },
  "San Michele di Serino": { p: "Avellino", s: "AV", r: "Campania" },
  "San Michele Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "San Michele Salentino": { p: "Brindisi", s: "BR", r: "Puglia" },
  "San Miniato": { p: "Pisa", s: "PI", r: "Toscana" },
  "San Nazzaro": { p: "Benevento", s: "BN", r: "Campania" },
  "San Nazzaro Sesia": { p: "Novara", s: "NO", r: "Piemonte" },
  "San Nazzaro Val Cavargna": { p: "Como", s: "CO", r: "Lombardia" },
  "San Nicandro Garganico": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Nicola Arcella": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Nicola Baronia": { p: "Avellino", s: "AV", r: "Campania" },
  "San Nicola da Crissa": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "San Nicola dell'Alto": { p: "Crotone", s: "KR", r: "Calabria" },
  "San Nicola la Strada": { p: "Caserta", s: "CE", r: "Campania" },
  "San Nicola Manfredi": { p: "Benevento", s: "BN", r: "Campania" },
  "San Nicolò d'Arcidano": { p: "Oristano", s: "OR", r: "Sardegna" },
  "San Nicolò di Comelico": { p: "Belluno", s: "BL", r: "Veneto" },
  "San Nicolò Gerrei": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Pancrazio": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "San Pancrazio Salentino": { p: "Brindisi", s: "BR", r: "Puglia" },
  "San Paolo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "San Paolo Albanese": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Paolo Bel Sito": { p: "Napoli", s: "NA", r: "Campania" },
  "San Paolo d'Argon": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "San Paolo di Civitate": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Paolo di Jesi": { p: "Ancona", s: "AN", r: "Marche" },
  "San Paolo Solbrito": { p: "Asti", s: "AT", r: "Piemonte" },
  "San Pellegrino Terme": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "San Pier d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "San Pier Niceto": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Piero Patti": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Pietro a Maida": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Pietro al Natisone": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Pietro al Tanagro": { p: "Salerno", s: "SA", r: "Campania" },
  "San Pietro Apostolo": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Pietro Avellana": { p: "Isernia", s: "IS", r: "Molise" },
  "San Pietro Clarenza": { p: "Catania", s: "CT", r: "Sicilia" },
  "San Pietro di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "San Pietro di Caridà": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Pietro di Feletto": { p: "Treviso", s: "TV", r: "Veneto" },
  "San Pietro di Morubio": { p: "Verona", s: "VR", r: "Veneto" },
  "San Pietro in Amantea": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Pietro in Cariano": { p: "Verona", s: "VR", r: "Veneto" },
  "San Pietro in Casale": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "San Pietro in Cerro": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "San Pietro in Gu": { p: "Padova", s: "PD", r: "Veneto" },
  "San Pietro in Guarano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Pietro in Lama": { p: "Lecce", s: "LE", r: "Puglia" },
  "San Pietro Infine": { p: "Caserta", s: "CE", r: "Campania" },
  "San Pietro Mosezzo": { p: "Novara", s: "NO", r: "Piemonte" },
  "San Pietro Mussolino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "San Pietro Val Lemina": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Pietro Vernotico": { p: "Brindisi", s: "BR", r: "Puglia" },
  "San Pietro Viminario": { p: "Padova", s: "PD", r: "Veneto" },
  "San Pio delle Camere": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "San Polo d'Enza": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "San Polo dei Cavalieri": { p: "Roma", s: "RM", r: "Lazio" },
  "San Polo di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "San Polo Matese": { p: "Campobasso", s: "CB", r: "Molise" },
  "San Ponso": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Possidonio": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "San Potito Sannitico": { p: "Caserta", s: "CE", r: "Campania" },
  "San Potito Ultra": { p: "Avellino", s: "AV", r: "Campania" },
  "San Prisco": { p: "Caserta", s: "CE", r: "Campania" },
  "San Procopio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Prospero": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "San Quirico d'Orcia": { p: "Siena", s: "SI", r: "Toscana" },
  "San Quirino": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "San Raffaele Cimena": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Roberto": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "San Rocco al Porto": { p: "Lodi", s: "LO", r: "Lombardia" },
  "San Romano in Garfagnana": { p: "Lucca", s: "LU", r: "Toscana" },
  "San Rufo": { p: "Salerno", s: "SA", r: "Campania" },
  "San Salvatore di Fitalia": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Salvatore Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "San Salvatore Telesino": { p: "Benevento", s: "BN", r: "Campania" },
  "San Salvo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Sebastiano al Vesuvio": { p: "Napoli", s: "NA", r: "Campania" },
  "San Sebastiano Curone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "San Sebastiano da Po": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Secondo di Pinerolo": { p: "Torino", s: "TO", r: "Piemonte" },
  "San Secondo Parmense": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "San Severino Lucano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "San Severino Marche": { p: "Macerata", s: "MC", r: "Marche" },
  "San Severo": { p: "Foggia", s: "FG", r: "Puglia" },
  "San Siro": { p: "Como", s: "CO", r: "Lombardia" },
  "San Sossio Baronia": { p: "Avellino", s: "AV", r: "Campania" },
  "San Sostene": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Sosti": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Sperate": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Stino di Livenza": { p: "Venezia", s: "VE", r: "Veneto" },
  "San Tammaro": { p: "Caserta", s: "CE", r: "Campania" },
  "San Teodoro": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Teodoro (ME)": { p: "Messina", s: "ME", r: "Sicilia" },
  "San Teodoro (SS)": { p: "Sassari", s: "SS", r: "Sardegna" },
  "San Tomaso Agordino": { p: "Belluno", s: "BL", r: "Veneto" },
  "San Valentino in Abruzzo Citeriore": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "San Valentino Torio": { p: "Salerno", s: "SA", r: "Campania" },
  "San Venanzo": { p: "Terni", s: "TR", r: "Umbria" },
  "San Vendemiano": { p: "Treviso", s: "TV", r: "Veneto" },
  "San Vero Milis": { p: "Oristano", s: "OR", r: "Sardegna" },
  "San Vincenzo": { p: "Livorno", s: "LI", r: "Toscana" },
  "San Vincenzo La Costa": { p: "Cosenza", s: "CS", r: "Calabria" },
  "San Vincenzo Valle Roveto": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "San Vitaliano": { p: "Napoli", s: "NA", r: "Campania" },
  "San Vito": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "San Vito al Tagliamento": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "San Vito al Torre": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Vito Chietino": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "San Vito dei Normanni": { p: "Brindisi", s: "BR", r: "Puglia" },
  "San Vito di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "San Vito di Fagagna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "San Vito di Leguzzano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "San Vito Lo Capo": { p: "Trapani", s: "TP", r: "Sicilia" },
  "San Vito Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "San Vito sullo Ionio": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "San Vittore del Lazio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "San Vittore Olona": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Zeno di Montagna": { p: "Verona", s: "VR", r: "Veneto" },
  "San Zeno Naviglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "San Zenone al Lambro": { p: "Milano", s: "MI", r: "Lombardia" },
  "San Zenone al Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "San Zenone degli Ezzelini": { p: "Treviso", s: "TV", r: "Veneto" },
  "Sanarica": { p: "Lecce", s: "LE", r: "Puglia" },
  "Sandigliano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Sandrigo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Sanfront": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sanfrè": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sangano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sangiano": { p: "Varese", s: "VA", r: "Lombardia" },
  "Sangineto": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Sanguinetto": { p: "Verona", s: "VR", r: "Veneto" },
  "Sanluri": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sannazzaro de' Burgondi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sannicandro di Bari": { p: "Bari", s: "BA", r: "Puglia" },
  "Sannicola": { p: "Lecce", s: "LE", r: "Puglia" },
  "Sanremo": { p: "Imperia", s: "IM", r: "Liguria" },
  "Sansepolcro": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Sant'Agapito": { p: "Isernia", s: "IS", r: "Molise" },
  "Sant'Agata Bolognese": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Sant'Agata de' Goti": { p: "Benevento", s: "BN", r: "Campania" },
  "Sant'Agata del Bianco": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Sant'Agata di Esaro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Sant'Agata di Militello": { p: "Messina", s: "ME", r: "Sicilia" },
  "Sant'Agata di Puglia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Sant'Agata Feltria": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Sant'Agata Fossili": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Sant'Agata li Battiati": { p: "Catania", s: "CT", r: "Sicilia" },
  "Sant'Agata sul Santerno": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Sant'Agnello": { p: "Napoli", s: "NA", r: "Campania" },
  "Sant'Albano Stura": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sant'Alessio con Vialone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sant'Alessio in Aspromonte": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Sant'Alessio Siculo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Sant'Alfio": { p: "Catania", s: "CT", r: "Sicilia" },
  "Sant'Ambrogio di Torino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sant'Ambrogio di Valpolicella": { p: "Verona", s: "VR", r: "Veneto" },
  "Sant'Ambrogio sul Garigliano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Sant'Anastasia": { p: "Napoli", s: "NA", r: "Campania" },
  "Sant'Anatolia di Narco": { p: "Perugia", s: "PG", r: "Umbria" },
  "Sant'Andrea Apostolo dello Ionio": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Sant'Andrea del Garigliano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Sant'Andrea di Conza": { p: "Avellino", s: "AV", r: "Campania" },
  "Sant'Andrea Frius": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sant'Angelo a Cupolo": { p: "Benevento", s: "BN", r: "Campania" },
  "Sant'Angelo a Fasanella": { p: "Salerno", s: "SA", r: "Campania" },
  "Sant'Angelo a Scala": { p: "Avellino", s: "AV", r: "Campania" },
  "Sant'Angelo all'Esca": { p: "Avellino", s: "AV", r: "Campania" },
  "Sant'Angelo d'Alife": { p: "Caserta", s: "CE", r: "Campania" },
  "Sant'Angelo dei Lombardi": { p: "Avellino", s: "AV", r: "Campania" },
  "Sant'Angelo del Pesco": { p: "Isernia", s: "IS", r: "Molise" },
  "Sant'Angelo di Brolo": { p: "Messina", s: "ME", r: "Sicilia" },
  "Sant'Angelo di Piove di Sacco": { p: "Padova", s: "PD", r: "Veneto" },
  "Sant'Angelo in Pontano": { p: "Macerata", s: "MC", r: "Marche" },
  "Sant'Angelo in Vado": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Sant'Angelo Le Fratte": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Sant'Angelo Limosano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Sant'Angelo Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Sant'Angelo Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sant'Angelo Muxaro": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Sant'Angelo Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Sant'Anna Arresi": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sant'Anna d'Alfaedo": { p: "Verona", s: "VR", r: "Veneto" },
  "Sant'Antimo": { p: "Napoli", s: "NA", r: "Campania" },
  "Sant'Antioco": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sant'Antonino di Susa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sant'Antonio Abate": { p: "Napoli", s: "NA", r: "Campania" },
  "Sant'Antonio di Gallura": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Sant'Apollinare": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Sant'Arcangelo": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Sant'Arcangelo Trimonte": { p: "Benevento", s: "BN", r: "Campania" },
  "Sant'Arpino": { p: "Caserta", s: "CE", r: "Campania" },
  "Sant'Arsenio": { p: "Salerno", s: "SA", r: "Campania" },
  "Sant'Egidio alla Vibrata": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Sant'Egidio del Monte Albino": { p: "Salerno", s: "SA", r: "Campania" },
  "Sant'Elena": { p: "Padova", s: "PD", r: "Veneto" },
  "Sant'Elena Sannita": { p: "Isernia", s: "IS", r: "Molise" },
  "Sant'Elia a Pianisi": { p: "Campobasso", s: "CB", r: "Molise" },
  "Sant'Elia Fiumerapido": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Sant'Elpidio a Mare": { p: "Fermo", s: "FM", r: "Marche" },
  "Sant'Eufemia a Maiella": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Sant'Eufemia d'Aspromonte": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Sant'Eusanio del Sangro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Sant'Eusanio Forconese": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Sant'Ilario d'Enza": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Sant'Ilario dello Ionio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Sant'Ippolito": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Sant'Olcese": { p: "Genova", s: "GE", r: "Liguria" },
  "Sant'Omero": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Sant'Omobono Terme": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sant'Onofrio": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Sant'Oreste": { p: "Roma", s: "RM", r: "Lazio" },
  "Sant'Orsola Terme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Sant'Urbano": { p: "Padova", s: "PD", r: "Veneto" },
  "Santa Brigida": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Santa Caterina Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Santa Caterina dello Ionio": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Santa Caterina Villarmosa": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Santa Cesarea Terme": { p: "Lecce", s: "LE", r: "Puglia" },
  "Santa Cristina d'Aspromonte": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Santa Cristina e Bissone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Santa Cristina Gela": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Santa Cristina Valgardena": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Santa Croce Camerina": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Santa Croce del Sannio": { p: "Benevento", s: "BN", r: "Campania" },
  "Santa Croce di Magliano": { p: "Campobasso", s: "CB", r: "Molise" },
  "Santa Croce sull'Arno": { p: "Pisa", s: "PI", r: "Toscana" },
  "Santa Domenica Talao": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Santa Domenica Vittoria": { p: "Messina", s: "ME", r: "Sicilia" },
  "Santa Elisabetta": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Santa Fiora": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Santa Flavia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Santa Giuletta": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Santa Giusta": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Santa Giustina": { p: "Belluno", s: "BL", r: "Veneto" },
  "Santa Giustina in Colle": { p: "Padova", s: "PD", r: "Veneto" },
  "Santa Luce": { p: "Pisa", s: "PI", r: "Toscana" },
  "Santa Lucia del Mela": { p: "Messina", s: "ME", r: "Sicilia" },
  "Santa Lucia di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Santa Lucia di Serino": { p: "Avellino", s: "AV", r: "Campania" },
  "Santa Margherita di Belice": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Santa Margherita di Staffora": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Santa Margherita Ligure": { p: "Genova", s: "GE", r: "Liguria" },
  "Santa Maria a Monte": { p: "Pisa", s: "PI", r: "Toscana" },
  "Santa Maria a Vico": { p: "Caserta", s: "CE", r: "Campania" },
  "Santa Maria Capua Vetere": { p: "Caserta", s: "CE", r: "Campania" },
  "Santa Maria Coghinas": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Santa Maria del Cedro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Santa Maria del Molise": { p: "Isernia", s: "IS", r: "Molise" },
  "Santa Maria della Versa": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Santa Maria di Licodia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Santa Maria di Sala": { p: "Venezia", s: "VE", r: "Veneto" },
  "Santa Maria Hoè": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Santa Maria Imbaro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Santa Maria la Carità": { p: "Napoli", s: "NA", r: "Campania" },
  "Santa Maria la Fossa": { p: "Caserta", s: "CE", r: "Campania" },
  "Santa Maria la Longa": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Santa Maria Maggiore": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Santa Maria Nuova": { p: "Ancona", s: "AN", r: "Marche" },
  "Santa Marina": { p: "Salerno", s: "SA", r: "Campania" },
  "Santa Marina Salina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Santa Marinella": { p: "Roma", s: "RM", r: "Lazio" },
  "Santa Ninfa": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Santa Paolina": { p: "Avellino", s: "AV", r: "Campania" },
  "Santa Severina": { p: "Crotone", s: "KR", r: "Calabria" },
  "Santa Sofia": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Santa Sofia d'Epiro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Santa Teresa di Riva": { p: "Messina", s: "ME", r: "Sicilia" },
  "Santa Teresa Gallura": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Santa Venerina": { p: "Catania", s: "CT", r: "Sicilia" },
  "Santa Vittoria d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Santa Vittoria in Matenano": { p: "Fermo", s: "FM", r: "Marche" },
  "Santadi": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Santarcangelo di Romagna": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Sante Marie": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Santena": { p: "Torino", s: "TO", r: "Piemonte" },
  "Santeramo in Colle": { p: "Bari", s: "BA", r: "Puglia" },
  "Santhià": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Santi Cosma e Damiano": { p: "Latina", s: "LT", r: "Lazio" },
  "Santo Stefano al Mare": { p: "Imperia", s: "IM", r: "Liguria" },
  "Santo Stefano Belbo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Santo Stefano d'Aveto": { p: "Genova", s: "GE", r: "Liguria" },
  "Santo Stefano del Sole": { p: "Avellino", s: "AV", r: "Campania" },
  "Santo Stefano di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Santo Stefano di Camastra": { p: "Messina", s: "ME", r: "Sicilia" },
  "Santo Stefano di Magra": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Santo Stefano di Rogliano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Santo Stefano di Sessanio": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Santo Stefano in Aspromonte": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Santo Stefano Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Santo Stefano Quisquina": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Santo Stefano Roero": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Santo Stefano Ticino": { p: "Milano", s: "MI", r: "Lombardia" },
  "Santomenna": { p: "Salerno", s: "SA", r: "Campania" },
  "Santopadre": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Santorso": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Santu Lussurgiu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sanza": { p: "Salerno", s: "SA", r: "Campania" },
  "Sanzeno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Saonara": { p: "Padova", s: "PD", r: "Veneto" },
  "Saponara": { p: "Messina", s: "ME", r: "Sicilia" },
  "Sappada": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Sapri": { p: "Salerno", s: "SA", r: "Campania" },
  "Saracena": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Saracinesco": { p: "Roma", s: "RM", r: "Lazio" },
  "Sarcedo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Sarconi": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Sardara": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sardigliano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Sarego": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Sarentino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Sarezzano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Sarezzo": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sarmato": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Sarmede": { p: "Treviso", s: "TV", r: "Veneto" },
  "Sarnano": { p: "Macerata", s: "MC", r: "Marche" },
  "Sarnico": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sarno": { p: "Salerno", s: "SA", r: "Campania" },
  "Sarnonico": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Saronno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Sarre": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Sarroch": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Sarsina": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Sarteano": { p: "Siena", s: "SI", r: "Toscana" },
  "Sartirana Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sarule": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Sarzana": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Sassano": { p: "Salerno", s: "SA", r: "Campania" },
  "Sassari": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Sassello": { p: "Savona", s: "SV", r: "Liguria" },
  "Sassetta": { p: "Livorno", s: "LI", r: "Toscana" },
  "Sassinoro": { p: "Benevento", s: "BN", r: "Campania" },
  "Sasso di Castalda": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Sasso Marconi": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Sassocorvaro Auditore": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Sassofeltrio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Sassoferrato": { p: "Ancona", s: "AN", r: "Marche" },
  "Sassuolo": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Satriano": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Satriano di Lucania": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Sauris": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Sauze d'Oulx": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sauze di Cesana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sava": { p: "Taranto", s: "TA", r: "Puglia" },
  "Savelli": { p: "Crotone", s: "KR", r: "Calabria" },
  "Saviano": { p: "Napoli", s: "NA", r: "Campania" },
  "Savigliano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Savignano Irpino": { p: "Avellino", s: "AV", r: "Campania" },
  "Savignano sul Panaro": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Savignano sul Rubicone": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Savignone": { p: "Genova", s: "GE", r: "Liguria" },
  "Saviore dell'Adamello": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Savoca": { p: "Messina", s: "ME", r: "Sicilia" },
  "Savogna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Savogna d'Isonzo": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Savoia di Lucania": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Savona": { p: "Savona", s: "SV", r: "Liguria" },
  "Scafa": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Scafati": { p: "Salerno", s: "SA", r: "Campania" },
  "Scagnello": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Scala": { p: "Salerno", s: "SA", r: "Campania" },
  "Scala Coeli": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Scaldasole": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Scalea": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Scalenghe": { p: "Torino", s: "TO", r: "Piemonte" },
  "Scaletta Zanclea": { p: "Messina", s: "ME", r: "Sicilia" },
  "Scampitella": { p: "Avellino", s: "AV", r: "Campania" },
  "Scandale": { p: "Crotone", s: "KR", r: "Calabria" },
  "Scandiano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Scandicci": { p: "Firenze", s: "FI", r: "Toscana" },
  "Scandolara Ravara": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Scandolara Ripa d'Oglio": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Scandriglia": { p: "Rieti", s: "RI", r: "Lazio" },
  "Scanno": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Scano di Montiferro": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Scansano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Scanzano Jonico": { p: "Matera", s: "MT", r: "Basilicata" },
  "Scanzorosciate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Scapoli": { p: "Isernia", s: "IS", r: "Molise" },
  "Scarlino": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Scarmagno": { p: "Torino", s: "TO", r: "Piemonte" },
  "Scarnafigi": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Scarperia e San Piero": { p: "Firenze", s: "FI", r: "Toscana" },
  "Scena": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Scerni": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Scheggia e Pascelupo": { p: "Perugia", s: "PG", r: "Umbria" },
  "Scheggino": { p: "Perugia", s: "PG", r: "Umbria" },
  "Schiavi di Abruzzo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Schiavon": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Schignano": { p: "Como", s: "CO", r: "Lombardia" },
  "Schilpario": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Schio": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Schivenoglia": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Sciacca": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Sciara": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Scicli": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Scido": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Scigliano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Scilla": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Scillato": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Sciolze": { p: "Torino", s: "TO", r: "Piemonte" },
  "Scisciano": { p: "Napoli", s: "NA", r: "Campania" },
  "Sclafani Bagni": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Scontrone": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Scopa": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Scopello": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Scoppito": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Scordia": { p: "Catania", s: "CT", r: "Sicilia" },
  "Scorrano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Scorzè": { p: "Venezia", s: "VE", r: "Veneto" },
  "Scurcola Marsicana": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Scurelle": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Scurzolengo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Seborga": { p: "Imperia", s: "IM", r: "Liguria" },
  "Secinaro": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Seclì": { p: "Lecce", s: "LE", r: "Puglia" },
  "Secugnago": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Sedegliano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Sedico": { p: "Belluno", s: "BL", r: "Veneto" },
  "Sedilo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sedini": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Sedriano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Sedrina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sefro": { p: "Macerata", s: "MC", r: "Marche" },
  "Segariu": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Seggiano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Segni": { p: "Roma", s: "RM", r: "Lazio" },
  "Segonzano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Segrate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Segusino": { p: "Treviso", s: "TV", r: "Veneto" },
  "Selargius": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Selci": { p: "Rieti", s: "RI", r: "Lazio" },
  "Selegas": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sella Giudicarie": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Sellano": { p: "Perugia", s: "PG", r: "Umbria" },
  "Sellero": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sellia": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Sellia Marina": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Selva dei Molini": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Selva di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Selva di Progno": { p: "Verona", s: "VR", r: "Veneto" },
  "Selva di Val Gardena": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Selvazzano Dentro": { p: "Padova", s: "PD", r: "Veneto" },
  "Selvino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Semestene": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Semiana": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Seminara": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Semproniano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Senago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Senale-San Felice": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Senales": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Seneghe": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Senerchia": { p: "Avellino", s: "AV", r: "Campania" },
  "Seniga": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Senigallia": { p: "Ancona", s: "AN", r: "Marche" },
  "Senis": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Senise": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Senna Comasco": { p: "Como", s: "CO", r: "Lombardia" },
  "Senna Lodigiana": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Sennariolo": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sennori": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Senorbì": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sepino": { p: "Campobasso", s: "CB", r: "Molise" },
  "Sequals": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Seravezza": { p: "Lucca", s: "LU", r: "Toscana" },
  "Serdiana": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Seregno": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Seren del Grappa": { p: "Belluno", s: "BL", r: "Veneto" },
  "Sergnano": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Seriate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Serina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Serino": { p: "Avellino", s: "AV", r: "Campania" },
  "Serle": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sermide e Felonica": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Sermoneta": { p: "Latina", s: "LT", r: "Lazio" },
  "Sernaglia della Battaglia": { p: "Treviso", s: "TV", r: "Veneto" },
  "Sernio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Serole": { p: "Asti", s: "AT", r: "Piemonte" },
  "Serra d'Aiello": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Serra de' Conti": { p: "Ancona", s: "AN", r: "Marche" },
  "Serra Riccò": { p: "Genova", s: "GE", r: "Liguria" },
  "Serra San Bruno": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Serra San Quirico": { p: "Ancona", s: "AN", r: "Marche" },
  "Serra Sant'Abbondio": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Serracapriola": { p: "Foggia", s: "FG", r: "Puglia" },
  "Serradifalco": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Serralunga d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Serralunga di Crea": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Serramanna": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Serramazzoni": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Serramezzana": { p: "Salerno", s: "SA", r: "Campania" },
  "Serramonacesca": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Serrapetrona": { p: "Macerata", s: "MC", r: "Marche" },
  "Serrara Fontana": { p: "Napoli", s: "NA", r: "Campania" },
  "Serrastretta": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Serrata": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Serravalle a Po": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Serravalle di Chienti": { p: "Macerata", s: "MC", r: "Marche" },
  "Serravalle Langhe": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Serravalle Pistoiese": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Serravalle Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Serravalle Sesia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Serre": { p: "Salerno", s: "SA", r: "Campania" },
  "Serrenti": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Serri": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Serrone": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Sersale": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Servigliano": { p: "Fermo", s: "FM", r: "Marche" },
  "Sessa Aurunca": { p: "Caserta", s: "CE", r: "Campania" },
  "Sessa Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Sessame": { p: "Asti", s: "AT", r: "Piemonte" },
  "Sessano del Molise": { p: "Isernia", s: "IS", r: "Molise" },
  "Sesta Godano": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Sestino": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Sesto": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Sesto al Reghena": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Sesto Calende": { p: "Varese", s: "VA", r: "Lombardia" },
  "Sesto Campano": { p: "Isernia", s: "IS", r: "Molise" },
  "Sesto ed Uniti": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Sesto Fiorentino": { p: "Firenze", s: "FI", r: "Toscana" },
  "Sesto San Giovanni": { p: "Milano", s: "MI", r: "Lombardia" },
  "Sestola": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Sestri Levante": { p: "Genova", s: "GE", r: "Liguria" },
  "Sestriere": { p: "Torino", s: "TO", r: "Piemonte" },
  "Sestu": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Settala": { p: "Milano", s: "MI", r: "Lombardia" },
  "Settefrati": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Settime": { p: "Asti", s: "AT", r: "Piemonte" },
  "Settimo Milanese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Settimo Rottaro": { p: "Torino", s: "TO", r: "Piemonte" },
  "Settimo San Pietro": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Settimo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Settimo Vittone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Settingiano": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Setzu": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Seui": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Seulo": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Seveso": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Sezzadio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Sezze": { p: "Latina", s: "LT", r: "Lazio" },
  "Sfruz": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Sgonico": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "Sgurgola": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Siamaggiore": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Siamanna": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Siano": { p: "Salerno", s: "SA", r: "Campania" },
  "Siapiccia": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sicignano degli Alburni": { p: "Salerno", s: "SA", r: "Campania" },
  "Siculiana": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Siddi": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Siderno": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Siena": { p: "Siena", s: "SI", r: "Toscana" },
  "Sigillo": { p: "Perugia", s: "PG", r: "Umbria" },
  "Signa": { p: "Firenze", s: "FI", r: "Toscana" },
  "Silandro": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Silanus": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Silea": { p: "Treviso", s: "TV", r: "Veneto" },
  "Siligo": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Siliqua": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Silius": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Sillano Giuncugnano": { p: "Lucca", s: "LU", r: "Toscana" },
  "Sillavengo": { p: "Novara", s: "NO", r: "Piemonte" },
  "Silvano d'Orba": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Silvano Pietra": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Silvi": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Simala": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Simaxis": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Simbario": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Simeri Crichi": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Sinagra": { p: "Messina", s: "ME", r: "Sicilia" },
  "Sinalunga": { p: "Siena", s: "SI", r: "Toscana" },
  "Sindia": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Sini": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sinio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Siniscola": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Sinnai": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Sinopoli": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Siracusa": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Sirignano": { p: "Avellino", s: "AV", r: "Campania" },
  "Siris": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sirmione": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sirolo": { p: "Ancona", s: "AN", r: "Marche" },
  "Sirone": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Sirtori": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Sissa Trecasali": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Siurgus Donigala": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Siziano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sizzano": { p: "Novara", s: "NO", r: "Piemonte" },
  "Sluderno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Smerillo": { p: "Fermo", s: "FM", r: "Marche" },
  "Soave": { p: "Verona", s: "VR", r: "Veneto" },
  "Socchieve": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Soddì": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sogliano al Rubicone": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Sogliano Cavour": { p: "Lecce", s: "LE", r: "Puglia" },
  "Soglio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Soiano del Lago": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Solagna": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Solarino": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Solaro": { p: "Milano", s: "MI", r: "Lombardia" },
  "Solarolo": { p: "Ravenna", s: "RA", r: "Emilia-Romagna" },
  "Solarolo Rainerio": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Solarussa": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Solbiate Arno": { p: "Varese", s: "VA", r: "Lombardia" },
  "Solbiate con Cagno": { p: "Como", s: "CO", r: "Lombardia" },
  "Solbiate Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Soldano": { p: "Imperia", s: "IM", r: "Liguria" },
  "Soleminis": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Solero": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Solesino": { p: "Padova", s: "PD", r: "Veneto" },
  "Soleto": { p: "Lecce", s: "LE", r: "Puglia" },
  "Solferino": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Soliera": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Solignano": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Solofra": { p: "Avellino", s: "AV", r: "Campania" },
  "Solonghello": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Solopaca": { p: "Benevento", s: "BN", r: "Campania" },
  "Solto Collina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Solza": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Somaglia": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Somano": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Somma Lombardo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Somma Vesuviana": { p: "Napoli", s: "NA", r: "Campania" },
  "Sommacampagna": { p: "Verona", s: "VR", r: "Veneto" },
  "Sommariva del Bosco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sommariva Perno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Sommatino": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Sommo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Sona": { p: "Verona", s: "VR", r: "Veneto" },
  "Soncino": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Sondalo": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Sondrio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Songavazzo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sonico": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sonnino": { p: "Latina", s: "LT", r: "Lazio" },
  "Sora": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Soraga di Fassa": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Soragna": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Sorano": { p: "Grosseto", s: "GR", r: "Toscana" },
  "Sorbo San Basile": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Sorbo Serpico": { p: "Avellino", s: "AV", r: "Campania" },
  "Sorbolo Mezzani": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Sordevolo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Sordio": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Soresina": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Sorgono": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Sorgà": { p: "Verona", s: "VR", r: "Veneto" },
  "Sori": { p: "Genova", s: "GE", r: "Liguria" },
  "Sorianello": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Soriano Calabro": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Soriano nel Cimino": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Sorico": { p: "Como", s: "CO", r: "Lombardia" },
  "Soriso": { p: "Novara", s: "NO", r: "Piemonte" },
  "Sorisole": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sormano": { p: "Como", s: "CO", r: "Lombardia" },
  "Sorradile": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Sorrento": { p: "Napoli", s: "NA", r: "Campania" },
  "Sorso": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Sortino": { p: "Siracusa", s: "SR", r: "Sicilia" },
  "Sospiro": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Sospirolo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Sossano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Sostegno": { p: "Biella", s: "BI", r: "Piemonte" },
  "Sotto il Monte Giovanni XXIII": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sover": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Soverato": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Sovere": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Soveria Mannelli": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Soveria Simeri": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Soverzene": { p: "Belluno", s: "BL", r: "Veneto" },
  "Sovicille": { p: "Siena", s: "SI", r: "Toscana" },
  "Sovico": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Sovizzo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Sovramonte": { p: "Belluno", s: "BL", r: "Veneto" },
  "Sozzago": { p: "Novara", s: "NO", r: "Piemonte" },
  "Spadafora": { p: "Messina", s: "ME", r: "Sicilia" },
  "Spadola": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Sparanise": { p: "Caserta", s: "CE", r: "Campania" },
  "Sparone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Specchia": { p: "Lecce", s: "LE", r: "Puglia" },
  "Spello": { p: "Perugia", s: "PG", r: "Umbria" },
  "Sperlinga": { p: "Enna", s: "EN", r: "Sicilia" },
  "Sperlonga": { p: "Latina", s: "LT", r: "Lazio" },
  "Sperone": { p: "Avellino", s: "AV", r: "Campania" },
  "Spessa": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Spezzano Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Spezzano della Sila": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Spiazzo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Spigno Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Spigno Saturnia": { p: "Latina", s: "LT", r: "Lazio" },
  "Spilamberto": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Spilimbergo": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Spilinga": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Spinadesco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Spinazzola": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Spinea": { p: "Venezia", s: "VE", r: "Veneto" },
  "Spineda": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Spinete": { p: "Campobasso", s: "CB", r: "Molise" },
  "Spineto Scrivia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Spinetoli": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Spino d'Adda": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Spinone al Lago": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Spinoso": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Spirano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Spoleto": { p: "Perugia", s: "PG", r: "Umbria" },
  "Spoltore": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Spongano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Spormaggiore": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Sporminore": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Spotorno": { p: "Savona", s: "SV", r: "Liguria" },
  "Spresiano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Spriana": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Squillace": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Squinzano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Staffolo": { p: "Ancona", s: "AN", r: "Marche" },
  "Stagno Lombardo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Staiti": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Stalettì": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Stanghella": { p: "Padova", s: "PD", r: "Veneto" },
  "Staranzano": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Statte": { p: "Taranto", s: "TA", r: "Puglia" },
  "Stazzano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Stazzema": { p: "Lucca", s: "LU", r: "Toscana" },
  "Stazzona": { p: "Como", s: "CO", r: "Lombardia" },
  "Stefanaconi": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Stella": { p: "Savona", s: "SV", r: "Liguria" },
  "Stella Cilento": { p: "Salerno", s: "SA", r: "Campania" },
  "Stellanello": { p: "Savona", s: "SV", r: "Liguria" },
  "Stelvio": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Stenico": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Sternatia": { p: "Lecce", s: "LE", r: "Puglia" },
  "Stezzano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Stienta": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Stigliano": { p: "Matera", s: "MT", r: "Basilicata" },
  "Stignano": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Stilo": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Stimigliano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Stintino": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Stio": { p: "Salerno", s: "SA", r: "Campania" },
  "Stornara": { p: "Foggia", s: "FG", r: "Puglia" },
  "Stornarella": { p: "Foggia", s: "FG", r: "Puglia" },
  "Storo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Stra": { p: "Venezia", s: "VE", r: "Veneto" },
  "Stradella": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Strambinello": { p: "Torino", s: "TO", r: "Piemonte" },
  "Strambino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Strangolagalli": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Stregna": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Strembo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Stresa": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Strevi": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Striano": { p: "Napoli", s: "NA", r: "Campania" },
  "Strona": { p: "Biella", s: "BI", r: "Piemonte" },
  "Stroncone": { p: "Terni", s: "TR", r: "Umbria" },
  "Strongoli": { p: "Crotone", s: "KR", r: "Calabria" },
  "Stroppiana": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Stroppo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Strozza": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sturno": { p: "Avellino", s: "AV", r: "Campania" },
  "Suardi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Subbiano": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Subiaco": { p: "Roma", s: "RM", r: "Lazio" },
  "Succivo": { p: "Caserta", s: "CE", r: "Campania" },
  "Sueglio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Suelli": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Suello": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Suisio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Sulbiate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Sulmona": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Sulzano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Sumirago": { p: "Varese", s: "VA", r: "Lombardia" },
  "Summonte": { p: "Avellino", s: "AV", r: "Campania" },
  "Suni": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Suno": { p: "Novara", s: "NO", r: "Piemonte" },
  "Supersano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Supino": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Surano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Surbo": { p: "Lecce", s: "LE", r: "Puglia" },
  "Susa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Susegana": { p: "Treviso", s: "TV", r: "Veneto" },
  "Sustinente": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Sutera": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Sutri": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Sutrio": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Suvereto": { p: "Livorno", s: "LI", r: "Toscana" },
  "Suzzara": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Taceno": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Tadasuni": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Taggia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Tagliacozzo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Taglio di Po": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Tagliolo Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Taibon Agordino": { p: "Belluno", s: "BL", r: "Veneto" },
  "Taino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Taipana": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Talamello": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Talamona": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Talana": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Taleggio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Talla": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Talmassons": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Tambre": { p: "Belluno", s: "BL", r: "Veneto" },
  "Taormina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Tarano": { p: "Rieti", s: "RI", r: "Lazio" },
  "Taranta Peligna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Tarantasca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Taranto": { p: "Taranto", s: "TA", r: "Puglia" },
  "Tarcento": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Tarquinia": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Tarsia": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Tartano": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Tarvisio": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Tarzo": { p: "Treviso", s: "TV", r: "Veneto" },
  "Tassarolo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Taurano": { p: "Avellino", s: "AV", r: "Campania" },
  "Taurasi": { p: "Avellino", s: "AV", r: "Campania" },
  "Taurianova": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Taurisano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Tavagnacco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Tavagnasco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Tavazzano con Villavesco": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Tavenna": { p: "Campobasso", s: "CB", r: "Molise" },
  "Taverna": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Tavernerio": { p: "Como", s: "CO", r: "Lombardia" },
  "Tavernola Bergamasca": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Tavernole sul Mella": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Taviano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Tavigliano": { p: "Biella", s: "BI", r: "Piemonte" },
  "Tavoleto": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Tavullia": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Teana": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Teano": { p: "Caserta", s: "CE", r: "Campania" },
  "Teggiano": { p: "Salerno", s: "SA", r: "Campania" },
  "Teglio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Teglio Veneto": { p: "Venezia", s: "VE", r: "Veneto" },
  "Telese Terme": { p: "Benevento", s: "BN", r: "Campania" },
  "Telgate": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Telti": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Telve": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Telve di Sopra": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tempio Pausania": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Temù": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Tenna": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tenno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Teolo": { p: "Padova", s: "PD", r: "Veneto" },
  "Teora": { p: "Avellino", s: "AV", r: "Campania" },
  "Teramo": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Terdobbiate": { p: "Novara", s: "NO", r: "Piemonte" },
  "Terelle": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Terento": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Terenzo": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Tergu": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Terlano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Terlizzi": { p: "Bari", s: "BA", r: "Puglia" },
  "Terme Vigliatore": { p: "Messina", s: "ME", r: "Sicilia" },
  "Termeno sulla strada del vino": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Termini Imerese": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Termoli": { p: "Campobasso", s: "CB", r: "Molise" },
  "Ternate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Ternengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Terni": { p: "Terni", s: "TR", r: "Umbria" },
  "Terno d'Isola": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Terracina": { p: "Latina", s: "LT", r: "Lazio" },
  "Terragnolo": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Terralba": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Terranova da Sibari": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Terranova dei Passerini": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Terranova di Pollino": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Terranova Sappo Minulio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Terranuova Bracciolini": { p: "Arezzo", s: "AR", r: "Toscana" },
  "Terrasini": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Terrassa Padovana": { p: "Padova", s: "PD", r: "Veneto" },
  "Terravecchia": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Terrazzo": { p: "Verona", s: "VR", r: "Veneto" },
  "Terre d'Adige": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Terre del Reno": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Terre Roveresche": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Terricciola": { p: "Pisa", s: "PI", r: "Toscana" },
  "Terruggia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Tertenia": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Terzigno": { p: "Napoli", s: "NA", r: "Campania" },
  "Terzo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Terzo d'Aquileia": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Terzolas": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Terzorio": { p: "Imperia", s: "IM", r: "Liguria" },
  "Tesero": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tesimo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Tessennano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Testico": { p: "Savona", s: "SV", r: "Liguria" },
  "Teti": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Teulada": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Teverola": { p: "Caserta", s: "CE", r: "Campania" },
  "Tezze sul Brenta": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Thiene": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Thiesi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Tiana": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ticengo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Ticineto": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Tiggiano": { p: "Lecce", s: "LE", r: "Puglia" },
  "Tiglieto": { p: "Genova", s: "GE", r: "Liguria" },
  "Tigliole": { p: "Asti", s: "AT", r: "Piemonte" },
  "Tignale": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Tinnura": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Tione degli Abruzzi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Tione di Trento": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tirano": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Tires": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Tiriolo": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Tirolo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Tissi": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Tito": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Tivoli": { p: "Roma", s: "RM", r: "Lazio" },
  "Tizzano Val Parma": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Toano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Tocco Caudio": { p: "Benevento", s: "BN", r: "Campania" },
  "Tocco da Casauria": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Toceno": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Todi": { p: "Perugia", s: "PG", r: "Umbria" },
  "Toffia": { p: "Rieti", s: "RI", r: "Lazio" },
  "Toirano": { p: "Savona", s: "SV", r: "Liguria" },
  "Tolentino": { p: "Macerata", s: "MC", r: "Marche" },
  "Tolfa": { p: "Roma", s: "RM", r: "Lazio" },
  "Tollegno": { p: "Biella", s: "BI", r: "Piemonte" },
  "Tollo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Tolmezzo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Tolve": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Tombolo": { p: "Padova", s: "PD", r: "Veneto" },
  "Ton": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tonara": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Tonco": { p: "Asti", s: "AT", r: "Piemonte" },
  "Tonengo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Tonezza del Cimone": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Tora e Piccilli": { p: "Caserta", s: "CE", r: "Campania" },
  "Torano Castello": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Torano Nuovo": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Torbole Casaglia": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Torcegno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Torchiara": { p: "Salerno", s: "SA", r: "Campania" },
  "Torchiarolo": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Torella dei Lombardi": { p: "Avellino", s: "AV", r: "Campania" },
  "Torella del Sannio": { p: "Campobasso", s: "CB", r: "Molise" },
  "Torgiano": { p: "Perugia", s: "PG", r: "Umbria" },
  "Torgnon": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Torino": { p: "Torino", s: "TO", r: "Piemonte" },
  "Torino di Sangro": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Toritto": { p: "Bari", s: "BA", r: "Puglia" },
  "Torlino Vimercati": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Tornaco": { p: "Novara", s: "NO", r: "Piemonte" },
  "Tornareccio": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Tornata": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Tornimparte": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Torno": { p: "Como", s: "CO", r: "Lombardia" },
  "Tornolo": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Toro": { p: "Campobasso", s: "CB", r: "Molise" },
  "Torpè": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Torraca": { p: "Salerno", s: "SA", r: "Campania" },
  "Torralba": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Torrazza Coste": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torrazza Piemonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Torrazzo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Torre Annunziata": { p: "Napoli", s: "NA", r: "Campania" },
  "Torre Beretti e Castellaro": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torre Boldone": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Torre Bormida": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Torre Cajetani": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Torre Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Torre d'Arese": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torre d'Isola": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torre de' Busi": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Torre de' Negri": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torre de' Passeri": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Torre de' Picenardi": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Torre de' Roveri": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Torre del Greco": { p: "Napoli", s: "NA", r: "Campania" },
  "Torre di Mosto": { p: "Venezia", s: "VE", r: "Veneto" },
  "Torre di Ruggiero": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Torre di Santa Maria": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Torre Le Nocelle": { p: "Avellino", s: "AV", r: "Campania" },
  "Torre Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Torre Orsaia": { p: "Salerno", s: "SA", r: "Campania" },
  "Torre Pallavicina": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Torre Pellice": { p: "Torino", s: "TO", r: "Piemonte" },
  "Torre San Giorgio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Torre San Patrizio": { p: "Fermo", s: "FM", r: "Marche" },
  "Torre Santa Susanna": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Torreano": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Torrebelvicino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Torrebruna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Torrecuso": { p: "Benevento", s: "BN", r: "Campania" },
  "Torreglia": { p: "Padova", s: "PD", r: "Veneto" },
  "Torregrotta": { p: "Messina", s: "ME", r: "Sicilia" },
  "Torremaggiore": { p: "Foggia", s: "FG", r: "Puglia" },
  "Torrenova": { p: "Messina", s: "ME", r: "Sicilia" },
  "Torresina": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Torretta": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Torrevecchia Pia": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torrevecchia Teatina": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Torri del Benaco": { p: "Verona", s: "VR", r: "Veneto" },
  "Torri di Quartesolo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Torri in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Torrice": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Torricella": { p: "Taranto", s: "TA", r: "Puglia" },
  "Torricella del Pizzo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Torricella in Sabina": { p: "Rieti", s: "RI", r: "Lazio" },
  "Torricella Peligna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Torricella Sicura": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Torricella Verzate": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Torriglia": { p: "Genova", s: "GE", r: "Liguria" },
  "Torrile": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Torrioni": { p: "Avellino", s: "AV", r: "Campania" },
  "Torrita di Siena": { p: "Siena", s: "SI", r: "Toscana" },
  "Torrita Tiberina": { p: "Roma", s: "RM", r: "Lazio" },
  "Tortolì": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Tortona": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Tortora": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Tortorella": { p: "Salerno", s: "SA", r: "Campania" },
  "Tortoreto": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Tortorici": { p: "Messina", s: "ME", r: "Sicilia" },
  "Torviscosa": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Toscolano-Maderno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Tossicia": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Tovo di Sant'Agata": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Tovo San Giacomo": { p: "Savona", s: "SV", r: "Liguria" },
  "Trabia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Tradate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Tramatza": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Trambileno": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Tramonti": { p: "Salerno", s: "SA", r: "Campania" },
  "Tramonti di Sopra": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Tramonti di Sotto": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Tramutola": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Trana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Trani": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Traona": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Trapani": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Trappeto": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Trarego Viggiona": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Trasacco": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Trasaghis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Trasquera": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Tratalias": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Travacò Siccomario": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Travagliato": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Travedona-Monate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Traversella": { p: "Torino", s: "TO", r: "Piemonte" },
  "Traversetolo": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Traves": { p: "Torino", s: "TO", r: "Piemonte" },
  "Travesio": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Travo": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Tre Ville": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Trebaseleghe": { p: "Padova", s: "PD", r: "Veneto" },
  "Trebisacce": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Trecase": { p: "Napoli", s: "NA", r: "Campania" },
  "Trecastagni": { p: "Catania", s: "CT", r: "Sicilia" },
  "Trecastelli": { p: "Ancona", s: "AN", r: "Marche" },
  "Trecate": { p: "Novara", s: "NO", r: "Piemonte" },
  "Trecchina": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Trecenta": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Tredozio": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Treglio": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Tregnago": { p: "Verona", s: "VR", r: "Veneto" },
  "Treia": { p: "Macerata", s: "MC", r: "Marche" },
  "Treiso": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Tremestieri Etneo": { p: "Catania", s: "CT", r: "Sicilia" },
  "Tremezzina": { p: "Como", s: "CO", r: "Lombardia" },
  "Tremosine sul Garda": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Trentinara": { p: "Salerno", s: "SA", r: "Campania" },
  "Trento": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Trentola Ducenta": { p: "Caserta", s: "CE", r: "Campania" },
  "Trenzano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Treppo Grande": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Treppo Ligosullo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Trepuzzi": { p: "Lecce", s: "LE", r: "Puglia" },
  "Trequanda": { p: "Siena", s: "SI", r: "Toscana" },
  "Tresana": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Trescore Balneario": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Trescore Cremasco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Tresignana": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Tresivio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Tresnuraghes": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Trevenzuolo": { p: "Verona", s: "VR", r: "Veneto" },
  "Trevi": { p: "Perugia", s: "PG", r: "Umbria" },
  "Trevi nel Lazio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Trevico": { p: "Avellino", s: "AV", r: "Campania" },
  "Treviglio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Trevignano": { p: "Treviso", s: "TV", r: "Veneto" },
  "Trevignano Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Treville": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Treviolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Treviso": { p: "Treviso", s: "TV", r: "Veneto" },
  "Treviso Bresciano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Trezzano Rosa": { p: "Milano", s: "MI", r: "Lombardia" },
  "Trezzano sul Naviglio": { p: "Milano", s: "MI", r: "Lombardia" },
  "Trezzo sull'Adda": { p: "Milano", s: "MI", r: "Lombardia" },
  "Trezzo Tinella": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Trezzone": { p: "Como", s: "CO", r: "Lombardia" },
  "Tribano": { p: "Padova", s: "PD", r: "Veneto" },
  "Tribiano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Tribogna": { p: "Genova", s: "GE", r: "Liguria" },
  "Tricarico": { p: "Matera", s: "MT", r: "Basilicata" },
  "Tricase": { p: "Lecce", s: "LE", r: "Puglia" },
  "Tricerro": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Tricesimo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Triei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Trieste": { p: "Trieste", s: "TS", r: "Friuli-Venezia Giulia" },
  "Triggiano": { p: "Bari", s: "BA", r: "Puglia" },
  "Trigolo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Trinitapoli": { p: "Barletta-Andria-Trani", s: "BT", r: "Puglia" },
  "Trinità": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Trinità d'Agultu e Vignola": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Trino": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Triora": { p: "Imperia", s: "IM", r: "Liguria" },
  "Tripi": { p: "Messina", s: "ME", r: "Sicilia" },
  "Trisobbio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Trissino": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Triuggio": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Trivento": { p: "Campobasso", s: "CB", r: "Molise" },
  "Trivigliano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Trivignano Udinese": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Trivigno": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Trivolzio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Trodena nel parco naturale": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Trofarello": { p: "Torino", s: "TO", r: "Piemonte" },
  "Troia": { p: "Foggia", s: "FG", r: "Puglia" },
  "Troina": { p: "Enna", s: "EN", r: "Sicilia" },
  "Tromello": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Trontano": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Tronzano Lago Maggiore": { p: "Varese", s: "VA", r: "Lombardia" },
  "Tronzano Vercellese": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Tropea": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Trovo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Truccazzano": { p: "Milano", s: "MI", r: "Lombardia" },
  "Tubre": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Tufara": { p: "Campobasso", s: "CB", r: "Molise" },
  "Tufillo": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Tufino": { p: "Napoli", s: "NA", r: "Campania" },
  "Tufo": { p: "Avellino", s: "AV", r: "Campania" },
  "Tuglie": { p: "Lecce", s: "LE", r: "Puglia" },
  "Tuili": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Tula": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Tuoro sul Trasimeno": { p: "Perugia", s: "PG", r: "Umbria" },
  "Turania": { p: "Rieti", s: "RI", r: "Lazio" },
  "Turano Lodigiano": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Turate": { p: "Como", s: "CO", r: "Lombardia" },
  "Turbigo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Turi": { p: "Bari", s: "BA", r: "Puglia" },
  "Turri": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Turriaco": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Turrivalignani": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Tursi": { p: "Matera", s: "MT", r: "Basilicata" },
  "Tusa": { p: "Messina", s: "ME", r: "Sicilia" },
  "Tuscania": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Ubiale Clanezzo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Uboldo": { p: "Varese", s: "VA", r: "Lombardia" },
  "Ucria": { p: "Messina", s: "ME", r: "Sicilia" },
  "Udine": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Ugento": { p: "Lecce", s: "LE", r: "Puglia" },
  "Uggiano la Chiesa": { p: "Lecce", s: "LE", r: "Puglia" },
  "Uggiate-Trevano": { p: "Como", s: "CO", r: "Lombardia" },
  "Ulassai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Ultimo": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Ulà Tirso": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Umbertide": { p: "Perugia", s: "PG", r: "Umbria" },
  "Umbriatico": { p: "Crotone", s: "KR", r: "Calabria" },
  "Urago d'Oglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Uras": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Urbana": { p: "Padova", s: "PD", r: "Veneto" },
  "Urbania": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Urbe": { p: "Savona", s: "SV", r: "Liguria" },
  "Urbino": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Urbisaglia": { p: "Macerata", s: "MC", r: "Marche" },
  "Urgnano": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Uri": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Ururi": { p: "Campobasso", s: "CB", r: "Molise" },
  "Urzulei": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Uscio": { p: "Genova", s: "GE", r: "Liguria" },
  "Usellus": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Usini": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Usmate Velate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Ussana": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Ussaramanna": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Ussassai": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Usseaux": { p: "Torino", s: "TO", r: "Piemonte" },
  "Usseglio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Ussita": { p: "Macerata", s: "MC", r: "Marche" },
  "Ustica": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Uta": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Uzzano": { p: "Pistoia", s: "PT", r: "Toscana" },
  "Vaccarizzo Albanese": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Vacone": { p: "Rieti", s: "RI", r: "Lazio" },
  "Vacri": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Vadena": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Vado Ligure": { p: "Savona", s: "SV", r: "Liguria" },
  "Vagli Sotto": { p: "Lucca", s: "LU", r: "Toscana" },
  "Vaglia": { p: "Firenze", s: "FI", r: "Toscana" },
  "Vaglio Basilicata": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Vaglio Serra": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vaiano": { p: "Prato", s: "PO", r: "Toscana" },
  "Vaiano Cremasco": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Vaie": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vailate": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Vairano Patenora": { p: "Caserta", s: "CE", r: "Campania" },
  "Vajont": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Val Brembilla": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Val della Torre": { p: "Torino", s: "TO", r: "Piemonte" },
  "Val di Chy": { p: "Torino", s: "TO", r: "Piemonte" },
  "Val di Nizza": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Val di Vizze": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Val di Zoldo": { p: "Belluno", s: "BL", r: "Veneto" },
  "Val Liona": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Val Masino": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Val Rezzo": { p: "Como", s: "CO", r: "Lombardia" },
  "Valbondione": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valbrembo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valbrenta": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Valbrevenna": { p: "Genova", s: "GE", r: "Liguria" },
  "Valbrona": { p: "Como", s: "CO", r: "Lombardia" },
  "Valchiusa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Valdagno": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Valdaone": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Valdaora": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Valdastico": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Valdengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Valderice": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Valdidentro": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Valdieri": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Valdilana": { p: "Biella", s: "BI", r: "Piemonte" },
  "Valdina": { p: "Messina", s: "ME", r: "Sicilia" },
  "Valdisotto": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Valdobbiadene": { p: "Treviso", s: "TV", r: "Veneto" },
  "Valduggia": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Valeggio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Valeggio sul Mincio": { p: "Verona", s: "VR", r: "Veneto" },
  "Valentano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Valenza": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Valenzano": { p: "Bari", s: "BA", r: "Puglia" },
  "Valera Fratta": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Valfabbrica": { p: "Perugia", s: "PG", r: "Umbria" },
  "Valfenera": { p: "Asti", s: "AT", r: "Piemonte" },
  "Valfloriana": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Valfornace": { p: "Macerata", s: "MC", r: "Marche" },
  "Valfurva": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Valganna": { p: "Varese", s: "VA", r: "Lombardia" },
  "Valgioie": { p: "Torino", s: "TO", r: "Piemonte" },
  "Valgoglio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valgrana": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Valgreghentino": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Valgrisenche": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Valguarnera Caropepe": { p: "Enna", s: "EN", r: "Sicilia" },
  "Vallada Agordina": { p: "Belluno", s: "BL", r: "Veneto" },
  "Vallanzengo": { p: "Biella", s: "BI", r: "Piemonte" },
  "Vallarsa": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Vallata": { p: "Avellino", s: "AV", r: "Campania" },
  "Valle Agricola": { p: "Caserta", s: "CE", r: "Campania" },
  "Valle Aurina": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Valle Cannobina": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Valle Castellana": { p: "Teramo", s: "TE", r: "Abruzzo" },
  "Valle dell'Angelo": { p: "Salerno", s: "SA", r: "Campania" },
  "Valle di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Valle di Casies": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Valle di Maddaloni": { p: "Caserta", s: "CE", r: "Campania" },
  "Valle Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Valle Salimbene": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Valle San Nicolao": { p: "Biella", s: "BI", r: "Piemonte" },
  "Vallebona": { p: "Imperia", s: "IM", r: "Liguria" },
  "Vallecorsa": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vallecrosia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Valledolmo": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Valledoria": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Vallefiorita": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Vallefoglia": { p: "Pesaro e Urbino", s: "PU", r: "Marche" },
  "Vallelaghi": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Vallelonga": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Vallelunga Pratameno": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Vallemaio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vallepietra": { p: "Roma", s: "RM", r: "Lazio" },
  "Vallerano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Vallermosa": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Vallerotonda": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vallesaccarda": { p: "Avellino", s: "AV", r: "Campania" },
  "Valleve": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valli del Pasubio": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Vallinfreda": { p: "Roma", s: "RM", r: "Lazio" },
  "Vallio Terme": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vallo della Lucania": { p: "Salerno", s: "SA", r: "Campania" },
  "Vallo di Nera": { p: "Perugia", s: "PG", r: "Umbria" },
  "Vallo Torinese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Valloriate": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Valmacca": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Valmadrera": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Valmontone": { p: "Roma", s: "RM", r: "Lazio" },
  "Valmorea": { p: "Como", s: "CO", r: "Lombardia" },
  "Valmozzola": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Valnegra": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valpelline": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Valperga": { p: "Torino", s: "TO", r: "Piemonte" },
  "Valprato Soana": { p: "Torino", s: "TO", r: "Piemonte" },
  "Valsamoggia": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Valsavarenche": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Valsinni": { p: "Matera", s: "MT", r: "Basilicata" },
  "Valsolda": { p: "Como", s: "CO", r: "Lombardia" },
  "Valstrona": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Valtopina": { p: "Perugia", s: "PG", r: "Umbria" },
  "Valtorta": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Valtournenche": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Valva": { p: "Salerno", s: "SA", r: "Campania" },
  "Valvarrone": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Valvasone Arzene": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Valverde": { p: "Catania", s: "CT", r: "Sicilia" },
  "Valvestino": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vandoies": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Vanzaghello": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vanzago": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vanzone con San Carlo": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Vaprio d'Adda": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vaprio d'Agogna": { p: "Novara", s: "NO", r: "Piemonte" },
  "Varallo": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Varallo Pombia": { p: "Novara", s: "NO", r: "Piemonte" },
  "Varano Borghi": { p: "Varese", s: "VA", r: "Lombardia" },
  "Varano de' Melegari": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Varapodio": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Varazze": { p: "Savona", s: "SV", r: "Liguria" },
  "Varco Sabino": { p: "Rieti", s: "RI", r: "Lazio" },
  "Varedo": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Varenna": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Varese": { p: "Varese", s: "VA", r: "Lombardia" },
  "Varese Ligure": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Varisella": { p: "Torino", s: "TO", r: "Piemonte" },
  "Varmo": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Varna": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Varsi": { p: "Parma", s: "PR", r: "Emilia-Romagna" },
  "Varzi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Varzo": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Vasanello": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Vasia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Vasto": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Vastogirardi": { p: "Isernia", s: "IS", r: "Molise" },
  "Vauda Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vazzano": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Vazzola": { p: "Treviso", s: "TV", r: "Veneto" },
  "Vecchiano": { p: "Pisa", s: "PI", r: "Toscana" },
  "Vedano al Lambro": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Vedano Olona": { p: "Varese", s: "VA", r: "Lombardia" },
  "Vedelago": { p: "Treviso", s: "TV", r: "Veneto" },
  "Vedeseta": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Veduggio con Colzano": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Veggiano": { p: "Padova", s: "PD", r: "Veneto" },
  "Veglie": { p: "Lecce", s: "LE", r: "Puglia" },
  "Veglio": { p: "Biella", s: "BI", r: "Piemonte" },
  "Vejano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Veleso": { p: "Como", s: "CO", r: "Lombardia" },
  "Velezzo Lomellina": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Velletri": { p: "Roma", s: "RM", r: "Lazio" },
  "Vellezzo Bellini": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Velo d'Astico": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Velo Veronese": { p: "Verona", s: "VR", r: "Veneto" },
  "Velturno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Venafro": { p: "Isernia", s: "IS", r: "Molise" },
  "Venaria Reale": { p: "Torino", s: "TO", r: "Piemonte" },
  "Venarotta": { p: "Ascoli Piceno", s: "AP", r: "Marche" },
  "Venasca": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Venaus": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vendone": { p: "Savona", s: "SV", r: "Liguria" },
  "Venegono Inferiore": { p: "Varese", s: "VA", r: "Lombardia" },
  "Venegono Superiore": { p: "Varese", s: "VA", r: "Lombardia" },
  "Venetico": { p: "Messina", s: "ME", r: "Sicilia" },
  "Venezia": { p: "Venezia", s: "VE", r: "Veneto" },
  "Veniano": { p: "Como", s: "CO", r: "Lombardia" },
  "Venosa": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Ventasso": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Venticano": { p: "Avellino", s: "AV", r: "Campania" },
  "Ventimiglia": { p: "Imperia", s: "IM", r: "Liguria" },
  "Ventimiglia di Sicilia": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Ventotene": { p: "Latina", s: "LT", r: "Lazio" },
  "Venzone": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Verano": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Verano Brianza": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Verbania": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Verbicaro": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Vercana": { p: "Como", s: "CO", r: "Lombardia" },
  "Verceia": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Vercelli": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Vercurago": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Verdellino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Verdello": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Verderio": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Verduno": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vergato": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Verghereto": { p: "Forlì-Cesena", s: "FC", r: "Emilia-Romagna" },
  "Vergiate": { p: "Varese", s: "VA", r: "Lombardia" },
  "Vermezzo con Zelo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vermiglio": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Vernante": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vernasca": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Vernate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vernazza": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Vernio": { p: "Prato", s: "PO", r: "Toscana" },
  "Vernole": { p: "Lecce", s: "LE", r: "Puglia" },
  "Verolanuova": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Verolavecchia": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Verolengo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Veroli": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Verona": { p: "Verona", s: "VR", r: "Veneto" },
  "Veronella": { p: "Verona", s: "VR", r: "Veneto" },
  "Verrayes": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Verretto": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Verrone": { p: "Biella", s: "BI", r: "Piemonte" },
  "Verrua Po": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Verrua Savoia": { p: "Torino", s: "TO", r: "Piemonte" },
  "Verrès": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Vertemate con Minoprio": { p: "Como", s: "CO", r: "Lombardia" },
  "Vertova": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Verucchio": { p: "Rimini", s: "RN", r: "Emilia-Romagna" },
  "Vervio": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Verzegnis": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Verzino": { p: "Crotone", s: "KR", r: "Calabria" },
  "Verzuolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vescovana": { p: "Padova", s: "PD", r: "Veneto" },
  "Vescovato": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Vesime": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vespolate": { p: "Novara", s: "NO", r: "Piemonte" },
  "Vessalico": { p: "Imperia", s: "IM", r: "Liguria" },
  "Vestenanova": { p: "Verona", s: "VR", r: "Veneto" },
  "Vestignè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vestone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vetralla": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Vetto": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Vezza d'Alba": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vezza d'Oglio": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vezzano Ligure": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Vezzano sul Crostolo": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Vezzi Portio": { p: "Savona", s: "SV", r: "Liguria" },
  "Viadana": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Viadanica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Viagrande": { p: "Catania", s: "CT", r: "Sicilia" },
  "Viale": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vialfrè": { p: "Torino", s: "TO", r: "Piemonte" },
  "Viano": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Viareggio": { p: "Lucca", s: "LU", r: "Toscana" },
  "Viarigi": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vibo Valentia": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Vibonati": { p: "Salerno", s: "SA", r: "Campania" },
  "Vicalvi": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vicari": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Vicchio": { p: "Firenze", s: "FI", r: "Toscana" },
  "Vicenza": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Vico del Gargano": { p: "Foggia", s: "FG", r: "Puglia" },
  "Vico Equense": { p: "Napoli", s: "NA", r: "Campania" },
  "Vico nel Lazio": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vicoforte": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vicoli": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Vicolungo": { p: "Novara", s: "NO", r: "Piemonte" },
  "Vicopisano": { p: "Pisa", s: "PI", r: "Toscana" },
  "Vicovaro": { p: "Roma", s: "RM", r: "Lazio" },
  "Viddalba": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Vidigulfo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Vidor": { p: "Treviso", s: "TV", r: "Veneto" },
  "Vidracco": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vieste": { p: "Foggia", s: "FG", r: "Puglia" },
  "Vietri di Potenza": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Vietri sul Mare": { p: "Salerno", s: "SA", r: "Campania" },
  "Vigano San Martino": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Viganò": { p: "Lecco", s: "LC", r: "Lombardia" },
  "Vigarano Mainarda": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Vigasio": { p: "Verona", s: "VR", r: "Veneto" },
  "Vigevano": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Viggianello": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Viggiano": { p: "Potenza", s: "PZ", r: "Basilicata" },
  "Viggiù": { p: "Varese", s: "VA", r: "Lombardia" },
  "Vighizzolo d'Este": { p: "Padova", s: "PD", r: "Veneto" },
  "Vigliano Biellese": { p: "Biella", s: "BI", r: "Piemonte" },
  "Vigliano d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vignale Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Vignanello": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Vignate": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vignola": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Vignola-Falesina": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Vignole Borbera": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Vignolo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vignone": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Vigo di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Vigodarzere": { p: "Padova", s: "PD", r: "Veneto" },
  "Vigolo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Vigolzone": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Vigone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vigonovo": { p: "Venezia", s: "VE", r: "Veneto" },
  "Vigonza": { p: "Padova", s: "PD", r: "Veneto" },
  "Viguzzolo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villa Bartolomea": { p: "Verona", s: "VR", r: "Veneto" },
  "Villa Basilica": { p: "Lucca", s: "LU", r: "Toscana" },
  "Villa Biscossi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Villa Carcina": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Villa Castelli": { p: "Brindisi", s: "BR", r: "Puglia" },
  "Villa Celiera": { p: "Pescara", s: "PE", r: "Abruzzo" },
  "Villa Collemandina": { p: "Lucca", s: "LU", r: "Toscana" },
  "Villa Cortese": { p: "Milano", s: "MI", r: "Lombardia" },
  "Villa d'Adda": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Villa d'Almè": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Villa d'Ogna": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Villa del Bosco": { p: "Biella", s: "BI", r: "Piemonte" },
  "Villa del Conte": { p: "Padova", s: "PD", r: "Veneto" },
  "Villa di Briano": { p: "Caserta", s: "CE", r: "Campania" },
  "Villa di Chiavenna": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Villa di Serio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Villa di Tirano": { p: "Sondrio", s: "SO", r: "Lombardia" },
  "Villa Estense": { p: "Padova", s: "PD", r: "Veneto" },
  "Villa Faraldi": { p: "Imperia", s: "IM", r: "Liguria" },
  "Villa Guardia": { p: "Como", s: "CO", r: "Lombardia" },
  "Villa Lagarina": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Villa Latina": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Villa Literno": { p: "Caserta", s: "CE", r: "Campania" },
  "Villa Minozzo": { p: "Reggio nell'Emilia", s: "RE", r: "Emilia-Romagna" },
  "Villa San Giovanni": { p: "Reggio Calabria", s: "RC", r: "Calabria" },
  "Villa San Giovanni in Tuscia": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Villa San Pietro": { p: "Cagliari", s: "CA", r: "Sardegna" },
  "Villa San Secondo": { p: "Asti", s: "AT", r: "Piemonte" },
  "Villa Sant'Angelo": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Villa Sant'Antonio": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Villa Santa Lucia": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Villa Santa Lucia degli Abruzzi": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Villa Santa Maria": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Villa Santina": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Villa Santo Stefano": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Villa Verde": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Villabassa": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Villabate": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Villachiara": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Villacidro": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villadeati": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villadose": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Villadossola": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Villafalletto": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Villafranca d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Villafranca di Verona": { p: "Verona", s: "VR", r: "Veneto" },
  "Villafranca in Lunigiana": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Villafranca Padovana": { p: "Padova", s: "PD", r: "Veneto" },
  "Villafranca Piemonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villafranca Sicula": { p: "Agrigento", s: "AG", r: "Sicilia" },
  "Villafranca Tirrena": { p: "Messina", s: "ME", r: "Sicilia" },
  "Villafrati": { p: "Palermo", s: "PA", r: "Sicilia" },
  "Villaga": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Villagrande Strisaili": { p: "Nuoro", s: "NU", r: "Sardegna" },
  "Villalago": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Villalba": { p: "Caltanissetta", s: "CL", r: "Sicilia" },
  "Villalfonsina": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Villalvernia": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villamagna": { p: "Chieti", s: "CH", r: "Abruzzo" },
  "Villamaina": { p: "Avellino", s: "AV", r: "Campania" },
  "Villamar": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villamarzana": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Villamassargia": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villamiroglio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villandro": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Villanova Biellese": { p: "Biella", s: "BI", r: "Piemonte" },
  "Villanova Canavese": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villanova d'Albenga": { p: "Savona", s: "SV", r: "Liguria" },
  "Villanova d'Ardenghi": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Villanova d'Asti": { p: "Asti", s: "AT", r: "Piemonte" },
  "Villanova del Battista": { p: "Avellino", s: "AV", r: "Campania" },
  "Villanova del Ghebbo": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Villanova del Sillaro": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Villanova di Camposampiero": { p: "Padova", s: "PD", r: "Veneto" },
  "Villanova Marchesana": { p: "Rovigo", s: "RO", r: "Veneto" },
  "Villanova Mondovì": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Villanova Monferrato": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villanova Monteleone": { p: "Sassari", s: "SS", r: "Sardegna" },
  "Villanova Solaro": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Villanova sull'Arda": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Villanova Truschedu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Villanova Tulo": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villanovaforru": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villanovafranca": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villanterio": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Villanuova sul Clisi": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Villaperuccio": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villapiana": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Villaputzu": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villar Dora": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villar Focchiardo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villar Pellice": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villar Perosa": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villar San Costanzo": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Villarbasse": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villarboit": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Villareggia": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villaricca": { p: "Napoli", s: "NA", r: "Campania" },
  "Villaromagnano": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Villarosa": { p: "Enna", s: "EN", r: "Sicilia" },
  "Villasalto": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villasanta": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Villasimius": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villasor": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villaspeciosa": { p: "Sud Sardegna", s: "SU", r: "Sardegna" },
  "Villastellone": { p: "Torino", s: "TO", r: "Piemonte" },
  "Villata": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Villaurbana": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Villavallelonga": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Villaverla": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Ville d'Anaunia": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ville di Fiemme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Villeneuve": { p: "Valle d'Aosta/Vallée d'Aoste", s: "AO", r: "Valle d'Aosta/Vallée d'Aoste" },
  "Villesse": { p: "Gorizia", s: "GO", r: "Friuli-Venezia Giulia" },
  "Villetta Barrea": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Villette": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Villimpenta": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Villongo": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Villorba": { p: "Treviso", s: "TV", r: "Veneto" },
  "Vilminore di Scalve": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Vimercate": { p: "Monza e della Brianza", s: "MB", r: "Lombardia" },
  "Vimodrone": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vinadio": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vinchiaturo": { p: "Campobasso", s: "CB", r: "Molise" },
  "Vinchio": { p: "Asti", s: "AT", r: "Piemonte" },
  "Vinci": { p: "Firenze", s: "FI", r: "Toscana" },
  "Vinovo": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vinzaglio": { p: "Novara", s: "NO", r: "Piemonte" },
  "Viola": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Vione": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vipiteno": { p: "Bolzano/Bozen", s: "BZ", r: "Trentino-Alto Adige/Südtirol" },
  "Virle Piemonte": { p: "Torino", s: "TO", r: "Piemonte" },
  "Visano": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vische": { p: "Torino", s: "TO", r: "Piemonte" },
  "Visciano": { p: "Napoli", s: "NA", r: "Campania" },
  "Visco": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Visone": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Visso": { p: "Macerata", s: "MC", r: "Marche" },
  "Vistarino": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Vistrorio": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vita": { p: "Trapani", s: "TP", r: "Sicilia" },
  "Viterbo": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Viticuso": { p: "Frosinone", s: "FR", r: "Lazio" },
  "Vito d'Asio": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Vitorchiano": { p: "Viterbo", s: "VT", r: "Lazio" },
  "Vittoria": { p: "Ragusa", s: "RG", r: "Sicilia" },
  "Vittorio Veneto": { p: "Treviso", s: "TV", r: "Veneto" },
  "Vittorito": { p: "L'Aquila", s: "AQ", r: "Abruzzo" },
  "Vittuone": { p: "Milano", s: "MI", r: "Lombardia" },
  "Vitulano": { p: "Benevento", s: "BN", r: "Campania" },
  "Vitulazio": { p: "Caserta", s: "CE", r: "Campania" },
  "Vivaro": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Vivaro Romano": { p: "Roma", s: "RM", r: "Lazio" },
  "Viverone": { p: "Biella", s: "BI", r: "Piemonte" },
  "Vizzini": { p: "Catania", s: "CT", r: "Sicilia" },
  "Vizzola Ticino": { p: "Varese", s: "VA", r: "Lombardia" },
  "Vizzolo Predabissi": { p: "Milano", s: "MI", r: "Lombardia" },
  "Viù": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vo'": { p: "Padova", s: "PD", r: "Veneto" },
  "Vobarno": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Vobbia": { p: "Genova", s: "GE", r: "Liguria" },
  "Vocca": { p: "Vercelli", s: "VC", r: "Piemonte" },
  "Vodo Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Voghera": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Voghiera": { p: "Ferrara", s: "FE", r: "Emilia-Romagna" },
  "Vogogna": { p: "Verbano-Cusio-Ossola", s: "VB", r: "Piemonte" },
  "Volano": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Volla": { p: "Napoli", s: "NA", r: "Campania" },
  "Volongo": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Volpago del Montello": { p: "Treviso", s: "TV", r: "Veneto" },
  "Volpara": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Volpedo": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Volpeglino": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Volpiano": { p: "Torino", s: "TO", r: "Piemonte" },
  "Volta Mantovana": { p: "Mantova", s: "MN", r: "Lombardia" },
  "Voltaggio": { p: "Alessandria", s: "AL", r: "Piemonte" },
  "Voltago Agordino": { p: "Belluno", s: "BL", r: "Veneto" },
  "Volterra": { p: "Pisa", s: "PI", r: "Toscana" },
  "Voltido": { p: "Cremona", s: "CR", r: "Lombardia" },
  "Volturara Appula": { p: "Foggia", s: "FG", r: "Puglia" },
  "Volturara Irpina": { p: "Avellino", s: "AV", r: "Campania" },
  "Volturino": { p: "Foggia", s: "FG", r: "Puglia" },
  "Volvera": { p: "Torino", s: "TO", r: "Piemonte" },
  "Vottignasco": { p: "Cuneo", s: "CN", r: "Piemonte" },
  "Zaccanopoli": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Zafferana Etnea": { p: "Catania", s: "CT", r: "Sicilia" },
  "Zagarise": { p: "Catanzaro", s: "CZ", r: "Calabria" },
  "Zagarolo": { p: "Roma", s: "RM", r: "Lazio" },
  "Zambrone": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
  "Zandobbio": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Zanica": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Zanè": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Zapponeta": { p: "Foggia", s: "FG", r: "Puglia" },
  "Zavattarello": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zeccone": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zeddiani": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Zelbio": { p: "Como", s: "CO", r: "Lombardia" },
  "Zelo Buon Persico": { p: "Lodi", s: "LO", r: "Lombardia" },
  "Zeme": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zenevredo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zenson di Piave": { p: "Treviso", s: "TV", r: "Veneto" },
  "Zerba": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Zerbo": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zerbolò": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zerfaliu": { p: "Oristano", s: "OR", r: "Sardegna" },
  "Zeri": { p: "Massa-Carrara", s: "MS", r: "Toscana" },
  "Zermeghedo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Zero Branco": { p: "Treviso", s: "TV", r: "Veneto" },
  "Zevio": { p: "Verona", s: "VR", r: "Veneto" },
  "Ziano di Fiemme": { p: "Trento", s: "TN", r: "Trentino-Alto Adige/Südtirol" },
  "Ziano Piacentino": { p: "Piacenza", s: "PC", r: "Emilia-Romagna" },
  "Zibido San Giacomo": { p: "Milano", s: "MI", r: "Lombardia" },
  "Zignago": { p: "La Spezia", s: "SP", r: "Liguria" },
  "Zimella": { p: "Verona", s: "VR", r: "Veneto" },
  "Zimone": { p: "Biella", s: "BI", r: "Piemonte" },
  "Zinasco": { p: "Pavia", s: "PV", r: "Lombardia" },
  "Zoagli": { p: "Genova", s: "GE", r: "Liguria" },
  "Zocca": { p: "Modena", s: "MO", r: "Emilia-Romagna" },
  "Zogno": { p: "Bergamo", s: "BG", r: "Lombardia" },
  "Zola Predosa": { p: "Bologna", s: "BO", r: "Emilia-Romagna" },
  "Zollino": { p: "Lecce", s: "LE", r: "Puglia" },
  "Zone": { p: "Brescia", s: "BS", r: "Lombardia" },
  "Zoppola": { p: "Pordenone", s: "PN", r: "Friuli-Venezia Giulia" },
  "Zoppè di Cadore": { p: "Belluno", s: "BL", r: "Veneto" },
  "Zovencedo": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Zubiena": { p: "Biella", s: "BI", r: "Piemonte" },
  "Zuccarello": { p: "Savona", s: "SV", r: "Liguria" },
  "Zugliano": { p: "Vicenza", s: "VI", r: "Veneto" },
  "Zuglio": { p: "Udine", s: "UD", r: "Friuli-Venezia Giulia" },
  "Zumaglia": { p: "Biella", s: "BI", r: "Piemonte" },
  "Zumpano": { p: "Cosenza", s: "CS", r: "Calabria" },
  "Zungoli": { p: "Avellino", s: "AV", r: "Campania" },
  "Zungri": { p: "Vibo Valentia", s: "VV", r: "Calabria" },
};

export const REGIONI = [
  "Abruzzo",
  "Basilicata",
  "Calabria",
  "Campania",
  "Emilia-Romagna",
  "Friuli-Venezia Giulia",
  "Lazio",
  "Liguria",
  "Lombardia",
  "Marche",
  "Molise",
  "Piemonte",
  "Puglia",
  "Sardegna",
  "Sicilia",
  "Toscana",
  "Trentino-Alto Adige/Südtirol",
  "Umbria",
  "Valle d'Aosta/Vallée d'Aoste",
  "Veneto",
];

export const PROVINCE_BY_REGIONE = {
  "Abruzzo": [{ s: "CH", n: "Chieti" }, { s: "AQ", n: "L'Aquila" }, { s: "PE", n: "Pescara" }, { s: "TE", n: "Teramo" }],
  "Basilicata": [{ s: "MT", n: "Matera" }, { s: "PZ", n: "Potenza" }],
  "Calabria": [{ s: "CZ", n: "Catanzaro" }, { s: "CS", n: "Cosenza" }, { s: "KR", n: "Crotone" }, { s: "RC", n: "Reggio Calabria" }, { s: "VV", n: "Vibo Valentia" }],
  "Campania": [{ s: "AV", n: "Avellino" }, { s: "BN", n: "Benevento" }, { s: "CE", n: "Caserta" }, { s: "NA", n: "Napoli" }, { s: "SA", n: "Salerno" }],
  "Emilia-Romagna": [{ s: "BO", n: "Bologna" }, { s: "FE", n: "Ferrara" }, { s: "FC", n: "Forlì-Cesena" }, { s: "MO", n: "Modena" }, { s: "PR", n: "Parma" }, { s: "PC", n: "Piacenza" }, { s: "RA", n: "Ravenna" }, { s: "RE", n: "Reggio nell'Emilia" }, { s: "RN", n: "Rimini" }],
  "Friuli-Venezia Giulia": [{ s: "GO", n: "Gorizia" }, { s: "PN", n: "Pordenone" }, { s: "TS", n: "Trieste" }, { s: "UD", n: "Udine" }],
  "Lazio": [{ s: "FR", n: "Frosinone" }, { s: "LT", n: "Latina" }, { s: "RI", n: "Rieti" }, { s: "RM", n: "Roma" }, { s: "VT", n: "Viterbo" }],
  "Liguria": [{ s: "GE", n: "Genova" }, { s: "IM", n: "Imperia" }, { s: "SP", n: "La Spezia" }, { s: "SV", n: "Savona" }],
  "Lombardia": [{ s: "BG", n: "Bergamo" }, { s: "BS", n: "Brescia" }, { s: "CO", n: "Como" }, { s: "CR", n: "Cremona" }, { s: "LC", n: "Lecco" }, { s: "LO", n: "Lodi" }, { s: "MN", n: "Mantova" }, { s: "MI", n: "Milano" }, { s: "MB", n: "Monza e della Brianza" }, { s: "PV", n: "Pavia" }, { s: "SO", n: "Sondrio" }, { s: "VA", n: "Varese" }],
  "Marche": [{ s: "AN", n: "Ancona" }, { s: "AP", n: "Ascoli Piceno" }, { s: "FM", n: "Fermo" }, { s: "MC", n: "Macerata" }, { s: "PU", n: "Pesaro e Urbino" }],
  "Molise": [{ s: "CB", n: "Campobasso" }, { s: "IS", n: "Isernia" }],
  "Piemonte": [{ s: "AL", n: "Alessandria" }, { s: "AT", n: "Asti" }, { s: "BI", n: "Biella" }, { s: "CN", n: "Cuneo" }, { s: "NO", n: "Novara" }, { s: "TO", n: "Torino" }, { s: "VB", n: "Verbano-Cusio-Ossola" }, { s: "VC", n: "Vercelli" }],
  "Puglia": [{ s: "BA", n: "Bari" }, { s: "BT", n: "Barletta-Andria-Trani" }, { s: "BR", n: "Brindisi" }, { s: "FG", n: "Foggia" }, { s: "LE", n: "Lecce" }, { s: "TA", n: "Taranto" }],
  "Sardegna": [{ s: "CA", n: "Cagliari" }, { s: "NU", n: "Nuoro" }, { s: "OR", n: "Oristano" }, { s: "SS", n: "Sassari" }, { s: "SU", n: "Sud Sardegna" }],
  "Sicilia": [{ s: "AG", n: "Agrigento" }, { s: "CL", n: "Caltanissetta" }, { s: "CT", n: "Catania" }, { s: "EN", n: "Enna" }, { s: "ME", n: "Messina" }, { s: "PA", n: "Palermo" }, { s: "RG", n: "Ragusa" }, { s: "SR", n: "Siracusa" }, { s: "TP", n: "Trapani" }],
  "Toscana": [{ s: "AR", n: "Arezzo" }, { s: "FI", n: "Firenze" }, { s: "GR", n: "Grosseto" }, { s: "LI", n: "Livorno" }, { s: "LU", n: "Lucca" }, { s: "MS", n: "Massa-Carrara" }, { s: "PI", n: "Pisa" }, { s: "PT", n: "Pistoia" }, { s: "PO", n: "Prato" }, { s: "SI", n: "Siena" }],
  "Trentino-Alto Adige/Südtirol": [{ s: "BZ", n: "Bolzano/Bozen" }, { s: "TN", n: "Trento" }],
  "Umbria": [{ s: "PG", n: "Perugia" }, { s: "TR", n: "Terni" }],
  "Valle d'Aosta/Vallée d'Aoste": [{ s: "AO", n: "Valle d'Aosta/Vallée d'Aoste" }],
  "Veneto": [{ s: "BL", n: "Belluno" }, { s: "PD", n: "Padova" }, { s: "RO", n: "Rovigo" }, { s: "TV", n: "Treviso" }, { s: "VE", n: "Venezia" }, { s: "VR", n: "Verona" }, { s: "VI", n: "Vicenza" }],
};
